/*! Version: 1.28.0.6 Built: 2021-01-12 14:46:58 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["styleguide"] = factory();
	else
		root["styleguide"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	module.exports = __webpack_require__(133);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Accordion = __webpack_require__(7);
	
	var _Accordion2 = _interopRequireDefault(_Accordion);
	
	var _Alert = __webpack_require__(9);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Modal = __webpack_require__(16);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _Nav = __webpack_require__(18);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _Search = __webpack_require__(19);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _Table = __webpack_require__(20);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Tabs = __webpack_require__(38);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _Tooltip = __webpack_require__(39);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Pagination = __webpack_require__(41);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _Loader = __webpack_require__(43);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dropdowns = __webpack_require__(44);
	
	var _Dropdowns2 = _interopRequireDefault(_Dropdowns);
	
	var _BackToTop = __webpack_require__(45);
	
	var _BackToTop2 = _interopRequireDefault(_BackToTop);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Filter = __webpack_require__(47);
	
	var _Filter2 = _interopRequireDefault(_Filter);
	
	var _DismissableSidebarPanels = __webpack_require__(48);
	
	var _DismissableSidebarPanels2 = _interopRequireDefault(_DismissableSidebarPanels);
	
	var _CountdownTimer = __webpack_require__(49);
	
	var _CountdownTimer2 = _interopRequireDefault(_CountdownTimer);
	
	var _PriceTick = __webpack_require__(50);
	
	var _PriceTick2 = _interopRequireDefault(_PriceTick);
	
	var _ButtonGroup = __webpack_require__(21);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _Toasts = __webpack_require__(51);
	
	var _Toasts2 = _interopRequireDefault(_Toasts);
	
	var _SplitPanel = __webpack_require__(52);
	
	var _SplitPanel2 = _interopRequireDefault(_SplitPanel);
	
	var _Datepicker = __webpack_require__(53);
	
	var _Datepicker2 = _interopRequireDefault(_Datepicker);
	
	var _updateBrowser = __webpack_require__(12);
	
	var _updateBrowser2 = _interopRequireDefault(_updateBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable newline-after-var */
	
	// IE Symbol Polyfill
	
	__webpack_require__(55);
	__webpack_require__(110);
	
	// IE Array polyfill
	__webpack_require__(121);
	
	// IE Number polyfill
	__webpack_require__(128);
	
	var commonUI = function () {
	  /**
	   * initialize the dropdowns per selector
	   * @param  {Object} config
	   */
	  var initializeDropdown = function initializeDropdown(config) {
	    return _get__('initDropdown')(config);
	  };
	  /**
	   * initialize the tabs per selector
	   * @param  {Object} config
	   */
	  var initializeTabs = function initializeTabs(config) {
	    return _get__('initTabs')(config);
	  };
	  /**
	   * Initialize the modal
	   * @param  {Object} config
	   */
	  var initializeModal = function initializeModal(config) {
	    return _get__('initModal')(config);
	  };
	  /**
	   * Creates a new alert instance
	   * @param  {Object} config
	   */
	  var initializeAlert = function initializeAlert(config) {
	    return _get__('initAlert')(config);
	  };
	  /**
	     * Initialize the table
	     * @param  {Object} config
	     */
	  var initializeTable = function initializeTable(config) {
	    return _get__('initTable')(config);
	  };
	  /**
	     * Initialize the nav
	     * @param  {Object} config
	     */
	  var initializeNavigation = function initializeNavigation(config) {
	    return _get__('initNav')(config);
	  };
	  /**
	   * Initialize the search
	   * @param  {Object} config
	   */
	  var initializeSearch = function initializeSearch(config) {
	    return _get__('initSearch')(config);
	  };
	  /**
	     * Initialize the accordion
	     * @param  {Object} config
	     */
	  var initializeAccordion = function initializeAccordion(config) {
	    return _get__('initAccordion')(config);
	  };
	  /**
	     * Initialize the tooltip
	     * @param  {Object} config
	     */
	  var initializeTooltip = function initializeTooltip(config) {
	    return _get__('initTooltip')(config);
	  };
	  /**
	     * Initialize the pagination
	     * @param  {Object} config
	     */
	  var initializePagination = function initializePagination(config) {
	    return _get__('initPagination')(config);
	  };
	
	  /**
	     * Initialize the loader
	     * @param  {Object} config
	     */
	  var initializeLoader = function initializeLoader(config) {
	    return _get__('initLoader')(config);
	  };
	
	  /**
	     * Initialize the back to top
	     * @param  {Object} config
	     */
	  var initializeBackToTop = function initializeBackToTop(config) {
	    return _get__('initBackToTop')(config);
	  };
	
	  /**
	     * Initialize the drawer
	     * @param  {Object} config
	     */
	  var initializeDrawer = function initializeDrawer(selector, config) {
	    return _get__('initDrawer')(selector, config);
	  };
	
	  /**
	   * Initialize the filter
	   * @param  {Object} config
	   */
	  var initializeFilter = function initializeFilter(selector, config) {
	    return _get__('initFilter')(selector, config);
	  };
	
	  /**
	  * Initialize the filter
	  * @param  {Object} config
	  */
	  var initializeDismissableSidebarPanel = function initializeDismissableSidebarPanel(selector, config) {
	    return _get__('initDismissableSidebarPanel')(selector, config);
	  };
	
	  /**
	   * Initialize the countdown timer
	   * @param  {Object} config
	   */
	  var initializeCountdownTimer = function initializeCountdownTimer(selector, config) {
	    return _get__('initCountdownTimer')(selector, config);
	  };
	
	  /**
	   * Initialize the price ticker
	   * @param  {Object} config
	   */
	  var initializePriceTick = function initializePriceTick(selector, config) {
	    return _get__('initPriceTick')(selector, config);
	  };
	
	  /**
	   * Initialize the button group
	   * @param  {Object} config
	   */
	  var initializeButtonGroup = function initializeButtonGroup(config) {
	    return _get__('initButtonGroup')(config);
	  };
	
	  /**
	   * Initialize the toasts
	   * @param  {Object} config
	   */
	  var initializeToasts = function initializeToasts(config) {
	    return _get__('initToasts')(config);
	  };
	
	  /**
	   * Initialize the split panel
	   * @param  {Object} config
	   */
	  var initializeSplitPanel = function initializeSplitPanel(config) {
	    return _get__('initSplitPanel')(config);
	  };
	
	  var initializeDatepicker = function initializeDatepicker(element, config) {
	    return _get__('initDatepicker')(element, config);
	  };
	
	  var initializeUpdateBrowser = function initializeUpdateBrowser(config) {
	    return _get__('initUpdateBrowser')(config);
	  };
	
	  /**
	   * Reveal public pointers
	   */
	  return {
	    initializeDropdown: initializeDropdown,
	    initializeTabs: initializeTabs,
	    initializeModal: initializeModal,
	    initializeAlert: initializeAlert,
	    initializeTable: initializeTable,
	    initializeNavigation: initializeNavigation,
	    initializeSearch: initializeSearch,
	    initializeAccordion: initializeAccordion,
	    initializeTooltip: initializeTooltip,
	    initializePagination: initializePagination,
	    initializeLoader: initializeLoader,
	    initializeBackToTop: initializeBackToTop,
	    initializeDrawer: initializeDrawer,
	    initializeFilter: initializeFilter,
	    initializeDismissableSidebarPanel: initializeDismissableSidebarPanel,
	    initializeCountdownTimer: initializeCountdownTimer,
	    initializePriceTick: initializePriceTick,
	    initializeButtonGroup: initializeButtonGroup,
	    initializeToasts: initializeToasts,
	    initializeSplitPanel: initializeSplitPanel,
	    initializeDatepicker: initializeDatepicker,
	    initializeUpdateBrowser: initializeUpdateBrowser
	  };
	}();
	
	module.exports = _get__('commonUI');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'initDropdown':
	      return _Dropdowns2.default;

	    case 'initTabs':
	      return _Tabs2.default;

	    case 'initModal':
	      return _Modal2.default;

	    case 'initAlert':
	      return _Alert2.default;

	    case 'initTable':
	      return _Table2.default;

	    case 'initNav':
	      return _Nav2.default;

	    case 'initSearch':
	      return _Search2.default;

	    case 'initAccordion':
	      return _Accordion2.default;

	    case 'initTooltip':
	      return _Tooltip2.default;

	    case 'initPagination':
	      return _Pagination2.default;

	    case 'initLoader':
	      return _Loader2.default;

	    case 'initBackToTop':
	      return _BackToTop2.default;

	    case 'initDrawer':
	      return _Drawer2.default;

	    case 'initFilter':
	      return _Filter2.default;

	    case 'initDismissableSidebarPanel':
	      return _DismissableSidebarPanels2.default;

	    case 'initCountdownTimer':
	      return _CountdownTimer2.default;

	    case 'initPriceTick':
	      return _PriceTick2.default;

	    case 'initButtonGroup':
	      return _ButtonGroup2.default;

	    case 'initToasts':
	      return _Toasts2.default;

	    case 'initSplitPanel':
	      return _SplitPanel2.default;

	    case 'initDatepicker':
	      return _Datepicker2.default;

	    case 'initUpdateBrowser':
	      return _updateBrowser2.default;

	    case 'commonUI':
	      return commonUI;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = _typeof(module.exports);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(module.exports, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(module.exports)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Accordion = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initAccordion;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Accordion = exports.Accordion = function () {
	
	  /**
	   * @param  {Dom}    accordion         container to hold accordion
	   * @param  {Bool}   openByDefault     open first item onLoad
	   */
	  function Accordion(accordion, config) {
	    _classCallCheck(this, Accordion);
	
	    this.accordion = accordion;
	    this.openByDefault = config.openByDefault;
	    this.singleOpen = config.singleOpen;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    // this.accordionItems = this.accordion.querySelectorAll('.accordion__item');
	    this.accordionItems = this.accordion.children;
	
	    // Bind the context with the event
	    this.showItem = this.showItem.bind(this);
	
	    // Initialize accordion
	    this.init();
	  }
	
	  _createClass(Accordion, [{
	    key: 'init',
	    value: function init() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.accordionItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var accordionItem = _step.value;
	
	          if (accordionItem.classList.contains('accordion__item')) {
	            _get__('addEvent')(accordionItem.querySelector('.accordion__title'), 'click', this.showItem);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (this.openByDefault) {
	        this.accordionItems[0].classList.add('accordion--open');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.accordionItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var accordionItem = _step2.value;
	
	          _get__('removeEvent')(accordionItem.querySelector('.accordion__title'), 'click', this.showItem);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'showItem',
	    value: function showItem(evt) {
	      _get__('cancelBubble')(evt);
	      var parentItem = evt.currentTarget.parentNode;
	      if (this.singleOpen === true) {
	        if (parentItem.classList.contains('accordion--open')) {
	          parentItem.classList.remove('accordion--open');
	        } else {
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = this.accordionItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var accordionItem = _step3.value;
	
	              accordionItem.classList.remove('accordion--open');
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          parentItem.classList.add('accordion--open');
	        }
	      } else {
	        parentItem.classList.toggle('accordion--open');
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.accordion) {
	        console.warn('CommonUI - Accordion - There\'s no accordion found');
	        return false;
	      } else if (this.accordion.querySelectorAll('.accordion__item').length === 0) {
	        console.warn('CommonUI - Accordion - There\'s no accordion items found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Accordion;
	}();
	
	/**
	 * Creates a new accordion instance
	 * @param  {Object} config
	 */
	
	
	function initAccordion() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$selector = _ref.selector,
	      selector = _ref$selector === undefined ? '.js-accordion' : _ref$selector,
	      _ref$openByDefault = _ref.openByDefault,
	      openByDefault = _ref$openByDefault === undefined ? true : _ref$openByDefault,
	      _ref$singleOpen = _ref.singleOpen,
	      singleOpen = _ref$singleOpen === undefined ? true : _ref$singleOpen;
	
	  var accordions = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = document.querySelectorAll(selector)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var accordion = _step4.value;
	
	        accordions = new (_get__('Accordion'))(accordion, { openByDefault: openByDefault, singleOpen: singleOpen });
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	  }
	  return accordions;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'cancelBubble':
	      return _events.cancelBubble;
	
	    case 'Accordion':
	      return Accordion;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initAccordion === 'undefined' ? 'undefined' : _typeof(initAccordion);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initAccordion, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initAccordion)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addEvent = addEvent;
	exports.removeEvent = removeEvent;
	exports.triggerEvent = triggerEvent;
	exports.cancelBubble = cancelBubble;
	exports.Throttle = Throttle;
	/* eslint-disable id-blacklist, func-style */
	
	function addEvent(object, type, callback) {
	  if (object === null || typeof object === 'undefined') {
	    return;
	  }
	  if (object.addEventListener) {
	    object.addEventListener(type, callback, false);
	  } else if (object.attachEvent) {
	    object.attachEvent('on' + type, callback);
	  } else {
	    object['on' + type] = callback;
	  }
	}
	
	function removeEvent(object, type, callback) {
	  if (object === null || typeof object === 'undefined') {
	    return;
	  }
	  if (object.removeEventListener) {
	    object.removeEventListener(type, callback, false);
	  } else if (object.removeEvent) {
	    object.removeEvent('on' + type);
	  }
	}
	
	function triggerEvent(element, eventName, options) {
	  var event = null;
	  if (window.CustomEvent) {
	    event = new CustomEvent(eventName, options);
	  } else {
	    event = document.createEvent('CustomEvent');
	    event.initCustomEvent(eventName, true, true, options);
	  }
	  element.dispatchEvent(event);
	}
	
	function cancelBubble(event) {
	  var evt = event ? event : window.event;
	  if (evt.stopPropagation) {
	    evt.stopPropagation();
	  }
	  if (evt.cancelBubble !== null) {
	    evt.cancelBubble = true;
	  }
	}
	
	/* eslint-disable prefer-reflect */
	function Throttle(functionToCall, throttleTime) {
	  var wait = false;
	  var trigger = function trigger(context) {
	    if (!wait) {
	      wait = true;
	      setTimeout(function () {
	        if (functionToCall) {
	          functionToCall.call(context);
	        }
	        wait = false;
	      }, throttleTime);
	    }
	  };
	  return {
	    trigger: trigger
	  };
	}
	/* eslint-enable prefer-reflect */

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Alert = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initAlert;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	var _updateBrowser = __webpack_require__(12);
	
	var _updateBrowser2 = _interopRequireDefault(_updateBrowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TIMEOUT_ALERT_RESIZE_INTERVAL = 10;
	
	var Alert = exports.Alert = function () {
	
	  /**
	   * @param  {Dom}    alert             container to hold modal
	   * @param  {String} closeClickArea    click area for close button
	   */
	  function Alert(alert, config) {
	    _classCallCheck(this, Alert);
	
	    this.alert = alert;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.closeClickArea = alert.querySelector(config.closeSelector);
	    this.autoCloseTime = config.autoCloseTime;
	    this.open = true;
	    this.isInline = config.isInline;
	    this.minimisedCellIndex = config.minimisedCellIndex;
	    this.updatedBrowser = config.updatedBrowser;
	    if (this.isInline) {
	      this.alertOverlay = alert.querySelector('.js-alert-overlay');
	    }
	    // Initialize alert
	    this.init();
	  }
	
	  _createClass(Alert, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      if (this.closeClickArea) {
	        _get__('addEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        _get__('addClasses')(this.alert, ['is-closeable']);
	      }
	      if (this.autoCloseTime) {
	        setTimeout(function () {
	          if (_this.open) {
	            _this.close();
	          }
	        }, this.autoCloseTime);
	      }
	      this.updateMyBrowser();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.isInline) {
	        if (this.minimisedCellIndex && _get__('hasClass')(this.alertOverlay, 'js-pending-alert')) {
	          this.minimiseInlineAlert();
	        } else {
	          _get__('addClasses')(this.alertOverlay, ['hide']);
	          this.open = false;
	        }
	      } else if (this.open) {
	        if (this.closeClickArea) {
	          _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        }
	        this.alert.outerHTML = '';
	        this.open = false;
	      }
	    }
	  }, {
	    key: 'minimiseInlineAlert',
	    value: function minimiseInlineAlert() {
	      var _this2 = this;
	
	      if (this.minimisedCellIndex) {
	        _get__('addClasses')(this.alertOverlay, ['is-minimised']);
	        var targettedCell = this.alert.cells[this.minimisedCellIndex];
	        var rightPos = this.alert.offsetWidth - (targettedCell.offsetLeft + targettedCell.offsetWidth);
	        _get__('setStyles')(this.alertOverlay, {
	          'left': targettedCell.offsetLeft + 'px',
	          'right': rightPos + 'px'
	        });
	        this.windowResizeListener = function () {
	          var updatedRightPos = _this2.alert.offsetWidth - (targettedCell.offsetLeft + targettedCell.offsetWidth);
	          _get__('setStyles')(_this2.alertOverlay, {
	            'left': targettedCell.offsetLeft + 'px',
	            'right': updatedRightPos + 'px'
	          });
	        };
	        this.windowResize = new (_get__('Throttle'))(this.windowResizeListener, _get__('TIMEOUT_ALERT_RESIZE_INTERVAL'));
	        _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	      }
	      this.open = false;
	      if (this.closeClickArea) {
	        _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	      }
	    }
	  }, {
	    key: 'updateMyBrowser',
	    value: function updateMyBrowser() {
	      if (this.updatedBrowser) {
	        if (_typeof(this.updatedBrowser) === 'object') {
	          _get__('updateBrowser')(this.updatedBrowser);
	        } else {
	          _get__('updateBrowser')();
	        }
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.alert) {
	        console.warn('CommonUI - Alert - There\'s no alert found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Alert;
	}();
	
	/**
	 * Creates a new alert instance
	 * @param  {Object} config
	 */
	
	
	function initAlert() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-alert' : _config$selector,
	      _config$closeSelector = config.closeSelector,
	      closeSelector = _config$closeSelector === undefined ? '.js-alert__close' : _config$closeSelector,
	      _config$autoCloseTime = config.autoCloseTime,
	      autoCloseTime = _config$autoCloseTime === undefined ? null : _config$autoCloseTime,
	      _config$inline = config.inline,
	      inline = _config$inline === undefined ? false : _config$inline,
	      _config$minimisedCell = config.minimisedCellIndex,
	      minimisedCellIndex = _config$minimisedCell === undefined ? null : _config$minimisedCell,
	      _config$updatedBrowse = config.updatedBrowser,
	      updatedBrowser = _config$updatedBrowse === undefined ? false : _config$updatedBrowse;
	
	  var alerts = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var alert = _step.value;
	
	        alerts = new (_get__('Alert'))(alert, {
	          closeSelector: closeSelector,
	          autoCloseTime: autoCloseTime,
	          inline: inline,
	          minimisedCellIndex: minimisedCellIndex,
	          updatedBrowser: updatedBrowser
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return alerts;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'TIMEOUT_ALERT_RESIZE_INTERVAL':
	      return TIMEOUT_ALERT_RESIZE_INTERVAL;
	
	    case 'updateBrowser':
	      return _updateBrowser2.default;
	
	    case 'Alert':
	      return Alert;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initAlert === 'undefined' ? 'undefined' : _typeof(initAlert);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initAlert, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initAlert)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable func-style, no-cond-assign, no-console */
	
	
	exports.arrayValueIsInArray = arrayValueIsInArray;
	exports.wrap = wrap;
	exports.unwrap = unwrap;
	exports.getElementWidth = getElementWidth;
	exports.getWidthOfWindow = getWidthOfWindow;
	exports.getHeightOfWindow = getHeightOfWindow;
	exports.offset = offset;
	exports.isOverflowed = isOverflowed;
	exports.hasDirectDescendant = hasDirectDescendant;
	exports.classListContains = classListContains;
	exports.getParentWithSelector = getParentWithSelector;
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	exports.addClasses = addClasses;
	exports.removeClasses = removeClasses;
	exports.setStyles = setStyles;
	exports.clearStyles = clearStyles;
	exports.smoothScroll = smoothScroll;
	exports.htmlFromString = htmlFromString;
	exports.createElement = createElement;
	exports.removeElement = removeElement;
	exports.createElementBefore = createElementBefore;
	exports.fadeOut = fadeOut;
	exports.fadeIn = fadeIn;
	exports.filterByTagName = filterByTagName;
	
	var _easings = __webpack_require__(11);
	
	var easings = _interopRequireWildcard(_easings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var MINUS_ONE = -1;
	function arrayValueIsInArray(arrayValues, arrayMatchValues) {
	  return arrayValues.filter(function (element) {
	    return arrayMatchValues.indexOf(element) > _get__('MINUS_ONE');
	  }).length > 0;
	}
	
	function wrap(element, className) {
	  var wrapper = document.createElement('div');
	  if (className) {
	    wrapper.className = className;
	  }
	  element.parentNode.insertBefore(wrapper, element);
	  wrapper.appendChild(element);
	}
	
	function unwrap(element) {
	  var parent = element.parentNode;
	  var grandParent = parent.parentNode;
	  grandParent.insertBefore(element, parent);
	  grandParent.removeChild(parent);
	}
	
	/**
	 * Returns the width of the specified DOM element.
	 * @param {Element} elem The DOM element that we want the width of.
	 * @return {Number} The width of the specified DOM element.
	 */
	function getElementWidth(elem) {
	  return elem.getBoundingClientRect().width;
	}
	
	function getWidthOfWindow() {
	  var actualWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || document.body.offsetWidth;
	  return actualWidth;
	}
	
	function getHeightOfWindow() {
	  var actualWidth = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || document.body.offsetHeight;
	  return actualWidth;
	}
	
	function offset(element) {
	  var offsetLeft = 0;
	  var offsetTop = 0;
	  if (element.offsetParent) {
	    do {
	      offsetLeft += element.offsetLeft;
	      offsetTop += element.offsetTop;
	    } while (element = element.offsetParent);
	  }
	  return {
	    left: offsetLeft,
	    top: offsetTop
	  };
	}
	
	// Position of left edge relative to frame left courtesy
	// http://www.quirksmode.org/js/findpos.html
	function absleft(element) {
	  var x = 0;
	  for (; element; element = element.offsetParent) {
	    x += element.offsetLeft;
	  }
	  return x;
	}
	
	// Position of top edge relative to top of frame.
	function abstop(element) {
	  var y = 0;
	  for (; element; element = element.offsetParent) {
	    y += element.offsetTop;
	  }
	  return y;
	}
	
	// True if element's bounding rectangle includes a non-zero area
	// the container's bounding rectangle.
	function isOverflowed(element, container) {
	  var cont = container || element.offsetParent;
	  var left = _get__('absleft')(element);
	  var right = left + element.offsetWidth;
	  var top = _get__('abstop')(element);
	  var bottom = top + element.offsetHeight;
	  var cleft = _get__('absleft')(cont);
	  var cright = cleft + cont.offsetWidth;
	  var ctop = _get__('abstop')(cont);
	  var cbottom = ctop + cont.offsetHeight;
	  return left < cleft || top < ctop || right > cright || bottom > cbottom;
	}
	
	function hasDirectDescendant(parent, child) {
	  if (parent.hasChildNodes()) {
	    var children = parent.childNodes;
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].isEqualNode(child)) {
	        return true;
	      }
	    }
	  }
	  return false;
	}
	
	function classListContains(cssClassList, cssClassMatches) {
	  var thisContains = false;
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = cssClassMatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var cssClass = _step.value;
	
	      if (!thisContains) {
	        thisContains = cssClassList.contains(cssClass);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return thisContains;
	}
	
	function getParentWithSelector(element, selectors) {
	  if (!element.parentNode) {
	    return false;
	  } else if (element.parentNode.classList && _get__('classListContains')(element.parentNode.classList, selectors)) {
	    return element.parentNode;
	  }
	  return _get__('getParentWithSelector')(element.parentNode, selectors);
	}
	
	/**
	 * Checks the specified DOM element for the presence of the specified CSS class.
	 * @param {Element} elem The DOM element on which we are checking for the presence of the CSS class.
	 * @param {String} cssClass The CSS class to check for on the specified element.
	 * @return {boolean}
	 */
	function hasClass(elem, cssClass) {
	  return elem.classList.contains(cssClass.trim());
	}
	
	/**
	 * Adds the specified CSS class to the specified DOM element.
	 * @param {Element} elem The DOM element to add the specified CSS class to.
	 * @param {String} cssClass The CSS class to be added.
	 * @return void
	 */
	function addClass(elem, cssClass) {
	  elem.classList.add(cssClass.trim());
	}
	
	/**
	 * Removes the specified CSS class from the specified DOM element.
	 * @param {Element} elem The DOM element to remove from the specified CSS class.
	 * @param {String} cssClass The CSS class to be removed.
	 * @return void
	 */
	function removeClass(elem, cssClass) {
	  elem.classList.remove(cssClass.trim());
	}
	
	/**
	 * As Internet Explorer does not support adding of multiple classes to an element via Element.classList.add()
	 * this utility method provides the ability to add multiple classes in one operation.
	 * @param elem
	 * @param classes
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
	 * @see http://caniuse.com/#search=classList
	 */
	function addClasses(elem, classes) {
	  var _iteratorNormalCompletion2 = true;
	  var _didIteratorError2 = false;
	  var _iteratorError2 = undefined;
	
	  try {
	    for (var _iterator2 = classes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	      var cls = _step2.value;
	
	      _get__('addClass')(elem, cls);
	    }
	  } catch (err) {
	    _didIteratorError2 = true;
	    _iteratorError2 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion2 && _iterator2.return) {
	        _iterator2.return();
	      }
	    } finally {
	      if (_didIteratorError2) {
	        throw _iteratorError2;
	      }
	    }
	  }
	}
	
	/**
	 * As Internet Explorer does not support removing of multiple classes from an element via Element.classList.remove()
	 * this utility method provides the ability to remove multiple classes in one operation.
	 * @param elem
	 * @param classes
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
	 * @see http://caniuse.com/#search=classList
	 */
	function removeClasses(elem, classes) {
	  var _iteratorNormalCompletion3 = true;
	  var _didIteratorError3 = false;
	  var _iteratorError3 = undefined;
	
	  try {
	    for (var _iterator3 = classes[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	      var cls = _step3.value;
	
	      _get__('removeClass')(elem, cls);
	    }
	  } catch (err) {
	    _didIteratorError3 = true;
	    _iteratorError3 = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion3 && _iterator3.return) {
	        _iterator3.return();
	      }
	    } finally {
	      if (_didIteratorError3) {
	        throw _iteratorError3;
	      }
	    }
	  }
	}
	
	/**
	 * Utility method for applying multiple inline styles to an element in one operation.
	 * @param {Element} element The applied being styled.
	 * @param {Object} styles An object defining the styles to be applied.
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (key) {
	    if (key === 'transform') {
	      element.style[key] = 'translateX(' + styles[key] + '%)';
	    }
	    element.style[key] = styles[key];
	  });
	}
	
	/**
	 * Clears all inline styles from the specified DOM element.
	 * @param {Element} element The DOM element on which the inline styles are to be removed.
	 */
	function clearStyles(element) {
	  element.style.cssText = '';
	}
	
	/**
	 * Provides the ability to animate the scrolling of an overflowed element either vertically or horizontally.
	 * @param element
	 * @param options
	 */
	function smoothScroll(element, options) {
	  var milliseconds = 1000;
	  var seconds = 60;
	  var requestAnimFrame = function requestAnimFrame() {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function reqAF(cbk) {
	      window.setTimeout(cbk, milliseconds / seconds);
	    };
	  }();
	  var defaults = {
	    to: 0,
	    duration: 250,
	    axis: 'horizontal',
	    easing: 'easeInOutQuad'
	  };
	  var settings = _extends({}, defaults, options);
	  var direction = settings.axis === 'horizontal' ? 'scrollLeft' : 'scrollTop';
	  var start = element[direction];
	  var change = settings.to - start;
	  var animationStart = Number(new Date());
	  var animating = true;
	  var animateScroll = function animateScroll() {
	    if (!animating) {
	      if (settings.cbk) {
	        settings.cbk();
	      }
	      return;
	    }
	    requestAnimFrame(animateScroll);
	    var now = Number(new Date());
	    element[direction] = Math.floor(_get__('easings')[settings.easing](now - animationStart, start, change, settings.duration));
	
	    if (now > animationStart + settings.duration) {
	      element[direction] = settings.to;
	      animating = false;
	    }
	  };
	  requestAnimFrame(animateScroll);
	}
	
	function htmlFromString(html) {
	  var div = document.createElement('div');
	  div.innerHTML = html.trim();
	
	  // Change this to div.childNodes to support multiple top-level nodes
	  return div.firstChild;
	}
	
	function createElement(elementType, targetElement) {
	  var element = document.createElement(elementType);
	  targetElement.appendChild(element);
	  return element;
	}
	
	function removeElement(element) {
	  var parent = element.parentElement;
	  parent.removeChild(element);
	}
	
	function createElementBefore(elementType, targetElement, beforeElement) {
	  var element = document.createElement(elementType);
	  targetElement.insertBefore(element, beforeElement);
	  return element;
	}
	
	function fadeOut(element) {
	  var OPACITY_INCREMENT = 0.05;
	  (function fade() {
	    if ((element.style.opacity -= OPACITY_INCREMENT) <= 0) {
	      element.style.display = 'none';
	      element.style.opacity = 0;
	    } else {
	      requestAnimationFrame(fade);
	    }
	  })();
	}
	
	function fadeIn(element, display) {
	  var OPACITY_INCREMENT = 0.05;
	  element.style.display = display || 'block';
	  (function fade() {
	    var val = parseFloat(element.style.opacity);
	    if (!((val += OPACITY_INCREMENT) > 1)) {
	      element.style.opacity = val;
	      requestAnimationFrame(fade);
	    }
	  })();
	}
	
	function filterByTagName(htmlCollection, tagname) {
	  var filtered = [];
	  tagname = tagname.toLowerCase();
	
	  for (var i = 0; i < htmlCollection.length; i++) {
	    if (htmlCollection.item(i).tagName.toLowerCase() === tagname) {
	      filtered.push(htmlCollection.item(i));
	    }
	  }
	  return filtered;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'MINUS_ONE':
	      return MINUS_ONE;

	    case 'absleft':
	      return absleft;

	    case 'abstop':
	      return abstop;

	    case 'classListContains':
	      return classListContains;

	    case 'getParentWithSelector':
	      return getParentWithSelector;

	    case 'addClass':
	      return addClass;

	    case 'removeClass':
	      return removeClass;

	    case 'easings':
	      return _filterWildcardImport__(easings);
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	exports.default = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.linear = linear;
	exports.easeInQuad = easeInQuad;
	exports.easeOutQuad = easeOutQuad;
	exports.easeInOutQuad = easeInOutQuad;
	exports.easeInCubic = easeInCubic;
	exports.easeOutCubic = easeOutCubic;
	exports.easeInOutCubic = easeInOutCubic;
	exports.easeInQuart = easeInQuart;
	exports.easeOutQuart = easeOutQuart;
	exports.easeInOutQuart = easeInOutQuart;
	exports.easeInQuint = easeInQuint;
	exports.easeOutQuint = easeOutQuint;
	exports.easeInOutQuint = easeInOutQuint;
	/* eslint-disable func-style */
	/**
	 * Easing Functions - inspired from http://gizma.com/easing/
	 */
	
	/**
	 * no easing, no acceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function linear(time, begin, change, duration) {
	  return change * time / duration + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInQuad(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutQuad(time, begin, change, duration) {
	  time /= duration;
	  return -change * time * (time - 2) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutQuad(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time + begin;
	  }
	  time--;
	  return -change / 2 * (time * (time - 2) - 1) + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInCubic(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutCubic(time, begin, change, duration) {
	  time /= duration;
	  time--;
	  return change * (time * time * time + 1) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutCubic(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time * time + begin;
	  }
	  time -= 2;
	  return change / 2 * (time * time * time + 2) + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInQuart(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutQuart(time, begin, change, duration) {
	  time /= duration;
	  time--;
	  return -change * (time * time * time * time - 1) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutQuart(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time * time * time + begin;
	  }
	  time -= 2;
	  return -change / 2 * (time * time * time * time - 2) + begin;
	}
	
	/**
	 * accelerating from zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInQuint(time, begin, change, duration) {
	  time /= duration;
	  return change * time * time * time * time * time + begin;
	}
	
	/**
	 * decelerating to zero velocity
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeOutQuint(time, begin, change, duration) {
	  time /= duration;
	  time--;
	  return change * (time * time * time * time * time + 1) + begin;
	}
	
	/**
	 * acceleration until halfway, then deceleration
	 * @param time
	 * @param begin
	 * @param change
	 * @param duration
	 * @returns {*}
	 */
	function easeInOutQuint(time, begin, change, duration) {
	  time /= duration / 2;
	  if (time < 1) {
	    return change / 2 * time * time * time * time * time + begin;
	  }
	  time -= 2;
	  return change / 2 * (time * time * time * time * time + 2) + begin;
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = updateBrowser;
	
	var _detectBrowser = __webpack_require__(13);
	
	var _semver = __webpack_require__(15);
	
	var _semver2 = _interopRequireDefault(_semver);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateBrowser() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    chrome: '71.0.0',
	    safari: '12.0.0',
	    ie: '10.0.0',
	    firefox: '64.0.0'
	  };
	
	  var browser = _get__('detect')();
	  var updateAlert = document.querySelector('.alert--update-browser');
	  var browsers = {
	    chrome: 'chrome',
	    safari: 'safari',
	    firefox: 'firefox',
	    ie: 'ie'
	  };
	  if (browser.name === browsers.chrome && _get__('semver').lt(browser.version, config.chrome)) {
	    updateAlert.style.display = 'block';
	  }
	
	  if (browser.name === browsers.safari && _get__('semver').lt(browser.version, config.safari)) {
	    updateAlert.style.display = 'block';
	  }
	
	  if (browser.name === browsers.firefox && _get__('semver').lt(browser.version, config.firefox)) {
	    updateAlert.style.display = 'block';
	  }
	
	  if (browser.name === browsers.ie && _get__('semver').lt(browser.version, config.ie)) {
	    updateAlert.style.display = 'block';
	  }
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'detect':
	      return _detectBrowser.detect;
	
	    case 'semver':
	      return _semver2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof updateBrowser === 'undefined' ? 'undefined' : _typeof(updateBrowser);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(updateBrowser, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(updateBrowser)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var __spreadArrays = (this && this.__spreadArrays) || function () {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var BrowserInfo = /** @class */ (function () {
	    function BrowserInfo(name, version, os) {
	        this.name = name;
	        this.version = version;
	        this.os = os;
	    }
	    return BrowserInfo;
	}());
	exports.BrowserInfo = BrowserInfo;
	var NodeInfo = /** @class */ (function () {
	    function NodeInfo(version) {
	        this.version = version;
	        this.name = 'node';
	        this.os = process.platform;
	    }
	    return NodeInfo;
	}());
	exports.NodeInfo = NodeInfo;
	var BotInfo = /** @class */ (function () {
	    function BotInfo() {
	        this.bot = true; // NOTE: deprecated test name instead
	        this.name = 'bot';
	        this.version = null;
	        this.os = null;
	    }
	    return BotInfo;
	}());
	exports.BotInfo = BotInfo;
	// tslint:disable-next-line:max-line-length
	var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
	var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
	var REQUIRED_VERSION_PARTS = 3;
	var userAgentRules = [
	    ['aol', /AOLShield\/([0-9\._]+)/],
	    ['edge', /Edge\/([0-9\._]+)/],
	    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
	    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
	    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
	    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
	    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
	    ['silk', /\bSilk\/([0-9._-]+)\b/],
	    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
	    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
	    ['edge-chromium', /Edg\/([0-9\.]+)/],
	    [
	        'chromium-webview',
	        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
	    ],
	    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
	    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
	    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
	    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
	    ['fxios', /FxiOS\/([0-9\.]+)/],
	    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
	    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
	    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
	    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
	    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
	    ['ie', /MSIE\s(7\.0)/],
	    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
	    ['android', /Android\s([0-9\.]+)/],
	    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
	    ['safari', /Version\/([0-9\._]+).*Safari/],
	    ['facebook', /FBAV\/([0-9\.]+)/],
	    ['instagram', /Instagram\s([0-9\.]+)/],
	    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
	    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
	    ['searchbot', SEARCHBOX_UA_REGEX],
	];
	var operatingSystemRules = [
	    ['iOS', /iP(hone|od|ad)/],
	    ['Android OS', /Android/],
	    ['BlackBerry OS', /BlackBerry|BB10/],
	    ['Windows Mobile', /IEMobile/],
	    ['Amazon OS', /Kindle/],
	    ['Windows 3.11', /Win16/],
	    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
	    ['Windows 98', /(Windows 98)|(Win98)/],
	    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
	    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
	    ['Windows Server 2003', /(Windows NT 5.2)/],
	    ['Windows Vista', /(Windows NT 6.0)/],
	    ['Windows 7', /(Windows NT 6.1)/],
	    ['Windows 8', /(Windows NT 6.2)/],
	    ['Windows 8.1', /(Windows NT 6.3)/],
	    ['Windows 10', /(Windows NT 10.0)/],
	    ['Windows ME', /Windows ME/],
	    ['Open BSD', /OpenBSD/],
	    ['Sun OS', /SunOS/],
	    ['Chrome OS', /CrOS/],
	    ['Linux', /(Linux)|(X11)/],
	    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
	    ['QNX', /QNX/],
	    ['BeOS', /BeOS/],
	    ['OS/2', /OS\/2/],
	    ['Search Bot', SEARCHBOT_OS_REGEX],
	];
	function detect(userAgent) {
	    if (!!userAgent) {
	        return parseUserAgent(userAgent);
	    }
	    if (typeof navigator !== 'undefined') {
	        return parseUserAgent(navigator.userAgent);
	    }
	    return getNodeVersion();
	}
	exports.detect = detect;
	function parseUserAgent(ua) {
	    // opted for using reduce here rather than Array#first with a regex.test call
	    // this is primarily because using the reduce we only perform the regex
	    // execution once rather than once for the test and for the exec again below
	    // probably something that needs to be benchmarked though
	    var matchedRule = ua !== '' &&
	        userAgentRules.reduce(function (matched, _a) {
	            var browser = _a[0], regex = _a[1];
	            if (matched) {
	                return matched;
	            }
	            var uaMatch = regex.exec(ua);
	            return !!uaMatch && [browser, uaMatch];
	        }, false);
	    if (!matchedRule) {
	        return null;
	    }
	    var name = matchedRule[0], match = matchedRule[1];
	    if (name === 'searchbot') {
	        return new BotInfo();
	    }
	    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
	    if (versionParts) {
	        if (versionParts.length < REQUIRED_VERSION_PARTS) {
	            versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
	        }
	    }
	    else {
	        versionParts = [];
	    }
	    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
	}
	exports.parseUserAgent = parseUserAgent;
	function detectOS(ua) {
	    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
	        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
	        var match = regex.test(ua);
	        if (match) {
	            return os;
	        }
	    }
	    return null;
	}
	exports.detectOS = detectOS;
	function getNodeVersion() {
	    var isNode = typeof process !== 'undefined' && process.version;
	    return isNode ? new NodeInfo(process.version.slice(1)) : null;
	}
	exports.getNodeVersion = getNodeVersion;
	function createVersionParts(count) {
	    var output = [];
	    for (var ii = 0; ii < count; ii++) {
	        output.push('0');
	    }
	    return output;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer
	
	var debug
	/* istanbul ignore next */
	if (typeof process === 'object' &&
	    ({"NODE_ENV":"production"}) &&
	    ({"NODE_ENV":"production"}).NODE_DEBUG &&
	    /\bsemver\b/i.test(({"NODE_ENV":"production"}).NODE_DEBUG)) {
	  debug = function () {
	    var args = Array.prototype.slice.call(arguments, 0)
	    args.unshift('SEMVER')
	    console.log.apply(console, args)
	  }
	} else {
	  debug = function () {}
	}
	
	// Note: this is the semver.org version of the spec that it implements
	// Not necessarily the package version of this code.
	exports.SEMVER_SPEC_VERSION = '2.0.0'
	
	var MAX_LENGTH = 256
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
	  /* istanbul ignore next */ 9007199254740991
	
	// Max safe segment length for coercion.
	var MAX_SAFE_COMPONENT_LENGTH = 16
	
	// The actual regexps go on exports.re
	var re = exports.re = []
	var src = exports.src = []
	var R = 0
	
	// The following Regular Expressions can be used for tokenizing,
	// validating, and parsing SemVer version strings.
	
	// ## Numeric Identifier
	// A single `0`, or a non-zero digit followed by zero or more digits.
	
	var NUMERICIDENTIFIER = R++
	src[NUMERICIDENTIFIER] = '0|[1-9]\\d*'
	var NUMERICIDENTIFIERLOOSE = R++
	src[NUMERICIDENTIFIERLOOSE] = '[0-9]+'
	
	// ## Non-numeric Identifier
	// Zero or more digits, followed by a letter or hyphen, and then zero or
	// more letters, digits, or hyphens.
	
	var NONNUMERICIDENTIFIER = R++
	src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*'
	
	// ## Main Version
	// Three dot-separated numeric identifiers.
	
	var MAINVERSION = R++
	src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
	                   '(' + src[NUMERICIDENTIFIER] + ')'
	
	var MAINVERSIONLOOSE = R++
	src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
	                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')'
	
	// ## Pre-release Version Identifier
	// A numeric identifier, or a non-numeric identifier.
	
	var PRERELEASEIDENTIFIER = R++
	src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
	                            '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	var PRERELEASEIDENTIFIERLOOSE = R++
	src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
	                                 '|' + src[NONNUMERICIDENTIFIER] + ')'
	
	// ## Pre-release Version
	// Hyphen, followed by one or more dot-separated pre-release version
	// identifiers.
	
	var PRERELEASE = R++
	src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
	                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))'
	
	var PRERELEASELOOSE = R++
	src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
	                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))'
	
	// ## Build Metadata Identifier
	// Any combination of digits, letters, or hyphens.
	
	var BUILDIDENTIFIER = R++
	src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+'
	
	// ## Build Metadata
	// Plus sign, followed by one or more period-separated build metadata
	// identifiers.
	
	var BUILD = R++
	src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
	             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))'
	
	// ## Full Version String
	// A main version, followed optionally by a pre-release version and
	// build metadata.
	
	// Note that the only major, minor, patch, and pre-release sections of
	// the version string are capturing groups.  The build metadata is not a
	// capturing group, because it should not ever be used in version
	// comparison.
	
	var FULL = R++
	var FULLPLAIN = 'v?' + src[MAINVERSION] +
	                src[PRERELEASE] + '?' +
	                src[BUILD] + '?'
	
	src[FULL] = '^' + FULLPLAIN + '$'
	
	// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
	// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
	// common in the npm registry.
	var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
	                 src[PRERELEASELOOSE] + '?' +
	                 src[BUILD] + '?'
	
	var LOOSE = R++
	src[LOOSE] = '^' + LOOSEPLAIN + '$'
	
	var GTLT = R++
	src[GTLT] = '((?:<|>)?=?)'
	
	// Something like "2.*" or "1.2.x".
	// Note that "x.x" is a valid xRange identifer, meaning "any version"
	// Only the first item is strictly required.
	var XRANGEIDENTIFIERLOOSE = R++
	src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*'
	var XRANGEIDENTIFIER = R++
	src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*'
	
	var XRANGEPLAIN = R++
	src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
	                   '(?:' + src[PRERELEASE] + ')?' +
	                   src[BUILD] + '?' +
	                   ')?)?'
	
	var XRANGEPLAINLOOSE = R++
	src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
	                        '(?:' + src[PRERELEASELOOSE] + ')?' +
	                        src[BUILD] + '?' +
	                        ')?)?'
	
	var XRANGE = R++
	src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$'
	var XRANGELOOSE = R++
	src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$'
	
	// Coercion.
	// Extract anything that could conceivably be a part of a valid semver
	var COERCE = R++
	src[COERCE] = '(?:^|[^\\d])' +
	              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
	              '(?:$|[^\\d])'
	
	// Tilde ranges.
	// Meaning is "reasonably at or greater than"
	var LONETILDE = R++
	src[LONETILDE] = '(?:~>?)'
	
	var TILDETRIM = R++
	src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+'
	re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g')
	var tildeTrimReplace = '$1~'
	
	var TILDE = R++
	src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$'
	var TILDELOOSE = R++
	src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$'
	
	// Caret ranges.
	// Meaning is "at least and backwards compatible with"
	var LONECARET = R++
	src[LONECARET] = '(?:\\^)'
	
	var CARETTRIM = R++
	src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+'
	re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g')
	var caretTrimReplace = '$1^'
	
	var CARET = R++
	src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$'
	var CARETLOOSE = R++
	src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$'
	
	// A simple gt/lt/eq thing, or just "" to indicate "any version"
	var COMPARATORLOOSE = R++
	src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$'
	var COMPARATOR = R++
	src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$'
	
	// An expression to strip any whitespace between the gtlt and the thing
	// it modifies, so that `> 1.2.3` ==> `>1.2.3`
	var COMPARATORTRIM = R++
	src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
	                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')'
	
	// this one has to use the /g flag
	re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g')
	var comparatorTrimReplace = '$1$2$3'
	
	// Something like `1.2.3 - 1.2.4`
	// Note that these all use the loose form, because they'll be
	// checked against either the strict or loose comparator form
	// later.
	var HYPHENRANGE = R++
	src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
	                   '\\s+-\\s+' +
	                   '(' + src[XRANGEPLAIN] + ')' +
	                   '\\s*$'
	
	var HYPHENRANGELOOSE = R++
	src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s+-\\s+' +
	                        '(' + src[XRANGEPLAINLOOSE] + ')' +
	                        '\\s*$'
	
	// Star ranges basically just allow anything at all.
	var STAR = R++
	src[STAR] = '(<|>)?=?\\s*\\*'
	
	// Compile to actual regexp objects.
	// All are flag-free, unless they were created above with a flag.
	for (var i = 0; i < R; i++) {
	  debug(i, src[i])
	  if (!re[i]) {
	    re[i] = new RegExp(src[i])
	  }
	}
	
	exports.parse = parse
	function parse (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  if (version.length > MAX_LENGTH) {
	    return null
	  }
	
	  var r = options.loose ? re[LOOSE] : re[FULL]
	  if (!r.test(version)) {
	    return null
	  }
	
	  try {
	    return new SemVer(version, options)
	  } catch (er) {
	    return null
	  }
	}
	
	exports.valid = valid
	function valid (version, options) {
	  var v = parse(version, options)
	  return v ? v.version : null
	}
	
	exports.clean = clean
	function clean (version, options) {
	  var s = parse(version.trim().replace(/^[=v]+/, ''), options)
	  return s ? s.version : null
	}
	
	exports.SemVer = SemVer
	
	function SemVer (version, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	  if (version instanceof SemVer) {
	    if (version.loose === options.loose) {
	      return version
	    } else {
	      version = version.version
	    }
	  } else if (typeof version !== 'string') {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  if (version.length > MAX_LENGTH) {
	    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')
	  }
	
	  if (!(this instanceof SemVer)) {
	    return new SemVer(version, options)
	  }
	
	  debug('SemVer', version, options)
	  this.options = options
	  this.loose = !!options.loose
	
	  var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL])
	
	  if (!m) {
	    throw new TypeError('Invalid Version: ' + version)
	  }
	
	  this.raw = version
	
	  // these are actually numbers
	  this.major = +m[1]
	  this.minor = +m[2]
	  this.patch = +m[3]
	
	  if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
	    throw new TypeError('Invalid major version')
	  }
	
	  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
	    throw new TypeError('Invalid minor version')
	  }
	
	  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
	    throw new TypeError('Invalid patch version')
	  }
	
	  // numberify any prerelease numeric ids
	  if (!m[4]) {
	    this.prerelease = []
	  } else {
	    this.prerelease = m[4].split('.').map(function (id) {
	      if (/^[0-9]+$/.test(id)) {
	        var num = +id
	        if (num >= 0 && num < MAX_SAFE_INTEGER) {
	          return num
	        }
	      }
	      return id
	    })
	  }
	
	  this.build = m[5] ? m[5].split('.') : []
	  this.format()
	}
	
	SemVer.prototype.format = function () {
	  this.version = this.major + '.' + this.minor + '.' + this.patch
	  if (this.prerelease.length) {
	    this.version += '-' + this.prerelease.join('.')
	  }
	  return this.version
	}
	
	SemVer.prototype.toString = function () {
	  return this.version
	}
	
	SemVer.prototype.compare = function (other) {
	  debug('SemVer.compare', this.version, this.options, other)
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return this.compareMain(other) || this.comparePre(other)
	}
	
	SemVer.prototype.compareMain = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  return compareIdentifiers(this.major, other.major) ||
	         compareIdentifiers(this.minor, other.minor) ||
	         compareIdentifiers(this.patch, other.patch)
	}
	
	SemVer.prototype.comparePre = function (other) {
	  if (!(other instanceof SemVer)) {
	    other = new SemVer(other, this.options)
	  }
	
	  // NOT having a prerelease is > having one
	  if (this.prerelease.length && !other.prerelease.length) {
	    return -1
	  } else if (!this.prerelease.length && other.prerelease.length) {
	    return 1
	  } else if (!this.prerelease.length && !other.prerelease.length) {
	    return 0
	  }
	
	  var i = 0
	  do {
	    var a = this.prerelease[i]
	    var b = other.prerelease[i]
	    debug('prerelease compare', i, a, b)
	    if (a === undefined && b === undefined) {
	      return 0
	    } else if (b === undefined) {
	      return 1
	    } else if (a === undefined) {
	      return -1
	    } else if (a === b) {
	      continue
	    } else {
	      return compareIdentifiers(a, b)
	    }
	  } while (++i)
	}
	
	// preminor will bump the version up to the next minor release, and immediately
	// down to pre-release. premajor and prepatch work the same way.
	SemVer.prototype.inc = function (release, identifier) {
	  switch (release) {
	    case 'premajor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor = 0
	      this.major++
	      this.inc('pre', identifier)
	      break
	    case 'preminor':
	      this.prerelease.length = 0
	      this.patch = 0
	      this.minor++
	      this.inc('pre', identifier)
	      break
	    case 'prepatch':
	      // If this is already a prerelease, it will bump to the next version
	      // drop any prereleases that might already exist, since they are not
	      // relevant at this point.
	      this.prerelease.length = 0
	      this.inc('patch', identifier)
	      this.inc('pre', identifier)
	      break
	    // If the input is a non-prerelease version, this acts the same as
	    // prepatch.
	    case 'prerelease':
	      if (this.prerelease.length === 0) {
	        this.inc('patch', identifier)
	      }
	      this.inc('pre', identifier)
	      break
	
	    case 'major':
	      // If this is a pre-major version, bump up to the same major version.
	      // Otherwise increment major.
	      // 1.0.0-5 bumps to 1.0.0
	      // 1.1.0 bumps to 2.0.0
	      if (this.minor !== 0 ||
	          this.patch !== 0 ||
	          this.prerelease.length === 0) {
	        this.major++
	      }
	      this.minor = 0
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'minor':
	      // If this is a pre-minor version, bump up to the same minor version.
	      // Otherwise increment minor.
	      // 1.2.0-5 bumps to 1.2.0
	      // 1.2.1 bumps to 1.3.0
	      if (this.patch !== 0 || this.prerelease.length === 0) {
	        this.minor++
	      }
	      this.patch = 0
	      this.prerelease = []
	      break
	    case 'patch':
	      // If this is not a pre-release version, it will increment the patch.
	      // If it is a pre-release it will bump up to the same patch version.
	      // 1.2.0-5 patches to 1.2.0
	      // 1.2.0 patches to 1.2.1
	      if (this.prerelease.length === 0) {
	        this.patch++
	      }
	      this.prerelease = []
	      break
	    // This probably shouldn't be used publicly.
	    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
	    case 'pre':
	      if (this.prerelease.length === 0) {
	        this.prerelease = [0]
	      } else {
	        var i = this.prerelease.length
	        while (--i >= 0) {
	          if (typeof this.prerelease[i] === 'number') {
	            this.prerelease[i]++
	            i = -2
	          }
	        }
	        if (i === -1) {
	          // didn't increment anything
	          this.prerelease.push(0)
	        }
	      }
	      if (identifier) {
	        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
	        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
	        if (this.prerelease[0] === identifier) {
	          if (isNaN(this.prerelease[1])) {
	            this.prerelease = [identifier, 0]
	          }
	        } else {
	          this.prerelease = [identifier, 0]
	        }
	      }
	      break
	
	    default:
	      throw new Error('invalid increment argument: ' + release)
	  }
	  this.format()
	  this.raw = this.version
	  return this
	}
	
	exports.inc = inc
	function inc (version, release, loose, identifier) {
	  if (typeof (loose) === 'string') {
	    identifier = loose
	    loose = undefined
	  }
	
	  try {
	    return new SemVer(version, loose).inc(release, identifier).version
	  } catch (er) {
	    return null
	  }
	}
	
	exports.diff = diff
	function diff (version1, version2) {
	  if (eq(version1, version2)) {
	    return null
	  } else {
	    var v1 = parse(version1)
	    var v2 = parse(version2)
	    var prefix = ''
	    if (v1.prerelease.length || v2.prerelease.length) {
	      prefix = 'pre'
	      var defaultResult = 'prerelease'
	    }
	    for (var key in v1) {
	      if (key === 'major' || key === 'minor' || key === 'patch') {
	        if (v1[key] !== v2[key]) {
	          return prefix + key
	        }
	      }
	    }
	    return defaultResult // may be undefined
	  }
	}
	
	exports.compareIdentifiers = compareIdentifiers
	
	var numeric = /^[0-9]+$/
	function compareIdentifiers (a, b) {
	  var anum = numeric.test(a)
	  var bnum = numeric.test(b)
	
	  if (anum && bnum) {
	    a = +a
	    b = +b
	  }
	
	  return a === b ? 0
	    : (anum && !bnum) ? -1
	    : (bnum && !anum) ? 1
	    : a < b ? -1
	    : 1
	}
	
	exports.rcompareIdentifiers = rcompareIdentifiers
	function rcompareIdentifiers (a, b) {
	  return compareIdentifiers(b, a)
	}
	
	exports.major = major
	function major (a, loose) {
	  return new SemVer(a, loose).major
	}
	
	exports.minor = minor
	function minor (a, loose) {
	  return new SemVer(a, loose).minor
	}
	
	exports.patch = patch
	function patch (a, loose) {
	  return new SemVer(a, loose).patch
	}
	
	exports.compare = compare
	function compare (a, b, loose) {
	  return new SemVer(a, loose).compare(new SemVer(b, loose))
	}
	
	exports.compareLoose = compareLoose
	function compareLoose (a, b) {
	  return compare(a, b, true)
	}
	
	exports.rcompare = rcompare
	function rcompare (a, b, loose) {
	  return compare(b, a, loose)
	}
	
	exports.sort = sort
	function sort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.compare(a, b, loose)
	  })
	}
	
	exports.rsort = rsort
	function rsort (list, loose) {
	  return list.sort(function (a, b) {
	    return exports.rcompare(a, b, loose)
	  })
	}
	
	exports.gt = gt
	function gt (a, b, loose) {
	  return compare(a, b, loose) > 0
	}
	
	exports.lt = lt
	function lt (a, b, loose) {
	  return compare(a, b, loose) < 0
	}
	
	exports.eq = eq
	function eq (a, b, loose) {
	  return compare(a, b, loose) === 0
	}
	
	exports.neq = neq
	function neq (a, b, loose) {
	  return compare(a, b, loose) !== 0
	}
	
	exports.gte = gte
	function gte (a, b, loose) {
	  return compare(a, b, loose) >= 0
	}
	
	exports.lte = lte
	function lte (a, b, loose) {
	  return compare(a, b, loose) <= 0
	}
	
	exports.cmp = cmp
	function cmp (a, op, b, loose) {
	  switch (op) {
	    case '===':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a === b
	
	    case '!==':
	      if (typeof a === 'object')
	        a = a.version
	      if (typeof b === 'object')
	        b = b.version
	      return a !== b
	
	    case '':
	    case '=':
	    case '==':
	      return eq(a, b, loose)
	
	    case '!=':
	      return neq(a, b, loose)
	
	    case '>':
	      return gt(a, b, loose)
	
	    case '>=':
	      return gte(a, b, loose)
	
	    case '<':
	      return lt(a, b, loose)
	
	    case '<=':
	      return lte(a, b, loose)
	
	    default:
	      throw new TypeError('Invalid operator: ' + op)
	  }
	}
	
	exports.Comparator = Comparator
	function Comparator (comp, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (comp instanceof Comparator) {
	    if (comp.loose === !!options.loose) {
	      return comp
	    } else {
	      comp = comp.value
	    }
	  }
	
	  if (!(this instanceof Comparator)) {
	    return new Comparator(comp, options)
	  }
	
	  debug('comparator', comp, options)
	  this.options = options
	  this.loose = !!options.loose
	  this.parse(comp)
	
	  if (this.semver === ANY) {
	    this.value = ''
	  } else {
	    this.value = this.operator + this.semver.version
	  }
	
	  debug('comp', this)
	}
	
	var ANY = {}
	Comparator.prototype.parse = function (comp) {
	  var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
	  var m = comp.match(r)
	
	  if (!m) {
	    throw new TypeError('Invalid comparator: ' + comp)
	  }
	
	  this.operator = m[1]
	  if (this.operator === '=') {
	    this.operator = ''
	  }
	
	  // if it literally is just '>' or '' then allow anything.
	  if (!m[2]) {
	    this.semver = ANY
	  } else {
	    this.semver = new SemVer(m[2], this.options.loose)
	  }
	}
	
	Comparator.prototype.toString = function () {
	  return this.value
	}
	
	Comparator.prototype.test = function (version) {
	  debug('Comparator.test', version, this.options.loose)
	
	  if (this.semver === ANY) {
	    return true
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  return cmp(version, this.operator, this.semver, this.options)
	}
	
	Comparator.prototype.intersects = function (comp, options) {
	  if (!(comp instanceof Comparator)) {
	    throw new TypeError('a Comparator is required')
	  }
	
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  var rangeTmp
	
	  if (this.operator === '') {
	    rangeTmp = new Range(comp.value, options)
	    return satisfies(this.value, rangeTmp, options)
	  } else if (comp.operator === '') {
	    rangeTmp = new Range(this.value, options)
	    return satisfies(comp.semver, rangeTmp, options)
	  }
	
	  var sameDirectionIncreasing =
	    (this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '>=' || comp.operator === '>')
	  var sameDirectionDecreasing =
	    (this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '<=' || comp.operator === '<')
	  var sameSemVer = this.semver.version === comp.semver.version
	  var differentDirectionsInclusive =
	    (this.operator === '>=' || this.operator === '<=') &&
	    (comp.operator === '>=' || comp.operator === '<=')
	  var oppositeDirectionsLessThan =
	    cmp(this.semver, '<', comp.semver, options) &&
	    ((this.operator === '>=' || this.operator === '>') &&
	    (comp.operator === '<=' || comp.operator === '<'))
	  var oppositeDirectionsGreaterThan =
	    cmp(this.semver, '>', comp.semver, options) &&
	    ((this.operator === '<=' || this.operator === '<') &&
	    (comp.operator === '>=' || comp.operator === '>'))
	
	  return sameDirectionIncreasing || sameDirectionDecreasing ||
	    (sameSemVer && differentDirectionsInclusive) ||
	    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan
	}
	
	exports.Range = Range
	function Range (range, options) {
	  if (!options || typeof options !== 'object') {
	    options = {
	      loose: !!options,
	      includePrerelease: false
	    }
	  }
	
	  if (range instanceof Range) {
	    if (range.loose === !!options.loose &&
	        range.includePrerelease === !!options.includePrerelease) {
	      return range
	    } else {
	      return new Range(range.raw, options)
	    }
	  }
	
	  if (range instanceof Comparator) {
	    return new Range(range.value, options)
	  }
	
	  if (!(this instanceof Range)) {
	    return new Range(range, options)
	  }
	
	  this.options = options
	  this.loose = !!options.loose
	  this.includePrerelease = !!options.includePrerelease
	
	  // First, split based on boolean or ||
	  this.raw = range
	  this.set = range.split(/\s*\|\|\s*/).map(function (range) {
	    return this.parseRange(range.trim())
	  }, this).filter(function (c) {
	    // throw out any that are not relevant for whatever reason
	    return c.length
	  })
	
	  if (!this.set.length) {
	    throw new TypeError('Invalid SemVer Range: ' + range)
	  }
	
	  this.format()
	}
	
	Range.prototype.format = function () {
	  this.range = this.set.map(function (comps) {
	    return comps.join(' ').trim()
	  }).join('||').trim()
	  return this.range
	}
	
	Range.prototype.toString = function () {
	  return this.range
	}
	
	Range.prototype.parseRange = function (range) {
	  var loose = this.options.loose
	  range = range.trim()
	  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
	  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE]
	  range = range.replace(hr, hyphenReplace)
	  debug('hyphen replace', range)
	  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
	  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace)
	  debug('comparator trim', range, re[COMPARATORTRIM])
	
	  // `~ 1.2.3` => `~1.2.3`
	  range = range.replace(re[TILDETRIM], tildeTrimReplace)
	
	  // `^ 1.2.3` => `^1.2.3`
	  range = range.replace(re[CARETTRIM], caretTrimReplace)
	
	  // normalize spaces
	  range = range.split(/\s+/).join(' ')
	
	  // At this point, the range is completely trimmed and
	  // ready to be split into comparators.
	
	  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
	  var set = range.split(' ').map(function (comp) {
	    return parseComparator(comp, this.options)
	  }, this).join(' ').split(/\s+/)
	  if (this.options.loose) {
	    // in loose mode, throw out any that are not valid comparators
	    set = set.filter(function (comp) {
	      return !!comp.match(compRe)
	    })
	  }
	  set = set.map(function (comp) {
	    return new Comparator(comp, this.options)
	  }, this)
	
	  return set
	}
	
	Range.prototype.intersects = function (range, options) {
	  if (!(range instanceof Range)) {
	    throw new TypeError('a Range is required')
	  }
	
	  return this.set.some(function (thisComparators) {
	    return thisComparators.every(function (thisComparator) {
	      return range.set.some(function (rangeComparators) {
	        return rangeComparators.every(function (rangeComparator) {
	          return thisComparator.intersects(rangeComparator, options)
	        })
	      })
	    })
	  })
	}
	
	// Mostly just for testing and legacy API reasons
	exports.toComparators = toComparators
	function toComparators (range, options) {
	  return new Range(range, options).set.map(function (comp) {
	    return comp.map(function (c) {
	      return c.value
	    }).join(' ').trim().split(' ')
	  })
	}
	
	// comprised of xranges, tildes, stars, and gtlt's at this point.
	// already replaced the hyphen ranges
	// turn into a set of JUST comparators.
	function parseComparator (comp, options) {
	  debug('comp', comp, options)
	  comp = replaceCarets(comp, options)
	  debug('caret', comp)
	  comp = replaceTildes(comp, options)
	  debug('tildes', comp)
	  comp = replaceXRanges(comp, options)
	  debug('xrange', comp)
	  comp = replaceStars(comp, options)
	  debug('stars', comp)
	  return comp
	}
	
	function isX (id) {
	  return !id || id.toLowerCase() === 'x' || id === '*'
	}
	
	// ~, ~> --> * (any, kinda silly)
	// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
	// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
	// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
	// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
	// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
	function replaceTildes (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceTilde(comp, options)
	  }).join(' ')
	}
	
	function replaceTilde (comp, options) {
	  var r = options.loose ? re[TILDELOOSE] : re[TILDE]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('tilde', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      // ~1.2 == >=1.2.0 <1.3.0
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    } else if (pr) {
	      debug('replaceTilde pr', pr)
	      ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    } else {
	      // ~1.2.3 == >=1.2.3 <1.3.0
	      ret = '>=' + M + '.' + m + '.' + p +
	            ' <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('tilde return', ret)
	    return ret
	  })
	}
	
	// ^ --> * (any, kinda silly)
	// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
	// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
	// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
	// ^1.2.3 --> >=1.2.3 <2.0.0
	// ^1.2.0 --> >=1.2.0 <2.0.0
	function replaceCarets (comp, options) {
	  return comp.trim().split(/\s+/).map(function (comp) {
	    return replaceCaret(comp, options)
	  }).join(' ')
	}
	
	function replaceCaret (comp, options) {
	  debug('caret', comp, options)
	  var r = options.loose ? re[CARETLOOSE] : re[CARET]
	  return comp.replace(r, function (_, M, m, p, pr) {
	    debug('caret', comp, _, M, m, p, pr)
	    var ret
	
	    if (isX(M)) {
	      ret = ''
	    } else if (isX(m)) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (isX(p)) {
	      if (M === '0') {
	        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	      } else {
	        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0'
	      }
	    } else if (pr) {
	      debug('replaceCaret pr', pr)
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    } else {
	      debug('no pr')
	      if (M === '0') {
	        if (m === '0') {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + m + '.' + (+p + 1)
	        } else {
	          ret = '>=' + M + '.' + m + '.' + p +
	                ' <' + M + '.' + (+m + 1) + '.0'
	        }
	      } else {
	        ret = '>=' + M + '.' + m + '.' + p +
	              ' <' + (+M + 1) + '.0.0'
	      }
	    }
	
	    debug('caret return', ret)
	    return ret
	  })
	}
	
	function replaceXRanges (comp, options) {
	  debug('replaceXRanges', comp, options)
	  return comp.split(/\s+/).map(function (comp) {
	    return replaceXRange(comp, options)
	  }).join(' ')
	}
	
	function replaceXRange (comp, options) {
	  comp = comp.trim()
	  var r = options.loose ? re[XRANGELOOSE] : re[XRANGE]
	  return comp.replace(r, function (ret, gtlt, M, m, p, pr) {
	    debug('xRange', comp, ret, gtlt, M, m, p, pr)
	    var xM = isX(M)
	    var xm = xM || isX(m)
	    var xp = xm || isX(p)
	    var anyX = xp
	
	    if (gtlt === '=' && anyX) {
	      gtlt = ''
	    }
	
	    if (xM) {
	      if (gtlt === '>' || gtlt === '<') {
	        // nothing is allowed
	        ret = '<0.0.0'
	      } else {
	        // nothing is forbidden
	        ret = '*'
	      }
	    } else if (gtlt && anyX) {
	      // we know patch is an x, because we have any x at all.
	      // replace X with 0
	      if (xm) {
	        m = 0
	      }
	      p = 0
	
	      if (gtlt === '>') {
	        // >1 => >=2.0.0
	        // >1.2 => >=1.3.0
	        // >1.2.3 => >= 1.2.4
	        gtlt = '>='
	        if (xm) {
	          M = +M + 1
	          m = 0
	          p = 0
	        } else {
	          m = +m + 1
	          p = 0
	        }
	      } else if (gtlt === '<=') {
	        // <=0.7.x is actually <0.8.0, since any 0.7.x should
	        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
	        gtlt = '<'
	        if (xm) {
	          M = +M + 1
	        } else {
	          m = +m + 1
	        }
	      }
	
	      ret = gtlt + M + '.' + m + '.' + p
	    } else if (xm) {
	      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
	    } else if (xp) {
	      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
	    }
	
	    debug('xRange return', ret)
	
	    return ret
	  })
	}
	
	// Because * is AND-ed with everything else in the comparator,
	// and '' means "any version", just remove the *s entirely.
	function replaceStars (comp, options) {
	  debug('replaceStars', comp, options)
	  // Looseness is ignored here.  star is always as loose as it gets!
	  return comp.trim().replace(re[STAR], '')
	}
	
	// This function is passed to string.replace(re[HYPHENRANGE])
	// M, m, patch, prerelease, build
	// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
	// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
	// 1.2 - 3.4 => >=1.2.0 <3.5.0
	function hyphenReplace ($0,
	  from, fM, fm, fp, fpr, fb,
	  to, tM, tm, tp, tpr, tb) {
	  if (isX(fM)) {
	    from = ''
	  } else if (isX(fm)) {
	    from = '>=' + fM + '.0.0'
	  } else if (isX(fp)) {
	    from = '>=' + fM + '.' + fm + '.0'
	  } else {
	    from = '>=' + from
	  }
	
	  if (isX(tM)) {
	    to = ''
	  } else if (isX(tm)) {
	    to = '<' + (+tM + 1) + '.0.0'
	  } else if (isX(tp)) {
	    to = '<' + tM + '.' + (+tm + 1) + '.0'
	  } else if (tpr) {
	    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr
	  } else {
	    to = '<=' + to
	  }
	
	  return (from + ' ' + to).trim()
	}
	
	// if ANY of the sets match ALL of its comparators, then pass
	Range.prototype.test = function (version) {
	  if (!version) {
	    return false
	  }
	
	  if (typeof version === 'string') {
	    version = new SemVer(version, this.options)
	  }
	
	  for (var i = 0; i < this.set.length; i++) {
	    if (testSet(this.set[i], version, this.options)) {
	      return true
	    }
	  }
	  return false
	}
	
	function testSet (set, version, options) {
	  for (var i = 0; i < set.length; i++) {
	    if (!set[i].test(version)) {
	      return false
	    }
	  }
	
	  if (version.prerelease.length && !options.includePrerelease) {
	    // Find the set of versions that are allowed to have prereleases
	    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
	    // That should allow `1.2.3-pr.2` to pass.
	    // However, `1.2.4-alpha.notready` should NOT be allowed,
	    // even though it's within the range set by the comparators.
	    for (i = 0; i < set.length; i++) {
	      debug(set[i].semver)
	      if (set[i].semver === ANY) {
	        continue
	      }
	
	      if (set[i].semver.prerelease.length > 0) {
	        var allowed = set[i].semver
	        if (allowed.major === version.major &&
	            allowed.minor === version.minor &&
	            allowed.patch === version.patch) {
	          return true
	        }
	      }
	    }
	
	    // Version has a -pre, but it's not one of the ones we like.
	    return false
	  }
	
	  return true
	}
	
	exports.satisfies = satisfies
	function satisfies (version, range, options) {
	  try {
	    range = new Range(range, options)
	  } catch (er) {
	    return false
	  }
	  return range.test(version)
	}
	
	exports.maxSatisfying = maxSatisfying
	function maxSatisfying (versions, range, options) {
	  var max = null
	  var maxSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!max || maxSV.compare(v) === -1) {
	        // compare(max, v, true)
	        max = v
	        maxSV = new SemVer(max, options)
	      }
	    }
	  })
	  return max
	}
	
	exports.minSatisfying = minSatisfying
	function minSatisfying (versions, range, options) {
	  var min = null
	  var minSV = null
	  try {
	    var rangeObj = new Range(range, options)
	  } catch (er) {
	    return null
	  }
	  versions.forEach(function (v) {
	    if (rangeObj.test(v)) {
	      // satisfies(v, range, options)
	      if (!min || minSV.compare(v) === 1) {
	        // compare(min, v, true)
	        min = v
	        minSV = new SemVer(min, options)
	      }
	    }
	  })
	  return min
	}
	
	exports.minVersion = minVersion
	function minVersion (range, loose) {
	  range = new Range(range, loose)
	
	  var minver = new SemVer('0.0.0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = new SemVer('0.0.0-0')
	  if (range.test(minver)) {
	    return minver
	  }
	
	  minver = null
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    comparators.forEach(function (comparator) {
	      // Clone to avoid manipulating the comparator's semver object.
	      var compver = new SemVer(comparator.semver.version)
	      switch (comparator.operator) {
	        case '>':
	          if (compver.prerelease.length === 0) {
	            compver.patch++
	          } else {
	            compver.prerelease.push(0)
	          }
	          compver.raw = compver.format()
	          /* fallthrough */
	        case '':
	        case '>=':
	          if (!minver || gt(minver, compver)) {
	            minver = compver
	          }
	          break
	        case '<':
	        case '<=':
	          /* Ignore maximum versions */
	          break
	        /* istanbul ignore next */
	        default:
	          throw new Error('Unexpected operation: ' + comparator.operator)
	      }
	    })
	  }
	
	  if (minver && range.test(minver)) {
	    return minver
	  }
	
	  return null
	}
	
	exports.validRange = validRange
	function validRange (range, options) {
	  try {
	    // Return '*' instead of '' so that truthiness works.
	    // This will throw if it's invalid anyway
	    return new Range(range, options).range || '*'
	  } catch (er) {
	    return null
	  }
	}
	
	// Determine if version is less than all the versions possible in the range
	exports.ltr = ltr
	function ltr (version, range, options) {
	  return outside(version, range, '<', options)
	}
	
	// Determine if version is greater than all the versions possible in the range.
	exports.gtr = gtr
	function gtr (version, range, options) {
	  return outside(version, range, '>', options)
	}
	
	exports.outside = outside
	function outside (version, range, hilo, options) {
	  version = new SemVer(version, options)
	  range = new Range(range, options)
	
	  var gtfn, ltefn, ltfn, comp, ecomp
	  switch (hilo) {
	    case '>':
	      gtfn = gt
	      ltefn = lte
	      ltfn = lt
	      comp = '>'
	      ecomp = '>='
	      break
	    case '<':
	      gtfn = lt
	      ltefn = gte
	      ltfn = gt
	      comp = '<'
	      ecomp = '<='
	      break
	    default:
	      throw new TypeError('Must provide a hilo val of "<" or ">"')
	  }
	
	  // If it satisifes the range it is not outside
	  if (satisfies(version, range, options)) {
	    return false
	  }
	
	  // From now on, variable terms are as if we're in "gtr" mode.
	  // but note that everything is flipped for the "ltr" function.
	
	  for (var i = 0; i < range.set.length; ++i) {
	    var comparators = range.set[i]
	
	    var high = null
	    var low = null
	
	    comparators.forEach(function (comparator) {
	      if (comparator.semver === ANY) {
	        comparator = new Comparator('>=0.0.0')
	      }
	      high = high || comparator
	      low = low || comparator
	      if (gtfn(comparator.semver, high.semver, options)) {
	        high = comparator
	      } else if (ltfn(comparator.semver, low.semver, options)) {
	        low = comparator
	      }
	    })
	
	    // If the edge version comparator has a operator then our version
	    // isn't outside it
	    if (high.operator === comp || high.operator === ecomp) {
	      return false
	    }
	
	    // If the lowest version comparator has an operator and our version
	    // is less than it then it isn't higher than the range
	    if ((!low.operator || low.operator === comp) &&
	        ltefn(version, low.semver)) {
	      return false
	    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
	      return false
	    }
	  }
	  return true
	}
	
	exports.prerelease = prerelease
	function prerelease (version, options) {
	  var parsed = parse(version, options)
	  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
	}
	
	exports.intersects = intersects
	function intersects (r1, r2, options) {
	  r1 = new Range(r1, options)
	  r2 = new Range(r2, options)
	  return r1.intersects(r2)
	}
	
	exports.coerce = coerce
	function coerce (version) {
	  if (version instanceof SemVer) {
	    return version
	  }
	
	  if (typeof version !== 'string') {
	    return null
	  }
	
	  var match = version.match(re[COERCE])
	
	  if (match == null) {
	    return null
	  }
	
	  return parse(match[1] +
	    '.' + (match[2] || '0') +
	    '.' + (match[3] || '0'))
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Modal = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initModal;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(17);
	
	var Modal = exports.Modal = function () {
	
	  /**
	   * @param  {Dom}    modelContents     contents of the modal to show
	   * @param  {Dom}    clickRegion  button or other element to show modal
	   */
	  function Modal(modelContents, clickRegion) {
	    _classCallCheck(this, Modal);
	
	    this.modalContents = modelContents;
	    this.clickRegion = clickRegion;
	    this.isOpen = false;
	    this.magicNumberForEscapeKey = 27;
	    this.magicNumberForTabIndex = -1;
	
	    // Bind the context with the events
	    this.open = this.open.bind(this);
	    this.negative = this.negative.bind(this);
	    this.positive = this.positive.bind(this);
	    this.checkEscapeKey = this.checkEscapeKey.bind(this);
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    // Initialize modal
	    this.init();
	  }
	
	  _createClass(Modal, [{
	    key: 'init',
	    value: function init() {
	      this.bindButtons();
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.clickRegion[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var click = _step.value;
	
	          _get__('addEvent')(click, 'click', this.open);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'bindButtons',
	    value: function bindButtons() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this.modalContents.querySelectorAll('.js-modal-close')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var closeButton = _step2.value;
	
	          _get__('addEvent')(closeButton, 'click', this.negative);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = this.modalContents.querySelectorAll('.js-modal-positive')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var positiveButton = _step3.value;
	
	          _get__('addEvent')(positiveButton, 'click', this.positive);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      this.createBackdrop();
	      this.modalContents.classList.add('modal--is-open');
	      document.body.setAttribute('aria-hidden', 'true');
	      _get__('addEvent')(document, 'keydown', this.checkEscapeKey);
	      _get__('triggerEvent')(this.modalContents, 'show.commonui.modal');
	      this.isOpen = true;
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.removeBackdrop();
	      this.modalContents.classList.remove('modal--is-open');
	      document.body.removeAttribute('aria-hidden', 'true');
	      document.onkeydown = null;
	      _get__('triggerEvent')(this.modalContents, 'hide.commonui.modal');
	      this.isOpen = false;
	    }
	  }, {
	    key: 'createBackdrop',
	    value: function createBackdrop() {
	      // Create the modal backdrop container
	      this.modalBackdrop = document.createElement('div');
	      this.modalBackdrop.classList.add('modal-backdrop');
	      this.modalBackdrop.classList.add('modal-backdrop--open');
	      this.modalBackdrop.setAttribute('tabindex', this.magicNumberForTabIndex);
	      document.body.appendChild(this.modalBackdrop);
	      this.modalBackdrop.focus();
	    }
	  }, {
	    key: 'removeBackdrop',
	    value: function removeBackdrop() {
	      if (this.isOpen) {
	        this.modalBackdrop.outerHTML = '';
	      }
	    }
	  }, {
	    key: 'positive',
	    value: function positive() {
	      _get__('triggerEvent')(this.modalContents, 'positive.commonui.modal');
	      this.close();
	    }
	  }, {
	    key: 'negative',
	    value: function negative() {
	      _get__('triggerEvent')(this.modalContents, 'negative.commonui.modal');
	      this.close();
	    }
	  }, {
	    key: 'checkEscapeKey',
	    value: function checkEscapeKey(evt) {
	      if (evt && evt.keyCode === this.magicNumberForEscapeKey) {
	        this.negative();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.clickRegion[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var click = _step4.value;
	
	          _get__('removeEvent')(click, 'click', this.open);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.modalContents) {
	        console.warn('CommonUI - Modal - No modal contents found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Modal;
	}();
	
	/**
	 * creates a new modal instance
	 * @param  {Object} config
	 */
	
	
	function initModal() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-modal' : _config$selector,
	      _config$clickElementS = config.clickElementSelector,
	      clickElementSelector = _config$clickElementS === undefined ? '.js-modal__button' : _config$clickElementS;
	
	  var modal = null;
	  if (typeof selector === 'string') {
	    modal = new (_get__('Modal'))(document.querySelector(selector), document.querySelectorAll(clickElementSelector));
	  }
	  return modal;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Modal':
	      return Modal;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initModal === 'undefined' ? 'undefined' : _typeof(initModal);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initModal, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initModal)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// Polyfill for creating CustomEvents on IE9/10/11
	
	// code pulled from:
	// https://github.com/d4tocchini/customevent-polyfill
	// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent#Polyfill
	
	try {
	  new window.CustomEvent("test");
	} catch(e) {
	 var CustomEvent = function(event, params) {
	      var evt;
	      params = params || {
	          bubbles: false,
	          cancelable: false,
	          detail: undefined
	      };
	
	      evt = document.createEvent("CustomEvent");
	      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
	      return evt;
	  };
	
	  CustomEvent.prototype = window.Event.prototype;
	  window.CustomEvent = CustomEvent; // expose definition to window
	}


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Nav = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	
	exports.default = initNav;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Nav = exports.Nav = function () {
	
	  /**
	   * @param  {Dom}    nav             Navigation DOM element
	   */
	  function Nav(nav) {
	    _classCallCheck(this, Nav);
	
	    this.nav = nav;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.isGlobal = nav.classList.contains('nav--global');
	    this.isTouchSupported = 'ontouchstart' in window;
	    this.isPointerSupported = 'pointerdown' in window;
	    this.clickEvent = 'click';
	
	    // this.navToggle = navToggle;
	    this.navInner = nav.querySelector('.nav__inner');
	    this.navPrimary = nav.querySelector('.nav__items--primary');
	    this.navPrimaryItems = this.navPrimary ? this.navPrimary.querySelectorAll('.nav__item--primary') : null;
	    this.navActions = nav.querySelector('.nav__actions');
	
	    // Initialize navigation
	    this.init();
	  }
	
	  _createClass(Nav, [{
	    key: 'init',
	    value: function init() {
	
	      // Add the nav actions element if it doesn't already exist
	      if (!this.navActions) {
	        var navActions = document.createElement('ul');
	        _get__('addClasses')(navActions, ['nav__actions']);
	        this.navInner.appendChild(navActions);
	        this.navActions = navActions;
	      }
	
	      var mobileNavIconClass = this.isGlobal ? 'fa-bars' : 'fa-chevron-down';
	
	      var newNavAction = document.createElement('li');
	
	      this.navToggle = document.createElement('button');
	
	      _get__('addClasses')(newNavAction, ['nav__action', 'hide--md-and-up']);
	      _get__('addClasses')(this.navToggle, ['nav__action-btn', 'js-nav-toggle']);
	      this.navToggle.innerHTML = '<i class="fa ' + mobileNavIconClass + '"></i>';
	      newNavAction.appendChild(this.navToggle);
	      this.navActions.appendChild(newNavAction);
	
	      // Check if a primary navigation element exists
	      if (this.navPrimaryItems) {
	
	        // Bind the click event of the navigation toggle to the openMenu() method
	        _get__('addEvent')(this.navToggle, this.clickEvent, this.openMenu.bind(this));
	
	        // Loop through each primary navigation item
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = this.navPrimaryItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var navPrimaryItem = _step.value;
	
	
	            var navPrimaryItemLink = navPrimaryItem.querySelector('a');
	            var navSecondary = navPrimaryItem.querySelector('.nav__items--secondary');
	
	            // Check if this primary navigation item also contains secondary level navigation items
	            if (navSecondary !== null) {
	
	              var navSecondaryItems = navSecondary.querySelectorAll('.nav__item--secondary');
	
	              // Determine the height of the sub nav and set the max-height as an inline style
	              // as we need a fixed height for the CSS transition to work
	              // let subNavHeight = subNav.offsetHeight;
	
	              var navSecondaryHeight = window.innerHeight / 100 * 75; // 75% of viewport width
	              var navSecondaryMobileHeight = navSecondaryItems.length * 57; // TODO: Find a better way to determine the height of the sub nav
	
	              navSecondary.setAttribute('data-height', navSecondaryHeight);
	              navSecondary.setAttribute('data-mobile-height', navSecondaryMobileHeight);
	
	              // Apply a "has-children" class to the primary navigation element if it doesn't already exist
	              if (!navPrimaryItem.classList.contains('has-children')) {
	                _get__('addClasses')(navPrimaryItem, ['has-children']);
	              }
	
	              // Bind the click event of this primary navigation link to toggle the secondary navigation
	              _get__('addEvent')(navPrimaryItemLink, this.clickEvent, this.toggleSubMenu.bind(this, navPrimaryItem));
	            } else {
	
	              // This is a top-level link that has no sub-nav, so bind different events
	              _get__('addEvent')(navPrimaryItemLink, this.clickEvent, this.setPrimaryNavItemAsActive.bind(this, navPrimaryItem));
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }
	
	    /**
	     * Removes the 'is-active' state from each navigation item at the specified level, i.e. primary or secondary.
	     * @param level
	     */
	
	  }, {
	    key: 'deactivateNavItems',
	    value: function deactivateNavItems(level) {
	      var activeNavItems = this.nav.querySelectorAll('.nav__items--' + level + ' > .is-active');
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = activeNavItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var activeNavItem = _step2.value;
	
	          _get__('removeClasses')(activeNavItem, ['is-active']);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	
	    /**
	     * Deactivates all currently active primary and secondary level navigation elements.
	     * Marks the specified primary navigation item as active.
	     * Closes the menu.
	     * @param item
	     */
	
	  }, {
	    key: 'setPrimaryNavItemAsActive',
	    value: function setPrimaryNavItemAsActive(item) {
	
	      // Mark any currently active elements as inactive by removing the 'is-active' state
	      this.deactivateNavItems('primary');
	      this.deactivateNavItems('secondary');
	
	      // Mark the current item as active
	      if (!item.classList.contains('is-active')) {
	        _get__('addClasses')(item, ['is-active']);
	      }
	
	      // Finally, close the menu
	      this.closeMenu();
	    }
	
	    /**
	     * Utility method for determining if an element is visible in the DOM.
	     * Taken directly from the jQuery source.
	     * @param elem
	     * @returns {boolean}
	     * @see https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js
	     */
	
	  }, {
	    key: 'isVisible',
	    value: function isVisible(elem) {
	      return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
	    }
	
	    /**
	     * Unbinds all click events at the primary and secondary level navigation elements.
	     */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	
	      _get__('removeEvent')(this.navToggle, this.clickEvent, this.openMenu);
	
	      // Unbind the click events for all secondary navigation items
	      var primaryNavItemsWithChildren = this.nav.querySelectorAll('.nav__items--primary.has-children');
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = primaryNavItemsWithChildren[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var primaryNavItem = _step3.value;
	
	          var primaryNavItemLink = primaryNavItem.querySelector('a');
	          _get__('removeEvent')(primaryNavItemLink, this.clickEvent, this.toggleSubMenu.bind(this, primaryNavItem));
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'toggleSubMenu',
	    value: function toggleSubMenu(primaryNavItem, e) {
	
	      var isOpen = primaryNavItem.classList.contains('is-open');
	      var secondaryNav = primaryNavItem.querySelector('.nav__items--secondary');
	      var isMobileView = this.isVisible(this.navToggle);
	
	      if (isOpen) {
	
	        secondaryNav.style.maxHeight = '0px';
	        _get__('removeClasses')(primaryNavItem, ['is-open']);
	      } else {
	
	        var navSecondaryHeight = secondaryNav.getAttribute(isMobileView ? 'data-mobile-height' : 'data-height');
	        secondaryNav.style.maxHeight = navSecondaryHeight + 'px';
	
	        _get__('addClasses')(primaryNavItem, ['is-open']);
	
	        // Bind click events to each link to close the nav if a link is clicked
	        var secondaryNavLinks = secondaryNav.querySelectorAll('a');
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = secondaryNavLinks[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var secondaryNavLink = _step4.value;
	
	            _get__('addEvent')(secondaryNavLink, this.clickEvent, this.secondaryNavItemLinkClicked.bind(this, primaryNavItem, secondaryNav), false);
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'secondaryNavItemLinkClicked',
	    value: function secondaryNavItemLinkClicked(primaryNavItem, secondaryNav) {
	      _get__('removeClasses')(secondaryNav, ['is-open']);
	      this.closeMenu();
	    }
	  }, {
	    key: 'openMenu',
	    value: function openMenu() {
	
	      if (!this.isGlobal) {
	        var toggleIcon = this.navToggle.querySelector('i');
	        if (toggleIcon.classList.contains('flip')) {
	          _get__('removeClasses')(toggleIcon, ['flip']);
	        } else {
	          _get__('addClasses')(toggleIcon, ['flip']);
	        }
	      }
	
	      if (this.nav.classList.contains('is-open')) {
	        _get__('removeClasses')(this.nav, ['is-open']);
	        _get__('removeClasses')(this.navPrimary, ['is-open']);
	      } else {
	        _get__('addClasses')(this.nav, ['is-open']);
	        _get__('addClasses')(this.navPrimary, ['is-open']);
	      }
	
	      var isMobileView = this.isVisible(this.navToggle);
	
	      if (isMobileView && this.isGlobal) {
	
	        this.overlay = document.createElement('div');
	        _get__('addClasses')(this.overlay, ['overlay', 'fade', 'js-overlay']);
	        this.navPrimary.parentNode.insertBefore(this.overlay, this.navPrimary);
	
	        this.navSectionHeader = document.createElement('li');
	        _get__('addClasses')(this.navSectionHeader, ['nav__item--primary', 'nav__section--header', 'is-sticky']);
	        this.navSectionHeader.innerText = 'Menu';
	
	        this.navCloseBtn = document.createElement('button');
	        _get__('addClasses')(this.navCloseBtn, ['btn', 'btn--close', 'fade', 'js-close-menu']);
	        this.navCloseBtn.innerHTML = '<i class="icon-cme-card-close"></i>';
	        this.navSectionHeader.appendChild(this.navCloseBtn);
	
	        this.navPrimary.insertBefore(this.navSectionHeader, this.navPrimary.firstChild);
	
	        setTimeout(function () {
	          _get__('addClasses')(this.overlay, ['fade--in']);
	          _get__('addClasses')(this.navCloseBtn, ['fade--in']);
	        }.bind(this), 100);
	      }
	
	      _get__('addEvent')(this.navCloseBtn, this.clickEvent, this.closeMenu.bind(this));
	    }
	  }, {
	    key: 'closeMenu',
	    value: function closeMenu() {
	
	      var isMobileView = this.isVisible(this.navToggle);
	
	      _get__('removeClasses')(this.nav, ['is-open']);
	      _get__('removeClasses')(this.navPrimary, ['is-open']);
	
	      if (isMobileView) {
	
	        if (this.isGlobal) {
	
	          _get__('removeClasses')(this.overlay, ['fade--in']);
	
	          setTimeout(function () {
	            // ChildNode.remove() is not supported in Internet Explorer,
	            // so we have to resort to the longhand version of ParentNode.removeChild() instead
	            this.overlay.parentNode.removeChild(this.overlay);
	            this.navSectionHeader.parentNode.removeChild(this.navSectionHeader);
	          }.bind(this), 300);
	        } else {
	
	          var toggleIcon = this.navToggle.querySelector('i');
	          if (toggleIcon !== null && toggleIcon.classList.contains('flip')) {
	            _get__('removeClasses')(toggleIcon, ['flip']);
	          }
	        }
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.nav) {
	        console.warn('CommonUI - Nav - There\'s no nav found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Nav;
	}();
	
	/**
	 * Creates a new nav instance
	 * @param  {Object} config
	 */
	
	
	function initNav() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-nav' : _config$selector;
	
	  var navs = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion5 = true;
	    var _didIteratorError5 = false;
	    var _iteratorError5 = undefined;
	
	    try {
	      for (var _iterator5 = document.querySelectorAll(selector)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	        var nav = _step5.value;
	
	        navs = new (_get__('Nav'))(nav);
	      }
	    } catch (err) {
	      _didIteratorError5 = true;
	      _iteratorError5 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion5 && _iterator5.return) {
	          _iterator5.return();
	        }
	      } finally {
	        if (_didIteratorError5) {
	          throw _iteratorError5;
	        }
	      }
	    }
	  }
	  return navs;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Nav':
	      return Nav;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initNav === 'undefined' ? 'undefined' : _typeof(initNav);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initNav, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initNav)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Search = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initSearch;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var KEY_ENTER = 13;
	var KEY_ESCAPE = 27;
	
	var Search = exports.Search = function () {
	
	  /**
	   * @param  {Dom}    search             container to hold search component
	   * @param  {String} searchButton       search button element
	   */
	
	  function Search(search, isOpen, allowClose, alwaysOpenDownInNav) {
	    _classCallCheck(this, Search);
	
	    this.search = search;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    this.searchToggle = search.querySelector('.search-toggle');
	    this.searchToggleIcon = search.querySelector('.search-toggle > i');
	    this.searchInput = search.querySelector('.search-input');
	    this.searchInputBox = search.querySelector('.search-input > input');
	    this.searchButton = search.querySelector('.search-input i');
	    this.isOpen = isOpen;
	    this.allowClose = allowClose;
	    this.alwaysOpenDownInNav = alwaysOpenDownInNav;
	    // Initialize search component
	    this.init();
	  }
	
	  _createClass(Search, [{
	    key: 'init',
	    value: function init() {
	      if (this.searchToggle && this.allowClose) {
	        this.search.classList.add('search--allow-close');
	      } else if (this.isOpen) {
	        this.searchToggle.classList.add('hide');
	      }
	      if (this.isOpen) {
	        this.search.classList.add('search--open');
	        this.searchToggleIcon.classList.remove('fa-search');
	        this.searchToggleIcon.classList.add('fa-close');
	      }
	      if (this.alwaysOpenDownInNav) {
	        this.search.classList.add('search--nav-down');
	      }
	      if (this.search.parentNode.classList.contains('nav__action')) {
	        this.search.parentNode.style.position = 'static';
	      }
	      _get__('addEvent')(this.searchToggle, 'click', this.toggle.bind(this));
	      _get__('addEvent')(this.searchInputBox, 'focus', this.selectText.bind(this));
	      _get__('addEvent')(this.searchInputBox, 'keydown', this.keyPress.bind(this));
	      _get__('addEvent')(this.searchButton, 'click', this.doSearch.bind(this));
	    }
	  }, {
	    key: 'selectText',
	    value: function selectText() {
	      this.searchInputBox.select();
	    }
	  }, {
	    key: 'keyPress',
	    value: function keyPress(event) {
	      if (event.which === _get__('KEY_ENTER')) {
	        this.doSearch();
	      }
	      if (event.which === _get__('KEY_ESCAPE') && this.allowClose) {
	        this.toggle();
	      }
	    }
	  }, {
	    key: 'doSearch',
	    value: function doSearch() {
	      _get__('triggerEvent')(this.search, 'do.commonui.search');
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      if (this.isOpen === false) {
	        this.search.classList.add('search--open');
	        if (this.allowClose === false) {
	          this.searchToggle.classList.add('hide');
	        } else {
	          this.searchToggleIcon.classList.remove('fa-search');
	          this.searchToggleIcon.classList.add('fa-close');
	        }
	        this.searchInputBox.focus();
	        this.isOpen = true;
	        _get__('triggerEvent')(this.search, 'open.commonui.search');
	      } else {
	        this.search.classList.remove('search--open');
	        this.searchToggleIcon.classList.remove('fa-close');
	        this.searchToggleIcon.classList.add('fa-search');
	        this.isOpen = false;
	        _get__('triggerEvent')(this.search, 'close.commonui.search');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.searchButton) {
	        _get__('removeEvent')(this.searchButton, 'click', this.toggle.bind(this));
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.search) {
	        console.warn('CommonUI - Search - There\'s no search component found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Search;
	}();
	
	/**
	 * Creates a new instance
	 * @param  {Object} config
	 */
	
	
	function initSearch() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-search' : _config$selector,
	      _config$openOnLoad = config.openOnLoad,
	      openOnLoad = _config$openOnLoad === undefined ? false : _config$openOnLoad,
	      _config$allowClose = config.allowClose,
	      allowClose = _config$allowClose === undefined ? true : _config$allowClose,
	      _config$alwaysOpenDow = config.alwaysOpenDownInNav,
	      alwaysOpenDownInNav = _config$alwaysOpenDow === undefined ? false : _config$alwaysOpenDow;
	
	  var searches = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var search = _step.value;
	
	        searches = new (_get__('Search'))(search, openOnLoad, allowClose, alwaysOpenDownInNav);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return searches;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'KEY_ENTER':
	      return KEY_ENTER;
	
	    case 'KEY_ESCAPE':
	      return KEY_ESCAPE;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Search':
	      return Search;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initSearch === 'undefined' ? 'undefined' : _typeof(initSearch);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initSearch, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initSearch)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Table = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initTable;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	var _ButtonGroup = __webpack_require__(21);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _formatInlineEdit = __webpack_require__(22);
	
	var _formatInlineEdit2 = _interopRequireDefault(_formatInlineEdit);
	
	var _isMobile = __webpack_require__(36);
	
	var _isMobile2 = _interopRequireDefault(_isMobile);
	
	var _delete = __webpack_require__(37);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var detailTableTypeList = {
	  detailedView: 'detailedView',
	  expandedRow: 'expandedRow',
	  stackedRow: 'stackedRow'
	};
	var overlayActionClasses = {
	  open: 'overlay__table--open',
	  close: 'overlay__table--close',
	  cancel: 'overlay__table--cancel',
	  trigger: 'js-table-overlay-trigger',
	  applyReorder: 'apply--reorder',
	  resetDefault: 'reset-to-default',
	  selectAll: 'select-all'
	};
	
	var Table = exports.Table = function () {
	  /**
	   * @param  {Dom}    table             table reference
	   */
	  function Table(config) {
	    _classCallCheck(this, Table);
	
	    this.table = config.table;
	
	    // Detail View
	    this.detailViewType = config.detailViewType;
	    this.detailViewSelector = config.detailViewSelector;
	    this.detailViewDismissTrigger = document.querySelector(config.detailViewDismissSelector);
	    this.inlineAlert = this.table.querySelector('.js-alert-overlay');
	    this.overlayTriggers = document.querySelectorAll('.' + _get__('overlayActionClasses').trigger);
	    this.overlayElement = document.querySelector(config.overlayElement);
	    this.overlayCloses = document.querySelectorAll('.' + _get__('overlayActionClasses').close);
	    this.cancelButton = document.querySelector('.' + _get__('overlayActionClasses').cancel);
	    this.applyReorder = document.querySelectorAll('.' + config.trigger);
	    this.buttonTrigger = document.querySelector('.' + config.trigger);
	    this.resetDefault = document.querySelector('.' + _get__('overlayActionClasses').resetDefault);
	    this.checkboxes = document.querySelectorAll('.' + _get__('overlayActionClasses').selectAll);
	    this.deleteModal = document.querySelector('.delete-row-modal');
	    this.inlineEdits = this.table.querySelectorAll('.inline--edit');
	    this.deleteRows = this.table.querySelectorAll('.delete-row');
	    this.selector = config.trigger;
	    this.tableReorder = config.tableReorder;
	    this.buttonGroup = {};
	
	    if (config.overlayElement) {
	      this.overlayElementString = config.overlayElement.split('.').join('');
	    }
	
	    this.currentTableHeaderOrder = [];
	    this.newTableHeaderOrder = [];
	    this.newOrderObject = {};
	    this.newOrderArray = [];
	    this.disabledList = {};
	    this.unlockedItems = [];
	    this.reorderDefaultState = {};
	    this.allRowsSelected = true;
	
	    this.switched = false;
	    this.magicBreakpoint = 768;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.copy = this.table.cloneNode(true);
	    _get__('formatInlineEdit')(this.copy.querySelectorAll('.inline--edit'));
	    this.copyTwo = this.table.cloneNode(true);
	    this.copyOverlayElement = {};
	
	    // Initialize table
	    this.init();
	  }
	
	  _createClass(Table, [{
	    key: 'init',
	    value: function init() {
	      if (!this.table.classList.contains('table--responsive')) {
	        this.table.classList.add('full--scroll');
	      }
	      if (!this.detailViewType) {
	        this.updateTable();
	      }
	      this.addListeners();
	      this.populateReorder();
	      this.checkSelectedRows();
	      _get__('formatInlineEdit')(this.inlineEdits);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (!this.detailViewType) {
	        this.unsplitTable();
	      }
	      this.removeListeners();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.table) {
	        console.warn('CommonUI - Table - There\'s no table found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: 'updateTable',
	    value: function updateTable() {
	      if (window.innerWidth < this.magicBreakpoint && !this.switched) {
	        this.switched = true;
	        this.splitTable();
	      } else if (this.switched && window.innerWidth >= this.magicBreakpoint) {
	        this.switched = false;
	        this.unsplitTable();
	      }
	    }
	  }, {
	    key: 'splitTable',
	    value: function splitTable() {
	      if (!this.table.classList.contains('full--scroll')) {
	        _get__('wrap')(this.table, 'table--wrapper');
	        this.copy.classList.remove('table--responsive');
	        this.table.parentElement.appendChild(this.copy);
	        _get__('wrap')(this.copy, 'table--pinned');
	        _get__('wrap')(this.table, 'table--scrollable');
	        if (this.inlineAlert) {
	          _get__('addEvent')(this.table.parentElement, 'scroll', this.updateAlertPosition.bind(this));
	        }
	      }
	    }
	  }, {
	    key: 'unsplitTable',
	    value: function unsplitTable() {
	      if (!this.table.classList.contains('full--scroll')) {
	        _get__('unwrap')(this.table);
	        _get__('unwrap')(this.table);
	        this.copy.parentNode.parentNode.removeChild(this.copy.parentNode);
	      }
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _this = this;
	
	      switch (this.detailViewType) {
	        case _get__('detailTableTypeList').detailedView:
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = this.table.querySelectorAll('.js-table-detail-trigger')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var detailViewTrigger = _step.value;
	
	              _get__('addEvent')(detailViewTrigger, 'click', this.showDetailView.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _get__('addEvent')(this.detailViewDismissTrigger, 'click', this.hideDetailView.bind(this));
	          break;
	        case _get__('detailTableTypeList').expandedRow:
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = this.table.querySelectorAll('.js-table-detail-expand-trigger')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var expandedViewTrigger = _step2.value;
	
	              _get__('addEvent')(expandedViewTrigger, 'click', this.toggleExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          break;
	        case _get__('detailTableTypeList').stackedRow:
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = this.table.querySelectorAll('.js-table-detail-stacked-trigger')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var stackedExpandedViewTrigger = _step3.value;
	
	              _get__('addEvent')(stackedExpandedViewTrigger, 'click', this.toggleStackedExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	
	          break;
	        default:
	          _get__('addEvent')(window, 'resize', this.updateTable.bind(this));
	          break;
	      }
	      this.overlayListeners();
	      _get__('addEvent')(this.table, 'apply.commonui.inline-edit', function () {
	        _this.copy = _this.table.cloneNode(true);
	      });
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.deleteRows[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var row = _step4.value;
	
	          _get__('addEvent')(row, 'click', this.confirmDeleteRow.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updateAlertPosition',
	    value: function updateAlertPosition() {
	      if (_get__('hasClass')(this.inlineAlert, 'is-minimised')) {
	        _get__('removeEvent')(this.table.parentElement, 'scroll', this.updateAlertPosition.bind(this));
	        return;
	      }
	      _get__('setStyles')(this.inlineAlert, { left: '-' + this.table.parentElement.scrollLeft + 'px' });
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      switch (this.detailViewType) {
	        case _get__('detailTableTypeList').detailedView:
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = this.table.querySelectorAll('.js-table-detail-trigger')[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var detailViewTrigger = _step5.value;
	
	              _get__('removeEvent')(detailViewTrigger, 'click', this.showDetailView.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	
	          _get__('removeEvent')(this.detailViewDismissTrigger, 'click', this.hideDetailView.bind(this));
	          break;
	        case _get__('detailTableTypeList').expandedRow:
	          var _iteratorNormalCompletion6 = true;
	          var _didIteratorError6 = false;
	          var _iteratorError6 = undefined;
	
	          try {
	            for (var _iterator6 = this.table.querySelectorAll('.js-table-detail-expand-trigger')[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	              var expandedViewTrigger = _step6.value;
	
	              _get__('removeEvent')(expandedViewTrigger, 'click', this.toggleExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                _iterator6.return();
	              }
	            } finally {
	              if (_didIteratorError6) {
	                throw _iteratorError6;
	              }
	            }
	          }
	
	          break;
	        case _get__('detailTableTypeList').stackedRow:
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = this.table.querySelectorAll('.js-table-detail-stacked-trigger')[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var stackedExpandedViewTrigger = _step7.value;
	
	              _get__('removeEvent')(stackedExpandedViewTrigger, 'click', this.toggleStackedExpandedRow.bind(this));
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	
	          break;
	        default:
	          _get__('removeEvent')(window, 'resize', this.updateTable.bind(this));
	          break;
	      }
	    }
	  }, {
	    key: 'overlayListeners',
	    value: function overlayListeners() {
	      var _iteratorNormalCompletion8 = true;
	      var _didIteratorError8 = false;
	      var _iteratorError8 = undefined;
	
	      try {
	        for (var _iterator8 = this.overlayTriggers[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	          var overlayTrigger = _step8.value;
	
	          _get__('addEvent')(overlayTrigger, 'click', this.open.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError8 = true;
	        _iteratorError8 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion8 && _iterator8.return) {
	            _iterator8.return();
	          }
	        } finally {
	          if (_didIteratorError8) {
	            throw _iteratorError8;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion9 = true;
	      var _didIteratorError9 = false;
	      var _iteratorError9 = undefined;
	
	      try {
	        for (var _iterator9 = this.overlayCloses[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	          var overlayClose = _step9.value;
	
	          _get__('addEvent')(overlayClose, 'click', this.close.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError9 = true;
	        _iteratorError9 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion9 && _iterator9.return) {
	            _iterator9.return();
	          }
	        } finally {
	          if (_didIteratorError9) {
	            throw _iteratorError9;
	          }
	        }
	      }
	
	      _get__('addEvent')(this.cancelButton, 'click', this.close.bind(this));
	      var _iteratorNormalCompletion10 = true;
	      var _didIteratorError10 = false;
	      var _iteratorError10 = undefined;
	
	      try {
	        for (var _iterator10 = this.applyReorder[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	          var apply = _step10.value;
	
	          _get__('addEvent')(apply, 'click', this.reorderTable.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError10 = true;
	        _iteratorError10 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion10 && _iterator10.return) {
	            _iterator10.return();
	          }
	        } finally {
	          if (_didIteratorError10) {
	            throw _iteratorError10;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion11 = true;
	      var _didIteratorError11 = false;
	      var _iteratorError11 = undefined;
	
	      try {
	        for (var _iterator11 = this.checkboxes[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	          var checkbox = _step11.value;
	
	          _get__('addEvent')(checkbox, 'click', this.selectAll.bind(this));
	        }
	      } catch (err) {
	        _didIteratorError11 = true;
	        _iteratorError11 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion11 && _iterator11.return) {
	            _iterator11.return();
	          }
	        } finally {
	          if (_didIteratorError11) {
	            throw _iteratorError11;
	          }
	        }
	      }
	
	      _get__('addEvent')(this.resetDefault, 'click', this.reset.bind(this));
	    }
	
	    // Detail View
	
	  }, {
	    key: 'showDetailView',
	    value: function showDetailView() {
	      if (this.detailViewType === _get__('detailTableTypeList').detailedView && this.table) {
	        var secondaryView = this.table.querySelector('.js-table-secondary-view');
	        secondaryView.style.top = this.table.scrollTop + 'px';
	        this.table.classList.add('is-active');
	      }
	    }
	  }, {
	    key: 'hideDetailView',
	    value: function hideDetailView() {
	      if (this.detailViewType === _get__('detailTableTypeList').detailedView && this.table) {
	        this.table.classList.remove('is-active');
	      }
	    }
	
	    // Expanded Row
	
	  }, {
	    key: 'toggleExpandedRow',
	    value: function toggleExpandedRow(event) {
	      var nextExpandedRow = event.currentTarget.parentNode.nextElementSibling;
	      if (nextExpandedRow.classList.contains('is-active')) {
	        event.currentTarget.classList.remove('is-active');
	        nextExpandedRow.classList.remove('is-active');
	      } else {
	        event.currentTarget.classList.add('is-active');
	        nextExpandedRow.classList.add('is-active');
	      }
	    }
	
	    // Stacked Expanded Row
	
	  }, {
	    key: 'toggleStackedExpandedRow',
	    value: function toggleStackedExpandedRow(event) {
	      var previousContentSection = event.currentTarget.parentNode.parentNode;
	      var expandedContainer = previousContentSection.querySelector('.js-stacked-content');
	      if (expandedContainer.classList.contains('is-active')) {
	        event.currentTarget.classList.remove('is-active');
	        expandedContainer.classList.remove('is-active');
	      } else {
	        event.currentTarget.classList.add('is-active');
	        expandedContainer.classList.add('is-active');
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(event) {
	      if (this.overlayElement && this.overlayElement.classList === event.target.parentElement.children[1].lastElementChild.classList) {
	        this.overlayElement.classList.add(_get__('overlayActionClasses').open);
	        event.target.nextElementSibling.scrollLeft = 0;
	        event.target.nextElementSibling.style.overflowX = 'hidden';
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close(event) {
	      if (event.target.classList.contains(_get__('overlayActionClasses').close) || event.target.classList.contains('apply--reorder')) {
	        event.target.parentElement.parentElement.parentElement.classList.remove(_get__('overlayActionClasses').open);
	        event.target.parentElement.parentElement.parentElement.parentElement.style.overflowX = 'scroll';
	      }
	      this.reset(event, true);
	    }
	  }, {
	    key: 'populateReorder',
	    value: function populateReorder() {
	      if (this.table.classList.contains(this.tableReorder)) {
	        var uList = document.createElement('ul');
	        uList.classList.add('btn-group', 'js-btn-group');
	        var _iteratorNormalCompletion12 = true;
	        var _didIteratorError12 = false;
	        var _iteratorError12 = undefined;
	
	        try {
	          for (var _iterator12 = this.copy.tHead.rows[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	            var row = _step12.value;
	
	            var index = 0;
	            var _iteratorNormalCompletion14 = true;
	            var _didIteratorError14 = false;
	            var _iteratorError14 = undefined;
	
	            try {
	              for (var _iterator14 = row.cells[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	                var cell = _step14.value;
	
	                this.currentTableHeaderOrder.push(cell.innerText);
	                this.newOrderObject[index] = cell.innerText;
	                var list = document.createElement('li');
	                list.classList.add('btn-group-item');
	                list.setAttribute('data-id', index);
	                if (cell.classList.contains('table__heading--disable')) {
	                  this.disabledList[index] = cell.innerText;
	                  list.setAttribute('disabled', true);
	                }
	
	                var input = document.createElement('input');
	                input.classList.add('btn-group-item__input');
	                input.setAttribute('type', 'checkbox');
	                input.setAttribute('id', cell.innerText);
	                list.appendChild(input);
	
	                if (input.parentElement.getAttribute('disabled')) {
	                  input.checked = true;
	                }
	
	                if (cell.classList.contains('table--reorder--show-row')) {
	                  input.checked = true;
	                }
	
	                var label = document.createElement('label');
	                label.classList.add('btn-group-item__label');
	                label.setAttribute('for', cell.innerText);
	                label.setAttribute('draggable', true);
	                label.innerHTML = cell.innerText;
	
	                var icon = document.createElement('i');
	                icon.classList.add('icon-cme-drag-drop');
	
	                label.appendChild(icon);
	                list.appendChild(label);
	                uList.appendChild(list);
	
	                index += 1;
	              }
	            } catch (err) {
	              _didIteratorError14 = true;
	              _iteratorError14 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion14 && _iterator14.return) {
	                  _iterator14.return();
	                }
	              } finally {
	                if (_didIteratorError14) {
	                  throw _iteratorError14;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError12 = true;
	          _iteratorError12 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion12 && _iterator12.return) {
	              _iterator12.return();
	            }
	          } finally {
	            if (_didIteratorError12) {
	              throw _iteratorError12;
	            }
	          }
	        }
	
	        this.buttonTrigger.setAttribute('disabled', true);
	        this.cancelButton.setAttribute('disabled', true);
	        this.resetDefault.setAttribute('disabled', true);
	        this.overlayElement.lastElementChild.children[1].appendChild(uList);
	        this.reorderDefaultState = uList.cloneNode(true);
	        this.copyOverlayElement = this.overlayElement.cloneNode(true);
	        this.defaultUnlockedItems = this.getUnlockedItems(this.reorderDefaultState);
	        this.unlockedItems = this.getUnlockedItems(uList);
	
	        _get__('initButtonGroup')(uList);
	
	        this.buttonGroup = uList;
	
	        var _iteratorNormalCompletion13 = true;
	        var _didIteratorError13 = false;
	        var _iteratorError13 = undefined;
	
	        try {
	          for (var _iterator13 = this.buttonGroup.children[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	            var button = _step13.value;
	
	            _get__('addEvent')(button, 'change', this.checkSelectedRows.bind(this));
	            _get__('addEvent')(button, 'click', this.enableApply.bind(this));
	          }
	        } catch (err) {
	          _didIteratorError13 = true;
	          _iteratorError13 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion13 && _iterator13.return) {
	              _iterator13.return();
	            }
	          } finally {
	            if (_didIteratorError13) {
	              throw _iteratorError13;
	            }
	          }
	        }
	
	        _get__('addEvent')(uList, 'drop.commonui.buttonGroup', this.enableApply.bind(this));
	      }
	    }
	  }, {
	    key: 'getUnlockedItems',
	    value: function getUnlockedItems(list) {
	      var unlockedItems = [];
	      var _iteratorNormalCompletion15 = true;
	      var _didIteratorError15 = false;
	      var _iteratorError15 = undefined;
	
	      try {
	        for (var _iterator15 = list.children[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	          var listItem = _step15.value;
	
	          if (!listItem.getAttribute('disabled')) {
	            unlockedItems.push(listItem.lastElementChild.innerHTML);
	          }
	        }
	      } catch (err) {
	        _didIteratorError15 = true;
	        _iteratorError15 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion15 && _iterator15.return) {
	            _iterator15.return();
	          }
	        } finally {
	          if (_didIteratorError15) {
	            throw _iteratorError15;
	          }
	        }
	      }
	
	      return unlockedItems;
	    }
	  }, {
	    key: 'createNewTableHeaderOrder',
	    value: function createNewTableHeaderOrder(tableHeaderOrder) {
	      var newTableHeaderOrder = tableHeaderOrder;
	      for (var key in this.disabledList) {
	        for (var header in newTableHeaderOrder) {
	          if (this.disabledList[key] === newTableHeaderOrder[header]) {
	            newTableHeaderOrder.splice(header, 1);
	            break;
	          }
	        }
	      }
	
	      for (var _key in this.disabledList) {
	        newTableHeaderOrder.splice(_key, 0, this.disabledList[_key]);
	      }
	
	      return newTableHeaderOrder;
	    }
	  }, {
	    key: 'reorderTableHeaders',
	    value: function reorderTableHeaders() {
	      var newOrderArray = [];
	      var _iteratorNormalCompletion16 = true;
	      var _didIteratorError16 = false;
	      var _iteratorError16 = undefined;
	
	      try {
	        for (var _iterator16 = this.table.tHead.rows[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	          var row = _step16.value;
	
	          var index = 0;
	          var _iteratorNormalCompletion17 = true;
	          var _didIteratorError17 = false;
	          var _iteratorError17 = undefined;
	
	          try {
	            for (var _iterator17 = row.cells[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	              var cell = _step17.value;
	
	              cell.innerHTML = this.newTableHeaderOrder[index];
	              for (var key in this.newOrderObject) {
	                if (cell.innerText === this.newOrderObject[key]) {
	                  newOrderArray.push(parseInt(key, 10));
	                }
	              }
	              index += 1;
	            }
	          } catch (err) {
	            _didIteratorError17 = true;
	            _iteratorError17 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion17 && _iterator17.return) {
	                _iterator17.return();
	              }
	            } finally {
	              if (_didIteratorError17) {
	                throw _iteratorError17;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError16 = true;
	        _iteratorError16 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion16 && _iterator16.return) {
	            _iterator16.return();
	          }
	        } finally {
	          if (_didIteratorError16) {
	            throw _iteratorError16;
	          }
	        }
	      }
	
	      return newOrderArray;
	    }
	  }, {
	    key: 'reorderTable',
	    value: function reorderTable(event) {
	      if (event.target.classList.contains(this.selector) && this.table.classList.contains(this.tableReorder)) {
	        var _iteratorNormalCompletion18 = true;
	        var _didIteratorError18 = false;
	        var _iteratorError18 = undefined;
	
	        try {
	          for (var _iterator18 = this.overlayElement.lastElementChild.children[1].children[1].children[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	            var tableHeading = _step18.value;
	
	            this.newTableHeaderOrder.push(tableHeading.lastElementChild.innerText);
	          }
	        } catch (err) {
	          _didIteratorError18 = true;
	          _iteratorError18 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion18 && _iterator18.return) {
	              _iterator18.return();
	            }
	          } finally {
	            if (_didIteratorError18) {
	              throw _iteratorError18;
	            }
	          }
	        }
	
	        this.unlockedItems = this.getUnlockedItems(this.overlayElement.lastElementChild.children[1].children[1]);
	        this.newTableHeaderOrder = this.createNewTableHeaderOrder(this.newTableHeaderOrder);
	        this.newOrderArray = this.reorderTableHeaders();
	
	        var rowIndex = 0;
	        var _iteratorNormalCompletion19 = true;
	        var _didIteratorError19 = false;
	        var _iteratorError19 = undefined;
	
	        try {
	          for (var _iterator19 = this.table.rows[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
	            var row = _step19.value;
	
	            var cellIndex = 0;
	            if (!row.classList.contains('table--detail__row--expanded') && !row.classList.contains('table--detail__row--stacked')) {
	              var _iteratorNormalCompletion20 = true;
	              var _didIteratorError20 = false;
	              var _iteratorError20 = undefined;
	
	              try {
	                for (var _iterator20 = row.cells[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
	                  var cell = _step20.value;
	
	                  cell.innerHTML = this.copyTwo.rows[rowIndex].cells[this.newOrderArray[cellIndex]].innerHTML;
	                  cellIndex += 1;
	                }
	              } catch (err) {
	                _didIteratorError20 = true;
	                _iteratorError20 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion20 && _iterator20.return) {
	                    _iterator20.return();
	                  }
	                } finally {
	                  if (_didIteratorError20) {
	                    throw _iteratorError20;
	                  }
	                }
	              }
	            }
	            rowIndex += 1;
	          }
	        } catch (err) {
	          _didIteratorError19 = true;
	          _iteratorError19 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion19 && _iterator19.return) {
	              _iterator19.return();
	            }
	          } finally {
	            if (_didIteratorError19) {
	              throw _iteratorError19;
	            }
	          }
	        }
	
	        if (this.switched) {
	          this.unsplitTable();
	        }
	        this.copy = this.table.cloneNode(true);
	        if (this.switched) {
	          this.splitTable();
	        }
	
	        this.newTableHeaderOrder = [];
	        this.newOrderArray = [];
	
	        _get__('triggerEvent')(this.table, 'apply.commonui.reorderTable', {
	          detail: {
	            savedTable: this.table
	          }
	        });
	
	        if (_get__('isMobile')()) {
	          this.close(event);
	        }
	        this.buttonTrigger.setAttribute('disabled', true);
	        this.cancelButton.setAttribute('disabled', true);
	      }
	    }
	  }, {
	    key: 'reset',
	    value: function reset(event, savedState) {
	      if (event.target.offsetParent.parentElement.parentElement.classList.contains(this.overlayElementString) && this.table.classList.contains(this.tableReorder)) {
	        var index = 0;
	        var _iteratorNormalCompletion21 = true;
	        var _didIteratorError21 = false;
	        var _iteratorError21 = undefined;
	
	        try {
	          for (var _iterator21 = this.overlayElement.lastElementChild.children[1].lastElementChild.children[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
	            var child = _step21.value;
	
	            if (!child.getAttribute('disabled')) {
	              if (savedState) {
	                child.lastElementChild.innerHTML = this.unlockedItems[index];
	                this.buttonTrigger.setAttribute('disabled', true);
	                this.cancelButton.setAttribute('disabled', true);
	              } else {
	                child.lastElementChild.innerHTML = this.defaultUnlockedItems[index];
	                this.enableApply();
	              }
	              index += 1;
	            }
	          }
	        } catch (err) {
	          _didIteratorError21 = true;
	          _iteratorError21 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion21 && _iterator21.return) {
	              _iterator21.return();
	            }
	          } finally {
	            if (_didIteratorError21) {
	              throw _iteratorError21;
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'checkSelectedRows',
	    value: function checkSelectedRows() {
	      if (this.table.classList.contains(this.tableReorder)) {
	        var selectIcon = this.overlayElement.querySelector('.fa.select-all');
	        var _iteratorNormalCompletion22 = true;
	        var _didIteratorError22 = false;
	        var _iteratorError22 = undefined;
	
	        try {
	          for (var _iterator22 = this.buttonGroup.children[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
	            var child = _step22.value;
	
	            if (!child.firstElementChild.checked) {
	              this.allRowsSelected = false;
	            }
	          }
	        } catch (err) {
	          _didIteratorError22 = true;
	          _iteratorError22 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion22 && _iterator22.return) {
	              _iterator22.return();
	            }
	          } finally {
	            if (_didIteratorError22) {
	              throw _iteratorError22;
	            }
	          }
	        }
	
	        if (this.allRowsSelected) {
	          selectIcon.classList.remove('fa-square-o');
	          selectIcon.classList.add('fa-check-square-o');
	        } else {
	          selectIcon.classList.add('fa-square-o');
	          selectIcon.classList.remove('fa-check-square-o');
	        }
	        this.allRowsSelected = true;
	      }
	    }
	  }, {
	    key: 'enableApply',
	    value: function enableApply() {
	      if (this.table.classList.contains(this.tableReorder)) {
	        this.buttonTrigger.removeAttribute('disabled');
	        this.cancelButton.removeAttribute('disabled');
	        this.resetDefault.removeAttribute('disabled');
	      }
	    }
	  }, {
	    key: 'selectAll',
	    value: function selectAll(event) {
	      if (event.target.offsetParent.parentElement.parentElement.classList.contains(this.overlayElementString) && this.table.classList.contains(this.tableReorder)) {
	        var selectIcon = this.overlayElement.querySelector('.fa.select-all');
	        var _iteratorNormalCompletion23 = true;
	        var _didIteratorError23 = false;
	        var _iteratorError23 = undefined;
	
	        try {
	          for (var _iterator23 = this.overlayElement.lastElementChild.children[1].lastElementChild.children[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
	            var child = _step23.value;
	
	            if (!child.firstElementChild.checked) {
	              this.allRowsSelected = false;
	            }
	          }
	        } catch (err) {
	          _didIteratorError23 = true;
	          _iteratorError23 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion23 && _iterator23.return) {
	              _iterator23.return();
	            }
	          } finally {
	            if (_didIteratorError23) {
	              throw _iteratorError23;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion24 = true;
	        var _didIteratorError24 = false;
	        var _iteratorError24 = undefined;
	
	        try {
	          for (var _iterator24 = this.overlayElement.lastElementChild.children[1].lastElementChild.children[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
	            var _child = _step24.value;
	
	            if (!_child.getAttribute('disabled') && !this.allRowsSelected) {
	              _child.firstElementChild.checked = true;
	              selectIcon.classList.remove('fa-square-o');
	              selectIcon.classList.add('fa-check-square-o');
	            } else if (!_child.getAttribute('disabled') && this.allRowsSelected) {
	              _child.firstElementChild.checked = false;
	              selectIcon.classList.remove('fa-check-square-o');
	              selectIcon.classList.add('fa-square-o');
	            }
	          }
	        } catch (err) {
	          _didIteratorError24 = true;
	          _iteratorError24 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion24 && _iterator24.return) {
	              _iterator24.return();
	            }
	          } finally {
	            if (_didIteratorError24) {
	              throw _iteratorError24;
	            }
	          }
	        }
	
	        this.allRowsSelected = !this.allRowsSelected;
	      }
	    }
	  }, {
	    key: 'confirmDeleteRow',
	    value: function confirmDeleteRow(event) {
	      var deleteEvent = event;
	      this.deleteModal.addEventListener('positive.commonui.modal', function () {
	        _get__('deleteRow')(deleteEvent);
	      });
	      this.deleteModal.addEventListener('negative.commonui.modal', function () {
	        deleteEvent = null;
	      });
	    }
	  }]);
	
	  return Table;
	}();
	
	/**
	 * Creates a new responsive table instance
	 * @param  {Object} config
	 */
	
	function initTable() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    selector: '.js-table--responsive',
	    detailViewType: null,
	    detailViewSelector: '.js-table-secondary-view',
	    detailViewDismissSelector: '.js-table-secondary-view--dismiss',
	    tableReorder: null,
	    overlayElement: null,
	    trigger: null
	  };
	  var selector = config.selector,
	      detailViewType = config.detailViewType,
	      detailViewSelector = config.detailViewSelector,
	      detailViewDismissSelector = config.detailViewDismissSelector,
	      tableReorder = config.tableReorder,
	      overlayElement = config.overlayElement,
	      trigger = config.trigger;
	
	  var tables = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion25 = true;
	    var _didIteratorError25 = false;
	    var _iteratorError25 = undefined;
	
	    try {
	      for (var _iterator25 = document.querySelectorAll(selector)[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
	        var table = _step25.value;
	
	        tables = new (_get__('Table'))({
	          table: table, detailViewType: detailViewType, detailViewSelector: detailViewSelector, detailViewDismissSelector: detailViewDismissSelector, tableReorder: tableReorder, overlayElement: overlayElement, trigger: trigger
	        });
	      }
	    } catch (err) {
	      _didIteratorError25 = true;
	      _iteratorError25 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion25 && _iterator25.return) {
	          _iterator25.return();
	        }
	      } finally {
	        if (_didIteratorError25) {
	          throw _iteratorError25;
	        }
	      }
	    }
	  }
	  return tables;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'overlayActionClasses':
	      return overlayActionClasses;
	
	    case 'formatInlineEdit':
	      return _formatInlineEdit2.default;
	
	    case 'wrap':
	      return _html.wrap;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'unwrap':
	      return _html.unwrap;
	
	    case 'detailTableTypeList':
	      return detailTableTypeList;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'initButtonGroup':
	      return _ButtonGroup2.default;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'isMobile':
	      return _isMobile2.default;
	
	    case 'deleteRow':
	      return _delete2.default;
	
	    case 'Table':
	      return Table;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initTable === 'undefined' ? 'undefined' : _typeof(initTable);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initTable, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initTable)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.ButtonGroup = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initButtonGroup;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ButtonGroup = exports.ButtonGroup = function () {
	  function ButtonGroup(buttonGroup) {
	    _classCallCheck(this, ButtonGroup);
	
	    this.buttonGroup = buttonGroup;
	    this.magicNumberForResizeThrottling = 10;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    this.init();
	  }
	
	  _createClass(ButtonGroup, [{
	    key: 'init',
	    value: function init() {
	      if (this.buttonGroup) {
	        var buttonGroupItems = this.buttonGroup.children;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = buttonGroupItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var buttonGroupItem = _step.value;
	
	            var input = buttonGroupItem.getElementsByClassName('btn-group-item__input')[0];
	            _get__('addEvent')(input, 'click', this.apply.bind(this));
	
	            var labels = buttonGroupItem.getElementsByClassName('btn-group-item__label');
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = labels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var label = _step2.value;
	
	                if (label.getAttribute('draggable')) {
	                  _get__('addEvent')(label, 'dragstart', this.onDrag.bind(this));
	                  _get__('addEvent')(label, 'dragenter', this.onDragEnter.bind(this));
	                  _get__('addEvent')(label, 'dragover', this.onDragOver.bind(this));
	                  _get__('addEvent')(label, 'dragleave', this.onDragLeave.bind(this));
	                  _get__('addEvent')(label, 'drop', this.onDragDrop.bind(this));
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	          }
	
	          // Snapshot the initial dimensions of the button group so that we can refer to them later
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.responsiveMode = false;
	        this.initialWidth = _get__('getElementWidth')(this.buttonGroup);
	        this.checkForResponsive();
	
	        this.windowResizeListener = this.onWindowResize.bind(this);
	        this.windowResize = new (_get__('Throttle'))(this.windowResizeListener, this.magicNumberForResizeThrottling);
	        _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	
	        this.disabledToTop();
	      }
	    }
	  }, {
	    key: 'onWindowResize',
	    value: function onWindowResize() {
	      this.checkForResponsive();
	    }
	  }, {
	    key: 'checkForResponsive',
	    value: function checkForResponsive() {
	      // Check if we need to convert to dropdown
	      var currentWindowWidth = window.innerWidth;
	      var currentWidth = _get__('getElementWidth')(this.buttonGroup);
	      var containerWidth = _get__('getElementWidth')(this.buttonGroup.parentNode);
	      if (!this.responsiveMode && containerWidth < currentWidth) {
	        this.enableResponsiveMode();
	        this.responsiveModeWindowWidth = currentWindowWidth;
	      } else if (this.responsiveMode && currentWindowWidth > this.responsiveModeWindowWidth) {
	        this.disableResponsiveMode();
	      }
	    }
	  }, {
	    key: 'apply',
	    value: function apply() {
	      _get__('triggerEvent')(this.buttonGroup, 'apply.commonui.buttonGroup');
	      this.checkForResponsive();
	    }
	  }, {
	    key: 'enableResponsiveMode',
	    value: function enableResponsiveMode() {
	      this.responsiveMode = true;
	      _get__('wrap')(this.buttonGroup, 'dropdown');
	
	      this.dropdown = this.buttonGroup.parentNode;
	
	      _get__('addClass')(this.buttonGroup, 'dropdown-menu');
	
	      // First check if an option is already selected, as we need to grab the text from that option
	      var selectedOption = this.buttonGroup.querySelector('input[type="radio"]:checked');
	      var buttonText = selectedOption ? selectedOption.parentNode.querySelector('label').innerText : 'Please select';
	      var buttonHtml = '<span class="js-btn-text push--right">' + buttonText + '</span> <i class="fa fa-caret"/>';
	      // Create the dropdown button
	      this.dropdownButton = document.createElement('button');
	      this.dropdownButton.innerHTML = buttonHtml;
	
	      _get__('addClasses')(this.dropdownButton, ['btn', 'btn-dropdown', 'js-dropdown-btn']);
	
	      // Check if we need to go full width
	      if (_get__('hasClass')(this.buttonGroup, 'btn-group--full-width')) {
	        _get__('addClass')(this.dropdown, 'width--100');
	      } else {
	        // Get the width of the button group
	        _get__('addClass')(this.dropdown, 'dropdown-open');
	        var buttonGroupWidth = _get__('getElementWidth')(this.buttonGroup);
	        _get__('removeClass')(this.dropdown, 'dropdown-open');
	        var buttonPadding = 40;
	        var buttonWidth = buttonGroupWidth + buttonPadding + 'px';
	        this.dropdownButton.style.width = buttonWidth;
	        this.buttonGroup.style.width = buttonWidth;
	      }
	
	      // Inject the dropdown button before the button group
	      this.buttonGroup.before(this.dropdownButton);
	
	      this.openDropdownListener = this.openDropdown.bind(this);
	      this.closeDropdownListener = this.closeDropdown.bind(this);
	      this.documentClickListener = this.onDocumentClick.bind(this);
	      this.selectOptionListener = this.selectOption.bind(this);
	
	      _get__('addEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	    }
	  }, {
	    key: 'disableResponsiveMode',
	    value: function disableResponsiveMode() {
	      this.responsiveMode = false;
	
	      // Unbind the "click" event on the dropdown button
	      _get__('removeEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	
	      // Remove the "dropdown-menu" class from the button group container
	      _get__('removeClass')(this.buttonGroup, 'dropdown-menu');
	
	      // Remove all inline styles from the button group as the width will have been set
	      _get__('clearStyles')(this.buttonGroup);
	
	      // Unwrap the button group to remove the "dropdown" container
	      _get__('unwrap')(this.buttonGroup);
	
	      // Remove the dropdown button
	      _get__('removeElement')(this.dropdownButton);
	    }
	  }, {
	    key: 'openDropdown',
	    value: function openDropdown(event) {
	      event.preventDefault();
	      event.stopPropagation();
	
	      _get__('addClass')(this.dropdown, 'dropdown-open');
	
	      _get__('removeEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	
	      _get__('addEvent')(this.dropdownButton, 'click', this.closeDropdownListener);
	      _get__('addEvent')(document, 'click', this.documentClickListener);
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = this.buttonGroup.querySelectorAll('.btn-group-item__label')[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var buttonGroupOption = _step3.value;
	
	          _get__('addEvent')(buttonGroupOption, 'click', this.selectOptionListener);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'closeDropdown',
	    value: function closeDropdown() {
	      this.dropdown.classList.remove('dropdown-open');
	      _get__('removeEvent')(document, 'click', this.documentClickListener);
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.buttonGroup.querySelectorAll('.btn-group-item__label')[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var buttonGroupOption = _step4.value;
	
	          _get__('removeEvent')(buttonGroupOption, 'click', this.selectOptionListener);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      _get__('removeEvent')(this.dropdownButton, 'click', this.closeDropdownListener);
	      _get__('addEvent')(this.dropdownButton, 'click', this.openDropdownListener);
	    }
	  }, {
	    key: 'onDocumentClick',
	    value: function onDocumentClick(event) {
	      if (!this.dropdown.contains(event.target)) {
	        this.closeDropdown();
	      }
	    }
	  }, {
	    key: 'selectOption',
	    value: function selectOption(event) {
	      var label = event.target;
	      var btnText = this.dropdownButton.querySelector('.js-btn-text');
	      btnText.innerText = label.innerText;
	      this.closeDropdown();
	    }
	  }, {
	    key: 'onDrag',
	    value: function onDrag(event) {
	      this.parent = event.target.parentNode.parentNode;
	      this.child = event.target.parentNode;
	
	      event.dataTransfer.setData('Text', this.child);
	
	      event.dataTransfer.effectAllowed = 'move';
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(event) {
	      event.preventDefault();
	      event.dataTransfer.dropEffect = 'move';
	      event.target.classList.add('button--dragover');
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(event) {
	      event.preventDefault();
	      event.target.classList.remove('button--dragover');
	    }
	  }, {
	    key: 'onDragDrop',
	    value: function onDragDrop(event) {
	      event.preventDefault();
	      event.target.classList.remove('button--dragover');
	      _get__('triggerEvent')(event.target.parentNode.parentNode, 'drop.commonui.buttonGroup');
	
	      if (Number(this.child.getAttribute('data-id')) > Number(event.target.parentNode.getAttribute('data-id'))) {
	        this.parent.insertBefore(this.child, event.target.parentNode);
	      } else {
	        this.parent.insertBefore(this.child, event.target.parentNode.nextSibling);
	      }
	
	      var index = 0;
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = this.parent.children[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var child = _step5.value;
	
	          child.setAttribute('data-id', index.toString());
	          index += 1;
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      event.stopImmediatePropagation();
	    }
	  }, {
	    key: 'disabledToTop',
	    value: function disabledToTop() {
	      var buttonGroup = [].concat(_toConsumableArray(this.buttonGroup.children));
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = buttonGroup.reverse()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var listItem = _step6.value;
	
	          if (listItem.hasAttribute('disabled')) {
	            this.buttonGroup.insertBefore(listItem, this.buttonGroup.children[0]);
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.buttonGroup) {
	        console.warn('CommonUI - Button - There\'s no button group found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return ButtonGroup;
	}();
	
	/**
	 * Creates a new button instance
	 * @param  {Object} config
	 */
	
	
	function initButtonGroup() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-btn-group';
	
	  var selector = config;
	  var buttonGroup = null;
	  if (typeof selector === 'string' && selector === '.js-btn-group') {
	    var _iteratorNormalCompletion7 = true;
	    var _didIteratorError7 = false;
	    var _iteratorError7 = undefined;
	
	    try {
	      for (var _iterator7 = document.querySelectorAll(selector)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	        var elem = _step7.value;
	
	        buttonGroup = new (_get__('ButtonGroup'))(elem);
	      }
	    } catch (err) {
	      _didIteratorError7 = true;
	      _iteratorError7 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion7 && _iterator7.return) {
	          _iterator7.return();
	        }
	      } finally {
	        if (_didIteratorError7) {
	          throw _iteratorError7;
	        }
	      }
	    }
	  } else {
	    buttonGroup = new (_get__('ButtonGroup'))(selector);
	  }
	  return buttonGroup;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'getElementWidth':
	      return _html.getElementWidth;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'wrap':
	      return _html.wrap;
	
	    case 'addClass':
	      return _html.addClass;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'removeClass':
	      return _html.removeClass;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'clearStyles':
	      return _html.clearStyles;
	
	    case 'unwrap':
	      return _html.unwrap;
	
	    case 'removeElement':
	      return _html.removeElement;
	
	    case 'ButtonGroup':
	      return ButtonGroup;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initButtonGroup === 'undefined' ? 'undefined' : _typeof(initButtonGroup);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initButtonGroup, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initButtonGroup)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = formatInlineEdit;
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	var _events = __webpack_require__(8);
	
	var _createAnchorInlineElement = __webpack_require__(24);
	
	var _createAnchorInlineElement2 = _interopRequireDefault(_createAnchorInlineElement);
	
	var _createTextInlineElement = __webpack_require__(25);
	
	var _createTextInlineElement2 = _interopRequireDefault(_createTextInlineElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formatInlineEdit(element) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = element[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var inlineEdit = _step.value;
	
	      /* CREATE INLINE EDIT FOR TEXT */
	
	      if (!inlineEdit.classList.contains('format-done') && inlineEdit.tagName !== 'A') {
	        _get__('createTextInlineElement')(inlineEdit);
	        var span = inlineEdit.querySelector('span');
	        var input = inlineEdit.querySelector('input');
	        if (inlineEdit.classList.contains('text--center')) {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	          input.classList.add('text--center');
	        } else if (inlineEdit.classList.contains('text--left')) {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	          input.classList.add('text--left');
	        } else if (inlineEdit.classList.contains('text--right')) {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-right', 'form-fields']);
	          input.classList.add('text--right');
	        } else {
	          _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	          input.classList.add('text--left');
	        }
	        if (inlineEdit.classList.contains('required')) {
	          input.classList.add('required');
	        }
	      }
	
	      /* CREATE INLINE EDIT FOR ANCHOR LINKS */
	
	      if (inlineEdit.tagName === 'A') {
	        (function () {
	          var linkConfig = {};
	
	          var linkParent = inlineEdit.parentElement;
	          linkParent.classList.add('inline--edit-link');
	          linkParent.classList.add('inline--edit');
	
	          // create edit icon
	          var spanIcon = document.createElement('div');
	          spanIcon.classList.add('inline--edit-icon');
	          var icon = document.createElement('i');
	          icon.classList.add('icon-cme-pencil');
	          var iconDisabled = document.createElement('i');
	          iconDisabled.classList.add('icon-cme-pencil');
	          iconDisabled.classList.add('display--none');
	          spanIcon.appendChild(icon);
	          spanIcon.appendChild(iconDisabled);
	
	          // reorg anchor element
	          var spanAnchor = document.createElement('div');
	          spanAnchor.classList.add('inline--edit-anchor');
	          var anchor = inlineEdit;
	          spanAnchor.appendChild(anchor);
	
	          // Append edit icon to parent
	          linkParent.appendChild(spanAnchor);
	          linkParent.appendChild(spanIcon);
	
	          // Add event listener for icon onclick
	          _get__('addEvent')(icon, 'click', function () {
	            icon.classList.add('display--none');
	            iconDisabled.classList.remove('display--none');
	            // Removes anchor element
	            linkConfig = _get__('createAnchorInlineElement')(spanAnchor);
	            linkConfig.icons = {
	              icon: icon,
	              iconDisabled: iconDisabled
	            };
	
	            // Create input element for inline edit
	            _get__('createTextInlineElement')(spanAnchor, linkParent, linkConfig);
	
	            // Add required classes to span and input elements
	            var span = spanAnchor.querySelector('span');
	            var input = spanAnchor.querySelector('input');
	            if (linkParent.classList.contains('text--center')) {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	              input.classList.add('text--center');
	            } else if (linkParent.classList.contains('text--left')) {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	              input.classList.add('text--left');
	            } else if (linkParent.classList.contains('text--right')) {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-right', 'form-fields']);
	              input.classList.add('text--right');
	            } else {
	              _get__('addClasses')(span, ['inline-edit', 'inline-edit--align-left', 'form-fields']);
	              input.classList.add('text--left');
	            }
	
	            input.focus();
	            input.select();
	          });
	        })();
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return element;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'createTextInlineElement':
	      return _createTextInlineElement2.default;
	
	    case 'addClasses':
	      return _addClasses2.default;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'createAnchorInlineElement':
	      return _createAnchorInlineElement2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof formatInlineEdit === 'undefined' ? 'undefined' : _typeof(formatInlineEdit);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(formatInlineEdit, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(formatInlineEdit)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createInlineEditElement;
	function createInlineEditElement(element, classes) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = classes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var singleClass = _step.value;
	
	      element.classList.add(singleClass);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return element;
	}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAnchorInlineElement;
	/* REMOVE ANCHOR ELEMENT AND REPLACE WITH TEXT */
	
	function createAnchorInlineElement(element) {
	  // Remove anchor element
	  var href = element.firstElementChild.getAttribute('href');
	  var linkText = element.firstElementChild.innerHTML;
	  var classList = element.firstElementChild.classList;
	  var parentElement = element.parentElement;
	  element.removeChild(element.firstElementChild);
	
	  var icon = parentElement.firstElementChild;
	  // Set text of parent element
	  element.innerHTML = linkText;
	
	  return {
	    href: href,
	    linkText: linkText,
	    classList: classList,
	    icon: icon
	  };
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createTextInlineElement;
	
	var _createInlineElement = __webpack_require__(26);
	
	var _createInlineElement2 = _interopRequireDefault(_createInlineElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTextInlineElement(inlineEdit) {
	  var inlineEditAnchor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var linkConfig = arguments[2];
	
	  var inlineEditValue = inlineEdit.innerHTML;
	  if (inlineEditAnchor) {
	    inlineEdit.innerHTML = '';
	    inlineEditAnchor.classList.add('format-done');
	    inlineEditAnchor.classList.add('inline--edit__anchor');
	    inlineEdit.appendChild(_get__('createInlineElement')(inlineEditValue, linkConfig));
	  } else {
	    inlineEdit.classList.add('format-done');
	    inlineEdit.innerHTML = '';
	    inlineEdit.appendChild(_get__('createInlineElement')(inlineEditValue));
	  }
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'createInlineElement':
	      return _createInlineElement2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createTextInlineElement === 'undefined' ? 'undefined' : _typeof(createTextInlineElement);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createTextInlineElement, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createTextInlineElement)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createInlineEditElement;
	
	var _events = __webpack_require__(8);
	
	var _index = __webpack_require__(27);
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	var _createAnchorElement = __webpack_require__(34);
	
	var _createAnchorElement2 = _interopRequireDefault(_createAnchorElement);
	
	var _removeInputElement = __webpack_require__(35);
	
	var _removeInputElement2 = _interopRequireDefault(_removeInputElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* CREATES INPUT ELEMENT FOR INLINE EDITING */
	
	function createInlineEditElement(element, linkConfig) {
	  var initialValue = element;
	
	  // Create span to wrap input element
	  var span = document.createElement('span');
	
	  // Create input element
	  var input = document.createElement('input');
	  input.type = 'text';
	  input.name = element;
	  input.value = element;
	  input.autocomplete = 'off';
	
	  if (linkConfig && linkConfig.classList.contains('required')) {
	    input.classList.add('required');
	  }
	
	  var magicBreakpoint = 768;
	  _get__('addEvent')(window, 'resize', function () {
	    if (window.innerWidth < magicBreakpoint) {
	      input.disabled = true;
	    } else {
	      input.disabled = false;
	    }
	  });
	
	  // Create icon elements
	  var iconWrapper = document.createElement('div');
	  iconWrapper.classList.add('icon__wrapper');
	  var iconPencil = document.createElement('i');
	  iconPencil.classList.add('icon-cme-pencil');
	  iconWrapper.appendChild(iconPencil);
	
	  // Create actions element
	  var actions = document.createElement('div');
	  _get__('addClasses')(actions, ['actions', 'display--none']);
	
	  // Create cancel button element
	  var btnCancel = document.createElement('button');
	  btnCancel.classList.add('btn', 'btn--secondary', 'btn--cancel');
	  var iconRemove = document.createElement('i');
	  _get__('addClasses')(iconRemove, ['fa', 'fa-remove']);
	  btnCancel.appendChild(iconRemove);
	
	  // Create confirm button element
	  var btnConfirm = document.createElement('button');
	  _get__('addClasses')(btnConfirm, ['btn', 'btn--positive', 'btn--confirm']);
	  var iconCheck = document.createElement('i');
	  _get__('addClasses')(iconCheck, ['fa', 'fa-check']);
	  btnConfirm.appendChild(iconCheck);
	
	  // Append buttons to actions container
	  actions.appendChild(btnCancel);
	  actions.appendChild(btnConfirm);
	
	  // Append elements to span wrapper
	  span.appendChild(input);
	  span.appendChild(iconWrapper);
	  span.appendChild(actions);
	
	  var anchor = {};
	  var anchorInput = {};
	  // Add mousedown event listener for cancel button
	  _get__('addEvent')(btnCancel, 'mousedown', function (event) {
	    if (linkConfig) {
	      anchorInput = _get__('removeInputElement')(span);
	
	      linkConfig.linkText = initialValue;
	      linkConfig.icons.icon.classList.remove('display--none');
	      linkConfig.icons.iconDisabled.classList.add('display--none');
	
	      anchor = _get__('createAnchorElement')(linkConfig);
	      anchorInput.parent.appendChild(anchor);
	    } else {
	      _get__('btnCancelEvent')(input, initialValue, actions, event, btnConfirm);
	    }
	  });
	
	  // Add mousedown event listener for confirm button
	  _get__('addEvent')(btnConfirm, 'mousedown', function (event) {
	    if (linkConfig) {
	      if (input.value !== '' || !input.classList.contains('has-error')) {
	        var table = input.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
	        anchorInput = _get__('removeInputElement')(span);
	
	        linkConfig.linkText = anchorInput.inputValue;
	        linkConfig.icons.icon.classList.remove('display--none');
	        linkConfig.icons.iconDisabled.classList.add('display--none');
	
	        anchor = _get__('createAnchorElement')(linkConfig);
	        anchorInput.parent.appendChild(anchor);
	        _get__('triggerEvent')(table, 'apply.commonui.inline-edit');
	      }
	      _get__('btnConfirmEvent')(input, actions, event, btnConfirm);
	    } else {
	      if (input.value !== '' || !input.classList.contains('has-error')) {
	        initialValue = input.value;
	      }
	      var _table = input.parentElement.parentElement.parentElement.parentElement.parentElement;
	      _get__('btnConfirmEvent')(input, actions, event, btnConfirm);
	      _get__('triggerEvent')(_table, 'apply.commonui.inline-edit');
	    }
	  });
	
	  // Add focusin event listener for input
	  _get__('addEvent')(input, 'focusin', function () {
	    _get__('inputFocusEvent')(actions);
	  });
	
	  // Add onclick event listener for input
	  _get__('addEvent')(input, 'click', function () {
	    input.select();
	  });
	
	  // Add focusout event listener for input
	  _get__('addEvent')(input, 'focusout', function (event) {
	    if (linkConfig) {
	      event.preventDefault();
	    } else if (input.classList.contains('invalid')) {
	      event.preventDefault();
	
	      input.classList.remove('invalid');
	      input.focus();
	    } else {
	      _get__('inputFocusOutEvent')(input, actions, event, btnConfirm);
	      input.value = initialValue;
	    }
	  });
	
	  // Add oninput event listener for input
	  _get__('addEvent')(input, 'input', function () {
	    _get__('inputEvent')(input, btnConfirm);
	  });
	
	  return span;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'addClasses':
	      return _addClasses2.default;
	
	    case 'removeInputElement':
	      return _removeInputElement2.default;
	
	    case 'createAnchorElement':
	      return _createAnchorElement2.default;
	
	    case 'btnCancelEvent':
	      return _index.btnCancelEvent;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'btnConfirmEvent':
	      return _index.btnConfirmEvent;
	
	    case 'inputFocusEvent':
	      return _index.inputFocusEvent;
	
	    case 'inputFocusOutEvent':
	      return _index.inputFocusOutEvent;
	
	    case 'inputEvent':
	      return _index.inputEvent;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createInlineEditElement === 'undefined' ? 'undefined' : _typeof(createInlineEditElement);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createInlineEditElement, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createInlineEditElement)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inputEvent = exports.inputFocusOutEvent = exports.inputFocusEvent = exports.btnConfirmEvent = exports.btnCancelEvent = undefined;
	
	var _btnCancelEvent = __webpack_require__(28);
	
	var _btnCancelEvent2 = _interopRequireDefault(_btnCancelEvent);
	
	var _btnConfirmEvent = __webpack_require__(29);
	
	var _btnConfirmEvent2 = _interopRequireDefault(_btnConfirmEvent);
	
	var _inputFocusEvent = __webpack_require__(31);
	
	var _inputFocusEvent2 = _interopRequireDefault(_inputFocusEvent);
	
	var _inputFocusOutEvent = __webpack_require__(32);
	
	var _inputFocusOutEvent2 = _interopRequireDefault(_inputFocusOutEvent);
	
	var _inputEvent = __webpack_require__(33);
	
	var _inputEvent2 = _interopRequireDefault(_inputEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.btnCancelEvent = _btnCancelEvent2.default;
	exports.btnConfirmEvent = _btnConfirmEvent2.default;
	exports.inputFocusEvent = _inputFocusEvent2.default;
	exports.inputFocusOutEvent = _inputFocusOutEvent2.default;
	exports.inputEvent = _inputEvent2.default;

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = btnCancelEvent;
	function btnCancelEvent(input, initialValue, actions, event, btnConfirm) {
	  input.value = initialValue;
	  if (input.classList.contains('has-error')) {
	    input.classList.remove('has-error');
	  }
	  actions.classList.add('display--none');
	  btnConfirm.classList.remove('display--none');
	
	  var toolTip = event.target.parentElement.parentElement.parentElement.querySelector('.tooltip--inline-edit');
	  var parentElement = event.target.parentElement.parentElement.classList.contains('inline-edit') ? event.target.parentElement.parentElement : event.target.parentElement.parentElement.parentElement;
	  if (toolTip) {
	    parentElement.removeChild(toolTip);
	  }
	}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = btnConfirmEvent;
	
	var _createToolTip = __webpack_require__(30);
	
	var _createToolTip2 = _interopRequireDefault(_createToolTip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function btnConfirmEvent(input, actions, event, btnConfirm) {
	  var initToolTip = _get__('createToolTip')();
	  if (input.classList.contains('has-error') && input.value !== '') {
	    input.classList.remove('has-error');
	  }
	
	  if (input.value === '' && input.classList.contains('required')) {
	    btnConfirm.classList.add('display--none');
	    input.focus();
	    input.classList.add('has-error');
	    input.classList.add('invalid');
	    initToolTip.style.bottom = input.offsetHeight + 'px';
	    input.parentElement.appendChild(initToolTip);
	  }
	
	  if (!input.classList.contains('has-error')) {
	    input.value = input.value;
	    input.name = input.value;
	
	    actions.classList.add('display--none');
	
	    var toolTip = event.target.parentElement.parentElement.parentElement.querySelector('.tooltip--inline-edit');
	    var parentElement = event.target.parentElement.parentElement.classList.contains('inline-edit') ? event.target.parentElement.parentElement : event.target.parentElement.parentElement.parentElement;
	    if (toolTip) {
	      parentElement.removeChild(toolTip);
	    }
	  }
	
	  return input;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'createToolTip':
	      return _createToolTip2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof btnConfirmEvent === 'undefined' ? 'undefined' : _typeof(btnConfirmEvent);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(btnConfirmEvent, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(btnConfirmEvent)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createToolTip;
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createToolTip() {
	  var toolTip = document.createElement('div');
	  _get__('addClasses')(toolTip, ['tooltip--inline-edit', 'tooltip--show']);
	
	  var toolTipInner = document.createElement('div');
	  toolTipInner.classList.add('tooltip-inner');
	  toolTipInner.innerHTML = 'This cell must not be empty.';
	
	  var toolTipArrow = document.createElement('div');
	  toolTipArrow.classList.add('tooltip__arrow');
	
	  toolTip.appendChild(toolTipInner);
	  toolTip.appendChild(toolTipArrow);
	
	  return toolTip;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _addClasses2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createToolTip === 'undefined' ? 'undefined' : _typeof(createToolTip);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createToolTip, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createToolTip)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inputFocusEvent;
	function inputFocusEvent(actions) {
	  actions.classList.remove('display--none');
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inputFocusOutEvent;
	function inputFocusOutEvent(input, actions, event, btnConfirm) {
	  if (input.classList.contains('has-error')) {
	    input.classList.remove('has-error');
	  }
	  actions.classList.add('display--none');
	  btnConfirm.classList.remove('display--none');
	
	  var toolTip = event.target.parentElement.querySelector('.tooltip--inline-edit');
	  if (toolTip) {
	    event.target.parentElement.removeChild(toolTip);
	  }
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inputEvent;
	function inputEvent(input, btnConfirm) {
	  if (input.value === '' && input.classList.contains('required')) {
	    input.classList.add('has-error');
	  } else {
	    btnConfirm.classList.remove('display--none');
	  }
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = createAnchorElement;
	
	var _addClasses = __webpack_require__(23);
	
	var _addClasses2 = _interopRequireDefault(_addClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAnchorElement(linkConfig) {
	  var anchor = document.createElement('a');
	  anchor.setAttribute('href', linkConfig.href);
	  anchor.innerHTML = linkConfig.linkText;
	  _get__('addClasses')(anchor, linkConfig.classList);
	
	  return anchor;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _addClasses2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof createAnchorElement === 'undefined' ? 'undefined' : _typeof(createAnchorElement);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(createAnchorElement, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(createAnchorElement)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeInputElement;
	function removeInputElement(element) {
	  var parent = element.parentElement;
	  var inputValue = element.firstElementChild.value;
	  parent.removeChild(element);
	  parent.parentElement.classList.remove('format-done');
	
	  return {
	    parent: parent,
	    inputValue: inputValue
	  };
	}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMobile;
	function isMobile() {
	  var mobileBreakpoint = 768;
	  if (window.innerWidth < mobileBreakpoint) {
	    return true;
	  }
	  return false;
	}

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deleteRow;
	function deleteRow(event) {
	  if (event.target.parentElement.parentElement.parentElement.parentElement.classList.contains('table--detail__expanded')) {
	    event.target.parentElement.parentElement.parentElement.parentElement.deleteRow(event.target.parentElement.parentElement.rowIndex + 1);
	  }
	
	  return event.target.parentElement.parentElement.parentElement.parentElement.deleteRow(event.target.parentElement.parentElement.rowIndex);
	}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Tabs = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initTabs;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tab = function () {
	  /**
	   * @param  {Tabs}     tabs        Instance of Tabs which contains this tab
	   * @param  {Dom}      toggle      toggle button
	   * @param  {Dom}      tab         block to hide or show
	   * @param  {Dom}      toggleGroup group of toggles
	   * @param  {Object}   config      Config object defining whether the tab should be
	   *                                scrollable and/or closeable.
	   */
	  function Tab(tabs, toggle, tab, toggleGroup) {
	    var config = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	    _classCallCheck(this, Tab);
	
	    var _config$scrollable = config.scrollable,
	        scrollable = _config$scrollable === undefined ? true : _config$scrollable,
	        _config$closeable = config.closeable,
	        closeable = _config$closeable === undefined ? false : _config$closeable;
	
	    this.tabs = tabs;
	    this.toggle = toggle;
	    this.tab = tab;
	    this.toggleGroup = toggleGroup;
	    this.scrollable = scrollable;
	    this.closeable = closeable;
	    this.scrollableOn = false;
	    if (this.toggle.classList.contains(this.tabs.activeToggleClassName)) {
	      this.open();
	    } else {
	      this.close();
	    }
	    this.init();
	  }
	
	  _createClass(Tab, [{
	    key: 'init',
	    value: function init() {
	      _get__('addEvent')(this.toggle, 'click', this.open.bind(this));
	      // Check if the tab is closeable
	      if (this.closeable) {
	        // Wrap the tab title in a <span> so that we can inject the close button before it
	        var tabTitle = document.createElement('span');
	        tabTitle.innerText = this.toggle.innerText;
	        // Add the close icon and bind the click event
	        this.btnClose = document.createElement('button');
	        _get__('addClasses')(this.btnClose, ['btn', 'btn--transparent', 'hard', 'push-quarter--right']);
	        this.btnClose.innerHTML = '<i class="fa fa-times"></i>';
	        this.toggle.innerText = '';
	        this.toggle.appendChild(this.btnClose);
	        this.toggle.appendChild(tabTitle);
	        _get__('addEvent')(this.btnClose, 'click', this.remove.bind(this));
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (this.tabs.active === this) {
	        // already open
	        return;
	      }
	      if (this.tabs.active) {
	        this.tabs.active.close();
	      }
	      this.tabs.active = this;
	      this.tab.style.display = 'block';
	      this.toggle.classList.add(this.tabs.activeToggleClassName);
	      if (this.scrollable) {
	        var tabToggleWidth = this.toggle.clientWidth;
	        var tabToggleLeft = this.toggle.offsetLeft;
	        var tabToggleRight = tabToggleLeft + tabToggleWidth;
	        var tabToggleGroupWidth = this.toggleGroup.clientWidth;
	        if (tabToggleLeft < this.toggleGroup.scrollLeft) {
	          this.tabs.scroll(tabToggleLeft);
	        }
	        if (tabToggleRight > this.toggleGroup.scrollLeft + tabToggleGroupWidth) {
	          this.tabs.scroll(tabToggleRight - tabToggleGroupWidth);
	        }
	      }
	      _get__('triggerEvent')(this.toggle, 'open.commonui.tabs');
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.tab.style.display = 'none';
	      this.toggle.classList.remove(this.tabs.activeToggleClassName);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(event) {
	      if (event) {
	        event.stopImmediatePropagation();
	      }
	      var tabIndex = this.tabs.initedTabs.indexOf(this);
	      this.tabs.remove({ index: tabIndex });
	      _get__('removeEvent')(this.btnClose, 'click', this.remove);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get__('removeEvent')(this.toggle, 'click', this.open);
	    }
	  }]);
	
	  return Tab;
	}();
	
	var Tabs = exports.Tabs = function () {
	  function Tabs(container) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Tabs);
	
	    var responsive = config.responsive,
	        scrollable = config.scrollable,
	        vertical = config.vertical;
	
	    this.container = container;
	    this.responsive = responsive;
	
	    if (vertical && scrollable) {
	      /* eslint-disable no-console */
	      console.warn('vertical tabs cannot be scrollable');
	      /* eslint-enable no-console */
	    }
	
	    this.vertical = vertical;
	    this.scrollable = this.vertical === true ? false : scrollable;
	    this.setClassNames();
	
	    this.setDropdown = this.setDropdown.bind(this);
	    this.dropdownUpdate = this.dropdownUpdate.bind(this);
	
	    this.magicNumberForTabToggleOffset = 6;
	    this.magicNumberForResizeThrottling = 100;
	
	    this.init();
	  }
	
	  _createClass(Tabs, [{
	    key: 'init',
	    value: function init() {
	      this.toggleGroup = this.container.querySelector(this.toggleGroupSelector);
	      this.tabsGroup = this.container.querySelector(this.tabsGroupSelector);
	      this.toggleDOMElements = this.container.querySelectorAll(this.toggleSelector);
	      this.tabDOMElements = this.container.querySelectorAll(this.tabSelector);
	      this.toggles = Array.from(this.toggleDOMElements);
	      this.tabs = Array.from(this.tabDOMElements);
	
	      this.initedTabs = [];
	
	      if (!this.isEverythingOk()) {
	        return;
	      }
	
	      for (var index = 0; index < this.toggles.length; index++) {
	        var toggleDOMElement = this.toggles[index];
	        var tabDOMElement = this.tabs[index];
	        var isCloseable = toggleDOMElement.classList.contains('is-closeable');
	        var tabOptions = { scrollable: this.scrollable, closeable: isCloseable };
	        var tab = new (_get__('Tab'))(this, toggleDOMElement, tabDOMElement, this.toggleGroup, tabOptions);
	        this.initedTabs.push(tab);
	      }
	
	      if (this.vertical) {
	        this.container.classList.add('tabs--vertical');
	      }
	
	      if (this.responsive) {
	        this.container.classList.add('tabs--responsive');
	        this.createResponsiveDropdown();
	      }
	
	      this.setScrollableState();
	
	      this.windowScrollResize = new (_get__('Throttle'))(this.setScrollableState.bind(this), this.magicNumberForResizeThrottling);
	      _get__('addEvent')(window, 'resize', this.windowScrollResize.trigger);
	    }
	  }, {
	    key: 'setScrollableState',
	    value: function setScrollableState() {
	      if (!this.scrollable) {
	        return;
	      }
	      if (this.checkScrollableState() && !this.scrollableOn) {
	        _get__('wrap')(this.toggleGroup, 'tabs--scrollable');
	
	        this.scrollLeftButton = document.createElement('button');
	        this.scrollRightButton = document.createElement('button');
	
	        _get__('addClasses')(this.scrollLeftButton, ['tabs__scroller', 'tabs__scroller--left', 'js-action--scroll-left']);
	        _get__('addClasses')(this.scrollRightButton, ['tabs__scroller', 'tabs__scroller--right', 'js-action--scroll-right']);
	
	        this.scrollLeftButton.innerHTML = '<i class="fa fa-chevron-left"></i>';
	        this.scrollRightButton.innerHTML = '<i class="fa fa-chevron-right"></i>';
	
	        this.toggleGroup.parentNode.insertBefore(this.scrollLeftButton, this.toggleGroup);
	        this.toggleGroup.parentNode.appendChild(this.scrollRightButton);
	
	        // Initialize some instance variables
	        this.scrollLeftPosition = 0;
	        this.scrollIndex = 0;
	
	        this.checkScrollButtonState();
	        this.windowResize = new (_get__('Throttle'))(this.checkScrollButtonState.bind(this), this.magicNumberForResizeThrottling);
	
	        _get__('addEvent')(this.scrollLeftButton, 'click', this.scrollLeft.bind(this));
	        _get__('addEvent')(this.scrollRightButton, 'click', this.scrollRight.bind(this));
	        _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	
	        this.scrollableOn = true;
	      } else if (!this.checkScrollableState() && this.scrollableOn) {
	        if (this.scrollLeftButton) {
	          this.scrollLeftButton.remove();
	        }
	        if (this.scrollRightButton) {
	          this.scrollRightButton.remove();
	        }
	        _get__('unwrap')(this.toggleGroup, 'tabs--scrollable');
	        _get__('removeEvent')(window, 'resize', this.windowResize.trigger);
	        this.scrollableOn = false;
	      } else if (this.checkScrollableState() && this.scrollableOn) {
	        this.checkScrollButtonState();
	      }
	    }
	  }, {
	    key: 'checkScrollableState',
	    value: function checkScrollableState() {
	      return this.toggleGroup.scrollWidth > this.toggleGroup.clientWidth;
	    }
	    /**
	     * Scrolls the tab toggle group to the previous tab, i.e. to the left.
	     */
	
	  }, {
	    key: 'scrollLeft',
	    value: function scrollLeft() {
	      // Check that there is room to scroll,
	      // i.e. if we're already on the first tab then don't change the scroll index
	      if (this.scrollIndex > 0) {
	        this.scrollIndex--;
	      }
	      this.scrollLeftPosition -= this.toggles[this.scrollIndex].clientWidth + this.magicNumberForTabToggleOffset;
	      if (this.scrollLeftPosition < 0) {
	        this.scrollLeftPosition = 0;
	      }
	      this.scroll(this.scrollLeftPosition);
	    }
	
	    /**
	     * Scrolls the tab toggle group to the next tab, i.e. to the right.
	     */
	
	  }, {
	    key: 'scrollRight',
	    value: function scrollRight() {
	      this.scrollLeftPosition += this.toggles[this.scrollIndex].clientWidth + this.magicNumberForTabToggleOffset;
	      // Check that there is still room to scroll,
	      // i.e. if we're already on the last tab then don't change the scroll index
	      if (this.scrollIndex < this.toggles.length - 1) {
	        this.scrollIndex++;
	      }
	      this.scroll(this.scrollLeftPosition);
	    }
	
	    /**
	     * Scrolls the tab toggle group to the specified position and then updates the scrolling button state.
	     * @param position
	     */
	
	  }, {
	    key: 'scroll',
	    value: function scroll(position) {
	      _get__('smoothScroll')(this.toggleGroup, { to: position, cbk: this.checkScrollButtonState.bind(this) });
	    }
	
	    /**
	     * Sets the 'disabled' state of each of the left and right scrolling buttons
	     * based on the scroll position of the overflowed container.
	     */
	
	  }, {
	    key: 'checkScrollButtonState',
	    value: function checkScrollButtonState() {
	      if (this.toggleGroup.scrollLeft <= 0) {
	        this.scrollLeftButton.setAttribute('disabled', true);
	      } else {
	        this.scrollLeftButton.removeAttribute('disabled');
	      }
	      if (this.toggleGroup.scrollLeft + this.toggleGroup.clientWidth >= this.toggleGroup.scrollWidth) {
	        this.scrollRightButton.setAttribute('disabled', true);
	      } else {
	        this.scrollRightButton.removeAttribute('disabled');
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var index = options.index,
	          _options$selector = options.selector,
	          selector = _options$selector === undefined ? '' : _options$selector;
	
	      if (index >= 0 && index < this.initedTabs.length) {
	        this.initedTabs[index].open();
	        return;
	      }
	      if (selector === '') {
	        return;
	      }
	      var tabToFind = document.querySelector(selector);
	      if (tabToFind) {
	        /* eslint-disable arrow-parens */
	        var foundTab = this.initedTabs.find(function (x) {
	          return x.tab === tabToFind;
	        });
	        /* eslint-enable arrow-parens */
	        if (foundTab) {
	          foundTab.open();
	          return;
	        }
	      }
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var index = options.index,
	          _options$selector2 = options.selector,
	          selector = _options$selector2 === undefined ? '' : _options$selector2;
	
	      if (index >= 0 && index < this.initedTabs.length) {
	        this.initedTabs[index].close();
	        return;
	      }
	      if (selector === '') {
	        return;
	      }
	      var tabToFind = document.querySelector(selector);
	      if (tabToFind) {
	        /* eslint-disable arrow-parens */
	        var foundTab = this.initedTabs.find(function (x) {
	          return x.tab === tabToFind;
	        });
	        /* eslint-enable arrow-parens */
	        if (foundTab) {
	          foundTab.close();
	          return;
	        }
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var index = config.index;
	      var _config$title = config.title,
	          title = _config$title === undefined ? '' : _config$title,
	          _config$scrollable2 = config.scrollable,
	          scrollable = _config$scrollable2 === undefined ? true : _config$scrollable2;
	
	      var newTabToggle = document.createElement('div');
	      var newTab = document.createElement('div');
	      var newTabTitle = document.createElement('span');
	      newTabTitle.innerText = title;
	      newTabToggle.classList.add(this.toggleClassName);
	      newTabToggle.appendChild(newTabTitle);
	
	      newTab.classList.add(this.tabClassName);
	      newTab.style.display = 'none';
	
	      index = index || this.initedTabs.length;
	
	      var tab = new (_get__('Tab'))(this, newTabToggle, newTab, this.toggleGroup, config);
	      if (index >= 0 && index < this.initedTabs.length) {
	        this.toggleGroup.insertBefore(newTabToggle, this.toggleGroup.children[index]);
	        this.tabsGroup.insertBefore(newTab, this.tabsGroup.children[index]);
	        this.toggles.splice(index, 0, newTabToggle);
	        this.initedTabs.splice(index, 0, tab);
	      } else {
	        this.toggleGroup.appendChild(newTabToggle);
	        this.tabsGroup.appendChild(newTab);
	        this.toggles.push(newTabToggle);
	        this.initedTabs.push(tab);
	      }
	
	      // Add the new tab to the dropdown if in responsive mode
	      if (this.responsive) {
	        this.addDropdownItem(index, title, title);
	      }
	
	      if (scrollable) {
	        this.setScrollableState();
	      }
	
	      // Open the tab and autoscroll to it
	      tab.open();
	
	      // Finally, return the tab
	      return tab;
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var tabIndex = options.index;
	      // Ensure that the index of the tab we are going to remove is valid
	      if (tabIndex < 0 || tabIndex >= this.initedTabs.length) {
	        return;
	      }
	      var tabToggle = this.toggleGroup.children[tabIndex];
	      var tab = this.tabsGroup.children[tabIndex];
	      this.toggleGroup.removeChild(tabToggle);
	      this.tabsGroup.removeChild(tab);
	      if (this.responsive) {
	        _get__('removeEvent')(this.initedTabs[tabIndex].toggle, 'open.commonui.tabs', this.setDropdown);
	        this.dropdown.removeChild(this.dropdown.children[tabIndex]);
	      }
	      this.toggles.splice(tabIndex, 1);
	      this.initedTabs.splice(tabIndex, 1);
	      this.setScrollableState();
	      // If the tab being removed is the active tab then
	      // open the tab after this tab, as long as it wasn't the last tab
	      if (tabToggle.classList.contains(this.activeToggleClassName)) {
	        var tabIndexToOpen = tabIndex;
	        if (tabIndexToOpen >= this.initedTabs.length) {
	          tabIndexToOpen = this.initedTabs.length - 1;
	        }
	        this.open({ index: tabIndexToOpen });
	      }
	    }
	  }, {
	    key: 'createResponsiveDropdown',
	    value: function createResponsiveDropdown() {
	      this.dropdown = document.createElement('select');
	      this.dropdown.classList.add('visuallyhidden--xs-and-up');
	      for (var index = 0; index < this.initedTabs.length; index++) {
	        // Create select option for each tab
	        this.addDropdownItem(index, this.toggles[index].textContent, this.toggles[index].textContent);
	      }
	      _get__('addEvent')(this.dropdown, 'change', this.dropdownUpdate);
	      this.container.insertBefore(this.dropdown, this.container.firstChild);
	    }
	
	    /**
	     * Adds an item to the responsive dropdown at the specified index, with the specified value and text.
	     * @param {Number} index  The index that the dropdown item should be injected at.
	     * @param {String} value  The value set on the dropdown item.
	     * @param {String} text   The text to be displayed in the dropdown item.
	     */
	
	  }, {
	    key: 'addDropdownItem',
	    value: function addDropdownItem(index, value, text) {
	      var option = document.createElement('option');
	      option.value = value;
	      option.text = text;
	      if (index < this.dropdown.children.length - 1) {
	        this.dropdown.insertBefore(option, this.dropdown.children[index]);
	      } else {
	        this.dropdown.appendChild(option);
	      }
	      // Add class to hide on xs on the buttons
	      this.toggles[index].classList.add('visuallyhidden--xs-only');
	      // Bind to each open to keep dropdown in sync
	      _get__('addEvent')(this.initedTabs[index].toggle, 'open.commonui.tabs', this.setDropdown);
	    }
	  }, {
	    key: 'setDropdown',
	    value: function setDropdown(event) {
	      this.dropdown.value = event.srcElement.textContent;
	    }
	  }, {
	    key: 'dropdownUpdate',
	    value: function dropdownUpdate(event) {
	      this.initedTabs[event.target.selectedIndex].open();
	    }
	
	    /**
	     * Initializes classes and selectors for blocks
	     */
	
	  }, {
	    key: 'setClassNames',
	    value: function setClassNames() {
	      this.blockClassName = 'tabs';
	      this.toggleGroupSelector = '.tabs__toggle-group';
	      this.tabsGroupSelector = '.tabs__tabs-group';
	      this.toggleClassName = 'tabs__toggle';
	      this.toggleSelector = '.' + this.toggleClassName;
	      this.tabClassName = 'tabs__tab';
	      this.tabSelector = '.' + this.tabClassName;
	      this.activeToggleClassName = 'tabs__toggle--active';
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (this.toggles.length === 0) {
	        console.warn('CommonUI - Tabs - There\'s no toggles for tabs');
	        return false;
	      } else if (this.tabs.length === 0) {
	        console.warn('CommonUI - Tabs - There\'s no content tabs');
	        return false;
	      } else if (this.toggles.length !== this.tabs.length) {
	        console.warn('CommonUI - Tabs - Tabs toggles and tabs amounts are not matching');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.responsive) {
	        for (var index = 0; index < this.initedTabs.length; index++) {
	          _get__('removeEvent')(this.initedTabs[index].toggle, 'open.commonui.tabs', this.setDropdown);
	          _get__('removeEvent')(this.dropdown, 'change', this.dropdownUpdate);
	        }
	        this.dropdown.outerHTML = '';
	      }
	      if (this.scrollable) {
	        _get__('removeEvent')(this.scrollLeftButton, 'click', this.scrollLeft.bind(this));
	        _get__('removeEvent')(this.scrollRightButton, 'click', this.scrollRight.bind(this));
	        _get__('removeEvent')(window, 'resize', this.windowResize.trigger);
	      }
	      while (this.initedTabs.length > 0) {
	        var tab = this.initedTabs.pop();
	        tab.destroy();
	      }
	    }
	  }]);
	
	  return Tabs;
	}();
	
	/**
	 * iterates through all matched blocks and initializes tabs classes
	 * @param  {Object} config
	 */
	
	
	function initTabs() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { selector: '.js-tabs', responsive: false, scrollable: true };
	
	  var tabs = null;
	  if (typeof config.selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(config.selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var container = _step.value;
	
	        tabs = new (_get__('Tabs'))(container, config);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return tabs;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Tab':
	      return Tab;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'wrap':
	      return _html.wrap;
	
	    case 'unwrap':
	      return _html.unwrap;
	
	    case 'smoothScroll':
	      return _html.smoothScroll;
	
	    case 'Tabs':
	      return Tabs;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initTabs === 'undefined' ? 'undefined' : _typeof(initTabs);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initTabs, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initTabs)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Tooltip = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-console, no-underscore-dangle,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     newline-after-var, id-match,  operator-linebreak, prefer-reflect, arrow-body-style */
	
	
	exports.default = initTooltip;
	
	var _popper = __webpack_require__(40);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// const ARROW_HEIGHT = 20;
	var CLASS_PREFIX = 'tooltip';
	// const BSCLS_PREFIX_REGEX = new RegExp(`(^|\\s)${ CLASS_PREFIX }\\S+`, 'g');
	
	var Default = {
	  animation: true,
	  template: '\n    <div class="tooltip">\n      <div class="tooltip__inner"></div>\n      <div class="tooltip__arrow"></div>\n    </div>\n  ',
	  trigger: ['hover', 'focus'],
	  title: '',
	  delay: 0,
	  html: false,
	  selector: false,
	  placement: 'top',
	  offset: 0,
	  container: false,
	  fallbackPlacement: 'flip',
	  boundary: 'scrollParent',
	  theme: false
	};
	
	var AttachmentMap = {
	  AUTO: 'auto',
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	var HoverState = {
	  SHOW: 'show',
	  OUT: 'out'
	};
	//
	var Selector = {
	  // TOOLTIP: '.tooltip',
	  ARROW: '.' + _get__('CLASS_PREFIX') + '__arrow',
	  TOOLTIP_INNER: '.' + _get__('CLASS_PREFIX') + '__inner'
	};
	
	var ClassName = {
	  ANIMATE: _get__('CLASS_PREFIX') + '--animate',
	  SHOW: _get__('CLASS_PREFIX') + '--show'
	};
	
	var Tooltip = exports.Tooltip = function () {
	
	  /**
	   * @param  {Dom}       element       tooltip element
	   * @param  {Object}    config        configuration
	   */
	  function Tooltip(element, config) {
	    _classCallCheck(this, Tooltip);
	
	    this._themes = ['light', 'error', 'alternative', 'white'];
	
	    this.element = element;
	    this.config = this._getConfig(config);
	
	    if (!this._healthCheck()) {
	      return;
	    }
	
	    this.addTooltip = this.addTooltip.bind(this);
	    this.removeTooltip = this.removeTooltip.bind(this);
	    this.toggleTooltip = this.toggleTooltip.bind(this);
	    this.checkForScollVal = this.checkForScollVal.bind(this);
	
	    this.magicNumberForOffsetInPixels = 20;
	    this.magicNumberForTooltipMaxSizeProportion = 1.5;
	
	    this.tooltipOpen = false;
	
	    // Initialize accordion
	    this._setListeners();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'checkForScollVal',
	    value: function checkForScollVal() {
	      var currentElement = this.tooltipElement;
	      var reachedBody = false;
	      var scrollTop = 0;
	      var scrollLeft = 0;
	      do {
	        if (currentElement.tagName === 'BODY') {
	          reachedBody = true;
	        } else if (/(auto|scroll|overlay)/.test(currentElement.style.overflow) || /(auto|scroll|overlay)/.test(currentElement.style.overflowX) || /(auto|scroll|overlay)/.test(currentElement.style.overflowY)) {
	          scrollTop += currentElement.scrollTop;
	          scrollLeft += currentElement.scrollLeft;
	          currentElement = currentElement.parentNode;
	        } else {
	          currentElement = currentElement.parentNode;
	        }
	      } while (reachedBody === false);
	      return {
	        top: scrollTop,
	        left: scrollLeft
	      };
	    }
	  }, {
	    key: 'addTooltip',
	    value: function addTooltip() {
	      var _this = this;
	
	      this.tooltipOpen = true;
	
	      // Get text
	      this.title = this.getTitle();
	
	      var tooltipLength = 140;
	      // Limit tooltip limit to 140 chars
	      if (this.title.length > tooltipLength) {
	        return false;
	      }
	
	      // Remove text from target node
	      this.element.removeAttribute('title');
	
	      // Add tooltip to document
	      var tooltip = this.getTipElement();
	
	      this.setContent();
	
	      if (this.config.animation) {
	        tooltip.classList.add(_get__('ClassName').ANIMATE);
	      }
	
	      this._setTheme(this.config.theme);
	
	      var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tooltip, this.element) : this.config.placement;
	
	      var attachment = this._getAttachment(placement);
	      this.addAttachmentClass(attachment);
	
	      var container = this.config.container === false ? document.body : document.querySelector(this.config.container);
	      container.appendChild(tooltip);
	
	      this._popper = new (_get__('Popper'))(this.element, tooltip, {
	        placement: attachment,
	        modifiers: {
	          offset: {
	            offset: this.config.offset
	          },
	          flip: {
	            behavior: this.config.fallbackPlacement
	          },
	          arrow: {
	            element: _get__('Selector').ARROW
	          },
	          preventOverflow: {
	            boundariesElement: this.config.boundary
	          }
	        },
	        onCreate: function onCreate(info) {
	          if (info.originalPlacement !== info.placement) {
	            _this._handlePopperPlacementChange(info);
	          }
	        },
	        onUpdate: function onUpdate(info) {
	          _this._handlePopperPlacementChange(info);
	        }
	      });
	
	      tooltip.classList.add(_get__('ClassName').SHOW);
	      return true;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.removeTooltip();
	      _get__('removeEvent')(this.element, 'mouseenter', this.addTooltip);
	      _get__('removeEvent')(this.element, 'mouseleave', this.removeTooltip);
	      _get__('removeEvent')(this.element, 'touchend', this.toggleTooltip);
	    }
	
	    // Helpers
	
	  }, {
	    key: 'toggleTooltip',
	    value: function toggleTooltip() {
	      this.tooltipOpen ? this.removeTooltip() : this.addTooltip();
	    }
	  }, {
	    key: 'removeTooltip',
	    value: function removeTooltip() {
	      if (this.tooltipOpen) {
	        var tooltip = this.getTipElement();
	        if (this._hoverState !== _get__('HoverState').SHOW && tooltip.parentNode) {
	          tooltip.parentNode.removeChild(tooltip);
	        }
	        this.tooltipOpen = false;
	      }
	    }
	  }, {
	    key: 'getTipElement',
	    value: function getTipElement() {
	      this.tooltip = this.tooltip || this._buildTooltip();
	      return this.tooltip;
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent() {
	      var tooltip = this.getTipElement();
	      this.setElementContent(tooltip.querySelector(_get__('Selector').TOOLTIP_INNER), this.getTitle());
	      // tooltip.removeClass(`${ ClassName.FADE } ${ ClassName.SHOW }`);
	    }
	  }, {
	    key: 'setElementContent',
	    value: function setElementContent(element, content) {
	      var html = this.config.html;
	
	      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && content.nodeType) {
	        if (html) {
	          if (content.parentNode === element) {
	            while (element.firstChild) {
	              element.removeChild(element.firstChild);
	            }
	            element.appendChild(content);
	          }
	        } else {
	          element.textContent(content.textContent());
	        }
	      } else {
	        element[html ? 'innerHTML' : 'textContent'] = content;
	      }
	    }
	  }, {
	    key: 'addAttachmentClass',
	    value: function addAttachmentClass(attachment) {
	      this.getTipElement().classList.add(_get__('CLASS_PREFIX') + '--' + attachment);
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var title = this.element.getAttribute('data-original-title');
	
	      if (!title) {
	        title = typeof this.config.title === 'function' ? Reflect.apply(this.config.title, this.element) : this.config.title;
	      }
	
	      return title;
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: '_healthCheck',
	    value: function _healthCheck() {
	      if (!this.element) {
	        console.warn('CommonUI - Tooltip - There\'s no tooltip found');
	        return false;
	      }
	      if (!this.element.attributes.title || this.element.attributes.title.value !== '' && !this.element.attributes.title.value) {
	        console.warn('CommonUI - Tooltip - Tooltip is missing the title attribute');
	        return false;
	      }
	
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: '_setListeners',
	    value: function _setListeners() {
	      _get__('addEvent')(this.element, 'mouseenter', this.addTooltip);
	      _get__('addEvent')(this.element, 'mouseleave', this.removeTooltip);
	      _get__('addEvent')(this.element, 'touchstart touchend', this.toggleTooltip);
	
	      if (this.config.selector) {
	        this.config = _extends({}, this.config, {
	          trigger: 'manual',
	          selector: ''
	        });
	      } else {
	        this._fixTitle();
	      }
	    }
	  }, {
	    key: '_getAttachment',
	    value: function _getAttachment(placement) {
	      return _get__('AttachmentMap')[placement.toUpperCase()];
	    }
	  }, {
	    key: '_fixTitle',
	    value: function _fixTitle() {
	      var titleType = _typeof(this.element.getAttribute('data-original-title'));
	      if (this.element.getAttribute('title') || titleType !== 'string') {
	        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
	        this.element.setAttribute('title', '');
	      }
	    }
	
	    // _buildTooltip() {
	    //   this.tooltip = htmlFromString(this.config.template);
	    //
	    //   return this.tooltip;
	    // }
	
	  }, {
	    key: '_buildTooltip',
	    value: function _buildTooltip() {
	      this.tooltip = _get__('htmlFromString')(this.config.template);
	
	      return this.tooltip;
	    }
	  }, {
	    key: '_setTheme',
	    value: function _setTheme(theme) {
	      if (theme !== null && typeof theme === 'string') {
	        if (this._themes.indexOf(theme) >= 0) {
	          this.tooltip.classList.add(_get__('CLASS_PREFIX') + '--' + theme);
	        } else {
	          /* eslint-disable no-console */
	          console.warn('CommonUI - Tooltip - The theme ' + theme + ' does not exist');
	          /* eslint-enable no-console */
	        }
	      }
	    }
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, _get__('Default'), _typeof(this.element.dataset) === 'object' ? _extends({}, this.element.dataset) : {}, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
	
	      if (typeof config.delay === 'number') {
	        config.delay = {
	          show: config.delay,
	          hide: config.delay
	        };
	      }
	
	      if (typeof config.title === 'number') {
	        config.title = config.title.toString();
	      }
	
	      if (typeof config.content === 'number') {
	        config.content = config.content.toString();
	      }
	
	      return config;
	    }
	  }, {
	    key: '_cleanAttachmentClass',
	    value: function _cleanAttachmentClass() {
	      var tooltip = this.getTipElement();
	
	      Object.keys(_get__('AttachmentMap')).forEach(function (key) {
	        if (tooltip.classList.contains(_get__('CLASS_PREFIX') + '--' + _get__('AttachmentMap')[key])) {
	          tooltip.classList.remove(_get__('CLASS_PREFIX') + '--' + _get__('AttachmentMap')[key]);
	        }
	      });
	    }
	  }, {
	    key: '_handlePopperPlacementChange',
	    value: function _handlePopperPlacementChange(info) {
	      this._cleanAttachmentClass();
	      this.addAttachmentClass(this._getAttachment(info.placement));
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	/**
	 * @param  {Dom | String}  target     tooltip DOM object or selector string
	 * @param  {Object}        config     config for tolltip
	 */
	// export default function initTooltip(target = 'abbr[rel="tooltip"]', config = {}) {
	//   if (typeof target === 'string') {
	//     target = document.querySelectorAll(target);
	//   }
	//
	//   let tooltips = null;
	//
	//   for (const tooltip of target) {
	//     tooltips = new Tooltip(tooltip, config);
	//   }
	//
	//   return tooltips;
	// }
	
	function initTooltip() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? 'abbr[rel="tooltip"]' : _config$selector;
	
	  var tooltips = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var tooltip = _step.value;
	
	        tooltips = new (_get__('Tooltip'))(tooltip, config);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return tooltips;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'CLASS_PREFIX':
	      return CLASS_PREFIX;
	
	    case 'ClassName':
	      return ClassName;
	
	    case 'Popper':
	      return _popper2.default;
	
	    case 'Selector':
	      return Selector;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'HoverState':
	      return HoverState;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'AttachmentMap':
	      return AttachmentMap;
	
	    case 'htmlFromString':
	      return _html.htmlFromString;
	
	    case 'Default':
	      return Default;
	
	    case 'Tooltip':
	      return Tooltip;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initTooltip === 'undefined' ? 'undefined' : _typeof(initTooltip);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initTooltip, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initTooltip)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Pagination = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable prefer-reflect */
	
	
	exports.default = initPagination;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(42);
	
	var Pagination = exports.Pagination = function () {
	
	  /**
	   * @param  {Dom}    pagination        pagination container
	   */
	  function Pagination(pagination) {
	    _classCallCheck(this, Pagination);
	
	    this.pagination = pagination;
	    this.magicNumberForResizeThrottling = 100;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    // Initialize pagination
	    this.init();
	  }
	
	  _createClass(Pagination, [{
	    key: 'init',
	    value: function init() {
	      // Cast to real array and not nodeList
	      this.pages = this.pagination.querySelectorAll('li:not(.pagination__first):not(.pagination__prev):not(.pagination__next):not(.pagination__last)');
	      this.totalPages = this.pages.length;
	
	      // Fetch the selected Page
	      this.selectedPageIndex = Array.prototype.slice.call(this.pages).findIndex(function (x) {
	        return x.classList.contains('pagination__current');
	      });
	
	      // Starting point for hidden pages - none
	      this.maxAway = 0;
	
	      // Add 'away-1' etc to the pages in the pagination
	      this.assignAwayClasses();
	
	      // Start the hiding at the maximum shown
	      this.currentHiddenAways = this.maxAway + 1;
	
	      // Bind the context with the event
	      this.updatePagination = this.updatePagination.bind(this);
	
	      this.windowResize = new (_get__('Throttle'))(this.updatePagination, this.magicNumberForResizeThrottling);
	
	      this.addListeners();
	      this.updatePagination();
	    }
	  }, {
	    key: 'assignAwayClasses',
	    value: function assignAwayClasses() {
	      for (var i = 0; i < this.totalPages; i++) {
	        if (i !== this.selectedPageIndex) {
	          this.pages[i].classList.add('away-' + Math.abs(this.selectedPageIndex - i));
	          if (Math.abs(this.selectedPageIndex - i) > this.maxAway) {
	            this.maxAway = Math.abs(this.selectedPageIndex - i);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'removeAwayClasses',
	    value: function removeAwayClasses() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var page = _step.value;
	
	          if (!page.classList.contains('pagination__current')) {
	            page.className = '';
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updatePagination',
	    value: function updatePagination() {
	      if (_get__('isOverflowed')(this.pagination, this.pagination.parentElement)) {
	        this.hidePages();
	      } else {
	        this.showPages();
	      }
	    }
	  }, {
	    key: 'hidePages',
	    value: function hidePages() {
	      if (this.currentHiddenAways !== 0) {
	        this.currentHiddenAways--;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = this.pages[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var page = _step2.value;
	
	            if (page.classList.contains('away-' + this.currentHiddenAways)) {
	              page.classList.add('hide');
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        if (_get__('isOverflowed')(this.pagination)) {
	          this.hidePages();
	        }
	      }
	    }
	  }, {
	    key: 'showPages',
	    value: function showPages() {
	      if (this.currentHiddenAways !== this.maxAway + 1) {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = this.pages[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var page = _step3.value;
	
	            if (page.classList.contains('away-' + this.currentHiddenAways)) {
	              page.classList.remove('hide');
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        this.currentHiddenAways++;
	        this.updatePagination();
	      }
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get__('removeEvent')(window, 'resize', this.windowResize.trigger);
	      this.removeAwayClasses();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.pagination) {
	        console.warn('CommonUI - Alert - There\'s no pagination found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Pagination;
	}();
	
	/**
	 * Creates a new alert instance
	 * @param  {Object} config
	 */
	
	
	function initPagination() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-pagination' : _config$selector;
	
	  var paginations = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion4 = true;
	    var _didIteratorError4 = false;
	    var _iteratorError4 = undefined;
	
	    try {
	      for (var _iterator4 = document.querySelectorAll(selector)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	        var pagination = _step4.value;
	
	        paginations = new (_get__('Pagination'))(pagination);
	      }
	    } catch (err) {
	      _didIteratorError4 = true;
	      _iteratorError4 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion4 && _iterator4.return) {
	          _iterator4.return();
	        }
	      } finally {
	        if (_didIteratorError4) {
	          throw _iteratorError4;
	        }
	      }
	    }
	  }
	  return paginations;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'isOverflowed':
	      return _html.isOverflowed;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'Pagination':
	      return Pagination;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initPagination === 'undefined' ? 'undefined' : _typeof(initPagination);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initPagination, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initPagination)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	'use strict';
	
	Array.prototype.findIndex = Array.prototype.findIndex || function(callback) {
	  if (this === null) {
	    throw new TypeError('Array.prototype.findIndex called on null or undefined');
	  } else if (typeof callback !== 'function') {
	    throw new TypeError('callback must be a function');
	  }
	  var list = Object(this);
	  // Makes sures is always has an positive integer as length.
	  var length = list.length >>> 0;
	  var thisArg = arguments[1];
	  for (var i = 0; i < length; i++) {
	    if ( callback.call(thisArg, list[i], i, list) ) {
	      return i;
	    }
	  }
	  return -1;
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Loader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initModal;
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Loader = exports.Loader = function () {
	
	  /**
	   * @param  {Dom}    loaderTarget     target to cover with the loader
	   * @param  {String} message          text to display on loading
	   * @param  {Bool}   fullscreen       if intended to cover the whole screen
	   */
	  function Loader(loaderTarget, message, fullscreen, theme, deferred) {
	    _classCallCheck(this, Loader);
	
	    this.loaderTarget = loaderTarget;
	    this.message = message;
	    this.fullscreen = fullscreen;
	    this.theme = theme;
	    this.isShowing = false;
	    this.isDeferred = deferred;
	    this.MILLISECONDS_SECONDS_RATIO = 1000;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    // Initialize loader
	    this.init();
	  }
	
	  _createClass(Loader, [{
	    key: 'init',
	    value: function init() {
	      if (!this.isDeferred) {
	        this.createLoader();
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this.createLoader();
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      this.destroy();
	    }
	  }, {
	    key: 'createLoader',
	    value: function createLoader() {
	      var _this = this;
	
	      // Create the various bits of the overlay
	      this.loaderOverlay = document.createElement('div');
	      this.loaderOverlay.classList.add('loader-overlay');
	
	      if (this.theme !== 'dark') {
	        this.loaderOverlay.classList.add('loader-overlay--' + this.theme);
	      }
	
	      if (this.fullscreen) {
	        this.loaderOverlay.classList.add('loader-fullscreen');
	      }
	
	      this.wrapper = document.createElement('div');
	      this.wrapper.classList.add('loader-wrapper');
	      this.loader = document.createElement('div');
	      this.loader.classList.add('loader');
	      this.loaderText = document.createElement('p');
	
	      if (Array.isArray(this.message)) {
	        // Message is an array - handle progress wording
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var wording = _step.value;
	
	            if (wording.hasOwnProperty('changeAt') && wording.hasOwnProperty('text')) {
	              if (Number.isInteger(wording.changeAt) && wording.text !== '') {
	                setTimeout(function () {
	                  return _this.setText(wording.text);
	                }, wording.changeAt * _this.MILLISECONDS_SECONDS_RATIO);
	              }
	            }
	          };
	
	          for (var _iterator = this.message[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else {
	        // Set static message
	        this.setText(this.message);
	      }
	
	      // Create the structure
	      this.wrapper.appendChild(this.loader);
	      this.wrapper.appendChild(this.loaderText);
	      this.loaderOverlay.appendChild(this.wrapper);
	      // Add to dom if not already there.
	      if (!_get__('hasDirectDescendant')(this.loaderTarget, this.loaderOverlay)) {
	        this.isShowing = true;
	        this.loaderTarget.appendChild(this.loaderOverlay);
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(message) {
	      this.loaderText.innerHTML = message;
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      if (this.isShowing) {
	        this.isShowing = false;
	        this.loaderTarget.removeChild(this.loaderOverlay);
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.loaderTarget) {
	        console.warn('CommonUI - Loader - No element found to target');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Loader;
	}();
	
	/**
	 * creates a new loader instance
	 * @param  {Object} config
	 */
	
	
	function initModal() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-loader' : _config$selector,
	      _config$message = config.message,
	      message = _config$message === undefined ? 'Loading...' : _config$message,
	      _config$fullscreen = config.fullscreen,
	      fullscreen = _config$fullscreen === undefined ? true : _config$fullscreen,
	      _config$theme = config.theme,
	      theme = _config$theme === undefined ? 'dark' : _config$theme,
	      _config$deferred = config.deferred,
	      deferred = _config$deferred === undefined ? false : _config$deferred;
	
	  var loader = null;
	  if (typeof selector === 'string') {
	    loader = new (_get__('Loader'))(document.querySelector(selector), message, fullscreen, theme, deferred);
	  }
	  return loader;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'hasDirectDescendant':
	      return _html.hasDirectDescendant;
	
	    case 'Loader':
	      return Loader;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initModal === 'undefined' ? 'undefined' : _typeof(initModal);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initModal, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initModal)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Dropdown = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initDropdown;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Dropdown = exports.Dropdown = function () {
	
	  /**
	   * @param  {Dom}    dropdown          container to hold dropdown
	   * @param  {String} toggleSelector    selector toggle for dropdown reveal
	   */
	  function Dropdown(dropdown, toggleSelector, menuSelector, allSelector) {
	    _classCallCheck(this, Dropdown);
	
	    this.dropdown = dropdown;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.toggleSelector = dropdown.querySelector(toggleSelector);
	    this.menuSelector = dropdown.querySelector(menuSelector);
	    this.allSelector = document.querySelectorAll(allSelector);
	    this.isOpen = false;
	    this.action = 'click';
	    this.mask = null;
	    this.direction = 'down';
	    this.linksSelector = this.menuSelector.querySelectorAll('a');
	
	    this.checkClickOff = this.checkClickOff.bind(this);
	    this.toggle = this.toggle.bind(this);
	    this.linkClick = this.linkClick.bind(this);
	    this.removeMask = this.removeMask.bind(this);
	
	    // Initialize dropdown
	    this.init();
	  }
	
	  _createClass(Dropdown, [{
	    key: 'init',
	    value: function init() {
	      // set direction of dropdown
	      if (this.dropdown.hasAttribute('data-direction')) {
	        if (this.dropdown.getAttribute('data-direction') === 'up') {
	          this.direction = 'up';
	          _get__('addClasses')(this.dropdown, ['dropdown-up']);
	        }
	      }
	      if (this.toggleSelector) {
	        _get__('addEvent')(this.toggleSelector, 'click', this.toggle);
	        if (this.menuSelector) {
	          this.menuSelector.style.width = this.toggleSelector.offsetWidth + 'px';
	          if (this.direction === 'up') {
	            this.menuSelector.style.bottom = this.toggleSelector.offsetHeight + 'px';
	          }
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = this.linksSelector[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var link = _step.value;
	
	              _get__('addEvent')(link, 'click', this.linkClick);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	      if (this.isOpen) {
	        this.close();
	      } else {
	        this.open();
	      }
	    }
	  }, {
	    key: 'closeAll',
	    value: function closeAll() {
	      if (window.commonUI) {
	        if (window.commonUI.dropdowns) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = window.commonUI.dropdowns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var dropdown = _step2.value;
	
	              if (typeof dropdown.close === 'function') {
	                dropdown.close();
	                if (dropdown.mask && dropdown.maskTarget.contains(dropdown.mask)) {
	                  _get__('removeElement')(dropdown.mask);
	                  dropdown.mask = null;
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      }
	    }
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.closeAll();
	      _get__('addClasses')(this.dropdown, [this.direction === 'up' ? 'dropdown-up-open' : 'dropdown-open']);
	      _get__('addEvent')(document, 'click', this.checkClickOff);
	      this.isOpen = true;
	    }
	    /* eslint-enable no-console */
	
	  }, {
	    key: 'removeMask',
	    value: function removeMask() {
	      if (this.maskTarget && this.maskTarget.contains(this.mask)) {
	        _get__('removeElement')(this.mask);
	      }
	      this.mask = null;
	    }
	  }, {
	    key: 'checkClickOff',
	    value: function checkClickOff(event) {
	      if (!this.dropdown.contains(event.target)) {
	        this.close();
	      }
	    }
	  }, {
	    key: 'linkClick',
	    value: function linkClick() {
	      this.close();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.isOpen = false;
	      this.toggleSelector.blur();
	      _get__('removeEvent')(document, 'click', this.checkClickOff);
	      if (this.action === 'click') {
	        _get__('removeClasses')(this.dropdown, ['dropdown-open', 'dropdown-up-open']);
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.dropdown) {
	        console.warn('CommonUI - Dropup - There\'s no dropdown found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Dropdown;
	}();
	
	/**
	 * Creates dropdown instances and returns array
	 * @param  {Object} config
	 */
	
	
	function initDropdown() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.dropdown, .dropup' : _config$selector,
	      _config$toggleSelecto = config.toggleSelector,
	      toggleSelector = _config$toggleSelecto === undefined ? 'button[data-toggle="dropdown"]' : _config$toggleSelecto,
	      _config$menuSelector = config.menuSelector,
	      menuSelector = _config$menuSelector === undefined ? '.dropdown-menu, .dropup-menu' : _config$menuSelector;
	
	  var dropdowns = [];
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = document.querySelectorAll(selector)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var dropdown = _step3.value;
	
	        dropdowns.push(new (_get__('Dropdown'))(dropdown, toggleSelector, menuSelector, selector));
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	  }
	  window.commonUI = window.commonUI ? window.commonUI : {};
	  window.commonUI.dropdowns = dropdowns;
	  return dropdowns;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeElement':
	      return _html.removeElement;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'Dropdown':
	      return Dropdown;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDropdown === 'undefined' ? 'undefined' : _typeof(initDropdown);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDropdown, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDropdown)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.BackToTop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initBackToTop;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BackToTop = exports.BackToTop = function () {
	
	  /**
	   * @param {Number} marginBottom Number of pixels to offset vertically from the bottom edge.
	   * @param {Number} marginRight  Number of pixels to offset horizontally from the right edge.
	   */
	  function BackToTop(marginBottom, marginRight) {
	    _classCallCheck(this, BackToTop);
	
	    this.cssClass = 'back-to-top';
	    this.selector = '.' + this.cssClass;
	    this.marginBottom = marginBottom;
	    this.marginRight = marginRight;
	    this.magicNumberForScrollTopTrigger = 100;
	    this.magicNumberForScrollThrottling = 100;
	    this.isTouchDevice = 'ontouchstart' in window || window.DocumentTouch;
	    if (!this.isEverythingOk()) {
	      return;
	    }
	    this.init();
	  }
	
	  _createClass(BackToTop, [{
	    key: 'init',
	    value: function init() {
	      this.scrollingElement = document.scrollingElement || document.documentElement;
	      this.backToTop = document.querySelector(this.selector);
	      if (this.backToTop) {
	        return;
	      }
	      this.backToTop = document.createElement('div');
	      if (this.marginBottom || this.marginRight) {
	        if (this.marginBottom) {
	          this.backToTop.style.marginBottom = this.marginBottom + 'px';
	        }
	        if (this.marginRight) {
	          this.backToTop.style.marginRight = this.marginRight + 'px';
	        }
	      }
	      if (!this.backToTop.classList.contains(this.cssClass)) {
	        this.backToTop.classList.add(this.cssClass);
	      }
	      this.backToTop.innerHTML = '<i class="fa fa-angle-up fa-2x"></i>';
	      this.scrollingElement.appendChild(this.backToTop);
	      this.bindEvents();
	      this.toggleBackToTop();
	    }
	
	    /**
	     * Bind a throttled event handler to the window scroll event
	     * to check whether the back to top element should be displayed or not.
	     * Also binds the click event of the back to top element itself to the scrollToTop method.
	     */
	
	  }, {
	    key: 'bindEvents',
	    value: function bindEvents() {
	      this.windowScroll = new (_get__('Throttle'))(this.toggleBackToTop.bind(this), this.magicNumberForScrollThrottling);
	      _get__('addEvent')(window, 'scroll', this.windowScroll.trigger);
	      _get__('addEvent')(this.backToTop, 'touchstart', this.scrollToTop.bind(this));
	      _get__('addEvent')(this.backToTop, 'click', this.scrollToTop.bind(this));
	    }
	
	    /**
	     * Determines whether the back to top element should be displayed or not.
	     * The back to top element will be displayed when the window has been scrolled 100 pixels.
	     */
	
	  }, {
	    key: 'toggleBackToTop',
	    value: function toggleBackToTop() {
	      if (this.scrollingElement.scrollTop > this.magicNumberForScrollTopTrigger) {
	        _get__('fadeIn')(this.backToTop, 'inline');
	      } else {
	        _get__('fadeOut')(this.backToTop);
	      }
	    }
	
	    /**
	     * Scrolls the document body back to the top using a smooth animation.
	     */
	
	  }, {
	    key: 'scrollToTop',
	    value: function scrollToTop(event) {
	      event.preventDefault();
	      if (this.isTouchDevice) {
	        this.scrollingElement.scrollTop = 0;
	      } else {
	        _get__('smoothScroll')(this.scrollingElement, { axis: 'vertical' });
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      // Ensure that any custom margins are integers
	      if (this.marginBottom && !Number.isInteger(this.marginBottom) || this.marginRight && !Number.isInteger(this.marginRight)) {
	        console.warn('CommonUI - Back to Top - Custom margins must be valid integers.');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return BackToTop;
	}();
	
	/**
	 * Creates a new "Back to Top" instance.
	 * Allows an optional config to be specified for setting of bottom and/or right margins.
	 * @param  {Object} config
	 */
	
	
	function initBackToTop() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$marginBottom = config.marginBottom,
	      marginBottom = _config$marginBottom === undefined ? null : _config$marginBottom,
	      _config$marginRight = config.marginRight,
	      marginRight = _config$marginRight === undefined ? null : _config$marginRight;
	
	  return new (_get__('BackToTop'))(marginBottom, marginRight);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'fadeIn':
	      return _html.fadeIn;
	
	    case 'fadeOut':
	      return _html.fadeOut;
	
	    case 'smoothScroll':
	      return _html.smoothScroll;
	
	    case 'BackToTop':
	      return BackToTop;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initBackToTop === 'undefined' ? 'undefined' : _typeof(initBackToTop);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initBackToTop, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initBackToTop)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Drawer = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */
	
	
	exports.default = initDrawer;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(17);
	
	var ESCAPE_KEYCODE = 27;
	var TABINDEX_VALUE = -1;
	var TRANSITION_DURATION = 300;
	var Default = {
	  customWidth: false,
	  direction: 'right',
	  positiveTrigger: '.js-drawer-positive',
	  negativeTrigger: '.js-drawer-close'
	};
	var ClassName = {
	  OPEN: 'drawer--is-open'
	};
	var Selector = {
	  CONTENT: '.drawer__panel',
	  DATA_TOGGLE: '[data-toggle="drawer"]',
	  DATA_DISMISS: '[data-dismiss="drawer"]'
	};
	
	var Drawer = exports.Drawer = function () {
	
	  /**
	   * @param  {Dom}    drawer     drawer DOM object
	   * @param  {Object} config     config for drawer
	   */
	  function Drawer(drawer, config) {
	    _classCallCheck(this, Drawer);
	
	    this._config = this.getConfig(config);
	    this._element = drawer;
	    this._content = this._element.querySelector(_get__('Selector').CONTENT);
	    if (this._config.trigger) {
	      this._trigger = document.querySelector(this._config.trigger);
	    }
	    this._isOpen = false;
	    this._hasCustomWidth = false;
	
	    // Bind the context with the events
	    this.open = this.open.bind(this);
	    this.close = this.close.bind(this);
	    this.negative = this.negative.bind(this);
	    this.positive = this.positive.bind(this);
	    this.checkEscapeKey = this.checkEscapeKey.bind(this);
	    this.backdropClick = this.backdropClick.bind(this);
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    // Initialize drawer
	    this.init();
	  }
	
	  _createClass(Drawer, [{
	    key: 'getConfig',
	    value: function getConfig(config) {
	      config = _extends({}, _get__('Default'), config);
	
	      return config;
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      if (this._config.customWidth) {
	        this.handleCustomWidth();
	      }
	      this.bindButtons();
	      if (this._trigger) {
	        _get__('addEvent')(this._trigger, 'click', this._config.tabbed ? this.toggle.bind(this) : this.open.bind(this));
	      }
	      this.handleAccessibility();
	    }
	  }, {
	    key: 'bindButtons',
	    value: function bindButtons() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this._element.querySelectorAll(this._config.negativeTrigger)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var closeButton = _step.value;
	
	          _get__('addEvent')(closeButton, 'click', this.negative);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = this._element.querySelectorAll(this._config.positiveTrigger)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var positiveButton = _step2.value;
	
	          _get__('addEvent')(positiveButton, 'click', this.positive);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'handleAccessibility',
	    value: function handleAccessibility() {
	      var _this = this;
	
	      if (this._isOpen === true) {
	        this._element.setAttribute('aria-hidden', 'false');
	        this._content.setAttribute('aria-expanded', 'true');
	        this._content.setAttribute('tabindex', _get__('TABINDEX_VALUE'));
	        /**
	         *----
	          [Come back to: Steven] Figure out why right aligned doesnt transition without
	          setTimeout
	         *----
	         */
	        setTimeout(function () {
	          _this._content.focus();
	        }, _get__('TRANSITION_DURATION'));
	      } else {
	        this._element.setAttribute('aria-hidden', 'true');
	        this._content.setAttribute('aria-expanded', 'false');
	        this._content.removeAttribute('tabindex');
	        if (this._trigger) {
	          this._trigger.focus();
	        }
	        setTimeout(function () {
	          if (_this._config.tabbed && _this._trigger) {
	            _this._trigger.querySelector('.btn').blur();
	          }
	        }, _get__('TRANSITION_DURATION'));
	      }
	    }
	
	    /**
	     *----
	      [Come back to: Steven] Look at a way to get this to work responively, px/rem
	      values not likely to be an option
	     *----
	     */
	
	  }, {
	    key: 'handleCustomWidth',
	    value: function handleCustomWidth() {
	      this._element.style.width = this._config.customWidth;
	      this._element.style[this._config.direction] = '-' + this._config.customWidth;
	      this._hasCustomWidth = true;
	    }
	  }, {
	    key: 'setDrawerDirection',
	    value: function setDrawerDirection() {
	      this._config.direction = this._element.className.split(' ').some(function (cla) {
	        return (/.*--left/.test(cla)
	        );
	      }) ? 'left' : 'right';
	    }
	  }, {
	    key: 'backdropClick',
	    value: function backdropClick(event) {
	      if (event.target === this._element) {
	        this.close();
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      if (!this._element.classList.contains(_get__('ClassName').OPEN)) {
	        this._element.classList.add(_get__('ClassName').OPEN);
	      }
	      if (this._hasCustomWidth) {
	        this._element.style[this._config.direction] = 0;
	      }
	      _get__('addEvent')(document, 'keydown', this.checkEscapeKey);
	      _get__('triggerEvent')(this._element, 'show.commonui.drawer');
	      this._isOpen = true;
	      _get__('addEvent')(this._element, 'click', this.backdropClick);
	      this.handleAccessibility();
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      if (this.hasCustomWidth) {
	        this._element.style[this._elementDirection] = '-' + this.customWidth;
	      }
	      this._element.classList.remove(_get__('ClassName').OPEN);
	      document.onkeydown = null;
	      _get__('triggerEvent')(this._element, 'hide.commonui.drawer');
	      this._isOpen = false;
	      _get__('removeEvent')(this._element, 'click', this.backdropClick);
	      this.handleAccessibility();
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      return this._isOpen ? this.close() : this.open();
	    }
	  }, {
	    key: 'positive',
	    value: function positive() {
	      _get__('triggerEvent')(this._element, 'positive.commonui.drawer');
	      this.close();
	    }
	  }, {
	    key: 'negative',
	    value: function negative() {
	      _get__('triggerEvent')(this._element, 'negative.commonui.drawer');
	      this.close();
	    }
	  }, {
	    key: 'checkEscapeKey',
	    value: function checkEscapeKey(evt) {
	      if (evt && evt.keyCode === _get__('ESCAPE_KEYCODE')) {
	        this.negative();
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	      if (this._trigger) {
	        _get__('removeEvent')(this._trigger, 'click', this.open);
	      }
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this._element) {
	        console.warn('CommonUI - Drawer - No drawer contents found');
	        return false;
	      }
	      if (this._config.customWidth && !this._config.customWidth.match(/\d*\.?\d+(?:px|rem|%)?/i) && typeof this._config.customWidth !== 'string') {
	        console.warn('CommonUI - Drawer - The value for customWidth must be a\n        string and an xx(px|rem|%) value (where xx is a number).');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Drawer;
	}();
	
	/**
	 * creates a new drawer instance
	 * @param  {Object} config
	 */
	
	
	function initDrawer(selector) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var drawer = null;
	  if (typeof selector === 'string') {
	    drawer = new (_get__('Drawer'))(document.querySelector(selector), config);
	  } else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object') {
	    drawer = new (_get__('Drawer'))(selector, config);
	  }
	  return drawer;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Selector':
	      return Selector;
	
	    case 'Default':
	      return Default;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'TABINDEX_VALUE':
	      return TABINDEX_VALUE;
	
	    case 'TRANSITION_DURATION':
	      return TRANSITION_DURATION;
	
	    case 'ClassName':
	      return ClassName;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'ESCAPE_KEYCODE':
	      return ESCAPE_KEYCODE;
	
	    case 'Drawer':
	      return Drawer;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDrawer === 'undefined' ? 'undefined' : _typeof(initDrawer);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDrawer, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDrawer)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.Filter = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initFilter;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Filter = exports.Filter = function () {
	
	  /**
	   * The filter file assigns open and close
	   * functionality to provided elements. It also provides
	   * toggle functionality around the "Apply" button
	   * which closes the filter but can also be used to
	   * call an action within the application developers code.
	   *
	   * @param  {string} filter               DOM element
	   * @param  {string} openClickArea        Js hook of open area
	   * @param  {string} remoteOpenClickArea  JS hook from content toggles filter
	   * @param  {string} closeClickArea       JS hook of close area
	   * @param  {string} applyFilterClickArea JS hook of action button
	   * @return undefined
	   *
	   * @author  Barry Hassan
	   */
	  function Filter(filter, openClickArea, remoteOpenClickArea, closeClickArea, applyFilterClickArea) {
	    _classCallCheck(this, Filter);
	
	    this.filter = filter;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.closeClickArea = filter.querySelector(closeClickArea);
	    this.openClickArea = filter.querySelector(openClickArea);
	    this.remoteOpenClickArea = filter.querySelector(remoteOpenClickArea);
	    this.applyFilterClickArea = filter.querySelector(applyFilterClickArea);
	    this.sidebarForm = filter.querySelector('form');
	
	    this.isOpen = true;
	
	    this.init();
	  }
	
	  /**
	   * Assigns events to the close button
	   * and the filter action button (Apply)
	   * @return undefined
	   */
	
	
	  _createClass(Filter, [{
	    key: 'init',
	    value: function init() {
	      if (this.closeClickArea) {
	        _get__('addEvent')(this.closeClickArea, 'click', this.close.bind(this));
	      }
	      if (this.applyFilterClickArea) {
	        _get__('addEvent')(this.applyFilterClickArea, 'click', this.apply.bind(this));
	      }
	      if (this.sidebarForm) {
	        _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	        _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	      }
	    }
	
	    /**
	     * Removes the disabled attribute
	     * from the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'enableAction',
	    value: function enableAction() {
	      if (this.applyFilterClickArea) {
	        this.applyFilterClickArea.removeAttribute('disabled');
	        if (this.sidebarForm) {
	          _get__('removeEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('removeEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Adds the disabled attribute
	     * to the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'disableAction',
	    value: function disableAction() {
	      if (this.applyFilterClickArea) {
	        this.applyFilterClickArea.setAttribute('disabled', true);
	        if (this.sidebarForm) {
	          _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Opens the filter, applies classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'open',
	    value: function open(event) {
	      event.stopImmediatePropagation();
	      if (!this.isOpen) {
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('removeClasses')(this.filter, ['is-compact']);
	          _get__('removeEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('removeEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	        this.isOpen = true;
	      }
	    }
	
	    /**
	     * Closes the filter, switches the functionality
	     * of the filter to now open
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'close',
	    value: function close(event) {
	      event.stopImmediatePropagation();
	      if (this.isOpen) {
	        if (this.closeClickArea) {
	          _get__('addClasses')(this.filter, ['is-compact']);
	          _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        }
	        this.isOpen = false;
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('addEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('addEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Toggles content button if present
	     * to switch between icon classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'apply',
	    value: function apply(event) {
	      if (this.applyFilterClickArea) {
	        var remoteIcon = this.filter.querySelector('.js-filter-panel__state');
	        if (remoteIcon) {
	          _get__('removeClasses')(remoteIcon, ['icon-cme-filter']);
	          _get__('addClasses')(remoteIcon, ['fa', 'fa-check']);
	        }
	        this.close(event);
	        _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        _get__('triggerEvent')(this.filter, 'apply.commonui.filter');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.filter) {
	        console.warn('CommonUI - Filter - There\'s no filter found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return Filter;
	}();
	
	/**
	 * Creates a new filter instance
	 * @param  {Object} config
	 */
	
	
	function initFilter() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-filter-panel' : _config$selector,
	      _config$openSelector = config.openSelector,
	      openSelector = _config$openSelector === undefined ? '.js-filter-panel__open' : _config$openSelector,
	      _config$remoteOpenCli = config.remoteOpenClickArea,
	      remoteOpenClickArea = _config$remoteOpenCli === undefined ? '.js-filter-panel__remote-open' : _config$remoteOpenCli,
	      _config$closeSelector = config.closeSelector,
	      closeSelector = _config$closeSelector === undefined ? '.js-filter-panel__close' : _config$closeSelector,
	      _config$applyFilterSe = config.applyFilterSelector,
	      applyFilterSelector = _config$applyFilterSe === undefined ? '.js-filter-panel__action' : _config$applyFilterSe;
	
	  var filters = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var filter = _step.value;
	
	        filters = new (_get__('Filter'))(filter, openSelector, remoteOpenClickArea, closeSelector, applyFilterSelector);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return filters;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'Filter':
	      return Filter;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initFilter === 'undefined' ? 'undefined' : _typeof(initFilter);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initFilter, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initFilter)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.DismissableSidebarPanel = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initDismissableSidebarPanel;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DismissableSidebarPanel = exports.DismissableSidebarPanel = function () {
	  function DismissableSidebarPanel(config) {
	    _classCallCheck(this, DismissableSidebarPanel);
	
	    this.dismissableSidebarPanels = config.dismissableSidebarPanel;
	    this.sidePanel = config.dismissableSidebarPanel.firstElementChild.firstElementChild;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.closeClickArea = config.dismissableSidebarPanel.querySelector(config.closeSelector);
	    this.openClickArea = document.querySelector(config.openSelector);
	    this.remoteOpenClickArea = config.dismissableSidebarPanel.querySelector(config.remoteOpenClickArea);
	    this.applyDismissableSidebarPanelClickArea = config.dismissableSidebarPanel.querySelector(config.applyDismissableSidebarPanelSelector);
	    this.sidebarForm = config.dismissableSidebarPanel.querySelector('form');
	
	    this.sidePanel.style.width = config.width;
	
	    this.isOpen = false;
	
	    this.init();
	  }
	
	  /**
	   * Assigns events to the close button
	   * and the dismissable sidebar panel action button (Apply)
	   * @return undefined
	   */
	
	
	  _createClass(DismissableSidebarPanel, [{
	    key: 'init',
	    value: function init() {
	      if (this.closeClickArea) {
	        _get__('addEvent')(this.closeClickArea, 'click', this.close.bind(this));
	      }
	      if (this.applyDismissableSidebarPanelClickArea) {
	        _get__('addEvent')(this.applyDismissableClickArea, 'click', this.apply.bind(this));
	      }
	      if (this.sidebarForm) {
	        _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	        _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	      }
	      if (this.openClickArea || this.remoteOpenClickArea) {
	        _get__('addEvent')(this.openClickArea, 'click', this.open.bind(this));
	        _get__('addEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	      }
	    }
	
	    /**
	     * Removes the disabled attribute
	     * from the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'enableAction',
	    value: function enableAction() {
	      if (this.applyDismissableClickArea) {
	        this.applyDismissableClickArea.removeAttribute('disabled');
	        if (this.sidebarForm) {
	          _get__('removeEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('removeEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Adds the disabled attribute
	     * to the sidebar action
	     * @return undefined
	     */
	
	  }, {
	    key: 'disableAction',
	    value: function disableAction() {
	      if (this.applyDismissableClickArea) {
	        this.applyDismissableClickArea.setAttribute('disabled', true);
	        if (this.sidebarForm) {
	          _get__('addEvent')(this.sidebarForm, 'keyup', this.enableAction.bind(this));
	          _get__('addEvent')(this.sidebarForm, 'change', this.enableAction.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Opens the dismissable sidebar panel, applies classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'open',
	    value: function open(event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	      if (!this.isOpen) {
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('removeClasses')(this.dismissableSidebarPanels, ['is-compact']);
	          _get__('removeEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('removeEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	        this.isOpen = true;
	      }
	    }
	
	    /**
	     * Closes the dismissable sidebar panel, switches the functionality
	     * of the dismissable sidebar panel to now open
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'close',
	    value: function close(event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	      if (this.isOpen) {
	        if (this.closeClickArea) {
	          _get__('addClasses')(this.dismissableSidebarPanels, ['is-compact']);
	          _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        }
	        this.isOpen = false;
	        if (this.openClickArea || this.remoteOpenClickArea) {
	          _get__('addEvent')(this.openClickArea, 'click', this.open.bind(this));
	          _get__('addEvent')(this.remoteOpenClickArea, 'click', this.open.bind(this));
	        }
	      }
	    }
	
	    /**
	     * Toggles content button if present
	     * to switch between icon classes
	     * @param  {event} event click event
	     * @return undefined
	     */
	
	  }, {
	    key: 'apply',
	    value: function apply(event) {
	      if (this.applyDismissableClickArea) {
	        var remoteIcon = this.dismissableSidebarPanels.querySelector('.js-dismissable-sidebar-panel__state');
	        if (remoteIcon) {
	          _get__('removeClasses')(remoteIcon, ['icon-cme-filter']);
	          _get__('addClasses')(remoteIcon, ['fa', 'fa-check']);
	        }
	        this.close(event);
	        _get__('removeEvent')(this.closeClickArea, 'click', this.close.bind(this));
	        _get__('triggerEvent')(this.dismissableSidebarPanels, 'apply.commonui.dismissable-side-panel');
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.dismissableSidebarPanels) {
	        console.warn('CommonUI - Dismissable Sidebar Panel - There\'s no dismissable sidebar panel found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return DismissableSidebarPanel;
	}();
	
	/**
	 * Creates a new dismissable sidebar panel instance
	 * @param  {Object} config
	 */
	
	
	function initDismissableSidebarPanel() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-dismissable-sidebar-panel' : _config$selector,
	      _config$openSelector = config.openSelector,
	      openSelector = _config$openSelector === undefined ? '.js-dismissable-sidebar-panel__open' : _config$openSelector,
	      _config$remoteOpenCli = config.remoteOpenClickArea,
	      remoteOpenClickArea = _config$remoteOpenCli === undefined ? '.js-dismissable-sidebar-panel__remote-open' : _config$remoteOpenCli,
	      _config$closeSelector = config.closeSelector,
	      closeSelector = _config$closeSelector === undefined ? '.js-dismissable-sidebar-panel__close' : _config$closeSelector,
	      _config$applyDismissa = config.applyDismissableSidebarPanelSelector,
	      applyDismissableSidebarPanelSelector = _config$applyDismissa === undefined ? '.js-dismissable-sidebar-panel__action' : _config$applyDismissa,
	      _config$width = config.width,
	      width = _config$width === undefined ? '25%' : _config$width;
	
	  var dismissableSidebarPanels = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var dismissableSidebarPanel = _step.value;
	
	        dismissableSidebarPanels = new (_get__('DismissableSidebarPanel'))({
	          dismissableSidebarPanel: dismissableSidebarPanel,
	          openSelector: openSelector,
	          remoteOpenClickArea: remoteOpenClickArea,
	          closeSelector: closeSelector,
	          applyDismissableSidebarPanelSelector: applyDismissableSidebarPanelSelector,
	          width: width
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return dismissableSidebarPanels;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'DismissableSidebarPanel':
	      return DismissableSidebarPanel;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDismissableSidebarPanel === 'undefined' ? 'undefined' : _typeof(initDismissableSidebarPanel);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDismissableSidebarPanel, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDismissableSidebarPanel)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.CountdownTimer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initCountdownTimer;
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-console, key-spacing, no-multi-spaces, no-magic-numbers */
	
	var SEC = 1000;
	var MIN = _get__('SEC') * 60;
	var HOUR = _get__('MIN') * 60;
	var DAY = _get__('HOUR') * 24;
	
	var CountdownTimer = exports.CountdownTimer = function () {
	
	  /**
	   * The Countdown Timer component
	   *
	   * @param {Element} timer DOM element that the timer should be injected into
	   * @return void
	   */
	  function CountdownTimer(elem, _ref) {
	    var startDate = _ref.startDate,
	        endDate = _ref.endDate,
	        _ref$extended = _ref.extended,
	        extended = _ref$extended === undefined ? false : _ref$extended,
	        _ref$compact = _ref.compact,
	        compact = _ref$compact === undefined ? false : _ref$compact,
	        _ref$dark = _ref.dark,
	        dark = _ref$dark === undefined ? false : _ref$dark;
	
	    _classCallCheck(this, CountdownTimer);
	
	    console.warn('Timer.constructor:', elem, startDate, endDate);
	    this.container = elem;
	    this.startDate = startDate;
	    this.endDate = endDate;
	    this.extended = extended;
	    this.compact = compact;
	    this.dark = dark;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.stages = [{ color: '#fa0033', percentRemaining: 10 }, { color: '#f68b1f', percentRemaining: 25 }, { color: '#bfd730', percentRemaining: 50 }, { color: '#8ebe3f', percentRemaining: 100 }];
	
	    this.init();
	  }
	
	  _createClass(CountdownTimer, [{
	    key: 'init',
	    value: function init() {
	      this.createDomElements(this.container);
	      this.startTimer();
	    }
	  }, {
	    key: 'createDomElements',
	    value: function createDomElements(container) {
	      var timerEl = document.createElement('div');
	      var timerPartsEl = document.createElement('div');
	      var timerDurationEl = document.createElement('div');
	      var timerRemainingEl = document.createElement('div');
	      this.daysEl = this.createTimePartElement('days');
	      this.hoursEl = this.createTimePartElement('hours');
	      this.minsEl = this.createTimePartElement('mins');
	      this.secsEl = this.createTimePartElement('secs');
	
	      this.daysRemainingEl = this.daysEl.querySelector('.js-days-remaining');
	      this.hoursRemainingEl = this.hoursEl.querySelector('.js-hours-remaining');
	      this.minsRemainingEl = this.minsEl.querySelector('.js-mins-remaining');
	      this.secsRemainingEl = this.secsEl.querySelector('.js-secs-remaining');
	      this.remainingEl = timerRemainingEl;
	
	      var timerElClasses = ['timer'];
	      if (this.extended === true) {
	        timerElClasses.push('timer--extended');
	      }
	      if (this.compact === true) {
	        timerElClasses.push('timer--compact');
	      }
	      if (this.dark === true) {
	        timerElClasses.push('timer--dark');
	      }
	
	      _get__('addClasses')(timerEl, timerElClasses);
	      _get__('addClasses')(timerPartsEl, ['timer__parts']);
	      _get__('addClasses')(timerDurationEl, ['timer__duration']);
	      _get__('addClasses')(timerRemainingEl, ['timer__duration-remaining', 'js-remaining']);
	
	      timerPartsEl.appendChild(this.daysEl);
	      timerPartsEl.appendChild(this.hoursEl);
	      timerPartsEl.appendChild(this.minsEl);
	      timerPartsEl.appendChild(this.secsEl);
	      timerDurationEl.appendChild(timerRemainingEl);
	      timerEl.appendChild(timerPartsEl);
	      timerEl.appendChild(timerDurationEl);
	      container.appendChild(timerEl);
	    }
	  }, {
	    key: 'createTimePartElement',
	    value: function createTimePartElement(timePart) {
	      var timePartEl = document.createElement('span');
	      var timePartValueEl = document.createElement('span');
	      var timePartUnitEl = document.createElement('span');
	      timePartEl.classList.add('timer__part');
	      timePartValueEl.classList.add('timer__part-value');
	      timePartValueEl.classList.add('js-' + timePart + '-remaining');
	      timePartUnitEl.classList.add('timer__part-unit');
	
	      timePartValueEl.innerText = '00';
	      timePartUnitEl.innerText = this.compact ? timePart.charAt(0) : timePart;
	
	      timePartEl.appendChild(timePartValueEl);
	      timePartEl.appendChild(timePartUnitEl);
	
	      return timePartEl;
	    }
	  }, {
	    key: 'renderTimeUnitRemaining',
	    value: function renderTimeUnitRemaining(val, elem) {
	      var valText = val < 10 ? '0' + val : '' + val;
	      if (elem.innerText !== valText) {
	        elem.innerText = valText;
	      }
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this = this;
	
	      this.countdownTimer = setInterval(function () {
	        _this.updateTimer();
	      }, 100);
	    }
	  }, {
	    key: 'stopTimer',
	    value: function stopTimer() {
	      clearInterval(this.countdownTimer);
	    }
	
	    /**
	    * Checks that the timer is still required.
	    * If no longer required, then the timer is stopped.
	    */
	
	  }, {
	    key: 'checkTimer',
	    value: function checkTimer() {
	      if (Date.now() > this.endDate) {
	        this.stopTimer();
	      }
	    }
	  }, {
	    key: 'updateTimer',
	    value: function updateTimer() {
	      this.checkTimer();
	
	      var _getTimeRemaining = this.getTimeRemaining(),
	          percentRemaining = _getTimeRemaining.percentRemaining,
	          daysRemaining = _getTimeRemaining.daysRemaining,
	          hoursRemaining = _getTimeRemaining.hoursRemaining,
	          minsRemaining = _getTimeRemaining.minsRemaining,
	          secsRemaining = _getTimeRemaining.secsRemaining;
	
	      this.updateProgressBar(percentRemaining);
	
	      if (daysRemaining === 0) {
	        this.muteValue(this.daysEl);
	        if (hoursRemaining === 0) {
	          this.muteValue(this.hoursEl);
	          if (minsRemaining === 0) {
	            this.muteValue(this.minsEl);
	            if (secsRemaining === 0) {
	              this.muteValue(this.secsEl);
	            }
	          }
	        }
	      }
	
	      this.renderTimeUnitRemaining(daysRemaining, this.daysRemainingEl);
	      this.renderTimeUnitRemaining(hoursRemaining, this.hoursRemainingEl);
	      this.renderTimeUnitRemaining(minsRemaining, this.minsRemainingEl);
	      this.renderTimeUnitRemaining(secsRemaining, this.secsRemainingEl);
	
	      this.remainingEl.style.width = percentRemaining + '%';
	    }
	  }, {
	    key: 'getTimeRemaining',
	    value: function getTimeRemaining() {
	      var NOW = Date.now();
	      var totalDuration = this.endDate - this.startDate;
	      // const totalElapsed	= NOW - this.startDate;
	      var totalRemaining = this.endDate - NOW;
	      if (totalRemaining < 0) {
	        totalRemaining = 0;
	      }
	
	      return {
	        totalRemaining: totalRemaining,
	        percentRemaining: totalRemaining / totalDuration * 100,
	        daysRemaining: Math.floor(totalRemaining / _get__('DAY')),
	        hoursRemaining: Math.floor(totalRemaining / _get__('HOUR') % 24),
	        minsRemaining: Math.floor(totalRemaining / _get__('MIN') % 60),
	        secsRemaining: Math.floor(totalRemaining / _get__('SEC') % 60)
	      };
	    }
	  }, {
	    key: 'muteValue',
	    value: function muteValue(elem) {
	      var muteClass = this.extended ? 'text--disabled' : 'display--none';
	      _get__('addClasses')(elem, [muteClass]);
	    }
	  }, {
	    key: 'updateProgressBar',
	    value: function updateProgressBar(percentRemaining) {
	      var color = this.stages[0].color;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = this.stages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var stage = _step.value;
	
	          if (percentRemaining < stage.percentRemaining) {
	            color = stage.color;
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (this.remainingEl.style.backgroundColor !== color) {
	        this.remainingEl.style.backgroundColor = color;
	      }
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.container) {
	        console.warn('CommonUI - Countdown Timer - There\'s no timer found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return CountdownTimer;
	}();
	
	/**
	 * Creates a new countdown timer instance
	 * @param  {Object} config
	 */
	
	
	function initCountdownTimer() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-timer' : _config$selector;
	
	  return new (_get__('CountdownTimer'))(document.querySelector(selector), config);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'SEC':
	      return SEC;
	
	    case 'MIN':
	      return MIN;
	
	    case 'HOUR':
	      return HOUR;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'DAY':
	      return DAY;
	
	    case 'CountdownTimer':
	      return CountdownTimer;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initCountdownTimer === 'undefined' ? 'undefined' : _typeof(initCountdownTimer);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initCountdownTimer, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initCountdownTimer)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = exports.PriceTick = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initFilter;
	
	var _events = __webpack_require__(8);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PriceTick = exports.PriceTick = function () {
	  function PriceTick(tickComponent, upButtonComponent, downButtonComponent, componentInput) {
	    _classCallCheck(this, PriceTick);
	
	    this.priceTickComponent = tickComponent;
	
	    if (!this.isEverythingOk()) {
	      return;
	    }
	
	    this.upButton = tickComponent.querySelector(upButtonComponent);
	    this.downButton = tickComponent.querySelector(downButtonComponent);
	    this.componentInputElement = tickComponent.querySelector(componentInput);
	
	    this.init();
	  }
	
	  /**
	   * Assigns events to the close button
	   * and the filter action button (Apply)
	   * @return undefined
	   */
	
	
	  _createClass(PriceTick, [{
	    key: 'init',
	    value: function init() {
	      if (this.upButton) {
	        _get__('addEvent')(this.upButton, 'click', this.triggerUp.bind(this));
	      }
	      if (this.downButton) {
	        _get__('addEvent')(this.downButton, 'click', this.triggerDown.bind(this));
	      }
	    }
	  }, {
	    key: 'triggerUp',
	    value: function triggerUp() {
	      _get__('triggerEvent')(this.priceTickComponent, 'up.commonui.pricetick');
	    }
	  }, {
	    key: 'triggerDown',
	    value: function triggerDown() {
	      _get__('triggerEvent')(this.priceTickComponent, 'down.commonui.pricetick');
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy() {
	      _get__('removeEvent')(this.upButton, 'click', this.triggerUp.bind(this));
	      _get__('removeEvent')(this.downButton, 'click', this.triggerDown.bind(this));
	      this.close();
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'isEverythingOk',
	    value: function isEverythingOk() {
	      if (!this.priceTickComponent) {
	        console.warn('CommonUI - Price Tick - There\'s no tick found');
	        return false;
	      }
	      return true;
	    }
	    /* eslint-enable no-console */
	
	  }]);
	
	  return PriceTick;
	}();
	
	/**
	 * Creates a new filter instance
	 * @param  {Object} config
	 */
	
	
	function initFilter() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$selector = config.selector,
	      selector = _config$selector === undefined ? '.js-price-tick' : _config$selector,
	      _config$upButtonCompo = config.upButtonComponent,
	      upButtonComponent = _config$upButtonCompo === undefined ? '.js-price-tick__up' : _config$upButtonCompo,
	      _config$downButtonCom = config.downButtonComponent,
	      downButtonComponent = _config$downButtonCom === undefined ? '.js-price-tick__down' : _config$downButtonCom,
	      _config$componentInpu = config.componentInput,
	      componentInput = _config$componentInpu === undefined ? '.js-price-tick__value' : _config$componentInpu;
	
	  var priceTicks = null;
	  if (typeof selector === 'string') {
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = document.querySelectorAll(selector)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var tick = _step.value;
	
	        priceTicks = new (_get__('PriceTick'))(tick, upButtonComponent, downButtonComponent, componentInput);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	  return priceTicks;
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'PriceTick':
	      return PriceTick;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initFilter === 'undefined' ? 'undefined' : _typeof(initFilter);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initFilter, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initFilter)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initToasts;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var defaultToastsOptions = {
	  container: 'body',
	  cssClass: 'js-toasts',
	  maxToasts: 3,
	  position: 'top|right'
	};
	
	var defaultToastOptions = {
	  message: '',
	  type: 'info',
	  minDuration: 2000,
	  maxDuration: 7000,
	  outline: false
	};
	
	var defaultIcons = {
	  'info': 'fa fa-info',
	  'success': 'fa fa-check',
	  'warning': 'fa fa-exclamation',
	  'error': 'fa fa-remove'
	};
	
	var DURATION_PER_CHARACTER = 50;
	var DELAY = 100;
	
	var Toast = function () {
	  function Toast(container) {
	    var _this = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Toast);
	
	    this.toastsEl = container;
	
	    options = _extends({}, _get__('defaultToastOptions'), options);
	
	    this.render(options);
	    setTimeout(function () {
	      return _this.show();
	    }, 0);
	  }
	
	  _createClass(Toast, [{
	    key: 'render',
	    value: function render() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var icon = options.icon,
	          message = options.message,
	          type = options.type,
	          outline = options.outline;
	
	      var toastIconEl = document.createElement('span');
	      var toastMessageEl = document.createElement('span');
	      this.toastDismissBtn = document.createElement('button');
	      // Create the toast element
	      this.toastEl = document.createElement('li');
	
	      // Apply the relevant css classes to the toast element
	      var toastClasses = ['toast', 'toast--' + type];
	      if (outline) {
	        toastClasses.push('toast--outline');
	      }
	      _get__('addClasses')(this.toastEl, toastClasses);
	
	      // Determine the duration of the toast
	      this.duration = this.getDuration(message, options);
	
	      // Set up the toast icon element
	      toastIconEl.innerHTML = '<i class="' + (icon || _get__('defaultIcons')[type]) + '"></i>';
	      toastIconEl.classList.add('toast__icon');
	
	      // Set up the toast message element
	      toastMessageEl.innerHTML = message;
	      toastMessageEl.classList.add('toast__message');
	
	      // Set up the dismiss button
	      this.toastDismissBtn.innerHTML = '<i class="fa fa-remove"></i>';
	      this.toastDismissBtn.classList.add('toast__action');
	
	      // Bind the 'click' event handler for the dismiss button
	      _get__('addEvent')(this.toastDismissBtn, 'click', this.dismiss.bind(this));
	
	      // Apply the 'is-landing' css class to the toast to provide the animations
	      this.toastEl.classList.add('is-landing');
	
	      // Finally, inject the elements to the DOM
	      this.toastEl.appendChild(toastIconEl);
	      this.toastEl.appendChild(toastMessageEl);
	      this.toastEl.appendChild(this.toastDismissBtn);
	      this.toastsEl.appendChild(this.toastEl);
	    }
	
	    /**
	     * Calculates the duration that the message should be displayed for.
	     * Based on 50ms per character, with a default minimum duration of 2s and a default maximum of 7s.
	     * @param {String} message The message to be displayed in the toast.
	     * @param {Object} minDuration, maxDuration The minimum and maximum duration that the toast should be displayed for.
	     */
	
	  }, {
	    key: 'getDuration',
	    value: function getDuration() {
	      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var _ref = arguments[1];
	      var minDuration = _ref.minDuration,
	          maxDuration = _ref.maxDuration;
	
	      var duration = message.replace(' ', '').length * _get__('DURATION_PER_CHARACTER');
	      if (duration < minDuration) {
	        duration = minDuration;
	      } else if (duration > maxDuration) {
	        duration = maxDuration;
	      }
	      return duration;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return _this2.toastEl.classList.remove('is-landing');
	      }, _get__('DELAY'));
	      this.startTimer();
	      _get__('removeEvent')(this.toastEl, 'mouseleave', this.show);
	    }
	  }, {
	    key: 'startTimer',
	    value: function startTimer() {
	      var _this3 = this;
	
	      this.timer = setTimeout(function () {
	        return _this3.dismiss();
	      }, this.duration);
	    }
	  }, {
	    key: 'stopTimer',
	    value: function stopTimer() {
	      clearTimeout(this.timer);
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      var _this4 = this;
	
	      if (this.isDismissing) {
	        return;
	      }
	
	      this.isDismissing = true;
	
	      this.onDismissTransitionEnd = function () {
	        _get__('removeElement')(_this4.toastEl);
	        _get__('removeEvent')(_this4.toastDismissBtn, 'click', _this4.dismiss);
	        _get__('removeEvent')(_this4.toastEl, 'mouseeneter', _this4.cancelDismiss);
	        _get__('removeEvent')(_this4.toastEl, 'transitionend', _this4.onDismissTransitionEnd);
	      };
	
	      _get__('addEvent')(this.toastEl, 'mouseenter', this.cancelDismiss.bind(this));
	      _get__('addEvent')(this.toastEl, 'transitionend', this.onDismissTransitionEnd);
	
	      this.toastEl.classList.add('is-dismissing');
	    }
	  }, {
	    key: 'cancelDismiss',
	    value: function cancelDismiss() {
	      this.isDismissing = false;
	      this.stopTimer();
	      _get__('removeEvent')(this.toastEl, 'mouseenter', this.cancelDismiss);
	      _get__('removeEvent')(this.toastEl, 'transitionend', this.onDismissTransitionEnd);
	      this.toastEl.classList.remove('is-dismissing');
	      _get__('addEvent')(this.toastEl, 'mouseleave', this.show.bind(this));
	    }
	  }]);
	
	  return Toast;
	}();
	
	var Toasts = function () {
	  function Toasts() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Toasts);
	
	    this.init(options);
	    return this;
	  }
	
	  _createClass(Toasts, [{
	    key: 'init',
	    value: function init(options) {
	      this.toasts = [];
	      this.toastsEl = this.getContainer(options);
	      this.setPositioning(options);
	
	      // Set the maximum number of toasts allowed
	      this.maxToasts = options.maxToasts;
	    }
	  }, {
	    key: 'getContainer',
	    value: function getContainer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var container = options.container,
	          cssClass = options.cssClass,
	          position = options.position;
	
	      var toastsEl = document.querySelector('.' + cssClass);
	      if (!toastsEl) {
	        toastsEl = document.createElement('ul');
	        var toastClasses = ['toasts', '' + cssClass];
	        var positions = position.split('|');
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = positions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var pos = _step.value;
	
	            toastClasses.push('toasts--position-' + pos);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        _get__('addClasses')(toastsEl, toastClasses);
	        var toastsContainer = document.querySelector(container);
	        toastsContainer.insertBefore(toastsEl, toastsContainer.firstChild);
	      }
	
	      return toastsEl;
	    }
	
	    /**
	     * Checks the options for positioning instructions and applies them accordingly.
	     * @param {*} options The configuration options specified when initializing the Toasts.
	     */
	
	  }, {
	    key: 'setPositioning',
	    value: function setPositioning(options) {
	      var top = options.top,
	          right = options.right,
	          bottom = options.bottom,
	          left = options.left;
	
	      if (top || right || bottom || left) {
	        var styles = {};
	        // Apply either top OR bottom, not both
	        if (top) {
	          styles = _extends({}, styles, { top: top + 'px' });
	        } else if (bottom) {
	          styles = _extends({}, styles, { bottom: bottom + 'px' });
	        }
	        // Apply either right OR left, not both
	        if (right) {
	          styles = _extends({}, styles, { right: right + 'px' });
	        } else if (left) {
	          styles = _extends({}, styles, { left: left + 'px' });
	        }
	        _get__('setStyles')(this.toastsEl, styles);
	      }
	    }
	  }, {
	    key: 'add',
	    value: function add() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var toast = new (_get__('Toast'))(this.toastsEl, options);
	      this.clearOldToasts(options);
	      this.toasts.push(toast);
	    }
	  }, {
	    key: 'clearOldToasts',
	    value: function clearOldToasts() {
	      // Ensure the number of toasts does not exceed the maximum number of allowed toasts
	      if (this.toasts.length < this.maxToasts) {
	        return;
	      }
	
	      // If the number of toasts exceeds the maximum,
	      // remove the first/oldest one and check again
	      while (this.toasts.length >= this.maxToasts) {
	        var oldToast = this.toasts.shift();
	        oldToast.dismiss();
	      }
	    }
	  }]);
	
	  return Toasts;
	}();
	
	function initToasts() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  options = _extends({}, _get__('defaultToastsOptions'), options);
	  return new (_get__('Toasts'))(options);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'defaultToastOptions':
	      return defaultToastOptions;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'defaultIcons':
	      return defaultIcons;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'DURATION_PER_CHARACTER':
	      return DURATION_PER_CHARACTER;
	
	    case 'DELAY':
	      return DELAY;
	
	    case 'removeEvent':
	      return _events.removeEvent;
	
	    case 'removeElement':
	      return _html.removeElement;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'Toast':
	      return Toast;
	
	    case 'defaultToastsOptions':
	      return defaultToastsOptions;
	
	    case 'Toasts':
	      return Toasts;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initToasts === 'undefined' ? 'undefined' : _typeof(initToasts);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initToasts, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initToasts)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = initSplitPanel;
	
	var _events = __webpack_require__(8);
	
	var _html = __webpack_require__(10);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable no-console */
	
	var DEFAULT_SPLIT_PANEL_OPTIONS = {
	  container: '.js-split-panel',
	  handle: '.js-splitter',
	  launchPanel: '.split-panel__launch',
	  backToMainPanel: '.split-panel__back'
	};
	
	var PERCENTAGE = 100;
	var TIMEOUT_RESIZE_INTERVAL = 20;
	var MAGIC_BREAKPOINT = 480;
	
	var SplitPanel = function () {
	  function SplitPanel() {
	    var _this = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, SplitPanel);
	
	    options = _extends({}, _get__('DEFAULT_SPLIT_PANEL_OPTIONS'), options);
	
	    this.resizes = [];
	    this.currentElement = null;
	
	    this.splitPanel = document.querySelector(options.container);
	    this.launchPanelButtons = document.querySelectorAll(options.launchPanel);
	    this.backToMainPanelButtons = document.querySelectorAll(options.backToMainPanel);
	    this.openPanelTriggers = document.querySelectorAll(options.openPanel);
	    this.closePanelTriggers = document.querySelectorAll(options.closePanel);
	    this.vertical = options.vertical;
	    this.horizontal = options.horizontal;
	
	    var verticalDividers = document.querySelectorAll('.js-vertically-divided');
	    var horizontalDividers = document.querySelectorAll('.js-horizontally-divided');
	
	    var verticalArray = Array.from(verticalDividers);
	    var horizontalArray = Array.from(horizontalDividers);
	    this.resizes = verticalArray.concat(horizontalArray);
	
	    this.setUpSplitters(this.resizes);
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = this.openPanelTriggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var openPanel = _step.value;
	
	        _get__('addEvent')(openPanel, 'click', function () {
	          return _this.openSplitPanel();
	        });
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = this.closePanelTriggers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var closePanel = _step2.value;
	
	        _get__('addEvent')(closePanel, 'click', function () {
	          return _this.closeSplitPanel();
	        });
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	
	  _createClass(SplitPanel, [{
	    key: 'setUpSplitters',
	    value: function setUpSplitters(resizes) {
	      var _this2 = this;
	
	      resizes.forEach(function (elem) {
	        var isVertical = _get__('hasClass')(elem, 'js-vertically-divided');
	        elem.vertical = isVertical;
	        var children = _get__('filterByTagName')(elem.children, 'div');
	
	        var firstItem = children[0];
	        var secondItem = children[1];
	        _get__('setStyles')(secondItem, {
	          position: 'absolute',
	          'overflow-x': 'hidden',
	          top: 0,
	          bottom: 0,
	          left: 0
	        });
	
	        _get__('setStyles')(firstItem, {
	          position: 'absolute',
	          'overflow-x': 'hidden',
	          top: 0,
	          bottom: 0,
	          left: 0
	        });
	
	        _get__('setStyles')(secondItem, { right: 0 });
	
	        _get__('setStyles')(elem, {
	          overflow: 'hidden',
	          position: elem.style.position === 'absolute' ? 'absolute' : 'relative'
	        });
	
	        if (isVertical) {
	          firstItem.style.bottom = '0';
	          secondItem.style.top = '0';
	        } else {
	          firstItem.style.right = '0';
	          secondItem.style.left = '0';
	        }
	
	        elem.firstItem = firstItem;
	        elem.secondItem = secondItem;
	        elem.percent = 50;
	
	        var divider = document.createElement('div');
	        var handle = document.createElement('div');
	        handle.className = 'split-panel__handle';
	
	        var indicator = document.createElement('i');
	        indicator.className = 'icon-cme-draggable-two';
	        handle.appendChild(indicator);
	        indicator = null;
	
	        divider.appendChild(handle);
	        divider.className = isVertical ? 'split-panel--vertical--divider js-vertical-divider' : 'split-panel--horizontal--divider js-horizontal-divider';
	        divider.style.cssText = isVertical ? 'top:0; bottom:0; position:absolute;' : 'left:0; right:0; position:absolute;';
	
	        divider.onmousedown = function (event) {
	          _get__('addClass')(elem.splitter, 'dragged');
	          _this2.currentElement = elem;
	          if (event) {
	            event.preventDefault();
	          }
	          return false;
	        };
	
	        elem.splitter = divider;
	        elem.appendChild(divider);
	        if (window.innerWidth <= _get__('MAGIC_BREAKPOINT')) {
	          _this2.setResponsiveLayout(elem);
	        } else {
	          _this2.update(elem);
	        }
	      });
	
	      if (this.splitPanel.classList.contains('is-closable')) {
	        this.splitPanel.children[1].classList.add('display--none');
	        this.splitPanel.children[2].classList.add('display--none');
	        if (this.vertical) {
	          this.splitPanel.children[0].classList.add('width--100');
	        }
	        if (this.horizontal) {
	          this.splitPanel.children[0].classList.add('height--100');
	        }
	      }
	
	      _get__('addEvent')(document, 'mousemove', this.onMouseMoveEvent.bind(this));
	      _get__('addEvent')(document, 'mouseup', this.onMouseUpEvent.bind(this));
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = this.launchPanelButtons[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var launchPanelButton = _step3.value;
	
	          _get__('addEvent')(launchPanelButton, 'click', function () {
	            return _this2.launchPanel();
	          });
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = this.backToMainPanelButtons[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var backToMainPanelButton = _step4.value;
	
	          _get__('addEvent')(backToMainPanelButton, 'click', function () {
	            return _this2.backToMainPanel();
	          });
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      this.windowResizeListener = this.onWindowResize.bind(this);
	      this.windowResize = new (_get__('Throttle'))(this.windowResizeListener, _get__('TIMEOUT_RESIZE_INTERVAL'));
	      _get__('addEvent')(window, 'resize', this.windowResize.trigger);
	    }
	  }, {
	    key: 'openSplitPanel',
	    value: function openSplitPanel() {
	      this.splitPanel.children[1].classList.remove('display--none');
	      this.splitPanel.children[2].classList.remove('display--none');
	      if (this.vertical) {
	        this.splitPanel.children[0].classList.remove('width--100');
	      }
	      if (this.horizontal) {
	        this.splitPanel.children[0].classList.remove('height--100');
	      }
	      this.launchPanel();
	    }
	  }, {
	    key: 'closeSplitPanel',
	    value: function closeSplitPanel() {
	      this.splitPanel.children[1].classList.add('display--none');
	      this.splitPanel.children[2].classList.add('display--none');
	      if (this.vertical) {
	        this.splitPanel.children[0].classList.add('width--100');
	      }
	      if (this.horizontal) {
	        this.splitPanel.children[0].classList.add('height--100');
	      }
	      this.backToMainPanel();
	    }
	  }, {
	    key: 'onWindowResize',
	    value: function onWindowResize() {
	      for (var index in this.resizes) {
	        if (window.innerWidth <= _get__('MAGIC_BREAKPOINT')) {
	          this.setResponsiveLayout(this.resizes[index]);
	        } else {
	          this.update(this.resizes[index]);
	        }
	      }
	    }
	  }, {
	    key: 'setResponsiveLayout',
	    value: function setResponsiveLayout(element) {
	      if (element.classList) {
	        _get__('addClass')(element.splitter, 'hide');
	        if (element.classList.contains('split-panel--stacked')) {
	          _get__('setStyles')(element.firstItem, { position: 'relative', left: 0, width: '100%', bottom: '0' });
	          _get__('setStyles')(element.secondItem, { position: 'relative', left: 0, width: '100%', top: '0', transform: 0 });
	          _get__('setStyles')(element, { 'overflow': 'auto' });
	        } else {
	          _get__('setStyles')(element.firstItem, { position: 'absolute', left: 0, width: '100%', bottom: '0' });
	          _get__('setStyles')(element.secondItem, { position: 'absolute', left: 0, width: '100%', top: '0' });
	          _get__('setStyles')(element, { 'overflow': 'hidden' });
	        }
	        element.isInResponsiveState = true;
	      }
	    }
	  }, {
	    key: 'unsetResponsiveLayout',
	    value: function unsetResponsiveLayout(element) {
	      if (element) {
	        _get__('removeClass')(element.splitter, 'hide');
	        _get__('setStyles')(element, { 'overflow': 'hidden' });
	        _get__('setStyles')(element.firstItem, { position: 'absolute', left: 0, width: 'inherit' });
	        _get__('setStyles')(element.secondItem, { position: 'absolute', left: '50%', width: 'inherit' });
	        element.secondItem.style.removeProperty('transform');
	        element.isInResponsiveState = false;
	      }
	    }
	  }, {
	    key: 'onMouseUpEvent',
	    value: function onMouseUpEvent() {
	      if (this.currentElement) {
	        this.currentElement.splitter.className = this.currentElement.vertical ? 'split-panel--vertical--divider js-vertical-divider' : 'split-panel--horizontal--divider js-horizontal-divider';
	        this.currentElement = null;
	        _get__('triggerEvent')(this.splitPanel, 'resized.commonui.splitpanel');
	      }
	    }
	  }, {
	    key: 'onMouseMoveEvent',
	    value: function onMouseMoveEvent(event) {
	      if (this.currentElement) {
	        var isVerticalState = this.currentElement.vertical;
	
	        var splitterState = isVerticalState ? this.currentElement.splitter.offsetWidth : this.currentElement.splitter.offsetHeight;
	        var elementState = isVerticalState ? this.currentElement.clientWidth : this.currentElement.clientHeight;
	        var newPos = (isVerticalState ? event.clientX : event.clientY) - this.currentElement.getBoundingClientRect()[isVerticalState ? 'left' : 'top'] - splitterState / 2;
	        var newPercentage = newPos > elementState - splitterState ? elementState - splitterState : newPos;
	        this.currentElement.percent = (newPos < 0 ? 0 : newPercentage) / elementState * _get__('PERCENTAGE');
	        this.update(this.currentElement);
	
	        if (event) {
	          event.preventDefault();
	        }
	        return false;
	      }
	
	      return true;
	    }
	  }, {
	    key: 'update',
	    value: function update(element) {
	      if (!element.splitter) {
	        return;
	      }
	      var elementState = element.vertical ? element.clientWidth : element.clientHeight;
	      var newPos = element.percent / _get__('PERCENTAGE') * elementState;
	      var splitterWidth = element.vertical ? element.splitter.offsetWidth : element.splitter.offsetHeight;
	      var bPercentage = (newPos + splitterWidth) / elementState * _get__('PERCENTAGE') + '%';
	      var aPercentage = (elementState - newPos) / elementState * _get__('PERCENTAGE') + '%';
	      element.splitter.style[element.vertical ? 'left' : 'top'] = element.percent + '%';
	      if (element.isInResponsiveState) {
	        this.unsetResponsiveLayout(element);
	      }
	      if (element.vertical) {
	        _get__('setStyles')(element.secondItem, { left: bPercentage, right: 0, top: 0, bottom: 0 });
	        _get__('setStyles')(element.firstItem, { right: aPercentage, left: 0, top: 0, bottom: 0 });
	      } else {
	        _get__('setStyles')(element.secondItem, { top: bPercentage, bottom: 0, left: 0, right: 0 });
	        _get__('setStyles')(element.firstItem, { bottom: aPercentage, top: 0, left: 0, right: 0 });
	      }
	    }
	  }, {
	    key: 'launchPanel',
	    value: function launchPanel() {
	      this.splitPanel.children[1].style.transform = 'translateX(0)';
	    }
	  }, {
	    key: 'backToMainPanel',
	    value: function backToMainPanel() {
	      this.splitPanel.children[1].style.transform = 'translateX(100%)';
	    }
	  }]);
	
	  return SplitPanel;
	}();
	
	function initSplitPanel() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  options = _extends({}, _get__('DEFAULT_SPLIT_PANEL_OPTIONS'), options);
	  return new (_get__('SplitPanel'))(options);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'DEFAULT_SPLIT_PANEL_OPTIONS':
	      return DEFAULT_SPLIT_PANEL_OPTIONS;
	
	    case 'addEvent':
	      return _events.addEvent;
	
	    case 'hasClass':
	      return _html.hasClass;
	
	    case 'filterByTagName':
	      return _html.filterByTagName;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'addClass':
	      return _html.addClass;
	
	    case 'MAGIC_BREAKPOINT':
	      return MAGIC_BREAKPOINT;
	
	    case 'Throttle':
	      return _events.Throttle;
	
	    case 'TIMEOUT_RESIZE_INTERVAL':
	      return TIMEOUT_RESIZE_INTERVAL;
	
	    case 'removeClass':
	      return _html.removeClass;
	
	    case 'triggerEvent':
	      return _events.triggerEvent;
	
	    case 'PERCENTAGE':
	      return PERCENTAGE;
	
	    case 'SplitPanel':
	      return SplitPanel;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initSplitPanel === 'undefined' ? 'undefined' : _typeof(initSplitPanel);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initSplitPanel, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initSplitPanel)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = initDatepicker;
	
	var _flatpickr = __webpack_require__(54);
	
	var _flatpickr2 = _interopRequireDefault(_flatpickr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initDatepicker(selector) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return _get__('flatpickr')(selector, config);
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'flatpickr':
	      return _flatpickr2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof initDatepicker === 'undefined' ? 'undefined' : _typeof(initDatepicker);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(initDatepicker, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(initDatepicker)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	/* flatpickr v4.6.3, @license MIT */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global = global || self, global.flatpickr = factory());
	}(this, function () { 'use strict';
	
	    /*! *****************************************************************************
	    Copyright (c) Microsoft Corporation. All rights reserved.
	    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	    this file except in compliance with the License. You may obtain a copy of the
	    License at http://www.apache.org/licenses/LICENSE-2.0
	
	    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	    MERCHANTABLITY OR NON-INFRINGEMENT.
	
	    See the Apache Version 2.0 License for specific language governing permissions
	    and limitations under the License.
	    ***************************************************************************** */
	
	    var __assign = function() {
	        __assign = Object.assign || function __assign(t) {
	            for (var s, i = 1, n = arguments.length; i < n; i++) {
	                s = arguments[i];
	                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	            }
	            return t;
	        };
	        return __assign.apply(this, arguments);
	    };
	
	    var HOOKS = [
	        "onChange",
	        "onClose",
	        "onDayCreate",
	        "onDestroy",
	        "onKeyDown",
	        "onMonthChange",
	        "onOpen",
	        "onParseConfig",
	        "onReady",
	        "onValueUpdate",
	        "onYearChange",
	        "onPreCalendarPosition",
	    ];
	    var defaults = {
	        _disable: [],
	        _enable: [],
	        allowInput: false,
	        altFormat: "F j, Y",
	        altInput: false,
	        altInputClass: "form-control input",
	        animate: typeof window === "object" &&
	            window.navigator.userAgent.indexOf("MSIE") === -1,
	        ariaDateFormat: "F j, Y",
	        clickOpens: true,
	        closeOnSelect: true,
	        conjunction: ", ",
	        dateFormat: "Y-m-d",
	        defaultHour: 12,
	        defaultMinute: 0,
	        defaultSeconds: 0,
	        disable: [],
	        disableMobile: false,
	        enable: [],
	        enableSeconds: false,
	        enableTime: false,
	        errorHandler: function (err) {
	            return typeof console !== "undefined" && console.warn(err);
	        },
	        getWeek: function (givenDate) {
	            var date = new Date(givenDate.getTime());
	            date.setHours(0, 0, 0, 0);
	            // Thursday in current week decides the year.
	            date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
	            // January 4 is always in week 1.
	            var week1 = new Date(date.getFullYear(), 0, 4);
	            // Adjust to Thursday in week 1 and count number of weeks from date to week1.
	            return (1 +
	                Math.round(((date.getTime() - week1.getTime()) / 86400000 -
	                    3 +
	                    ((week1.getDay() + 6) % 7)) /
	                    7));
	        },
	        hourIncrement: 1,
	        ignoredFocusElements: [],
	        inline: false,
	        locale: "default",
	        minuteIncrement: 5,
	        mode: "single",
	        monthSelectorType: "dropdown",
	        nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
	        noCalendar: false,
	        now: new Date(),
	        onChange: [],
	        onClose: [],
	        onDayCreate: [],
	        onDestroy: [],
	        onKeyDown: [],
	        onMonthChange: [],
	        onOpen: [],
	        onParseConfig: [],
	        onReady: [],
	        onValueUpdate: [],
	        onYearChange: [],
	        onPreCalendarPosition: [],
	        plugins: [],
	        position: "auto",
	        positionElement: undefined,
	        prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
	        shorthandCurrentMonth: false,
	        showMonths: 1,
	        static: false,
	        time_24hr: false,
	        weekNumbers: false,
	        wrap: false
	    };
	
	    var english = {
	        weekdays: {
	            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	            longhand: [
	                "Sunday",
	                "Monday",
	                "Tuesday",
	                "Wednesday",
	                "Thursday",
	                "Friday",
	                "Saturday",
	            ]
	        },
	        months: {
	            shorthand: [
	                "Jan",
	                "Feb",
	                "Mar",
	                "Apr",
	                "May",
	                "Jun",
	                "Jul",
	                "Aug",
	                "Sep",
	                "Oct",
	                "Nov",
	                "Dec",
	            ],
	            longhand: [
	                "January",
	                "February",
	                "March",
	                "April",
	                "May",
	                "June",
	                "July",
	                "August",
	                "September",
	                "October",
	                "November",
	                "December",
	            ]
	        },
	        daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	        firstDayOfWeek: 0,
	        ordinal: function (nth) {
	            var s = nth % 100;
	            if (s > 3 && s < 21)
	                return "th";
	            switch (s % 10) {
	                case 1:
	                    return "st";
	                case 2:
	                    return "nd";
	                case 3:
	                    return "rd";
	                default:
	                    return "th";
	            }
	        },
	        rangeSeparator: " to ",
	        weekAbbreviation: "Wk",
	        scrollTitle: "Scroll to increment",
	        toggleTitle: "Click to toggle",
	        amPM: ["AM", "PM"],
	        yearAriaLabel: "Year",
	        hourAriaLabel: "Hour",
	        minuteAriaLabel: "Minute",
	        time_24hr: false
	    };
	
	    var pad = function (number) { return ("0" + number).slice(-2); };
	    var int = function (bool) { return (bool === true ? 1 : 0); };
	    /* istanbul ignore next */
	    function debounce(func, wait, immediate) {
	        if (immediate === void 0) { immediate = false; }
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            timeout !== null && clearTimeout(timeout);
	            timeout = window.setTimeout(function () {
	                timeout = null;
	                if (!immediate)
	                    func.apply(context, args);
	            }, wait);
	            if (immediate && !timeout)
	                func.apply(context, args);
	        };
	    }
	    var arrayify = function (obj) {
	        return obj instanceof Array ? obj : [obj];
	    };
	
	    function toggleClass(elem, className, bool) {
	        if (bool === true)
	            return elem.classList.add(className);
	        elem.classList.remove(className);
	    }
	    function createElement(tag, className, content) {
	        var e = window.document.createElement(tag);
	        className = className || "";
	        content = content || "";
	        e.className = className;
	        if (content !== undefined)
	            e.textContent = content;
	        return e;
	    }
	    function clearNode(node) {
	        while (node.firstChild)
	            node.removeChild(node.firstChild);
	    }
	    function findParent(node, condition) {
	        if (condition(node))
	            return node;
	        else if (node.parentNode)
	            return findParent(node.parentNode, condition);
	        return undefined; // nothing found
	    }
	    function createNumberInput(inputClassName, opts) {
	        var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
	        if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
	            numInput.type = "number";
	        }
	        else {
	            numInput.type = "text";
	            numInput.pattern = "\\d*";
	        }
	        if (opts !== undefined)
	            for (var key in opts)
	                numInput.setAttribute(key, opts[key]);
	        wrapper.appendChild(numInput);
	        wrapper.appendChild(arrowUp);
	        wrapper.appendChild(arrowDown);
	        return wrapper;
	    }
	    function getEventTarget(event) {
	        if (typeof event.composedPath === "function") {
	            var path = event.composedPath();
	            return path[0];
	        }
	        return event.target;
	    }
	
	    var doNothing = function () { return undefined; };
	    var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber]; };
	    var revFormat = {
	        D: doNothing,
	        F: function (dateObj, monthName, locale) {
	            dateObj.setMonth(locale.months.longhand.indexOf(monthName));
	        },
	        G: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        H: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        J: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        K: function (dateObj, amPM, locale) {
	            dateObj.setHours((dateObj.getHours() % 12) +
	                12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
	        },
	        M: function (dateObj, shortMonth, locale) {
	            dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
	        },
	        S: function (dateObj, seconds) {
	            dateObj.setSeconds(parseFloat(seconds));
	        },
	        U: function (_, unixSeconds) { return new Date(parseFloat(unixSeconds) * 1000); },
	        W: function (dateObj, weekNum, locale) {
	            var weekNumber = parseInt(weekNum);
	            var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
	            date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
	            return date;
	        },
	        Y: function (dateObj, year) {
	            dateObj.setFullYear(parseFloat(year));
	        },
	        Z: function (_, ISODate) { return new Date(ISODate); },
	        d: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        h: function (dateObj, hour) {
	            dateObj.setHours(parseFloat(hour));
	        },
	        i: function (dateObj, minutes) {
	            dateObj.setMinutes(parseFloat(minutes));
	        },
	        j: function (dateObj, day) {
	            dateObj.setDate(parseFloat(day));
	        },
	        l: doNothing,
	        m: function (dateObj, month) {
	            dateObj.setMonth(parseFloat(month) - 1);
	        },
	        n: function (dateObj, month) {
	            dateObj.setMonth(parseFloat(month) - 1);
	        },
	        s: function (dateObj, seconds) {
	            dateObj.setSeconds(parseFloat(seconds));
	        },
	        u: function (_, unixMillSeconds) {
	            return new Date(parseFloat(unixMillSeconds));
	        },
	        w: doNothing,
	        y: function (dateObj, year) {
	            dateObj.setFullYear(2000 + parseFloat(year));
	        }
	    };
	    var tokenRegex = {
	        D: "(\\w+)",
	        F: "(\\w+)",
	        G: "(\\d\\d|\\d)",
	        H: "(\\d\\d|\\d)",
	        J: "(\\d\\d|\\d)\\w+",
	        K: "",
	        M: "(\\w+)",
	        S: "(\\d\\d|\\d)",
	        U: "(.+)",
	        W: "(\\d\\d|\\d)",
	        Y: "(\\d{4})",
	        Z: "(.+)",
	        d: "(\\d\\d|\\d)",
	        h: "(\\d\\d|\\d)",
	        i: "(\\d\\d|\\d)",
	        j: "(\\d\\d|\\d)",
	        l: "(\\w+)",
	        m: "(\\d\\d|\\d)",
	        n: "(\\d\\d|\\d)",
	        s: "(\\d\\d|\\d)",
	        u: "(.+)",
	        w: "(\\d\\d|\\d)",
	        y: "(\\d{2})"
	    };
	    var formats = {
	        // get the date in UTC
	        Z: function (date) { return date.toISOString(); },
	        // weekday name, short, e.g. Thu
	        D: function (date, locale, options) {
	            return locale.weekdays.shorthand[formats.w(date, locale, options)];
	        },
	        // full month name e.g. January
	        F: function (date, locale, options) {
	            return monthToStr(formats.n(date, locale, options) - 1, false, locale);
	        },
	        // padded hour 1-12
	        G: function (date, locale, options) {
	            return pad(formats.h(date, locale, options));
	        },
	        // hours with leading zero e.g. 03
	        H: function (date) { return pad(date.getHours()); },
	        // day (1-30) with ordinal suffix e.g. 1st, 2nd
	        J: function (date, locale) {
	            return locale.ordinal !== undefined
	                ? date.getDate() + locale.ordinal(date.getDate())
	                : date.getDate();
	        },
	        // AM/PM
	        K: function (date, locale) { return locale.amPM[int(date.getHours() > 11)]; },
	        // shorthand month e.g. Jan, Sep, Oct, etc
	        M: function (date, locale) {
	            return monthToStr(date.getMonth(), true, locale);
	        },
	        // seconds 00-59
	        S: function (date) { return pad(date.getSeconds()); },
	        // unix timestamp
	        U: function (date) { return date.getTime() / 1000; },
	        W: function (date, _, options) {
	            return options.getWeek(date);
	        },
	        // full year e.g. 2016
	        Y: function (date) { return date.getFullYear(); },
	        // day in month, padded (01-30)
	        d: function (date) { return pad(date.getDate()); },
	        // hour from 1-12 (am/pm)
	        h: function (date) { return (date.getHours() % 12 ? date.getHours() % 12 : 12); },
	        // minutes, padded with leading zero e.g. 09
	        i: function (date) { return pad(date.getMinutes()); },
	        // day in month (1-30)
	        j: function (date) { return date.getDate(); },
	        // weekday name, full, e.g. Thursday
	        l: function (date, locale) {
	            return locale.weekdays.longhand[date.getDay()];
	        },
	        // padded month number (01-12)
	        m: function (date) { return pad(date.getMonth() + 1); },
	        // the month number (1-12)
	        n: function (date) { return date.getMonth() + 1; },
	        // seconds 0-59
	        s: function (date) { return date.getSeconds(); },
	        // Unix Milliseconds
	        u: function (date) { return date.getTime(); },
	        // number of the day of the week
	        w: function (date) { return date.getDay(); },
	        // last two digits of year e.g. 16 for 2016
	        y: function (date) { return String(date.getFullYear()).substring(2); }
	    };
	
	    var createDateFormatter = function (_a) {
	        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
	        return function (dateObj, frmt, overrideLocale) {
	            var locale = overrideLocale || l10n;
	            if (config.formatDate !== undefined) {
	                return config.formatDate(dateObj, frmt, locale);
	            }
	            return frmt
	                .split("")
	                .map(function (c, i, arr) {
	                return formats[c] && arr[i - 1] !== "\\"
	                    ? formats[c](dateObj, locale, config)
	                    : c !== "\\"
	                        ? c
	                        : "";
	            })
	                .join("");
	        };
	    };
	    var createDateParser = function (_a) {
	        var _b = _a.config, config = _b === void 0 ? defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? english : _c;
	        return function (date, givenFormat, timeless, customLocale) {
	            if (date !== 0 && !date)
	                return undefined;
	            var locale = customLocale || l10n;
	            var parsedDate;
	            var dateOrig = date;
	            if (date instanceof Date)
	                parsedDate = new Date(date.getTime());
	            else if (typeof date !== "string" &&
	                date.toFixed !== undefined // timestamp
	            )
	                // create a copy
	                parsedDate = new Date(date);
	            else if (typeof date === "string") {
	                // date string
	                var format = givenFormat || (config || defaults).dateFormat;
	                var datestr = String(date).trim();
	                if (datestr === "today") {
	                    parsedDate = new Date();
	                    timeless = true;
	                }
	                else if (/Z$/.test(datestr) ||
	                    /GMT$/.test(datestr) // datestrings w/ timezone
	                )
	                    parsedDate = new Date(date);
	                else if (config && config.parseDate)
	                    parsedDate = config.parseDate(date, format);
	                else {
	                    parsedDate =
	                        !config || !config.noCalendar
	                            ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
	                            : new Date(new Date().setHours(0, 0, 0, 0));
	                    var matched = void 0, ops = [];
	                    for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
	                        var token_1 = format[i];
	                        var isBackSlash = token_1 === "\\";
	                        var escaped = format[i - 1] === "\\" || isBackSlash;
	                        if (tokenRegex[token_1] && !escaped) {
	                            regexStr += tokenRegex[token_1];
	                            var match = new RegExp(regexStr).exec(date);
	                            if (match && (matched = true)) {
	                                ops[token_1 !== "Y" ? "push" : "unshift"]({
	                                    fn: revFormat[token_1],
	                                    val: match[++matchIndex]
	                                });
	                            }
	                        }
	                        else if (!isBackSlash)
	                            regexStr += "."; // don't really care
	                        ops.forEach(function (_a) {
	                            var fn = _a.fn, val = _a.val;
	                            return (parsedDate = fn(parsedDate, val, locale) || parsedDate);
	                        });
	                    }
	                    parsedDate = matched ? parsedDate : undefined;
	                }
	            }
	            /* istanbul ignore next */
	            if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
	                config.errorHandler(new Error("Invalid date provided: " + dateOrig));
	                return undefined;
	            }
	            if (timeless === true)
	                parsedDate.setHours(0, 0, 0, 0);
	            return parsedDate;
	        };
	    };
	    /**
	     * Compute the difference in dates, measured in ms
	     */
	    function compareDates(date1, date2, timeless) {
	        if (timeless === void 0) { timeless = true; }
	        if (timeless !== false) {
	            return (new Date(date1.getTime()).setHours(0, 0, 0, 0) -
	                new Date(date2.getTime()).setHours(0, 0, 0, 0));
	        }
	        return date1.getTime() - date2.getTime();
	    }
	    var isBetween = function (ts, ts1, ts2) {
	        return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
	    };
	    var duration = {
	        DAY: 86400000
	    };
	
	    if (typeof Object.assign !== "function") {
	        Object.assign = function (target) {
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            if (!target) {
	                throw TypeError("Cannot convert undefined or null to object");
	            }
	            var _loop_1 = function (source) {
	                if (source) {
	                    Object.keys(source).forEach(function (key) { return (target[key] = source[key]); });
	                }
	            };
	            for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
	                var source = args_1[_a];
	                _loop_1(source);
	            }
	            return target;
	        };
	    }
	
	    var DEBOUNCED_CHANGE_MS = 300;
	    function FlatpickrInstance(element, instanceConfig) {
	        var self = {
	            config: __assign({}, defaults, flatpickr.defaultConfig),
	            l10n: english
	        };
	        self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
	        self._handlers = [];
	        self.pluginElements = [];
	        self.loadedPlugins = [];
	        self._bind = bind;
	        self._setHoursFromDate = setHoursFromDate;
	        self._positionCalendar = positionCalendar;
	        self.changeMonth = changeMonth;
	        self.changeYear = changeYear;
	        self.clear = clear;
	        self.close = close;
	        self._createElement = createElement;
	        self.destroy = destroy;
	        self.isEnabled = isEnabled;
	        self.jumpToDate = jumpToDate;
	        self.open = open;
	        self.redraw = redraw;
	        self.set = set;
	        self.setDate = setDate;
	        self.toggle = toggle;
	        function setupHelperFunctions() {
	            self.utils = {
	                getDaysInMonth: function (month, yr) {
	                    if (month === void 0) { month = self.currentMonth; }
	                    if (yr === void 0) { yr = self.currentYear; }
	                    if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0))
	                        return 29;
	                    return self.l10n.daysInMonth[month];
	                }
	            };
	        }
	        function init() {
	            self.element = self.input = element;
	            self.isOpen = false;
	            parseConfig();
	            setupLocale();
	            setupInputs();
	            setupDates();
	            setupHelperFunctions();
	            if (!self.isMobile)
	                build();
	            bindEvents();
	            if (self.selectedDates.length || self.config.noCalendar) {
	                if (self.config.enableTime) {
	                    setHoursFromDate(self.config.noCalendar
	                        ? self.latestSelectedDateObj || self.config.minDate
	                        : undefined);
	                }
	                updateValue(false);
	            }
	            setCalendarWidth();
	            self.showTimeInput =
	                self.selectedDates.length > 0 || self.config.noCalendar;
	            var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	            /* TODO: investigate this further
	        
	              Currently, there is weird positioning behavior in safari causing pages
	              to scroll up. https://github.com/chmln/flatpickr/issues/563
	        
	              However, most browsers are not Safari and positioning is expensive when used
	              in scale. https://github.com/chmln/flatpickr/issues/1096
	            */
	            if (!self.isMobile && isSafari) {
	                positionCalendar();
	            }
	            triggerEvent("onReady");
	        }
	        function bindToInstance(fn) {
	            return fn.bind(self);
	        }
	        function setCalendarWidth() {
	            var config = self.config;
	            if (config.weekNumbers === false && config.showMonths === 1)
	                return;
	            else if (config.noCalendar !== true) {
	                window.requestAnimationFrame(function () {
	                    if (self.calendarContainer !== undefined) {
	                        self.calendarContainer.style.visibility = "hidden";
	                        self.calendarContainer.style.display = "block";
	                    }
	                    if (self.daysContainer !== undefined) {
	                        var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
	                        self.daysContainer.style.width = daysWidth + "px";
	                        self.calendarContainer.style.width =
	                            daysWidth +
	                                (self.weekWrapper !== undefined
	                                    ? self.weekWrapper.offsetWidth
	                                    : 0) +
	                                "px";
	                        self.calendarContainer.style.removeProperty("visibility");
	                        self.calendarContainer.style.removeProperty("display");
	                    }
	                });
	            }
	        }
	        /**
	         * The handler for all events targeting the time inputs
	         */
	        function updateTime(e) {
	            if (self.selectedDates.length === 0) {
	                setDefaultTime();
	            }
	            if (e !== undefined && e.type !== "blur") {
	                timeWrapper(e);
	            }
	            var prevValue = self._input.value;
	            setHoursFromInputs();
	            updateValue();
	            if (self._input.value !== prevValue) {
	                self._debouncedChange();
	            }
	        }
	        function ampm2military(hour, amPM) {
	            return (hour % 12) + 12 * int(amPM === self.l10n.amPM[1]);
	        }
	        function military2ampm(hour) {
	            switch (hour % 24) {
	                case 0:
	                case 12:
	                    return 12;
	                default:
	                    return hour % 12;
	            }
	        }
	        /**
	         * Syncs the selected date object time with user's time input
	         */
	        function setHoursFromInputs() {
	            if (self.hourElement === undefined || self.minuteElement === undefined)
	                return;
	            var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined
	                ? (parseInt(self.secondElement.value, 10) || 0) % 60
	                : 0;
	            if (self.amPM !== undefined) {
	                hours = ampm2military(hours, self.amPM.textContent);
	            }
	            var limitMinHours = self.config.minTime !== undefined ||
	                (self.config.minDate &&
	                    self.minDateHasTime &&
	                    self.latestSelectedDateObj &&
	                    compareDates(self.latestSelectedDateObj, self.config.minDate, true) ===
	                        0);
	            var limitMaxHours = self.config.maxTime !== undefined ||
	                (self.config.maxDate &&
	                    self.maxDateHasTime &&
	                    self.latestSelectedDateObj &&
	                    compareDates(self.latestSelectedDateObj, self.config.maxDate, true) ===
	                        0);
	            if (limitMaxHours) {
	                var maxTime = self.config.maxTime !== undefined
	                    ? self.config.maxTime
	                    : self.config.maxDate;
	                hours = Math.min(hours, maxTime.getHours());
	                if (hours === maxTime.getHours())
	                    minutes = Math.min(minutes, maxTime.getMinutes());
	                if (minutes === maxTime.getMinutes())
	                    seconds = Math.min(seconds, maxTime.getSeconds());
	            }
	            if (limitMinHours) {
	                var minTime = self.config.minTime !== undefined
	                    ? self.config.minTime
	                    : self.config.minDate;
	                hours = Math.max(hours, minTime.getHours());
	                if (hours === minTime.getHours())
	                    minutes = Math.max(minutes, minTime.getMinutes());
	                if (minutes === minTime.getMinutes())
	                    seconds = Math.max(seconds, minTime.getSeconds());
	            }
	            setHours(hours, minutes, seconds);
	        }
	        /**
	         * Syncs time input values with a date
	         */
	        function setHoursFromDate(dateObj) {
	            var date = dateObj || self.latestSelectedDateObj;
	            if (date)
	                setHours(date.getHours(), date.getMinutes(), date.getSeconds());
	        }
	        function setDefaultHours() {
	            var hours = self.config.defaultHour;
	            var minutes = self.config.defaultMinute;
	            var seconds = self.config.defaultSeconds;
	            if (self.config.minDate !== undefined) {
	                var minHr = self.config.minDate.getHours();
	                var minMinutes = self.config.minDate.getMinutes();
	                hours = Math.max(hours, minHr);
	                if (hours === minHr)
	                    minutes = Math.max(minMinutes, minutes);
	                if (hours === minHr && minutes === minMinutes)
	                    seconds = self.config.minDate.getSeconds();
	            }
	            if (self.config.maxDate !== undefined) {
	                var maxHr = self.config.maxDate.getHours();
	                var maxMinutes = self.config.maxDate.getMinutes();
	                hours = Math.min(hours, maxHr);
	                if (hours === maxHr)
	                    minutes = Math.min(maxMinutes, minutes);
	                if (hours === maxHr && minutes === maxMinutes)
	                    seconds = self.config.maxDate.getSeconds();
	            }
	            setHours(hours, minutes, seconds);
	        }
	        /**
	         * Sets the hours, minutes, and optionally seconds
	         * of the latest selected date object and the
	         * corresponding time inputs
	         * @param {Number} hours the hour. whether its military
	         *                 or am-pm gets inferred from config
	         * @param {Number} minutes the minutes
	         * @param {Number} seconds the seconds (optional)
	         */
	        function setHours(hours, minutes, seconds) {
	            if (self.latestSelectedDateObj !== undefined) {
	                self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
	            }
	            if (!self.hourElement || !self.minuteElement || self.isMobile)
	                return;
	            self.hourElement.value = pad(!self.config.time_24hr
	                ? ((12 + hours) % 12) + 12 * int(hours % 12 === 0)
	                : hours);
	            self.minuteElement.value = pad(minutes);
	            if (self.amPM !== undefined)
	                self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
	            if (self.secondElement !== undefined)
	                self.secondElement.value = pad(seconds);
	        }
	        /**
	         * Handles the year input and incrementing events
	         * @param {Event} event the keyup or increment event
	         */
	        function onYearInput(event) {
	            var year = parseInt(event.target.value) + (event.delta || 0);
	            if (year / 1000 > 1 ||
	                (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
	                changeYear(year);
	            }
	        }
	        /**
	         * Essentially addEventListener + tracking
	         * @param {Element} element the element to addEventListener to
	         * @param {String} event the event name
	         * @param {Function} handler the event handler
	         */
	        function bind(element, event, handler, options) {
	            if (event instanceof Array)
	                return event.forEach(function (ev) { return bind(element, ev, handler, options); });
	            if (element instanceof Array)
	                return element.forEach(function (el) { return bind(el, event, handler, options); });
	            element.addEventListener(event, handler, options);
	            self._handlers.push({
	                element: element,
	                event: event,
	                handler: handler,
	                options: options
	            });
	        }
	        /**
	         * A mousedown handler which mimics click.
	         * Minimizes latency, since we don't need to wait for mouseup in most cases.
	         * Also, avoids handling right clicks.
	         *
	         * @param {Function} handler the event handler
	         */
	        function onClick(handler) {
	            return function (evt) {
	                evt.which === 1 && handler(evt);
	            };
	        }
	        function triggerChange() {
	            triggerEvent("onChange");
	        }
	        /**
	         * Adds all the necessary event listeners
	         */
	        function bindEvents() {
	            if (self.config.wrap) {
	                ["open", "close", "toggle", "clear"].forEach(function (evt) {
	                    Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
	                        return bind(el, "click", self[evt]);
	                    });
	                });
	            }
	            if (self.isMobile) {
	                setupMobile();
	                return;
	            }
	            var debouncedResize = debounce(onResize, 50);
	            self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
	            if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
	                bind(self.daysContainer, "mouseover", function (e) {
	                    if (self.config.mode === "range")
	                        onMouseOver(e.target);
	                });
	            bind(window.document.body, "keydown", onKeyDown);
	            if (!self.config.inline && !self.config.static)
	                bind(window, "resize", debouncedResize);
	            if (window.ontouchstart !== undefined)
	                bind(window.document, "touchstart", documentClick);
	            else
	                bind(window.document, "mousedown", onClick(documentClick));
	            bind(window.document, "focus", documentClick, { capture: true });
	            if (self.config.clickOpens === true) {
	                bind(self._input, "focus", self.open);
	                bind(self._input, "mousedown", onClick(self.open));
	            }
	            if (self.daysContainer !== undefined) {
	                bind(self.monthNav, "mousedown", onClick(onMonthNavClick));
	                bind(self.monthNav, ["keyup", "increment"], onYearInput);
	                bind(self.daysContainer, "mousedown", onClick(selectDate));
	            }
	            if (self.timeContainer !== undefined &&
	                self.minuteElement !== undefined &&
	                self.hourElement !== undefined) {
	                var selText = function (e) {
	                    return e.target.select();
	                };
	                bind(self.timeContainer, ["increment"], updateTime);
	                bind(self.timeContainer, "blur", updateTime, { capture: true });
	                bind(self.timeContainer, "mousedown", onClick(timeIncrement));
	                bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
	                if (self.secondElement !== undefined)
	                    bind(self.secondElement, "focus", function () { return self.secondElement && self.secondElement.select(); });
	                if (self.amPM !== undefined) {
	                    bind(self.amPM, "mousedown", onClick(function (e) {
	                        updateTime(e);
	                        triggerChange();
	                    }));
	                }
	            }
	        }
	        /**
	         * Set the calendar view to a particular date.
	         * @param {Date} jumpDate the date to set the view to
	         * @param {boolean} triggerChange if change events should be triggered
	         */
	        function jumpToDate(jumpDate, triggerChange) {
	            var jumpTo = jumpDate !== undefined
	                ? self.parseDate(jumpDate)
	                : self.latestSelectedDateObj ||
	                    (self.config.minDate && self.config.minDate > self.now
	                        ? self.config.minDate
	                        : self.config.maxDate && self.config.maxDate < self.now
	                            ? self.config.maxDate
	                            : self.now);
	            var oldYear = self.currentYear;
	            var oldMonth = self.currentMonth;
	            try {
	                if (jumpTo !== undefined) {
	                    self.currentYear = jumpTo.getFullYear();
	                    self.currentMonth = jumpTo.getMonth();
	                }
	            }
	            catch (e) {
	                /* istanbul ignore next */
	                e.message = "Invalid date supplied: " + jumpTo;
	                self.config.errorHandler(e);
	            }
	            if (triggerChange && self.currentYear !== oldYear) {
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	            if (triggerChange &&
	                (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
	                triggerEvent("onMonthChange");
	            }
	            self.redraw();
	        }
	        /**
	         * The up/down arrow handler for time inputs
	         * @param {Event} e the click event
	         */
	        function timeIncrement(e) {
	            if (~e.target.className.indexOf("arrow"))
	                incrementNumInput(e, e.target.classList.contains("arrowUp") ? 1 : -1);
	        }
	        /**
	         * Increments/decrements the value of input associ-
	         * ated with the up/down arrow by dispatching an
	         * "increment" event on the input.
	         *
	         * @param {Event} e the click event
	         * @param {Number} delta the diff (usually 1 or -1)
	         * @param {Element} inputElem the input element
	         */
	        function incrementNumInput(e, delta, inputElem) {
	            var target = e && e.target;
	            var input = inputElem ||
	                (target && target.parentNode && target.parentNode.firstChild);
	            var event = createEvent("increment");
	            event.delta = delta;
	            input && input.dispatchEvent(event);
	        }
	        function build() {
	            var fragment = window.document.createDocumentFragment();
	            self.calendarContainer = createElement("div", "flatpickr-calendar");
	            self.calendarContainer.tabIndex = -1;
	            if (!self.config.noCalendar) {
	                fragment.appendChild(buildMonthNav());
	                self.innerContainer = createElement("div", "flatpickr-innerContainer");
	                if (self.config.weekNumbers) {
	                    var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
	                    self.innerContainer.appendChild(weekWrapper);
	                    self.weekNumbers = weekNumbers;
	                    self.weekWrapper = weekWrapper;
	                }
	                self.rContainer = createElement("div", "flatpickr-rContainer");
	                self.rContainer.appendChild(buildWeekdays());
	                if (!self.daysContainer) {
	                    self.daysContainer = createElement("div", "flatpickr-days");
	                    self.daysContainer.tabIndex = -1;
	                }
	                buildDays();
	                self.rContainer.appendChild(self.daysContainer);
	                self.innerContainer.appendChild(self.rContainer);
	                fragment.appendChild(self.innerContainer);
	            }
	            if (self.config.enableTime) {
	                fragment.appendChild(buildTime());
	            }
	            toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
	            toggleClass(self.calendarContainer, "animate", self.config.animate === true);
	            toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
	            self.calendarContainer.appendChild(fragment);
	            var customAppend = self.config.appendTo !== undefined &&
	                self.config.appendTo.nodeType !== undefined;
	            if (self.config.inline || self.config.static) {
	                self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
	                if (self.config.inline) {
	                    if (!customAppend && self.element.parentNode)
	                        self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
	                    else if (self.config.appendTo !== undefined)
	                        self.config.appendTo.appendChild(self.calendarContainer);
	                }
	                if (self.config.static) {
	                    var wrapper = createElement("div", "flatpickr-wrapper");
	                    if (self.element.parentNode)
	                        self.element.parentNode.insertBefore(wrapper, self.element);
	                    wrapper.appendChild(self.element);
	                    if (self.altInput)
	                        wrapper.appendChild(self.altInput);
	                    wrapper.appendChild(self.calendarContainer);
	                }
	            }
	            if (!self.config.static && !self.config.inline)
	                (self.config.appendTo !== undefined
	                    ? self.config.appendTo
	                    : window.document.body).appendChild(self.calendarContainer);
	        }
	        function createDay(className, date, dayNumber, i) {
	            var dateIsEnabled = isEnabled(date, true), dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
	            dayElement.dateObj = date;
	            dayElement.$i = i;
	            dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
	            if (className.indexOf("hidden") === -1 &&
	                compareDates(date, self.now) === 0) {
	                self.todayDateElem = dayElement;
	                dayElement.classList.add("today");
	                dayElement.setAttribute("aria-current", "date");
	            }
	            if (dateIsEnabled) {
	                dayElement.tabIndex = -1;
	                if (isDateSelected(date)) {
	                    dayElement.classList.add("selected");
	                    self.selectedDateElem = dayElement;
	                    if (self.config.mode === "range") {
	                        toggleClass(dayElement, "startRange", self.selectedDates[0] &&
	                            compareDates(date, self.selectedDates[0], true) === 0);
	                        toggleClass(dayElement, "endRange", self.selectedDates[1] &&
	                            compareDates(date, self.selectedDates[1], true) === 0);
	                        if (className === "nextMonthDay")
	                            dayElement.classList.add("inRange");
	                    }
	                }
	            }
	            else {
	                dayElement.classList.add("flatpickr-disabled");
	            }
	            if (self.config.mode === "range") {
	                if (isDateInRange(date) && !isDateSelected(date))
	                    dayElement.classList.add("inRange");
	            }
	            if (self.weekNumbers &&
	                self.config.showMonths === 1 &&
	                className !== "prevMonthDay" &&
	                dayNumber % 7 === 1) {
	                self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
	            }
	            triggerEvent("onDayCreate", dayElement);
	            return dayElement;
	        }
	        function focusOnDayElem(targetNode) {
	            targetNode.focus();
	            if (self.config.mode === "range")
	                onMouseOver(targetNode);
	        }
	        function getFirstAvailableDay(delta) {
	            var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
	            var endMonth = delta > 0 ? self.config.showMonths : -1;
	            for (var m = startMonth; m != endMonth; m += delta) {
	                var month = self.daysContainer.children[m];
	                var startIndex = delta > 0 ? 0 : month.children.length - 1;
	                var endIndex = delta > 0 ? month.children.length : -1;
	                for (var i = startIndex; i != endIndex; i += delta) {
	                    var c = month.children[i];
	                    if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
	                        return c;
	                }
	            }
	            return undefined;
	        }
	        function getNextAvailableDay(current, delta) {
	            var givenMonth = current.className.indexOf("Month") === -1
	                ? current.dateObj.getMonth()
	                : self.currentMonth;
	            var endMonth = delta > 0 ? self.config.showMonths : -1;
	            var loopDelta = delta > 0 ? 1 : -1;
	            for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
	                var month = self.daysContainer.children[m];
	                var startIndex = givenMonth - self.currentMonth === m
	                    ? current.$i + delta
	                    : delta < 0
	                        ? month.children.length - 1
	                        : 0;
	                var numMonthDays = month.children.length;
	                for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
	                    var c = month.children[i];
	                    if (c.className.indexOf("hidden") === -1 &&
	                        isEnabled(c.dateObj) &&
	                        Math.abs(current.$i - i) >= Math.abs(delta))
	                        return focusOnDayElem(c);
	                }
	            }
	            self.changeMonth(loopDelta);
	            focusOnDay(getFirstAvailableDay(loopDelta), 0);
	            return undefined;
	        }
	        function focusOnDay(current, offset) {
	            var dayFocused = isInView(document.activeElement || document.body);
	            var startElem = current !== undefined
	                ? current
	                : dayFocused
	                    ? document.activeElement
	                    : self.selectedDateElem !== undefined && isInView(self.selectedDateElem)
	                        ? self.selectedDateElem
	                        : self.todayDateElem !== undefined && isInView(self.todayDateElem)
	                            ? self.todayDateElem
	                            : getFirstAvailableDay(offset > 0 ? 1 : -1);
	            if (startElem === undefined)
	                return self._input.focus();
	            if (!dayFocused)
	                return focusOnDayElem(startElem);
	            getNextAvailableDay(startElem, offset);
	        }
	        function buildMonthDays(year, month) {
	            var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
	            var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12);
	            var daysInMonth = self.utils.getDaysInMonth(month), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
	            var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
	            // prepend days from the ending of previous month
	            for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
	                days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
	            }
	            // Start at 1 since there is no 0th day
	            for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
	                days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
	            }
	            // append days from the next month
	            for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth &&
	                (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
	                days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
	            }
	            //updateNavigationCurrentMonth();
	            var dayContainer = createElement("div", "dayContainer");
	            dayContainer.appendChild(days);
	            return dayContainer;
	        }
	        function buildDays() {
	            if (self.daysContainer === undefined) {
	                return;
	            }
	            clearNode(self.daysContainer);
	            // TODO: week numbers for each month
	            if (self.weekNumbers)
	                clearNode(self.weekNumbers);
	            var frag = document.createDocumentFragment();
	            for (var i = 0; i < self.config.showMonths; i++) {
	                var d = new Date(self.currentYear, self.currentMonth, 1);
	                d.setMonth(self.currentMonth + i);
	                frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
	            }
	            self.daysContainer.appendChild(frag);
	            self.days = self.daysContainer.firstChild;
	            if (self.config.mode === "range" && self.selectedDates.length === 1) {
	                onMouseOver();
	            }
	        }
	        function buildMonthSwitch() {
	            if (self.config.showMonths > 1 ||
	                self.config.monthSelectorType !== "dropdown")
	                return;
	            var shouldBuildMonth = function (month) {
	                if (self.config.minDate !== undefined &&
	                    self.currentYear === self.config.minDate.getFullYear() &&
	                    month < self.config.minDate.getMonth()) {
	                    return false;
	                }
	                return !(self.config.maxDate !== undefined &&
	                    self.currentYear === self.config.maxDate.getFullYear() &&
	                    month > self.config.maxDate.getMonth());
	            };
	            self.monthsDropdownContainer.tabIndex = -1;
	            self.monthsDropdownContainer.innerHTML = "";
	            for (var i = 0; i < 12; i++) {
	                if (!shouldBuildMonth(i))
	                    continue;
	                var month = createElement("option", "flatpickr-monthDropdown-month");
	                month.value = new Date(self.currentYear, i).getMonth().toString();
	                month.textContent = monthToStr(i, self.config.shorthandCurrentMonth, self.l10n);
	                month.tabIndex = -1;
	                if (self.currentMonth === i) {
	                    month.selected = true;
	                }
	                self.monthsDropdownContainer.appendChild(month);
	            }
	        }
	        function buildMonth() {
	            var container = createElement("div", "flatpickr-month");
	            var monthNavFragment = window.document.createDocumentFragment();
	            var monthElement;
	            if (self.config.showMonths > 1 ||
	                self.config.monthSelectorType === "static") {
	                monthElement = createElement("span", "cur-month");
	            }
	            else {
	                self.monthsDropdownContainer = createElement("select", "flatpickr-monthDropdown-months");
	                bind(self.monthsDropdownContainer, "change", function (e) {
	                    var target = e.target;
	                    var selectedMonth = parseInt(target.value, 10);
	                    self.changeMonth(selectedMonth - self.currentMonth);
	                    triggerEvent("onMonthChange");
	                });
	                buildMonthSwitch();
	                monthElement = self.monthsDropdownContainer;
	            }
	            var yearInput = createNumberInput("cur-year", { tabindex: "-1" });
	            var yearElement = yearInput.getElementsByTagName("input")[0];
	            yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
	            if (self.config.minDate) {
	                yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
	            }
	            if (self.config.maxDate) {
	                yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
	                yearElement.disabled =
	                    !!self.config.minDate &&
	                        self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
	            }
	            var currentMonth = createElement("div", "flatpickr-current-month");
	            currentMonth.appendChild(monthElement);
	            currentMonth.appendChild(yearInput);
	            monthNavFragment.appendChild(currentMonth);
	            container.appendChild(monthNavFragment);
	            return {
	                container: container,
	                yearElement: yearElement,
	                monthElement: monthElement
	            };
	        }
	        function buildMonths() {
	            clearNode(self.monthNav);
	            self.monthNav.appendChild(self.prevMonthNav);
	            if (self.config.showMonths) {
	                self.yearElements = [];
	                self.monthElements = [];
	            }
	            for (var m = self.config.showMonths; m--;) {
	                var month = buildMonth();
	                self.yearElements.push(month.yearElement);
	                self.monthElements.push(month.monthElement);
	                self.monthNav.appendChild(month.container);
	            }
	            self.monthNav.appendChild(self.nextMonthNav);
	        }
	        function buildMonthNav() {
	            self.monthNav = createElement("div", "flatpickr-months");
	            self.yearElements = [];
	            self.monthElements = [];
	            self.prevMonthNav = createElement("span", "flatpickr-prev-month");
	            self.prevMonthNav.innerHTML = self.config.prevArrow;
	            self.nextMonthNav = createElement("span", "flatpickr-next-month");
	            self.nextMonthNav.innerHTML = self.config.nextArrow;
	            buildMonths();
	            Object.defineProperty(self, "_hidePrevMonthArrow", {
	                get: function () { return self.__hidePrevMonthArrow; },
	                set: function (bool) {
	                    if (self.__hidePrevMonthArrow !== bool) {
	                        toggleClass(self.prevMonthNav, "flatpickr-disabled", bool);
	                        self.__hidePrevMonthArrow = bool;
	                    }
	                }
	            });
	            Object.defineProperty(self, "_hideNextMonthArrow", {
	                get: function () { return self.__hideNextMonthArrow; },
	                set: function (bool) {
	                    if (self.__hideNextMonthArrow !== bool) {
	                        toggleClass(self.nextMonthNav, "flatpickr-disabled", bool);
	                        self.__hideNextMonthArrow = bool;
	                    }
	                }
	            });
	            self.currentYearElement = self.yearElements[0];
	            updateNavigationCurrentMonth();
	            return self.monthNav;
	        }
	        function buildTime() {
	            self.calendarContainer.classList.add("hasTime");
	            if (self.config.noCalendar)
	                self.calendarContainer.classList.add("noCalendar");
	            self.timeContainer = createElement("div", "flatpickr-time");
	            self.timeContainer.tabIndex = -1;
	            var separator = createElement("span", "flatpickr-time-separator", ":");
	            var hourInput = createNumberInput("flatpickr-hour", {
	                "aria-label": self.l10n.hourAriaLabel
	            });
	            self.hourElement = hourInput.getElementsByTagName("input")[0];
	            var minuteInput = createNumberInput("flatpickr-minute", {
	                "aria-label": self.l10n.minuteAriaLabel
	            });
	            self.minuteElement = minuteInput.getElementsByTagName("input")[0];
	            self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
	            self.hourElement.value = pad(self.latestSelectedDateObj
	                ? self.latestSelectedDateObj.getHours()
	                : self.config.time_24hr
	                    ? self.config.defaultHour
	                    : military2ampm(self.config.defaultHour));
	            self.minuteElement.value = pad(self.latestSelectedDateObj
	                ? self.latestSelectedDateObj.getMinutes()
	                : self.config.defaultMinute);
	            self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
	            self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
	            self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
	            self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
	            self.minuteElement.setAttribute("min", "0");
	            self.minuteElement.setAttribute("max", "59");
	            self.timeContainer.appendChild(hourInput);
	            self.timeContainer.appendChild(separator);
	            self.timeContainer.appendChild(minuteInput);
	            if (self.config.time_24hr)
	                self.timeContainer.classList.add("time24hr");
	            if (self.config.enableSeconds) {
	                self.timeContainer.classList.add("hasSeconds");
	                var secondInput = createNumberInput("flatpickr-second");
	                self.secondElement = secondInput.getElementsByTagName("input")[0];
	                self.secondElement.value = pad(self.latestSelectedDateObj
	                    ? self.latestSelectedDateObj.getSeconds()
	                    : self.config.defaultSeconds);
	                self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
	                self.secondElement.setAttribute("min", "0");
	                self.secondElement.setAttribute("max", "59");
	                self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
	                self.timeContainer.appendChild(secondInput);
	            }
	            if (!self.config.time_24hr) {
	                // add self.amPM if appropriate
	                self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj
	                    ? self.hourElement.value
	                    : self.config.defaultHour) > 11)]);
	                self.amPM.title = self.l10n.toggleTitle;
	                self.amPM.tabIndex = -1;
	                self.timeContainer.appendChild(self.amPM);
	            }
	            return self.timeContainer;
	        }
	        function buildWeekdays() {
	            if (!self.weekdayContainer)
	                self.weekdayContainer = createElement("div", "flatpickr-weekdays");
	            else
	                clearNode(self.weekdayContainer);
	            for (var i = self.config.showMonths; i--;) {
	                var container = createElement("div", "flatpickr-weekdaycontainer");
	                self.weekdayContainer.appendChild(container);
	            }
	            updateWeekdays();
	            return self.weekdayContainer;
	        }
	        function updateWeekdays() {
	            if (!self.weekdayContainer) {
	                return;
	            }
	            var firstDayOfWeek = self.l10n.firstDayOfWeek;
	            var weekdays = self.l10n.weekdays.shorthand.slice();
	            if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
	                weekdays = weekdays.splice(firstDayOfWeek, weekdays.length).concat(weekdays.splice(0, firstDayOfWeek));
	            }
	            for (var i = self.config.showMonths; i--;) {
	                self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
	            }
	        }
	        /* istanbul ignore next */
	        function buildWeeks() {
	            self.calendarContainer.classList.add("hasWeeks");
	            var weekWrapper = createElement("div", "flatpickr-weekwrapper");
	            weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
	            var weekNumbers = createElement("div", "flatpickr-weeks");
	            weekWrapper.appendChild(weekNumbers);
	            return {
	                weekWrapper: weekWrapper,
	                weekNumbers: weekNumbers
	            };
	        }
	        function changeMonth(value, isOffset) {
	            if (isOffset === void 0) { isOffset = true; }
	            var delta = isOffset ? value : value - self.currentMonth;
	            if ((delta < 0 && self._hidePrevMonthArrow === true) ||
	                (delta > 0 && self._hideNextMonthArrow === true))
	                return;
	            self.currentMonth += delta;
	            if (self.currentMonth < 0 || self.currentMonth > 11) {
	                self.currentYear += self.currentMonth > 11 ? 1 : -1;
	                self.currentMonth = (self.currentMonth + 12) % 12;
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	            buildDays();
	            triggerEvent("onMonthChange");
	            updateNavigationCurrentMonth();
	        }
	        function clear(triggerChangeEvent, toInitial) {
	            if (triggerChangeEvent === void 0) { triggerChangeEvent = true; }
	            if (toInitial === void 0) { toInitial = true; }
	            self.input.value = "";
	            if (self.altInput !== undefined)
	                self.altInput.value = "";
	            if (self.mobileInput !== undefined)
	                self.mobileInput.value = "";
	            self.selectedDates = [];
	            self.latestSelectedDateObj = undefined;
	            if (toInitial === true) {
	                self.currentYear = self._initialDate.getFullYear();
	                self.currentMonth = self._initialDate.getMonth();
	            }
	            self.showTimeInput = false;
	            if (self.config.enableTime === true) {
	                setDefaultHours();
	            }
	            self.redraw();
	            if (triggerChangeEvent)
	                // triggerChangeEvent is true (default) or an Event
	                triggerEvent("onChange");
	        }
	        function close() {
	            self.isOpen = false;
	            if (!self.isMobile) {
	                if (self.calendarContainer !== undefined) {
	                    self.calendarContainer.classList.remove("open");
	                }
	                if (self._input !== undefined) {
	                    self._input.classList.remove("active");
	                }
	            }
	            triggerEvent("onClose");
	        }
	        function destroy() {
	            if (self.config !== undefined)
	                triggerEvent("onDestroy");
	            for (var i = self._handlers.length; i--;) {
	                var h = self._handlers[i];
	                h.element.removeEventListener(h.event, h.handler, h.options);
	            }
	            self._handlers = [];
	            if (self.mobileInput) {
	                if (self.mobileInput.parentNode)
	                    self.mobileInput.parentNode.removeChild(self.mobileInput);
	                self.mobileInput = undefined;
	            }
	            else if (self.calendarContainer && self.calendarContainer.parentNode) {
	                if (self.config.static && self.calendarContainer.parentNode) {
	                    var wrapper = self.calendarContainer.parentNode;
	                    wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
	                    if (wrapper.parentNode) {
	                        while (wrapper.firstChild)
	                            wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
	                        wrapper.parentNode.removeChild(wrapper);
	                    }
	                }
	                else
	                    self.calendarContainer.parentNode.removeChild(self.calendarContainer);
	            }
	            if (self.altInput) {
	                self.input.type = "text";
	                if (self.altInput.parentNode)
	                    self.altInput.parentNode.removeChild(self.altInput);
	                delete self.altInput;
	            }
	            if (self.input) {
	                self.input.type = self.input._type;
	                self.input.classList.remove("flatpickr-input");
	                self.input.removeAttribute("readonly");
	                self.input.value = "";
	            }
	            [
	                "_showTimeInput",
	                "latestSelectedDateObj",
	                "_hideNextMonthArrow",
	                "_hidePrevMonthArrow",
	                "__hideNextMonthArrow",
	                "__hidePrevMonthArrow",
	                "isMobile",
	                "isOpen",
	                "selectedDateElem",
	                "minDateHasTime",
	                "maxDateHasTime",
	                "days",
	                "daysContainer",
	                "_input",
	                "_positionElement",
	                "innerContainer",
	                "rContainer",
	                "monthNav",
	                "todayDateElem",
	                "calendarContainer",
	                "weekdayContainer",
	                "prevMonthNav",
	                "nextMonthNav",
	                "monthsDropdownContainer",
	                "currentMonthElement",
	                "currentYearElement",
	                "navigationCurrentMonth",
	                "selectedDateElem",
	                "config",
	            ].forEach(function (k) {
	                try {
	                    delete self[k];
	                }
	                catch (_) { }
	            });
	        }
	        function isCalendarElem(elem) {
	            if (self.config.appendTo && self.config.appendTo.contains(elem))
	                return true;
	            return self.calendarContainer.contains(elem);
	        }
	        function documentClick(e) {
	            if (self.isOpen && !self.config.inline) {
	                var eventTarget_1 = getEventTarget(e);
	                var isCalendarElement = isCalendarElem(eventTarget_1);
	                var isInput = eventTarget_1 === self.input ||
	                    eventTarget_1 === self.altInput ||
	                    self.element.contains(eventTarget_1) ||
	                    // web components
	                    // e.path is not present in all browsers. circumventing typechecks
	                    (e.path &&
	                        e.path.indexOf &&
	                        (~e.path.indexOf(self.input) ||
	                            ~e.path.indexOf(self.altInput)));
	                var lostFocus = e.type === "blur"
	                    ? isInput &&
	                        e.relatedTarget &&
	                        !isCalendarElem(e.relatedTarget)
	                    : !isInput &&
	                        !isCalendarElement &&
	                        !isCalendarElem(e.relatedTarget);
	                var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
	                    return elem.contains(eventTarget_1);
	                });
	                if (lostFocus && isIgnored) {
	                    if (self.timeContainer !== undefined &&
	                        self.minuteElement !== undefined &&
	                        self.hourElement !== undefined) {
	                        updateTime();
	                    }
	                    self.close();
	                    if (self.config.mode === "range" && self.selectedDates.length === 1) {
	                        self.clear(false);
	                        self.redraw();
	                    }
	                }
	            }
	        }
	        function changeYear(newYear) {
	            if (!newYear ||
	                (self.config.minDate && newYear < self.config.minDate.getFullYear()) ||
	                (self.config.maxDate && newYear > self.config.maxDate.getFullYear()))
	                return;
	            var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
	            self.currentYear = newYearNum || self.currentYear;
	            if (self.config.maxDate &&
	                self.currentYear === self.config.maxDate.getFullYear()) {
	                self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
	            }
	            else if (self.config.minDate &&
	                self.currentYear === self.config.minDate.getFullYear()) {
	                self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
	            }
	            if (isNewYear) {
	                self.redraw();
	                triggerEvent("onYearChange");
	                buildMonthSwitch();
	            }
	        }
	        function isEnabled(date, timeless) {
	            if (timeless === void 0) { timeless = true; }
	            var dateToCheck = self.parseDate(date, undefined, timeless); // timeless
	            if ((self.config.minDate &&
	                dateToCheck &&
	                compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) ||
	                (self.config.maxDate &&
	                    dateToCheck &&
	                    compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0))
	                return false;
	            if (self.config.enable.length === 0 && self.config.disable.length === 0)
	                return true;
	            if (dateToCheck === undefined)
	                return false;
	            var bool = self.config.enable.length > 0, array = bool ? self.config.enable : self.config.disable;
	            for (var i = 0, d = void 0; i < array.length; i++) {
	                d = array[i];
	                if (typeof d === "function" &&
	                    d(dateToCheck) // disabled by function
	                )
	                    return bool;
	                else if (d instanceof Date &&
	                    dateToCheck !== undefined &&
	                    d.getTime() === dateToCheck.getTime())
	                    // disabled by date
	                    return bool;
	                else if (typeof d === "string" && dateToCheck !== undefined) {
	                    // disabled by date string
	                    var parsed = self.parseDate(d, undefined, true);
	                    return parsed && parsed.getTime() === dateToCheck.getTime()
	                        ? bool
	                        : !bool;
	                }
	                else if (
	                // disabled by range
	                typeof d === "object" &&
	                    dateToCheck !== undefined &&
	                    d.from &&
	                    d.to &&
	                    dateToCheck.getTime() >= d.from.getTime() &&
	                    dateToCheck.getTime() <= d.to.getTime())
	                    return bool;
	            }
	            return !bool;
	        }
	        function isInView(elem) {
	            if (self.daysContainer !== undefined)
	                return (elem.className.indexOf("hidden") === -1 &&
	                    self.daysContainer.contains(elem));
	            return false;
	        }
	        function onKeyDown(e) {
	            // e.key                      e.keyCode
	            // "Backspace"                        8
	            // "Tab"                              9
	            // "Enter"                           13
	            // "Escape"     (IE "Esc")           27
	            // "ArrowLeft"  (IE "Left")          37
	            // "ArrowUp"    (IE "Up")            38
	            // "ArrowRight" (IE "Right")         39
	            // "ArrowDown"  (IE "Down")          40
	            // "Delete"     (IE "Del")           46
	            var isInput = e.target === self._input;
	            var allowInput = self.config.allowInput;
	            var allowKeydown = self.isOpen && (!allowInput || !isInput);
	            var allowInlineKeydown = self.config.inline && isInput && !allowInput;
	            if (e.keyCode === 13 && isInput) {
	                if (allowInput) {
	                    self.setDate(self._input.value, true, e.target === self.altInput
	                        ? self.config.altFormat
	                        : self.config.dateFormat);
	                    return e.target.blur();
	                }
	                else {
	                    self.open();
	                }
	            }
	            else if (isCalendarElem(e.target) ||
	                allowKeydown ||
	                allowInlineKeydown) {
	                var isTimeObj = !!self.timeContainer &&
	                    self.timeContainer.contains(e.target);
	                switch (e.keyCode) {
	                    case 13:
	                        if (isTimeObj) {
	                            e.preventDefault();
	                            updateTime();
	                            focusAndClose();
	                        }
	                        else
	                            selectDate(e);
	                        break;
	                    case 27: // escape
	                        e.preventDefault();
	                        focusAndClose();
	                        break;
	                    case 8:
	                    case 46:
	                        if (isInput && !self.config.allowInput) {
	                            e.preventDefault();
	                            self.clear();
	                        }
	                        break;
	                    case 37:
	                    case 39:
	                        if (!isTimeObj && !isInput) {
	                            e.preventDefault();
	                            if (self.daysContainer !== undefined &&
	                                (allowInput === false ||
	                                    (document.activeElement && isInView(document.activeElement)))) {
	                                var delta_1 = e.keyCode === 39 ? 1 : -1;
	                                if (!e.ctrlKey)
	                                    focusOnDay(undefined, delta_1);
	                                else {
	                                    e.stopPropagation();
	                                    changeMonth(delta_1);
	                                    focusOnDay(getFirstAvailableDay(1), 0);
	                                }
	                            }
	                        }
	                        else if (self.hourElement)
	                            self.hourElement.focus();
	                        break;
	                    case 38:
	                    case 40:
	                        e.preventDefault();
	                        var delta = e.keyCode === 40 ? 1 : -1;
	                        if ((self.daysContainer && e.target.$i !== undefined) ||
	                            e.target === self.input ||
	                            e.target === self.altInput) {
	                            if (e.ctrlKey) {
	                                e.stopPropagation();
	                                changeYear(self.currentYear - delta);
	                                focusOnDay(getFirstAvailableDay(1), 0);
	                            }
	                            else if (!isTimeObj)
	                                focusOnDay(undefined, delta * 7);
	                        }
	                        else if (e.target === self.currentYearElement) {
	                            changeYear(self.currentYear - delta);
	                        }
	                        else if (self.config.enableTime) {
	                            if (!isTimeObj && self.hourElement)
	                                self.hourElement.focus();
	                            updateTime(e);
	                            self._debouncedChange();
	                        }
	                        break;
	                    case 9:
	                        if (isTimeObj) {
	                            var elems = [
	                                self.hourElement,
	                                self.minuteElement,
	                                self.secondElement,
	                                self.amPM,
	                            ]
	                                .concat(self.pluginElements)
	                                .filter(function (x) { return x; });
	                            var i = elems.indexOf(e.target);
	                            if (i !== -1) {
	                                var target = elems[i + (e.shiftKey ? -1 : 1)];
	                                e.preventDefault();
	                                (target || self._input).focus();
	                            }
	                        }
	                        else if (!self.config.noCalendar &&
	                            self.daysContainer &&
	                            self.daysContainer.contains(e.target) &&
	                            e.shiftKey) {
	                            e.preventDefault();
	                            self._input.focus();
	                        }
	                        break;
	                    default:
	                        break;
	                }
	            }
	            if (self.amPM !== undefined && e.target === self.amPM) {
	                switch (e.key) {
	                    case self.l10n.amPM[0].charAt(0):
	                    case self.l10n.amPM[0].charAt(0).toLowerCase():
	                        self.amPM.textContent = self.l10n.amPM[0];
	                        setHoursFromInputs();
	                        updateValue();
	                        break;
	                    case self.l10n.amPM[1].charAt(0):
	                    case self.l10n.amPM[1].charAt(0).toLowerCase():
	                        self.amPM.textContent = self.l10n.amPM[1];
	                        setHoursFromInputs();
	                        updateValue();
	                        break;
	                }
	            }
	            if (isInput || isCalendarElem(e.target)) {
	                triggerEvent("onKeyDown", e);
	            }
	        }
	        function onMouseOver(elem) {
	            if (self.selectedDates.length !== 1 ||
	                (elem &&
	                    (!elem.classList.contains("flatpickr-day") ||
	                        elem.classList.contains("flatpickr-disabled"))))
	                return;
	            var hoverDate = elem
	                ? elem.dateObj.getTime()
	                : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
	            var containsDisabled = false;
	            var minRange = 0, maxRange = 0;
	            for (var t = rangeStartDate; t < rangeEndDate; t += duration.DAY) {
	                if (!isEnabled(new Date(t), true)) {
	                    containsDisabled =
	                        containsDisabled || (t > rangeStartDate && t < rangeEndDate);
	                    if (t < initialDate && (!minRange || t > minRange))
	                        minRange = t;
	                    else if (t > initialDate && (!maxRange || t < maxRange))
	                        maxRange = t;
	                }
	            }
	            for (var m = 0; m < self.config.showMonths; m++) {
	                var month = self.daysContainer.children[m];
	                var _loop_1 = function (i, l) {
	                    var dayElem = month.children[i], date = dayElem.dateObj;
	                    var timestamp = date.getTime();
	                    var outOfRange = (minRange > 0 && timestamp < minRange) ||
	                        (maxRange > 0 && timestamp > maxRange);
	                    if (outOfRange) {
	                        dayElem.classList.add("notAllowed");
	                        ["inRange", "startRange", "endRange"].forEach(function (c) {
	                            dayElem.classList.remove(c);
	                        });
	                        return "continue";
	                    }
	                    else if (containsDisabled && !outOfRange)
	                        return "continue";
	                    ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
	                        dayElem.classList.remove(c);
	                    });
	                    if (elem !== undefined) {
	                        elem.classList.add(hoverDate <= self.selectedDates[0].getTime()
	                            ? "startRange"
	                            : "endRange");
	                        if (initialDate < hoverDate && timestamp === initialDate)
	                            dayElem.classList.add("startRange");
	                        else if (initialDate > hoverDate && timestamp === initialDate)
	                            dayElem.classList.add("endRange");
	                        if (timestamp >= minRange &&
	                            (maxRange === 0 || timestamp <= maxRange) &&
	                            isBetween(timestamp, initialDate, hoverDate))
	                            dayElem.classList.add("inRange");
	                    }
	                };
	                for (var i = 0, l = month.children.length; i < l; i++) {
	                    _loop_1(i, l);
	                }
	            }
	        }
	        function onResize() {
	            if (self.isOpen && !self.config.static && !self.config.inline)
	                positionCalendar();
	        }
	        function setDefaultTime() {
	            self.setDate(self.config.minDate !== undefined
	                ? new Date(self.config.minDate.getTime())
	                : new Date(), true);
	            setDefaultHours();
	            updateValue();
	        }
	        function open(e, positionElement) {
	            if (positionElement === void 0) { positionElement = self._positionElement; }
	            if (self.isMobile === true) {
	                if (e) {
	                    e.preventDefault();
	                    e.target && e.target.blur();
	                }
	                if (self.mobileInput !== undefined) {
	                    self.mobileInput.focus();
	                    self.mobileInput.click();
	                }
	                triggerEvent("onOpen");
	                return;
	            }
	            if (self._input.disabled || self.config.inline)
	                return;
	            var wasOpen = self.isOpen;
	            self.isOpen = true;
	            if (!wasOpen) {
	                self.calendarContainer.classList.add("open");
	                self._input.classList.add("active");
	                triggerEvent("onOpen");
	                positionCalendar(positionElement);
	            }
	            if (self.config.enableTime === true && self.config.noCalendar === true) {
	                if (self.selectedDates.length === 0) {
	                    setDefaultTime();
	                }
	                if (self.config.allowInput === false &&
	                    (e === undefined ||
	                        !self.timeContainer.contains(e.relatedTarget))) {
	                    setTimeout(function () { return self.hourElement.select(); }, 50);
	                }
	            }
	        }
	        function minMaxDateSetter(type) {
	            return function (date) {
	                var dateObj = (self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat));
	                var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
	                if (dateObj !== undefined) {
	                    self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] =
	                        dateObj.getHours() > 0 ||
	                            dateObj.getMinutes() > 0 ||
	                            dateObj.getSeconds() > 0;
	                }
	                if (self.selectedDates) {
	                    self.selectedDates = self.selectedDates.filter(function (d) { return isEnabled(d); });
	                    if (!self.selectedDates.length && type === "min")
	                        setHoursFromDate(dateObj);
	                    updateValue();
	                }
	                if (self.daysContainer) {
	                    redraw();
	                    if (dateObj !== undefined)
	                        self.currentYearElement[type] = dateObj.getFullYear().toString();
	                    else
	                        self.currentYearElement.removeAttribute(type);
	                    self.currentYearElement.disabled =
	                        !!inverseDateObj &&
	                            dateObj !== undefined &&
	                            inverseDateObj.getFullYear() === dateObj.getFullYear();
	                }
	            };
	        }
	        function parseConfig() {
	            var boolOpts = [
	                "wrap",
	                "weekNumbers",
	                "allowInput",
	                "clickOpens",
	                "time_24hr",
	                "enableTime",
	                "noCalendar",
	                "altInput",
	                "shorthandCurrentMonth",
	                "inline",
	                "static",
	                "enableSeconds",
	                "disableMobile",
	            ];
	            var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
	            var formats = {};
	            self.config.parseDate = userConfig.parseDate;
	            self.config.formatDate = userConfig.formatDate;
	            Object.defineProperty(self.config, "enable", {
	                get: function () { return self.config._enable; },
	                set: function (dates) {
	                    self.config._enable = parseDateRules(dates);
	                }
	            });
	            Object.defineProperty(self.config, "disable", {
	                get: function () { return self.config._disable; },
	                set: function (dates) {
	                    self.config._disable = parseDateRules(dates);
	                }
	            });
	            var timeMode = userConfig.mode === "time";
	            if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
	                var defaultDateFormat = flatpickr.defaultConfig.dateFormat || defaults.dateFormat;
	                formats.dateFormat =
	                    userConfig.noCalendar || timeMode
	                        ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
	                        : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
	            }
	            if (userConfig.altInput &&
	                (userConfig.enableTime || timeMode) &&
	                !userConfig.altFormat) {
	                var defaultAltFormat = flatpickr.defaultConfig.altFormat || defaults.altFormat;
	                formats.altFormat =
	                    userConfig.noCalendar || timeMode
	                        ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K")
	                        : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
	            }
	            if (!userConfig.altInputClass) {
	                self.config.altInputClass =
	                    self.input.className + " " + self.config.altInputClass;
	            }
	            Object.defineProperty(self.config, "minDate", {
	                get: function () { return self.config._minDate; },
	                set: minMaxDateSetter("min")
	            });
	            Object.defineProperty(self.config, "maxDate", {
	                get: function () { return self.config._maxDate; },
	                set: minMaxDateSetter("max")
	            });
	            var minMaxTimeSetter = function (type) { return function (val) {
	                self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
	            }; };
	            Object.defineProperty(self.config, "minTime", {
	                get: function () { return self.config._minTime; },
	                set: minMaxTimeSetter("min")
	            });
	            Object.defineProperty(self.config, "maxTime", {
	                get: function () { return self.config._maxTime; },
	                set: minMaxTimeSetter("max")
	            });
	            if (userConfig.mode === "time") {
	                self.config.noCalendar = true;
	                self.config.enableTime = true;
	            }
	            Object.assign(self.config, formats, userConfig);
	            for (var i = 0; i < boolOpts.length; i++)
	                self.config[boolOpts[i]] =
	                    self.config[boolOpts[i]] === true ||
	                        self.config[boolOpts[i]] === "true";
	            HOOKS.filter(function (hook) { return self.config[hook] !== undefined; }).forEach(function (hook) {
	                self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
	            });
	            self.isMobile =
	                !self.config.disableMobile &&
	                    !self.config.inline &&
	                    self.config.mode === "single" &&
	                    !self.config.disable.length &&
	                    !self.config.enable.length &&
	                    !self.config.weekNumbers &&
	                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	            for (var i = 0; i < self.config.plugins.length; i++) {
	                var pluginConf = self.config.plugins[i](self) || {};
	                for (var key in pluginConf) {
	                    if (HOOKS.indexOf(key) > -1) {
	                        self.config[key] = arrayify(pluginConf[key])
	                            .map(bindToInstance)
	                            .concat(self.config[key]);
	                    }
	                    else if (typeof userConfig[key] === "undefined")
	                        self.config[key] = pluginConf[key];
	                }
	            }
	            triggerEvent("onParseConfig");
	        }
	        function setupLocale() {
	            if (typeof self.config.locale !== "object" &&
	                typeof flatpickr.l10ns[self.config.locale] === "undefined")
	                self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
	            self.l10n = __assign({}, flatpickr.l10ns["default"], (typeof self.config.locale === "object"
	                ? self.config.locale
	                : self.config.locale !== "default"
	                    ? flatpickr.l10ns[self.config.locale]
	                    : undefined));
	            tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
	            var userConfig = __assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
	            if (userConfig.time_24hr === undefined &&
	                flatpickr.defaultConfig.time_24hr === undefined) {
	                self.config.time_24hr = self.l10n.time_24hr;
	            }
	            self.formatDate = createDateFormatter(self);
	            self.parseDate = createDateParser({ config: self.config, l10n: self.l10n });
	        }
	        function positionCalendar(customPositionElement) {
	            if (self.calendarContainer === undefined)
	                return;
	            triggerEvent("onPreCalendarPosition");
	            var positionElement = customPositionElement || self._positionElement;
	            var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, (function (acc, child) { return acc + child.offsetHeight; }), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" ||
	                (configPosVertical !== "below" &&
	                    distanceFromBottom < calendarHeight &&
	                    inputBounds.top > calendarHeight);
	            var top = window.pageYOffset +
	                inputBounds.top +
	                (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
	            toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
	            toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
	            if (self.config.inline)
	                return;
	            var left = window.pageXOffset +
	                inputBounds.left -
	                (configPosHorizontal != null && configPosHorizontal === "center"
	                    ? (calendarWidth - inputBounds.width) / 2
	                    : 0);
	            var right = window.document.body.offsetWidth - (window.pageXOffset + inputBounds.right);
	            var rightMost = left + calendarWidth > window.document.body.offsetWidth;
	            var centerMost = right + calendarWidth > window.document.body.offsetWidth;
	            toggleClass(self.calendarContainer, "rightMost", rightMost);
	            if (self.config.static)
	                return;
	            self.calendarContainer.style.top = top + "px";
	            if (!rightMost) {
	                self.calendarContainer.style.left = left + "px";
	                self.calendarContainer.style.right = "auto";
	            }
	            else if (!centerMost) {
	                self.calendarContainer.style.left = "auto";
	                self.calendarContainer.style.right = right + "px";
	            }
	            else {
	                var doc = document.styleSheets[0];
	                // some testing environments don't have css support
	                if (doc === undefined)
	                    return;
	                var bodyWidth = window.document.body.offsetWidth;
	                var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
	                var centerBefore = ".flatpickr-calendar.centerMost:before";
	                var centerAfter = ".flatpickr-calendar.centerMost:after";
	                var centerIndex = doc.cssRules.length;
	                var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
	                toggleClass(self.calendarContainer, "rightMost", false);
	                toggleClass(self.calendarContainer, "centerMost", true);
	                doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
	                self.calendarContainer.style.left = centerLeft + "px";
	                self.calendarContainer.style.right = "auto";
	            }
	        }
	        function redraw() {
	            if (self.config.noCalendar || self.isMobile)
	                return;
	            updateNavigationCurrentMonth();
	            buildDays();
	        }
	        function focusAndClose() {
	            self._input.focus();
	            if (window.navigator.userAgent.indexOf("MSIE") !== -1 ||
	                navigator.msMaxTouchPoints !== undefined) {
	                // hack - bugs in the way IE handles focus keeps the calendar open
	                setTimeout(self.close, 0);
	            }
	            else {
	                self.close();
	            }
	        }
	        function selectDate(e) {
	            e.preventDefault();
	            e.stopPropagation();
	            var isSelectable = function (day) {
	                return day.classList &&
	                    day.classList.contains("flatpickr-day") &&
	                    !day.classList.contains("flatpickr-disabled") &&
	                    !day.classList.contains("notAllowed");
	            };
	            var t = findParent(e.target, isSelectable);
	            if (t === undefined)
	                return;
	            var target = t;
	            var selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
	            var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth ||
	                selectedDate.getMonth() >
	                    self.currentMonth + self.config.showMonths - 1) &&
	                self.config.mode !== "range";
	            self.selectedDateElem = target;
	            if (self.config.mode === "single")
	                self.selectedDates = [selectedDate];
	            else if (self.config.mode === "multiple") {
	                var selectedIndex = isDateSelected(selectedDate);
	                if (selectedIndex)
	                    self.selectedDates.splice(parseInt(selectedIndex), 1);
	                else
	                    self.selectedDates.push(selectedDate);
	            }
	            else if (self.config.mode === "range") {
	                if (self.selectedDates.length === 2) {
	                    self.clear(false, false);
	                }
	                self.latestSelectedDateObj = selectedDate;
	                self.selectedDates.push(selectedDate);
	                // unless selecting same date twice, sort ascendingly
	                if (compareDates(selectedDate, self.selectedDates[0], true) !== 0)
	                    self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
	            }
	            setHoursFromInputs();
	            if (shouldChangeMonth) {
	                var isNewYear = self.currentYear !== selectedDate.getFullYear();
	                self.currentYear = selectedDate.getFullYear();
	                self.currentMonth = selectedDate.getMonth();
	                if (isNewYear) {
	                    triggerEvent("onYearChange");
	                    buildMonthSwitch();
	                }
	                triggerEvent("onMonthChange");
	            }
	            updateNavigationCurrentMonth();
	            buildDays();
	            updateValue();
	            if (self.config.enableTime)
	                setTimeout(function () { return (self.showTimeInput = true); }, 50);
	            // maintain focus
	            if (!shouldChangeMonth &&
	                self.config.mode !== "range" &&
	                self.config.showMonths === 1)
	                focusOnDayElem(target);
	            else if (self.selectedDateElem !== undefined &&
	                self.hourElement === undefined) {
	                self.selectedDateElem && self.selectedDateElem.focus();
	            }
	            if (self.hourElement !== undefined)
	                self.hourElement !== undefined && self.hourElement.focus();
	            if (self.config.closeOnSelect) {
	                var single = self.config.mode === "single" && !self.config.enableTime;
	                var range = self.config.mode === "range" &&
	                    self.selectedDates.length === 2 &&
	                    !self.config.enableTime;
	                if (single || range) {
	                    focusAndClose();
	                }
	            }
	            triggerChange();
	        }
	        var CALLBACKS = {
	            locale: [setupLocale, updateWeekdays],
	            showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
	            minDate: [jumpToDate],
	            maxDate: [jumpToDate]
	        };
	        function set(option, value) {
	            if (option !== null && typeof option === "object") {
	                Object.assign(self.config, option);
	                for (var key in option) {
	                    if (CALLBACKS[key] !== undefined)
	                        CALLBACKS[key].forEach(function (x) { return x(); });
	                }
	            }
	            else {
	                self.config[option] = value;
	                if (CALLBACKS[option] !== undefined)
	                    CALLBACKS[option].forEach(function (x) { return x(); });
	                else if (HOOKS.indexOf(option) > -1)
	                    self.config[option] = arrayify(value);
	            }
	            self.redraw();
	            updateValue(false);
	        }
	        function setSelectedDate(inputDate, format) {
	            var dates = [];
	            if (inputDate instanceof Array)
	                dates = inputDate.map(function (d) { return self.parseDate(d, format); });
	            else if (inputDate instanceof Date || typeof inputDate === "number")
	                dates = [self.parseDate(inputDate, format)];
	            else if (typeof inputDate === "string") {
	                switch (self.config.mode) {
	                    case "single":
	                    case "time":
	                        dates = [self.parseDate(inputDate, format)];
	                        break;
	                    case "multiple":
	                        dates = inputDate
	                            .split(self.config.conjunction)
	                            .map(function (date) { return self.parseDate(date, format); });
	                        break;
	                    case "range":
	                        dates = inputDate
	                            .split(self.l10n.rangeSeparator)
	                            .map(function (date) { return self.parseDate(date, format); });
	                        break;
	                    default:
	                        break;
	                }
	            }
	            else
	                self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
	            self.selectedDates = dates.filter(function (d) { return d instanceof Date && isEnabled(d, false); });
	            if (self.config.mode === "range")
	                self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
	        }
	        function setDate(date, triggerChange, format) {
	            if (triggerChange === void 0) { triggerChange = false; }
	            if (format === void 0) { format = self.config.dateFormat; }
	            if ((date !== 0 && !date) || (date instanceof Array && date.length === 0))
	                return self.clear(triggerChange);
	            setSelectedDate(date, format);
	            self.showTimeInput = self.selectedDates.length > 0;
	            self.latestSelectedDateObj =
	                self.selectedDates[self.selectedDates.length - 1];
	            self.redraw();
	            jumpToDate();
	            setHoursFromDate();
	            if (self.selectedDates.length === 0) {
	                self.clear(false);
	            }
	            updateValue(triggerChange);
	            if (triggerChange)
	                triggerEvent("onChange");
	        }
	        function parseDateRules(arr) {
	            return arr
	                .slice()
	                .map(function (rule) {
	                if (typeof rule === "string" ||
	                    typeof rule === "number" ||
	                    rule instanceof Date) {
	                    return self.parseDate(rule, undefined, true);
	                }
	                else if (rule &&
	                    typeof rule === "object" &&
	                    rule.from &&
	                    rule.to)
	                    return {
	                        from: self.parseDate(rule.from, undefined),
	                        to: self.parseDate(rule.to, undefined)
	                    };
	                return rule;
	            })
	                .filter(function (x) { return x; }); // remove falsy values
	        }
	        function setupDates() {
	            self.selectedDates = [];
	            self.now = self.parseDate(self.config.now) || new Date();
	            // Workaround IE11 setting placeholder as the input's value
	            var preloadedDate = self.config.defaultDate ||
	                ((self.input.nodeName === "INPUT" ||
	                    self.input.nodeName === "TEXTAREA") &&
	                    self.input.placeholder &&
	                    self.input.value === self.input.placeholder
	                    ? null
	                    : self.input.value);
	            if (preloadedDate)
	                setSelectedDate(preloadedDate, self.config.dateFormat);
	            self._initialDate =
	                self.selectedDates.length > 0
	                    ? self.selectedDates[0]
	                    : self.config.minDate &&
	                        self.config.minDate.getTime() > self.now.getTime()
	                        ? self.config.minDate
	                        : self.config.maxDate &&
	                            self.config.maxDate.getTime() < self.now.getTime()
	                            ? self.config.maxDate
	                            : self.now;
	            self.currentYear = self._initialDate.getFullYear();
	            self.currentMonth = self._initialDate.getMonth();
	            if (self.selectedDates.length > 0)
	                self.latestSelectedDateObj = self.selectedDates[0];
	            if (self.config.minTime !== undefined)
	                self.config.minTime = self.parseDate(self.config.minTime, "H:i");
	            if (self.config.maxTime !== undefined)
	                self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
	            self.minDateHasTime =
	                !!self.config.minDate &&
	                    (self.config.minDate.getHours() > 0 ||
	                        self.config.minDate.getMinutes() > 0 ||
	                        self.config.minDate.getSeconds() > 0);
	            self.maxDateHasTime =
	                !!self.config.maxDate &&
	                    (self.config.maxDate.getHours() > 0 ||
	                        self.config.maxDate.getMinutes() > 0 ||
	                        self.config.maxDate.getSeconds() > 0);
	            Object.defineProperty(self, "showTimeInput", {
	                get: function () { return self._showTimeInput; },
	                set: function (bool) {
	                    self._showTimeInput = bool;
	                    if (self.calendarContainer)
	                        toggleClass(self.calendarContainer, "showTimeInput", bool);
	                    self.isOpen && positionCalendar();
	                }
	            });
	        }
	        function setupInputs() {
	            self.input = self.config.wrap
	                ? element.querySelector("[data-input]")
	                : element;
	            /* istanbul ignore next */
	            if (!self.input) {
	                self.config.errorHandler(new Error("Invalid input element specified"));
	                return;
	            }
	            // hack: store previous type to restore it after destroy()
	            self.input._type = self.input.type;
	            self.input.type = "text";
	            self.input.classList.add("flatpickr-input");
	            self._input = self.input;
	            if (self.config.altInput) {
	                // replicate self.element
	                self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
	                self._input = self.altInput;
	                self.altInput.placeholder = self.input.placeholder;
	                self.altInput.disabled = self.input.disabled;
	                self.altInput.required = self.input.required;
	                self.altInput.tabIndex = self.input.tabIndex;
	                self.altInput.type = "text";
	                self.input.setAttribute("type", "hidden");
	                if (!self.config.static && self.input.parentNode)
	                    self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
	            }
	            if (!self.config.allowInput)
	                self._input.setAttribute("readonly", "readonly");
	            self._positionElement = self.config.positionElement || self._input;
	        }
	        function setupMobile() {
	            var inputType = self.config.enableTime
	                ? self.config.noCalendar
	                    ? "time"
	                    : "datetime-local"
	                : "date";
	            self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
	            self.mobileInput.step = self.input.getAttribute("step") || "any";
	            self.mobileInput.tabIndex = 1;
	            self.mobileInput.type = inputType;
	            self.mobileInput.disabled = self.input.disabled;
	            self.mobileInput.required = self.input.required;
	            self.mobileInput.placeholder = self.input.placeholder;
	            self.mobileFormatStr =
	                inputType === "datetime-local"
	                    ? "Y-m-d\\TH:i:S"
	                    : inputType === "date"
	                        ? "Y-m-d"
	                        : "H:i:S";
	            if (self.selectedDates.length > 0) {
	                self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
	            }
	            if (self.config.minDate)
	                self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
	            if (self.config.maxDate)
	                self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
	            self.input.type = "hidden";
	            if (self.altInput !== undefined)
	                self.altInput.type = "hidden";
	            try {
	                if (self.input.parentNode)
	                    self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
	            }
	            catch (_a) { }
	            bind(self.mobileInput, "change", function (e) {
	                self.setDate(e.target.value, false, self.mobileFormatStr);
	                triggerEvent("onChange");
	                triggerEvent("onClose");
	            });
	        }
	        function toggle(e) {
	            if (self.isOpen === true)
	                return self.close();
	            self.open(e);
	        }
	        function triggerEvent(event, data) {
	            // If the instance has been destroyed already, all hooks have been removed
	            if (self.config === undefined)
	                return;
	            var hooks = self.config[event];
	            if (hooks !== undefined && hooks.length > 0) {
	                for (var i = 0; hooks[i] && i < hooks.length; i++)
	                    hooks[i](self.selectedDates, self.input.value, self, data);
	            }
	            if (event === "onChange") {
	                self.input.dispatchEvent(createEvent("change"));
	                // many front-end frameworks bind to the input event
	                self.input.dispatchEvent(createEvent("input"));
	            }
	        }
	        function createEvent(name) {
	            var e = document.createEvent("Event");
	            e.initEvent(name, true, true);
	            return e;
	        }
	        function isDateSelected(date) {
	            for (var i = 0; i < self.selectedDates.length; i++) {
	                if (compareDates(self.selectedDates[i], date) === 0)
	                    return "" + i;
	            }
	            return false;
	        }
	        function isDateInRange(date) {
	            if (self.config.mode !== "range" || self.selectedDates.length < 2)
	                return false;
	            return (compareDates(date, self.selectedDates[0]) >= 0 &&
	                compareDates(date, self.selectedDates[1]) <= 0);
	        }
	        function updateNavigationCurrentMonth() {
	            if (self.config.noCalendar || self.isMobile || !self.monthNav)
	                return;
	            self.yearElements.forEach(function (yearElement, i) {
	                var d = new Date(self.currentYear, self.currentMonth, 1);
	                d.setMonth(self.currentMonth + i);
	                if (self.config.showMonths > 1 ||
	                    self.config.monthSelectorType === "static") {
	                    self.monthElements[i].textContent =
	                        monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
	                }
	                else {
	                    self.monthsDropdownContainer.value = d.getMonth().toString();
	                }
	                yearElement.value = d.getFullYear().toString();
	            });
	            self._hidePrevMonthArrow =
	                self.config.minDate !== undefined &&
	                    (self.currentYear === self.config.minDate.getFullYear()
	                        ? self.currentMonth <= self.config.minDate.getMonth()
	                        : self.currentYear < self.config.minDate.getFullYear());
	            self._hideNextMonthArrow =
	                self.config.maxDate !== undefined &&
	                    (self.currentYear === self.config.maxDate.getFullYear()
	                        ? self.currentMonth + 1 > self.config.maxDate.getMonth()
	                        : self.currentYear > self.config.maxDate.getFullYear());
	        }
	        function getDateStr(format) {
	            return self.selectedDates
	                .map(function (dObj) { return self.formatDate(dObj, format); })
	                .filter(function (d, i, arr) {
	                return self.config.mode !== "range" ||
	                    self.config.enableTime ||
	                    arr.indexOf(d) === i;
	            })
	                .join(self.config.mode !== "range"
	                ? self.config.conjunction
	                : self.l10n.rangeSeparator);
	        }
	        /**
	         * Updates the values of inputs associated with the calendar
	         */
	        function updateValue(triggerChange) {
	            if (triggerChange === void 0) { triggerChange = true; }
	            if (self.mobileInput !== undefined && self.mobileFormatStr) {
	                self.mobileInput.value =
	                    self.latestSelectedDateObj !== undefined
	                        ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr)
	                        : "";
	            }
	            self.input.value = getDateStr(self.config.dateFormat);
	            if (self.altInput !== undefined) {
	                self.altInput.value = getDateStr(self.config.altFormat);
	            }
	            if (triggerChange !== false)
	                triggerEvent("onValueUpdate");
	        }
	        function onMonthNavClick(e) {
	            var isPrevMonth = self.prevMonthNav.contains(e.target);
	            var isNextMonth = self.nextMonthNav.contains(e.target);
	            if (isPrevMonth || isNextMonth) {
	                changeMonth(isPrevMonth ? -1 : 1);
	            }
	            else if (self.yearElements.indexOf(e.target) >= 0) {
	                e.target.select();
	            }
	            else if (e.target.classList.contains("arrowUp")) {
	                self.changeYear(self.currentYear + 1);
	            }
	            else if (e.target.classList.contains("arrowDown")) {
	                self.changeYear(self.currentYear - 1);
	            }
	        }
	        function timeWrapper(e) {
	            e.preventDefault();
	            var isKeyDown = e.type === "keydown", input = e.target;
	            if (self.amPM !== undefined && e.target === self.amPM) {
	                self.amPM.textContent =
	                    self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	            }
	            var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta ||
	                (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
	            var newValue = curValue + step * delta;
	            if (typeof input.value !== "undefined" && input.value.length === 2) {
	                var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
	                if (newValue < min) {
	                    newValue =
	                        max +
	                            newValue +
	                            int(!isHourElem) +
	                            (int(isHourElem) && int(!self.amPM));
	                    if (isMinuteElem)
	                        incrementNumInput(undefined, -1, self.hourElement);
	                }
	                else if (newValue > max) {
	                    newValue =
	                        input === self.hourElement ? newValue - max - int(!self.amPM) : min;
	                    if (isMinuteElem)
	                        incrementNumInput(undefined, 1, self.hourElement);
	                }
	                if (self.amPM &&
	                    isHourElem &&
	                    (step === 1
	                        ? newValue + curValue === 23
	                        : Math.abs(newValue - curValue) > step)) {
	                    self.amPM.textContent =
	                        self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	                }
	                input.value = pad(newValue);
	            }
	        }
	        init();
	        return self;
	    }
	    /* istanbul ignore next */
	    function _flatpickr(nodeList, config) {
	        // static list
	        var nodes = Array.prototype.slice
	            .call(nodeList)
	            .filter(function (x) { return x instanceof HTMLElement; });
	        var instances = [];
	        for (var i = 0; i < nodes.length; i++) {
	            var node = nodes[i];
	            try {
	                if (node.getAttribute("data-fp-omit") !== null)
	                    continue;
	                if (node._flatpickr !== undefined) {
	                    node._flatpickr.destroy();
	                    node._flatpickr = undefined;
	                }
	                node._flatpickr = FlatpickrInstance(node, config || {});
	                instances.push(node._flatpickr);
	            }
	            catch (e) {
	                console.error(e);
	            }
	        }
	        return instances.length === 1 ? instances[0] : instances;
	    }
	    /* istanbul ignore next */
	    if (typeof HTMLElement !== "undefined" &&
	        typeof HTMLCollection !== "undefined" &&
	        typeof NodeList !== "undefined") {
	        // browser env
	        HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
	            return _flatpickr(this, config);
	        };
	        HTMLElement.prototype.flatpickr = function (config) {
	            return _flatpickr([this], config);
	        };
	    }
	    /* istanbul ignore next */
	    var flatpickr = function (selector, config) {
	        if (typeof selector === "string") {
	            return _flatpickr(window.document.querySelectorAll(selector), config);
	        }
	        else if (selector instanceof Node) {
	            return _flatpickr([selector], config);
	        }
	        else {
	            return _flatpickr(selector, config);
	        }
	    };
	    /* istanbul ignore next */
	    flatpickr.defaultConfig = {};
	    flatpickr.l10ns = {
	        en: __assign({}, english),
	        "default": __assign({}, english)
	    };
	    flatpickr.localize = function (l10n) {
	        flatpickr.l10ns["default"] = __assign({}, flatpickr.l10ns["default"], l10n);
	    };
	    flatpickr.setDefaults = function (config) {
	        flatpickr.defaultConfig = __assign({}, flatpickr.defaultConfig, config);
	    };
	    flatpickr.parseDate = createDateParser({});
	    flatpickr.formatDate = createDateFormatter({});
	    flatpickr.compareDates = compareDates;
	    /* istanbul ignore next */
	    if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
	        jQuery.fn.flatpickr = function (config) {
	            return _flatpickr(this, config);
	        };
	    }
	    // eslint-disable-next-line @typescript-eslint/camelcase
	    Date.prototype.fp_incr = function (days) {
	        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
	    };
	    if (typeof window !== "undefined") {
	        window.flatpickr = flatpickr;
	    }
	
	    return flatpickr;
	
	}));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(56);
	__webpack_require__(106);
	__webpack_require__(108);
	__webpack_require__(109);
	module.exports = __webpack_require__(62).Symbol;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(57);
	var has = __webpack_require__(58);
	var DESCRIPTORS = __webpack_require__(59);
	var $export = __webpack_require__(61);
	var redefine = __webpack_require__(71);
	var META = __webpack_require__(78).KEY;
	var $fails = __webpack_require__(60);
	var shared = __webpack_require__(74);
	var setToStringTag = __webpack_require__(79);
	var uid = __webpack_require__(72);
	var wks = __webpack_require__(80);
	var wksExt = __webpack_require__(81);
	var wksDefine = __webpack_require__(82);
	var enumKeys = __webpack_require__(83);
	var isArray = __webpack_require__(98);
	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(66);
	var toObject = __webpack_require__(99);
	var toIObject = __webpack_require__(86);
	var toPrimitive = __webpack_require__(69);
	var createDesc = __webpack_require__(70);
	var _create = __webpack_require__(100);
	var gOPNExt = __webpack_require__(103);
	var $GOPD = __webpack_require__(105);
	var $GOPS = __webpack_require__(96);
	var $DP = __webpack_require__(64);
	var $keys = __webpack_require__(84);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(104).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(97).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(75)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(63)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(60)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var core = __webpack_require__(62);
	var hide = __webpack_require__(63);
	var redefine = __webpack_require__(71);
	var ctx = __webpack_require__(76);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(64);
	var createDesc = __webpack_require__(70);
	module.exports = __webpack_require__(59) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(65);
	var IE8_DOM_DEFINE = __webpack_require__(67);
	var toPrimitive = __webpack_require__(69);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(59) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(59) && !__webpack_require__(60)(function () {
	  return Object.defineProperty(__webpack_require__(68)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	var document = __webpack_require__(57).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(66);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var hide = __webpack_require__(63);
	var has = __webpack_require__(58);
	var SRC = __webpack_require__(72)('src');
	var $toString = __webpack_require__(73);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(62).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(74)('native-function-to-string', Function.toString);


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(62);
	var global = __webpack_require__(57);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(75) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(77);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(72)('meta');
	var isObject = __webpack_require__(66);
	var has = __webpack_require__(58);
	var setDesc = __webpack_require__(64).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(60)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(64).f;
	var has = __webpack_require__(58);
	var TAG = __webpack_require__(80)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(74)('wks');
	var uid = __webpack_require__(72);
	var Symbol = __webpack_require__(57).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(80);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var core = __webpack_require__(62);
	var LIBRARY = __webpack_require__(75);
	var wksExt = __webpack_require__(81);
	var defineProperty = __webpack_require__(64).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(84);
	var gOPS = __webpack_require__(96);
	var pIE = __webpack_require__(97);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(85);
	var enumBugKeys = __webpack_require__(95);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(58);
	var toIObject = __webpack_require__(86);
	var arrayIndexOf = __webpack_require__(90)(false);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(87);
	var defined = __webpack_require__(89);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(88);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(86);
	var toLength = __webpack_require__(91);
	var toAbsoluteIndex = __webpack_require__(93);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(92);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(92);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(74)('keys');
	var uid = __webpack_require__(72);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(88);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(89);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(65);
	var dPs = __webpack_require__(101);
	var enumBugKeys = __webpack_require__(95);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(68)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(102).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(64);
	var anObject = __webpack_require__(65);
	var getKeys = __webpack_require__(84);
	
	module.exports = __webpack_require__(59) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(57).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(86);
	var gOPN = __webpack_require__(104).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(85);
	var hiddenKeys = __webpack_require__(95).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(97);
	var createDesc = __webpack_require__(70);
	var toIObject = __webpack_require__(86);
	var toPrimitive = __webpack_require__(69);
	var has = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(67);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(59) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(107);
	var test = {};
	test[__webpack_require__(80)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(71)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(88);
	var TAG = __webpack_require__(80)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('asyncIterator');


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(82)('observable');


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(111);
	__webpack_require__(117);
	module.exports = __webpack_require__(81).f('iterator');


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(112)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(113)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(92);
	var defined = __webpack_require__(89);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(75);
	var $export = __webpack_require__(61);
	var redefine = __webpack_require__(71);
	var hide = __webpack_require__(63);
	var Iterators = __webpack_require__(114);
	var $iterCreate = __webpack_require__(115);
	var setToStringTag = __webpack_require__(79);
	var getPrototypeOf = __webpack_require__(116);
	var ITERATOR = __webpack_require__(80)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(100);
	var descriptor = __webpack_require__(70);
	var setToStringTag = __webpack_require__(79);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(63)(IteratorPrototype, __webpack_require__(80)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(58);
	var toObject = __webpack_require__(99);
	var IE_PROTO = __webpack_require__(94)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(118);
	var getKeys = __webpack_require__(84);
	var redefine = __webpack_require__(71);
	var global = __webpack_require__(57);
	var hide = __webpack_require__(63);
	var Iterators = __webpack_require__(114);
	var wks = __webpack_require__(80);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(119);
	var step = __webpack_require__(120);
	var Iterators = __webpack_require__(114);
	var toIObject = __webpack_require__(86);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(113)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(80)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(63)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(111);
	__webpack_require__(122);
	module.exports = __webpack_require__(62).Array.from;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(76);
	var $export = __webpack_require__(61);
	var toObject = __webpack_require__(99);
	var call = __webpack_require__(123);
	var isArrayIter = __webpack_require__(124);
	var toLength = __webpack_require__(91);
	var createProperty = __webpack_require__(125);
	var getIterFn = __webpack_require__(126);
	
	$export($export.S + $export.F * !__webpack_require__(127)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(65);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(114);
	var ITERATOR = __webpack_require__(80)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(64);
	var createDesc = __webpack_require__(70);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(107);
	var ITERATOR = __webpack_require__(80)('iterator');
	var Iterators = __webpack_require__(114);
	module.exports = __webpack_require__(62).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(80)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(129);
	module.exports = __webpack_require__(62).Number.isInteger;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(130) });


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(66);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 131 */,
/* 132 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(134);
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(423);
	
	var _reactRedux = __webpack_require__(561);
	
	var _reactRouter = __webpack_require__(605);
	
	var _reactRouterRedux = __webpack_require__(667);
	
	var _redux = __webpack_require__(571);
	
	var _components = __webpack_require__(672);
	
	var _reducers = __webpack_require__(890);
	
	var reducers = _interopRequireWildcard(_reducers);
	
	var _actions = __webpack_require__(881);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reducer = _get__('combineReducers')(_extends({}, _get__('reducers'), {
	  routing: _get__('routerReducer')
	}));
	var store = _get__('createStore')(_get__('reducer'));
	
	_get__('store').dispatch(_get__('actions').toggleStaticVersion(true));
	
	function scrollToAnchor() {
	  var hashParts = window.decodeURIComponent(window.location.hash).split('#');
	  if (hashParts && hashParts.length >= 2 && hashParts[1] !== '') {
	    var subHashParts = hashParts[1].split('/');
	    if (subHashParts && subHashParts.length === 3 && subHashParts[2] !== '') {
	      var subHash = subHashParts[2].indexOf('?') > -1 ? subHashParts[2].substr(0, subHashParts[2].indexOf('?')) : subHashParts[2];
	      if (subHash !== '') {
	        if (document.querySelector('#' + subHash)) {
	          document.querySelector('#' + subHash).scrollIntoView();
	        }
	      }
	    }
	  }
	}
	
	_get__('render')(_get__('React').createElement(
	  _get__('Provider'),
	  { store: _get__('store') },
	  _get__('React').createElement(
	    _get__('Router'),
	    { history: _get__('hashHistory') },
	    _get__('React').createElement(
	      _get__('Route'),
	      { path: '/', component: _get__('App') },
	      _get__('React').createElement(_get__('IndexRoute'), { component: _get__('Home') }),
	      _get__('React').createElement(_get__('Route'), { path: 'home', component: _get__('Home') }),
	      _get__('React').createElement(_get__('Route'), { path: 'home/:section', component: _get__('Home'), onEnter: _get__('scrollToAnchor') }),
	      _get__('React').createElement(_get__('Route'), { path: 'brand', component: _get__('Brand') }),
	      _get__('React').createElement(_get__('Route'), { path: 'brand/:section', component: _get__('Brand'), onEnter: _get__('scrollToAnchor') }),
	      _get__('React').createElement(_get__('Route'), { path: 'core', component: _get__('Core') }),
	      _get__('React').createElement(_get__('Route'), { path: 'core/:section', component: _get__('Core'), onEnter: _get__('scrollToAnchor') }),
	      _get__('React').createElement(_get__('Route'), { path: 'components', component: _get__('Components') }),
	      _get__('React').createElement(_get__('Route'), { path: 'components/:section', component: _get__('Components'), onEnter: _get__('scrollToAnchor') }),
	      _get__('React').createElement(_get__('Route'), { path: 'layouts', component: _get__('Layouts') }),
	      _get__('React').createElement(_get__('Route'), { path: 'layouts/:section', component: _get__('Layouts'), onEnter: _get__('scrollToAnchor') }),
	      _get__('React').createElement(_get__('Route'), { path: 'themes', component: _get__('Themes') }),
	      _get__('React').createElement(_get__('Route'), { path: 'themes/:section', component: _get__('Themes'), onEnter: _get__('scrollToAnchor') }),
	      _get__('React').createElement(_get__('Route'), { path: 'getting-started', component: _get__('GettingStarted') }),
	      _get__('React').createElement(_get__('Route'), { path: 'getting-started/:section', component: _get__('GettingStarted'), onEnter: _get__('scrollToAnchor') })
	    )
	  )
	), document.getElementById('root'));
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'combineReducers':
	      return _redux.combineReducers;

	    case 'reducers':
	      return _filterWildcardImport__(reducers);

	    case 'routerReducer':
	      return _reactRouterRedux.routerReducer;

	    case 'createStore':
	      return _redux.createStore;

	    case 'reducer':
	      return reducer;

	    case 'store':
	      return store;

	    case 'actions':
	      return _filterWildcardImport__(actions);

	    case 'render':
	      return _reactDom.render;

	    case 'hashHistory':
	      return _reactRouter.hashHistory;

	    case 'App':
	      return _components.App;

	    case 'Home':
	      return _components.Home;

	    case 'scrollToAnchor':
	      return scrollToAnchor;

	    case 'Brand':
	      return _components.Brand;

	    case 'Core':
	      return _components.Core;

	    case 'Components':
	      return _components.Components;

	    case 'Layouts':
	      return _components.Layouts;

	    case 'Themes':
	      return _components.Themes;

	    case 'GettingStarted':
	      return _components.GettingStarted;

	    case 'React':
	      return _react2.default;

	    case 'Provider':
	      return _reactRedux.Provider;

	    case 'Router':
	      return _reactRouter.Router;

	    case 'Route':
	      return _reactRouter.Route;

	    case 'IndexRoute':
	      return _reactRouter.IndexRoute;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	exports.default = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(135);
	
	__webpack_require__(389);
	
	__webpack_require__(390);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(56);
	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(152);
	__webpack_require__(154);
	__webpack_require__(106);
	__webpack_require__(156);
	__webpack_require__(159);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(165);
	__webpack_require__(167);
	__webpack_require__(169);
	__webpack_require__(172);
	__webpack_require__(173);
	__webpack_require__(174);
	__webpack_require__(129);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(187);
	__webpack_require__(188);
	__webpack_require__(189);
	__webpack_require__(191);
	__webpack_require__(193);
	__webpack_require__(194);
	__webpack_require__(195);
	__webpack_require__(196);
	__webpack_require__(197);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(111);
	__webpack_require__(205);
	__webpack_require__(206);
	__webpack_require__(210);
	__webpack_require__(211);
	__webpack_require__(212);
	__webpack_require__(213);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(217);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(220);
	__webpack_require__(221);
	__webpack_require__(222);
	__webpack_require__(223);
	__webpack_require__(224);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(234);
	__webpack_require__(122);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(244);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(250);
	__webpack_require__(251);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(255);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(118);
	__webpack_require__(261);
	__webpack_require__(263);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(275);
	__webpack_require__(285);
	__webpack_require__(289);
	__webpack_require__(290);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(297);
	__webpack_require__(298);
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(302);
	__webpack_require__(303);
	__webpack_require__(304);
	__webpack_require__(305);
	__webpack_require__(306);
	__webpack_require__(307);
	__webpack_require__(308);
	__webpack_require__(309);
	__webpack_require__(310);
	__webpack_require__(311);
	__webpack_require__(312);
	__webpack_require__(313);
	__webpack_require__(314);
	__webpack_require__(315);
	__webpack_require__(316);
	__webpack_require__(317);
	__webpack_require__(318);
	__webpack_require__(320);
	__webpack_require__(321);
	__webpack_require__(322);
	__webpack_require__(323);
	__webpack_require__(324);
	__webpack_require__(326);
	__webpack_require__(327);
	__webpack_require__(328);
	__webpack_require__(330);
	__webpack_require__(331);
	__webpack_require__(332);
	__webpack_require__(333);
	__webpack_require__(108);
	__webpack_require__(109);
	__webpack_require__(334);
	__webpack_require__(335);
	__webpack_require__(337);
	__webpack_require__(338);
	__webpack_require__(340);
	__webpack_require__(341);
	__webpack_require__(342);
	__webpack_require__(343);
	__webpack_require__(346);
	__webpack_require__(347);
	__webpack_require__(349);
	__webpack_require__(350);
	__webpack_require__(351);
	__webpack_require__(352);
	__webpack_require__(354);
	__webpack_require__(355);
	__webpack_require__(356);
	__webpack_require__(357);
	__webpack_require__(358);
	__webpack_require__(359);
	__webpack_require__(360);
	__webpack_require__(361);
	__webpack_require__(362);
	__webpack_require__(363);
	__webpack_require__(365);
	__webpack_require__(366);
	__webpack_require__(367);
	__webpack_require__(368);
	__webpack_require__(369);
	__webpack_require__(370);
	__webpack_require__(371);
	__webpack_require__(372);
	__webpack_require__(373);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(379);
	__webpack_require__(380);
	__webpack_require__(381);
	__webpack_require__(382);
	__webpack_require__(383);
	__webpack_require__(384);
	__webpack_require__(385);
	__webpack_require__(386);
	__webpack_require__(387);
	__webpack_require__(388);
	__webpack_require__(117);
	module.exports = __webpack_require__(62);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(100) });


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperty: __webpack_require__(64).f });


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperties: __webpack_require__(101) });


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(86);
	var $getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	__webpack_require__(140)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(61);
	var core = __webpack_require__(62);
	var fails = __webpack_require__(60);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(99);
	var $getPrototypeOf = __webpack_require__(116);
	
	__webpack_require__(140)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(99);
	var $keys = __webpack_require__(84);
	
	__webpack_require__(140)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(140)('getOwnPropertyNames', function () {
	  return __webpack_require__(103).f;
	});


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(66);
	var meta = __webpack_require__(78).onFreeze;
	
	__webpack_require__(140)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(66);
	var meta = __webpack_require__(78).onFreeze;
	
	__webpack_require__(140)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(66);
	var meta = __webpack_require__(78).onFreeze;
	
	__webpack_require__(140)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(66);
	
	__webpack_require__(140)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(66);
	
	__webpack_require__(140)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(66);
	
	__webpack_require__(140)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(61);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(151) });


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(59);
	var getKeys = __webpack_require__(84);
	var gOPS = __webpack_require__(96);
	var pIE = __webpack_require__(97);
	var toObject = __webpack_require__(99);
	var IObject = __webpack_require__(87);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(60)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(61);
	$export($export.S, 'Object', { is: __webpack_require__(153) });


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(61);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(155).set });


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(66);
	var anObject = __webpack_require__(65);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(76)(Function.call, __webpack_require__(105).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(61);
	
	$export($export.P, 'Function', { bind: __webpack_require__(157) });


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(77);
	var isObject = __webpack_require__(66);
	var invoke = __webpack_require__(158);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(64).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(59) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(66);
	var getPrototypeOf = __webpack_require__(116);
	var HAS_INSTANCE = __webpack_require__(80)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(64).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var $parseInt = __webpack_require__(162);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(57).parseInt;
	var $trim = __webpack_require__(163).trim;
	var ws = __webpack_require__(164);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var defined = __webpack_require__(89);
	var fails = __webpack_require__(60);
	var spaces = __webpack_require__(164);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var $parseFloat = __webpack_require__(166);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(57).parseFloat;
	var $trim = __webpack_require__(163).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(164) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(57);
	var has = __webpack_require__(58);
	var cof = __webpack_require__(88);
	var inheritIfRequired = __webpack_require__(168);
	var toPrimitive = __webpack_require__(69);
	var fails = __webpack_require__(60);
	var gOPN = __webpack_require__(104).f;
	var gOPD = __webpack_require__(105).f;
	var dP = __webpack_require__(64).f;
	var $trim = __webpack_require__(163).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(100)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(59) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(71)(global, NUMBER, $Number);
	}


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	var setPrototypeOf = __webpack_require__(155).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var toInteger = __webpack_require__(92);
	var aNumberValue = __webpack_require__(170);
	var repeat = __webpack_require__(171);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(60)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(88);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(92);
	var defined = __webpack_require__(89);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $fails = __webpack_require__(60);
	var aNumberValue = __webpack_require__(170);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(61);
	var _isFinite = __webpack_require__(57).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(61);
	var isInteger = __webpack_require__(130);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var $parseFloat = __webpack_require__(166);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var $parseInt = __webpack_require__(162);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(61);
	var log1p = __webpack_require__(182);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 182 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(61);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(61);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(61);
	var sign = __webpack_require__(186);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(61);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(61);
	var $expm1 = __webpack_require__(190);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 190 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', { fround: __webpack_require__(192) });


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(186);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(61);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(61);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(60)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(182) });


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', { sign: __webpack_require__(186) });


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(61);
	var expm1 = __webpack_require__(190);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(60)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(61);
	var expm1 = __webpack_require__(190);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var toAbsoluteIndex = __webpack_require__(93);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var toIObject = __webpack_require__(86);
	var toLength = __webpack_require__(91);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(163)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $at = __webpack_require__(112)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(61);
	var toLength = __webpack_require__(91);
	var context = __webpack_require__(207);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(209)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(208);
	var defined = __webpack_require__(89);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(66);
	var cof = __webpack_require__(88);
	var MATCH = __webpack_require__(80)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(80)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(61);
	var context = __webpack_require__(207);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(209)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(171)
	});


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(61);
	var toLength = __webpack_require__(91);
	var context = __webpack_require__(207);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(209)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(214)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var fails = __webpack_require__(60);
	var defined = __webpack_require__(89);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(214)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(214)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(214)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(214)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(214)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(214)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(214)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(214)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(214)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(214)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(214)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(214)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var toObject = __webpack_require__(99);
	var toPrimitive = __webpack_require__(69);
	
	$export($export.P + $export.F * __webpack_require__(60)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(61);
	var toISOString = __webpack_require__(230);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(60);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(71)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(80)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(63)(proto, TO_PRIMITIVE, __webpack_require__(233));


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(65);
	var toPrimitive = __webpack_require__(69);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(98) });


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var createProperty = __webpack_require__(125);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(60)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(61);
	var toIObject = __webpack_require__(86);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(87) != Object || !__webpack_require__(237)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(60);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var html = __webpack_require__(102);
	var cof = __webpack_require__(88);
	var toAbsoluteIndex = __webpack_require__(93);
	var toLength = __webpack_require__(91);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(60)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var aFunction = __webpack_require__(77);
	var toObject = __webpack_require__(99);
	var fails = __webpack_require__(60);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(237)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $forEach = __webpack_require__(241)(0);
	var STRICT = __webpack_require__(237)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(76);
	var IObject = __webpack_require__(87);
	var toObject = __webpack_require__(99);
	var toLength = __webpack_require__(91);
	var asc = __webpack_require__(242);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(243);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	var isArray = __webpack_require__(98);
	var SPECIES = __webpack_require__(80)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $map = __webpack_require__(241)(1);
	
	$export($export.P + $export.F * !__webpack_require__(237)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $filter = __webpack_require__(241)(2);
	
	$export($export.P + $export.F * !__webpack_require__(237)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $some = __webpack_require__(241)(3);
	
	$export($export.P + $export.F * !__webpack_require__(237)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $every = __webpack_require__(241)(4);
	
	$export($export.P + $export.F * !__webpack_require__(237)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $reduce = __webpack_require__(249);
	
	$export($export.P + $export.F * !__webpack_require__(237)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(77);
	var toObject = __webpack_require__(99);
	var IObject = __webpack_require__(87);
	var toLength = __webpack_require__(91);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $reduce = __webpack_require__(249);
	
	$export($export.P + $export.F * !__webpack_require__(237)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $indexOf = __webpack_require__(90)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(237)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var toIObject = __webpack_require__(86);
	var toInteger = __webpack_require__(92);
	var toLength = __webpack_require__(91);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(237)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(61);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(254) });
	
	__webpack_require__(119)('copyWithin');


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(99);
	var toAbsoluteIndex = __webpack_require__(93);
	var toLength = __webpack_require__(91);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(61);
	
	$export($export.P, 'Array', { fill: __webpack_require__(256) });
	
	__webpack_require__(119)('fill');


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(99);
	var toAbsoluteIndex = __webpack_require__(93);
	var toLength = __webpack_require__(91);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(61);
	var $find = __webpack_require__(241)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(119)(KEY);


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(61);
	var $find = __webpack_require__(241)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(119)(KEY);


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(260)('Array');


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(57);
	var dP = __webpack_require__(64);
	var DESCRIPTORS = __webpack_require__(59);
	var SPECIES = __webpack_require__(80)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var inheritIfRequired = __webpack_require__(168);
	var dP = __webpack_require__(64).f;
	var gOPN = __webpack_require__(104).f;
	var isRegExp = __webpack_require__(208);
	var $flags = __webpack_require__(262);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(59) && (!CORRECT_NEW || __webpack_require__(60)(function () {
	  re2[__webpack_require__(80)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(71)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(260)('RegExp');


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(65);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(264);
	__webpack_require__(61)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(262);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(266);
	var anObject = __webpack_require__(65);
	var $flags = __webpack_require__(262);
	var DESCRIPTORS = __webpack_require__(59);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(71)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(60)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(59) && /./g.flags != 'g') __webpack_require__(64).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(262)
	});


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(65);
	var toLength = __webpack_require__(91);
	var advanceStringIndex = __webpack_require__(268);
	var regExpExec = __webpack_require__(269);
	
	// @@match logic
	__webpack_require__(270)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(112)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(107);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(263);
	var redefine = __webpack_require__(71);
	var hide = __webpack_require__(63);
	var fails = __webpack_require__(60);
	var defined = __webpack_require__(89);
	var wks = __webpack_require__(80);
	var regexpExec = __webpack_require__(264);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(65);
	var toObject = __webpack_require__(99);
	var toLength = __webpack_require__(91);
	var toInteger = __webpack_require__(92);
	var advanceStringIndex = __webpack_require__(268);
	var regExpExec = __webpack_require__(269);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(270)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(65);
	var sameValue = __webpack_require__(153);
	var regExpExec = __webpack_require__(269);
	
	// @@search logic
	__webpack_require__(270)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(208);
	var anObject = __webpack_require__(65);
	var speciesConstructor = __webpack_require__(274);
	var advanceStringIndex = __webpack_require__(268);
	var toLength = __webpack_require__(91);
	var callRegExpExec = __webpack_require__(269);
	var regexpExec = __webpack_require__(264);
	var fails = __webpack_require__(60);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(270)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(65);
	var aFunction = __webpack_require__(77);
	var SPECIES = __webpack_require__(80)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(75);
	var global = __webpack_require__(57);
	var ctx = __webpack_require__(76);
	var classof = __webpack_require__(107);
	var $export = __webpack_require__(61);
	var isObject = __webpack_require__(66);
	var aFunction = __webpack_require__(77);
	var anInstance = __webpack_require__(276);
	var forOf = __webpack_require__(277);
	var speciesConstructor = __webpack_require__(274);
	var task = __webpack_require__(278).set;
	var microtask = __webpack_require__(279)();
	var newPromiseCapabilityModule = __webpack_require__(280);
	var perform = __webpack_require__(281);
	var userAgent = __webpack_require__(282);
	var promiseResolve = __webpack_require__(283);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(80)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(284)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(79)($Promise, PROMISE);
	__webpack_require__(260)(PROMISE);
	Wrapper = __webpack_require__(62)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(127)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 276 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(76);
	var call = __webpack_require__(123);
	var isArrayIter = __webpack_require__(124);
	var anObject = __webpack_require__(65);
	var toLength = __webpack_require__(91);
	var getIterFn = __webpack_require__(126);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(76);
	var invoke = __webpack_require__(158);
	var html = __webpack_require__(102);
	var cel = __webpack_require__(68);
	var global = __webpack_require__(57);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(88)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var macrotask = __webpack_require__(278).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(88)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(77);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(66);
	var newPromiseCapability = __webpack_require__(280);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(71);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(286);
	var validate = __webpack_require__(287);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(288)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(64).f;
	var create = __webpack_require__(100);
	var redefineAll = __webpack_require__(284);
	var ctx = __webpack_require__(76);
	var anInstance = __webpack_require__(276);
	var forOf = __webpack_require__(277);
	var $iterDefine = __webpack_require__(113);
	var step = __webpack_require__(120);
	var setSpecies = __webpack_require__(260);
	var DESCRIPTORS = __webpack_require__(59);
	var fastKey = __webpack_require__(78).fastKey;
	var validate = __webpack_require__(287);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(66);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(57);
	var $export = __webpack_require__(61);
	var redefine = __webpack_require__(71);
	var redefineAll = __webpack_require__(284);
	var meta = __webpack_require__(78);
	var forOf = __webpack_require__(277);
	var anInstance = __webpack_require__(276);
	var isObject = __webpack_require__(66);
	var fails = __webpack_require__(60);
	var $iterDetect = __webpack_require__(127);
	var setToStringTag = __webpack_require__(79);
	var inheritIfRequired = __webpack_require__(168);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(286);
	var validate = __webpack_require__(287);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(288)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(57);
	var each = __webpack_require__(241)(0);
	var redefine = __webpack_require__(71);
	var meta = __webpack_require__(78);
	var assign = __webpack_require__(151);
	var weak = __webpack_require__(291);
	var isObject = __webpack_require__(66);
	var validate = __webpack_require__(287);
	var NATIVE_WEAK_MAP = __webpack_require__(287);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(288)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(284);
	var getWeak = __webpack_require__(78).getWeak;
	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(66);
	var anInstance = __webpack_require__(276);
	var forOf = __webpack_require__(277);
	var createArrayMethod = __webpack_require__(241);
	var $has = __webpack_require__(58);
	var validate = __webpack_require__(287);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(291);
	var validate = __webpack_require__(287);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(288)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var $typed = __webpack_require__(294);
	var buffer = __webpack_require__(295);
	var anObject = __webpack_require__(65);
	var toAbsoluteIndex = __webpack_require__(93);
	var toLength = __webpack_require__(91);
	var isObject = __webpack_require__(66);
	var ArrayBuffer = __webpack_require__(57).ArrayBuffer;
	var speciesConstructor = __webpack_require__(274);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(60)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(260)(ARRAY_BUFFER);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(57);
	var hide = __webpack_require__(63);
	var uid = __webpack_require__(72);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(57);
	var DESCRIPTORS = __webpack_require__(59);
	var LIBRARY = __webpack_require__(75);
	var $typed = __webpack_require__(294);
	var hide = __webpack_require__(63);
	var redefineAll = __webpack_require__(284);
	var fails = __webpack_require__(60);
	var anInstance = __webpack_require__(276);
	var toInteger = __webpack_require__(92);
	var toLength = __webpack_require__(91);
	var toIndex = __webpack_require__(296);
	var gOPN = __webpack_require__(104).f;
	var dP = __webpack_require__(64).f;
	var arrayFill = __webpack_require__(256);
	var setToStringTag = __webpack_require__(79);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(92);
	var toLength = __webpack_require__(91);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	$export($export.G + $export.W + $export.F * !__webpack_require__(294).ABV, {
	  DataView: __webpack_require__(295).DataView
	});


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(59)) {
	  var LIBRARY = __webpack_require__(75);
	  var global = __webpack_require__(57);
	  var fails = __webpack_require__(60);
	  var $export = __webpack_require__(61);
	  var $typed = __webpack_require__(294);
	  var $buffer = __webpack_require__(295);
	  var ctx = __webpack_require__(76);
	  var anInstance = __webpack_require__(276);
	  var propertyDesc = __webpack_require__(70);
	  var hide = __webpack_require__(63);
	  var redefineAll = __webpack_require__(284);
	  var toInteger = __webpack_require__(92);
	  var toLength = __webpack_require__(91);
	  var toIndex = __webpack_require__(296);
	  var toAbsoluteIndex = __webpack_require__(93);
	  var toPrimitive = __webpack_require__(69);
	  var has = __webpack_require__(58);
	  var classof = __webpack_require__(107);
	  var isObject = __webpack_require__(66);
	  var toObject = __webpack_require__(99);
	  var isArrayIter = __webpack_require__(124);
	  var create = __webpack_require__(100);
	  var getPrototypeOf = __webpack_require__(116);
	  var gOPN = __webpack_require__(104).f;
	  var getIterFn = __webpack_require__(126);
	  var uid = __webpack_require__(72);
	  var wks = __webpack_require__(80);
	  var createArrayMethod = __webpack_require__(241);
	  var createArrayIncludes = __webpack_require__(90);
	  var speciesConstructor = __webpack_require__(274);
	  var ArrayIterators = __webpack_require__(118);
	  var Iterators = __webpack_require__(114);
	  var $iterDetect = __webpack_require__(127);
	  var setSpecies = __webpack_require__(260);
	  var arrayFill = __webpack_require__(256);
	  var arrayCopyWithin = __webpack_require__(254);
	  var $DP = __webpack_require__(64);
	  var $GOPD = __webpack_require__(105);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(299)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(61);
	var aFunction = __webpack_require__(77);
	var anObject = __webpack_require__(65);
	var rApply = (__webpack_require__(57).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(60)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(61);
	var create = __webpack_require__(100);
	var aFunction = __webpack_require__(77);
	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(66);
	var fails = __webpack_require__(60);
	var bind = __webpack_require__(157);
	var rConstruct = (__webpack_require__(57).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(64);
	var $export = __webpack_require__(61);
	var anObject = __webpack_require__(65);
	var toPrimitive = __webpack_require__(69);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(60)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(61);
	var gOPD = __webpack_require__(105).f;
	var anObject = __webpack_require__(65);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(61);
	var anObject = __webpack_require__(65);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(115)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(105);
	var getPrototypeOf = __webpack_require__(116);
	var has = __webpack_require__(58);
	var $export = __webpack_require__(61);
	var isObject = __webpack_require__(66);
	var anObject = __webpack_require__(65);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(105);
	var $export = __webpack_require__(61);
	var anObject = __webpack_require__(65);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(61);
	var getProto = __webpack_require__(116);
	var anObject = __webpack_require__(65);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(61);
	var anObject = __webpack_require__(65);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(319) });


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(104);
	var gOPS = __webpack_require__(96);
	var anObject = __webpack_require__(65);
	var Reflect = __webpack_require__(57).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(61);
	var anObject = __webpack_require__(65);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(64);
	var gOPD = __webpack_require__(105);
	var getPrototypeOf = __webpack_require__(116);
	var has = __webpack_require__(58);
	var $export = __webpack_require__(61);
	var createDesc = __webpack_require__(70);
	var anObject = __webpack_require__(65);
	var isObject = __webpack_require__(66);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(61);
	var setProto = __webpack_require__(155);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(61);
	var $includes = __webpack_require__(90)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(119)('includes');


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(61);
	var flattenIntoArray = __webpack_require__(325);
	var toObject = __webpack_require__(99);
	var toLength = __webpack_require__(91);
	var aFunction = __webpack_require__(77);
	var arraySpeciesCreate = __webpack_require__(242);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(119)('flatMap');


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(98);
	var isObject = __webpack_require__(66);
	var toLength = __webpack_require__(91);
	var ctx = __webpack_require__(76);
	var IS_CONCAT_SPREADABLE = __webpack_require__(80)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(61);
	var flattenIntoArray = __webpack_require__(325);
	var toObject = __webpack_require__(99);
	var toLength = __webpack_require__(91);
	var toInteger = __webpack_require__(92);
	var arraySpeciesCreate = __webpack_require__(242);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(119)('flatten');


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(61);
	var $at = __webpack_require__(112)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(61);
	var $pad = __webpack_require__(329);
	var userAgent = __webpack_require__(282);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(91);
	var repeat = __webpack_require__(171);
	var defined = __webpack_require__(89);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(61);
	var $pad = __webpack_require__(329);
	var userAgent = __webpack_require__(282);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(163)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(163)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(61);
	var defined = __webpack_require__(89);
	var toLength = __webpack_require__(91);
	var isRegExp = __webpack_require__(208);
	var getFlags = __webpack_require__(262);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(115)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(61);
	var ownKeys = __webpack_require__(319);
	var toIObject = __webpack_require__(86);
	var gOPD = __webpack_require__(105);
	var createProperty = __webpack_require__(125);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(61);
	var $values = __webpack_require__(336)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(59);
	var getKeys = __webpack_require__(84);
	var toIObject = __webpack_require__(86);
	var isEnum = __webpack_require__(97).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(61);
	var $entries = __webpack_require__(336)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var toObject = __webpack_require__(99);
	var aFunction = __webpack_require__(77);
	var $defineProperty = __webpack_require__(64);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(59) && $export($export.P + __webpack_require__(339), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(75) || !__webpack_require__(60)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(57)[K];
	});


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var toObject = __webpack_require__(99);
	var aFunction = __webpack_require__(77);
	var $defineProperty = __webpack_require__(64);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(59) && $export($export.P + __webpack_require__(339), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var toObject = __webpack_require__(99);
	var toPrimitive = __webpack_require__(69);
	var getPrototypeOf = __webpack_require__(116);
	var getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(59) && $export($export.P + __webpack_require__(339), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(61);
	var toObject = __webpack_require__(99);
	var toPrimitive = __webpack_require__(69);
	var getPrototypeOf = __webpack_require__(116);
	var getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(59) && $export($export.P + __webpack_require__(339), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(61);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(344)('Map') });


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(107);
	var from = __webpack_require__(345);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(277);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(61);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(344)('Set') });


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(348)('Map');


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(61);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(348)('Set');


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(348)('WeakMap');


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(348)('WeakSet');


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(353)('Map');


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(61);
	var aFunction = __webpack_require__(77);
	var ctx = __webpack_require__(76);
	var forOf = __webpack_require__(277);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(353)('Set');


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(353)('WeakMap');


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(353)('WeakSet');


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(61);
	
	$export($export.G, { global: __webpack_require__(57) });


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(61);
	
	$export($export.S, 'System', { global: __webpack_require__(57) });


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(61);
	var cof = __webpack_require__(88);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(61);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(61);
	var scale = __webpack_require__(364);
	var fround = __webpack_require__(192);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(61);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', { scale: __webpack_require__(364) });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(61);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(61);
	var core = __webpack_require__(62);
	var global = __webpack_require__(57);
	var speciesConstructor = __webpack_require__(274);
	var promiseResolve = __webpack_require__(283);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(61);
	var newPromiseCapability = __webpack_require__(280);
	var perform = __webpack_require__(281);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(285);
	var $export = __webpack_require__(61);
	var shared = __webpack_require__(74)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(290))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var getPrototypeOf = __webpack_require__(116);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(289);
	var from = __webpack_require__(345);
	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var getPrototypeOf = __webpack_require__(116);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var getPrototypeOf = __webpack_require__(116);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(376);
	var anObject = __webpack_require__(65);
	var aFunction = __webpack_require__(77);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(61);
	var microtask = __webpack_require__(279)();
	var process = __webpack_require__(57).process;
	var isNode = __webpack_require__(88)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(61);
	var global = __webpack_require__(57);
	var core = __webpack_require__(62);
	var microtask = __webpack_require__(279)();
	var OBSERVABLE = __webpack_require__(80)('observable');
	var aFunction = __webpack_require__(77);
	var anObject = __webpack_require__(65);
	var anInstance = __webpack_require__(276);
	var redefineAll = __webpack_require__(284);
	var hide = __webpack_require__(63);
	var forOf = __webpack_require__(277);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(260)('Observable');


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(57);
	var $export = __webpack_require__(61);
	var userAgent = __webpack_require__(282);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(61);
	var $task = __webpack_require__(278);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(391);
	module.exports = __webpack_require__(62).RegExp.escape;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(61);
	var $re = __webpack_require__(392)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(394);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var ReactBaseClasses = __webpack_require__(396);
	var ReactChildren = __webpack_require__(405);
	var ReactDOMFactories = __webpack_require__(413);
	var ReactElement = __webpack_require__(407);
	var ReactPropTypes = __webpack_require__(414);
	var ReactVersion = __webpack_require__(419);
	
	var createReactClass = __webpack_require__(420);
	var onlyChild = __webpack_require__(422);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(397),
	    _assign = __webpack_require__(395);
	
	var ReactNoopUpdateQueue = __webpack_require__(398);
	
	var canDefineProperty = __webpack_require__(401);
	var emptyObject = __webpack_require__(402);
	var invariant = __webpack_require__(403);
	var lowPriorityWarning = __webpack_require__(404);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(399);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(400);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(406);
	var ReactElement = __webpack_require__(407);
	
	var emptyFunction = __webpack_require__(400);
	var traverseAllChildren = __webpack_require__(410);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 406 */
[894, 397],
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var ReactCurrentOwner = __webpack_require__(408);
	
	var warning = __webpack_require__(399);
	var canDefineProperty = __webpack_require__(401);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(409);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(397);
	
	var ReactCurrentOwner = __webpack_require__(408);
	var REACT_ELEMENT_TYPE = __webpack_require__(409);
	
	var getIteratorFn = __webpack_require__(411);
	var invariant = __webpack_require__(403);
	var KeyEscapeUtils = __webpack_require__(412);
	var warning = __webpack_require__(399);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(407);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(407),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(415);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(416);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(400);
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	var assign = __webpack_require__(395);
	
	var ReactPropTypesSecret = __webpack_require__(417);
	var checkPropTypes = __webpack_require__(418);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 417 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(396),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(407),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(398);
	var factory = __webpack_require__(421);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var emptyObject = __webpack_require__(402);
	var _invariant = __webpack_require__(403);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(397);
	
	var ReactElement = __webpack_require__(407);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(424);


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactDefaultInjection = __webpack_require__(429);
	var ReactMount = __webpack_require__(552);
	var ReactReconciler = __webpack_require__(450);
	var ReactUpdates = __webpack_require__(447);
	var ReactVersion = __webpack_require__(557);
	
	var findDOMNode = __webpack_require__(558);
	var getHostComponentFromComposite = __webpack_require__(559);
	var renderSubtreeIntoContainer = __webpack_require__(560);
	var warning = __webpack_require__(399);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var DOMProperty = __webpack_require__(427);
	var ReactDOMComponentFlags = __webpack_require__(428);
	
	var invariant = __webpack_require__(403);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 426 */
397,
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(430);
	var BeforeInputEventPlugin = __webpack_require__(431);
	var ChangeEventPlugin = __webpack_require__(446);
	var DefaultEventPluginOrder = __webpack_require__(459);
	var EnterLeaveEventPlugin = __webpack_require__(460);
	var HTMLDOMPropertyConfig = __webpack_require__(465);
	var ReactComponentBrowserEnvironment = __webpack_require__(466);
	var ReactDOMComponent = __webpack_require__(479);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactDOMEmptyComponent = __webpack_require__(523);
	var ReactDOMTreeTraversal = __webpack_require__(524);
	var ReactDOMTextComponent = __webpack_require__(525);
	var ReactDefaultBatchingStrategy = __webpack_require__(526);
	var ReactEventListener = __webpack_require__(527);
	var ReactInjection = __webpack_require__(530);
	var ReactReconcileTransaction = __webpack_require__(531);
	var SVGDOMPropertyConfig = __webpack_require__(539);
	var SelectEventPlugin = __webpack_require__(540);
	var SimpleEventPlugin = __webpack_require__(541);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(432);
	var ExecutionEnvironment = __webpack_require__(439);
	var FallbackCompositionState = __webpack_require__(440);
	var SyntheticCompositionEvent = __webpack_require__(443);
	var SyntheticInputEvent = __webpack_require__(445);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(433);
	var EventPluginUtils = __webpack_require__(435);
	
	var accumulateInto = __webpack_require__(437);
	var forEachAccumulated = __webpack_require__(438);
	var warning = __webpack_require__(399);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var EventPluginRegistry = __webpack_require__(434);
	var EventPluginUtils = __webpack_require__(435);
	var ReactErrorUtils = __webpack_require__(436);
	
	var accumulateInto = __webpack_require__(437);
	var forEachAccumulated = __webpack_require__(438);
	var invariant = __webpack_require__(403);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var ReactErrorUtils = __webpack_require__(436);
	
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var PooledClass = __webpack_require__(441);
	
	var getTextContentAccessor = __webpack_require__(442);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 441 */
[894, 426],
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(439);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(444);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var PooledClass = __webpack_require__(441);
	
	var emptyFunction = __webpack_require__(400);
	var warning = __webpack_require__(399);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(444);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(433);
	var EventPropagators = __webpack_require__(432);
	var ExecutionEnvironment = __webpack_require__(439);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactUpdates = __webpack_require__(447);
	var SyntheticEvent = __webpack_require__(444);
	
	var inputValueTracking = __webpack_require__(455);
	var getEventTarget = __webpack_require__(456);
	var isEventSupported = __webpack_require__(457);
	var isTextInputElement = __webpack_require__(458);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426),
	    _assign = __webpack_require__(395);
	
	var CallbackQueue = __webpack_require__(448);
	var PooledClass = __webpack_require__(441);
	var ReactFeatureFlags = __webpack_require__(449);
	var ReactReconciler = __webpack_require__(450);
	var Transaction = __webpack_require__(454);
	
	var invariant = __webpack_require__(403);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(441);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(451);
	var ReactInstrumentation = __webpack_require__(453);
	
	var warning = __webpack_require__(399);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(452);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(425);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(439);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 458 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(432);
	var ReactDOMComponentTree = __webpack_require__(425);
	var SyntheticMouseEvent = __webpack_require__(461);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(462);
	var ViewportMetrics = __webpack_require__(463);
	
	var getEventModifierState = __webpack_require__(464);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(444);
	
	var getEventTarget = __webpack_require__(456);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 463 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 464 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(427);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(467);
	var ReactDOMIDOperations = __webpack_require__(478);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(468);
	var Danger = __webpack_require__(474);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactInstrumentation = __webpack_require__(453);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(471);
	var setInnerHTML = __webpack_require__(470);
	var setTextContent = __webpack_require__(472);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(469);
	var setInnerHTML = __webpack_require__(470);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(471);
	var setTextContent = __webpack_require__(472);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(439);
	var DOMNamespaces = __webpack_require__(469);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(471);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(439);
	var escapeTextContentForBrowser = __webpack_require__(473);
	var setInnerHTML = __webpack_require__(470);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var DOMLazyTree = __webpack_require__(468);
	var ExecutionEnvironment = __webpack_require__(439);
	
	var createNodesFromMarkup = __webpack_require__(475);
	var emptyFunction = __webpack_require__(400);
	var invariant = __webpack_require__(403);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(439);
	
	var createArrayFromMixed = __webpack_require__(476);
	var getMarkupWrap = __webpack_require__(477);
	var invariant = __webpack_require__(403);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(403);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(439);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(467);
	var ReactDOMComponentTree = __webpack_require__(425);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426),
	    _assign = __webpack_require__(395);
	
	var AutoFocusUtils = __webpack_require__(480);
	var CSSPropertyOperations = __webpack_require__(482);
	var DOMLazyTree = __webpack_require__(468);
	var DOMNamespaces = __webpack_require__(469);
	var DOMProperty = __webpack_require__(427);
	var DOMPropertyOperations = __webpack_require__(490);
	var EventPluginHub = __webpack_require__(433);
	var EventPluginRegistry = __webpack_require__(434);
	var ReactBrowserEventEmitter = __webpack_require__(492);
	var ReactDOMComponentFlags = __webpack_require__(428);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactDOMInput = __webpack_require__(495);
	var ReactDOMOption = __webpack_require__(498);
	var ReactDOMSelect = __webpack_require__(499);
	var ReactDOMTextarea = __webpack_require__(500);
	var ReactInstrumentation = __webpack_require__(453);
	var ReactMultiChild = __webpack_require__(501);
	var ReactServerRenderingTransaction = __webpack_require__(519);
	
	var emptyFunction = __webpack_require__(400);
	var escapeTextContentForBrowser = __webpack_require__(473);
	var invariant = __webpack_require__(403);
	var isEventSupported = __webpack_require__(457);
	var shallowEqual = __webpack_require__(508);
	var inputValueTracking = __webpack_require__(455);
	var validateDOMNesting = __webpack_require__(522);
	var warning = __webpack_require__(399);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(425);
	
	var focusNode = __webpack_require__(481);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(483);
	var ExecutionEnvironment = __webpack_require__(439);
	var ReactInstrumentation = __webpack_require__(453);
	
	var camelizeStyleName = __webpack_require__(484);
	var dangerousStyleValue = __webpack_require__(486);
	var hyphenateStyleName = __webpack_require__(487);
	var memoizeStringOnly = __webpack_require__(489);
	var warning = __webpack_require__(399);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 483 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(485);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(483);
	var warning = __webpack_require__(399);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(488);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 488 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(427);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactInstrumentation = __webpack_require__(453);
	
	var quoteAttributeValueForBrowser = __webpack_require__(491);
	var warning = __webpack_require__(399);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(473);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var EventPluginRegistry = __webpack_require__(434);
	var ReactEventEmitterMixin = __webpack_require__(493);
	var ViewportMetrics = __webpack_require__(463);
	
	var getVendorPrefixedEventName = __webpack_require__(494);
	var isEventSupported = __webpack_require__(457);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(433);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(439);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426),
	    _assign = __webpack_require__(395);
	
	var DOMPropertyOperations = __webpack_require__(490);
	var LinkedValueUtils = __webpack_require__(496);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactUpdates = __webpack_require__(447);
	
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var ReactPropTypesSecret = __webpack_require__(497);
	var propTypesFactory = __webpack_require__(415);
	
	var React = __webpack_require__(394);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 497 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var React = __webpack_require__(394);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactDOMSelect = __webpack_require__(499);
	
	var warning = __webpack_require__(399);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var LinkedValueUtils = __webpack_require__(496);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactUpdates = __webpack_require__(447);
	
	var warning = __webpack_require__(399);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426),
	    _assign = __webpack_require__(395);
	
	var LinkedValueUtils = __webpack_require__(496);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactUpdates = __webpack_require__(447);
	
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var ReactComponentEnvironment = __webpack_require__(502);
	var ReactInstanceMap = __webpack_require__(503);
	var ReactInstrumentation = __webpack_require__(453);
	
	var ReactCurrentOwner = __webpack_require__(408);
	var ReactReconciler = __webpack_require__(450);
	var ReactChildReconciler = __webpack_require__(504);
	
	var emptyFunction = __webpack_require__(400);
	var flattenChildren = __webpack_require__(518);
	var invariant = __webpack_require__(403);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(450);
	
	var instantiateReactComponent = __webpack_require__(505);
	var KeyEscapeUtils = __webpack_require__(513);
	var shouldUpdateReactComponent = __webpack_require__(509);
	var traverseAllChildren = __webpack_require__(514);
	var warning = __webpack_require__(399);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(517);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426),
	    _assign = __webpack_require__(395);
	
	var ReactCompositeComponent = __webpack_require__(506);
	var ReactEmptyComponent = __webpack_require__(510);
	var ReactHostComponent = __webpack_require__(511);
	
	var getNextDebugID = __webpack_require__(512);
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426),
	    _assign = __webpack_require__(395);
	
	var React = __webpack_require__(394);
	var ReactComponentEnvironment = __webpack_require__(502);
	var ReactCurrentOwner = __webpack_require__(408);
	var ReactErrorUtils = __webpack_require__(436);
	var ReactInstanceMap = __webpack_require__(503);
	var ReactInstrumentation = __webpack_require__(453);
	var ReactNodeTypes = __webpack_require__(507);
	var ReactReconciler = __webpack_require__(450);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(402);
	var invariant = __webpack_require__(403);
	var shallowEqual = __webpack_require__(508);
	var shouldUpdateReactComponent = __webpack_require__(509);
	var warning = __webpack_require__(399);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var React = __webpack_require__(394);
	
	var invariant = __webpack_require__(403);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 510 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 513 */
412,
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var ReactCurrentOwner = __webpack_require__(408);
	var REACT_ELEMENT_TYPE = __webpack_require__(515);
	
	var getIteratorFn = __webpack_require__(516);
	var invariant = __webpack_require__(403);
	var KeyEscapeUtils = __webpack_require__(513);
	var warning = __webpack_require__(399);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 515 */
409,
/* 516 */
411,
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(397);
	
	var ReactCurrentOwner = __webpack_require__(408);
	
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(513);
	var traverseAllChildren = __webpack_require__(514);
	var warning = __webpack_require__(399);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production"}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(517);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var PooledClass = __webpack_require__(441);
	var Transaction = __webpack_require__(454);
	var ReactInstrumentation = __webpack_require__(453);
	var ReactServerUpdateQueue = __webpack_require__(520);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(521);
	
	var warning = __webpack_require__(399);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var ReactCurrentOwner = __webpack_require__(408);
	var ReactInstanceMap = __webpack_require__(503);
	var ReactInstrumentation = __webpack_require__(453);
	var ReactUpdates = __webpack_require__(447);
	
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var emptyFunction = __webpack_require__(400);
	var warning = __webpack_require__(399);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var DOMLazyTree = __webpack_require__(468);
	var ReactDOMComponentTree = __webpack_require__(425);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426),
	    _assign = __webpack_require__(395);
	
	var DOMChildrenOperations = __webpack_require__(467);
	var DOMLazyTree = __webpack_require__(468);
	var ReactDOMComponentTree = __webpack_require__(425);
	
	var escapeTextContentForBrowser = __webpack_require__(473);
	var invariant = __webpack_require__(403);
	var validateDOMNesting = __webpack_require__(522);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var ReactUpdates = __webpack_require__(447);
	var Transaction = __webpack_require__(454);
	
	var emptyFunction = __webpack_require__(400);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var EventListener = __webpack_require__(528);
	var ExecutionEnvironment = __webpack_require__(439);
	var PooledClass = __webpack_require__(441);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactUpdates = __webpack_require__(447);
	
	var getEventTarget = __webpack_require__(456);
	var getUnboundedScrollPosition = __webpack_require__(529);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(400);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 529 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(427);
	var EventPluginHub = __webpack_require__(433);
	var EventPluginUtils = __webpack_require__(435);
	var ReactComponentEnvironment = __webpack_require__(502);
	var ReactEmptyComponent = __webpack_require__(510);
	var ReactBrowserEventEmitter = __webpack_require__(492);
	var ReactHostComponent = __webpack_require__(511);
	var ReactUpdates = __webpack_require__(447);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(395);
	
	var CallbackQueue = __webpack_require__(448);
	var PooledClass = __webpack_require__(441);
	var ReactBrowserEventEmitter = __webpack_require__(492);
	var ReactInputSelection = __webpack_require__(532);
	var ReactInstrumentation = __webpack_require__(453);
	var Transaction = __webpack_require__(454);
	var ReactUpdateQueue = __webpack_require__(521);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(533);
	
	var containsNode = __webpack_require__(535);
	var focusNode = __webpack_require__(481);
	var getActiveElement = __webpack_require__(538);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(439);
	
	var getNodeForCharacterOffset = __webpack_require__(534);
	var getTextContentAccessor = __webpack_require__(442);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 534 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(536);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(537);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 538 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 539 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(432);
	var ExecutionEnvironment = __webpack_require__(439);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactInputSelection = __webpack_require__(532);
	var SyntheticEvent = __webpack_require__(444);
	
	var getActiveElement = __webpack_require__(538);
	var isTextInputElement = __webpack_require__(458);
	var shallowEqual = __webpack_require__(508);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var EventListener = __webpack_require__(528);
	var EventPropagators = __webpack_require__(432);
	var ReactDOMComponentTree = __webpack_require__(425);
	var SyntheticAnimationEvent = __webpack_require__(542);
	var SyntheticClipboardEvent = __webpack_require__(543);
	var SyntheticEvent = __webpack_require__(444);
	var SyntheticFocusEvent = __webpack_require__(544);
	var SyntheticKeyboardEvent = __webpack_require__(545);
	var SyntheticMouseEvent = __webpack_require__(461);
	var SyntheticDragEvent = __webpack_require__(548);
	var SyntheticTouchEvent = __webpack_require__(549);
	var SyntheticTransitionEvent = __webpack_require__(550);
	var SyntheticUIEvent = __webpack_require__(462);
	var SyntheticWheelEvent = __webpack_require__(551);
	
	var emptyFunction = __webpack_require__(400);
	var getEventCharCode = __webpack_require__(546);
	var invariant = __webpack_require__(403);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(444);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(444);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(462);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(462);
	
	var getEventCharCode = __webpack_require__(546);
	var getEventKey = __webpack_require__(547);
	var getEventModifierState = __webpack_require__(464);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 546 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(546);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(461);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(462);
	
	var getEventModifierState = __webpack_require__(464);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(444);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(461);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var DOMLazyTree = __webpack_require__(468);
	var DOMProperty = __webpack_require__(427);
	var React = __webpack_require__(394);
	var ReactBrowserEventEmitter = __webpack_require__(492);
	var ReactCurrentOwner = __webpack_require__(408);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactDOMContainerInfo = __webpack_require__(553);
	var ReactDOMFeatureFlags = __webpack_require__(554);
	var ReactFeatureFlags = __webpack_require__(449);
	var ReactInstanceMap = __webpack_require__(503);
	var ReactInstrumentation = __webpack_require__(453);
	var ReactMarkupChecksum = __webpack_require__(555);
	var ReactReconciler = __webpack_require__(450);
	var ReactUpdateQueue = __webpack_require__(521);
	var ReactUpdates = __webpack_require__(447);
	
	var emptyObject = __webpack_require__(402);
	var instantiateReactComponent = __webpack_require__(505);
	var invariant = __webpack_require__(403);
	var setInnerHTML = __webpack_require__(470);
	var shouldUpdateReactComponent = __webpack_require__(509);
	var warning = __webpack_require__(399);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(522);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 554 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(556);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 557 */
419,
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(426);
	
	var ReactCurrentOwner = __webpack_require__(408);
	var ReactDOMComponentTree = __webpack_require__(425);
	var ReactInstanceMap = __webpack_require__(503);
	
	var getHostComponentFromComposite = __webpack_require__(559);
	var invariant = __webpack_require__(403);
	var warning = __webpack_require__(399);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(507);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(552);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(562);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(568);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(393);
	
	var _propTypes = __webpack_require__(563);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(566);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(567);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(564)();
	}


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(565);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 565 */
417,
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(563);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 567 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(393);
	
	var _storeShape = __webpack_require__(566);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(569);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(570);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(567);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(591);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(601);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(571);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(572);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(586);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(588);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(589);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(590);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(587);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(573);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(583);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 573 */
[895, 574, 580, 582],
/* 574 */
[896, 575, 578, 579],
/* 575 */
[897, 576],
/* 576 */
[898, 577],
/* 577 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 578 */
[899, 575],
/* 579 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 580 */
[900, 581],
/* 581 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(585);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(584)(module)))

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(572);
	
	var _isPlainObject = __webpack_require__(573);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(587);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(590);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 591 */
[895, 592, 598, 600],
/* 592 */
[896, 593, 596, 597],
/* 593 */
[897, 594],
/* 594 */
[898, 595],
/* 595 */
577,
/* 596 */
[899, 593],
/* 597 */
579,
/* 598 */
[900, 599],
/* 599 */
581,
/* 600 */
582,
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(602);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(603);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),
/* 603 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(606);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(607);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(612);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(613);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(644);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(645);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(646);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(648);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(650);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(649);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(651);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(652);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(653);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(654);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(655);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(641);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(656);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(657);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(661);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(662);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(663);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(666);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(658);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(393);
	
	var _deprecateObjectProperties = __webpack_require__(608);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(611);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(610);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(393);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(614);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(630);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(633);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(611);
	
	var _RouterContext = __webpack_require__(641);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(606);
	
	var _RouterUtils = __webpack_require__(643);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // Deprecated:
	    parseQueryString: func,
	    stringifyQuery: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(616);
	
	var _PathUtils = __webpack_require__(617);
	
	var _ExecutionEnvironment = __webpack_require__(618);
	
	var _DOMUtils = __webpack_require__(619);
	
	var _DOMStateStorage = __webpack_require__(620);
	
	var _createDOMHistory = __webpack_require__(621);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ }),
/* 615 */
610,
/* 616 */
/***/ (function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(618);
	
	var _DOMUtils = __webpack_require__(619);
	
	var _createHistory = __webpack_require__(622);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(623);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(617);
	
	var _AsyncUtils = __webpack_require__(626);
	
	var _Actions = __webpack_require__(616);
	
	var _createLocation2 = __webpack_require__(627);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(628);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(629);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(624);
	var isArguments = __webpack_require__(625);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 624 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 625 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(616);
	
	var _PathUtils = __webpack_require__(617);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(631);
	
	var _runTransitionHook = __webpack_require__(628);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(617);
	
	var _deprecate = __webpack_require__(629);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(632);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 632 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(634);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(635);
	
	var _isActive2 = __webpack_require__(637);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(638);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(640);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	
	module.exports = exports['default'];

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(612);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(636);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes, prevState) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	  }
	}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(612);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(636);
	
	var _makeStateWithLocation = __webpack_require__(639);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(608);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(636);
	
	var _makeStateWithLocation = __webpack_require__(639);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(612);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(606);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(608);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(642);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(606);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(612);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(608);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]),
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    var _props = this.props;
	    var to = _props.to;
	    var query = _props.query;
	    var hash = _props.hash;
	    var state = _props.state;
	
	    var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	    this.context.router.push(location);
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (to == null) {
	        return _react2.default.createElement('a', props);
	      }
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(644);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(647);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      var props = _extends({}, this.props, { router: router });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(649);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(606);
	
	var _PatternUtils = __webpack_require__(612);
	
	var _InternalPropTypes = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(606);
	
	var _InternalPropTypes = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(606);
	
	var _InternalPropTypes = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(611);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(630);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(633);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(641);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(616);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(658);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(633);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(606);
	
	var _RouterUtils = __webpack_require__(643);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation && router.createLocation(redirectLocation, _Actions.REPLACE), nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(630);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(659);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(660);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(618);
	
	var _PathUtils = __webpack_require__(617);
	
	var _runTransitionHook = __webpack_require__(628);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(629);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(615);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(617);
	
	var _Actions = __webpack_require__(616);
	
	var _createHistory = __webpack_require__(622);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(630);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(659);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(641);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(609);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(664);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(665);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(604);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(616);
	
	var _PathUtils = __webpack_require__(617);
	
	var _ExecutionEnvironment = __webpack_require__(618);
	
	var _DOMUtils = __webpack_require__(619);
	
	var _DOMStateStorage = __webpack_require__(620);
	
	var _createDOMHistory = __webpack_require__(621);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(661);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(614);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(665);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(668);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(669);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(670);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(671);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(668);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(669);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GettingStarted = exports.Themes = exports.Layouts = exports.Components = exports.Core = exports.Brand = exports.Home = exports.App = undefined;
	
	var _App2 = __webpack_require__(673);
	
	var _App3 = _interopRequireDefault(_App2);
	
	var _Home2 = __webpack_require__(674);
	
	var _Home3 = _interopRequireDefault(_Home2);
	
	var _Brand2 = __webpack_require__(883);
	
	var _Brand3 = _interopRequireDefault(_Brand2);
	
	var _Core2 = __webpack_require__(884);
	
	var _Core3 = _interopRequireDefault(_Core2);
	
	var _Components2 = __webpack_require__(885);
	
	var _Components3 = _interopRequireDefault(_Components2);
	
	var _Layouts2 = __webpack_require__(886);
	
	var _Layouts3 = _interopRequireDefault(_Layouts2);
	
	var _Themes2 = __webpack_require__(887);
	
	var _Themes3 = _interopRequireDefault(_Themes2);
	
	var _GettingStarted2 = __webpack_require__(888);
	
	var _GettingStarted3 = _interopRequireDefault(_GettingStarted2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.App = _App3.default;
	exports.Home = _Home3.default;
	exports.Brand = _Brand3.default;
	exports.Core = _Core3.default;
	exports.Components = _Components3.default;
	exports.Layouts = _Layouts3.default;
	exports.Themes = _Themes3.default;
	exports.GettingStarted = _GettingStarted3.default;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = App;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function App(_ref) {
	  var children = _ref.children;
	
	  return _get__('React').createElement(
	    'div',
	    null,
	    children
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof App === 'undefined' ? 'undefined' : _typeof(App);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(App, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(App)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(561);
	
	var _redux = __webpack_require__(571);
	
	var _Sidebar = __webpack_require__(675);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainMenu = __webpack_require__(677);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _DynamicSection = __webpack_require__(678);
	
	var _DynamicSection2 = _interopRequireDefault(_DynamicSection);
	
	var _actions = __webpack_require__(881);
	
	var ComponentActions = _interopRequireWildcard(_actions);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_get__2) {
	  _inherits(Home, _get__2);
	
	  function Home(_ref) {
	    var components = _ref.components;
	
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this));
	  }
	
	  _createClass(Home, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(function () {
	        _get__('commonUI').initializeNavigation();
	        $('.fitText').fitText(1.2, { minFontSize: '20px', maxFontSize: '110px' });
	        _get__('offcanvasMenu')();
	        _get__('initPlugins')();
	      }, 0);
	    }
	  }, {
	    key: 'getFilteredContent',
	    value: function getFilteredContent(components) {
	      return components.Home;
	    }
	  }, {
	    key: 'renderMainMenu',
	    value: function renderMainMenu(components, staticVersion) {
	      return _get__('React').createElement(_get__('MainMenu'), { selected: 'Home', components: components, staticVersion: staticVersion });
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(filteredContent, staticVersion) {
	      return _get__('React').createElement(_get__('Sidebar'), { sections: [], selected: 'Home', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var components = this.props.components;
	
	      var staticVersion = this.props.config.staticVersion;
	      var filteredContent = this.getFilteredContent(components);
	
	      return _get__('React').createElement(
	        'div',
	        null,
	        this.renderMainMenu(components, staticVersion),
	        this.renderSidebar(filteredContent, staticVersion),
	        _get__('React').createElement(
	          'div',
	          { id: 'main', className: 'content--full' },
	          filteredContent.map(function (object, index) {
	            return _get__('React').createElement(_get__('DynamicSection'), {
	              key: object.template,
	              sectionName: object.template,
	              staticVersion: staticVersion });
	          })
	        )
	      );
	    }
	  }]);
	
	  return Home;
	}(_get__('Component'));
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: _get__('bindActionCreators')(_get__('ComponentActions'), dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return { components: state.components, config: state.config };
	}
	
	var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Home'));
	
	exports.default = _DefaultExportValue;

	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;

	    case 'offcanvasMenu':
	      return _utils.offcanvasMenu;

	    case 'initPlugins':
	      return _utils.initPlugins;

	    case 'Component':
	      return _react.Component;

	    case 'bindActionCreators':
	      return _redux.bindActionCreators;

	    case 'ComponentActions':
	      return _filterWildcardImport__(ComponentActions);

	    case 'connect':
	      return _reactRedux.connect;

	    case 'mapStateToProps':
	      return mapStateToProps;

	    case 'mapDispatchToProps':
	      return mapDispatchToProps;

	    case 'Home':
	      return Home;

	    case 'React':
	      return _react2.default;

	    case 'MainMenu':
	      return _MainMenu2.default;

	    case 'Sidebar':
	      return _Sidebar2.default;

	    case 'DynamicSection':
	      return _DynamicSection2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(_DefaultExportValue, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(605);
	
	var _classnames = __webpack_require__(676);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = function (_get__2) {
	  _inherits(Sidebar, _get__2);
	
	  function Sidebar(props) {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, (Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call(this, props));
	  }
	
	  _createClass(Sidebar, [{
	    key: 'renderSubMenu',
	    value: function renderSubMenu(sections, order, staticVersion) {
	      if (sections.length > 0) {
	        return _get__('React').createElement(
	          'li',
	          { className: 'grid--order-' + order },
	          _get__('React').createElement(
	            'ul',
	            { className: 'nav__submenu flush' },
	            sections.map(function (object, i) {
	              if (staticVersion === false || object.includeStatic !== false) {
	                return _get__('React').createElement(
	                  'li',
	                  { key: object.anchor },
	                  _get__('React').createElement(
	                    'a',
	                    { className: 'clearfix', href: object.anchor },
	                    object.name,
	                    function () {
	                      if (object.js) {
	                        return _get__('React').createElement(
	                          'code',
	                          { className: 'float--right' },
	                          'JS'
	                        );
	                      }
	                    }()
	                  )
	                );
	              }
	            })
	          )
	        );
	      }
	      return;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          sections = _props.sections,
	          selected = _props.selected;
	
	      var order = 12;
	      switch (selected) {
	        case 'Home':
	          order = 1;
	          break;
	        case 'Brand':
	          order = 3;
	          break;
	        case 'Core':
	          order = 5;
	          break;
	        case 'Components':
	          order = 7;
	          break;
	        case 'Layouts':
	          order = 9;
	          break;
	        case 'Themes':
	          order = 9;
	          break;
	        case 'GettingStarted':
	          order = 11;
	          break;
	      }
	
	      return _get__('React').createElement(
	        'nav',
	        { className: 'sidebar js-home hide', id: 'menu' },
	        _get__('React').createElement(
	          'ul',
	          { className: 'nav--branded-main grid grid--direction-column' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid--order-0 visuallyhidden--lap-and-up' },
	            _get__('React').createElement(
	              _get__('Link'),
	              { to: 'home' },
	              'Home'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid--order-2 visuallyhidden--lap-and-up' },
	            _get__('React').createElement(
	              _get__('Link'),
	              { to: 'brand' },
	              'Brand'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid--order-4 visuallyhidden--lap-and-up' },
	            _get__('React').createElement(
	              _get__('Link'),
	              { to: 'core' },
	              'Core'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid--order-6 visuallyhidden--lap-and-up' },
	            _get__('React').createElement(
	              _get__('Link'),
	              { to: 'components' },
	              'Components'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid--order-8 visuallyhidden--lap-and-up' },
	            _get__('React').createElement(
	              _get__('Link'),
	              { to: 'layouts' },
	              'Layouts'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid--order-8 visuallyhidden--lap-and-up' },
	            _get__('React').createElement(
	              _get__('Link'),
	              { to: 'themes' },
	              'Themese'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid--order-10 visuallyhidden--lap-and-up' },
	            _get__('React').createElement(
	              _get__('Link'),
	              { to: 'getting-started' },
	              'Getting Started'
	            )
	          ),
	          this.renderSubMenu(sections, order, this.props.staticVersion)
	        )
	      );
	    }
	  }]);
	
	  return Sidebar;
	}(_get__('Component'));
	
	exports.default = _get__('Sidebar');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Sidebar':
	      return Sidebar;
	
	    case 'React':
	      return _react2.default;
	
	    case 'Link':
	      return _reactRouter.Link;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Sidebar === 'undefined' ? 'undefined' : _typeof(Sidebar);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Sidebar, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Sidebar)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(605);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MainMenu = function (_get__2) {
	  _inherits(MainMenu, _get__2);
	
	  function MainMenu(props) {
	    _classCallCheck(this, MainMenu);
	
	    return _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).call(this, props));
	  }
	
	  _createClass(MainMenu, [{
	    key: 'renderLink',
	    value: function renderLink(staticVersion, primaryMenuItem, secondaryMenuItem) {
	      return staticVersion ? _get__('React').createElement(
	        'a',
	        { href: staticVersion == true ? '#' + primaryMenuItem.toLowerCase().replace(" ", "-") + '/' + secondaryMenuItem.anchor.replace('#', '') : primaryMenuItem.toLowerCase().replace(" ", "-") + secondaryMenuItem.anchor },
	        secondaryMenuItem.name
	      ) : _get__('React').createElement(
	        _get__('Link'),
	        { to: staticVersion == true ? '#' + primaryMenuItem.toLowerCase().replace(" ", "-") + '/' + secondaryMenuItem.anchor.replace('#', '') : primaryMenuItem.toLowerCase().replace(" ", "-") + secondaryMenuItem.anchor },
	        secondaryMenuItem.name
	      );
	    }
	  }, {
	    key: 'renderMenu',
	    value: function renderMenu(menuItems, selected, staticVersion) {
	      var _this = this;
	      return _get__('React').createElement(
	        'ul',
	        { className: 'nav__items--primary' },
	        Object.keys(menuItems).map(function (primaryMenuItem, i) {
	          return _get__('React').createElement(
	            'li',
	            { key: primaryMenuItem + "__" + i, className: "nav__item--primary has-children " + (primaryMenuItem === selected ? "is-active" : "") },
	            _get__('React').createElement(
	              'a',
	              null,
	              primaryMenuItem
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'nav__items--secondary' },
	              menuItems[primaryMenuItem].map(function (secondaryMenuItem, j) {
	                if (staticVersion === false || secondaryMenuItem.includeStatic !== false) {
	                  return _get__('React').createElement(
	                    'li',
	                    { key: primaryMenuItem + "__" + secondaryMenuItem.name, className: 'nav__item--secondary' },
	                    _this.renderLink(staticVersion, primaryMenuItem, secondaryMenuItem)
	                  );
	                }
	              })
	            )
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          selected = _props.selected,
	          staticVersion = _props.staticVersion,
	          components = _props.components;
	
	      return _get__('React').createElement(
	        'nav',
	        { className: 'nav nav--dark nav--global fixed drop-shadow js-nav' },
	        _get__('React').createElement(
	          'div',
	          { className: 'nav__inner' },
	          _get__('React').createElement(
	            'div',
	            { className: 'nav__header' },
	            _get__('React').createElement('a', { className: 'nav__logo', href: '//www.cmegroup.com', rel: 'external', target: '_blank', title: 'CME Group' }),
	            _get__('React').createElement(
	              'h1',
	              { className: 'nav__app-name' },
	              'Common UI'
	            )
	          ),
	          this.renderMenu(components, selected, staticVersion),
	          _get__('React').createElement(
	            'ul',
	            { className: 'nav__actions' },
	            _get__('React').createElement(
	              'li',
	              { className: 'nav__action' },
	              _get__('React').createElement(
	                'small',
	                null,
	                'v1.28.0.6'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MainMenu;
	}(_get__('Component'));
	
	exports.default = _get__('MainMenu');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'MainMenu':
	      return MainMenu;
	
	    case 'React':
	      return _react2.default;
	
	    case 'Link':
	      return _reactRouter.Link;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof MainMenu === 'undefined' ? 'undefined' : _typeof(MainMenu);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(MainMenu, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(MainMenu)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sections = __webpack_require__(679);
	
	var Sections = _interopRequireWildcard(_sections);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DynamicSection = function (_get__2) {
	  _inherits(DynamicSection, _get__2);
	
	  function DynamicSection(props) {
	    _classCallCheck(this, DynamicSection);
	
	    return _possibleConstructorReturn(this, (DynamicSection.__proto__ || Object.getPrototypeOf(DynamicSection)).call(this, props));
	  }
	
	  _createClass(DynamicSection, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var InputType = _get__('Sections')[this.props.sectionName];
	      return _get__('React').createElement(InputType, { onIncludeClick: function onIncludeClick() {
	          return _this2.props.onIncludeClick();
	        }, included: this.props.included, staticVersion: this.props.staticVersion });
	    }
	  }]);
	
	  return DynamicSection;
	}(_get__('Component'));
	
	exports.default = _get__('DynamicSection');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Sections':
	      return _filterWildcardImport__(Sections);
	
	    case 'Component':
	      return _react.Component;
	
	    case 'DynamicSection':
	      return DynamicSection;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof DynamicSection === 'undefined' ? 'undefined' : _typeof(DynamicSection);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(DynamicSection, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(DynamicSection)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BrowserCompatibility = exports.ChangeLog = exports.Support = exports.Installation = exports.BuildDetail = exports.ComponentsShowcase = exports.AgGrid = exports.LayoutsErrors = exports.LayoutsUpdateBrowser = exports.LayoutsCoreUI = exports.LayoutsEREP = exports.LayoutsSignIn = exports.LayoutsMarketing = exports.LayoutsGrid = exports.DismissableSidebarPanel = exports.Breakpoints = exports.Tick = exports.Drawers = exports.BackToTop = exports.EnvironmentBanners = exports.Helpers = exports.Loaders = exports.Panels = exports.SplitPanel = exports.Accordion = exports.Search = exports.Nav = exports.Wizard = exports.Toggles = exports.Breadcrumb = exports.Pagination = exports.Carousel = exports.Modals = exports.CountdownTimer = exports.Tooltips = exports.Grid = exports.Wells = exports.Media = exports.Cards = exports.Callouts = exports.Datepicker = exports.Progress = exports.Tabs = exports.Toasts = exports.Alerts = exports.DataTables = exports.Tables = exports.FileComponent = exports.Dropzone = exports.Forms = exports.Icons = exports.Filters = exports.ButtonDropdowns = exports.Buttons = exports.Badges = exports.Appify = exports.Logo = exports.Colors = exports.Typography = exports.Intro = undefined;
	
	var _FileComponent2 = __webpack_require__(680);
	
	var _FileComponent3 = _interopRequireDefault(_FileComponent2);
	
	var _Intro2 = __webpack_require__(804);
	
	var _Intro3 = _interopRequireDefault(_Intro2);
	
	var _Typography2 = __webpack_require__(805);
	
	var _Typography3 = _interopRequireDefault(_Typography2);
	
	var _Colors2 = __webpack_require__(807);
	
	var _Colors3 = _interopRequireDefault(_Colors2);
	
	var _Logo2 = __webpack_require__(811);
	
	var _Logo3 = _interopRequireDefault(_Logo2);
	
	var _Appify2 = __webpack_require__(812);
	
	var _Appify3 = _interopRequireDefault(_Appify2);
	
	var _Badges2 = __webpack_require__(813);
	
	var _Badges3 = _interopRequireDefault(_Badges2);
	
	var _Buttons2 = __webpack_require__(814);
	
	var _Buttons3 = _interopRequireDefault(_Buttons2);
	
	var _ButtonDropdowns2 = __webpack_require__(815);
	
	var _ButtonDropdowns3 = _interopRequireDefault(_ButtonDropdowns2);
	
	var _Filters2 = __webpack_require__(816);
	
	var _Filters3 = _interopRequireDefault(_Filters2);
	
	var _Icons2 = __webpack_require__(817);
	
	var _Icons3 = _interopRequireDefault(_Icons2);
	
	var _Forms2 = __webpack_require__(818);
	
	var _Forms3 = _interopRequireDefault(_Forms2);
	
	var _Dropzone2 = __webpack_require__(819);
	
	var _Dropzone3 = _interopRequireDefault(_Dropzone2);
	
	var _Tables2 = __webpack_require__(821);
	
	var _Tables3 = _interopRequireDefault(_Tables2);
	
	var _DataTables2 = __webpack_require__(823);
	
	var _DataTables3 = _interopRequireDefault(_DataTables2);
	
	var _Alerts2 = __webpack_require__(824);
	
	var _Alerts3 = _interopRequireDefault(_Alerts2);
	
	var _Toasts2 = __webpack_require__(825);
	
	var _Toasts3 = _interopRequireDefault(_Toasts2);
	
	var _Tabs2 = __webpack_require__(826);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Progress2 = __webpack_require__(827);
	
	var _Progress3 = _interopRequireDefault(_Progress2);
	
	var _Datepicker2 = __webpack_require__(828);
	
	var _Datepicker3 = _interopRequireDefault(_Datepicker2);
	
	var _Callouts2 = __webpack_require__(829);
	
	var _Callouts3 = _interopRequireDefault(_Callouts2);
	
	var _Cards2 = __webpack_require__(830);
	
	var _Cards3 = _interopRequireDefault(_Cards2);
	
	var _Media2 = __webpack_require__(831);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _Wells2 = __webpack_require__(832);
	
	var _Wells3 = _interopRequireDefault(_Wells2);
	
	var _Grid2 = __webpack_require__(833);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _Tooltips2 = __webpack_require__(834);
	
	var _Tooltips3 = _interopRequireDefault(_Tooltips2);
	
	var _CountdownTimer2 = __webpack_require__(835);
	
	var _CountdownTimer3 = _interopRequireDefault(_CountdownTimer2);
	
	var _Modals2 = __webpack_require__(836);
	
	var _Modals3 = _interopRequireDefault(_Modals2);
	
	var _Carousel2 = __webpack_require__(837);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _Pagination2 = __webpack_require__(838);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _Breadcrumb2 = __webpack_require__(839);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _Toggles2 = __webpack_require__(840);
	
	var _Toggles3 = _interopRequireDefault(_Toggles2);
	
	var _Wizard2 = __webpack_require__(841);
	
	var _Wizard3 = _interopRequireDefault(_Wizard2);
	
	var _Nav2 = __webpack_require__(842);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Search2 = __webpack_require__(843);
	
	var _Search3 = _interopRequireDefault(_Search2);
	
	var _Accordion2 = __webpack_require__(844);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _SplitPanel2 = __webpack_require__(851);
	
	var _SplitPanel3 = _interopRequireDefault(_SplitPanel2);
	
	var _Panels2 = __webpack_require__(852);
	
	var _Panels3 = _interopRequireDefault(_Panels2);
	
	var _Loaders2 = __webpack_require__(853);
	
	var _Loaders3 = _interopRequireDefault(_Loaders2);
	
	var _Helpers2 = __webpack_require__(854);
	
	var _Helpers3 = _interopRequireDefault(_Helpers2);
	
	var _EnvironmentBanners2 = __webpack_require__(855);
	
	var _EnvironmentBanners3 = _interopRequireDefault(_EnvironmentBanners2);
	
	var _BackToTop2 = __webpack_require__(856);
	
	var _BackToTop3 = _interopRequireDefault(_BackToTop2);
	
	var _Drawers2 = __webpack_require__(857);
	
	var _Drawers3 = _interopRequireDefault(_Drawers2);
	
	var _Tick2 = __webpack_require__(858);
	
	var _Tick3 = _interopRequireDefault(_Tick2);
	
	var _Breakpoints2 = __webpack_require__(859);
	
	var _Breakpoints3 = _interopRequireDefault(_Breakpoints2);
	
	var _DismissableSidebarPanel2 = __webpack_require__(860);
	
	var _DismissableSidebarPanel3 = _interopRequireDefault(_DismissableSidebarPanel2);
	
	var _LayoutsGrid2 = __webpack_require__(861);
	
	var _LayoutsGrid3 = _interopRequireDefault(_LayoutsGrid2);
	
	var _LayoutsMarketing2 = __webpack_require__(862);
	
	var _LayoutsMarketing3 = _interopRequireDefault(_LayoutsMarketing2);
	
	var _LayoutsSignIn2 = __webpack_require__(863);
	
	var _LayoutsSignIn3 = _interopRequireDefault(_LayoutsSignIn2);
	
	var _LayoutsEREP2 = __webpack_require__(864);
	
	var _LayoutsEREP3 = _interopRequireDefault(_LayoutsEREP2);
	
	var _LayoutsCoreUI2 = __webpack_require__(865);
	
	var _LayoutsCoreUI3 = _interopRequireDefault(_LayoutsCoreUI2);
	
	var _LayoutsUpdateBrowser2 = __webpack_require__(866);
	
	var _LayoutsUpdateBrowser3 = _interopRequireDefault(_LayoutsUpdateBrowser2);
	
	var _LayoutsErrors2 = __webpack_require__(867);
	
	var _LayoutsErrors3 = _interopRequireDefault(_LayoutsErrors2);
	
	var _AgGrid2 = __webpack_require__(874);
	
	var _AgGrid3 = _interopRequireDefault(_AgGrid2);
	
	var _ComponentsShowcase2 = __webpack_require__(875);
	
	var _ComponentsShowcase3 = _interopRequireDefault(_ComponentsShowcase2);
	
	var _BuildDetail2 = __webpack_require__(876);
	
	var _BuildDetail3 = _interopRequireDefault(_BuildDetail2);
	
	var _Installation2 = __webpack_require__(877);
	
	var _Installation3 = _interopRequireDefault(_Installation2);
	
	var _Support2 = __webpack_require__(878);
	
	var _Support3 = _interopRequireDefault(_Support2);
	
	var _ChangeLog2 = __webpack_require__(879);
	
	var _ChangeLog3 = _interopRequireDefault(_ChangeLog2);
	
	var _BrowserCompatibility2 = __webpack_require__(880);
	
	var _BrowserCompatibility3 = _interopRequireDefault(_BrowserCompatibility2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Intro = _Intro3.default;
	//Brand
	
	
	//Home
	
	exports.Typography = _Typography3.default;
	exports.Colors = _Colors3.default;
	exports.Logo = _Logo3.default;
	exports.Appify = _Appify3.default;
	//Components
	
	exports.Badges = _Badges3.default;
	exports.Buttons = _Buttons3.default;
	exports.ButtonDropdowns = _ButtonDropdowns3.default;
	exports.Filters = _Filters3.default;
	exports.Icons = _Icons3.default;
	exports.Forms = _Forms3.default;
	exports.Dropzone = _Dropzone3.default;
	exports.FileComponent = _FileComponent3.default;
	exports.Tables = _Tables3.default;
	exports.DataTables = _DataTables3.default;
	exports.Alerts = _Alerts3.default;
	exports.Toasts = _Toasts3.default;
	exports.Tabs = _Tabs3.default;
	exports.Progress = _Progress3.default;
	exports.Datepicker = _Datepicker3.default;
	exports.Callouts = _Callouts3.default;
	exports.Cards = _Cards3.default;
	exports.Media = _Media3.default;
	exports.Wells = _Wells3.default;
	exports.Grid = _Grid3.default;
	exports.Tooltips = _Tooltips3.default;
	exports.CountdownTimer = _CountdownTimer3.default;
	exports.Modals = _Modals3.default;
	exports.Carousel = _Carousel3.default;
	exports.Pagination = _Pagination3.default;
	exports.Breadcrumb = _Breadcrumb3.default;
	exports.Toggles = _Toggles3.default;
	exports.Wizard = _Wizard3.default;
	exports.Nav = _Nav3.default;
	exports.Search = _Search3.default;
	exports.Accordion = _Accordion3.default;
	exports.SplitPanel = _SplitPanel3.default;
	exports.Panels = _Panels3.default;
	exports.Loaders = _Loaders3.default;
	exports.Helpers = _Helpers3.default;
	exports.EnvironmentBanners = _EnvironmentBanners3.default;
	exports.BackToTop = _BackToTop3.default;
	exports.Drawers = _Drawers3.default;
	exports.Tick = _Tick3.default;
	exports.Breakpoints = _Breakpoints3.default;
	exports.DismissableSidebarPanel = _DismissableSidebarPanel3.default;
	//Layouts
	
	exports.LayoutsGrid = _LayoutsGrid3.default;
	exports.LayoutsMarketing = _LayoutsMarketing3.default;
	exports.LayoutsSignIn = _LayoutsSignIn3.default;
	exports.LayoutsEREP = _LayoutsEREP3.default;
	exports.LayoutsCoreUI = _LayoutsCoreUI3.default;
	exports.LayoutsUpdateBrowser = _LayoutsUpdateBrowser3.default;
	exports.LayoutsErrors = _LayoutsErrors3.default;
	// Themes
	
	exports.AgGrid = _AgGrid3.default;
	exports.ComponentsShowcase = _ComponentsShowcase3.default;
	//Build
	
	exports.BuildDetail = _BuildDetail3.default;
	exports.Installation = _Installation3.default;
	exports.Support = _Support3.default;
	exports.ChangeLog = _ChangeLog3.default;
	exports.BrowserCompatibility = _BrowserCompatibility3.default;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var React = _interopRequireWildcard(_react);
	
	var _filesize = __webpack_require__(681);
	
	var filesize = _interopRequireWildcard(_filesize);
	
	var _momentEs = __webpack_require__(682);
	
	var _momentEs2 = _interopRequireDefault(_momentEs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FileComponent = function (_get__2) {
	    _inherits(FileComponent, _get__2);
	
	    function FileComponent(props) {
	        _classCallCheck(this, FileComponent);
	
	        var _this = _possibleConstructorReturn(this, (FileComponent.__proto__ || Object.getPrototypeOf(FileComponent)).call(this, props));
	
	        _this.onClearButtonClicked = _this.onClearButtonClicked.bind(_this);
	        return _this;
	    }
	
	    _createClass(FileComponent, [{
	        key: 'onClearButtonClicked',
	        value: function onClearButtonClicked() {
	            this.props.onFileClosed();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var file = this.props.file;
	
	
	            return _get__('React').createElement(
	                'div',
	                { className: 'attachment' },
	                _get__('React').createElement(
	                    'div',
	                    { className: 'attachment__icon' },
	                    _get__('React').createElement('i', { className: 'fa fa-2x fa-file-excel-o opacity--75' })
	                ),
	                _get__('React').createElement(
	                    'div',
	                    { className: 'attachment__body' },
	                    _get__('React').createElement(
	                        'div',
	                        { className: 'attachment__name' },
	                        _get__('React').createElement(
	                            'span',
	                            { className: '' },
	                            file.name
	                        )
	                    ),
	                    _get__('React').createElement(
	                        'div',
	                        { className: 'attachment__meta text--smallest display--flex display--flex--align-center' },
	                        _get__('React').createElement(
	                            'span',
	                            { className: 'opacity--50 push-quarter--right' },
	                            'Size: ',
	                            _get__('filesize').default(file.size)
	                        ),
	                        '\xB7',
	                        _get__('React').createElement(
	                            'span',
	                            { className: 'opacity--50 push-quarter--sides' },
	                            _get__('moment')().fromNow()
	                        )
	                    )
	                ),
	                _get__('React').createElement(
	                    'button',
	                    { className: 'attachment__action btn btn--transparent', onClick: this.onClearButtonClicked },
	                    _get__('React').createElement('i', { className: 'alert__close__icon icon-cme-close-thin icon--small', 'aria-hidden': 'true' })
	                )
	            );
	        }
	    }]);
	
	    return FileComponent;
	}(_get__('Component'));
	
	exports.default = _get__('FileComponent');
	
	function _getGlobalObject() {
	    try {
	        if (!!global) {
	            return global;
	        }
	    } catch (e) {
	        try {
	            if (!!window) {
	                return window;
	            }
	        } catch (e) {
	            return this;
	        }
	    }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	    if (_RewireModuleId__ === null) {
	        var globalVariable = _getGlobalObject();
	
	        if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	            globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	        }
	
	        _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	    }
	
	    return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	    var theGlobalVariable = _getGlobalObject();
	
	    if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    }
	
	    return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	    var moduleId = _getRewireModuleId__();
	
	    var registry = _getRewireRegistry__();
	
	    var rewireData = registry[moduleId];
	
	    if (!rewireData) {
	        registry[moduleId] = Object.create(null);
	        rewireData = registry[moduleId];
	    }
	
	    return rewireData;
	}
	
	(function registerResetAll() {
	    var theGlobalVariable = _getGlobalObject();
	
	    if (!theGlobalVariable['__rewire_reset_all__']) {
	        theGlobalVariable['__rewire_reset_all__'] = function () {
	            theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	        };
	    }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	    function addPropertyToAPIObject(name, value) {
	        Object.defineProperty(_RewireAPI__, name, {
	            value: value,
	            enumerable: false,
	            configurable: true
	        });
	    }
	
	    addPropertyToAPIObject('__get__', _get__);
	    addPropertyToAPIObject('__GetDependency__', _get__);
	    addPropertyToAPIObject('__Rewire__', _set__);
	    addPropertyToAPIObject('__set__', _set__);
	    addPropertyToAPIObject('__reset__', _reset__);
	    addPropertyToAPIObject('__ResetDependency__', _reset__);
	    addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	    var rewireData = _getRewiredData__();
	
	    if (rewireData[variableName] === undefined) {
	        return _get_original__(variableName);
	    } else {
	        var value = rewireData[variableName];
	
	        if (value === INTENTIONAL_UNDEFINED) {
	            return undefined;
	        } else {
	            return value;
	        }
	    }
	}
	
	function _get_original__(variableName) {
	    switch (variableName) {
	        case 'filesize':
	            return _filterWildcardImport__(filesize);
	
	        case 'moment':
	            return _momentEs2.default;
	
	        case 'Component':
	            return _react.Component;
	
	        case 'FileComponent':
	            return FileComponent;
	
	        case 'React':
	            return _filterWildcardImport__(React);
	    }
	
	    return undefined;
	}
	
	function _assign__(variableName, value) {
	    var rewireData = _getRewiredData__();
	
	    if (rewireData[variableName] === undefined) {
	        return _set_original__(variableName, value);
	    } else {
	        return rewireData[variableName] = value;
	    }
	}
	
	function _set_original__(variableName, _value) {
	    switch (variableName) {}
	
	    return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	    var oldValue = _get__(variableName);
	
	    var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	    _assign__(variableName, newValue);
	
	    return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	    var rewireData = _getRewiredData__();
	
	    if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	        Object.keys(variableName).forEach(function (name) {
	            rewireData[name] = variableName[name];
	        });
	        return function () {
	            Object.keys(variableName).forEach(function (name) {
	                _reset__(variableName);
	            });
	        };
	    } else {
	        if (value === undefined) {
	            rewireData[variableName] = INTENTIONAL_UNDEFINED;
	        } else {
	            rewireData[variableName] = value;
	        }
	
	        return function () {
	            _reset__(variableName);
	        };
	    }
	}
	
	function _reset__(variableName) {
	    var rewireData = _getRewiredData__();
	
	    delete rewireData[variableName];
	
	    if (Object.keys(rewireData).length == 0) {
	        delete _getRewireRegistry__()[_getRewireModuleId__];
	    }
	
	    ;
	}
	
	function _with__(object) {
	    var rewireData = _getRewiredData__();
	
	    var rewiredVariableNames = Object.keys(object);
	    var previousValues = {};
	
	    function reset() {
	        rewiredVariableNames.forEach(function (variableName) {
	            rewireData[variableName] = previousValues[variableName];
	        });
	    }
	
	    return function (callback) {
	        rewiredVariableNames.forEach(function (variableName) {
	            previousValues[variableName] = rewireData[variableName];
	            rewireData[variableName] = object[variableName];
	        });
	        var result = callback();
	
	        if (!!result && typeof result.then == 'function') {
	            result.then(reset).catch(reset);
	        } else {
	            reset();
	        }
	
	        return result;
	    };
	}
	
	var _typeOfOriginalExport = typeof FileComponent === 'undefined' ? 'undefined' : _typeof(FileComponent);
	
	function addNonEnumerableProperty(name, value) {
	    Object.defineProperty(FileComponent, name, {
	        value: value,
	        enumerable: false,
	        configurable: true
	    });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(FileComponent)) {
	    addNonEnumerableProperty('__get__', _get__);
	    addNonEnumerableProperty('__GetDependency__', _get__);
	    addNonEnumerableProperty('__Rewire__', _set__);
	    addNonEnumerableProperty('__set__', _set__);
	    addNonEnumerableProperty('__reset__', _reset__);
	    addNonEnumerableProperty('__ResetDependency__', _reset__);
	    addNonEnumerableProperty('__with__', _with__);
	    addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	    var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	        return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	    });
	    return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	        filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	        return filteredWildcardImport;
	    }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 2020 Jason Mulligan <jason.mulligan@avoidwork.com>
	 @version 6.1.0
	*/
	"use strict";!function(e){var x=/^(b|B)$/,M={iec:{bits:["b","Kib","Mib","Gib","Tib","Pib","Eib","Zib","Yib"],bytes:["B","KiB","MiB","GiB","TiB","PiB","EiB","ZiB","YiB"]},jedec:{bits:["b","Kb","Mb","Gb","Tb","Pb","Eb","Zb","Yb"],bytes:["B","KB","MB","GB","TB","PB","EB","ZB","YB"]}},w={iec:["","kibi","mebi","gibi","tebi","pebi","exbi","zebi","yobi"],jedec:["","kilo","mega","giga","tera","peta","exa","zetta","yotta"]};function t(e){var i,t,o,n,b,r,a,l,s,d,u,c,f,p,B,y=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},g=[],v=0,m=void 0,h=void 0;if(isNaN(e))throw new TypeError("Invalid number");return t=!0===y.bits,u=!0===y.unix,i=y.base||2,d=void 0!==y.round?y.round:u?1:2,r=void 0!==y.locale?y.locale:"",a=y.localeOptions||{},c=void 0!==y.separator?y.separator:"",f=void 0!==y.spacer?y.spacer:u?"":" ",B=y.symbols||{},p=2===i&&y.standard||"jedec",s=y.output||"string",n=!0===y.fullform,b=y.fullforms instanceof Array?y.fullforms:[],m=void 0!==y.exponent?y.exponent:-1,o=2<i?1e3:1024,(l=(h=Number(e))<0)&&(h=-h),(-1===m||isNaN(m))&&(m=Math.floor(Math.log(h)/Math.log(o)))<0&&(m=0),8<m&&(m=8),"exponent"===s?m:(0===h?(g[0]=0,g[1]=u?"":M[p][t?"bits":"bytes"][m]):(v=h/(2===i?Math.pow(2,10*m):Math.pow(1e3,m)),t&&o<=(v*=8)&&m<8&&(v/=o,m++),g[0]=Number(v.toFixed(0<m?d:0)),g[0]===o&&m<8&&void 0===y.exponent&&(g[0]=1,m++),g[1]=10===i&&1===m?t?"kb":"kB":M[p][t?"bits":"bytes"][m],u&&(g[1]="jedec"===p?g[1].charAt(0):0<m?g[1].replace(/B$/,""):g[1],x.test(g[1])&&(g[0]=Math.floor(g[0]),g[1]=""))),l&&(g[0]=-g[0]),g[1]=B[g[1]]||g[1],!0===r?g[0]=g[0].toLocaleString():0<r.length?g[0]=g[0].toLocaleString(r,a):0<c.length&&(g[0]=g[0].toString().replace(".",c)),"array"===s?g:(n&&(g[1]=b[m]?b[m]:w[p][m]+(t?"bit":"byte")+(1===g[0]?"":"s")),"object"===s?{value:g[0],symbol:g[1],exponent:m}:g.join(f)))}t.partial=function(i){return function(e){return t(e,i)}}, true?module.exports=t:"function"==typeof define&&void 0!==define.amd?define(function(){return t}):e.filesize=t}("undefined"!=typeof window?window:global);
	//# sourceMappingURL=filesize.min.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict"
	var moment = __webpack_require__(683);
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = moment;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.20.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(684)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.20.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(584)(module)))

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 685,
		"./af.js": 685,
		"./ar": 686,
		"./ar-dz": 687,
		"./ar-dz.js": 687,
		"./ar-kw": 688,
		"./ar-kw.js": 688,
		"./ar-ly": 689,
		"./ar-ly.js": 689,
		"./ar-ma": 690,
		"./ar-ma.js": 690,
		"./ar-sa": 691,
		"./ar-sa.js": 691,
		"./ar-tn": 692,
		"./ar-tn.js": 692,
		"./ar.js": 686,
		"./az": 693,
		"./az.js": 693,
		"./be": 694,
		"./be.js": 694,
		"./bg": 695,
		"./bg.js": 695,
		"./bm": 696,
		"./bm.js": 696,
		"./bn": 697,
		"./bn.js": 697,
		"./bo": 698,
		"./bo.js": 698,
		"./br": 699,
		"./br.js": 699,
		"./bs": 700,
		"./bs.js": 700,
		"./ca": 701,
		"./ca.js": 701,
		"./cs": 702,
		"./cs.js": 702,
		"./cv": 703,
		"./cv.js": 703,
		"./cy": 704,
		"./cy.js": 704,
		"./da": 705,
		"./da.js": 705,
		"./de": 706,
		"./de-at": 707,
		"./de-at.js": 707,
		"./de-ch": 708,
		"./de-ch.js": 708,
		"./de.js": 706,
		"./dv": 709,
		"./dv.js": 709,
		"./el": 710,
		"./el.js": 710,
		"./en-au": 711,
		"./en-au.js": 711,
		"./en-ca": 712,
		"./en-ca.js": 712,
		"./en-gb": 713,
		"./en-gb.js": 713,
		"./en-ie": 714,
		"./en-ie.js": 714,
		"./en-nz": 715,
		"./en-nz.js": 715,
		"./eo": 716,
		"./eo.js": 716,
		"./es": 717,
		"./es-do": 718,
		"./es-do.js": 718,
		"./es-us": 719,
		"./es-us.js": 719,
		"./es.js": 717,
		"./et": 720,
		"./et.js": 720,
		"./eu": 721,
		"./eu.js": 721,
		"./fa": 722,
		"./fa.js": 722,
		"./fi": 723,
		"./fi.js": 723,
		"./fo": 724,
		"./fo.js": 724,
		"./fr": 725,
		"./fr-ca": 726,
		"./fr-ca.js": 726,
		"./fr-ch": 727,
		"./fr-ch.js": 727,
		"./fr.js": 725,
		"./fy": 728,
		"./fy.js": 728,
		"./gd": 729,
		"./gd.js": 729,
		"./gl": 730,
		"./gl.js": 730,
		"./gom-latn": 731,
		"./gom-latn.js": 731,
		"./gu": 732,
		"./gu.js": 732,
		"./he": 733,
		"./he.js": 733,
		"./hi": 734,
		"./hi.js": 734,
		"./hr": 735,
		"./hr.js": 735,
		"./hu": 736,
		"./hu.js": 736,
		"./hy-am": 737,
		"./hy-am.js": 737,
		"./id": 738,
		"./id.js": 738,
		"./is": 739,
		"./is.js": 739,
		"./it": 740,
		"./it.js": 740,
		"./ja": 741,
		"./ja.js": 741,
		"./jv": 742,
		"./jv.js": 742,
		"./ka": 743,
		"./ka.js": 743,
		"./kk": 744,
		"./kk.js": 744,
		"./km": 745,
		"./km.js": 745,
		"./kn": 746,
		"./kn.js": 746,
		"./ko": 747,
		"./ko.js": 747,
		"./ky": 748,
		"./ky.js": 748,
		"./lb": 749,
		"./lb.js": 749,
		"./lo": 750,
		"./lo.js": 750,
		"./lt": 751,
		"./lt.js": 751,
		"./lv": 752,
		"./lv.js": 752,
		"./me": 753,
		"./me.js": 753,
		"./mi": 754,
		"./mi.js": 754,
		"./mk": 755,
		"./mk.js": 755,
		"./ml": 756,
		"./ml.js": 756,
		"./mr": 757,
		"./mr.js": 757,
		"./ms": 758,
		"./ms-my": 759,
		"./ms-my.js": 759,
		"./ms.js": 758,
		"./mt": 760,
		"./mt.js": 760,
		"./my": 761,
		"./my.js": 761,
		"./nb": 762,
		"./nb.js": 762,
		"./ne": 763,
		"./ne.js": 763,
		"./nl": 764,
		"./nl-be": 765,
		"./nl-be.js": 765,
		"./nl.js": 764,
		"./nn": 766,
		"./nn.js": 766,
		"./pa-in": 767,
		"./pa-in.js": 767,
		"./pl": 768,
		"./pl.js": 768,
		"./pt": 769,
		"./pt-br": 770,
		"./pt-br.js": 770,
		"./pt.js": 769,
		"./ro": 771,
		"./ro.js": 771,
		"./ru": 772,
		"./ru.js": 772,
		"./sd": 773,
		"./sd.js": 773,
		"./se": 774,
		"./se.js": 774,
		"./si": 775,
		"./si.js": 775,
		"./sk": 776,
		"./sk.js": 776,
		"./sl": 777,
		"./sl.js": 777,
		"./sq": 778,
		"./sq.js": 778,
		"./sr": 779,
		"./sr-cyrl": 780,
		"./sr-cyrl.js": 780,
		"./sr.js": 779,
		"./ss": 781,
		"./ss.js": 781,
		"./sv": 782,
		"./sv.js": 782,
		"./sw": 783,
		"./sw.js": 783,
		"./ta": 784,
		"./ta.js": 784,
		"./te": 785,
		"./te.js": 785,
		"./tet": 786,
		"./tet.js": 786,
		"./th": 787,
		"./th.js": 787,
		"./tl-ph": 788,
		"./tl-ph.js": 788,
		"./tlh": 789,
		"./tlh.js": 789,
		"./tr": 790,
		"./tr.js": 790,
		"./tzl": 791,
		"./tzl.js": 791,
		"./tzm": 792,
		"./tzm-latn": 793,
		"./tzm-latn.js": 793,
		"./tzm.js": 792,
		"./uk": 794,
		"./uk.js": 794,
		"./ur": 795,
		"./ur.js": 795,
		"./uz": 796,
		"./uz-latn": 797,
		"./uz-latn.js": 797,
		"./uz.js": 796,
		"./vi": 798,
		"./vi.js": 798,
		"./x-pseudo": 799,
		"./x-pseudo.js": 799,
		"./yo": 800,
		"./yo.js": 800,
		"./zh-cn": 801,
		"./zh-cn.js": 801,
		"./zh-hk": 802,
		"./zh-hk.js": 802,
		"./zh-tw": 803,
		"./zh-tw.js": 803
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 684;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        ss : '%d sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss : '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        ss : '%d saniyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        ss : 'sekondi %d',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        ss : '%d সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        ss : '%d སྐར་ཆ།',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        ss : '%d eilenn',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        ss : '%d segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        ss : '%d ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        ss : '%d sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        ss : 'd% ސިކުންތު',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        ss : '%d δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        ss : '%d sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'ss': [number + 'sekundi', number + 'sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        ss : '%d segundo',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        ss : 'ثانیه d%',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        ss : '%d sekundir',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        ss : '%d sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        ss : '%d diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'ss': [number + ' secondanim', number + ' second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        ss: '%d સેકંડ',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        ss : '%d שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        ss : '%d सेकंड',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        ss : '%d վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        ss : '%d detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        ss : '%d secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        ss : '%d秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        ss : '%d detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        ss : '%d წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        ss : '%d секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss : '%d ಸೆಕೆಂಡುಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        ss : '%d секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        ss : '%d Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss : '%d ວິນາທີ' ,
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss' : 'sekundė_sekundžių_sekundes',
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        ss : translate,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        ss : '%d സെക്കൻഡ്',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'ss': output = '%d सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'ss': output = '%d सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mt = moment.defineLocale('mt', {
	    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Illum fil-]LT',
	        nextDay : '[Għada fil-]LT',
	        nextWeek : 'dddd [fil-]LT',
	        lastDay : '[Il-bieraħ fil-]LT',
	        lastWeek : 'dddd [li għadda] [fil-]LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'f’ %s',
	        past : '%s ilu',
	        s : 'ftit sekondi',
	        ss : '%d sekondi',
	        m : 'minuta',
	        mm : '%d minuti',
	        h : 'siegħa',
	        hh : '%d siegħat',
	        d : 'ġurnata',
	        dd : '%d ġranet',
	        M : 'xahar',
	        MM : '%d xhur',
	        y : 'sena',
	        yy : '%d sni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mt;
	
	})));


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss : '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        ss : '%d sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        ss : '%d सेकेण्ड',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        ss : '%d sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        ss : '%d ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'ss': 'secunde',
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        ss : relativeTimeWithPlural,
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., H:mm',
	        LLLL : 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        ss : '%d سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        ss : 'තත්පර %d',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        ss : '%d sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        ss : '%d mzuzwana',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        ss : '%d sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        ss : 'sekunde %d',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        ss : '%d விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        ss : '%d సెకన్లు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        ss : 'minutu %d',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        ss : '%d วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        ss : '%d segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        ss : translate,
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        ss : '%d saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'ss': [number + ' secunds', '' + number + ' secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        ss : '%d ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        ss : '%d imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        ss : '%d سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        ss : '%d фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        ss : '%d soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        ss : '%d giây' ,
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        ss : '%d s~écóñ~ds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        ss :'aayá %d',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah点mm分',
	        LLLL : 'YYYY年M月D日ddddAh点mm分',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        ss : '%d 秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(683)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Intro;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Intro(props) {
	  var staticVersion = props.staticVersion;
	  return _get__("React").createElement(
	    "section",
	    { className: "flush--bottom" },
	    _get__("React").createElement("a", { className: "anchor", id: "intro" }),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--bleed" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 main" },
	        _get__("React").createElement(
	          "div",
	          { className: "well text--center banner" },
	          _get__("React").createElement(
	            "h1",
	            { className: "fitText flush--bottom" },
	            "Common UI"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "div",
	      { className: "grid content--middle" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 main" },
	        _get__("React").createElement(
	          "div",
	          { className: "grid" },
	          _get__("React").createElement(
	            "div",
	            { className: "grid__col-xs-6 grid__col-sm-3" },
	            _get__("React").createElement(
	              "div",
	              { className: "media media--stacked text--center" },
	              _get__("React").createElement("i", { className: "fa fa-rocket", "aria-hidden": "true", style: {
	                  "fontSize": "8em"
	                } }),
	              _get__("React").createElement(
	                "div",
	                { className: "media__body" },
	                _get__("React").createElement(
	                  "h3",
	                  { className: "push--top" },
	                  "Solid Foundation"
	                ),
	                "Built on a foundation of ",
	                _get__("React").createElement(
	                  "a",
	                  { href: "http://necolas.github.io/normalize.css/" },
	                  "Normalize.css"
	                )
	              )
	            )
	          ),
	          _get__("React").createElement(
	            "div",
	            { className: "grid__col-xs-6 grid__col-sm-3" },
	            _get__("React").createElement(
	              "div",
	              { className: "media media--stacked text--center" },
	              _get__("React").createElement(
	                "div",
	                { style: {
	                    "height": "8em",
	                    "display": "flex",
	                    "flexDirection": "row",
	                    "alignItems": "center",
	                    "justifyContent": "center"
	                  } },
	                _get__("React").createElement("i", { className: "fa fa-mobile fa-3x", "aria-hidden": "true" }),
	                _get__("React").createElement("i", { className: "fa fa-tablet fa-3x", "aria-hidden": "true" }),
	                _get__("React").createElement("i", { className: "fa fa-desktop fa-3x", "aria-hidden": "true" })
	              ),
	              _get__("React").createElement(
	                "div",
	                { className: "media__body" },
	                _get__("React").createElement(
	                  "h3",
	                  { className: "push--top" },
	                  "Made with mobile in mind"
	                ),
	                "Responsive out of the box, so elements look great on all screens."
	              )
	            )
	          ),
	          _get__("React").createElement(
	            "div",
	            { className: "grid__col-xs-6 grid__col-sm-3" },
	            _get__("React").createElement(
	              "div",
	              { className: "media media--stacked text--center" },
	              _get__("React").createElement("i", { className: "fa fa-gears", "aria-hidden": "true", style: {
	                  "fontSize": "8em"
	                } }),
	              _get__("React").createElement(
	                "div",
	                { className: "media__body" },
	                _get__("React").createElement(
	                  "h3",
	                  { className: "push--top" },
	                  "Semantic"
	                ),
	                "BEM syntax keeps the CSS clear and informative."
	              )
	            )
	          ),
	          _get__("React").createElement(
	            "div",
	            { className: "grid__col-xs-6 grid__col-sm-3" },
	            _get__("React").createElement(
	              "div",
	              { className: "media media--stacked text--center" },
	              _get__("React").createElement("i", { className: "fa fa-code", "aria-hidden": "true", style: {
	                  "fontSize": "8em"
	                } }),
	              _get__("React").createElement(
	                "div",
	                { className: "media__body" },
	                _get__("React").createElement(
	                  "h3",
	                  { className: "push--top" },
	                  "Tiny footprint"
	                ),
	                "The core set of modules clocks in at 7.9KB minified and gzipped."
	              )
	            )
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid content--middle" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 main" },
	        _get__("React").createElement(
	          "section",
	          null,
	          _get__("React").createElement("hr", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement(
	            "h2",
	            { className: "text--center" },
	            "A HTML, CSS, and JS framework for developing responsive, mobile first projects for CME Group."
	          ),
	          props.staticVersion === false ? _get__("React").createElement(
	            "h3",
	            { className: "text--center" },
	            "Need a feature?   Found a bug?   Want to contribute?"
	          ) : '',
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement(
	            "a",
	            { href: props.staticVersion === true ? '#getting-started' : 'getting-started', className: "center btn btn--large btn--positive" },
	            _get__("React").createElement("i", { className: "fa fa-cog fa-lg" }),
	            " Get Started!"
	          ),
	          "\xA0",
	          props.staticVersion === false ? _get__("React").createElement(
	            "a",
	            { href: "https://fisheye.chicago.cme.com:8663/changelog/common_ui", className: "center btn btn--large" },
	            _get__("React").createElement("i", { className: "fa fa-code-fork fa-lg" }),
	            " Common UI on Fisheye"
	          ) : ''
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid content--middle" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 main" },
	        _get__("React").createElement(
	          "section",
	          { className: "flush" },
	          _get__("React").createElement("hr", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement(
	            "h2",
	            { className: "center text--center" },
	            _get__("React").createElement("i", { className: "fa fa-bolt fa-4x" })
	          ),
	          _get__("React").createElement(
	            "h2",
	            { className: "text--center" },
	            "Accelerate your development"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-6" },
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots h2" },
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "20+ UI Components"
	          ),
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "CME Group Branded"
	          ),
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "Build cross-platform web applications delivering experience tailored to the user's screen size."
	          ),
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "Flexbox grid system for new layout possibilities"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-6" },
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots h2" },
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "Easy to learn and use"
	          ),
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "Leverages latest HTML5/JS features for modern browsers"
	          ),
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "Supported upgrade path"
	          ),
	          _get__("React").createElement(
	            "li",
	            { className: "soft-half" },
	            "Sample layouts and code snippets to help you get started"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid content--middle" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 main" },
	        props.staticVersion === false ? _get__("React").createElement(
	          "section",
	          null,
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement(
	            "h2",
	            { className: "text--center" },
	            "Got questions? Join the discussion"
	          ),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement("br", null),
	          _get__("React").createElement(
	            "a",
	            { href: "https://fadvhc0001d.chicago.cme.com/chat/room/414", className: "center btn btn--large btn--positive" },
	            _get__("React").createElement("i", { className: "fa fa-comments fa-lg" }),
	            " Hipchat!"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { href: "getting-started#support", className: "center btn btn--large" },
	            _get__("React").createElement("i", { className: "fa fa-question fa-lg" }),
	            " Get some help"
	          )
	        ) : ''
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Intro === "undefined" ? "undefined" : _typeof(Intro);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Intro, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Intro)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Typography = function (_get__2) {
	  _inherits(Typography, _get__2);
	
	  function Typography(props) {
	    _classCallCheck(this, Typography);
	
	    return _possibleConstructorReturn(this, (Typography.__proto__ || Object.getPrototypeOf(Typography)).call(this, props));
	  }
	
	  _createClass(Typography, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'typography' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Typography'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'typography' }),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'table',
	            { className: 'table table--rows table--notop' },
	            _get__('React').createElement(
	              'thead',
	              null,
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement('th', null),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Size'
	                ),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Font Weight'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'tbody',
	              null,
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'h1',
	                    { className: 'push--top' },
	                    'Heading 1'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '27px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Bold'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'h2',
	                    { className: 'push--top' },
	                    'Heading 2'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '20px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Bold'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'h3',
	                    { className: 'push--top' },
	                    'Heading 3'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '18px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Bold'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'h4',
	                    { className: 'push--top' },
	                    'Heading 4'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '16px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Bold'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'h5',
	                    { className: 'push--top' },
	                    'Heading 5'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '14px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Bold'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'h6',
	                    { className: 'push--top' },
	                    'Heading 6'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '12px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '600'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<h1>Heading 1</h1>\n          <h2>Heading 2</h2>\n          <h3>Heading 3</h3>\n          <h4>Heading 4</h4>\n          <h5>Heading 5</h5>\n          <h6>Heading 6</h6>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          'Headings use the ',
	          _get__('React').createElement(
	            'a',
	            { href: 'https://fonts.google.com/specimen/Poppins?selection.family=Poppins' },
	            'Poppins font.'
	          ),
	          ' This is included by adding a link to the head element of your page. See the ',
	          _get__('React').createElement(
	            'a',
	            { href: 'getting-started#usage' },
	            'getting started'
	          ),
	          ' guide for more details.'
	        ),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Paragraph Styles'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'p',
	            null,
	            'Nullam quis risus eget ',
	            _get__('React').createElement(
	              'a',
	              { href: '#' },
	              'urna mollis ornare'
	            ),
	            ' vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.'
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            _get__('React').createElement(
	              'small',
	              null,
	              'This line of text is meant to be treated as fine print.'
	            )
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'The following snippet of text is ',
	            _get__('React').createElement(
	              'strong',
	              null,
	              'rendered as bold text'
	            ),
	            '.'
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'The following snippet of text is ',
	            _get__('React').createElement(
	              'em',
	              null,
	              'rendered as italicized text'
	            ),
	            '.'
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'An abbreviation of the word attribute is ',
	            _get__('React').createElement(
	              'abbr',
	              { title: 'attribute' },
	              'attr'
	            ),
	            '.'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<p>Nullam quis risus eget <a href="#">urna mollis ornare</a> vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula.</p>\n          <p><small>This line of text is meant to be treated as fine print.</small></p>\n          <p>The following snippet of text is <strong>rendered as bold text</strong>.</p>\n          <p>The following snippet of text is <em>rendered as italicized text</em>.</p>\n          <p>An abbreviation of the word attribute is <abbr title="attribute">attr</abbr>.</p>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Paragraph Sizes'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'table',
	            { className: 'table table--rows table--notop' },
	            _get__('React').createElement(
	              'thead',
	              null,
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement('th', null),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Size'
	                ),
	                _get__('React').createElement('th', null)
	              )
	            ),
	            _get__('React').createElement(
	              'tbody',
	              null,
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--large' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  'Paragraph body text large'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '18px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Large'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--medium' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  'Paragraph body text Regular'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '16px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Regular'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--small' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  'Paragraph body text small'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '13px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Small'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--x-small' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  'Paragraph body text x-small'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '10px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Xsmall'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Links'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'p',
	            null,
	            'This is a ',
	            _get__('React').createElement(
	              'a',
	              { href: '#' },
	              'link'
	            ),
	            '. You should try and not use phrases like \'click here\' for your link text, but rather words that ',
	            _get__('React').createElement(
	              'a',
	              { href: '#' },
	              'describe the content'
	            ),
	            ' on the other end for SEO purposes'
	          ),
	          _get__('React').createElement(
	            'p',
	            { style: { backgroundColor: '#454647', color: '#fff' } },
	            'This is a ',
	            _get__('React').createElement(
	              'a',
	              { href: '#', className: 'link--dark-bg' },
	              'link'
	            ),
	            ' on a dark background. Add class .link--dark-bg to make link color lighter when placed on dark backgrounds'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<p>This is a <a href="#">link</a>.\n  You should try and not use phrases like \'click here\' for your link text,\n  but rather words that <a href="#">describe the content</a> on the other end for SEO purposes</p>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Link Sizes'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'table',
	            { className: 'table table--rows table--notop' },
	            _get__('React').createElement(
	              'thead',
	              null,
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement('th', null),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Size'
	                ),
	                _get__('React').createElement('th', null)
	              )
	            ),
	            _get__('React').createElement(
	              'tbody',
	              null,
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--large' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'a',
	                    { href: '#' },
	                    'Text Link large'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '18px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Large'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--medium' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'a',
	                    { href: '#' },
	                    'Text Link Regular'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '16px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Regular'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--small' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'a',
	                    { href: '#' },
	                    'Text Link Small'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '13px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Small'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { className: 'paragraph--x-small' },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'a',
	                    { href: '#' },
	                    'Text Link x-small'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '10px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Xsmall'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Icon Links'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'p',
	            null,
	            'You can add an icon to a link to give it visual context.'
	          ),
	          _get__('React').createElement(
	            'a',
	            { href: '#' },
	            _get__('React').createElement('i', { className: 'fa fa-cog' }),
	            'Settings'
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'a',
	            { href: '#' },
	            _get__('React').createElement('i', { className: 'fa fa-plus-circle' }),
	            'Add Record'
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'a',
	            { href: '#' },
	            'Refresh',
	            _get__('React').createElement('i', { className: 'fa fa-refresh' })
	          ),
	          _get__('React').createElement('br', null)
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<a href="#"><i class="fa fa-cog"></i>Settings</a>\n  <a href="#"><i class="fa fa-plus-circle"></i>Add Record</a>\n  <a href="#">Refresh<i class="fa fa-refresh"></i></a>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Accessibility Tips'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'p',
	            null,
	            'Aim to have a logical document structure with a single h1 element with decreasing levels below. The structure can travel up and down as needed, but keep the levels decending in correct order.'
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'h1',
	            _get__('React').createElement('br', null),
	            '--h2',
	            _get__('React').createElement('br', null),
	            '----h3',
	            _get__('React').createElement('br', null),
	            '----h3',
	            _get__('React').createElement('br', null),
	            '----h3',
	            _get__('React').createElement('br', null),
	            '------h4',
	            _get__('React').createElement('br', null),
	            '--h2',
	            _get__('React').createElement('br', null),
	            '--h2',
	            _get__('React').createElement('br', null),
	            '--h2',
	            _get__('React').createElement('br', null),
	            '----h3',
	            _get__('React').createElement('br', null),
	            '------h4',
	            _get__('React').createElement('br', null)
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'Sometimes you need a certain style/size and wish to use a header \'out of place\'. This can be achieved with the helper classes to create the desired styles without breaking accessibility.'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '/* Good */\n            <h1>Heading 1</h1>\n            <h2>Heading 2</h2>\n\n            /* Good - when your h2 looks like the styling of a h3 */\n            <h1>Heading 1</h1>\n            <h2 class="h3">Heading 2</h2>\n\n            /* Bad- when you try to match the styling of a h2 with a h3 by using the wrong heading level */\n            <h1>Heading 1</h1>\n            <h3>Heading 2</h3>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Typography;
	}(_get__('Component'));
	
	exports.default = _get__('Typography');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Typography':
	      return Typography;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Typography === 'undefined' ? 'undefined' : _typeof(Typography);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Typography, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Typography)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = DarkThemeNav;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DarkThemeNav(_ref) {
	  var anchor = _ref.anchor;
	
	  var darkGrey = '/common-ui/samples/theme-dark-grey.html';
	  var darkBlue = '/common-ui/samples/theme-dark-blue.html';
	  return _get__('React').createElement(
	    'div',
	    null,
	    _get__('React').createElement(
	      'p',
	      null,
	      'To view this component in the either Dark Grey Theme or Dark Blue Theme, click on of the below buttons'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid dark-theme-nav' },
	      _get__('React').createElement(
	        'div',
	        { className: 'grid__col-4' },
	        _get__('React').createElement(
	          'a',
	          { className: 'btn', href: darkGrey + '#' + anchor },
	          'Dark Grey Theme'
	        )
	      ),
	      _get__('React').createElement(
	        'div',
	        { className: 'grid__col-4' },
	        _get__('React').createElement(
	          'a',
	          { className: 'btn', href: darkBlue + '#' + anchor },
	          'Dark Blue Theme'
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof DarkThemeNav === 'undefined' ? 'undefined' : _typeof(DarkThemeNav);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(DarkThemeNav, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(DarkThemeNav)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Colors;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonuiColors = {
	  gray: [{
	    name: 'Grey 1',
	    r: 22,
	    g: 32,
	    b: 42
	  }, {
	    name: 'Grey 2',
	    r: 37,
	    g: 50,
	    b: 60
	  }, {
	    name: 'Grey 3',
	    r: 90,
	    g: 104,
	    b: 116
	  }, {
	    name: 'Grey 4',
	    r: 140,
	    g: 154,
	    b: 162
	  }, {
	    name: 'Grey 5',
	    r: 194,
	    g: 202,
	    b: 206
	  }, {
	    name: 'Grey 6',
	    r: 235,
	    g: 237,
	    b: 238
	  }, {
	    name: 'Grey 7',
	    r: 241,
	    g: 245,
	    b: 247
	  }],
	  blue: [{
	    name: 'Blue 1',
	    r: 8,
	    g: 29,
	    b: 55
	  }, {
	    name: 'Blue 2',
	    r: 17,
	    g: 43,
	    b: 74
	  }, {
	    name: 'Blue 3',
	    r: 31,
	    g: 51,
	    b: 116
	  }, {
	    name: 'Blue 4',
	    r: 0,
	    g: 110,
	    b: 182
	  }, {
	    name: 'Blue 5',
	    r: 37,
	    g: 169,
	    b: 224
	  }, {
	    name: 'Blue 6',
	    r: 60,
	    g: 200,
	    b: 255
	  }, {
	    name: 'Blue 7',
	    r: 235,
	    g: 249,
	    b: 255
	  }],
	  red: [{
	    name: 'Red 1',
	    r: 96,
	    g: 0,
	    b: 23
	  }, {
	    name: 'Red 2',
	    r: 159,
	    g: 0,
	    b: 38
	  }, {
	    name: 'Red 3',
	    r: 223,
	    g: 0,
	    b: 53
	  }, {
	    name: 'Red 4',
	    r: 255,
	    g: 0,
	    b: 61
	  }, {
	    name: 'Red 5',
	    r: 255,
	    g: 226,
	    b: 228
	  }],
	  green: [{
	    name: 'Green 1',
	    r: 14,
	    g: 76,
	    b: 1
	  }, {
	    name: 'Green 2',
	    r: 24,
	    g: 126,
	    b: 2
	  }, {
	    name: 'Green 3',
	    r: 33,
	    g: 176,
	    b: 2
	  }, {
	    name: 'Green 4',
	    r: 42,
	    g: 227,
	    b: 3
	  }, {
	    name: 'Green 5',
	    r: 193,
	    g: 254,
	    b: 179
	  }],
	  limegreen: [{
	    name: 'Lime 1',
	    r: 227,
	    g: 233,
	    b: 53
	  }, {
	    name: 'Lime 2',
	    r: 0,
	    g: 228,
	    b: 115
	  }],
	  orange: [{
	    name: 'Orange 1',
	    r: 255,
	    g: 103,
	    b: 0
	  }, {
	    name: 'Orange 2',
	    r: 255,
	    g: 145,
	    b: 46
	  }, {
	    name: 'Orange 3',
	    r: 255,
	    g: 169,
	    b: 92
	  }, {
	    name: 'Orange 4',
	    r: 252,
	    g: 207,
	    b: 0
	  }],
	  yellow: [{
	    name: 'Yellow 1',
	    r: 254,
	    g: 255,
	    b: 232
	  }, {
	    name: 'Yellow 2',
	    r: 255,
	    g: 221,
	    b: 0
	  }],
	  purple: [{
	    name: 'Purple 1',
	    r: 71,
	    g: 45,
	    b: 82
	  }, {
	    name: 'Purple 2',
	    r: 99,
	    g: 63,
	    b: 115
	  }, {
	    name: 'Purple 3',
	    r: 153,
	    g: 107,
	    b: 174
	  }, {
	    name: 'Purple 4',
	    r: 199,
	    g: 173,
	    b: 210
	  }, {
	    name: 'Purple 5',
	    r: 221,
	    g: 206,
	    b: 228
	  }],
	  teal: [{
	    name: 'Teal 2',
	    r: 2,
	    g: 122,
	    b: 104
	  }, {
	    name: 'Teal 4',
	    r: 8,
	    g: 184,
	    b: 157
	  }, {
	    name: 'Teal 5',
	    r: 127,
	    g: 203,
	    b: 174
	  }]
	};
	
	var renderColorCards = function renderColorCards(colorArray) {
	  return colorArray.map(function (color, i) {
	    var r = color.r,
	        g = color.g,
	        b = color.b,
	        name = color.name;
	
	    return _get__('React').createElement(
	      'div',
	      { className: 'grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12', key: 'color_' + i },
	      _get__('React').createElement(
	        'div',
	        { className: 'color' },
	        _get__('React').createElement('div', {
	          className: 'color__example',
	          style: { 'backgroundColor': 'rgb(' + r + ', ' + g + ', ' + b + ')' } }),
	        _get__('React').createElement(
	          'div',
	          { className: 'color__details' },
	          _get__('React').createElement(
	            'h4',
	            { className: 'color__title' },
	            name
	          ),
	          _get__('React').createElement(
	            'div',
	            null,
	            _get__('React').createElement(
	              'code',
	              null,
	              _get__('rgbToHex')(color)
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            null,
	            'R:',
	            r,
	            ' G:',
	            g,
	            ' B:',
	            b
	          ),
	          _get__('React').createElement(
	            'div',
	            null,
	            _get__('React').createElement(
	              'code',
	              null,
	              '$commonui-color-',
	              _get__('slugify')(name)
	            )
	          )
	        )
	      )
	    );
	  });
	};
	
	function Colors() {
	  return _get__('React').createElement(
	    'section',
	    null,
	    _get__('React').createElement('a', { className: 'anchor', id: 'colors' }),
	    _get__('React').createElement(
	      'h2',
	      null,
	      'Colors'
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'p',
	      null,
	      'Color plays a major role in our brand expression. Our primary palette of colors asserts our distinctiveness and differentiates us from our competitors. Also note that we apply a high level of stringency to our neutral palette. Be sure that color fidelity is strictly maintained across all communications. To ensure this consistency, use the formulas provided here. They have been carefully selected to achieve optimum results across print and digital media.'
	    ),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Gray Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').gray)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Blue Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').blue)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Red Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').red)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Orange Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').orange)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Yellow Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').yellow)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Green Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').green)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Lime Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').limegreen)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Teal Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').teal)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'h3',
	      { className: 'flush--bottom' },
	      'Purple Palette'
	    ),
	    _get__('React').createElement(
	      'div',
	      { className: 'grid' },
	      _get__('renderColorCards')(_get__('commonuiColors').purple)
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement('hr', null)
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'rgbToHex':
	      return _utils.rgbToHex;
	
	    case 'slugify':
	      return _utils.slugify;
	
	    case 'renderColorCards':
	      return renderColorCards;
	
	    case 'commonuiColors':
	      return commonuiColors;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Colors === 'undefined' ? 'undefined' : _typeof(Colors);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Colors, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Colors)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.initPlugins = initPlugins;
	exports.scrollspy = scrollspy;
	exports.scrollToAnchor = scrollToAnchor;
	exports.showHideCodeSnippets = showHideCodeSnippets;
	exports.responsiveDemoSetup = responsiveDemoSetup;
	exports.polyfillSrcSet = polyfillSrcSet;
	exports.backToTop = backToTop;
	exports.bindJiraButton = bindJiraButton;
	exports.offcanvasMenu = offcanvasMenu;
	exports.rgbToHex = rgbToHex;
	exports.slugify = slugify;
	
	var _jquery = __webpack_require__(809);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var srcdoc = __webpack_require__(810);
	
	function initPlugins() {
	  _get__('offcanvasMenu')();
	  _get__('responsiveDemoSetup')();
	  _get__('polyfillSrcSet')();
	  _get__('showHideCodeSnippets')();
	  Prism.highlightAll();
	  _get__('scrollspy')();
	  _get__('scrollToAnchor')();
	  _get__('backToTop')();
	  _get__('bindJiraButton')();
	}
	
	function scrollspy() {
	
	  var lastId = undefined;
	  var sidebar = _get__('$')(".sidebar:visible");
	  var sidebarHeight = sidebar.outerHeight() + 15;
	  var menuItems = sidebar.find('a');
	  var scrollItems = menuItems.map(function (index, scrollItem) {
	    var item = _get__('$')(_get__('$')(scrollItem).attr('href'));
	    if (item.length) {
	      return item;
	    }
	  });
	
	  var $activePrimaryNavItem = _get__('$')(".nav__item--primary.is-active");
	  var $subNavItems = $activePrimaryNavItem.find(".nav__items--secondary").children();
	  var $subNavLinks = $subNavItems.find("a");
	
	  // Bind click handler to menu items
	  menuItems.click(function (e) {
	    var href = _get__('$')(e.currentTarget).attr('href');
	    var internalMenuItem = _get__('$')(href).offset();
	    if (internalMenuItem) {
	      var offsetTop = href === '#' ? 0 : internalMenuItem.top + 1;
	      _get__('$')('html, body').stop().animate({
	        scrollTop: offsetTop
	      }, 200);
	      e.preventDefault();
	    }
	  });
	
	  $subNavLinks.click(function (e) {
	    var $a = _get__('$')(e.currentTarget);
	    var $li = $a.parent();
	    $subNavItems.removeClass("is-active");
	    $li.addClass("is-active");
	  });
	
	  // Bind to scroll
	  _get__('$')(window).scroll(function () {
	    var fromTop = _get__('$')(this).scrollTop() + sidebarHeight;
	    // Get id of current scroll item
	    if (scrollItems) {
	      var cur = scrollItems.map(function (index, scrollItem) {
	        if (_get__('$')(scrollItem).offset().top < fromTop) {
	          return scrollItem;
	        }
	      });
	      // Get the id of the current element
	      cur = cur[cur.length - 1];
	      var id = cur && cur.length ? cur[0].id : '';
	
	      var staticmenuid = 0;
	      if (_get__('$')("body").hasClass("static-version")) {
	        staticmenuid = location.hash.substring(2, location.hash.indexOf("?"));
	      }
	      if (lastId !== id) {
	        lastId = id;
	        // Set/remove active class
	        menuItems.parent().removeClass('active').end().filter("[href='#" + id + "']").parent().addClass('active');
	        $subNavItems.removeClass('is-active');
	        $subNavLinks.filter("[href$='#" + id + "']").parent().addClass("is-active");
	        if (staticmenuid !== 0) {
	          $subNavLinks.filter("[href$='#" + staticmenuid + "']").parent().addClass("is-active");
	        }
	      }
	    }
	  }).bind(this);
	}
	
	// Decode entities in the URL
	// Sometimes a URL like #/foo#bar will be encoded as #/foo%23bar
	function scrollToAnchor() {
	  var hashParts = window.decodeURIComponent(window.location.hash).split('#');
	  if (hashParts && hashParts.length >= 2 && hashParts[1] !== '') {
	    if (_get__('$')("body").hasClass("static-version") === false) {
	      document.querySelector('#' + hashParts[1]).scrollIntoView();
	    } else {
	      var subHashParts = hashParts[1].split('/');
	      if (subHashParts && subHashParts.length === 3 && subHashParts[2] !== '') {
	        var subHash = subHashParts[2].indexOf('?') > -1 ? subHashParts[2].substr(0, subHashParts[2].indexOf('?')) : subHashParts[2];
	        if (subHash !== '') {
	          document.querySelector('#' + subHash).scrollIntoView();
	        }
	      }
	    }
	  }
	}
	
	function showHideCodeSnippets() {
	  _get__('$')('.show-code').on('click touch', function () {
	    var $toggleText = _get__('$')(this).children('span');
	    var $toggleIcon = _get__('$')(this).children('i');
	    if ($toggleText.text() === 'View source') {
	      $toggleText.text('Hide source');
	      $toggleIcon.removeClass('fa-plus');
	      $toggleIcon.addClass('fa-minus');
	    } else {
	      $toggleText.text('View source');
	      $toggleIcon.removeClass('fa-minus');
	      $toggleIcon.addClass('fa-plus');
	    }
	    _get__('$')(this).nextAll('.hide-code:first').stop().slideToggle();
	  });
	}
	
	function responsiveDemoSetup() {
	  _get__('$')(".size-select").change(function () {
	    var $selectedOption = _get__('$')('option:selected', _get__('$')(this));
	    var iframeWidth = $selectedOption.val();
	    var $iframeContainer = _get__('$')(this).nextAll('.iframe-container:first');
	    if (isNaN(iframeWidth)) {
	      $iframeContainer.width('auto');
	    } else {
	      $iframeContainer.animate({ width: iframeWidth });
	    }
	  });
	}
	
	function polyfillSrcSet() {
	  // Polyfill for IE
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = document.querySelectorAll('iframe')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var iframe = _step.value;
	
	      _get__('srcdoc').set(iframe);
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	}
	
	function backToTop() {
	  _get__('commonUI').initializeBackToTop();
	}
	
	function bindJiraButton() {
	  _get__('$')('.jira-button').on('click', function () {
	    _get__('$')('#atlwdg-trigger')[0].click();
	  });
	}
	
	function offcanvasMenu() {
	
	  var resizeTimer = void 0;
	
	  _get__('$')('.sidebar').removeClass('hide');
	  var slideout = new Slideout({
	    'panel': document.getElementById('main'),
	    'menu': document.getElementById('menu'),
	    'padding': 0,
	    'touch': false
	  });
	  slideout.on('beforeopen', function () {
	    document.querySelector('.fixed').classList.add('fixed-open');
	  });
	
	  slideout.on('beforeclose', function () {
	    document.querySelector('.fixed').classList.remove('fixed-open');
	  });
	  // Toggle button
	  _get__('$')('.js-menu').on('click', function () {
	    slideout.toggle();
	  });
	  _get__('$')('.slideout-panel, .sidebar li').click(function () {
	    if (slideout.isOpen()) {
	      slideout.close();
	    }
	  });
	
	  function resizeFunction() {
	    if (_get__('$')(window).width() > 780) {
	      if (slideout.isOpen()) {
	        slideout.close();
	      }
	    }
	  };
	
	  _get__('$')(window).resize(function () {
	    clearTimeout(resizeTimer);
	    resizeTimer = setTimeout(resizeFunction, 100);
	  });
	}
	
	/**
	 * Method for converting an RGB color value to the hexadecimal counterpart.
	 * @param {Object} Number Color object containing red, green and blue values.
	 * @requires {String} The hexadecimal counterpart to the specified RGB value.
	 */
	function rgbToHex(_ref) {
	  var r = _ref.r,
	      g = _ref.g,
	      b = _ref.b;
	
	  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
	}
	
	/**
	 * Slugifies the specified string, i.e. "Dark Gray" -> "dark-gray".
	 * @param {String} str The string to be slugified.
	 * @returns {String} The slugified string.
	 */
	function slugify() {
	  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return str.toLowerCase().replace(/\s/g, '-');
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'offcanvasMenu':
	      return offcanvasMenu;

	    case 'responsiveDemoSetup':
	      return responsiveDemoSetup;

	    case 'polyfillSrcSet':
	      return polyfillSrcSet;

	    case 'showHideCodeSnippets':
	      return showHideCodeSnippets;

	    case 'scrollspy':
	      return scrollspy;

	    case 'scrollToAnchor':
	      return scrollToAnchor;

	    case 'backToTop':
	      return backToTop;

	    case 'bindJiraButton':
	      return bindJiraButton;

	    case '$':
	      return _jquery2.default;

	    case 'srcdoc':
	      return srcdoc;

	    case 'commonUI':
	      return _commonUI2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	exports.default = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.5.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2020-05-04T22:49Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.5.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.5
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2020-03-14
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
						dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px";
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = (
						dataPriv.get( cur, "events" ) || Object.create( null )
					)[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script
				if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				if ( typeof props.top === "number" ) {
					props.top += "px";
				}
				if ( typeof props.left === "number" ) {
					props.left += "px";
				}
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		} );
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
		// `root` does not resolve to the global window object in a Browserified
		// bundle, so a direct reference to that object is used instead.
		var _srcDoc = window.srcDoc;
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function(exports) {
				factory(exports, _srcDoc);
				root.srcDoc = exports;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports === "object") {
			factory(exports, _srcDoc);
		} else {
			root.srcDoc = {};
			factory(root.srcDoc, _srcDoc);
		}
	})(this, function(exports, _srcDoc) {
		var idx, iframes;
		var isCompliant = !!("srcdoc" in document.createElement("iframe"));
		var implementations = {
			compliant: function( iframe, content ) {
	
				if (content) {
					iframe.setAttribute("srcdoc", content);
				}
			},
			legacy: function( iframe, content ) {
	
				var jsUrl;
	
				if (!iframe || !iframe.getAttribute) {
					return;
				}
	
				if (!content) {
					content = iframe.getAttribute("srcdoc");
				} else {
					iframe.setAttribute("srcdoc", content);
				}
	
				if (content) {
					// The value returned by a script-targeted URL will be used as
					// the iFrame's content. Create such a URL which returns the
					// iFrame element's `srcdoc` attribute.
					jsUrl = "javascript: window.frameElement.getAttribute('srcdoc');";
	
					iframe.setAttribute("src", jsUrl);
	
					// Explicitly set the iFrame's window.location for
					// compatability with IE9, which does not react to changes in
					// the `src` attribute when it is a `javascript:` URL, for
					// some reason
					if (iframe.contentWindow) {
						iframe.contentWindow.location = jsUrl;
					}
				}
			}
		};
		var srcDoc = exports;
		// Assume the best
		srcDoc.set = implementations.compliant;
		srcDoc.noConflict = function() {
			window.srcDoc = _srcDoc;
			return srcDoc;
		};
	
		// If the browser supports srcdoc, no shimming is necessary
		if (isCompliant) {
			return;
		}
	
		srcDoc.set = implementations.legacy;
	
		// Automatically shim any iframes already present in the document
		iframes = document.getElementsByTagName("iframe");
		idx = iframes.length;
	
		while (idx--) {
			srcDoc.set( iframes[idx] );
		}
	
	});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Logo;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Logo() {
		var darkBg = {
			backgroundColor: '#000000'
		};
	
		return _get__('React').createElement(
			'section',
			null,
			_get__('React').createElement('a', { className: 'anchor', id: 'logo' }),
			_get__('React').createElement(
				'h2',
				null,
				'Logo'
			),
			_get__('React').createElement(
				'p',
				null,
				'The CME Group logo is the flagship of our brand identity - the principal visual reference for our audiences. For this reason, consistency of logo use is not only a design imperative, it\'s a business imperative.'
			),
			_get__('React').createElement(
				'p',
				null,
				'This 3-D version of the CME Group logo is optimized for use in high-quality offset printing, videos and broadcast applications. It may be used only by CME Group corporate communications and marketing. When high-quality reproduction is not available, the secondary two-color CME Group logo should be used.'
			),
			_get__('React').createElement(
				'p',
				null,
				'There are two versions of this 3-D logo, one with black type and one with white type.'
			),
			_get__('React').createElement(
				'table',
				{ className: 'table table--comfy table--dark' },
				_get__('React').createElement(
					'thead',
					null,
					_get__('React').createElement(
						'tr',
						null,
						_get__('React').createElement(
							'th',
							null,
							'Logo'
						),
						_get__('React').createElement(
							'th',
							null,
							'Logo Description'
						),
						_get__('React').createElement(
							'th',
							null,
							'Downloads'
						)
					)
				),
				_get__('React').createElement(
					'tbody',
					null,
					_get__('React').createElement(
						'tr',
						null,
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement('img', { src: 'images/CMEGroupLogo_BlackVersion.png', alt: 'CME Group logo black and white', className: 'push' })
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							'Black and White Logo (Flat Globe)'
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement(
								'ul',
								{ className: 'btn-group js-btn-group' },
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_BlackVersion.png', download: true },
										'Download PNG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_BlackVersion.jpg', download: true },
										'Download JPG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_BlackVersion.eps', download: true },
										'Download EPS'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_BlackVersion.svg', download: true },
										'Download SVG'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'tr',
						null,
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement('img', { src: 'images/CMEGroupLogo_Default.png', alt: 'CME Group logo flat', className: 'push' })
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							'Color Logo'
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement(
								'ul',
								{ className: 'btn-group js-btn-group' },
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_Default.png', download: true },
										'Download PNG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_Default.jpg', download: true },
										'Download JPG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_Default.eps', download: true },
										'Download EPS'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_Default.svg', download: true },
										'Download SVG'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'tr',
						null,
						_get__('React').createElement(
							'td',
							{ className: 'text--center', style: darkBg },
							_get__('React').createElement('img', { src: 'images/CMEGroupLogo_DarkWithBlueGlobe.png', alt: 'CME Group logo dark with blue globe', className: 'push' })
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							'White Logo (Blue Globe)'
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement(
								'ul',
								{ className: 'btn-group js-btn-group' },
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithBlueGlobe.png', download: true },
										'Download PNG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithBlueGlobe.jpg', download: true },
										'Download JPG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithBlueGlobe.eps', download: true },
										'Download EPS'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithBlueGlobe.svg', download: true },
										'Download SVG'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'tr',
						null,
						_get__('React').createElement(
							'td',
							{ className: 'text--center', style: darkBg },
							_get__('React').createElement('img', { src: 'images/CMEGroupLogo_DarkWithWhiteGlobe.png', alt: 'CME Group logo dark with white globe', className: 'push' })
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							'White Logo (White Globe)'
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement(
								'ul',
								{ className: 'btn-group js-btn-group btn-group-item--full-width' },
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithWhiteGlobe.png', download: true },
										'Download PNG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithWhiteGlobe.jpg', download: true },
										'Download JPG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithWhiteGlobe.eps', download: true },
										'Download EPS'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGroupLogo_DarkWithWhiteGlobe.svg', download: true },
										'Download SVG'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'tr',
						null,
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement('img', { src: 'images/CMEGlobe_Blue.png', alt: 'CME Group logo dark with white globe', className: 'push' })
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							'CME Globe (Blue)'
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement(
								'ul',
								{ className: 'btn-group js-btn-group btn-group-item--full-width' },
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Blue.png', download: true },
										'Download PNG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Blue.jpg', download: true },
										'Download JPG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Blue.eps', download: true },
										'Download EPS'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Blue.svg', download: true },
										'Download SVG'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'tr',
						null,
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement('img', { src: 'images/CMEGlobe_Black.png', alt: 'CME Group logo dark with white globe', className: 'push' })
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							'CME Globe (Black)'
						),
						_get__('React').createElement(
							'td',
							{ className: 'text--center' },
							_get__('React').createElement(
								'ul',
								{ className: 'btn-group js-btn-group btn-group-item--full-width' },
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Black.png', download: true },
										'Download PNG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Black.jpg', download: true },
										'Download JPG'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Black.eps', download: true },
										'Download EPS'
									)
								),
								_get__('React').createElement(
									'li',
									{ className: 'btn-group-item btn-group-item--full-width' },
									_get__('React').createElement(
										'a',
										{ className: 'btn btn--link', href: 'images/CMEGlobe_Black.svg', download: true },
										'Download SVG'
									)
								)
							)
						)
					)
				)
			),
			_get__('React').createElement('hr', null)
		);
	}
	
	function _getGlobalObject() {
		try {
			if (!!global) {
				return global;
			}
		} catch (e) {
			try {
				if (!!window) {
					return window;
				}
			} catch (e) {
				return this;
			}
		}
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
		if (_RewireModuleId__ === null) {
			var globalVariable = _getGlobalObject();
	
			if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
				globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
			}
	
			_RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
		}
	
		return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
			theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
		}
	
		return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
		var moduleId = _getRewireModuleId__();
	
		var registry = _getRewireRegistry__();
	
		var rewireData = registry[moduleId];
	
		if (!rewireData) {
			registry[moduleId] = Object.create(null);
			rewireData = registry[moduleId];
		}
	
		return rewireData;
	}
	
	(function registerResetAll() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable['__rewire_reset_all__']) {
			theGlobalVariable['__rewire_reset_all__'] = function () {
				theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
			};
		}
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
		function addPropertyToAPIObject(name, value) {
			Object.defineProperty(_RewireAPI__, name, {
				value: value,
				enumerable: false,
				configurable: true
			});
		}
	
		addPropertyToAPIObject('__get__', _get__);
		addPropertyToAPIObject('__GetDependency__', _get__);
		addPropertyToAPIObject('__Rewire__', _set__);
		addPropertyToAPIObject('__set__', _set__);
		addPropertyToAPIObject('__reset__', _reset__);
		addPropertyToAPIObject('__ResetDependency__', _reset__);
		addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _get_original__(variableName);
		} else {
			var value = rewireData[variableName];
	
			if (value === INTENTIONAL_UNDEFINED) {
				return undefined;
			} else {
				return value;
			}
		}
	}
	
	function _get_original__(variableName) {
		switch (variableName) {
			case 'React':
				return _react2.default;
		}
	
		return undefined;
	}
	
	function _assign__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _set_original__(variableName, value);
		} else {
			return rewireData[variableName] = value;
		}
	}
	
	function _set_original__(variableName, _value) {
		switch (variableName) {}
	
		return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
		var oldValue = _get__(variableName);
	
		var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
		_assign__(variableName, newValue);
	
		return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
			Object.keys(variableName).forEach(function (name) {
				rewireData[name] = variableName[name];
			});
			return function () {
				Object.keys(variableName).forEach(function (name) {
					_reset__(variableName);
				});
			};
		} else {
			if (value === undefined) {
				rewireData[variableName] = INTENTIONAL_UNDEFINED;
			} else {
				rewireData[variableName] = value;
			}
	
			return function () {
				_reset__(variableName);
			};
		}
	}
	
	function _reset__(variableName) {
		var rewireData = _getRewiredData__();
	
		delete rewireData[variableName];
	
		if (Object.keys(rewireData).length == 0) {
			delete _getRewireRegistry__()[_getRewireModuleId__];
		}
	
		;
	}
	
	function _with__(object) {
		var rewireData = _getRewiredData__();
	
		var rewiredVariableNames = Object.keys(object);
		var previousValues = {};
	
		function reset() {
			rewiredVariableNames.forEach(function (variableName) {
				rewireData[variableName] = previousValues[variableName];
			});
		}
	
		return function (callback) {
			rewiredVariableNames.forEach(function (variableName) {
				previousValues[variableName] = rewireData[variableName];
				rewireData[variableName] = object[variableName];
			});
			var result = callback();
	
			if (!!result && typeof result.then == 'function') {
				result.then(reset).catch(reset);
			} else {
				reset();
			}
	
			return result;
		};
	}
	
	var _typeOfOriginalExport = typeof Logo === 'undefined' ? 'undefined' : _typeof(Logo);
	
	function addNonEnumerableProperty(name, value) {
		Object.defineProperty(Logo, name, {
			value: value,
			enumerable: false,
			configurable: true
		});
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Logo)) {
		addNonEnumerableProperty('__get__', _get__);
		addNonEnumerableProperty('__GetDependency__', _get__);
		addNonEnumerableProperty('__Rewire__', _set__);
		addNonEnumerableProperty('__set__', _set__);
		addNonEnumerableProperty('__reset__', _reset__);
		addNonEnumerableProperty('__ResetDependency__', _reset__);
		addNonEnumerableProperty('__with__', _with__);
		addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Appify;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Appify() {
		return _get__("React").createElement(
			"section",
			null,
			_get__("React").createElement("a", { className: "anchor", id: "appify" }),
			_get__("React").createElement(
				"h2",
				null,
				"App Icons"
			),
			_get__("React").createElement("br", null),
			_get__("React").createElement(
				"p",
				null,
				"In the head section add the following tags"
			),
			_get__("React").createElement(
				"pre",
				null,
				_get__("React").createElement(
					"code",
					{ className: "language-html" },
					"<head>\n  <!-- Other tags -->\n  <link rel=\"green-3-touch-icon\" sizes=\"180x180\" href=\"/green-3-touch-icon.png\">\n  <link rel=\"icon\" type=\"image/png\" href=\"/favicon-32x32.png\" sizes=\"32x32\">\n  <link rel=\"icon\" type=\"image/png\" href=\"/favicon-16x16.png\" sizes=\"16x16\">\n  <link rel=\"manifest\" href=\"/manifest.json\">\n  <meta name=\"theme-color\" content=\"#000\">\n</head>"
				)
			),
			_get__("React").createElement("br", null),
			_get__("React").createElement(
				"p",
				null,
				"Place these assets in the root directory of your website."
			),
			_get__("React").createElement(
				"table",
				{ className: "table table--rows table--notop" },
				_get__("React").createElement(
					"thead",
					null,
					_get__("React").createElement(
						"tr",
						null,
						_get__("React").createElement(
							"th",
							null,
							"Filename"
						),
						_get__("React").createElement(
							"th",
							null,
							"Image"
						)
					)
				),
				_get__("React").createElement(
					"tbody",
					null,
					_get__("React").createElement(
						"tr",
						null,
						_get__("React").createElement(
							"td",
							null,
							_get__("React").createElement(
								"p",
								{ className: "push--top" },
								"android-chrome-512x512.png"
							)
						),
						_get__("React").createElement(
							"td",
							{ className: "text--center soft" },
							_get__("React").createElement("img", { src: "images/android-chrome-512x512.png", alt: "Android icon 512px" })
						)
					),
					_get__("React").createElement(
						"tr",
						null,
						_get__("React").createElement(
							"td",
							null,
							_get__("React").createElement(
								"p",
								{ className: "push--top" },
								"android-chrome-192x192.png"
							)
						),
						_get__("React").createElement(
							"td",
							{ className: "text--center soft" },
							_get__("React").createElement("img", { src: "images/android-chrome-192x192.png", alt: "Android icon 192px" })
						)
					),
					_get__("React").createElement(
						"tr",
						null,
						_get__("React").createElement(
							"td",
							null,
							_get__("React").createElement(
								"p",
								{ className: "push--top" },
								"green-3-touch-icon.png"
							)
						),
						_get__("React").createElement(
							"td",
							{ className: "text--center soft" },
							_get__("React").createElement("img", { src: "images/green-3-touch-icon.png", alt: "green-3 icon icon 180px" })
						)
					),
					_get__("React").createElement(
						"tr",
						null,
						_get__("React").createElement(
							"td",
							null,
							_get__("React").createElement(
								"p",
								{ className: "push--top" },
								"favicon.ico"
							)
						),
						_get__("React").createElement(
							"td",
							{ className: "text--center soft" },
							_get__("React").createElement("img", { src: "images/favicon.ico", alt: "Favicon icon" })
						)
					),
					_get__("React").createElement(
						"tr",
						null,
						_get__("React").createElement(
							"td",
							null,
							_get__("React").createElement(
								"p",
								{ className: "push--top" },
								"favicon-32x32.png"
							)
						),
						_get__("React").createElement(
							"td",
							{ className: "text--center soft" },
							_get__("React").createElement("img", { src: "images/favicon-32x32.png", alt: "Favicon icon 32px" })
						)
					),
					_get__("React").createElement(
						"tr",
						null,
						_get__("React").createElement(
							"td",
							null,
							_get__("React").createElement(
								"p",
								{ className: "push--top" },
								"favicon-16x16.png"
							)
						),
						_get__("React").createElement(
							"td",
							{ className: "text--center soft" },
							_get__("React").createElement("img", { src: "images/favicon-16x16.png", alt: "Favicon icon 16px" })
						)
					)
				)
			),
			_get__("React").createElement(
				"p",
				null,
				"Create a ",
				_get__("React").createElement(
					"a",
					{ href: "https://w3c.github.io/manifest/" },
					"manifest.json"
				),
				" file at the root directory to add metadata about your application",
				_get__("React").createElement("br", null),
				"An example would be -"
			),
			_get__("React").createElement(
				"pre",
				null,
				_get__("React").createElement(
					"code",
					{ className: "language-html" },
					"{\n\t\"name\": \"Common UI\",\n\t\"icons\": [\n\t\t{\n\t\t\t\"src\": \"/android-chrome-192x192.png\",\n\t\t\t\"sizes\": \"192x192\",\n\t\t\t\"type\": \"image/png\"\n\t\t},\n\t\t{\n\t\t\t\"src\": \"/android-chrome-512x512.png\",\n\t\t\t\"sizes\": \"512x512\",\n\t\t\t\"type\": \"image/png\"\n\t\t}\n\t],\n\t\"theme_color\": \"#000000\",\n\t\"display\": \"standalone\"\n}"
				)
			),
			_get__("React").createElement("hr", null)
		);
	}
	
	function _getGlobalObject() {
		try {
			if (!!global) {
				return global;
			}
		} catch (e) {
			try {
				if (!!window) {
					return window;
				}
			} catch (e) {
				return this;
			}
		}
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
		if (_RewireModuleId__ === null) {
			var globalVariable = _getGlobalObject();
	
			if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
				globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
			}
	
			_RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
		}
	
		return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
			theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
		}
	
		return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
		var moduleId = _getRewireModuleId__();
	
		var registry = _getRewireRegistry__();
	
		var rewireData = registry[moduleId];
	
		if (!rewireData) {
			registry[moduleId] = Object.create(null);
			rewireData = registry[moduleId];
		}
	
		return rewireData;
	}
	
	(function registerResetAll() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable['__rewire_reset_all__']) {
			theGlobalVariable['__rewire_reset_all__'] = function () {
				theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
			};
		}
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
		function addPropertyToAPIObject(name, value) {
			Object.defineProperty(_RewireAPI__, name, {
				value: value,
				enumerable: false,
				configurable: true
			});
		}
	
		addPropertyToAPIObject('__get__', _get__);
		addPropertyToAPIObject('__GetDependency__', _get__);
		addPropertyToAPIObject('__Rewire__', _set__);
		addPropertyToAPIObject('__set__', _set__);
		addPropertyToAPIObject('__reset__', _reset__);
		addPropertyToAPIObject('__ResetDependency__', _reset__);
		addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _get_original__(variableName);
		} else {
			var value = rewireData[variableName];
	
			if (value === INTENTIONAL_UNDEFINED) {
				return undefined;
			} else {
				return value;
			}
		}
	}
	
	function _get_original__(variableName) {
		switch (variableName) {
			case "React":
				return _react2.default;
		}
	
		return undefined;
	}
	
	function _assign__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _set_original__(variableName, value);
		} else {
			return rewireData[variableName] = value;
		}
	}
	
	function _set_original__(variableName, _value) {
		switch (variableName) {}
	
		return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
		var oldValue = _get__(variableName);
	
		var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
		_assign__(variableName, newValue);
	
		return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
			Object.keys(variableName).forEach(function (name) {
				rewireData[name] = variableName[name];
			});
			return function () {
				Object.keys(variableName).forEach(function (name) {
					_reset__(variableName);
				});
			};
		} else {
			if (value === undefined) {
				rewireData[variableName] = INTENTIONAL_UNDEFINED;
			} else {
				rewireData[variableName] = value;
			}
	
			return function () {
				_reset__(variableName);
			};
		}
	}
	
	function _reset__(variableName) {
		var rewireData = _getRewiredData__();
	
		delete rewireData[variableName];
	
		if (Object.keys(rewireData).length == 0) {
			delete _getRewireRegistry__()[_getRewireModuleId__];
		}
	
		;
	}
	
	function _with__(object) {
		var rewireData = _getRewiredData__();
	
		var rewiredVariableNames = Object.keys(object);
		var previousValues = {};
	
		function reset() {
			rewiredVariableNames.forEach(function (variableName) {
				rewireData[variableName] = previousValues[variableName];
			});
		}
	
		return function (callback) {
			rewiredVariableNames.forEach(function (variableName) {
				previousValues[variableName] = rewireData[variableName];
				rewireData[variableName] = object[variableName];
			});
			var result = callback();
	
			if (!!result && typeof result.then == 'function') {
				result.then(reset).catch(reset);
			} else {
				reset();
			}
	
			return result;
		};
	}
	
	var _typeOfOriginalExport = typeof Appify === "undefined" ? "undefined" : _typeof(Appify);
	
	function addNonEnumerableProperty(name, value) {
		Object.defineProperty(Appify, name, {
			value: value,
			enumerable: false,
			configurable: true
		});
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Appify)) {
		addNonEnumerableProperty('__get__', _get__);
		addNonEnumerableProperty('__GetDependency__', _get__);
		addNonEnumerableProperty('__Rewire__', _set__);
		addNonEnumerableProperty('__set__', _set__);
		addNonEnumerableProperty('__reset__', _reset__);
		addNonEnumerableProperty('__ResetDependency__', _reset__);
		addNonEnumerableProperty('__with__', _with__);
		addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Badges = function Badges() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "badges" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Badges"
	    ),
	    "Badges are intended to be used for indicating a status or stage and have built-in variations.",
	    _get__("React").createElement(
	      "p",
	      null,
	      "We recommend a maximum of 20 characters to be used, anything beyond this may be more suited for an alert."
	    ),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Sizing "
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Add a ",
	      _get__("React").createElement(
	        "code",
	        null,
	        "badge--small"
	      ),
	      ", ",
	      _get__("React").createElement(
	        "code",
	        null,
	        "badge--medium"
	      ),
	      ", ",
	      _get__("React").createElement(
	        "code",
	        null,
	        "badge--large"
	      ),
	      " for different sized badges."
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "display--inline-block" },
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--small" },
	        "Small Badge"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge" },
	        "Default Badge"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--medium" },
	        "Medium Badge"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--large" },
	        "Large Badge"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<span class=\"badge badge--small\">Small Badge</span>\n<span class=\"badge\">Default Badge</span>\n<span class=\"badge badge--medium\">Medium Badge</span>\n<span class=\"badge badge--large\">Large Badge</span>"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Coloring "
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "display--inline-block" },
	      _get__("React").createElement(
	        "span",
	        { className: "badge" },
	        "Default"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--blue-6" },
	        "Sky Blue"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--red-4" },
	        "Coral Red"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--orange-1" },
	        "orange-1"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--green-4" },
	        "green-4"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--purple-3" },
	        "Trendy Pink"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--teal-4" },
	        "teal-4"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--orange-2" },
	        "Tree Poppy"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<span class=\"badge\">Default</span>\n<span class=\"badge badge--blue-6\">Sky Blue</span>\n<span class=\"badge badge--red-4\">Coral Red</span>\n<span class=\"badge badge--orange-1\">orange-1</span>\n<span class=\"badge badge--green-4\">green-4</span>\n<span class=\"badge badge--purple-3\">Trendy Pink</span>\n<span class=\"badge badge--teal-4\">teal-4</span>\n<span class=\"badge badge--orange-2\">Tree Poppy</span>"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Ghost Badges "
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Add ",
	      _get__("React").createElement(
	        "code",
	        null,
	        "badge--ghost"
	      ),
	      " to achieve the following ghosted effect:"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--ghost" },
	      "Default Ghost"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--blue-6 badge--ghost" },
	      "Sky Blue Ghost"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--red-4 badge--ghost" },
	      "Coral Red Ghost"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--orange-1 badge--ghost" },
	      "orange-1 Ghost"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--green-4 badge--ghost" },
	      "green-4 Ghost"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--purple-3 badge--ghost" },
	      "Trendy Pink Ghost"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--teal-4 badge--ghost" },
	      "teal-4 Ghost"
	    ),
	    _get__("React").createElement(
	      "span",
	      { className: "badge badge--orange-2 badge--ghost" },
	      "Tree Poppy Ghost"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "div",
	      { className: "reversed__background display--inline-block" },
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--ghost" },
	        "Default Ghost"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--blue-6 badge--ghost" },
	        "Sky Blue Ghost"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--red-4 badge--ghost" },
	        "Coral Red Ghost"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--orange-1 badge--ghost" },
	        "orange-1 Ghost"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--green-4 badge--ghost" },
	        "green-4 Ghost"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--purple-3 badge--ghost" },
	        "Trendy Pink Ghost"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--teal-4 badge--ghost" },
	        "teal-4 Ghost"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--orange-2 badge--ghost" },
	        "Tree Poppy Ghost"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<span class=\"badge badge--ghost\">Default Ghost</span>\n<span class=\"badge badge--blue-6 badge--ghost\">Sky Blue Ghost</span>\n<span class=\"badge badge--red-4 badge--ghost\">Coral Red Ghost</span>\n<span class=\"badge badge--orange-1 badge--ghost\">orange-1 Ghost</span>\n<span class=\"badge badge--green-4 badge--ghost\">green-4 Ghost</span>\n<span class=\"badge badge--purple-3 badge--ghost\">Trendy Pink Ghost</span>\n<span class=\"badge badge--teal-4 badge--ghost\">teal-4 Ghost</span>\n<span class=\"badge badge--orange-2 badge--ghost\">Tree Poppy Ghost</span>"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      { className: "callout" },
	      _get__("React").createElement(
	        "b",
	        null,
	        "Note: "
	      ),
	      "We recommend avoiding using the ",
	      _get__("React").createElement(
	        "code",
	        null,
	        "trendy--pink"
	      ),
	      " ghost on dark backgrounds due to poor visibility."
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Icon Badges "
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "display--inline-block" },
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--green-4" },
	        _get__("React").createElement("i", { className: "fa fa-plus" }),
	        " Plus Badge"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--teal-4" },
	        "Minus Badge ",
	        _get__("React").createElement("i", { className: "fa fa-minus" })
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--purple-3" },
	        _get__("React").createElement("i", { className: "fa fa-check" }),
	        " Check Badge"
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--orange-2" },
	        "Check Badge ",
	        _get__("React").createElement("i", { className: "fa fa-check-circle" })
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--teal-4 badge--teal-4--ghost" },
	        "Send Badge ",
	        _get__("React").createElement("i", { className: "fa fa-send" })
	      ),
	      _get__("React").createElement(
	        "span",
	        { className: "badge badge--green-4 badge--green-4--ghost" },
	        "Wifi ",
	        _get__("React").createElement("i", { className: "fa fa-wifi" }),
	        " Badge"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<span class=\"badge badge--green-4\"><i class=\"fa fa-plus\"></i> Plus Badge</span>\n<span class=\"badge badge--teal-4\">Minus Badge <i class=\"fa fa-minus\"></i></span>\n<span class=\"badge badge--purple-3\"><i class=\"fa fa-check\"></i> Check Badge</span>\n<span class=\"badge badge--orange-2\">Check Badge <i class=\"fa fa-check-circle\"></i></span>\n<span class=\"badge badge--teal-4 badge--teal-4--ghost\">Send Badge <i class=\"fa fa-send\"></i></span>\n<span class=\"badge badge--green-4 badge--green-4--ghost\">Wifi <i class=\"fa fa-wifi\"></i> Badge</span"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null)
	  );
	};
	
	exports.default = _get__("Badges");
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "Badges":
	      return Badges;
	
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Badges === "undefined" ? "undefined" : _typeof(Badges);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Badges, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Badges)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Buttons = function (_get__2) {
	  _inherits(Buttons, _get__2);
	
	  function Buttons() {
	    _classCallCheck(this, Buttons);
	
	    return _possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).apply(this, arguments));
	  }
	
	  _createClass(Buttons, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = document.getElementsByClassName('btn-group')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var buttonGroup = _step.value;
	
	          buttonGroup.addEventListener('apply.commonui.buttonGroup', this.logSelectedButtons.bind(this, buttonGroup), false);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Unbind all event listeners
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = document.getElementsByClassName('btn-group')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var buttonGroup = _step2.value;
	
	          buttonGroup.removeEventListener('apply.commonui.buttonGroup', this.logSelectedButtons.bind(this, buttonGroup));
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'logSelectedButtons',
	    value: function logSelectedButtons(buttonGroup) {
	      console.log('Button-Group-Item Toggled'); // eslint-disable-line no-console
	      var buttonsArray = [];
	      var selectedButtons = buttonGroup.querySelectorAll('input:checked');
	      for (var i = 0; i < selectedButtons.length; i++) {
	        buttonsArray.push(selectedButtons[i].id);
	      }
	      console.log(buttonsArray); // eslint-disable-line no-console
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'buttons' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Buttons'
	        ),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Basics'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'A basic button can be created with minimal markup. Because buttons can be used for many purposes, it\'s important to use the right tag.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Use the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '<a>'
	          ),
	          ' tag if the button is a link to another page, or a link to an anchor within a page. Generally anchors don\'t require JavaScript to work.',
	          _get__('React').createElement('br', null),
	          'Use the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '<button>'
	          ),
	          ' tag if the button performs an action that changes something on the current page. ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '<button>'
	          ),
	          ' elements almost always require JavaScript to function.',
	          _get__('React').createElement('br', null),
	          'To create a button, add the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn'
	          ),
	          ' class to any ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '<a>'
	          ),
	          ' or ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '<button>'
	          ),
	          ' or ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '<input>'
	          ),
	          ' element.',
	          _get__('React').createElement('br', null),
	          'In general you should use a ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'button'
	          ),
	          ' as is far more explicit, and comes along with aria accessibility features. Buttons can have ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'type="submit"'
	          ),
	          ' too.'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'buttons' }),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn' },
	          'Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'a',
	          { className: 'btn' },
	          'Button'
	        ),
	        '\xA0',
	        _get__('React').createElement('input', { type: 'button', className: 'btn', value: 'Button' }),
	        '\xA0',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button class="btn">Button</button>\n<a class="btn">Button</a>\n<input type="button" class="btn" value="Button"/>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Link Buttons'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--link' },
	          'Link Button'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button class="btn btn--link">Link Button</button>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Sizing'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Add a ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn--small'
	          ),
	          ' or ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn--large'
	          ),
	          ' for different sized buttons.'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--small push-quarter--ends' },
	          'Small Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push-quarter--ends' },
	          'Normal Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--large push-quarter--ends' },
	          'Large Button'
	        ),
	        '\xA0',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button class="btn btn--small">Small Button</button>\n<button class="btn">Normal Button</button>\n<button class="btn btn--large">Large Button</button>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Coloring - Full Color'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push-quarter--ends' },
	          'Primary Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--positive push-quarter--ends' },
	          'Positive Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--negative push-quarter--ends' },
	          'Negative Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--secondary push-quarter--ends' },
	          'Secondary Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--secondary blue-label push-quarter--ends' },
	          'Secondary Blue Button'
	        ),
	        '\xA0',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button class="btn">Primary Button</button>\n<button class="btn btn--positive">Positive Button</button>\n<button class="btn btn--negative">Negative Button</button>\n<button class="btn btn--secondary">Secondary Button</button>\n<button class="btn btn--secondary blue-label">Secondary Blue Button</button>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Coloring - Outline Color'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--outline push-quarter--ends' },
	          'Primary Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--positive btn--outline push-quarter--ends' },
	          'Positive Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--negative btn--outline push-quarter--ends' },
	          'Negative Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--secondary btn--outline push-quarter--ends' },
	          'Secondary Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--secondary btn--outline blue-label push-quarter--ends' },
	          'Secondary Blue Button'
	        ),
	        '\xA0',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button className="btn btn--outline">Primary Button</button>\n<button className="btn btn--positive btn--outline">Positive Button</button>\n<button className="btn btn--negative btn--outline">Negative Button</button>\n<button className="btn btn--secondary btn--outline">Secondary Button</button>\n<button className="btn btn--secondary btn--outline blue-label">Secondary Blue Button</button>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Coloring - Transparent'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--transparent' },
	          'Transparent Button'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button class="btn btn--transparent">Transparent Button</button>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Icon Buttons'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push-quarter--ends' },
	          _get__('React').createElement('i', { className: 'icon-cme-download' }),
	          ' Download Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--secondary push-quarter--ends' },
	          _get__('React').createElement('i', { className: 'fa fa-info' }),
	          ' Info Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--positive push-quarter--ends' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          ' Plus Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--negative push-quarter--ends' },
	          _get__('React').createElement('i', { className: 'fa fa-minus' }),
	          ' Minus Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--transparent push-quarter--ends' },
	          _get__('React').createElement('i', { className: 'fa fa-download fa-lg' })
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--link push-quarter--ends' },
	          _get__('React').createElement('i', { className: 'fa fa-info' }),
	          ' Link Button'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button class="btn"><i class="icon-cme-download"></i> Download Button</button>\n<button class="btn btn--secondary"><i class="fa fa-info"></i> Info Button</button>\n<button class="btn btn--positive"><i class="fa fa-plus"></i> Plus Button</button>\n<button class="btn btn--negative"><i class="fa fa-minus"></i> Minus Button</button>\n<button class="btn btn--transparent"><i class="fa fa-download fa-lg"></i></button>\n<button class="btn btn--link"><i class="fa fa-info"></i> Link Button</button>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Disabled'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push-quarter--ends', disabled: true },
	          'Primary Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--secondary push-quarter--ends', disabled: true },
	          'Secondary Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--positive push-quarter--ends', disabled: true },
	          'Positive Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--negative push-quarter--ends', disabled: true },
	          'Negative Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--transparent push-quarter--ends', disabled: true },
	          'Transparent Button'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn btn--link push-quarter--ends', disabled: true },
	          'Link Button'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<button class="btn" disabled>Primary Button</button>\n<button class="btn btn--secondary" disabled>Secondary Button</button>\n<button class="btn btn--positive" disabled>Positive Button</button>\n<button class="btn btn--negative" disabled>Negative Button</button>\n<button class="btn btn--transparent" disabled>Transparent Button</button>\n<button class="btn btn--link" disabled>Link Button</button>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Button Groups'
	        ),
	        _get__('React').createElement(
	          'h4',
	          { className: 'push-half--bottom' },
	          'Single Select'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The single select button group is represented by a series of radio buttons where the associated label for each radio button is styled to look like a button. Apply both the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn-group'
	          ),
	          ' and ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn-group--single'
	          ),
	          ' classes to the containing element.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Additionally, small and large variants of the single select button group are also available by applying the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn-group--small'
	          ),
	          ' or ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn-group--large'
	          ),
	          ' class to the containing element as appropriate.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'push-quarter--bottom clearfix' },
	          _get__('React').createElement(
	            'div',
	            { className: 'float--left push--right' },
	            _get__('React').createElement(
	              'h6',
	              { className: 'push-half--bottom' },
	              'Small'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'btn-group btn-group--single btn-group--small js-btn-group' },
	              _get__('React').createElement(
	                'li',
	                { className: 'btn-group-item' },
	                _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-trade-1', type: 'radio', name: 'button-group-single-select-example-1', value: 'button-group-single-select-trade-1' }),
	                _get__('React').createElement(
	                  'label',
	                  { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-trade-1' },
	                  'Trade'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'btn-group-item ' },
	                _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-spread-1', type: 'radio', name: 'button-group-single-select-example-1', value: 'button-group-single-select-spread-1' }),
	                _get__('React').createElement(
	                  'label',
	                  { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-spread-1' },
	                  'Spread'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'float--left push--right' },
	            _get__('React').createElement(
	              'h6',
	              { className: 'push-half--bottom' },
	              'Default'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'btn-group btn-group--single js-btn-group' },
	              _get__('React').createElement(
	                'li',
	                { className: 'btn-group-item' },
	                _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-trade-2', type: 'radio', name: 'button-group-single-select-example-2', value: 'button-group-single-select-trade-2' }),
	                _get__('React').createElement(
	                  'label',
	                  { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-trade-2' },
	                  'Trade'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'btn-group-item' },
	                _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-spread-2', type: 'radio', name: 'button-group-single-select-example-2', value: 'button-group-single-select-spread-2' }),
	                _get__('React').createElement(
	                  'label',
	                  { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-spread-2' },
	                  'Spread'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'float--left' },
	            _get__('React').createElement(
	              'h6',
	              { className: 'push-half--bottom' },
	              'Large'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'btn-group btn-group--single btn-group--large js-btn-group' },
	              _get__('React').createElement(
	                'li',
	                { className: 'btn-group-item' },
	                _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-trade-3', type: 'radio', name: 'button-group-single-select-example-3', value: 'button-group-single-select-trade-3' }),
	                _get__('React').createElement(
	                  'label',
	                  { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-trade-3' },
	                  'Trade'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'btn-group-item' },
	                _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-spread-3', type: 'radio', name: 'button-group-single-select-example-3', value: 'button-group-single-select-spread-3' }),
	                _get__('React').createElement(
	                  'label',
	                  { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-spread-3' },
	                  'Spread'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Single Select Button Group - Small -->\n<ul class="btn-group btn-group--single btn-group--small">\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-trade-1" type="radio" name="button-group-single-select-example-1" value="button-group-single-select-trade-1" />\n    <label class="btn-group-item__label" for="button-group-single-select-trade-1">Trade</label>\n  </li>\n  <li class="btn-group-item ">\n    <input class="btn-group-item__input" id="button-group-single-select-spread-1" type="radio" name="button-group-single-select-example-1" value="button-group-single-select-spread-1" />\n    <label class="btn-group-item__label" for="button-group-single-select-spread-1">Spread</label>\n  </li>\n</ul>\n\n<!-- Single Select Button Group - Default -->\n<ul class="btn-group btn-group--single">\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-trade-2" type="radio" name="button-group-single-select-example-2" value="button-group-single-select-trade-2" />\n    <label class="btn-group-item__label" for="button-group-single-select-trade-2">Trade</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-spread-2" type="radio" name="button-group-single-select-example-2" value="button-group-single-select-spread-2" />\n    <label class="btn-group-item__label" for="button-group-single-select-spread-2">Spread</label>\n  </li>\n</ul>\n\n<!-- Single Select Button Group - Large -->\n<ul class="btn-group btn-group--single btn-group--large">\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-trade-3" type="radio" name="button-group-single-select-example-3" value="button-group-single-select-trade-3" />\n    <label class="btn-group-item__label" for="button-group-single-select-trade-3">Trade</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-spread-3" type="radio" name="button-group-single-select-example-3" value="button-group-single-select-spread-3" />\n    <label class="btn-group-item__label" for="button-group-single-select-spread-3">Spread</label>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display--block push-quarter--bottom' },
	          _get__('React').createElement(
	            'h6',
	            { className: 'push-half--bottom' },
	            'Single Select with Multiple Options'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'btn-group btn-group--single js-btn-group js-btn-group--responsive-example' },
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-1', type: 'radio', name: 'button-group-single-select', value: 'button-group-single-select-1' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-1' },
	                'Single Select'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-2', type: 'radio', name: 'button-group-single-select', value: 'button-group-single-select-2' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-2' },
	                'Button Group'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-3', type: 'radio', name: 'button-group-single-select', value: 'button-group-single-select-3' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-3' },
	                'With'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-4', type: 'radio', name: 'button-group-single-select', value: 'button-group-single-select-4' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-4' },
	                'Multiple Options'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-group-single-select-5', type: 'radio', name: 'button-group-single-select', value: 'button-group-single-select-5' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-group-single-select-5' },
	                'Example'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="btn-group btn-group--single">\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-1" type="radio" name="button-group-single-select" value="button-group-single-select-1" />\n    <label class="btn-group-item__label" for="button-group-single-select-1">Single Select</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-2" type="radio" name="button-group-single-select" value="button-group-single-select-2" />\n    <label class="btn-group-item__label" for="button-group-single-select-2">Button Group</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-3" type="radio" name="button-group-single-select" value="button-group-single-select-3" />\n    <label class="btn-group-item__label" for="button-group-single-select-3">With</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-4" type="radio" name="button-group-single-select" value="button-group-single-select-4" />\n    <label class="btn-group-item__label" for="button-group-single-select-4">Multiple Options</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-group-single-select-5" type="radio" name="button-group-single-select" value="button-group-single-select-5" />\n    <label class="btn-group-item__label" for="button-group-single-select-5">Example</label>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--callout panel--callout--blue-3' },
	          _get__('React').createElement(
	            'h3',
	            { className: 'panel__heading' },
	            'Important'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'list-dots' },
	            _get__('React').createElement(
	              'li',
	              null,
	              'Each radio button element in the button group must contain the same ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'name'
	              ),
	              ' attribute.'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'Each ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'btn-group-item'
	              ),
	              ' must contain a radio button input element and a label element, where the input element contains a unique ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'id'
	              ),
	              ' and the label element is associated with the ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'id'
	              ),
	              ' of the input via the ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'for'
	              ),
	              ' attribute of the label.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Responsive'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'When the width of the element containing the button group is not wide enough to display all buttons in the group without wrapping, the button group will convert automatically into a dropdown (provided it has been initialized as outlined below). By default, the width of the dropdown button will be determined dynamically based on the width of the widest option in the list of available options.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Alternatively, you can apply a ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn-group--full-width'
	          ),
	          ' modifier class to the button group to make the button group span the full width of the containing element, as demonstrated below (select 480px from the dropdown).'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="btn-group btn-group--single btn-group--full-width js-btn-group">\n  <li class="btn-group-item">\n    ...\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1602' },
	            '1600px (xlg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "350px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n          <html>\n            <head>\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n              <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n            </head>\n            <body>\n\n              <div class="push-half">\n                <h5 class="push-quarter--bottom">Default Width</h5>\n                <ul class="btn-group btn-group--single js-btn-group">\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-1" type="radio" name="button-group-single-select-1" value="button-group-single-select-1" />\n                    <label class="btn-group-item__label" for="button-group-single-select-1">Single Select</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-2" type="radio" name="button-group-single-select-1" value="button-group-single-select-2" />\n                    <label class="btn-group-item__label" for="button-group-single-select-2">Button Group</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-3" type="radio" name="button-group-single-select-1" value="button-group-single-select-3" />\n                    <label class="btn-group-item__label" for="button-group-single-select-3">With</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-4" type="radio" name="button-group-single-select-1" value="button-group-single-select-4" />\n                    <label class="btn-group-item__label" for="button-group-single-select-4">Multiple Options</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-5" type="radio" name="button-group-single-select-1" value="button-group-single-select-5" />\n                    <label class="btn-group-item__label" for="button-group-single-select-5">Example</label>\n                  </li>\n                </ul>\n              </div>\n\n              <div class="push-half">\n                <h5 class="push-quarter--bottom">Full Width</h5>\n                <ul class="btn-group btn-group--single btn-group--full-width js-btn-group">\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-6" type="radio" name="button-group-single-select-2" value="button-group-single-select-6" />\n                    <label class="btn-group-item__label" for="button-group-single-select-6">Single Select</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-7" type="radio" name="button-group-single-select-2" value="button-group-single-select-7" />\n                    <label class="btn-group-item__label" for="button-group-single-select-7">Button Group</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-8" type="radio" name="button-group-single-select-2" value="button-group-single-select-8" />\n                    <label class="btn-group-item__label" for="button-group-single-select-8">With</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-9" type="radio" name="button-group-single-select-2" value="button-group-single-select-9" />\n                    <label class="btn-group-item__label" for="button-group-single-select-9">Multiple Options</label>\n                  </li>\n                  <li class="btn-group-item">\n                    <input class="btn-group-item__input" id="button-group-single-select-10" type="radio" name="button-group-single-select-2" value="button-group-single-select-10" />\n                    <label class="btn-group-item__label" for="button-group-single-select-10">Example</label>\n                  </li>\n                </ul>\n              </div>\n\n            </body>\n            <script type="text/javascript" src="js/commonUI.js"></script>\n            <script>\n              function init() {\n                commonUI.initializeButtonGroup();\n              }\n              window.onload = init;\n            </script>\n          </html>\n        ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          { className: 'push-half--bottom' },
	          'Multi Select'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The multi select button group is represented by a series of checkboxes where the associated label for each checkbox is styled to look like a button.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display--block push-quarter--bottom' },
	          _get__('React').createElement(
	            'ul',
	            { className: 'btn-group js-btn-group' },
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-1', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-1' },
	                'Selected'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-2', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-2' },
	                'Longer Selected'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-3', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-3' },
	                'Selected'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-4', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-4' },
	                'Longer Selected'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-5', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-5' },
	                'Selected'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-6', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-6' },
	                'Longer Selected'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-7', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-7' },
	                'Selected'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'button-8', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'button-8' },
	                'Very Long Selected'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="btn-group js-btn-group">\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-1" type="checkbox"/>\n    <label class="btn-group-item__label" for="button-1">Selected</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-2" type="checkbox"/>\n    <label class="btn-group-item__label" for="button-2">Longer Selected</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-3" type="checkbox"/>\n    <label class="btn-group-item__label" for="button-3">Selected</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-4" type="checkbox"/>\n    <label class="btn-group-item__label" for="button-4">Longer Selected</label>\n  </li>\n  <li class="btn-group-item">\n  <input class="btn-group-item__input" id="button-5" type="checkbox"/>\n  <label class="btn-group-item__label" for="button-5">Selected</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-6" type="checkbox"/>\n    <label class="btn-group-item__label" for="button-6">Longer Selected</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-7" type="checkbox"/>\n    <label class="btn-group-item__label" for="button-7">Selected</label>\n  </li>\n  <li class="btn-group-item">\n    <input class="btn-group-item__input" id="button-8" type="checkbox"/>\n    <label class="btn-group-item__label" for="button-8">Very Long Selected</label>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          { className: 'push-half--bottom' },
	          'Draggable Multi Select'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The draggable multi select button group is represented by a series of checkboxes where the associated label for each checkbox is styled to look like a button. To make the button draggable add ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'draggable'
	          ),
	          ' as an attribute. To position the draggable icon to the left use the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'draggable__icon--left'
	          ),
	          ' modifier'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display--block push-quarter--bottom' },
	          _get__('React').createElement(
	            'ul',
	            { className: 'btn-group js-btn-group' },
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-id': '0' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-1', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-1', draggable: true },
	                'Button 1',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-id': '1' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-2', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-2', draggable: true },
	                'Button 2',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-id': '2' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-3', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-3', draggable: true },
	                'Button 3',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-d': '3' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-4', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-4', draggable: true },
	                'Button 4',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-id': '4' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-5', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-5', draggable: true },
	                'Button 5',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-id': '5' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-6', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-6', draggable: true },
	                'Button 6',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-id': '6' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-7', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-7', draggable: true },
	                'Button 7',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item', 'data-id': '7' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-8', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-8', draggable: true },
	                'Button 8',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="btn-group js-btn-group">\n  <li class="btn-group-item" id="0">\n    <input class="btn-group-item__input" id="draggable-button-1" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-1" draggable>\n      Button 1\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item" id="1">\n    <input class="btn-group-item__input" id="draggable-button-2" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-2" draggable>\n      Button 2\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item" id="2">\n    <input class="btn-group-item__input" id="draggable-button-3" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-3" draggable>\n      Button 3\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item" id="3">\n    <input class="btn-group-item__input" id="draggable-button-4" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-4" draggable>\n      Button 4\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item" id="4">\n    <input class="btn-group-item__input" id="draggable-button-5" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-5" draggable>\n      Button 5\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item" id="5">\n    <input class="btn-group-item__input" id="draggable-button-6" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-6" draggable>\n      Button 6\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item" id="6">\n    <input class="btn-group-item__input" id="draggable-button-7" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-7" draggable>\n      Button 7\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item" id="7">\n    <input class="btn-group-item__input" id="draggable-button-8" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-8" draggable>\n      Button 8\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          { className: 'push-half--bottom' },
	          'Draggable Multi Select Full Width'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The draggable multi select button group is represented by a series of checkboxes where the associated label for each checkbox is styled to look like a button. To make the button draggable add ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'draggable'
	          ),
	          ' as an attribute. Add ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'btn-group-item--full-width'
	          ),
	          ' as a helper to set each button to the full width of the container it is in.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display--block push-quarter--bottom grid__col-sm-4' },
	          _get__('React').createElement(
	            'ul',
	            { className: 'btn-group js-btn-group' },
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '0' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-1', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-1', draggable: true },
	                'Button 1',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '1' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-2', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-2', draggable: true },
	                'Button 2',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '2' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-3', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-3', draggable: true },
	                'Button 3',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '3' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-4', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-4', draggable: true },
	                'Button 4',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '4' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-5', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-5', draggable: true },
	                'Button 5',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '5' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-6', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-6', draggable: true },
	                'Button 6',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '6' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-7', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-7', draggable: true },
	                'Button 7',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'btn-group-item btn-group-item--full-width', 'data-id': '7' },
	              _get__('React').createElement('input', { className: 'btn-group-item__input', id: 'draggable-button-full-width-8', type: 'checkbox' }),
	              _get__('React').createElement(
	                'label',
	                { className: 'btn-group-item__label', htmlFor: 'draggable-button-full-width-8', draggable: true },
	                'Button 8',
	                _get__('React').createElement('i', { className: 'icon-cme-drag-drop' })
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="btn-group js-btn-group">\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-1" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-1" draggable>\n      Button 1\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-2" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-2" draggable>\n      Button 2\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-3" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-3" draggable>\n      Button 3\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-4" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-4" draggable>\n      Button 4\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-5" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-5" draggable>\n      Button 5\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-6" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-6" draggable>\n      Button 6\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-7" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-7" draggable>\n      Button 7\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n  <li class="btn-group-item btn-group-item--full-width" id="0">\n    <input class="btn-group-item__input" id="draggable-button-full-width-8" type="checkbox"/>\n    <label class="btn-group-item__label" for="draggable-button-full-width-8" draggable>\n      Button 8\n      <i class="icon-cme-drag-drop"></i>\n    </label>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'ul',
	          { className: 'panel--callout panel--callout--grey-4' },
	          _get__('React').createElement(
	            'li',
	            { className: 'panel__body' },
	            _get__('React').createElement(
	              'strong',
	              null,
	              'Note:'
	            ),
	            _get__('React').createElement('br', null),
	            '* The button-group-items are inputs-checkboxes that are styled to look like buttons. ',
	            _get__('React').createElement('br', null),
	            '* Each button-group-item must have a unique id-for combination.'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Button Groups are JavaScript enabled and if you want to listen to the click events you must do the following:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            '// Initialize the button group\ncommonUI.initializeButtonGroup();\n\n// Target your button group and store it\'s reference in a var\nvar buttonGroup = document.getElementsByClassName(\'btn-group\')[0];\n\n// Listen to the specific event and specify what you want to happen within a function\nbuttonGroup.addEventListener(\'apply.commonui.buttonGroup\', function() {\n  // Example - If we wanted to to know the ids of the button-group-items which have been selected:\n\n  // Starting empty array\n  var selectedButtonsArray = [];\n  // Grab all buttons which have been selected\n  var allSelectedButtons = buttonGroup.querySelectorAll(\'input[type=checkbox]:checked\');\n  // For each selected button, add it\'s id value to the array\n  for (var i = 0; i < allSelectedButtons.length; i++) {\n    selectedButtonsArray.push(allSelectedButtons[i].id)\n  };\n  console.log(selectedButtonsArray);\n  // See console for example results\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Buttons;
	}(_get__('Component'));
	
	exports.default = _get__('Buttons');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Buttons':
	      return Buttons;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Buttons === 'undefined' ? 'undefined' : _typeof(Buttons);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Buttons, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Buttons)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonDropdowns = function ButtonDropdowns() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "button-dropdowns" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Button Dropdowns"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "A dropdown is a toggleable menu that allows the user to choose one value from a predefined list."
	    ),
	    _get__("React").createElement(
	      "div",
	      null,
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown push-quarter--bottom push-quarter--right" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn", type: "button", "data-toggle": "dropdown" },
	          "Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "HTML"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "CSS"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "JavaScript"
	            )
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown push-quarter--bottom push-quarter--right" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn btn--positive", type: "button", "data-toggle": "dropdown" },
	          "Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu dropdown-menu--positive" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "HTML"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "CSS"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "JavaScript"
	            )
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown push-quarter--bottom push-quarter--right" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn btn--negative", type: "button", "data-toggle": "dropdown" },
	          "Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu dropdown-menu--negative" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "HTML"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "CSS"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "JavaScript"
	            )
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown push-quarter--bottom push-quarter--right" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn btn--outline", type: "button", "data-toggle": "dropdown" },
	          "Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "HTML"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "CSS"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "JavaScript"
	            )
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown push-quarter--bottom push-quarter--right" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn btn--positive btn--outline", type: "button", "data-toggle": "dropdown" },
	          "Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu dropdown-menu--positive" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "HTML"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "CSS"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "JavaScript"
	            )
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown push-quarter--bottom push-quarter--right" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn btn--negative btn--outline", type: "button", "data-toggle": "dropdown" },
	          "Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu dropdown-menu--negative" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "HTML"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "CSS"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "JavaScript"
	            )
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown push-quarter--bottom push-quarter--right" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn btn--transparent", type: "button", "data-toggle": "dropdown" },
	          "Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "HTML"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "CSS"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: "#" },
	              "JavaScript"
	            )
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "button",
	      { type: "button", className: "btn btn--secondary show-code" },
	      _get__("React").createElement("i", { className: "fa fa-plus" }),
	      "View source"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      { className: "hide-code" },
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<!-- // primary (default) -->\n<div class=\"dropdown push-quarter--bottom push-quarter--right\">\n  <button class=\"btn\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n</div>\n\n<!-- // positive -->\n<div class=\"dropdown push-quarter--bottom push-quarter--right\">\n  <button class=\"btn btn--positive\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu dropdown-menu--positive\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n</div>\n\n<!-- // negative -->\n<div class=\"dropdown push-quarter--bottom push-quarter--right\">\n  <button class=\"btn btn--negative\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu dropdown-menu--negative\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n</div>\n\n<!-- // primary outline -->\n<div class=\"dropdown push-quarter--bottom push-quarter--right\">\n  <button class=\"btn btn--outline\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n</div>\n\n<!-- // positive outline -->\n<div class=\"dropdown push-quarter--bottom push-quarter--right\">\n  <button class=\"btn btn--positive btn--outline\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu dropdown-menu--positive\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n  </div>\n\n<!-- // negative outline -->\n<div class=\"dropdown push-quarter--bottom push-quarter--right\">\n  <button class=\"btn btn--negative btn--outline\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu dropdown-menu--negative\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n</div>\n\n<!-- // transparent -->\n<div class=\"dropdown push-quarter--bottom push-quarter--right\">\n  <button class=\"btn btn--transparent\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n</div>"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "This is a javascript enabled component. You must initialize it using the following snippet:"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-javascript" },
	        "commonUI.initializeDropdown();"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Dropdown menus can be changed to expand upwards (instead of downwards) by adding the \"data-direction\" attribute to the parent element set to \"up\"."
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "dropdown", "data-direction": "up" },
	      _get__("React").createElement(
	        "button",
	        { className: "btn btn--primary", type: "button", "data-toggle": "dropdown" },
	        "Dropdown Example ",
	        _get__("React").createElement("span", { className: "fa fa-caret" })
	      ),
	      _get__("React").createElement(
	        "ul",
	        { className: "dropdown-menu" },
	        _get__("React").createElement(
	          "li",
	          null,
	          _get__("React").createElement(
	            "a",
	            { href: "#" },
	            "HTML"
	          )
	        ),
	        _get__("React").createElement(
	          "li",
	          null,
	          _get__("React").createElement(
	            "a",
	            { href: "#" },
	            "CSS"
	          )
	        ),
	        _get__("React").createElement(
	          "li",
	          null,
	          _get__("React").createElement(
	            "a",
	            { href: "#" },
	            "JavaScript"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "button",
	      { type: "button", className: "btn btn--secondary show-code" },
	      _get__("React").createElement("i", { className: "fa fa-plus" }),
	      "View source"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      { className: "hide-code" },
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<div class=\"dropdown\" data-direction=\"up\">\n  <button class=\"btn btn--primary\" type=\"button\" data-toggle=\"dropdown\">Dropdown Example <span class=\"fa fa-caret\"></span></button>\n  <ul class=\"dropdown-menu\">\n    <li><a href=\"#\">HTML</a></li>\n    <li><a href=\"#\">CSS</a></li>\n    <li><a href=\"#\">JavaScript</a></li>\n  </ul>\n</div>\n"
	      )
	    ),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Dropdown Groups"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Dropdown menus can be organised into groups. Headings can be added to each group along with dividers, giving more control to the separation of content. When using a tags for menu items, add class 'disabled' to disable the link functionality and apply disabled style"
	    ),
	    _get__("React").createElement(
	      "div",
	      null,
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn", type: "button", "data-toggle": "dropdown" },
	          "Group Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "ul",
	              null,
	              _get__("React").createElement(
	                "div",
	                { className: "dropdown-title" },
	                "Group Heading 1"
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "a",
	                  { href: "#" },
	                  "HTML"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "a",
	                  { href: "#", className: "disabled" },
	                  "CSS"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "a",
	                  { href: "#" },
	                  "JavaScript"
	                )
	              )
	            )
	          ),
	          _get__("React").createElement("div", { className: "dropdown-divider" }),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "ul",
	              null,
	              _get__("React").createElement(
	                "div",
	                { className: "dropdown-title" },
	                "Group Heading 2"
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "a",
	                  { href: "#" },
	                  "HTML"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "a",
	                  { href: "#" },
	                  "CSS"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "a",
	                  { href: "#" },
	                  "JavaScript"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "button",
	      { type: "button", className: "btn btn--secondary show-code" },
	      _get__("React").createElement("i", { className: "fa fa-plus" }),
	      "View source"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      { className: "hide-code" },
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "\n      <div class=\"dropdown\">\n        <button class=\"btn\" type=\"button\" data-toggle=\"dropdown\">Group Dropdown Example <span class=\"fa fa-caret\" /></button>\n        <ul class=\"dropdown-menu\">\n          <li>\n            <ul>\n              <div class=\"dropdown-title\">Group Heading 1</div>\n              <li><a href=\"#\">HTML</a></li>\n              <li><a href=\"#\" class=\"disabled\">CSS</a></li>\n              <li><a href=\"#\">JavaScript</a></li>\n            </ul>\n          </li>\n          <div class=\"dropdown-divider\" />\n          <li>\n            <ul>\n              <div class=\"dropdown-title\">Group Heading 2</div>\n              <li><a href=\"#\">HTML</a></li>\n              <li><a href=\"#\">CSS</a></li>\n              <li><a href=\"#\">JavaScript</a></li>\n            </ul>\n          </li>\n        </ul>\n      </div>\n    "
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Buttons can be used as dropdown items for more control over functionality (i.e. the 'disabled' property as shown below)."
	    ),
	    _get__("React").createElement(
	      "div",
	      null,
	      _get__("React").createElement(
	        "div",
	        { className: "dropdown" },
	        _get__("React").createElement(
	          "button",
	          { className: "btn btn--primary", type: "button", "data-toggle": "dropdown" },
	          "Disabled Dropdown Example ",
	          _get__("React").createElement("span", { className: "fa fa-caret" })
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "dropdown-menu" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "ul",
	              null,
	              _get__("React").createElement(
	                "div",
	                { className: "dropdown-title" },
	                "Enabled links"
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "button",
	                  null,
	                  "HTML"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "button",
	                  null,
	                  "CSS"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "button",
	                  null,
	                  "JavaScript"
	                )
	              )
	            )
	          ),
	          _get__("React").createElement("div", { className: "dropdown-divider" }),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "ul",
	              null,
	              _get__("React").createElement(
	                "div",
	                { className: "dropdown-title" },
	                "Disabled Buttons"
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "button",
	                  { disabled: true },
	                  "HTML"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "button",
	                  { disabled: true },
	                  "CSS"
	                )
	              ),
	              _get__("React").createElement(
	                "li",
	                null,
	                _get__("React").createElement(
	                  "button",
	                  { disabled: true },
	                  "JavaScript"
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "button",
	      { type: "button", className: "btn btn--secondary show-code" },
	      _get__("React").createElement("i", { className: "fa fa-plus" }),
	      "View source"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      { className: "hide-code" },
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "\n      <div class=\"dropdown\">\n        <button class=\"btn btn--primary\" type=\"button\" data-toggle=\"dropdown\">Disabled Dropdown Example <span className=\"fa fa-caret\" /></button>\n        <ul class=\"dropdown-menu\">\n          <li>\n            <ul>\n              <div class=\"dropdown-title\">Enabled links</div>\n              <li><button>HTML</button></li>\n              <li><button>CSS</button></li>\n              <li><button>JavaScript</button></li>\n            </ul>\n          </li>\n          <div class=\"dropdown-divider\" />\n          <li>\n            <ul>\n              <div class=\"dropdown-title\">Disabled Buttons</div>\n              <li><button disabled>HTML</button></li>\n              <li><button disabled>CSS</button></li>\n              <li><button disabled>JavaScript</button></li>\n            </ul>\n          </li>\n        </ul>\n      </div>\n    "
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null)
	  );
	};
	
	exports.default = _get__("ButtonDropdowns");
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "ButtonDropdowns":
	      return ButtonDropdowns;
	
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof ButtonDropdowns === "undefined" ? "undefined" : _typeof(ButtonDropdowns);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(ButtonDropdowns, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ButtonDropdowns)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Filters = function (_get__2) {
	  _inherits(Filters, _get__2);
	
	  function Filters(props) {
	    _classCallCheck(this, Filters);
	
	    return _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).call(this, props));
	  }
	
	  _createClass(Filters, [{
	    key: "render",
	    value: function render() {
	      return _get__("React").createElement(
	        "section",
	        null,
	        _get__("React").createElement("a", { className: "anchor", id: "filters" }),
	        _get__("React").createElement(
	          "h2",
	          null,
	          "Filters"
	        ),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "Core Layout"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "The Default wording for filters will be:"
	        ),
	        _get__("React").createElement(
	          "ul",
	          null,
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "b",
	              null,
	              "Title:"
	            ),
	            " \"Filters\" or \"Refine By:\""
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "b",
	              null,
	              "Button:"
	            ),
	            " \"Apply\" or \"Submit\""
	          )
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "You can add an ",
	          _get__("React").createElement(
	            "code",
	            null,
	            "is-title"
	          ),
	          " CSS class to the filter div to make use of this layout."
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "iframe-container display--flex", style: {
	              "height": "700px",
	              "border": "0",
	              "flexDirection": "column"
	            } },
	          _get__("React").createElement("iframe", { seamless: true, srcDoc: "\n            <html class=\"height--100\" style=\"background-color: #dedfe0\">\n              <head>\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\"> \n                <link rel=\"stylesheet\" type=\"text/css\" href=\"css/commonUI.css\">\n              </head>\n                <body class=\"height--100\">\n                  <div class=\"filter js-filter-panel is-title\" id=\"filter-ex-a\">\n                    <div class=\"filter__wrapper\">\n                      <div class=\"filter__sidebar js-filter-panel__open\" id=\"filter-ex-a-sidebar\">\n                        <div class=\"filter__sidebar--heading\">\n                          <div class=\"filter__sidebar--heading--icon\">\n                            <i class=\"icon-cme-filter\"></i>\n                          </div>\n                          <h3 class=\"flush--bottom filter__sidebar--heading--title push-quarter--left\">Filters</h3>\n                          <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\" id=\"filter-ex-a-sidebar-hide\">\n                            <span class=\"filter__sidebar--heading--hide--icon\">\n                              <i class=\"fa fa-chevron-left\"></i> Hide\n                            </span>\n                            <span class=\"filter__sidebar--heading--hide--close\">\n                              <i class=\"icon-cme-close-circle-o\"></i>\n                            </span>\n                          </button>\n                        </div>\n\n                        <div class=\"filter__sidebar--content\" id=\"filter-ex-a-sidebar-content\"></div>\n\n                        <div class=\"filter__sidebar--open\">\n                          <i class=\"fa fa-chevron-right\"></i>\n                        </div>\n\n                        <div class=\"filter__sidebar--seperator\"></div>\n\n                        <div class=\"filter__sidebar--action soft-half\">\n                          <button class=\"btn js-filter-panel__action width--100\" id=\"filter-ex-a-sidebar-action\">Apply</button>\n                        </div>\n                      </div>\n                      <div class=\"filter__content\" id=\"filter-ex-a-content\">\n                        <div class=\"well well--border-color push\">\n                          <h3 class=\"flush\">Results Content</h3>\n                          <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\" id=\"filter-ex-a-content-action\">\n                              <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n                              <span class=\"push-quarter--left\">Filters</span>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <script type=\"text/javascript\" src=\"js/commonUI.js\"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeFilter();\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            " })
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "button",
	          { type: "button", className: "btn btn--secondary show-code" },
	          _get__("React").createElement("i", { className: "fa fa-plus" }),
	          "View source"
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "pre",
	          { className: "hide-code" },
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<div class=\"filter js-filter-panel is-title\">\n  <div class=\"filter__wrapper\">\n    <div class=\"filter__sidebar js-filter-panel__open\">\n      <div class=\"filter__sidebar--heading\">\n        <div class=\"filter__sidebar--heading--icon\">\n          <i class=\"icon-cme-filter\"></i>\n        </div>\n        <h3 class=\"flush--bottom filter__sidebar--heading--title push-quarter--left\">Filters</h3>\n        <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\">\n          <span class=\"filter__sidebar--heading--hide--icon\">\n            <i class=\"fa fa-chevron-left\"></i> Hide\n          </span>\n          <span class=\"filter__sidebar--heading--hide--close\">\n            <i class=\"icon-cme-close-circle-o\"></i>\n          </span>\n        </button>\n      </div>\n\n      <div class=\"filter__sidebar--content\"></div>\n\n      <div class=\"filter__sidebar--open\">\n        <i class=\"fa fa-chevron-right\"></i>\n      </div>\n\n      <div class=\"filter__sidebar--seperator\"></div>\n\n      <div class=\"filter__sidebar--action soft-half\">\n        <button class=\"btn js-filter-panel__action width--100\">Apply</button>\n      </div>\n    </div>\n    <div class=\"filter__content\">\n      <div class=\"well well--border-color push\">\n        <h3 class=\"flush\">Results Content</h3>\n        <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\">\n            <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n            <span class=\"push-quarter--left\">Filters</span>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "p",
	          null,
	          "The sidebar remains a fixed width default 224px. (a small & large class will be available), is left aligned and scrolls independently and leaving the user in their place on the table/main content. Allow a gap of approximately 18px between the filter and the main content."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "If you wish for the sidebar to remain open, omit the ",
	          _get__("React").createElement(
	            "code",
	            null,
	            ".js-filter-panel__action"
	          ),
	          " CSS class from the sidebar action button."
	        ),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "With Icon"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "You can add an ",
	          _get__("React").createElement(
	            "code",
	            null,
	            "is-icon"
	          ),
	          " CSS class to the filter div to make use of this layout."
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "iframe-container display--flex", style: {
	              "height": "700px",
	              "border": "0",
	              "flexDirection": "column"
	            } },
	          _get__("React").createElement("iframe", { seamless: true, srcDoc: "\n            <html class=\"height--100\" style=\"background-color: #dedfe0\">\n              <head>\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\"> \n                <link rel=\"stylesheet\" type=\"text/css\" href=\"css/commonUI.css\">\n              </head>\n                <body class=\"height--100\">\n                  <div class=\"filter js-filter-panel is-icon\" id=\"filter-ex-b\">\n                    <div class=\"filter__wrapper\">\n                      <div class=\"filter__sidebar js-filter-panel__open\" id=\"filter-ex-b-sidebar\">\n                        <div class=\"filter__sidebar--heading\">\n                          <div class=\"filter__sidebar--heading--icon\">\n                            <i class=\"icon-cme-filter\"></i>\n                          </div>\n                          <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\" id=\"filter-ex-b-sidebar-hide\">\n                            <span class=\"filter__sidebar--heading--hide--icon\">\n                              <i class=\"fa fa-chevron-left\"></i> Hide\n                            </span>\n                            <span class=\"filter__sidebar--heading--hide--close\">\n                              <i class=\"icon-cme-close-circle-o\"></i>\n                            </span>\n                          </button>\n                        </div>\n\n                        <div class=\"filter__sidebar--content\" id=\"filter-ex-b-sidebar-content\"></div>\n\n                        <div class=\"filter__sidebar--open\">\n                          <i class=\"fa fa-chevron-right\"></i>\n                        </div>\n\n                        <div class=\"filter__sidebar--seperator\"></div>\n\n                        <div class=\"filter__sidebar--action soft-half\">\n                          <button class=\"btn js-filter-panel__action width--100\" id=\"filter-ex-b-sidebar-action\">Apply</button>\n                        </div>\n                      </div>\n                      <div class=\"filter__content\" id=\"filter-ex-b-content\">\n                        <div class=\"well well--border-color push\">\n                          <h3 class=\"flush\">Results Content</h3>\n                          <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\" id=\"filter-ex-b-content-action\">\n                              <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n                              <span class=\"push-quarter--left\">Filters</span>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <script type=\"text/javascript\" src=\"js/commonUI.js\"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeFilter();\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            " })
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "button",
	          { type: "button", className: "btn btn--secondary show-code" },
	          _get__("React").createElement("i", { className: "fa fa-plus" }),
	          "View source"
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "pre",
	          { className: "hide-code" },
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<div class=\"filter js-filter-panel is-icon\">\n  <div class=\"filter__wrapper\">\n    <div class=\"filter__sidebar js-filter-panel__open\">\n      <div class=\"filter__sidebar--heading\">\n        <div class=\"filter__sidebar--heading--icon\">\n          <i class=\"icon-cme-filter\"></i>\n        </div>\n        <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\">\n          <span class=\"filter__sidebar--heading--hide--icon\">\n            <i class=\"fa fa-chevron-left\"></i> Hide\n          </span>\n          <span class=\"filter__sidebar--heading--hide--close\">\n            <i class=\"icon-cme-close-circle-o\"></i>\n          </span>\n        </button>\n      </div>\n\n      <div class=\"filter__sidebar--content\"></div>\n\n      <div class=\"filter__sidebar--open\">\n        <i class=\"fa fa-chevron-right\"></i>\n      </div>\n\n      <div class=\"filter__sidebar--seperator\"></div>\n\n      <div class=\"filter__sidebar--action soft-half\">\n        <button class=\"btn js-filter-panel__action width--100\">Apply</button>\n      </div>\n    </div>\n    <div class=\"filter__content\">\n      <div class=\"well well--border-color push\">\n        <h3 class=\"flush\">Results Content</h3>\n        <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\">\n            <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n            <span class=\"push-quarter--left\">Filters</span>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("hr", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "With Text & Icon"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "You can add an ",
	          _get__("React").createElement(
	            "code",
	            null,
	            "is-icon-title"
	          ),
	          " CSS class to the filter div to make use of this layout."
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "iframe-container display--flex", style: {
	              "height": "700px",
	              "border": "0",
	              "flexDirection": "column"
	            } },
	          _get__("React").createElement("iframe", { seamless: true, srcDoc: "\n            <html class=\"height--100\" style=\"background-color: #dedfe0\">\n              <head>\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\"> \n                <link rel=\"stylesheet\" type=\"text/css\" href=\"css/commonUI.css\">\n              </head>\n                <body class=\"height--100\">\n                  <div class=\"filter js-filter-panel is-icon-title\" id=\"filter-ex-c\">\n                    <div class=\"filter__wrapper\">\n                      <div class=\"filter__sidebar js-filter-panel__open\" id=\"filter-ex-c-sidebar\">\n                        <div class=\"filter__sidebar--heading\">\n                          <div class=\"filter__sidebar--heading--icon\">\n                            <i class=\"icon-cme-filter\"></i>\n                          </div>\n                          <h3 class=\"flush--bottom filter__sidebar--heading--title push-quarter--left\">Filters</h3>\n                          <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\" id=\"filter-ex-c-sidebar-hide\">\n                            <span class=\"filter__sidebar--heading--hide--icon\">\n                              <i class=\"fa fa-chevron-left\"></i> Hide\n                            </span>\n                            <span class=\"filter__sidebar--heading--hide--close\">\n                              <i class=\"icon-cme-close-circle-o\"></i>\n                            </span>\n                          </button>\n                        </div>\n\n                        <div class=\"filter__sidebar--content\" id=\"filter-ex-c-sidebar-content\"></div>\n\n                        <div class=\"filter__sidebar--open\">\n                          <i class=\"fa fa-chevron-right\"></i>\n                        </div>\n\n                        <div class=\"filter__sidebar--seperator\"></div>\n\n                        <div class=\"filter__sidebar--action soft-half\">\n                          <button class=\"btn js-filter-panel__action width--100\" id=\"filter-ex-c-sidebar-action\">Apply</button>\n                        </div>\n                      </div>\n                      <div class=\"filter__content\" id=\"filter-ex-c-content\">\n                        <div class=\"well well--border-color push\">\n                          <h3 class=\"flush\">Results Content</h3>\n                          <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\" id=\"filter-ex-c-content-action\">\n                              <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n                              <span class=\"push-quarter--left\">Filters</span>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <script type=\"text/javascript\" src=\"js/commonUI.js\"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeFilter();\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            " })
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "button",
	          { type: "button", className: "btn btn--secondary show-code" },
	          _get__("React").createElement("i", { className: "fa fa-plus" }),
	          "View source"
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "pre",
	          { className: "hide-code" },
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<div class=\"filter js-filter-panel is-icon-title\">\n  <div class=\"filter__wrapper\">\n    <div class=\"filter__sidebar js-filter-panel__open\">\n      <div class=\"filter__sidebar--heading\">\n        <div class=\"filter__sidebar--heading--icon\">\n          <i class=\"icon-cme-filter\"></i>\n        </div>\n        <h3 class=\"flush--bottom filter__sidebar--heading--title push-quarter--left\">Filters</h3>\n        <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\">\n          <span class=\"filter__sidebar--heading--hide--icon\">\n            <i class=\"fa fa-chevron-left\"></i> Hide\n          </span>\n          <span class=\"filter__sidebar--heading--hide--close\">\n            <i class=\"icon-cme-close-circle-o\"></i>\n          </span>\n        </button>\n      </div>\n\n      <div class=\"filter__sidebar--content\"></div>\n\n      <div class=\"filter__sidebar--open\">\n        <i class=\"fa fa-chevron-right\"></i>\n      </div>\n\n      <div class=\"filter__sidebar--seperator\"></div>\n\n      <div class=\"filter__sidebar--action soft-half\">\n        <button class=\"btn js-filter-panel__action width--100\">Apply</button>\n      </div>\n    </div>\n    <div class=\"filter__content\">\n      <div class=\"well well--border-color push\">\n        <h3 class=\"flush\">Results Content</h3>\n        <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\">\n            <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n            <span class=\"push-quarter--left\">Filters</span>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("hr", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "With Content"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "You can make use of other Common UI components within the filter's ",
	          _get__("React").createElement(
	            "code",
	            null,
	            "filter__sidebar--content--wrapper"
	          ),
	          " DOM element."
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "iframe-container display--flex", style: {
	              "height": "700px",
	              "border": "0",
	              "flexDirection": "column"
	            } },
	          _get__("React").createElement("iframe", { seamless: true, srcDoc: "\n            <html class=\"height--100\" style=\"background-color: #dedfe0\">\n              <head>\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\"> \n                <link rel=\"stylesheet\" type=\"text/css\" href=\"css/commonUI.css\">\n              </head>\n                <body class=\"height--100\">\n                  <div class=\"filter js-filter-panel is-icon\" id=\"filter-ex-d\">\n                    <div class=\"filter__wrapper\">\n                      <div class=\"filter__sidebar js-filter-panel__open\" id=\"filter-ex-d-sidebar\">\n                        <div class=\"filter__sidebar--heading\">\n                          <div class=\"filter__sidebar--heading--icon\">\n                            <i class=\"icon-cme-filter\"></i>\n                          </div>\n                          <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\" id=\"filter-ex-d-sidebar-hide\">\n                            <span class=\"filter__sidebar--heading--hide--icon\">\n                              <i class=\"fa fa-chevron-left\"></i> Hide\n                            </span>\n                            <span class=\"filter__sidebar--heading--hide--close\">\n                              <i class=\"icon-cme-close-circle-o\"></i>\n                            </span>\n                          </button>\n                        </div>\n                        <div class=\"filter__sidebar--content\" id=\"filter-ex-d-sidebar-content\">\n                          <div class=\"filter__sidebar--content--wrapper\">\n                            <form class=\"js-filter-content-form\">\n                              <ul class=\"form-fields\">\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"filtersFirstName\">First Name</label>\n                                  <input id=\"filtersFirstName\" type=\"text\" class=\"text-input width--100\"/>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"filtersSecondName\">Second Name</label>\n                                  <input id=\"filtersSecondName\" type=\"text\" class=\"text-input width--100\"/>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"filtersAge\">Age</label>\n                                  <input id=\"filtersAge\" type=\"text\" class=\"text-input width--100\"/>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label>How would you like to be contacted?</label>\n                                  <ul class=\"check-list\">\n                                    <li>\n                                        <input type=\"checkbox\" id=\"filters-by-email\"/> <label for=\"filters-by-email\">By email</label>\n                                    </li>\n                                    <li>\n                                        <input type=\"checkbox\" id=\"filters-by-post\"/> <label for=\"filters-by-post\">By post</label>\n                                    </li>\n                                    <li>\n                                        <input type=\"checkbox\" id=\"filters-by-pigeon\"/> <label for=\"filters-by-pigeon\">By carrier pigeon</label>\n                                    </li>\n                                  </ul>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label>Select your hero</label>\n                                  <ul class=\"check-list\">\n                                    <li>\n                                      <input type=\"radio\" name=\"filters-hero\" id=\"FiltersHector\" /> <label for=\"FiltersHector\">Hector</label>\n                                    </li>\n                                    <li>\n                                      <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAchilles\" /> <label for=\"FiltersAchilles\">Achilles</label>\n                                    </li>\n                                    <li>\n                                      <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAgamemnon\" /> <label for=\"FiltersAgamemnon\">Agamemnon</label>\n                                    </li>\n                                  </ul>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"filters-countries\">Select your country</label>\n                                  <select id=\"filters-countries\" name=\"filters-countries\" class=\"width--100\">\n                                    <option>Argentina</option>\n                                    <option>Albania</option>\n                                    <option selected=\"selected\">Aruba</option>\n                                  </select>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label>What is your feedback?</label>\n                                  <textarea class=\"text-input width--100\" name=\"comments\" >Please enter your comments...</textarea>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label>How would you like to be contacted?</label>\n                                  <ul class=\"check-list\">\n                                    <li>\n                                      <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                                    </li>\n                                    <li>\n                                      <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                                    </li>\n                                    <li>\n                                      <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                                    </li>\n                                  </ul>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"countries\">Select your country</label>\n                                  <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                                    <option>Argentina</option>\n                                    <option>Albania</option>\n                                    <option selected=\"selected\">Aruba</option>\n                                  </select>\n                                </li>\n                              </ul>\n                            </form>\n                          </div>\n                        </div>\n                        <div class=\"filter__sidebar--open\">\n                          <i class=\"fa fa-chevron-right\"></i>\n                        </div>\n\n                        <div class=\"filter__sidebar--seperator\"></div>\n\n                        <div class=\"filter__sidebar--action soft-half\">\n                          <button class=\"btn js-filter-panel__action width--100\" id=\"filter-ex-d-sidebar-action\" disabled>Apply</button>\n                        </div>\n                      </div>\n                      <div class=\"filter__content\" id=\"filter-ex-d-content\">\n                        <div class=\"well well--border-color push\">\n                          <h3 class=\"flush\">Results Content</h3>\n                          <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\" id=\"filter-ex-d-content-action\">\n                              <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n                              <span class=\"push-quarter--left\">Filters</span>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <script type=\"text/javascript\" src=\"js/commonUI.js\"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeFilter();\n                      var filter = document.querySelector('.js-filter-panel');\n                      filter.addEventListener('apply.commonui.filter', function (event) {}, false);\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            " })
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "button",
	          { type: "button", className: "btn btn--secondary show-code" },
	          _get__("React").createElement("i", { className: "fa fa-plus" }),
	          "View source"
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "pre",
	          { className: "hide-code" },
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<div class=\"filter js-filter-panel is-icon\">\n  <div class=\"filter__wrapper\">\n    <div class=\"filter__sidebar js-filter-panel__open\">\n      <div class=\"filter__sidebar--heading\">\n        <div class=\"filter__sidebar--heading--icon\">\n          <i class=\"icon-cme-filter\"></i>\n        </div>\n        <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\">\n          <span class=\"filter__sidebar--heading--hide--icon\">\n            <i class=\"fa fa-chevron-left\"></i> Hide\n          </span>\n          <span class=\"filter__sidebar--heading--hide--close\">\n            <i class=\"icon-cme-close-circle-o\"></i>\n          </span>\n        </button>\n      </div>\n      <div class=\"filter__sidebar--content\">\n        <div class=\"filter__sidebar--content--wrapper\">\n          <form>\n            <ul class=\"form-fields\">\n              <li class=\"push-half--bottom\">\n                <label for=\"filtersFirstName\">First Name</label>\n                <input id=\"filtersFirstName\" type=\"text\" class=\"text-input width--100\"/>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label for=\"filtersSecondName\">Second Name</label>\n                <input id=\"filtersSecondName\" type=\"text\" class=\"text-input width--100\"/>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label for=\"filtersAge\">Age</label>\n                <input id=\"filtersAge\" type=\"text\" class=\"text-input width--100\"/>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label>How would you like to be contacted?</label>\n                <ul class=\"check-list\">\n                  <li>\n                      <input type=\"checkbox\" id=\"filters-by-email\"/> <label for=\"filters-by-email\">By email</label>\n                  </li>\n                  <li>\n                      <input type=\"checkbox\" id=\"filters-by-post\"/> <label for=\"filters-by-post\">By post</label>\n                  </li>\n                  <li>\n                      <input type=\"checkbox\" id=\"filters-by-pigeon\"/> <label for=\"filters-by-pigeon\">By carrier pigeon</label>\n                  </li>\n                </ul>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label>Select your hero</label>\n                <ul class=\"check-list\">\n                  <li>\n                    <input type=\"radio\" name=\"filters-hero\" id=\"FiltersHector\" /> <label for=\"FiltersHector\">Hector</label>\n                  </li>\n                  <li>\n                    <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAchilles\" /> <label for=\"FiltersAchilles\">Achilles</label>\n                  </li>\n                  <li>\n                    <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAgamemnon\" /> <label for=\"FiltersAgamemnon\">Agamemnon</label>\n                  </li>\n                </ul>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label for=\"filters-countries\">Select your country</label>\n                <select id=\"filters-countries\" name=\"filters-countries\" class=\"width--100\">\n                  <option>Argentina</option>\n                  <option>Albania</option>\n                  <option selected=\"selected\">Aruba</option>\n                </select>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label>What is your feedback?</label>\n                <textarea class=\"text-input width--100\" name=\"comments\" >Please enter your comments...</textarea>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label>How would you like to be contacted?</label>\n                <ul class=\"check-list\">\n                  <li>\n                    <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                  </li>\n                  <li>\n                    <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                  </li>\n                  <li>\n                    <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                  </li>\n                </ul>\n              </li>\n              <li class=\"push-half--bottom\">\n                <label for=\"countries\">Select your country</label>\n                <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                  <option>Argentina</option>\n                  <option>Albania</option>\n                  <option selected=\"selected\">Aruba</option>\n                </select>\n              </li>\n            </ul>\n          </form>\n        </div>\n      </div>\n      <div class=\"filter__sidebar--open\">\n        <i class=\"fa fa-chevron-right\"></i>\n      </div>\n\n      <div class=\"filter__sidebar--seperator\"></div>\n\n      <div class=\"filter__sidebar--action soft-half\">\n        <button class=\"btn js-filter-panel__action width--100\" disabled>Apply</button>\n      </div>\n    </div>\n    <div class=\"filter__content\">\n      <div class=\"well well--border-color push\">\n        <h3 class=\"flush\">Results Content</h3>\n        <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\">\n            <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n            <span class=\"push-quarter--left\">Filters</span>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "p",
	          null,
	          "There is a JavaScript event triggered on the component whenever the apply button is clicked. You can listen to this event like so:"
	        ),
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-javascript" },
	            "filterElement.addEventListener('cui-filters-apply', function (event) {}, false);"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "p",
	          null,
	          "When a filter form is present in the sidebar, the apply button becomes disabled until the form is interacted with. There are two events to handle this functionality:"
	        ),
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-javascript" },
	            "var filter = commonUI.initializeFilter();\nfilter.enableAction();\nfilter.disableAction();"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("hr", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "Embedded Filter"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "If you have multiple components on your page, you can wrap these in a ",
	          _get__("React").createElement(
	            "code",
	            null,
	            ".filter__group"
	          ),
	          " element. This will ensure that the filter properly spans the height of the browser window."
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "iframe-container display--flex", style: {
	              "height": "700px",
	              "border": "0",
	              "flexDirection": "column"
	            } },
	          _get__("React").createElement("iframe", { seamless: true, srcDoc: "\n            <html class=\"height--100\" style=\"background-color: #dedfe0\">\n              <head>\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\"> \n                <link rel=\"stylesheet\" type=\"text/css\" href=\"css/commonUI.css\">\n              </head>\n                <body class=\"height--100\">\n                  <div class=\"filter__group\">\n                    <nav class=\"nav nav--global nav--light drop-shadow js-nav\">\n                      <div class=\"nav__inner\">\n                        <div class=\"nav__header nav__header--logo-only\">\n                          <a class=\"nav__logo\" href=\"//www.cmegroup.com\" title=\"CME Group\" target=\"_blank\"></a>\n                        </div>\n                        <ul class=\"nav__items--primary\">\n                          <li class=\"nav__item--primary\"><a>Trading</a></li>\n                          <li class=\"nav__item--primary\"><a>Clearing</a></li>\n                          <li class=\"nav__item--primary\"><a>Regulation</a></li>\n                          <li class=\"nav__item--primary\"><a>Data</a></li>\n                          <li class=\"nav__item--primary\"><a>Education</a></li>\n                          <li class=\"nav__item--primary\"><a>About</a></li>\n                        </ul>\n                        <ul class=\"nav__actions\">\n                          <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"fa fa-star-o nav__action-icon\"></i></button></li>\n                          <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-search nav__action-icon\"></i></button></li>\n                          <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-profile nav__action-icon\"></i></button></li>\n                        </ul>\n                      </div>\n                    </nav>\n                    <div class=\"filter js-filter-panel is-icon\" id=\"filter-ex-d\">\n                      <div class=\"filter__wrapper\">\n                        <div class=\"filter__sidebar js-filter-panel__open\" id=\"filter-ex-d-sidebar\">\n                          <div class=\"filter__sidebar--heading\">\n                            <div class=\"filter__sidebar--heading--icon\">\n                              <i class=\"icon-cme-filter\"></i>\n                            </div>\n                            <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\" id=\"filter-ex-d-sidebar-hide\">\n                              <span class=\"filter__sidebar--heading--hide--icon\">\n                                <i class=\"fa fa-chevron-left\"></i> Hide\n                              </span>\n                              <span class=\"filter__sidebar--heading--hide--close\">\n                                <i class=\"icon-cme-close-circle-o\"></i>\n                              </span>\n                            </button>\n                          </div>\n                          <div class=\"filter__sidebar--content\" id=\"filter-ex-d-sidebar-content\">\n                            <div class=\"filter__sidebar--content--wrapper\">\n                              <form class=\"js-filter-content-form\">\n                                <ul class=\"form-fields\">\n                                  <li class=\"push-half--bottom\">\n                                    <label for=\"filtersFirstName\">First Name</label>\n                                    <input id=\"filtersFirstName\" type=\"text\" class=\"text-input width--100\"/>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label for=\"filtersSecondName\">Second Name</label>\n                                    <input id=\"filtersSecondName\" type=\"text\" class=\"text-input width--100\"/>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label for=\"filtersAge\">Age</label>\n                                    <input id=\"filtersAge\" type=\"text\" class=\"text-input width--100\"/>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label>How would you like to be contacted?</label>\n                                    <ul class=\"check-list\">\n                                      <li>\n                                          <input type=\"checkbox\" id=\"filters-by-email\"/> <label for=\"filters-by-email\">By email</label>\n                                      </li>\n                                      <li>\n                                          <input type=\"checkbox\" id=\"filters-by-post\"/> <label for=\"filters-by-post\">By post</label>\n                                      </li>\n                                      <li>\n                                          <input type=\"checkbox\" id=\"filters-by-pigeon\"/> <label for=\"filters-by-pigeon\">By carrier pigeon</label>\n                                      </li>\n                                    </ul>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label>Select your hero</label>\n                                    <ul class=\"check-list\">\n                                      <li>\n                                        <input type=\"radio\" name=\"filters-hero\" id=\"FiltersHector\" /> <label for=\"FiltersHector\">Hector</label>\n                                      </li>\n                                      <li>\n                                        <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAchilles\" /> <label for=\"FiltersAchilles\">Achilles</label>\n                                      </li>\n                                      <li>\n                                        <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAgamemnon\" /> <label for=\"FiltersAgamemnon\">Agamemnon</label>\n                                      </li>\n                                    </ul>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label for=\"filters-countries\">Select your country</label>\n                                    <select id=\"filters-countries\" name=\"filters-countries\" class=\"width--100\">\n                                      <option>Argentina</option>\n                                      <option>Albania</option>\n                                      <option selected=\"selected\">Aruba</option>\n                                    </select>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label>What is your feedback?</label>\n                                    <textarea class=\"text-input width--100\" name=\"comments\" >Please enter your comments...</textarea>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label>How would you like to be contacted?</label>\n                                    <ul class=\"check-list\">\n                                      <li>\n                                        <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                                      </li>\n                                      <li>\n                                        <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                                      </li>\n                                      <li>\n                                        <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                                      </li>\n                                    </ul>\n                                  </li>\n                                  <li class=\"push-half--bottom\">\n                                    <label for=\"countries\">Select your country</label>\n                                    <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                                      <option>Argentina</option>\n                                      <option>Albania</option>\n                                      <option selected=\"selected\">Aruba</option>\n                                    </select>\n                                  </li>\n                                </ul>\n                              </form>\n                            </div>\n                          </div>\n                          <div class=\"filter__sidebar--open\">\n                            <i class=\"fa fa-chevron-right\"></i>\n                          </div>\n\n                          <div class=\"filter__sidebar--seperator\"></div>\n\n                          <div class=\"filter__sidebar--action soft-half\">\n                            <button class=\"btn js-filter-panel__action width--100\" id=\"filter-ex-d-sidebar-action\" disabled>Apply</button>\n                          </div>\n                        </div>\n                        <div class=\"filter__content\" id=\"filter-ex-d-content\">\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">Results Content</h3>\n                            <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\" id=\"filter-ex-d-content-action\">\n                                <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n                                <span class=\"push-quarter--left\">Filters</span>\n                            </button>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">1</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">2</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">3</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">4</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">5</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">6</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">7</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">8</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">9</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">10</h3>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <script type=\"text/javascript\" src=\"js/commonUI.js\"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeFilter();\n                      var filter = document.querySelector('.js-filter-panel');\n                      filter.addEventListener('apply.commonui.filter', function (event) {}, false);\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            " })
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "button",
	          { type: "button", className: "btn btn--secondary show-code" },
	          _get__("React").createElement("i", { className: "fa fa-plus" }),
	          "View source"
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "pre",
	          { className: "hide-code" },
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<div class=\"filter__group\">\n  <nav class=\"nav nav--global nav--light drop-shadow js-nav\">\n    <div class=\"nav__inner\">\n      <div class=\"nav__header nav__header--logo-only\">\n        <a class=\"nav__logo\" href=\"//www.cmegroup.com\" title=\"CME Group\" target=\"_blank\"></a>\n      </div>\n      <ul class=\"nav__items--primary\">\n        <li class=\"nav__item--primary\"><a>Trading</a></li>\n        <li class=\"nav__item--primary\"><a>Clearing</a></li>\n        <li class=\"nav__item--primary\"><a>Regulation</a></li>\n        <li class=\"nav__item--primary\"><a>Data</a></li>\n        <li class=\"nav__item--primary\"><a>Education</a></li>\n        <li class=\"nav__item--primary\"><a>About</a></li>\n      </ul>\n      <ul class=\"nav__actions\">\n        <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"fa fa-star-o nav__action-icon\"></i></button></li>\n        <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-search nav__action-icon\"></i></button></li>\n        <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-profile nav__action-icon\"></i></button></li>\n      </ul>\n    </div>\n  </nav>\n  <div class=\"filter js-filter-panel is-icon\">\n    <div class=\"filter__wrapper\">\n      <div class=\"filter__sidebar js-filter-panel__open\">\n        <div class=\"filter__sidebar--heading\">\n          <div class=\"filter__sidebar--heading--icon\">\n            <i class=\"icon-cme-filter\"></i>\n          </div>\n          <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\">\n            <span class=\"filter__sidebar--heading--hide--icon\">\n              <i class=\"fa fa-chevron-left\"></i> Hide\n            </span>\n            <span class=\"filter__sidebar--heading--hide--close\">\n              <i class=\"icon-cme-close-circle-o\"></i>\n            </span>\n          </button>\n        </div>\n        <div class=\"filter__sidebar--content\">\n          <div class=\"filter__sidebar--content--wrapper\">\n            <form>\n              <ul class=\"form-fields\">\n                <li class=\"push-half--bottom\">\n                  <label for=\"filtersFirstName\">First Name</label>\n                  <input id=\"filtersFirstName\" type=\"text\" class=\"text-input width--100\"/>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label for=\"filtersSecondName\">Second Name</label>\n                  <input id=\"filtersSecondName\" type=\"text\" class=\"text-input width--100\"/>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label for=\"filtersAge\">Age</label>\n                  <input id=\"filtersAge\" type=\"text\" class=\"text-input width--100\"/>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label>How would you like to be contacted?</label>\n                  <ul class=\"check-list\">\n                    <li>\n                        <input type=\"checkbox\" id=\"filters-by-email\"/> <label for=\"filters-by-email\">By email</label>\n                    </li>\n                    <li>\n                        <input type=\"checkbox\" id=\"filters-by-post\"/> <label for=\"filters-by-post\">By post</label>\n                    </li>\n                    <li>\n                        <input type=\"checkbox\" id=\"filters-by-pigeon\"/> <label for=\"filters-by-pigeon\">By carrier pigeon</label>\n                    </li>\n                  </ul>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label>Select your hero</label>\n                  <ul class=\"check-list\">\n                    <li>\n                      <input type=\"radio\" name=\"filters-hero\" id=\"FiltersHector\" /> <label for=\"FiltersHector\">Hector</label>\n                    </li>\n                    <li>\n                      <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAchilles\" /> <label for=\"FiltersAchilles\">Achilles</label>\n                    </li>\n                    <li>\n                      <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAgamemnon\" /> <label for=\"FiltersAgamemnon\">Agamemnon</label>\n                    </li>\n                  </ul>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label for=\"filters-countries\">Select your country</label>\n                  <select id=\"filters-countries\" name=\"filters-countries\" class=\"width--100\">\n                    <option>Argentina</option>\n                    <option>Albania</option>\n                    <option selected=\"selected\">Aruba</option>\n                  </select>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label>What is your feedback?</label>\n                  <textarea class=\"text-input width--100\" name=\"comments\" >Please enter your comments...</textarea>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label>How would you like to be contacted?</label>\n                  <ul class=\"check-list\">\n                    <li>\n                      <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                    </li>\n                    <li>\n                      <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                    </li>\n                    <li>\n                      <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                    </li>\n                  </ul>\n                </li>\n                <li class=\"push-half--bottom\">\n                  <label for=\"countries\">Select your country</label>\n                  <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                    <option>Argentina</option>\n                    <option>Albania</option>\n                    <option selected=\"selected\">Aruba</option>\n                  </select>\n                </li>\n              </ul>\n            </form>\n          </div>\n        </div>\n        <div class=\"filter__sidebar--open\">\n          <i class=\"fa fa-chevron-right\"></i>\n        </div>\n\n        <div class=\"filter__sidebar--seperator\"></div>\n\n        <div class=\"filter__sidebar--action soft-half\">\n          <button class=\"btn js-filter-panel__action width--100\" disabled>Apply</button>\n        </div>\n      </div>\n      <div class=\"filter__content\">\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">Results Content</h3>\n          <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\">\n              <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n              <span class=\"push-quarter--left\">Filters</span>\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("hr", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "Filter Categories"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Using the Accordian component we can sub-divide filters into categories. This requires the Common UI Accordion JavaScript to be initialised like this: ",
	          _get__("React").createElement(
	            "code",
	            null,
	            "commonUI.initializeAccordion();"
	          ),
	          ". It is recommended to use an accordion when there is more than one item per category. Here is an example:"
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "iframe-container display--flex", style: {
	              "height": "700px",
	              "border": "0",
	              "flexDirection": "column"
	            } },
	          _get__("React").createElement("iframe", { seamless: true, srcDoc: "\n            <html class=\"height--100\" style=\"background-color: #dedfe0\">\n              <head>\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\"> \n                <link rel=\"stylesheet\" type=\"text/css\" href=\"css/commonUI.css\">\n              </head>\n                <body class=\"height--100\">\n                  <div class=\"filter__group\">\n                    <nav class=\"nav nav--global nav--light drop-shadow js-nav\">\n                      <div class=\"nav__inner\">\n                        <div class=\"nav__header nav__header--logo-only\">\n                          <a class=\"nav__logo\" href=\"//www.cmegroup.com\" title=\"CME Group\" target=\"_blank\"></a>\n                        </div>\n                        <ul class=\"nav__items--primary\">\n                          <li class=\"nav__item--primary\"><a>Trading</a></li>\n                          <li class=\"nav__item--primary\"><a>Clearing</a></li>\n                          <li class=\"nav__item--primary\"><a>Regulation</a></li>\n                          <li class=\"nav__item--primary\"><a>Data</a></li>\n                          <li class=\"nav__item--primary\"><a>Education</a></li>\n                          <li class=\"nav__item--primary\"><a>About</a></li>\n                        </ul>\n                        <ul class=\"nav__actions\">\n                          <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"fa fa-star-o nav__action-icon\"></i></button></li>\n                          <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-search nav__action-icon\"></i></button></li>\n                          <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-profile nav__action-icon\"></i></button></li>\n                        </ul>\n                      </div>\n                    </nav>\n                    <div class=\"filter js-filter-panel is-icon\" id=\"filter-ex-d\">\n                      <div class=\"filter__wrapper\">\n                        <div class=\"filter__sidebar js-filter-panel__open\" id=\"filter-ex-d-sidebar\">\n                          <div class=\"filter__sidebar--heading\">\n                            <div class=\"filter__sidebar--heading--icon\">\n                              <i class=\"icon-cme-filter\"></i>\n                            </div>\n                            <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\" id=\"filter-ex-d-sidebar-hide\">\n                              <span class=\"filter__sidebar--heading--hide--icon\">\n                                <i class=\"fa fa-chevron-left\"></i> Hide\n                              </span>\n                              <span class=\"filter__sidebar--heading--hide--close\">\n                                <i class=\"icon-cme-close-circle-o\"></i>\n                              </span>\n                            </button>\n                          </div>\n                          <div class=\"filter__sidebar--content hard\" id=\"filter-ex-d-sidebar-content\">\n                            <div class=\"filter__sidebar--content--wrapper\">\n                              <form class=\"js-filter-content-form\">\n                                <div class=\"accordion js-accordion\">\n                                  <div class=\"accordion__item\">\n                                      <div class=\"accordion__title\">\n                                          <h5 class=\"flush\">Category 1</h5>\n                                      </div>\n                                      <div class=\"accordion__content\">\n                                        <ul class=\"form-fields\">\n                                          <li class=\"push-half--bottom\">\n                                            <label for=\"filtersFirstName\">First Name</label>\n                                            <input id=\"filtersFirstName\" type=\"text\" class=\"text-input width--100\"/>\n                                          </li>\n                                          <li class=\"push-half--bottom\">\n                                            <label for=\"filtersSecondName\">Second Name</label>\n                                            <input id=\"filtersSecondName\" type=\"text\" class=\"text-input width--100\"/>\n                                          </li>\n                                          <li class=\"push-half--bottom\">\n                                            <label for=\"filtersAge\">Age</label>\n                                            <input id=\"filtersAge\" type=\"text\" class=\"text-input width--100\"/>\n                                          </li>\n                                        </ul>\n                                      </div>\n                                  </div>\n                                  <div class=\"accordion__item\">\n                                    <div class=\"accordion__title\">\n                                      <h5 class=\"flush\">Category 2</h5>\n                                    </div>\n                                    <div class=\"accordion__content\">\n                                      <ul class=\"form-fields\">\n                                        <li class=\"push-half--bottom\">\n                                          <label>How would you like to be contacted?</label>\n                                          <ul class=\"check-list\">\n                                            <li>\n                                                <input type=\"checkbox\" id=\"filters-by-email\"/> <label for=\"filters-by-email\">By email</label>\n                                            </li>\n                                            <li>\n                                                <input type=\"checkbox\" id=\"filters-by-post\"/> <label for=\"filters-by-post\">By post</label>\n                                            </li>\n                                            <li>\n                                                <input type=\"checkbox\" id=\"filters-by-pigeon\"/> <label for=\"filters-by-pigeon\">By carrier pigeon</label>\n                                            </li>\n                                          </ul>\n                                        </li>\n                                        <li class=\"push-half--bottom\">\n                                          <label>Select your hero</label>\n                                          <ul class=\"check-list\">\n                                            <li>\n                                              <input type=\"radio\" name=\"filters-hero\" id=\"FiltersHector\" /> <label for=\"FiltersHector\">Hector</label>\n                                            </li>\n                                            <li>\n                                              <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAchilles\" /> <label for=\"FiltersAchilles\">Achilles</label>\n                                            </li>\n                                            <li>\n                                              <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAgamemnon\" /> <label for=\"FiltersAgamemnon\">Agamemnon</label>\n                                            </li>\n                                          </ul>\n                                        </li>\n                                      </ul>\n                                    </div>\n                                </div>\n                                <div class=\"accordion__item\">\n                                    <div class=\"accordion__title\">\n                                      <h5 class=\"flush\">Category 3</h5>\n                                    </div>\n                                    <div class=\"accordion__content\">\n                                      <ul class=\"form-fields\">\n                                        <li class=\"push-half--bottom\">\n                                          <label for=\"filters-countries\">Select your country</label>\n                                          <select id=\"filters-countries\" name=\"filters-countries\" class=\"width--100\">\n                                            <option>Argentina</option>\n                                            <option>Albania</option>\n                                            <option selected=\"selected\">Aruba</option>\n                                          </select>\n                                        </li>\n                                        <li class=\"push-half--bottom\">\n                                          <label>What is your feedback?</label>\n                                          <textarea class=\"text-input width--100\" name=\"comments\" >Please enter your comments...</textarea>\n                                        </li>\n                                        <li class=\"push-half--bottom\">\n                                          <label>How would you like to be contacted?</label>\n                                          <ul class=\"check-list\">\n                                            <li>\n                                              <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                                            </li>\n                                            <li>\n                                              <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                                            </li>\n                                            <li>\n                                              <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                                            </li>\n                                          </ul>\n                                        </li>\n                                        <li class=\"push-half--bottom\">\n                                          <label for=\"countries\">Select your country</label>\n                                          <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                                            <option>Argentina</option>\n                                            <option>Albania</option>\n                                            <option selected=\"selected\">Aruba</option>\n                                          </select>\n                                        </li>\n                                      </ul>\n                                    </div>\n                                  </div>\n                                </div>\n                              </form>\n                            </div>\n                          </div>\n                          <div class=\"filter__sidebar--open\">\n                            <i class=\"fa fa-chevron-right\"></i>\n                          </div>\n\n                          <div class=\"filter__sidebar--seperator\"></div>\n\n                          <div class=\"filter__sidebar--action soft-half\">\n                            <button class=\"btn js-filter-panel__action width--100\" id=\"filter-ex-d-sidebar-action\" disabled>Apply</button>\n                          </div>\n                        </div>\n                        <div class=\"filter__content\" id=\"filter-ex-d-content\">\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">Results Content</h3>\n                            <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\" id=\"filter-ex-d-content-action\">\n                                <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n                                <span class=\"push-quarter--left\">Filters</span>\n                            </button>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">1</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">2</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">3</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">4</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">5</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">6</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">7</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">8</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">9</h3>\n                          </div>\n                          <div class=\"well well--border-color push\">\n                            <h3 class=\"flush\">10</h3>\n                          </div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <script type=\"text/javascript\" src=\"js/commonUI.js\"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeFilter();\n                      commonUI.initializeAccordion();\n                      var filter = document.querySelector('.js-filter-panel');\n                      filter.addEventListener('apply.commonui.filter', function (event) {}, false);\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            " })
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "button",
	          { type: "button", className: "btn btn--secondary show-code" },
	          _get__("React").createElement("i", { className: "fa fa-plus" }),
	          "View source"
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "pre",
	          { className: "hide-code" },
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<div class=\"filter__group\">\n  <nav class=\"nav nav--global nav--light drop-shadow js-nav\">\n    <div class=\"nav__inner\">\n      <div class=\"nav__header nav__header--logo-only\">\n        <a class=\"nav__logo\" href=\"//www.cmegroup.com\" title=\"CME Group\" target=\"_blank\"></a>\n      </div>\n      <ul class=\"nav__items--primary\">\n        <li class=\"nav__item--primary\"><a>Trading</a></li>\n        <li class=\"nav__item--primary\"><a>Clearing</a></li>\n        <li class=\"nav__item--primary\"><a>Regulation</a></li>\n        <li class=\"nav__item--primary\"><a>Data</a></li>\n        <li class=\"nav__item--primary\"><a>Education</a></li>\n        <li class=\"nav__item--primary\"><a>About</a></li>\n      </ul>\n      <ul class=\"nav__actions\">\n        <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"fa fa-star-o nav__action-icon\"></i></button></li>\n        <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-search nav__action-icon\"></i></button></li>\n        <li class=\"nav__action\"><button class=\"nav__action-btn\"><i class=\"icon-cme-profile nav__action-icon\"></i></button></li>\n      </ul>\n    </div>\n  </nav>\n  <div class=\"filter js-filter-panel is-icon\" id=\"filter-ex-d\">\n    <div class=\"filter__wrapper\">\n      <div class=\"filter__sidebar js-filter-panel__open\" id=\"filter-ex-d-sidebar\">\n        <div class=\"filter__sidebar--heading\">\n          <div class=\"filter__sidebar--heading--icon\">\n            <i class=\"icon-cme-filter\"></i>\n          </div>\n          <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\" id=\"filter-ex-d-sidebar-hide\">\n            <span class=\"filter__sidebar--heading--hide--icon\">\n              <i class=\"fa fa-chevron-left\"></i> Hide\n            </span>\n            <span class=\"filter__sidebar--heading--hide--close\">\n              <i class=\"icon-cme-close-circle-o\"></i>\n            </span>\n          </button>\n        </div>\n        <div class=\"filter__sidebar--content hard\" id=\"filter-ex-d-sidebar-content\">\n          <div class=\"filter__sidebar--content--wrapper\">\n            <form class=\"js-filter-content-form\">\n              <div class=\"accordion js-accordion\">\n                <div class=\"accordion__item\">\n                  <div class=\"accordion__title\">\n                      <h5 class=\"flush\">Category 1</h5>\n                  </div>\n                  <div class=\"accordion__content\">\n                    <ul class=\"form-fields\">\n                      <li class=\"push-half--bottom\">\n                        <label for=\"filtersFirstName\">First Name</label>\n                        <input id=\"filtersFirstName\" type=\"text\" class=\"text-input width--100\"/>\n                      </li>\n                      <li class=\"push-half--bottom\">\n                        <label for=\"filtersSecondName\">Second Name</label>\n                        <input id=\"filtersSecondName\" type=\"text\" class=\"text-input width--100\"/>\n                      </li>\n                      <li class=\"push-half--bottom\">\n                        <label for=\"filtersAge\">Age</label>\n                        <input id=\"filtersAge\" type=\"text\" class=\"text-input width--100\"/>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n                <div class=\"accordion__item\">\n                  <div class=\"accordion__title\">\n                    <h5 class=\"flush\">Category 2</h5>\n                  </div>\n                  <div class=\"accordion__content\">\n                    <ul class=\"form-fields\">\n                      <li class=\"push-half--bottom\">\n                        <label>How would you like to be contacted?</label>\n                        <ul class=\"check-list\">\n                          <li>\n                              <input type=\"checkbox\" id=\"filters-by-email\"/> <label for=\"filters-by-email\">By email</label>\n                          </li>\n                          <li>\n                              <input type=\"checkbox\" id=\"filters-by-post\"/> <label for=\"filters-by-post\">By post</label>\n                          </li>\n                          <li>\n                              <input type=\"checkbox\" id=\"filters-by-pigeon\"/> <label for=\"filters-by-pigeon\">By carrier pigeon</label>\n                          </li>\n                        </ul>\n                      </li>\n                      <li class=\"push-half--bottom\">\n                        <label>Select your hero</label>\n                        <ul class=\"check-list\">\n                          <li>\n                            <input type=\"radio\" name=\"filters-hero\" id=\"FiltersHector\" /> <label for=\"FiltersHector\">Hector</label>\n                          </li>\n                          <li>\n                            <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAchilles\" /> <label for=\"FiltersAchilles\">Achilles</label>\n                          </li>\n                          <li>\n                            <input type=\"radio\" name=\"filters-hero\" id=\"FiltersAgamemnon\" /> <label for=\"FiltersAgamemnon\">Agamemnon</label>\n                          </li>\n                        </ul>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n                <div class=\"accordion__item\">\n                  <div class=\"accordion__title\">\n                    <h5 class=\"flush\">Category 3</h5>\n                  </div>\n                  <div class=\"accordion__content\">\n                    <ul class=\"form-fields\">\n                      <li class=\"push-half--bottom\">\n                        <label for=\"filters-countries\">Select your country</label>\n                        <select id=\"filters-countries\" name=\"filters-countries\" class=\"width--100\">\n                          <option>Argentina</option>\n                          <option>Albania</option>\n                          <option selected=\"selected\">Aruba</option>\n                        </select>\n                      </li>\n                      <li class=\"push-half--bottom\">\n                        <label>What is your feedback?</label>\n                        <textarea class=\"text-input width--100\" name=\"comments\" >Please enter your comments...</textarea>\n                      </li>\n                      <li class=\"push-half--bottom\">\n                        <label>How would you like to be contacted?</label>\n                        <ul class=\"check-list\">\n                          <li>\n                            <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                          </li>\n                          <li>\n                            <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                          </li>\n                          <li>\n                            <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                          </li>\n                        </ul>\n                      </li>\n                      <li class=\"push-half--bottom\">\n                        <label for=\"countries\">Select your country</label>\n                        <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                          <option>Argentina</option>\n                          <option>Albania</option>\n                          <option selected=\"selected\">Aruba</option>\n                        </select>\n                      </li>\n                    </ul>\n                  </div>\n                </div>\n              </div>\n            </form>\n          </div>\n        </div>\n        <div class=\"filter__sidebar--open\">\n          <i class=\"fa fa-chevron-right\"></i>\n        </div>\n\n        <div class=\"filter__sidebar--seperator\"></div>\n\n        <div class=\"filter__sidebar--action soft-half\">\n          <button class=\"btn js-filter-panel__action width--100\" id=\"filter-ex-d-sidebar-action\" disabled>Apply</button>\n        </div>\n      </div>\n      <div class=\"filter__content\" id=\"filter-ex-d-content\">\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">Results Content</h3>\n          <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\" id=\"filter-ex-d-content-action\">\n              <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n              <span class=\"push-quarter--left\">Filters</span>\n          </button>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">1</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">2</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">3</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">4</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">5</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">6</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">7</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">8</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">9</h3>\n        </div>\n        <div class=\"well well--border-color push\">\n          <h3 class=\"flush\">10</h3>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("hr", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "Responsive Behaviour"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "On the Mobile view the Filter becomes it's own page, full width. 'Hide' text becomes 'X' (cme close icon) Filters are triggered by a button on the main results page, recommend icon & text on the button. Filters icon becomes a tick mark on this button when filters have been applied."
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "h3",
	          null,
	          "Hide/Show"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "This feature is best used when the sidebar does not always need to be visible and to give the data table more breathing room. Not necessary for smaller filters / data light tables. By default, the sidebar should be visible for discoverability."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "To close filter: Use chevron & 'Hide' link in Filter Header. To open: icon & a single centered blue chevron to open. The full closed sidebar is clickable to open."
	        ),
	        _get__("React").createElement(
	          "select",
	          { className: "size-select" },
	          _get__("React").createElement(
	            "option",
	            { value: "1199" },
	            "Select a resolution"
	          ),
	          _get__("React").createElement(
	            "option",
	            { value: "479" },
	            "480px (xs)"
	          ),
	          _get__("React").createElement(
	            "option",
	            { value: "767" },
	            "768px (sm)"
	          ),
	          _get__("React").createElement(
	            "option",
	            { value: "991" },
	            "992px (md)"
	          ),
	          _get__("React").createElement(
	            "option",
	            { value: "1199" },
	            "1200px (lg)"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "div",
	          { className: "iframe-container", style: { "height": "700px", "border": "0" } },
	          _get__("React").createElement("iframe", { seamless: true, srcDoc: "\n            <html class=\"height--100\" style=\"background-color: #dedfe0\">\n              <head>\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n                <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\"> \n                <link rel=\"stylesheet\" type=\"text/css\" href=\"css/commonUI.css\">\n              </head>\n                <body class=\"height--100\">\n                  <div class=\"filter js-filter-panel is-icon\">\n                    <div class=\"filter__wrapper\">\n                      <div class=\"filter__sidebar js-filter-panel__open\">\n                        <div class=\"filter__sidebar--heading\">\n                          <div class=\"filter__sidebar--heading--icon\">\n                            <i class=\"icon-cme-filter\"></i>\n                          </div>\n                          <button class=\"btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard\">\n                            <span class=\"filter__sidebar--heading--hide--icon\">\n                              <i class=\"fa fa-chevron-left\"></i> Hide\n                            </span>\n                            <span class=\"filter__sidebar--heading--hide--close\">\n                              <i class=\"icon-cme-close-circle-o\"></i>\n                            </span>\n                          </button>\n                        </div>\n                        <div class=\"filter__sidebar--content\">\n                          <div class=\"filter__sidebar--content--wrapper\">\n                            <form>\n                              <ul class=\"form-fields\">\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"firstName\">First Name</label>\n                                  <input id=\"firstName\" type=\"text\" class=\"text-input width--100\"/>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"secondName\">Second Name</label>\n                                  <input id=\"secondName\" type=\"text\" class=\"text-input width--100\"/>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label for=\"age\">Age</label>\n                                  <input id=\"age\" type=\"text\" class=\"text-input width--100\"/>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                  <label>How would you like to be contacted?</label>\n                                  <ul class=\"check-list\">\n                                      <li>\n                                          <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                                      </li>\n                                      <li>\n                                          <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                                      </li>\n                                      <li>\n                                          <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                                      </li>\n                                  </ul>\n                                </li>\n                                <li class=\"push-half--bottom\">\n                                    <label>Select your hero</label>\n                                    <ul class=\"check-list\">\n                                        <li>\n                                            <input type=\"radio\" name=\"hero\" id=\"Hector\" /> <label for=\"Hector\">Hector</label>\n                                        </li>\n                                        <li>\n                                            <input type=\"radio\" name=\"hero\" id=\"Achilles\" /> <label for=\"Achilles\">Achilles</label>\n                                        </li>\n                                        <li>\n                                          <input type=\"radio\" name=\"hero\" id=\"Agamemnon\" /> <label for=\"Agamemnon\">Agamemnon</label>\n                                        </li>\n                                    </ul>\n                                  </li>\n                                <li class=\"push-half--bottom\">\n                                    <label for=\"countries\">Select your country</label>\n                                    <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                                         <option>Argentina</option>\n                                         <option>Albania</option>\n                                         <option selected=\"selected\">Aruba</option>\n                                      </select>\n                                  </li>\n                                <li class=\"push-half--bottom\">\n                                    <label>What is your feedback?</label>\n                                    <textarea class=\"text-input width--100\" name=\"comments\" >Please enter your comments...</textarea>\n                                  </li>\n                                <li class=\"push-half--bottom\">\n                                    <label>How would you like to be contacted?</label>\n                                    <ul class=\"check-list\">\n                                        <li>\n                                            <input type=\"checkbox\" id=\"by-email\"/> <label for=\"by-email\">By email</label>\n                                        </li>\n                                        <li>\n                                            <input type=\"checkbox\" id=\"by-post\"/> <label for=\"by-post\">By post</label>\n                                        </li>\n                                        <li>\n                                            <input type=\"checkbox\" id=\"by-pigeon\"/> <label for=\"by-pigeon\">By carrier pigeon</label>\n                                        </li>\n                                    </ul>\n                                  </li>\n                                <li class=\"push-half--bottom\">\n                                    <label for=\"countries\">Select your country</label>\n                                    <select id=\"countries\" name=\"countries\" class=\"width--100\">\n                                         <option>Argentina</option>\n                                         <option>Albania</option>\n                                         <option selected=\"selected\">Aruba</option>\n                                      </select>\n                                  </li>\n                              </ul>\n                            </form>\n                          </div>\n                        </div>\n                        <div class=\"filter__sidebar--open\">\n                          <i class=\"fa fa-chevron-right\"></i>\n                        </div>\n\n                        <div class=\"filter__sidebar--action soft-half\">\n                          <button class=\"btn js-filter-panel__action width--100\" disabled>Apply</button>\n                        </div>\n                      </div>\n                      <div class=\"filter__content\">\n                        <div class=\"well well--border-color push\">\n                          <h3 class=\"flush\">Results Content</h3>\n                          <button class=\"btn filter__content--action js-filter-panel__remote-open push--top\">\n                              <i class=\"filter__content--state js-filter-panel__state fa icon-cme-filter\"></i>\n                              <span class=\"push-quarter--left\">Filters</span>\n                          </button>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                  <script type=\"text/javascript\" src=\"js/commonUI.js\"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeFilter();\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            " })
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "p",
	          null,
	          "This is a javascript enabled component. To enable the close and open functionality of the filter drawer you must initialize it using the following snippet:"
	        ),
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-javascript" },
	            "commonUI.initializeFilter();"
	          )
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement(
	          "p",
	          null,
	          "If you are embedding the Common UI filter within your application and it is being wrapped by one or many divs, you may need to apply the ",
	          _get__("React").createElement(
	            "code",
	            null,
	            ".height--inherit"
	          ),
	          " helper to these parent divs for the height be calculated correctly. Common UI provides 100% height to the ",
	          _get__("React").createElement(
	            "code",
	            null,
	            "html"
	          ),
	          " and ",
	          _get__("React").createElement(
	            "code",
	            null,
	            "body"
	          ),
	          " tags by default."
	        ),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("br", null),
	        _get__("React").createElement("hr", null),
	        _get__("React").createElement("br", null)
	      );
	    }
	  }]);
	
	  return Filters;
	}(_get__("Component"));
	
	exports.default = _get__("Filters");
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "Component":
	      return _react.Component;
	
	    case "Filters":
	      return Filters;
	
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Filters === "undefined" ? "undefined" : _typeof(Filters);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Filters, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Filters)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cmeBrandedIcons = ['multi-fill', 'cube', 'pause-circle', 'remove-circle', 'logout', 'login', 'cancellation-history', 'close-circle-o', 'profile', 'search', 'maximize-circle-o', 'remove-circle-o', 'settings', 'fill', 'chat', 'person-add', 'line-chart', 'report-delete', 'pencil', 'connection-off', 'report-download', 'book', 'connection-on', 'download', 'filter', 'report-unknown', 'ticket', 'line-book', 'split-arrows', 'gavel', 'users-outline', 'user-outline', 'admin-user', 'trophy', 'group', 'whiteboard', 'close-thin', 'price-history', 'drag-drop', 'draggable-three', 'draggable-two', 'file-alt', 'file-upload', 'layout-icon', 'new-window', 'collapse-all', 'expand-all', 'plus-thin', 'arrow-thin-up', 'arrow-thin-right', 'arrow-thin-left', 'arrow-thin-down', 'minus-thin'];
	
	var cmeAliasIcons = ['aggregate-fills', 'blocks', 'card-close', 'card-max', 'card-min', 'chat-add', 'chat-edit', 'fills', 'hold-all', 'market-data', 'mass-quote-cancel', 'nightly-reports', 'order-book', 'kill-all', 'orders', 'rfqs', 'trade-book', 'options', 'auctions', 'associate-bid', 'user-bid', 'price-to-beat', 'chat-room', 'draggable-three', 'draggable-two', 'file-alt'];
	
	var faWebAppIcons = ['archive', 'area-chart', 'arrows', 'arrows-h', 'arrows-v', 'assistive-listening-systems', 'asterisk', 'at', 'balance-scale', 'ban', 'bank (alias)', 'bar-chart', 'bars', 'bed', 'beer', 'bell', 'bell-o', 'bell-slash', 'bell-slash-o', 'binoculars', 'bolt', 'book', 'bookmark', 'bookmark-o', 'briefcase', 'building', 'building-o', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar-check-o', 'calendar-minus-o', 'calendar-o', 'calendar-plus-o', 'calendar-times-o', 'camera', 'camera-retro', 'caret-square-o-down', 'caret-square-o-left', 'caret-square-o-right', 'caret-square-o-up', 'cart-arrow-down', 'cart-plus', 'certificate', 'check', 'check-circle', 'check-circle-o', 'check-square', 'check-square-o', 'circle', 'circle-o', 'circle-o-notch', 'circle-thin', 'clock-o', 'clone', 'close (alias)', 'cloud', 'cloud-download', 'cloud-upload', 'code', 'code-fork', 'coffee', 'cog', 'cogs', 'comment', 'comment-o', 'commenting', 'commenting-o', 'comments', 'comments-o', 'copyright', 'credit-card', 'credit-card-alt', 'crop', 'cube', 'cubes', 'dashboard (alias)', 'database', 'desktop', 'diamond', 'dot-circle-o', 'download', 'edit (alias)', 'ellipsis-h', 'ellipsis-v', 'envelope', 'envelope-o', 'envelope-square', 'eraser', 'exchange', 'exclamation', 'exclamation-circle', 'exclamation-triangle', 'external-link', 'external-link-square', 'eye', 'eye-slash', 'fax', 'feed (alias)', 'film', 'filter', 'flag', 'flag-checkered', 'flag-o', 'flash (alias)', 'folder', 'folder-o', 'folder-open', 'folder-open-o', 'frown-o', 'futbol-o', 'gavel', 'gear (alias)', 'gears (alias)', 'globe', 'graduation-cap', 'group (alias)', 'hand-grab-o (alias)', 'hand-pointer-o', 'hand-stop-o (alias)', 'hashtag', 'headphones', 'heart', 'heart-o', 'heartbeat', 'history', 'home', 'hourglass', 'hourglass-1 (alias)', 'hourglass-2 (alias)', 'hourglass-3 (alias)', 'hourglass-end', 'hourglass-half', 'hourglass-o', 'hourglass-start', 'i-cursor', 'image (alias)', 'inbox', 'industry', 'info', 'info-circle', 'institution (alias)', 'key', 'keyboard-o', 'laptop', 'legal (alias)', 'level-down', 'level-up', 'lightbulb-o', 'line-chart', 'location-arrow', 'lock', 'magic', 'mail-forward (alias)', 'mail-reply (alias)', 'mail-reply-all (alias)', 'map', 'map-marker', 'map-o', 'map-pin', 'map-signs', 'meh-o', 'microphone', 'microphone-slash', 'minus', 'minus-circle', 'minus-square', 'minus-square-o', 'mobile', 'mobile-phone (alias)', 'money', 'mortar-board (alias)', 'mouse-pointer', 'navicon (alias)', 'newspaper-o', 'object-group', 'object-ungroup', 'pencil', 'pencil-square', 'pencil-square-o', 'percent', 'phone', 'phone-square', 'photo (alias)', 'picture-o', 'pie-chart', 'plug', 'plus', 'plus-circle', 'plus-square', 'plus-square-o', 'power-off', 'print', 'puzzle-piece', 'qrcode', 'question', 'question-circle', 'question-circle-o', 'quote-left', 'quote-right', 'random', 'recycle', 'refresh', 'registered', 'remove (alias)', 'reorder (alias)', 'reply', 'reply-all', 'retweet', 'road', 'rss', 'rss-square', 'search', 'search-minus', 'search-plus', 'send (alias)', 'send-o (alias)', 'share', 'share-alt', 'share-alt-square', 'share-square', 'share-square-o', 'shield', 'shopping-bag', 'shopping-basket', 'shopping-cart', 'sign-in', 'sign-out', 'signal', 'sitemap', 'sliders', 'smile-o', 'soccer-ball-o (alias)', 'sort', 'sort-alpha-asc', 'sort-alpha-desc', 'sort-amount-asc', 'sort-amount-desc', 'sort-asc', 'sort-desc', 'sort-down (alias)', 'sort-numeric-asc', 'sort-numeric-desc', 'sort-up (alias)', 'spinner', 'square', 'square-o', 'star', 'star-half', 'star-half-empty (alias)', 'star-half-full (alias)', 'star-half-o', 'star-o', 'sticky-note', 'sticky-note-o', 'suitcase', 'sun-o', 'tablet', 'tachometer', 'tag', 'tags', 'tasks', 'television', 'terminal', 'thumb-tack', 'thumbs-down', 'thumbs-o-down', 'thumbs-o-up', 'thumbs-up', 'ticket', 'times', 'times-circle', 'times-circle-o', 'toggle-down (alias)', 'toggle-left (alias)', 'toggle-off', 'toggle-on', 'toggle-right (alias)', 'toggle-up (alias)', 'trademark', 'trash', 'trash-o', 'trophy', 'tty', 'tv (alias)', 'umbrella', 'universal-access', 'university', 'unlock', 'unlock-alt', 'unsorted (alias)', 'upload', 'user', 'user-plus', 'user-times', 'users', 'video-camera', 'volume-down', 'volume-off', 'volume-up', 'warning (alias)', 'wifi', 'wrench'];
	
	var faFileTypeIcons = ['file', 'file-archive-o', 'file-audio-o', 'file-code-o', 'file-excel-o', 'file-image-o', 'file-movie-o (alias)', 'file-o', 'file-pdf-o', 'file-photo-o (alias)', 'file-picture-o (alias)', 'file-powerpoint-o', 'file-sound-o (alias)', 'file-text', 'file-text-o', 'file-video-o', 'file-word-o', 'file-zip-o (alias)'];
	
	var faCurrencyIcons = ['bitcoin (alias)', 'btc', 'cny (alias)', 'dollar (alias)', 'eur', 'euro (alias)', 'gbp', 'gg', 'gg-circle', 'ils', 'inr', 'jpy', 'krw', 'money', 'rmb (alias)', 'rouble (alias)', 'rub', 'ruble (alias)', 'rupee (alias)', 'shekel (alias)', 'sheqel (alias)', 'try', 'turkish-lira (alias)', 'usd', 'won (alias)', 'yen (alias)'];
	
	var faTextEditorIcons = ['align-center', 'align-justify', 'align-left', 'align-right', 'bold', 'chain (alias)', 'chain-broken', 'clipboard', 'columns', 'copy (alias)', 'cut (alias)', 'dedent (alias)', 'eraser', 'file', 'file-o', 'file-text', 'file-text-o', 'files-o', 'floppy-o', 'font', 'header', 'indent', 'italic', 'link', 'list', 'list-alt', 'list-ol', 'list-ul', 'outdent', 'paperclip', 'paragraph', 'paste (alias)', 'repeat', 'rotate-left (alias)', 'rotate-right (alias)', 'save (alias)', 'scissors', 'strikethrough', 'subscript', 'superscript', 'table', 'text-height', 'text-width', 'th', 'th-large', 'th-list', 'underline', 'undo', 'unlink (alias)'];
	
	var faDirectionalIcons = ['angle-double-down', 'angle-double-left', 'angle-double-right', 'angle-double-up', 'angle-down', 'angle-left', 'angle-right', 'angle-up', 'arrow-circle-down', 'arrow-circle-left', 'arrow-circle-o-down', 'arrow-circle-o-left', 'arrow-circle-o-right', 'arrow-circle-o-up', 'arrow-circle-right', 'arrow-circle-up', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'arrows', 'arrows-alt', 'arrows-h', 'arrows-v', 'caret-down', 'caret-left', 'caret-right', 'caret-square-o-down', 'caret-square-o-left', 'caret-square-o-right', 'caret-square-o-up', 'caret-up', 'chevron-circle-down', 'chevron-circle-left', 'chevron-circle-right', 'chevron-circle-up', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'exchange', 'hand-o-down', 'hand-o-left', 'hand-o-right', 'hand-o-up', 'long-arrow-down', 'long-arrow-left', 'long-arrow-right', 'long-arrow-up', 'toggle-down (alias)', 'toggle-left (alias)', 'toggle-right (alias)', 'toggle-up (alias)'];
	
	var faVideoPlayerIcons = ['arrows-alt', 'backward', 'compress', 'eject', 'expand', 'fast-backward', 'fast-forward', 'forward', 'pause', 'pause-circle', 'pause-circle-o', 'play', 'play-circle', 'play-circle-o', 'random', 'step-backward', 'step-forward', 'stop', 'stop-circle', 'stop-circle-o', 'youtube-play'];
	
	var faBrandIcons = ['facebook', 'google', 'instagram', 'linkedin', 'pinterest', 'slideshare', 'twitter', 'wechat (alias)', 'weibo', 'youtube'];
	
	var Icons = function (_get__2) {
	  _inherits(Icons, _get__2);
	
	  function Icons(props) {
	    _classCallCheck(this, Icons);
	
	    return _possibleConstructorReturn(this, (Icons.__proto__ || Object.getPrototypeOf(Icons)).call(this, props));
	  }
	
	  _createClass(Icons, [{
	    key: 'renderIcons',
	    value: function renderIcons(icons, iconClassPrefix) {
	      return _get__('React').createElement(
	        'div',
	        { className: 'grid grid--bleed icon-documentation' },
	        icons.map(function (icon, index) {
	
	          var isAlias = icon.indexOf('alias') > -1;
	          var iconClass = icon.replace(' (alias)', '');
	          var iconText = [iconClass, isAlias ? _get__('React').createElement(
	            'small',
	            { key: [icon, index, 'small'], className: 'text-muted' },
	            '\xA0(alias)'
	          ) : ''];
	
	          iconClass = iconClassPrefix + iconClass;
	
	          return _get__('React').createElement(
	            'div',
	            { key: [icon, index, 'div'], className: 'grid__col-xs-4 grid__col-md-4 grid__col-lg-3 grid--direction-row grid--align-center' },
	            _get__('React').createElement('i', { className: iconClass }),
	            '\xA0',
	            iconText
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'icons' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Icons'
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Branded'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Use an ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '<i>'
	          ),
	          ' for icon elements. You just simply apply the appropriate classes that match the icon you want to use. Here\'s what the markup looks like:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<i class="icon-cme-[name]"></i>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        this.renderIcons(_get__('cmeBrandedIcons'), "icon-cme-"),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Branded Icon Aliases'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' Some of the generic branded icons above are also available as specific aliases for use within applications such as CME One.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The following icons are additionally available as aliases and are used in the same way:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<i class="icon-cme-[alias]"></i>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        this.renderIcons(_get__('cmeAliasIcons'), "icon-cme-"),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Unbranded'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Use an ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '<i>'
	          ),
	          ' for icon elements. You just simply apply the appropriate classes that match the icon you want to use. Here\'s what the markup looks like:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<i class="fab fa-[icon]"></i>'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<i class="fas fa-[icon]"></i>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'We use the icon library ',
	          _get__('React').createElement(
	            'a',
	            { href: 'https://fontawesome.com/icons?d=gallery&m=free', target: '_blank' },
	            'font awesome'
	          ),
	          '. ',
	          _get__('React').createElement(
	            'b',
	            null,
	            'This is a subset of those available, please visit their documentation for more.'
	          ),
	          ' As you can see from the markup there are 2 syntaxes, so make sure you check the syntax provided by font awesome for the icon you use. To include it in your project insert the following'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Insert this in the <head> element on your page -->\n<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> '
	          )
	        )
	      );
	    }
	  }]);
	
	  return Icons;
	}(_get__('Component'));
	
	exports.default = _get__('Icons');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'cmeBrandedIcons':
	      return cmeBrandedIcons;
	
	    case 'cmeAliasIcons':
	      return cmeAliasIcons;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'Icons':
	      return Icons;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Icons === 'undefined' ? 'undefined' : _typeof(Icons);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Icons, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Icons)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Forms = function (_get__2) {
	  _inherits(Forms, _get__2);
	
	  function Forms(props) {
	    _classCallCheck(this, Forms);
	
	    var _this = _possibleConstructorReturn(this, (Forms.__proto__ || Object.getPrototypeOf(Forms)).call(this, props));
	
	    _this.state = {
	      formTheme: 'form--default'
	    };
	    _this.handleChangeFormTheme = _this.handleChangeFormTheme.bind(_this);
	    return _this;
	  }
	
	  _createClass(Forms, [{
	    key: 'handleChangeValidationState',
	    value: function handleChangeValidationState(e) {
	      var selectedOption = e.target.value;
	
	      if (selectedOption === 'success') {
	        $('.validation-success-example').show();
	        $('.validation-errors-example').hide();
	      } else if (selectedOption === 'error') {
	        $('.validation-errors-example').show();
	        $('.validation-success-example').hide();
	      }
	    }
	  }, {
	    key: 'handleChangeFormTheme',
	    value: function handleChangeFormTheme(option) {
	      var theme = option.target.value;
	      this.setState({ formTheme: 'form--' + theme });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'forms' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Forms'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Forms should be simple, smart and consistent through all parts of the user experience. Form labels should always be placed above the field entry. Fields should have a minimum of twice the height of the field label in vertical space between fields. Field lengths and drop downs should be as consistent as possible from field to field and not vary. Required fields should always show a red * to the left of the field. '
	        ),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Default Form Titles, Category Headings & Sub Category Headings'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'forms' }),
	        _get__('React').createElement(
	          'div',
	          null,
	          _get__('React').createElement(
	            'table',
	            { className: 'table table--rows table--notop' },
	            _get__('React').createElement(
	              'thead',
	              null,
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement('th', null),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Color'
	                ),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Size'
	                ),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Font Weight'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'tbody',
	              null,
	              _get__('React').createElement(
	                'tr',
	                { style: { height: 50 + 'px' } },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'span',
	                    { className: 'form__title' },
	                    'Form Title Style'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '#25323c'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '21px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '800'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { style: { height: 50 + 'px' } },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'span',
	                    { className: 'form__category' },
	                    'Category Font Style'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '#5a6874'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '18px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Bold'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { style: { height: 50 + 'px' } },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'span',
	                    { className: 'form__category-sub-helper' },
	                    'Form category sub helper text'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '#5a6874'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '11px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Normal'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { style: { height: 50 + 'px' } },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'span',
	                    { className: 'form__sub-category' },
	                    'Sub Category Font Style'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '#8c9aa1'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '14px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '800'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { style: { height: 50 + 'px' } },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'label',
	                    null,
	                    'labels capitalised by default'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '#25323C'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '12px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Normal'
	                )
	              ),
	              _get__('React').createElement(
	                'tr',
	                { style: { height: 50 + 'px' } },
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  _get__('React').createElement(
	                    'label',
	                    { className: 'label--uppercase' },
	                    'label uppercase'
	                  )
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '#25323C'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  '12px'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Normal'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'pre',
	            null,
	            _get__('React').createElement(
	              'code',
	              { className: 'language-html' },
	              '<span class="form__title">Form Title Style</span>\n<span class="form__category">Category Font Style</span>\n<span class="form__category-sub-helper">Form category sub helper text</span>\n<span class="form__sub-category">Sub Category Font Style</span>\n<label>labels capitalised by default</label>\n<label class="label--uppercase">label uppercase</label>'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Wrap fields in a ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '<ul class="form-fields">'
	          ),
	          ' to ensure correct spacing.'
	        ),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Textbox'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid hard' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'firstName' },
	              'Input (Default)'
	            ),
	            _get__('React').createElement('input', { id: 'firstName', type: 'text', className: 'text-input', value: 'Dave' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'firstName' },
	              'Input (Readonly)'
	            ),
	            _get__('React').createElement('input', { id: 'firstName', type: 'text', className: 'text-input', value: 'Input is readonly', readOnly: true })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'firstNameDisabled' },
	              'Input (Disabled)'
	            ),
	            _get__('React').createElement('input', { id: 'firstNameDisabled', type: 'text', className: 'text-input', value: 'Input is disabled', disabled: true })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          { className: 'flush' },
	          'Textbox - Size Options'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid hard' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'firstNameXsmall' },
	              'First Name (Xsmall)'
	            ),
	            _get__('React').createElement('input', { id: 'firstNameXsmall', type: 'text', className: 'text-input text-input--xsmall', placeholder: 'Enter first name...' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'firstNameDefault' },
	              'First Name (Default)'
	            ),
	            _get__('React').createElement('input', { id: 'firstNameDefault', type: 'text', className: 'text-input', placeholder: 'Enter first name...' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'firstNameMedium' },
	              'First Name (Medium)'
	            ),
	            _get__('React').createElement('input', { id: 'firstNameMedium', type: 'text', className: 'text-input text-input--medium', placeholder: 'Enter first name...' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'firstNameLarge' },
	              'First Name (Large)'
	            ),
	            _get__('React').createElement('input', { id: 'firstNameLarge', type: 'text', className: 'text-input text-input--large', placeholder: 'Enter first name...' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Add the following classes to set Textbox size.  Input width is set to fill 100% of the container it is in.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            'Xsmall:   .text-input .text-input--xsmall\nDefault:  .text-input\nMedium:   .text-input .text-input--medium\nLarge:    .text-input .text-input--large'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul className="form-fields grid hard">\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">\n    <label htmlFor="firstNameXsmall">First Name (Xsmall)</label>\n    <input id="firstNameXsmall" type="text" className="text-input text-input--xsmall" value="Angela" />\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">\n    <label htmlFor="firstNameDefault">First Name (Default)</label>\n    <input id="firstNameDefault" type="text" className="text-input" value="Angela" />\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">\n    <label htmlFor="firstNameMedium">First Name (Medium)</label>\n    <input id="firstNameMedium" type="text" className="text-input text-input--medium" value="Angela" />\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 soft-half">\n    <label htmlFor="firstNameLarge">First Name (Large)</label>\n    <input id="firstNameLarge" type="text" className="text-input text-input--large" value="Angela" />\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Multiline'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid hard' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'What is your feedback? (Default)'
	            ),
	            _get__('React').createElement('textarea', { className: 'text-input', name: 'comments', placeholder: 'Please enter your comments...' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'What is your feedback? (Readonly)'
	            ),
	            _get__('React').createElement('textarea', { className: 'text-input', name: 'comments', value: 'This content is readonly', readOnly: true })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'What is your feedback? (Disabled)'
	            ),
	            _get__('React').createElement('textarea', { className: 'text-input', name: 'comments', value: 'This input is disabled', disabled: true })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          { className: 'flush' },
	          'Multiline - Size Options'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid hard' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'What is your feedback? (Xsmall)'
	            ),
	            _get__('React').createElement('textarea', { className: 'text-input--xsmall', name: 'comments', placeholder: 'Please enter your comments...' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'What is your feedback? (Default)'
	            ),
	            _get__('React').createElement('textarea', { className: 'text-input', name: 'comments', placeholder: 'Please enter your comments...' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'What is your feedback? (Medium)'
	            ),
	            _get__('React').createElement('textarea', { className: 'text-input--medium', name: 'comments', placeholder: 'Please enter your comments...' })
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-3 grid__col-lg-3 soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'What is your feedback? (Large)'
	            ),
	            _get__('React').createElement('textarea', { className: 'text-input--large', name: 'comments', placeholder: 'Please enter your comments...' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Add the following classes to set Multiline size.  Input width is set to fill 100% of the container it is in.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            'Xsmall:   .text-input--xsmall\nDefault:  .text-input\nMedium:   .text-input--medium\nLarge:    .text-input--large'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="form-fields">\n  <li>\n    <label>What is your feedback?</label>\n    <textarea class="text-input--xsmall" name="comments" >Please enter your comments...</textarea>\n  </li>\n  <li>\n    <label>What is your feedback?</label>\n    <textarea class="text-input" name="comments" >Please enter your comments...</textarea>\n  </li>\n  <li>\n    <label>What is your feedback?</label>\n    <textarea class="text-input--medium" name="comments" >Please enter your comments...</textarea>\n  </li>\n  <li>\n    <label>What is your feedback?</label>\n    <textarea class="text-input--large" name="comments" >Please enter your comments...</textarea>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Checkbox'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid hard' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Contact Method (Xsmall)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list--xsmall' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-email-1' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-email-1' },
	                  'By email'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-post-1' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-post-1' },
	                  'By post'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-pigeon-1', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-pigeon-1' },
	                  'By carrier pigeon'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Contact Method (Default)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-email-2', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-email-2' },
	                  'By email'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-post-2' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-post-2' },
	                  'By post'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-pigeon-2', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-pigeon-2' },
	                  'By carrier pigeon'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Contact Method (Medium)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list--medium' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-email-3' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-email-3' },
	                  'By email'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-post-3', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-post-3' },
	                  'By post'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-pigeon-3' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-pigeon-3' },
	                  'By carrier pigeon'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Contact Method (Large)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list--large' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-email-4', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-email-4' },
	                  'By email'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-post-4' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-post-4' },
	                  'By post'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'by-pigeon-4', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'by-pigeon-4' },
	                  'By carrier pigeon'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul className="form-fields grid hard">\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Contact Method (Xsmall)</label>\n    <ul className="check-list--xsmall">\n        <li>\n            <input type="checkbox" id="by-email-1" /> <label htmlFor="by-email-1">By email</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-post-1" /> <label htmlFor="by-post-1">By post</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-pigeon-1" checked /> <label htmlFor="by-pigeon-1">By carrier pigeon</label>\n        </li>\n    </ul>\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Contact Method (Default)</label>\n    <ul className="check-list">\n        <li>\n            <input type="checkbox" id="by-email-2" checked /> <label htmlFor="by-email-2">By email</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-post-2" /> <label htmlFor="by-post-2">By post</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-pigeon-2" checked /> <label htmlFor="by-pigeon-2">By carrier pigeon</label>\n        </li>\n    </ul>\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Contact Method (Medium)</label>\n    <ul className="check-list--medium">\n        <li>\n            <input type="checkbox" id="by-email-3" /> <label htmlFor="by-email-3">By email</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-post-3" checked /> <label htmlFor="by-post-3">By post</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-pigeon-3" /> <label htmlFor="by-pigeon-3">By carrier pigeon</label>\n        </li>\n    </ul>\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Contact Method (Large)</label>\n    <ul className="check-list--large">\n        <li>\n            <input type="checkbox" id="by-email-4" checked /> <label htmlFor="by-email-4">By email</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-post-4" /> <label htmlFor="by-post-4">By post</label>\n        </li>\n        <li>\n            <input type="checkbox" id="by-pigeon-4" checked /> <label htmlFor="by-pigeon-4">By carrier pigeon</label>\n        </li>\n    </ul>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Radio'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Select your hero (Xsmall)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list--xsmall' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero', id: 'Hector', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Hector' },
	                  'Hector'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero', id: 'Achilles' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Achilles' },
	                  'Achilles'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero', id: 'Agamemnon' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Agamemnon' },
	                  'Agamemnon'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Select your hero (Default)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero1', id: 'Hector1' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Hector1' },
	                  'Hector'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero1', id: 'Achilles1', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Achilles1' },
	                  'Achilles'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero1', id: 'Agamemnon1' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Agamemnon1' },
	                  'Agamemnon'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Select your hero (Medium)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list--medium' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero2', id: 'Hector2' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Hector2' },
	                  'Hector'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero2', id: 'Achilles2' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Achilles2' },
	                  'Achilles'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero2', id: 'Agamemnon2', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Agamemnon2' },
	                  'Agamemnon'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Select your hero (Large)'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list--large' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero3', id: 'Hector3', checked: true }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Hector3' },
	                  'Hector'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero3', id: 'Achilles3' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Achilles3' },
	                  'Achilles'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'radio', name: 'hero3', id: 'Agamemnon3' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'Agamemnon3' },
	                  'Agamemnon'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul className="form-fields grid">\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Select your hero (Xsmall)</label>\n    <ul className="check-list--xsmall">\n        <li>\n            <input type="radio" name="hero" id="Hector" checked /> <label htmlFor="Hector">Hector</label>\n        </li>\n        <li>\n            <input type="radio" name="hero" id="Achilles" /> <label htmlFor="Achilles">Achilles</label>\n        </li>\n        <li>\n          <input type="radio" name="hero" id="Agamemnon" /> <label htmlFor="Agamemnon">Agamemnon</label>\n        </li>\n    </ul>\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Select your hero (Default)</label>\n    <ul className="check-list">\n        <li>\n            <input type="radio" name="hero1" id="Hector1" /> <label htmlFor="Hector1">Hector</label>\n        </li>\n        <li>\n            <input type="radio" name="hero1" id="Achilles1" checked /> <label htmlFor="Achilles1">Achilles</label>\n        </li>\n        <li>\n          <input type="radio" name="hero1" id="Agamemnon1" /> <label htmlFor="Agamemnon1">Agamemnon</label>\n        </li>\n    </ul>\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Select your hero (Medium)</label>\n    <ul className="check-list--medium">\n        <li>\n            <input type="radio" name="hero2" id="Hector2" /> <label htmlFor="Hector2">Hector</label>\n        </li>\n        <li>\n            <input type="radio" name="hero2" id="Achilles2" /> <label htmlFor="Achilles2">Achilles</label>\n        </li>\n        <li>\n          <input type="radio" name="hero2" id="Agamemnon2" checked /> <label htmlFor="Agamemnon2">Agamemnon</label>\n        </li>\n    </ul>\n  </li>\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-3 hard">\n    <label>Select your hero (Large)</label>\n    <ul className="check-list--large">\n        <li>\n            <input type="radio" name="hero3" id="Hector3" checked /> <label htmlFor="Hector3">Hector</label>\n        </li>\n        <li>\n            <input type="radio" name="hero3" id="Achilles3" /> <label htmlFor="Achilles3">Achilles</label>\n        </li>\n        <li>\n          <input type="radio" name="hero3" id="Agamemnon3" /> <label htmlFor="Agamemnon3">Agamemnon</label>\n        </li>\n    </ul>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Add the following classes to the containing ul to resize radio and checkbox lists'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            'Xsmall:   .check-list--xsmall\nDefault:  .check-list\nMedium:   .check-list--medium\nLarge:    .check-list--large'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Select'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid hard' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-2 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'countries' },
	              'Select country (Default)'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'countries', name: 'countries', defaultValue: 'Aruba' },
	              _get__('React').createElement(
	                'option',
	                null,
	                'Argentina'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Albania'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Aruba'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-3 grid__col-sm-3 grid__col-md-2 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'countries' },
	              'Select country (Disabled)'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'countries', name: 'countries', defaultValue: 'Aruba', disabled: true },
	              _get__('React').createElement(
	                'option',
	                null,
	                'Argentina'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Albania'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Aruba'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          { className: 'flush' },
	          'Select - Size Options'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid hard' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'countries' },
	              'Select country (Xsmall)'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'countries', name: 'countries', defaultValue: 'Argentina', className: 'select-input--xsmall' },
	              _get__('React').createElement(
	                'option',
	                null,
	                'Argentina'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Albania'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Aruba'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'countries' },
	              'Select country (Default)'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'countries', name: 'countries', defaultValue: 'Argentina' },
	              _get__('React').createElement(
	                'option',
	                null,
	                'Argentina'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Albania'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Aruba'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'countries' },
	              'Select country (Medium)'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'countries', name: 'countries', defaultValue: 'Argentina', className: 'select-input--medium' },
	              _get__('React').createElement(
	                'option',
	                null,
	                'Argentina'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Albania'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Aruba'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2 soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'countries' },
	              'Select country (Large)'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'countries', name: 'countries', defaultValue: 'Argentina', className: 'select-input--large' },
	              _get__('React').createElement(
	                'option',
	                null,
	                'Argentina'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Albania'
	              ),
	              _get__('React').createElement(
	                'option',
	                null,
	                'Aruba'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Add the following classes to set Select size.  Input width is set to fill 100% of the container it is in.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            'Xsmall:   .select-input--xsmall\nMedium:   .select-input--medium\nLarge:    .select-input--large'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="form-fields">\n  <li>\n    <label for="countries">Select your country</label>\n    <select id="countries" name="countries" class="select-input--xsmall">\n        <option>Argentina</option>\n        <option>Albania</option>\n        <option selected="selected">Aruba</option>\n    </select>\n  </li>\n  <li>\n    <label for="countries">Select your country</label>\n    <select id="countries" name="countries">\n        <option>Argentina</option>\n        <option>Albania</option>\n        <option selected="selected">Aruba</option>\n    </select>\n  </li>\n  <li>\n    <label for="countries">Select your country</label>\n    <select id="countries" name="countries" class="select-input--medium">\n        <option>Argentina</option>\n        <option>Albania</option>\n        <option selected="selected">Aruba</option>\n    </select>\n  </li>\n  <li>\n    <label for="countries">Select your country</label>\n    <select id="countries" name="countries" class="select-input--large">\n        <option>Argentina</option>\n        <option>Albania</option>\n        <option selected="selected">Aruba</option>\n    </select>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Validation'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Form validation should always be done inline. Error messaging should highlight the row and provide messaging underneath. Below is the 3 styles of validation that can be used based on the preference of the designer / application that is going to use it. Please note that these styles are not intended to be used in a mix \'n\' match type scenario and how they are presented below in groups is how its expected to be used via form design and development.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { style: { width: 100 + 'px' } },
	          _get__('React').createElement(
	            'select',
	            { id: 'validation-state-select', onChange: this.handleChangeValidationState },
	            _get__('React').createElement(
	              'option',
	              { value: 'error', selected: true },
	              'Error'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'success' },
	              'Success'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid hard flush validation-success-example', style: { display: 'none' } },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              _get__('React').createElement(
	                'label',
	                { className: 'label--uppercase soft-half', style: { display: 'inline' } },
	                'Default'
	              ),
	              _get__('React').createElement(
	                'label',
	                { style: { textTransform: "lowercase", display: 'inline' } },
	                '(.is-valid)'
	              )
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'form-fields soft-half max-width--80' },
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultSuccessText' },
	                  'Success - outline & text'
	                ),
	                _get__('React').createElement('input', { id: 'defaultSuccessText', type: 'text', className: 'text-input is-valid' }),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorSelect' },
	                  'Success - outline & text'
	                ),
	                _get__('React').createElement(
	                  'select',
	                  { id: 'countries', name: 'defaultErrorSelect', defaultValue: 'Argentina', className: 'is-valid' },
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Argentina'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Albania'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Aruba'
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorTextarea' },
	                  'Success - outline & text'
	                ),
	                _get__('React').createElement(
	                  'textarea',
	                  { className: 'text-input is-valid', name: 'defaultErrorTextarea' },
	                  'Please enter your comments...'
	                ),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultValidCalIcon' },
	                  'Calendar'
	                ),
	                _get__('React').createElement('input', { id: 'defaultValidCalIcon', type: 'text', className: 'text-input is-valid' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'icon__wrapper icon__wrapper--datepicker' },
	                  _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  null,
	                  'Units'
	                ),
	                _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text is-valid' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'input__unit-text' },
	                  'Kg'
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list list-inline is-valid' },
	                  _get__('React').createElement(
	                    'li',
	                    { className: 'push--right' },
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-valid-validation-1', id: 'radio1yes' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio1yes' },
	                      'Yes'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-valid-validation-1', id: 'radio1no', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio1no' },
	                      'No'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list is-valid' },
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'checkbox', id: 'accept-terms-valid-1' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'accept-terms-valid-1' },
	                      'Accept Terms & Conditions'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              _get__('React').createElement(
	                'label',
	                { className: 'label--uppercase soft-half', style: { display: 'inline' } },
	                'With Icon'
	              ),
	              _get__('React').createElement(
	                'label',
	                { style: { textTransform: 'lowercase', display: 'inline' } },
	                '(.is-valid--icon)'
	              )
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'form-fields soft-half max-width--80' },
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Success - outline with Icon & Text'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorText', type: 'text', className: 'text-input is-valid--icon' }),
	                _get__('React').createElement('i', { className: 'fas fa-check feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorSelect' },
	                  'Success - outline & Text'
	                ),
	                _get__('React').createElement(
	                  'select',
	                  { id: 'countries', name: 'defaultErrorSelect', defaultValue: 'Argentina', className: 'is-valid--icon' },
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Argentina'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Albania'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Aruba'
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Success - outline with Icon & Text'
	                ),
	                _get__('React').createElement(
	                  'textarea',
	                  { className: 'text-input is-valid--icon', name: 'comments' },
	                  'Please enter your comments...'
	                ),
	                _get__('React').createElement('i', { className: 'fas fa-check feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorTextarea' },
	                  'Calendar'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorTextarea', type: 'text', className: 'text-input is-valid--icon' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'icon__wrapper icon__wrapper--datepicker' },
	                  _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  null,
	                  'Units'
	                ),
	                _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text is-valid--icon' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'input__unit-text' },
	                  'Kg'
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list list-inline is-valid--icon' },
	                  _get__('React').createElement(
	                    'li',
	                    { className: 'push--right' },
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-valid-validation-2', id: 'radio2yes' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio2yes' },
	                      'Yes'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-valid-validation-2', id: 'radio2no', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio2no' },
	                      'No'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list is-valid--icon' },
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'checkbox', id: 'accept-terms-valid-2', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'accept-terms-valid-2' },
	                      'Accept Terms & Conditions'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              _get__('React').createElement(
	                'label',
	                { className: 'label--uppercase soft-half', style: { display: 'inline' } },
	                'Minimal'
	              ),
	              _get__('React').createElement(
	                'label',
	                { style: { textTransform: "lowercase", display: 'inline' } },
	                '(.is-valid--minimal)'
	              )
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'form-fields soft-half max-width--80' },
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Success - text & no icon'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorText', type: 'text', className: 'text-input is-valid--minimal' }),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorSelect' },
	                  'Success - text & no icon'
	                ),
	                _get__('React').createElement(
	                  'select',
	                  { id: 'countries', name: 'defaultErrorSelect', defaultValue: 'Argentina', className: 'is-valid--minimal' },
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Argentina'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Albania'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Aruba'
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Success - text & no icon'
	                ),
	                _get__('React').createElement(
	                  'textarea',
	                  { className: 'text-input is-valid--minimal', name: 'comments' },
	                  'Please enter your comments...'
	                ),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorTextarea' },
	                  'Calendar'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorTextarea', type: 'text', className: 'text-input is-valid--minimal' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'icon__wrapper icon__wrapper--datepicker' },
	                  _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  null,
	                  'Units'
	                ),
	                _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text is-valid--minimal' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'input__unit-text' },
	                  'Kg'
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list list-inline is-valid--minimal' },
	                  _get__('React').createElement(
	                    'li',
	                    { className: 'push--right' },
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-valid-validation-3', id: 'radio3yes' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio3yes' },
	                      'Yes'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-valid-validation-3', id: 'radio3no', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio3no' },
	                      'No'
	                    )
	                  )
	                ),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list is-valid--minimal' },
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'checkbox', id: 'accept-terms-valid-3' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'accept-terms-valid-3' },
	                      'Accept Terms & Conditions'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'success' },
	                  'This is the validation message'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code validation-success-example', style: { display: 'none' } },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html validation-success-example' },
	            'Validation Success - Default:\n\n<ul class="form-fields">\n  <li>\n    <label htmlFor="defaultValidText">Error - outline and text</label>\n    <input id="defaultValidText" type="text" class="text-input is-valid"/>\n    <span class="feedback"></span>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n  <label htmlFor="defaultValidSelect">Error - outline and text</label>\n    <select id="countries" name="defaultValidSelect" defaultValue="Argentina" class="is-valid">\n      <option>Argentina</option>\n      <option>Albania</option>\n      <option>Aruba</option>\n    </select>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidTextarea">Error - outline and text</label>\n    <textarea class="text-input is-valid" name="defaultValidTextarea" >Please enter your comments...</textarea>\n    <span class="feedback"></span>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidCalIcon">Calendar</label>\n    <input id="defaultValidCalIcon" type="text" class="text-input is-valid"/>\n    <div class="icon__wrapper icon__wrapper--datepicker">\n      <i class="far fa-calendar-alt"></i>\n    </div>\n    <div class="success">This is a required field</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidUnit">Units</label>\n    <input type="text" class="text-input has-unit-text is-valid" name="defaultValidUnit" />\n    <div class="input__unit-text">\n        Kg\n    </div>\n    <div class="success">This is a required field</div>\n  </li>\n  <li>\n    <ul class="check-list list-inline is-valid">\n      <li class="push--right">\n          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>\n      </li>\n      <li>\n          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>\n      </li>\n    </ul>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <ul class="check-list is-valid">\n      <li>\n          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>\n      </li>\n    </ul>\n    <div class="success">This is the validation message</div>\n  </li>\n</ul>\n\nValidation Success - With icon:\n\n<ul class="form-fields">\n  <li>\n    <label htmlFor="defaultValidText">Error - outline, icon & text</label>\n    <input id="defaultValidText" type="text" class="text-input is-valid--icon"/>\n    <i class="fas fa-check feedback"></i>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n  <label htmlFor="defaultValidSelect">Error - outline, icon & text</label>\n    <select id="countries" name="defaultValidSelect" defaultValue="Argentina" class="is-valid--icon">\n      <option>Argentina</option>\n      <option>Albania</option>\n      <option>Aruba</option>\n    </select>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidTextarea">Error - outline and text</label>\n    <textarea class="text-input is-valid--icon" name="defaultValidTextarea" >Please enter your comments...</textarea>\n    <i class="fas fa-check feedback"></i>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidCalIcon">Calendar</label>\n    <input id="defaultValidCalIcon" type="text" class="text-input is-valid--icon"/>\n    <div class="icon__wrapper icon__wrapper--datepicker">\n      <i class="far fa-calendar-alt"></i>\n    </div>\n    <div class="success">This is a required field</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidUnit">Units</label>\n    <input type="text" class="text-input has-unit-text is-valid--icon" name="defaultValidUnit" />\n    <div class="input__unit-text">\n        Kg\n    </div>\n    <div class="success">This is a required field</div>\n  </li>\n  <li>\n    <ul class="check-list list-inline is-valid--icon">\n      <li class="push--right">\n          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>\n      </li>\n      <li>\n          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>\n      </li>\n    </ul>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <ul class="check-list is-valid--icon">\n      <li>\n          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>\n      </li>\n    </ul>\n    <div class="success">This is the validation message</div>\n  </li>\n</ul>\n\nValidation Success - Minimal:\n\n<ul class="form-fields">\n  <li>\n    <label htmlFor="defaultValidText">Error - Text & No Icon</label>\n    <input id="defaultValidText" type="text" class="text-input is-valid--minimal"/>\n    <span class="feedback"></span>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n  <label htmlFor="defaultValidSelect">Error - Text & No Icon</label>\n    <select id="countries" name="defaultValidSelect" defaultValue="Argentina" class="is-valid--minimal">\n      <option>Argentina</option>\n      <option>Albania</option>\n      <option>Aruba</option>\n    </select>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidTextarea">Error - Text & No Icon</label>\n    <textarea class="text-input is-valid--minimal" name="defaultValidTextarea" >Please enter your comments...</textarea>\n    <span class="feedback"></span>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidCalIcon">Calendar</label>\n    <input id="defaultValidCalIcon" type="text" class="text-input is-valid--minimal"/>\n    <div class="icon__wrapper icon__wrapper--datepicker">\n      <i class="far fa-calendar-alt"></i>\n    </div>\n    <div class="success">This is a required field</div>\n  </li>\n  <li>\n    <label htmlFor="defaultValidUnit">Units</label>\n    <input type="text" class="text-input has-unit-text is-valid--minimal" name="defaultValidUnit" />\n    <div class="input__unit-text">\n        Kg\n    </div>\n    <div class="success">This is a required field</div>\n  </li>\n  <li>\n    <ul class="check-list list-inline is-valid--minimal">\n      <li class="push--right">\n          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>\n      </li>\n      <li>\n          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>\n      </li>\n    </ul>\n    <div class="success">This is the validation message</div>\n  </li>\n  <li>\n    <ul class="check-list is-valid--minimal">\n      <li>\n          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>\n      </li>\n    </ul>\n    <div class="success">This is the validation message</div>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid hard flush validation-errors-example' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              _get__('React').createElement(
	                'label',
	                { className: 'label--uppercase soft-half', style: { display: 'inline' } },
	                'Default'
	              ),
	              _get__('React').createElement(
	                'label',
	                { style: { textTransform: "lowercase", display: 'inline' } },
	                '(.has-error)'
	              )
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'form-fields soft-half max-width--80' },
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Error - outline & text'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorText', type: 'text', className: 'text-input has-error' }),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorSelect' },
	                  'Error - outline & text'
	                ),
	                _get__('React').createElement(
	                  'select',
	                  { id: 'countries', name: 'defaultErrorSelect', defaultValue: 'Argentina', className: 'has-error' },
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Argentina'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Albania'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Aruba'
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Error - outline & text'
	                ),
	                _get__('React').createElement(
	                  'textarea',
	                  { className: 'text-input has-error', name: 'comments' },
	                  'Please enter your comments...'
	                ),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorTextarea' },
	                  'Calendar'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorTextarea', type: 'text', className: 'text-input has-error' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'icon__wrapper icon__wrapper--datepicker' },
	                  _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  null,
	                  'Units'
	                ),
	                _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text has-error' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'input__unit-text' },
	                  'Kg'
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list list-inline has-error' },
	                  _get__('React').createElement(
	                    'li',
	                    { className: 'push--right' },
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-validation-1', id: 'radio1yes' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio1yes' },
	                      'Yes'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-validation-1', id: 'radio1no', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio1no' },
	                      'No'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list has-error' },
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'checkbox', id: 'accept-terms-1' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'accept-terms-1' },
	                      'Accept Terms & Conditions'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              _get__('React').createElement(
	                'label',
	                { className: 'label--uppercase soft-half', style: { display: 'inline' } },
	                'With Icon'
	              ),
	              _get__('React').createElement(
	                'label',
	                { style: { textTransform: "lowercase", display: 'inline' } },
	                '(.has-error--icon)'
	              )
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'form-fields soft-half max-width--80' },
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Error - outline, icon & text'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorText', type: 'text', className: 'text-input has-error--icon' }),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorSelect' },
	                  'Error - outline & text'
	                ),
	                _get__('React').createElement(
	                  'select',
	                  { id: 'countries', name: 'defaultErrorSelect', defaultValue: 'Argentina', className: 'has-error' },
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Argentina'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Albania'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Aruba'
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Error - outline, icon & text'
	                ),
	                _get__('React').createElement(
	                  'textarea',
	                  { className: 'text-input has-error--icon', name: 'comments' },
	                  'Please enter your comments...'
	                ),
	                _get__('React').createElement('i', { className: 'fas fa-times feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorTextarea' },
	                  'Calendar'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorTextarea', type: 'text', className: 'text-input has-error' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'icon__wrapper icon__wrapper--datepicker' },
	                  _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  null,
	                  'Units'
	                ),
	                _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text has-error' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'input__unit-text' },
	                  'Kg'
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list list-inline has-error' },
	                  _get__('React').createElement(
	                    'li',
	                    { className: 'push--right' },
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-validation-2', id: 'radio2yes' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio2yes' },
	                      'Yes'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-validation-2', id: 'radio2no', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio2no' },
	                      'No'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list has-error' },
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'checkbox', id: 'accept-terms-2', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'accept-terms-2' },
	                      'Accept Terms & Conditions'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-4 hard' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              _get__('React').createElement(
	                'label',
	                { className: 'label--uppercase soft-half', style: { display: 'inline' } },
	                'Minimal'
	              ),
	              _get__('React').createElement(
	                'label',
	                { style: { textTransform: "lowercase", display: 'inline' } },
	                '(.has-error--minimal)'
	              )
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'form-fields soft-half max-width--80' },
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Error - text & no icon'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorText', type: 'text', className: 'text-input has-error--minimal' }),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorSelect' },
	                  'Error - text & no icon'
	                ),
	                _get__('React').createElement(
	                  'select',
	                  { id: 'countries', name: 'defaultErrorSelect', defaultValue: 'Argentina', className: 'has-error--minimal' },
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Argentina'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Albania'
	                  ),
	                  _get__('React').createElement(
	                    'option',
	                    null,
	                    'Aruba'
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorText' },
	                  'Error - text & no icon'
	                ),
	                _get__('React').createElement(
	                  'textarea',
	                  { className: 'text-input has-error--minimal', name: 'comments' },
	                  'Please enter your comments...'
	                ),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'defaultErrorTextarea' },
	                  'Calendar'
	                ),
	                _get__('React').createElement('input', { id: 'defaultErrorTextarea', type: 'text', className: 'text-input has-error--minimal' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'icon__wrapper icon__wrapper--datepicker' },
	                  _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'label',
	                  null,
	                  'Units'
	                ),
	                _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text has-error--minimal' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'input__unit-text' },
	                  'Kg'
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list list-inline has-error--minimal' },
	                  _get__('React').createElement(
	                    'li',
	                    { className: 'push--right' },
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-validation-3', id: 'radio3yes' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio3yes' },
	                      'Yes'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'radio', name: 'radio-validation-3', id: 'radio3no', checked: true }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'radio3no' },
	                      'No'
	                    )
	                  )
	                ),
	                _get__('React').createElement('span', { className: 'feedback' }),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'push-half--bottom' },
	                _get__('React').createElement(
	                  'ul',
	                  { className: 'check-list has-error--minimal' },
	                  _get__('React').createElement(
	                    'li',
	                    null,
	                    _get__('React').createElement('input', { type: 'checkbox', id: 'accept-terms-3' }),
	                    ' ',
	                    _get__('React').createElement(
	                      'label',
	                      { htmlFor: 'accept-terms-3' },
	                      'Accept Terms & Conditions'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'div',
	                  { className: 'error' },
	                  'This is the validation message'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code validation-errors-example' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html validation-errors-example' },
	            'Validation Error - Default:\n\n<ul class="form-fields">\n  <li>\n    <label htmlFor="defaultErrorText">Error - outline and text</label>\n    <input id="defaultErrorText" type="text" class="text-input has-error"/>\n    <span class="feedback"></span>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n  <label htmlFor="defaultErrorSelect">Error - outline and text</label>\n    <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" class="has-error">\n      <option>Argentina</option>\n      <option>Albania</option>\n      <option>Aruba</option>\n    </select>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultErrorText">Error - outline and text</label>\n    <textarea class="text-input has-error" name="comments" >Please enter your comments...</textarea>\n    <span class="feedback"></span>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultErrorTextarea">Calendar</label>\n    <input id="defaultErrorTextarea" type="text" class="text-input has-error"/>\n    <div class="icon__wrapper icon__wrapper--datepicker">\n      <i class="far fa-calendar-alt"></i>\n    </div>\n    <div class="error">This is a required field</div>\n  </li>\n  <li>\n    <label>Units</label>\n    <input type="text" class="text-input has-unit-text has-error"/>\n    <div class="input__unit-text">\n        Kg\n    </div>\n    <div class="error">This is a required field</div>\n  </li>\n  <li>\n    <ul class="check-list list-inline has-error">\n      <li class="push--right">\n          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>\n      </li>\n      <li>\n          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>\n      </li>\n    </ul>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <ul class="check-list has-error">\n      <li>\n          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>\n      </li>\n    </ul>\n    <div class="error">This is the validation message</div>\n  </li>\n</ul>\n\nValidation Error - With icon:\n\n<ul class="form-fields">\n  <li>\n    <label htmlFor="defaultErrorText">Error - outline and text</label>\n    <input id="defaultErrorText" type="text" class="text-input has-error--icon"/>\n    <i class="fas fa-times feedback"></i>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n  <label htmlFor="defaultErrorSelect">Error - outline and text</label>\n    <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" class="has-error--icon">\n      <option>Argentina</option>\n      <option>Albania</option>\n      <option>Aruba</option>\n    </select>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultErrorText">Error - outline and text</label>\n    <textarea class="text-input has-error--icon" name="comments" >Please enter your comments...</textarea>\n    <i class="fas fa-times feedback"></i>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultErrorTextarea">Calendar</label>\n    <input id="defaultErrorTextarea" type="text" class="text-input has-error--icon"/>\n    <div class="icon__wrapper icon__wrapper--datepicker">\n      <i class="far fa-calendar-alt"></i>\n    </div>\n    <div class="error">This is a required field</div>\n  </li>\n  <li>\n    <label>Units</label>\n    <input type="text" class="text-input has-unit-text has-error--icon"/>\n    <div class="input__unit-text">\n        Kg\n    </div>\n    <div class="error">This is a required field</div>\n  </li>\n  <li>\n    <ul class="check-list list-inline has-error--icon">\n      <li class="push--right">\n          <input type="radio" name="radio-validation-1" id="radio1yes" /> <label htmlFor="radio1yes">Yes</label>\n      </li>\n      <li>\n          <input type="radio" name="radio-validation-1" id="radio1no" checked /> <label htmlFor="radio1no">No</label>\n      </li>\n    </ul>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <ul class="check-list has-error--icon">\n      <li>\n          <input type="checkbox" id="accept-terms-1" /> <label htmlFor="accept-terms-1">Accept Terms &#38; Conditions</label>\n      </li>\n    </ul>\n    <div class="error">This is the validation message</div>\n  </li>\n</ul>\n\nValidation Error - Minimal:\n\n<ul class="form-fields">\n  <li>\n    <label htmlFor="defaultErrorText">Error - outline and text</label>\n    <input id="defaultErrorText" type="text" class="text-input has-error--minimal"/>\n    <span class="feedback"></span>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultErrorSelect">Error - outline and text</label>\n    <select id="countries" name="defaultErrorSelect" defaultValue="Argentina" class="has-error--minimal">\n      <option>Argentina</option>\n      <option>Albania</option>\n      <option>Aruba</option>\n    </select>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultErrorText">Error - outline and text</label>\n    <textarea class="text-input has-error--minimal" name="comments" >Please enter your comments...</textarea>\n    <span class="feedback"></span>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <label htmlFor="defaultErrorTextarea">Calendar</label>\n    <input id="defaultErrorTextarea" type="text" class="text-input has-error--minimal"/>\n    <div class="icon__wrapper icon__wrapper--datepicker">\n      <i class="far fa-calendar-alt"></i>\n    </div>\n    <div class="error">This is a required field</div>\n  </li>\n  <li>\n    <label>Units</label>\n    <input type="text" class="text-input has-unit-text has-error--minimal"/>\n    <div class="input__unit-text">\n        Kg\n    </div>\n    <div class="error">This is a required field</div>\n  </li>\n  <li>\n    <ul class="check-list list-inline has-error--minimal">\n      <li class="push--right">\n          <input type="radio" name="radio-validation-3" id="radio3yes" /> <label htmlFor="radio3yes">Yes</label>\n      </li>\n      <li>\n          <input type="radio" name="radio-validation-3" id="radio3no" checked /> <label htmlFor="radio3no">No</label>\n      </li>\n    </ul>\n    <span class="feedback"></span>\n    <div class="error">This is the validation message</div>\n  </li>\n  <li>\n    <ul class="check-list has-error--minimal">\n      <li>\n          <input type="checkbox" id="accept-terms-3" /> <label htmlFor="accept-terms-3">Accept Terms &#38; Conditions</label>\n      </li>\n    </ul>\n    <div class="error">This is the validation message</div>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Validation - Required/Optional display'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Displaying required or optional labels should be positioned to the top-right of the input. Each form must either display the required fields label only or the optional fields label only - do not mix the presentation of these indicatators on forms and always lean towards using the option that will present the indicator the least.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display--inline-block max-width--50 soft-half' },
	          _get__('React').createElement(
	            'h5',
	            null,
	            'Required'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'form-fields grid max-width--90' },
	            _get__('React').createElement(
	              'li',
	              { className: 'required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'requiredExample1' },
	                'Username'
	              ),
	              _get__('React').createElement('input', { id: 'requiredExample1', type: 'text', className: 'text-input has-error--icon' }),
	              _get__('React').createElement('span', { className: 'feedback' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'defaultErrorText' },
	                'Error - outline, icon & text'
	              ),
	              _get__('React').createElement('input', { id: 'defaultErrorText', type: 'text', className: 'text-input has-error--icon' }),
	              _get__('React').createElement('span', { className: 'feedback' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'requiredExample2' },
	                'Select Country'
	              ),
	              _get__('React').createElement(
	                'select',
	                { id: 'countries', name: 'requiredExample2', defaultValue: 'Argentina' },
	                _get__('React').createElement(
	                  'option',
	                  null,
	                  'Argentina'
	                ),
	                _get__('React').createElement(
	                  'option',
	                  null,
	                  'Albania'
	                ),
	                _get__('React').createElement(
	                  'option',
	                  null,
	                  'Aruba'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-12' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'requiredExample3' },
	                'Comments'
	              ),
	              _get__('React').createElement(
	                'textarea',
	                { className: 'text-input', name: 'requiredExample3' },
	                'Please enter your comments...'
	              ),
	              _get__('React').createElement('span', { className: 'feedback' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'requiredExample4' },
	                'Calendar'
	              ),
	              _get__('React').createElement('input', { id: 'requiredExample4', type: 'text', className: 'text-input' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'icon__wrapper icon__wrapper--datepicker' },
	                _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'requiredExample5' },
	                'Units'
	              ),
	              _get__('React').createElement('input', { type: 'text', name: 'requiredExample5', className: 'text-input has-unit-text' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'input__unit-text' },
	                'Kg'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'ul',
	                { className: 'check-list list-inline' },
	                _get__('React').createElement(
	                  'li',
	                  { className: 'push--right' },
	                  _get__('React').createElement('input', { type: 'radio', name: 'requiredExampleRadio', id: 'required1yes' }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'required1yes' },
	                    'Yes'
	                  )
	                ),
	                _get__('React').createElement(
	                  'li',
	                  null,
	                  _get__('React').createElement('input', { type: 'radio', name: 'requiredExampleRadio', id: 'required1no', checked: true }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'required1no' },
	                    'No'
	                  )
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'ul',
	                { className: 'check-list' },
	                _get__('React').createElement(
	                  'li',
	                  null,
	                  _get__('React').createElement('input', { type: 'checkbox', id: 'requiredExampleTerms' }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'requiredExampleTerms' },
	                    'Accept Terms & Conditions'
	                  )
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display--inline-block max-width--50 soft-half' },
	          _get__('React').createElement(
	            'h5',
	            null,
	            'Optional'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'form-fields grid max-width--90' },
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'optionalExample1' },
	                'Username'
	              ),
	              _get__('React').createElement('input', { id: 'optionalExample1', type: 'text', className: 'text-input' }),
	              _get__('React').createElement('span', { className: 'feedback' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'optionalExample2' },
	                'Select Country'
	              ),
	              _get__('React').createElement(
	                'select',
	                { id: 'countries', name: 'optionalExample2', defaultValue: 'Argentina' },
	                _get__('React').createElement(
	                  'option',
	                  null,
	                  'Argentina'
	                ),
	                _get__('React').createElement(
	                  'option',
	                  null,
	                  'Albania'
	                ),
	                _get__('React').createElement(
	                  'option',
	                  null,
	                  'Aruba'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom optional grid__col-12' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'optionalExample3' },
	                'Comments'
	              ),
	              _get__('React').createElement(
	                'textarea',
	                { className: 'text-input', name: 'optionalExample3' },
	                'Please enter your comments...'
	              ),
	              _get__('React').createElement('span', { className: 'feedback' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'optionalExample4' },
	                'Calendar'
	              ),
	              _get__('React').createElement('input', { name: 'optionalExample4', type: 'text', className: 'text-input' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'icon__wrapper icon__wrapper--datepicker' },
	                _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'optionalExample5' },
	                'Units'
	              ),
	              _get__('React').createElement('input', { type: 'text', name: 'optionalExample5', className: 'text-input has-unit-text' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'input__unit-text' },
	                'Kg'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'ul',
	                { className: 'check-list list-inline' },
	                _get__('React').createElement(
	                  'li',
	                  { className: 'push--right' },
	                  _get__('React').createElement('input', { type: 'radio', name: 'optionalExampleRadio', id: 'radio2yes' }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'radio2yes' },
	                    'Yes'
	                  )
	                ),
	                _get__('React').createElement(
	                  'li',
	                  null,
	                  _get__('React').createElement('input', { type: 'radio', name: 'optionalExampleRadio', id: 'radio2no', checked: true }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'radio2no' },
	                    'No'
	                  )
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6' },
	              _get__('React').createElement(
	                'ul',
	                { className: 'check-list' },
	                _get__('React').createElement(
	                  'li',
	                  null,
	                  _get__('React').createElement('input', { type: 'checkbox', id: 'optionalExampleCheck' }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'optionalExampleCheck' },
	                    'Accept Terms & Conditions'
	                  )
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is the validation message'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="display--inline-block max-width--50 soft-half">\n  <h5>Required</h5>\n  <ul class="form-fields grid max-width--90">\n    <li class="required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <label for="requiredExample1">Username</label>\n      <input id="requiredExample1" type="text" class="text-input"/>\n      <span class="feedback"></span>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <label for="requiredExample2">Select Country</label>\n      <select id="countries" name="requiredExample2" defaultValue="Argentina">\n        <option>Argentina</option>\n        <option>Albania</option>\n        <option>Aruba</option>\n      </select>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-12">\n      <label for="requiredExample3">Comments</label>\n      <textarea class="text-input" name="requiredExample3" >Please enter your comments...</textarea>\n      <span class="feedback"></span>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="required push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <label for="requiredExample4">Calendar</label>\n      <input id="requiredExample4" type="text" class="text-input"/>\n      <div class="icon__wrapper icon__wrapper--datepicker">\n        <i class="far fa-calendar-alt"></i>\n      </div>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <label for="requiredExample5">Units</label>\n      <input type="text" name="requiredExample5" class="text-input has-unit-text"/>\n      <div class="input__unit-text">\n        Kg\n      </div>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <ul class="check-list list-inline">\n        <li class="push--right">\n            <input type="radio" name="requiredExampleRadio" id="required1yes" /> <label for="required1yes">Yes</label>\n        </li>\n        <li>\n            <input type="radio" name="requiredExampleRadio" id="required1no" checked /> <label for="required1no">No</label>\n        </li>\n      </ul>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <ul class="check-list">\n        <li>\n            <input type="checkbox" id="requiredExampleTerms" /> <label for="requiredExampleTerms">Accept Terms &#38; Conditions</label>\n        </li>\n      </ul>\n      <div class="error">This is the validation message</div>\n    </li>\n  </ul>\n  </div>\n\n  <div class="display--inline-block max-width--50 soft-half">\n  <h5>Optional</h5>\n  <ul class="form-fields grid max-width--90">\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <label for="optionalExample1">Username</label>\n      <input id="optionalExample1" type="text" class="text-input"/>\n      <span class="feedback"></span>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n    <label for="optionalExample2">Select Country</label>\n      <select id="countries" name="optionalExample2" defaultValue="Argentina">\n        <option>Argentina</option>\n        <option>Albania</option>\n        <option>Aruba</option>\n      </select>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom optional grid__col-12">\n      <label for="optionalExample3">Comments</label>\n      <textarea class="text-input" name="optionalExample3" >Please enter your comments...</textarea>\n      <span class="feedback"></span>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <label for="optionalExample4">Calendar</label>\n      <input name="optionalExample4" type="text" class="text-input"/>\n      <div class="icon__wrapper icon__wrapper--datepicker">\n        <i class="far fa-calendar-alt"></i>\n      </div>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <label for="optionalExample5">Units</label>\n      <input type="text" name="optionalExample5" class="text-input has-unit-text"/>\n      <div class="input__unit-text">\n        Kg\n      </div>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <ul class="check-list list-inline">\n        <li class="push--right">\n            <input type="radio" name="optionalExampleRadio" id="radio2yes" /> <label for="radio2yes">Yes</label>\n        </li>\n        <li>\n            <input type="radio" name="optionalExampleRadio" id="radio2no" checked /> <label for="radio2no">No</label>\n        </li>\n      </ul>\n      <div class="error">This is the validation message</div>\n    </li>\n    <li class="push-half--bottom grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6">\n      <ul class="check-list">\n        <li>\n            <input type="checkbox" id="optionalExampleCheck" /> <label for="optionalExampleCheck">Accept Terms &#38; Conditions</label>\n        </li>\n      </ul>\n      <div class="error">This is the validation message</div>\n    </li>\n  </ul>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Validation examples'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Error groups'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--error' },
	          _get__('React').createElement(
	            'p',
	            null,
	            'Errors:'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'flush' },
	            _get__('React').createElement(
	              'li',
	              null,
	              'Question 1: This is a required field'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'Question 2: Only numbers allowed'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'Question 3: Maximum 30 characters'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'Question 4: Please enter a valid email address'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="alert alert--error">\n  <p>Errors:</p>\n  <ul class="flush">\n    <li>Question 1: This is a required field</li>\n    <li>Question 2: Only numbers allowed</li>\n    <li>Question 3: Maximum 30 characters</li>\n    <li>Question 4: Please enter a valid email address</li>\n  </ul>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Vertical forms'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'h3',
	            null,
	            'Please sign in'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'form-fields max-width--20' },
	            _get__('React').createElement(
	              'li',
	              { className: 'required' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'username' },
	                'Username'
	              ),
	              _get__('React').createElement('input', { id: 'username', type: 'text', className: 'text-input has-error', autoComplete: 'off' }),
	              _get__('React').createElement('span', { className: 'feedback' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is a required field'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'required' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'password' },
	                'Password'
	              ),
	              _get__('React').createElement('input', { id: 'password', type: 'password', className: 'text-input is-valid', defaultValue: 'password', autoComplete: 'off' }),
	              _get__('React').createElement('span', { className: 'feedback' })
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'ul',
	                { className: 'check-list' },
	                _get__('React').createElement(
	                  'li',
	                  null,
	                  _get__('React').createElement('input', { type: 'checkbox', id: 'rememberMe' }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'rememberMe' },
	                    'Remember me?'
	                  )
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn' },
	                'Sign In'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<h3>Please sign in</h3>\n<ul class="form-fields">\n  <li class="required">\n    <label for="username">Username</label>\n    <input id="username" type="text" class="text-input has-error" autocomplete="off"/>\n    <span class="feedback"></span>\n    <div class="error">This is a required field</div>\n  </li>\n  <li class="required">\n    <label for="password">Password</label>\n    <input id="password" type="password" class="text-input is-valid" value="password" autocomplete="off"/>\n    <span class="feedback"></span>\n  </li>\n  <li>\n    <ul class="check-list">\n      <li>\n          <input type="checkbox" id="rememberMe"/> <label for="rememberMe">Remember me?</label>\n      </li>\n    </ul>\n  </li>\n  <li>\n    <button type="button" class="btn">Sign In</button>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Horizontal forms'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Horizontal forms are much more involved to ensure a responsive experience. The below example uses ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.list-inline'
	          ),
	          'to create the sideways flow. An empty label is used to provide consistent spacing for the single checkbox. The helper spacing classes of',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.soft-half'
	          ),
	          ' are used to space the content out consistently'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'row soft' },
	          _get__('React').createElement(
	            'h3',
	            null,
	            'Please sign in'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'form-fields list-inline' },
	            _get__('React').createElement(
	              'li',
	              { className: 'required soft-half' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'username' },
	                'Username'
	              ),
	              _get__('React').createElement('input', { id: 'username', type: 'text', className: 'text-input has-error' }),
	              _get__('React').createElement('span', { className: 'feedback' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'error' },
	                'This is a required field'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'required soft-half' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'password' },
	                'Password'
	              ),
	              _get__('React').createElement('input', { id: 'password', type: 'password', className: 'text-input is-valid', defaultValue: 'password' }),
	              _get__('React').createElement('span', { className: 'feedback' })
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'soft-half' },
	              _get__('React').createElement(
	                'label',
	                null,
	                '\xA0'
	              ),
	              _get__('React').createElement(
	                'ul',
	                { className: 'check-list' },
	                _get__('React').createElement(
	                  'li',
	                  null,
	                  _get__('React').createElement('input', { type: 'checkbox', id: 'rememberMe' }),
	                  ' ',
	                  _get__('React').createElement(
	                    'label',
	                    { htmlFor: 'rememberMe' },
	                    'Remember me?'
	                  )
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { className: 'soft' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn' },
	                'Sign In'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<h3>Please sign in</h3>\n<ul class="form-fields list-inline">\n  <li class="required soft-half">\n    <label for="username">Username</label>\n    <input id="username" type="text" class="text-input has-error"/>\n    <span class="feedback"></span>\n    <div class="error">This is a required field</div>\n  </li>\n  <li class="required soft-half">\n    <label for="password">Password</label>\n    <input id="password" type="password" class="text-input is-valid" value="password"/>\n    <span class="feedback"></span>\n  </li>\n  <li class="soft-half">\n    <label>&nbsp;</label>\n    <ul class="check-list">\n      <li>\n          <input type="checkbox" id="rememberMe"/> <label for="rememberMe">Remember me?</label>\n      </li>\n    </ul>\n  </li>\n  <li class="soft">\n    <button type="button" class="btn">Sign In</button>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Inputs with icons'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'On text fields containing an icon to the right, add optional class \'.has-icon-right\' to the input to prevent text covering the icon'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'required grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-3' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Email'
	            ),
	            _get__('React').createElement('input', { type: 'text', className: 'text-input has-icon-right is-valid' }),
	            _get__('React').createElement('span', { className: 'feedback' }),
	            _get__('React').createElement(
	              'div',
	              { className: 'icon__wrapper icon__wrapper--right' },
	              _get__('React').createElement('i', { className: 'fa fa-envelope' })
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-3' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Phone No.'
	            ),
	            _get__('React').createElement('input', { type: 'text', className: 'text-input has-icon-right' }),
	            _get__('React').createElement(
	              'div',
	              { className: 'icon__wrapper icon__wrapper--right' },
	              _get__('React').createElement('i', { className: 'fa fa-phone' })
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'required grid__col-xs-6 grid__col-sm-6 grid__col-md-4 grid__col-lg-3' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Calendar'
	            ),
	            _get__('React').createElement('input', { type: 'text', className: 'text-input has-icon-right has-error' }),
	            _get__('React').createElement('span', { className: 'feedback' }),
	            _get__('React').createElement(
	              'div',
	              { className: 'icon__wrapper icon__wrapper--datepicker' },
	              _get__('React').createElement('i', { className: 'far fa-calendar-alt' })
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'error' },
	              'This is a required field'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul className="form-fields grid">\n  <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">\n    <label>Email (icon aligned left)</label>\n    <input type="text" className="text-input is-valid"/>\n    <span className="feedback"></span>\n    <div className="icon__wrapper icon__wrapper--right">\n      <i className="fa fa-envelope"></i>\n    </div>\n  </li>\n  <li className="required grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">\n    <label>Phone No. (icon aligned right)</label>\n    <input type="text" className="text-input"/>\n    <div className="icon__wrapper icon__wrapper--right">\n      <i className="fa fa-phone"></i>\n    </div>\n  </li>\n  <li className="required grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">\n    <label>Calendar</label>\n    <input type="text" className="text-input has-error"/>\n    <span className="feedback"></span>\n    <div className="icon__wrapper icon__wrapper--datepicker">\n      <i className="far fa-calendar-alt"></i>\n    </div>\n    <div className="error">This is a required field</div>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Inputs with Unit Text'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'On text fields containing unit text, add optional class \'.has-unit-text\' to the input to prevent text covering the icon'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Units'
	            ),
	            _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text' }),
	            _get__('React').createElement(
	              'div',
	              { className: 'input__unit-text' },
	              'Kg'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Amount'
	            ),
	            _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text' }),
	            _get__('React').createElement(
	              'div',
	              { className: 'input__unit-text' },
	              '$USD'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Amount'
	            ),
	            _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text' }),
	            _get__('React').createElement(
	              'div',
	              { className: 'input__unit-text' },
	              '\xA3GBP'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2' },
	            _get__('React').createElement(
	              'label',
	              null,
	              'Amount'
	            ),
	            _get__('React').createElement('input', { type: 'text', className: 'text-input has-unit-text' }),
	            _get__('React').createElement(
	              'div',
	              { className: 'input__unit-text' },
	              '\u20ACEUR'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul className="form-fields grid">\n      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">\n        <label>Units</label>\n        <input type="text" className="text-input"/>\n        <div className="input__unit-text">\n            Kg\n        </div>\n      </li>\n      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">\n        <label>Amount</label>\n        <input type="text" className="text-input"/>\n        <div className="input__unit-text">\n            $USD\n        </div>\n      </li>\n      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">\n        <label>Amount</label>\n        <input type="text" className="text-input"/>\n        <div className="input__unit-text">\n            \xA3GBP\n        </div>\n      </li>\n      <li className="grid__col-xs-6 grid__col-sm-6 grid__col-md-3 grid__col-lg-2">\n        <label>Amount</label>\n        <input type="text" className="text-input"/>\n        <div className="input__unit-text">\n            \u20ACEUR\n        </div>\n      </li>\n    </ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Forms;
	}(_get__('Component'));
	
	exports.default = _get__('Forms');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Forms':
	      return Forms;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Forms === 'undefined' ? 'undefined' : _typeof(Forms);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Forms, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Forms)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _FileComponent = __webpack_require__(680);
	
	var _FileComponent2 = _interopRequireDefault(_FileComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALLOWED_FILE_EXTENSION = ['jpg', 'png', 'jpeg', 'pdf', 'txt'];
	
	var Dropzone = function (_get__2) {
	  _inherits(Dropzone, _get__2);
	
	  function Dropzone(props) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props));
	
	    _this.state = {
	      error: null,
	      fileList: []
	    };
	
	    _this.onFilesSelected = _this.onFilesSelected.bind(_this);
	    _this.onFileClosed = _this.onFileClosed.bind(_this);
	    _this.onFormCancel = _this.onFormCancel.bind(_this);
	
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragEnd = _this.onDragEnd.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'onFilesSelected',
	    value: function onFilesSelected(e) {
	      e.preventDefault();
	      this.processFiles(e.currentTarget.files);
	      e.currentTarget.value = null;
	    }
	  }, {
	    key: 'onFileClosed',
	    value: function onFileClosed(index) {
	      var newFileList = [].concat(_toConsumableArray(this.state.fileList));
	      newFileList.splice(index, 1);
	      this.setState({
	        fileList: newFileList
	      });
	    }
	  }, {
	    key: 'onFormCancel',
	    value: function onFormCancel(e) {
	      e.preventDefault();
	      this.setState({
	        error: null,
	        fileList: []
	      });
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(e) {
	      e.preventDefault();
	      this.setIsDragOver(e);
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(e) {
	      e.preventDefault();
	      this.setIsDragOver(e);
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(e) {
	      e.preventDefault();
	      this.unsetIsDragOver(e);
	    }
	  }, {
	    key: 'onDragEnd',
	    value: function onDragEnd(e) {
	      e.preventDefault();
	      this.unsetIsDragOver(e);
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(e) {
	      e.preventDefault();
	      this.unsetIsDragOver(e);
	      this.processFiles(e.dataTransfer.files);
	    }
	  }, {
	    key: 'setIsDragOver',
	    value: function setIsDragOver(e) {
	      e.target.classList.add('is-dragover');
	    }
	  }, {
	    key: 'unsetIsDragOver',
	    value: function unsetIsDragOver(e) {
	      e.target.classList.remove('is-dragover');
	    }
	  }, {
	    key: 'processFiles',
	    value: function processFiles(fileList) {
	      var _this2 = this;
	
	      var _ = 100000000,
	          maxFileSize = _.maxFileSize;
	
	
	      var error = null;
	      var totalFiles = fileList.length;
	
	      var _loop = function _loop() {
	
	        var file = fileList.item(i);
	        var isAllowedFileExtension = false;
	        _get__('ALLOWED_FILE_EXTENSION').forEach(function (item) {
	          if (file.name.endsWith('.' + item)) {
	            isAllowedFileExtension = true;
	          }
	        });
	
	        if (!isAllowedFileExtension) {
	          error = 'File type selected not allowed. Please select ' + _get__('ALLOWED_FILE_EXTENSION') + ' only.';
	        } else if (file.size === 0) {
	          error = 'The selected file is empty. Please select another file to upload.';
	        } else if (file.size > maxFileSize) {
	          error = 'The selected file exceeds the maximum file size of ' + filesize(maxFileSize) + '. Please select another file to upload.';
	        } else {
	          _this2.setState(function (prevState) {
	            return {
	              fileList: [].concat(_toConsumableArray(prevState.fileList), [file]),
	              error: null
	            };
	          });
	        }
	      };
	
	      for (var i = 0; i < totalFiles; i++) {
	        _loop();
	      }
	
	      this.setState({
	        error: error
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'dropzone' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Dropzone'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'h3',
	            null,
	            'Form Title'
	          ),
	          _get__('React').createElement(
	            'form',
	            null,
	            _get__('React').createElement(
	              'ul',
	              { className: 'form-fields soft-half max-width--70 grid' },
	              _get__('React').createElement(
	                'li',
	                { className: 'flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 required' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'labelone' },
	                  'Label'
	                ),
	                _get__('React').createElement('input', { id: 'labelone', type: 'text', className: 'text-input' })
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 required' },
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'labeltwo' },
	                  'Label'
	                ),
	                _get__('React').createElement('input', { id: 'labeltwo', type: 'text', className: 'text-input' })
	              ),
	              this.state.fileList.length === 0 && _get__('React').createElement(
	                'li',
	                {
	                  onDragOver: this.onDragOver,
	                  onDragEnter: this.onDragEnter,
	                  onDragLeave: this.onDragLeave,
	                  onDragEnd: this.onDragEnd,
	                  onDrop: this.onDrop,
	                  className: 'flush grid__col-xs-12 grid__col-sm-12 grid__col-md-12 grid__col-lg-12' },
	                _get__('React').createElement(
	                  'label',
	                  { className: 'text--center soft-half is-droppable', htmlFor: 'files' },
	                  _get__('React').createElement(
	                    'div',
	                    { className: 'push-quarter--bottom' },
	                    _get__('React').createElement('i', { className: 'fas fa-file-upload fa-2x' })
	                  ),
	                  !this.state.error && _get__('React').createElement(
	                    'div',
	                    null,
	                    'Drop file ',
	                    _get__('React').createElement(
	                      'strong',
	                      null,
	                      'OR'
	                    ),
	                    ' Click to upload'
	                  ),
	                  this.state.error && _get__('React').createElement(
	                    'div',
	                    { className: 'dropzone__error-msg' },
	                    this.state.error
	                  )
	                ),
	                _get__('React').createElement('input', {
	                  id: 'files',
	                  name: 'files[]',
	                  type: 'file',
	                  className: 'hide',
	                  multiple: true,
	                  onChange: this.onFilesSelected
	                })
	              ),
	              _get__('React').createElement(
	                'ul',
	                { className: 'grid is-droppable dropzone__layout', style: { display: this.state.fileList.length !== 0 ? 'flex' : 'none' } },
	                this.state.fileList.map(function (file, index, arr) {
	                  return _get__('React').createElement(
	                    'li',
	                    { className: 'flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 attachment__multiple' },
	                    _get__('React').createElement(_get__('FileComponent'), {
	                      file: _this3.state.fileList[index],
	                      key: index,
	                      onFileClosed: _this3.onFileClosed.bind(_this3, index)
	                    })
	                  );
	                }),
	                this.state.fileList.length % 2 !== 0 && _get__('React').createElement(
	                  'li',
	                  { className: 'flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 attachment__multiple' },
	                  _get__('React').createElement(
	                    'label',
	                    { className: 'text--center soft-half border border-rounded', htmlFor: 'files' },
	                    _get__('React').createElement(
	                      'span',
	                      { className: 'attachment__meta push-quarter--bottom' },
	                      _get__('React').createElement('i', { className: 'fas fa-plus fa-2x' })
	                    )
	                  ),
	                  _get__('React').createElement('input', {
	                    id: 'files',
	                    name: 'files[]',
	                    type: 'file',
	                    className: 'hide',
	                    multiple: true,
	                    onChange: this.onFilesSelected
	                  })
	                ),
	                this.state.fileList.length !== 0 && this.state.fileList.length % 2 === 0 && _get__('React').createElement(
	                  'li',
	                  { className: 'flush grid__col-xs-12 grid__col-sm-12 grid__col-md-12 grid__col-lg-12 attachment__multiple' },
	                  _get__('React').createElement(
	                    'label',
	                    { className: 'text--center soft-half border border-rounded', htmlFor: 'files' },
	                    _get__('React').createElement(
	                      'span',
	                      { className: 'attachment__meta push-quarter--bottom' },
	                      _get__('React').createElement('i', { className: 'fas fa-plus fa-2x' })
	                    )
	                  ),
	                  _get__('React').createElement('input', {
	                    id: 'files',
	                    name: 'files[]',
	                    type: 'file',
	                    className: 'hide',
	                    multiple: true,
	                    onChange: this.onFilesSelected
	                  })
	                )
	              ),
	              _get__('React').createElement(
	                'li',
	                { className: 'flush grid__col-xs-12 grid__col-sm-12 grid__col-md-12 grid__col-lg-12 text--center flex-end' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary push--right', onClick: this.onFormCancel },
	                  'Cancel'
	                ),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn' },
	                  'Submit'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_get__('Component'));
	
	exports.default = _get__('Dropzone');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'ALLOWED_FILE_EXTENSION':
	      return ALLOWED_FILE_EXTENSION;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'Dropzone':
	      return Dropzone;
	
	    case 'React':
	      return _react2.default;
	
	    case 'FileComponent':
	      return _FileComponent2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Dropzone === 'undefined' ? 'undefined' : _typeof(Dropzone);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Dropzone, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Dropzone)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Included = function (_get__2) {
	  _inherits(Included, _get__2);
	
	  function Included(props) {
	    _classCallCheck(this, Included);
	
	    return _possibleConstructorReturn(this, (Included.__proto__ || Object.getPrototypeOf(Included)).call(this, props));
	  }
	
	  _createClass(Included, [{
	    key: "getBuildDescription",
	    value: function getBuildDescription() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          onClick = _props.onClick,
	          included = _props.included;
	
	      return _get__("React").createElement(
	        "div",
	        null,
	        _get__("React").createElement(
	          "ul",
	          { className: "check-list" },
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement("input", { type: "checkbox", name: "toggle", onChange: onClick, checked: included }),
	            _get__("React").createElement(
	              "label",
	              null,
	              "\xA0",
	              function () {
	                return included ? 'Included in build' : 'Excluded from build';
	              }()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Included;
	}(_get__("Component"));
	
	exports.default = _get__("Included");
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "Component":
	      return _react.Component;
	
	    case "Included":
	      return Included;
	
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Included === "undefined" ? "undefined" : _typeof(Included);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Included, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Included)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	var _agGridThemeNav = __webpack_require__(822);
	
	var _agGridThemeNav2 = _interopRequireDefault(_agGridThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tables = function (_get__2) {
		_inherits(Tables, _get__2);
	
		function Tables(props) {
			_classCallCheck(this, Tables);
	
			return _possibleConstructorReturn(this, (Tables.__proto__ || Object.getPrototypeOf(Tables)).call(this, props));
		}
	
		_createClass(Tables, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				setTimeout(function () {
					$('.theme-select').on('change', function () {
						var theme = $(this).val();
						$('.js-data-table').removeClass('table--light table--dark table--blue').addClass(theme);
					});
				}, 0);
			}
		}, {
			key: 'render',
			value: function render() {
				return _get__('React').createElement(
					'section',
					{ className: 'is-styleguide' },
					_get__('React').createElement('a', { className: 'anchor', id: 'tables' }),
					_get__('React').createElement(
						'h2',
						null,
						'Tables'
					),
					_get__('React').createElement(
						'p',
						null,
						'We have a lot at our disposal for making very complex table construct'
					),
					_get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'tables' }),
					_get__('React').createElement(
						'h3',
						null,
						'AG Grid'
					),
					_get__('React').createElement(
						'p',
						null,
						'CUI has now created new brand compliant ',
						_get__('React').createElement(
							'a',
							{ href: '/themes#AgGrid' },
							'themes'
						),
						' for AG-Grid. This will help bridge the gap if using AG-Grid within your project.'
					),
					_get__('React').createElement(
						'h3',
						null,
						'What is AG-Grid?'
					),
					_get__('React').createElement(
						'p',
						null,
						'AG-Grid is feature rich datagrid designed for the major JavaScript Frameworks. ',
						_get__('React').createElement(
							'a',
							{ href: 'https://www.ag-grid.com/', target: 'new' },
							'Find out more'
						)
					),
					_get__('React').createElement(_get__('AgGridThemeNav'), { anchor: 'AgGrid' }),
					_get__('React').createElement('hr', null),
					_get__('React').createElement(
						'h3',
						null,
						'Formatting'
					),
					_get__('React').createElement(
						'ul',
						null,
						_get__('React').createElement(
							'li',
							null,
							'.table--fixed - equal width columns'
						)
					),
					_get__('React').createElement(
						'h3',
						null,
						'Styling'
					),
					_get__('React').createElement(
						'ul',
						null,
						_get__('React').createElement(
							'li',
							null,
							'.table--cells - bordered cells'
						),
						_get__('React').createElement(
							'li',
							null,
							'.table--rows - bordered rows'
						),
						_get__('React').createElement(
							'li',
							null,
							'.table--columns - bordered columns'
						),
						_get__('React').createElement(
							'li',
							null,
							'.table--hover - adds hover styling on rows'
						),
						_get__('React').createElement(
							'li',
							null,
							'.table--striped - adds zebra striping to rows'
						)
					),
					_get__('React').createElement(
						'h3',
						null,
						'Spacing'
					),
					_get__('React').createElement(
						'ul',
						null,
						_get__('React').createElement(
							'li',
							null,
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--compact'
							),
							' \u2014 smallest padding'
						),
						_get__('React').createElement(
							'li',
							null,
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--cosy'
							),
							' \u2014 middle padding'
						),
						_get__('React').createElement(
							'li',
							null,
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--comfy'
							),
							' \u2014 wide padding'
						),
						_get__('React').createElement(
							'li',
							null,
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--colossal'
							),
							' \u2014 most padding'
						)
					),
					_get__('React').createElement(
						'div',
						{ className: 'push-half--ends' },
						_get__('React').createElement(
							'p',
							null,
							_get__('React').createElement(
								'strong',
								null,
								'Compact'
							),
							' table styling has the least padding. Use ',
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--compact'
							)
						),
						_get__('React').createElement(
							'table',
							{ className: 'table table--cells table--compact' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'th',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'th',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'th',
										null,
										'Sit'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'td',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'td',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'td',
										null,
										'Sit'
									)
								)
							)
						),
						_get__('React').createElement(
							'button',
							{ type: 'button', className: 'btn btn--secondary show-code' },
							_get__('React').createElement('i', { className: 'fa fa-plus' }),
							'View source'
						),
						_get__('React').createElement('br', null),
						_get__('React').createElement('br', null),
						_get__('React').createElement(
							'pre',
							{ className: 'hide-code' },
							_get__('React').createElement(
								'code',
								{ className: 'language-html' },
								'<table class="table table--cells table--compact">\n  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>\n  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>\n</table>'
							)
						)
					),
					_get__('React').createElement(
						'div',
						{ className: 'push-half--ends' },
						_get__('React').createElement(
							'p',
							null,
							_get__('React').createElement(
								'strong',
								null,
								'Cosy'
							),
							' table styling is still quite compact, but with slightly more padding. Use ',
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--cosy'
							)
						),
						_get__('React').createElement(
							'table',
							{ className: 'table table--cells table--cosy' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'th',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'th',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'th',
										null,
										'Sit'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'td',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'td',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'td',
										null,
										'Sit'
									)
								)
							)
						),
						_get__('React').createElement(
							'button',
							{ type: 'button', className: 'btn btn--secondary show-code' },
							_get__('React').createElement('i', { className: 'fa fa-plus' }),
							'View source'
						),
						_get__('React').createElement('br', null),
						_get__('React').createElement('br', null),
						_get__('React').createElement(
							'pre',
							{ className: 'hide-code' },
							_get__('React').createElement(
								'code',
								{ className: 'language-html' },
								'<table class="table table--cells table--cosy">\n  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>\n  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>\n</table>'
							)
						)
					),
					_get__('React').createElement(
						'div',
						{ className: 'push-half--ends' },
						_get__('React').createElement(
							'p',
							null,
							_get__('React').createElement(
								'strong',
								null,
								'Comfy'
							),
							' table styling uses wide padding. Use ',
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--comfy'
							)
						),
						_get__('React').createElement(
							'table',
							{ className: 'table table--cells table--comfy' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'th',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'th',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'th',
										null,
										'Sit'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'td',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'td',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'td',
										null,
										'Sit'
									)
								)
							)
						),
						_get__('React').createElement(
							'button',
							{ type: 'button', className: 'btn btn--secondary show-code' },
							_get__('React').createElement('i', { className: 'fa fa-plus' }),
							'View source'
						),
						_get__('React').createElement('br', null),
						_get__('React').createElement('br', null),
						_get__('React').createElement(
							'pre',
							{ className: 'hide-code' },
							_get__('React').createElement(
								'code',
								{ className: 'language-html' },
								'<table class="table table--cells table--comfy">\n  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>\n  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>\n</table>'
							)
						)
					),
					_get__('React').createElement(
						'div',
						{ className: 'push-half--ends' },
						_get__('React').createElement(
							'p',
							null,
							_get__('React').createElement(
								'strong',
								null,
								'Colossal'
							),
							' table styling has the most padding. Use ',
							_get__('React').createElement(
								'code',
								{ className: 'inline' },
								'.table--colossal'
							)
						),
						_get__('React').createElement(
							'table',
							{ className: 'table table--cells table--colossal' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'th',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'th',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'th',
										null,
										'Sit'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										'Lorem'
									),
									_get__('React').createElement(
										'td',
										null,
										'Ipsum'
									),
									_get__('React').createElement(
										'td',
										null,
										'Dolor'
									),
									_get__('React').createElement(
										'td',
										null,
										'Sit'
									)
								)
							)
						),
						_get__('React').createElement(
							'button',
							{ type: 'button', className: 'btn btn--secondary show-code' },
							_get__('React').createElement('i', { className: 'fa fa-plus' }),
							'View source'
						),
						_get__('React').createElement('br', null),
						_get__('React').createElement('br', null),
						_get__('React').createElement(
							'pre',
							{ className: 'hide-code' },
							_get__('React').createElement(
								'code',
								{ className: 'language-html' },
								'<table class="table table--cells table--colossal">\n  <thead><tr><th>Lorem</th><th>Ipsum</th><th>Dolor</th><th>Sit</th></tr></thead>\n  <tbody><tr><td>Lorem</td><td>Ipsum</td><td>Dolor</td><td>Sit</td></tr></tbody>\n</table>'
							)
						)
					),
					_get__('React').createElement(
						'h3',
						null,
						'Head Alignment'
					),
					_get__('React').createElement(
						'ul',
						null,
						_get__('React').createElement(
							'li',
							null,
							'.table-head--top-align - top align'
						),
						_get__('React').createElement(
							'li',
							null,
							'.table-head--middle-align - middle align'
						),
						_get__('React').createElement(
							'li',
							null,
							'.table-head--bottom-align - bottom align'
						)
					),
					_get__('React').createElement(
						'h3',
						null,
						'Cell Alignment'
					),
					_get__('React').createElement(
						'p',
						null,
						'By default they will align in the middle.'
					),
					_get__('React').createElement(
						'table',
						{ className: 'table table--cells table--compact' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'th',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'th',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'th',
									null,
									'Sit'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor ',
									_get__('React').createElement('br', null),
									'Dolor ',
									_get__('React').createElement('br', null),
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'03.788'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								)
							)
						)
					),
					_get__('React').createElement(
						'p',
						null,
						'.table--top-align - Align at the top of the cell'
					),
					_get__('React').createElement(
						'table',
						{ className: 'table table--cells table--compact table--top-align' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'th',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'th',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'th',
									null,
									'Sit'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor ',
									_get__('React').createElement('br', null),
									'Dolor ',
									_get__('React').createElement('br', null),
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'03.788'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								)
							)
						)
					),
					_get__('React').createElement(
						'p',
						null,
						'.table--bottom-align - Align at the bottom of the cell'
					),
					_get__('React').createElement(
						'table',
						{ className: 'table table--cells table--compact table--bottom-align' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'th',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'th',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'th',
									null,
									'Sit'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor ',
									_get__('React').createElement('br', null),
									'Dolor ',
									_get__('React').createElement('br', null),
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'03.788'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								)
							)
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Theming'
					),
					_get__('React').createElement(
						'h4',
						null,
						'Light themed table'
					),
					_get__('React').createElement(
						'p',
						null,
						'To apply the light theme to a table, simply add the class ',
						_get__('React').createElement(
							'code',
							null,
							'.table--light'
						),
						' in addition to the ',
						_get__('React').createElement(
							'code',
							null,
							'.table'
						),
						' class (as shown in the example below).'
					),
					_get__('React').createElement(
						'table',
						{ className: 'table table--light table--comfy table--hover table--striped table--responsive js-table--responsive' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'th',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'th',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'th',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'th',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'th',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'th',
									null,
									'Afdipisicing'
								),
								_get__('React').createElement('th', null)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ scope: 'row' },
									_get__('React').createElement(
										'a',
										{ href: '' },
										'Sit'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'03.788'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'td',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'td',
									null,
									'Afdipisicing'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ scope: 'row' },
									_get__('React').createElement(
										'a',
										{ href: '' },
										'Sit'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'32.210'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'td',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'td',
									null,
									'Afdipisicing'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ scope: 'row' },
									_get__('React').createElement(
										'a',
										{ href: '' },
										'Sit'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'47.797'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'td',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'td',
									null,
									'Afdipisicing'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ scope: 'row' },
									_get__('React').createElement(
										'a',
										{ href: '' },
										'Sit'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'09.640'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'td',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'td',
									null,
									'Afdipisicing'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ scope: 'row' },
									_get__('React').createElement(
										'a',
										{ href: '' },
										'Sit'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'12.117'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'td',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'td',
									null,
									'Afdipisicing'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
								)
							)
						)
					),
					_get__('React').createElement(
						'div',
						{ className: 'modal delete-row-modal modal--is-small' },
						_get__('React').createElement(
							'div',
							{ className: 'modal__inner' },
							_get__('React').createElement(
								'header',
								{ className: 'modal__header', 'aria-labelledby': 'modal__title' },
								_get__('React').createElement(
									'h1',
									{ className: 'modal__title' },
									'Delete selected row'
								),
								_get__('React').createElement(
									'button',
									{ className: 'modal__close btn btn--transparent js-modal-close', 'aria-label': 'close' },
									_get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
								)
							),
							_get__('React').createElement(
								'div',
								{ className: 'modal__contents', role: 'dialog', 'aria-hidden': 'false', 'aria-labelledby': 'modal__title', 'aria-describedby': 'modal__description' },
								_get__('React').createElement(
									'p',
									{ className: 'modal__description' },
									'Are you sure you wish to delete this row?'
								)
							),
							_get__('React').createElement(
								'footer',
								{ className: 'modal__footer' },
								_get__('React').createElement(
									'button',
									{ type: 'button', className: 'modal__cancel btn btn--secondary js-modal-close delete-row-negative' },
									'No'
								),
								_get__('React').createElement(
									'button',
									{ type: 'button', className: 'modal__confirm btn js-modal-positive delete-row-positive' },
									'Yes'
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'\n<table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">\n<thead>\n\t<tr>\n\t\t<th>Lorem</th>\n\t\t<th>Ipsum</th>\n\t\t<th>Dolor</th>\n\t\t<th>Sit</th>\n\t\t<th>Amet</th>\n\t\t<th>Consectetur</th>\n\t\t<th>Afdipisicing</th>\n\t\t<th></th>\n\t</tr>\n</thead>\n<tbody>\n\t<tr>\n\t\t<th scope="row">\n\t\t\t<a href="">Sit</a>\n\t\t</th>\n\t\t<td>Dolor</td>\n\t\t<td class="text--center">03.788</td>\n\t\t<td>Lorem</td>\n\t\t<td>Amet</td>\n\t\t<td>Consectetur</td>\n\t\t<td>Afdipisicing</td>\n\t\t<td class="text--right"><i class="fa fa-trash delete-row"></i></td>\n\t</tr>\n\t<tr>\n\t\t<th scope="row">\n\t\t\t<a href="">Sit</a>\n\t\t</th>\n\t\t<td>Dolor</td>\n\t\t<td class="text--center">32.210</td>\n\t\t<td>Lorem</td>\n\t\t<td>Amet</td>\n\t\t<td>Consectetur</td>\n\t\t<td>Afdipisicing</td>\n\t\t<td class="text--right"><i class="fa fa-trash delete-row"></i></td>\n\t</tr>\n\t<tr>\n\t\t<th scope="row">\n\t\t\t<a href="">Sit</a>\n\t\t</th>\n\t\t<td>Dolor</td>\n\t\t<td class="text--center">47.797</td>\n\t\t<td>Lorem</td>\n\t\t<td>Amet</td>\n\t\t<td>Consectetur</td>\n\t\t<td>Afdipisicing</td>\n\t\t<td class="text--right"><i class="fa fa-trash delete-row"></i></td>\n\t</tr>\n\t<tr>\n\t\t<th scope="row">\n\t\t\t<a href="">Sit</a>\n\t\t</th>\n\t\t<td>Dolor</td>\n\t\t<td class="text--center">09.640</td>\n\t\t<td>Lorem</td>\n\t\t<td>Amet</td>\n\t\t<td>Consectetur</td>\n\t\t<td>Afdipisicing</td>\n\t\t<td class="text--right"><i class="fa fa-trash delete-row"></i></td>\n\t</tr>\n\t<tr>\n\t\t<th scope="row">\n\t\t\t<a href="">Sit</a>\n\t\t</th>\n\t\t<td>Dolor</td>\n\t\t<td class="text--center">12.117</td>\n\t\t<td>Lorem</td>\n\t\t<td>Amet</td>\n\t\t<td>Consectetur</td>\n\t\t<td>Afdipisicing</td>\n\t\t<td class="text--right"><i class="fa fa-trash delete-row"></i></td>\n\t</tr>\n</tbody>\n</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'.table__cell--highlight - light themed table column'
					),
					_get__('React').createElement(
						'table',
						{ className: 'table table--comfy table--hover table--striped table--light table--responsive js-table--responsive' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'th',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'th',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'th',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'th',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'th',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'th',
									null,
									'Afdipisicing'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ scope: 'row', className: 'table__cell--highlight' },
									_get__('React').createElement(
										'a',
										{ href: '' },
										'Sit'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'03.788'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'td',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'td',
									null,
									'Afdipisicing'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ scope: 'row', className: 'table__cell--highlight' },
									_get__('React').createElement(
										'a',
										{ href: '' },
										'Sit'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'32.210'
								),
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Amet'
								),
								_get__('React').createElement(
									'td',
									null,
									'Consectetur'
								),
								_get__('React').createElement(
									'td',
									null,
									'Afdipisicing'
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--comfy table--hover table--striped table--light table--responsive js-table--responsive">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Lorem</th>\n\t\t\t\t<th>Ipsum</th>\n\t\t\t\t<th>Dolor</th>\n\t\t\t\t<th>Sit</th>\n\t\t\t\t<th>Amet</th>\n\t\t\t\t<th>Consectetur</th>\n\t\t\t\t<th>Afdipisicing</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr>\n\t\t\t\t<th scope="row" class="table__cell--highlight"><a href="">Sit</a></th>\n\t\t\t\t<td>Dolor</td>\n\t\t\t\t<td class="text--center">03.788</td>\n\t\t\t\t<td>Lorem</td>\n\t\t\t\t<td>Amet</td>\n\t\t\t\t<td>Consectetur</td>\n\t\t\t\t<td>Afdipisicing</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<th scope="row" class="table__cell--highlight"><a href="">Sit</a></th>\n\t\t\t\t<td>Dolor</td>\n\t\t\t\t<td class="text--center">32.210</td>\n\t\t\t\t<td>Lorem</td>\n\t\t\t\t<td>Amet</td>\n\t\t\t\t<td>Consectetur</td>\n\t\t\t\t<td>Afdipisicing</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t\t</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h4',
						null,
						'Blue themed table'
					),
					_get__('React').createElement(
						'p',
						null,
						'To apply the blue theme to a table, simply add the class ',
						_get__('React').createElement(
							'code',
							null,
							'.table--blue'
						),
						' in addition to the ',
						_get__('React').createElement(
							'code',
							null,
							'.table'
						),
						' class (as shown in the example below).'
					),
					_get__('React').createElement(
						'div',
						{ className: 'callout' },
						'Previously, the ',
						_get__('React').createElement(
							'code',
							null,
							'.table--blue'
						),
						' class shipped with column and row dividers by default. Following the new additive approach for table styling you can achieve the same style by applying the ',
						_get__('React').createElement(
							'code',
							null,
							'.table--cells'
						),
						' class to the table.'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'table',
						{ className: 'table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Product'
								),
								_get__('React').createElement(
									'th',
									null,
									'Code'
								),
								_get__('React').createElement(
									'th',
									null,
									'Last'
								),
								_get__('React').createElement(
									'th',
									null,
									'Change'
								),
								_get__('React').createElement(
									'th',
									null,
									'Chart'
								),
								_get__('React').createElement(
									'th',
									null,
									'Open'
								),
								_get__('React').createElement(
									'th',
									null,
									'High'
								),
								_get__('React').createElement(
									'th',
									null,
									'Low'
								),
								_get__('React').createElement(
									'th',
									null,
									'Globex Vol'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									_get__('React').createElement(
										'a',
										{ className: 'weight--bold', href: '#' },
										'Corn Futures'
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'ZCH7'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'369\'0'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'+1\'0'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									_get__('React').createElement(
										'a',
										{ href: '#' },
										_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'367\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'367\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'367\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'68,284'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									_get__('React').createElement(
										'a',
										{ className: 'weight--bold', href: '#' },
										'Soybean Futures'
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'ZCH7'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1036\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'+1\'0'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									_get__('React').createElement(
										'a',
										{ href: '#' },
										_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1037\'2'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1037\'2'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1037\'2'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'48,346'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									_get__('React').createElement(
										'a',
										{ className: 'weight--bold', href: '#' },
										'Soybean Oil Futures'
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'ZCH7'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.29'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'+0.02'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									_get__('React').createElement(
										'a',
										{ href: '#' },
										_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.31'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.31'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.31'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'23,054'
								)
							)
						)
					),
					_get__('React').createElement(
						'ul',
						{ className: 'link-list' },
						_get__('React').createElement(
							'li',
							{ className: 'link-list__item' },
							_get__('React').createElement(
								'a',
								{ href: '' },
								'Link One'
							)
						),
						_get__('React').createElement(
							'li',
							{ className: 'link-list__item' },
							_get__('React').createElement(
								'a',
								{ href: '' },
								'Link Two'
							)
						),
						_get__('React').createElement(
							'li',
							{ className: 'link-list__item' },
							_get__('React').createElement(
								'a',
								{ href: '' },
								'Link Three'
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'\n<table class="table table--blue table--comfy table--cells table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>Product</th>\n\t\t\t<th>Code</th>\n\t\t\t<th>Last</th>\n\t\t\t<th>Change</th>\n\t\t\t<th>Chart</th>\n\t\t\t<th>Open</th>\n\t\t\t<th>High</th>\n\t\t\t<th>Low</th>\n\t\t\t<th>Globex Vol</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t  <tr>\n\t    <td><a class="weight--bold" href="#">Corn Futures</a></td>\n\t    <td class="text--center">ZCH7</td>\n\t    <td class="text--right">369\'0</td>\n\t    <td class="text--right">+1\'0</td>\n\t    <td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t    <td class="text--right">367\'4</td>\n\t    <td class="text--right">367\'4</td>\n\t    <td class="text--right">367\'4</td>\n\t    <td class="text--right">68,284</td>\n\t  </tr>\n\t  <tr>\n\t    <td><a class="weight--bold" href="#">Soybean Futures</a></td>\n\t    <td class="text--center">ZCH7</td>\n\t    <td class="text--right">1036\'4</td>\n\t    <td class="text--right">+1\'0</td>\n\t    <td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t    <td class="text--right">1037\'2</td>\n\t    <td class="text--right">1037\'2</td>\n\t    <td class="text--right">1037\'2</td>\n\t    <td class="text--right">48,346</td>\n\t  </tr>\n\t  <tr>\n\t    <td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>\n\t    <td class="text--center">ZCH7</td>\n\t    <td class="text--right">34.29</td>\n\t    <td class="text--right">+0.02</td>\n\t    <td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t    <td class="text--right">34.31</td>\n\t    <td class="text--right">34.31</td>\n\t    <td class="text--right">34.31</td>\n\t    <td class="text--right">23,054</td>\n\t  </tr>\n\t</tbody>\n</table>\n<ul class="link-list">\n\t<li class="link-list__item"><a href="">Link One</a></li>\n\t<li class="link-list__item"><a href="">Link Two</a></li>\n\t<li class="link-list__item"><a href="">Link Three</a></li>\n</ul>\n'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Grouped columns'
					),
					_get__('React').createElement(
						'p',
						null,
						'Grouped columns are a clear way to visually gather relevant columns into one overall category. They can be 2 or 3 levels deep, but no larger than 3. The very top row (overall grouped category) will always be a lighter colour than the other row(s). Individual columns are separated by divider line to clearly identify them. Currently the grouped columns are only available for use with blue themed tables.'
					),
					_get__('React').createElement(
						'p',
						null,
						'Grouped columns are not responsive. When viewed on a small screen, the whole table should scroll.'
					),
					_get__('React').createElement(
						'p',
						null,
						'To apply grouped column styling to your blue themed table, simply add the ',
						_get__('React').createElement(
							'code',
							null,
							'.table--grouped-columns'
						),
						' class to your existing table class list.'
					),
					_get__('React').createElement(
						'div',
						{ className: 'scroll-container-x' },
						_get__('React').createElement(
							'table',
							{ className: 'table table--comfy table--blue table--rows table--grouped-columns' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										{ colSpan: '4' },
										'First column grouping'
									),
									_get__('React').createElement(
										'th',
										{ rowSpan: '2' },
										'\xA0'
									),
									_get__('React').createElement(
										'th',
										{ colSpan: '6' },
										'First column grouping'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										{ colSpan: '2' },
										'Second column grouping'
									),
									_get__('React').createElement(
										'th',
										{ colSpan: '2' },
										'Second column grouping'
									),
									_get__('React').createElement(
										'th',
										{ colSpan: '2' },
										'Second column grouping'
									),
									_get__('React').createElement(
										'th',
										{ colSpan: '2' },
										'Second column grouping'
									),
									_get__('React').createElement(
										'th',
										{ colSpan: '2' },
										'Second column grouping'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									),
									_get__('React').createElement(
										'th',
										null,
										'Column'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									),
									_get__('React').createElement(
										'td',
										null,
										'Content'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'\n\t<div class="scroll-container-x">\n\t\t<table class="table table--comfy table--blue table--cells table--grouped-columns">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan="4">First column grouping</th>\n\t\t\t\t\t<th rowspan="2">&nbsp;</th>\n\t\t\t\t\t<th colspan="6">First column grouping</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th colspan="2">Second column grouping</th>\n\t\t\t\t\t<th colspan="2">Second column grouping</th>\n\t\t\t\t\t<th colspan="2">Second column grouping</th>\n\t\t\t\t\t<th colspan="2">Second column grouping</th>\n\t\t\t\t\t<th colspan="2">Second column grouping</th>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t\t<th>Column</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t\t<td>Content</td>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\t\t\t\t'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Grouped rows'
					),
					_get__('React').createElement(
						'p',
						{ className: 'callout' },
						_get__('React').createElement(
							'strong',
							null,
							'Note:'
						),
						' Only the styles for grouped rows are being provided at this time. Functionality will come in a future release.'
					),
					_get__('React').createElement(
						'p',
						null,
						'Grouped rows should be used in cases where one or several rows of data are aggregated to a single identifier row. There are 2 use cases for grouped rows at present: Row hierarchy and Row history'
					),
					_get__('React').createElement(
						'h4',
						null,
						'Row hierarchy'
					),
					_get__('React').createElement(
						'p',
						null,
						'Row hierarchy displays the grouped rows in an indented visual order which can be navigated using plus/minus icons. The hierarchy can be up to 3 levels deep. A solid plus/minus icon should be used in the identifier row (level 1). A lite plus/minus icon should be used for the indented row (level 2). For level 3 data rows are displayed under a dark grey line.'
					),
					_get__('React').createElement(
						'div',
						{ className: 'scroll-container-x' },
						_get__('React').createElement(
							'table',
							{ className: 'table table--rows table--border table--blue table--comfy text--left' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'\xA0'
									),
									_get__('React').createElement(
										'th',
										null,
										'One'
									),
									_get__('React').createElement(
										'th',
										null,
										'Two'
									),
									_get__('React').createElement(
										'th',
										null,
										'Three'
									),
									_get__('React').createElement(
										'th',
										null,
										'Four'
									),
									_get__('React').createElement(
										'th',
										null,
										'Five'
									),
									_get__('React').createElement(
										'th',
										null,
										'Six'
									),
									_get__('React').createElement(
										'th',
										null,
										'Seven'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'row-group row-group--open' },
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__key-row' },
									_get__('React').createElement(
										'td',
										{ className: 'row-expand' },
										_get__('React').createElement('button', { className: 'row-expand__trigger row-expand__trigger--open' })
									),
									_get__('React').createElement(
										'th',
										{ scope: 'row' },
										_get__('React').createElement(
											'a',
											{ href: '' },
											'MAINLINK'
										)
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__parent-row row-group__parent-row--active', 'data-row-id': '123' },
									_get__('React').createElement(
										'td',
										{ rowSpan: '5' },
										'\xA0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'row-expand row-expand--secondary' },
										_get__('React').createElement('button', { className: 'row-expand__trigger row-expand__trigger--open' })
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__child-row row-group__child-row--show', 'data-row-parent': '123' },
									_get__('React').createElement(
										'td',
										{ rowSpan: '2' },
										'\xA0'
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__child-row row-group__child-row--show', 'data-row-parent': '123' },
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__parent-row', 'data-row-id': '456' },
									_get__('React').createElement(
										'td',
										{ className: 'row-expand row-expand--secondary' },
										_get__('React').createElement('button', { className: 'js-rowExpand row-expand__trigger' })
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__child-row', 'data-row-parent': '456' },
									_get__('React').createElement(
										'td',
										null,
										'\xA0'
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'row-group' },
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__key-row' },
									_get__('React').createElement(
										'td',
										{ className: 'row-expand' },
										_get__('React').createElement('button', { className: 'row-expand__trigger row-expand__trigger--open' })
									),
									_get__('React').createElement(
										'th',
										{ scope: 'row' },
										_get__('React').createElement(
											'a',
											{ href: '' },
											'MAINLINK'
										)
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<div class="scroll-container-x"><table class="table table--rows table--border table--blue table--comfy text--left">\n\t\t  <thead>\n\t\t    <tr>\n\t\t      <th>&nbsp;</th>\n\t\t      <th>One</th>\n\t\t      <th>Two</th>\n\t\t      <th>Three</th>\n\t\t      <th>Four</th>\n\t\t      <th>Five</th>\n\t\t      <th>Six</th>\n\t\t      <th>Seven</th>\n\t\t    </tr>\n\t\t  </thead>\n\t\t  <tbody class="row-group row-group--open">\n\t\t    <tr class="row-group__key-row">\n\t\t      <td class="row-expand">\n\t\t        <button class="row-expand__trigger row-expand__trigger--open"></button>\n\t\t      </td>\n\t\t      <th scope="row">\n\t\t        <a href="">MAINLINK</a>\n\t\t      </th>\n\t\t      <td>Two</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__parent-row row-group__parent-row--active" data-row-id="123">\n\t\t      <td rowspan="5">&nbsp;</td>\n\t\t      <td class="row-expand row-expand--secondary">\n\t\t        <button class="row-expand__trigger row-expand__trigger--open"></button>\n\t\t      </td>\n\t\t      <td>Two</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__child-row row-group__child-row--show" data-row-parent="123">\n\t\t      <td rowspan="2">&nbsp;</td>\n\t\t      <td>Two</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__child-row row-group__child-row--show" data-row-parent="123">\n\t\t      <td>Two</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__parent-row" data-row-id="456">\n\t\t      <td class="row-expand row-expand--secondary">\n\t\t        <button class="js-rowExpand row-expand__trigger"></button>\n\t\t      </td>\n\t\t      <td>Two</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__child-row" data-row-parent="456">\n\t\t      <td>&nbsp;</td>\n\t\t      <td>Two</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t  </tbody>\n\t\t  <tbody class="row-group">\n\t\t    <tr class="row-group__key-row">\n\t\t      <td class="row-expand">\n\t\t        <button class="row-expand__trigger row-expand__trigger--open"></button>\n\t\t      </td>\n\t\t      <th scope="row">\n\t\t        <a href="">MAINLINK</a>\n\t\t      </th>\n\t\t      <td>Two</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t  </tbody>\n\t\t</table></div>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h4',
						null,
						'Row history'
					),
					_get__('React').createElement(
						'p',
						null,
						'Row history should be used when showing the previous states of a single row. This is different to the hierarchy format as there is no indentation or visual order of the data rows. This format might be used when showing the depth of the book for example. A single solid plus/minus icon per row is used to open/close the row history. This icon can be placed beside the data relevant to trigger a display of the rows history e.g. ID'
					),
					_get__('React').createElement(
						'div',
						{ className: 'scroll-container-x' },
						_get__('React').createElement(
							'table',
							{ className: 'table table--rows table--border table--blue table--comfy text--left' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'One'
									),
									_get__('React').createElement(
										'th',
										null,
										'Two'
									),
									_get__('React').createElement(
										'th',
										null,
										'\xA0'
									),
									_get__('React').createElement(
										'th',
										null,
										'Three'
									),
									_get__('React').createElement(
										'th',
										null,
										'Four'
									),
									_get__('React').createElement(
										'th',
										null,
										'Five'
									),
									_get__('React').createElement(
										'th',
										null,
										'Six'
									),
									_get__('React').createElement(
										'th',
										null,
										'Seven'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'row-group row-group--history row-group--open' },
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__key-row' },
									_get__('React').createElement(
										'th',
										{ scope: 'row' },
										_get__('React').createElement(
											'a',
											{ href: '' },
											'One'
										)
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										{ className: 'row-expand' },
										_get__('React').createElement('button', { className: 'row-expand__trigger row-expand__trigger--open' })
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__child-row' },
									_get__('React').createElement(
										'td',
										{ colSpan: '3', rowSpan: '2' },
										'\xA0'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__child-row' },
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'row-group row-group--history' },
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__key-row' },
									_get__('React').createElement(
										'th',
										{ scope: 'row' },
										_get__('React').createElement(
											'a',
											{ href: '' },
											'One'
										)
									),
									_get__('React').createElement(
										'td',
										null,
										'Two'
									),
									_get__('React').createElement(
										'td',
										{ className: 'row-expand' },
										_get__('React').createElement('button', { className: 'js-rowExpand row-expand__trigger' })
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'row-group__child-row' },
									_get__('React').createElement(
										'td',
										{ colSpan: '3' },
										'\xA0'
									),
									_get__('React').createElement(
										'td',
										null,
										'Three'
									),
									_get__('React').createElement(
										'td',
										null,
										'Four'
									),
									_get__('React').createElement(
										'td',
										null,
										'Five'
									),
									_get__('React').createElement(
										'td',
										null,
										'Six'
									),
									_get__('React').createElement(
										'td',
										null,
										'Seven'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<div class="scroll-container-x"><table class="table table--rows table--border table--blue table--comfy text--left">\n\t\t  <thead>\n\t\t    <tr>\n\t\t      <th>One</th>\n\t\t      <th>Two</th>\n\t\t      <th>&nbsp;</th>\n\t\t      <th>Three</th>\n\t\t      <th>Four</th>\n\t\t      <th>Five</th>\n\t\t      <th>Six</th>\n\t\t      <th>Seven</th>\n\t\t    </tr>\n\t\t  </thead>\n\t\t  <tbody class="row-group row-group--history row-group--open">\n\t\t    <tr class="row-group__key-row">\n\t\t      <th scope="row">\n\t\t        <a href="">One</a>\n\t\t      </th>\n\t\t      <td>Two</td>\n\t\t      <td class="row-expand">\n\t\t        <button class="row-expand__trigger row-expand__trigger--open"></button>\n\t\t      </td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__child-row">\n\t\t      <td colspan="3" rowspan="2">&nbsp;</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__child-row">\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t  </tbody>\n\t\t  <tbody class="row-group row-group--history">\n\t\t    <tr class="row-group__key-row">\n\t\t      <th scope="row">\n\t\t        <a href="">One</a>\n\t\t      </th>\n\t\t      <td>Two</td>\n\t\t      <td class="row-expand">\n\t\t        <button class="js-rowExpand row-expand__trigger"></button>\n\t\t      </td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t    <tr class="row-group__child-row">\n\t\t      <td colspan="3">&nbsp;</td>\n\t\t      <td>Three</td>\n\t\t      <td>Four</td>\n\t\t      <td>Five</td>\n\t\t      <td>Six</td>\n\t\t      <td>Seven</td>\n\t\t    </tr>\n\t\t  </tbody>\n\t\t</table></div>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Sorting'
					),
					_get__('React').createElement(
						'p',
						null,
						'Giving users the ability to sort data based on a column is a common feature when using tables to display data. The ',
						_get__('React').createElement(
							'code',
							null,
							'.table-sort'
						),
						' class and modifiers provide styling (no functionality) to indicate that a column can be sorted and, if it is being sorted, which direction it is being sorted in.'
					),
					_get__('React').createElement(
						'table',
						{ className: 'table table--comfy text--left' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Class'
								),
								_get__('React').createElement(
									'th',
									null,
									'Type'
								),
								_get__('React').createElement(
									'th',
									null,
									'Description'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									_get__('React').createElement(
										'code',
										null,
										'.table-sort'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Block'
								),
								_get__('React').createElement(
									'td',
									null,
									'Applies styling to indicate that a column can be sorted'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									_get__('React').createElement(
										'code',
										null,
										'.table-sort--asc'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Modifier'
								),
								_get__('React').createElement(
									'td',
									null,
									'Applies styling to indicate that a column is being sorted in an ascending direction'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									_get__('React').createElement(
										'code',
										null,
										'.table-sort--desc'
									)
								),
								_get__('React').createElement(
									'td',
									null,
									'Modifier'
								),
								_get__('React').createElement(
									'td',
									null,
									'Applies styling to indicate that a column is being sorted in a descending direction'
								)
							)
						)
					),
					_get__('React').createElement(
						'div',
						{ className: 'scroll-container-x' },
						_get__('React').createElement(
							'table',
							{ className: 'table table--comfy table--hover table--striped table--blue js-data-table' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										_get__('React').createElement(
											'button',
											{ type: 'button', className: 'table-sort' },
											'Product'
										)
									),
									_get__('React').createElement(
										'th',
										null,
										_get__('React').createElement(
											'button',
											{ type: 'button', className: 'table-sort' },
											'Code'
										)
									),
									_get__('React').createElement(
										'th',
										null,
										'Last'
									),
									_get__('React').createElement(
										'th',
										null,
										_get__('React').createElement(
											'button',
											{ type: 'button', className: 'table-sort table-sort--asc' },
											'Change'
										)
									),
									_get__('React').createElement(
										'th',
										null,
										'Chart'
									),
									_get__('React').createElement(
										'th',
										null,
										'Open'
									),
									_get__('React').createElement(
										'th',
										null,
										_get__('React').createElement(
											'button',
											{ type: 'button', className: 'table-sort table-sort--desc' },
											'High'
										)
									),
									_get__('React').createElement(
										'th',
										null,
										'Low'
									),
									_get__('React').createElement(
										'th',
										null,
										'Globex Vol'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Corn Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'369\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'68,284'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1036\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'48,346'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Oil Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.29'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+0.02'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'23,054'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'select',
						{ className: 'theme-select float--left' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Default Theme'
						),
						_get__('React').createElement(
							'option',
							{ value: 'table--light' },
							'Light Theme'
						),
						_get__('React').createElement(
							'option',
							{ value: 'table--blue', selected: true },
							'Blue Theme'
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<div class="scroll-container-x"><table class="table table--comfy table--hover table--striped table--blue">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>\n\t\t\t\t<button type="button" class="table-sort">Product</button>\n\t\t\t</th>\n\t\t\t<th>\n\t\t\t\t<button type="button" class="table-sort">Code</button>\n\t\t\t</th>\n\t\t\t<th>Last</th>\n\t\t\t<th>\n\t\t\t\t<button type="button" class="table-sort table-sort--asc">Change</button>\n\t\t\t</th>\n\t\t\t<th>Chart</th>\n\t\t\t<th>Open</th>\n\t\t\t<th>\n\t\t\t\t<button type="button" class="table-sort table-sort--desc">High</button>\n\t\t\t</th>\n\t\t\t<th>Low</th>\n\t\t\t<th>Globex Vol</th>\n\t\t</tr>\n\t</thead>\n  <tbody>\n      ...\n  </tbody>\n</table></div>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Categories'
					),
					_get__('React').createElement(
						'p',
						null,
						'Categories can be added to tables when groups of rows need to be broken up. Several categories can exist within a single table.'
					),
					_get__('React').createElement(
						'div',
						{ className: 'scroll-container-x' },
						_get__('React').createElement(
							'table',
							{ className: 'table table--blue table--comfy table--striped table--rows table--hover' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Product'
									),
									_get__('React').createElement(
										'th',
										null,
										'Code'
									),
									_get__('React').createElement(
										'th',
										null,
										'Last'
									),
									_get__('React').createElement(
										'th',
										null,
										'Change'
									),
									_get__('React').createElement(
										'th',
										null,
										'Chart'
									),
									_get__('React').createElement(
										'th',
										null,
										'Open'
									),
									_get__('React').createElement(
										'th',
										null,
										'High'
									),
									_get__('React').createElement(
										'th',
										null,
										'Low'
									),
									_get__('React').createElement(
										'th',
										null,
										'Globex Vol'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'table-category' },
								_get__('React').createElement(
									'tr',
									{ className: 'table-category__head' },
									_get__('React').createElement(
										'td',
										{ colSpan: '9' },
										_get__('React').createElement(
											'div',
											{ className: 'display--flex' },
											_get__('React').createElement(
												'div',
												{ className: 'table-category__title' },
												'Category heading'
											)
										)
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Corn Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'369\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'68,284'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1036\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'48,346'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'table-category' },
								_get__('React').createElement(
									'tr',
									{ className: 'table-category__head' },
									_get__('React').createElement(
										'td',
										{ colSpan: '9' },
										_get__('React').createElement(
											'div',
											{ className: 'display--flex' },
											_get__('React').createElement(
												'div',
												{ className: 'table-category__title' },
												'Category heading'
											)
										)
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Oil Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.29'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+0.02'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'23,054'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<div class="scroll-container-x"><table class="table table--blue table--comfy table--striped table--rows table--hover">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>Product</th>\n\t\t\t<th>Code</th>\n\t\t\t<th>Last</th>\n\t\t\t<th>Change</th>\n\t\t\t<th>Chart</th>\n\t\t\t<th>Open</th>\n\t\t\t<th>High</th>\n\t\t\t<th>Low</th>\n\t\t\t<th>Globex Vol</th>\n\t\t</tr>\n\t</thead>\n\t<tbody class="table-category">\n\t\t<tr class="table-category__head">\n\t\t\t<td colspan="9">\n\t\t\t\t<div class="display--flex">\n\t\t\t\t\t<div class="table-category__title">\n\t\t\t\t\t\tCategory heading\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td><a class="weight--bold" href="#">Corn Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">369\'0</td>\n\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">68,284</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td><a class="weight--bold" href="#">Soybean Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">1036\'4</td>\n\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">48,346</td>\n\t\t</tr>\n\t</tbody>\n\t<tbody class="table-category">\n\t\t<tr class="table-category__head">\n\t\t\t<td colspan="9">\n\t\t\t\t<div class="display--flex">\n\t\t\t\t\t<div class="table-category__title">\n\t\t\t\t\t\tCategory heading\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">34.29</td>\n\t\t\t<td class="text--right">+0.02</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">23,054</td>\n\t\t</tr>\n\t</tbody>\n</table></div>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Selected Rows'
					),
					_get__('React').createElement(
						'p',
						null,
						'Rows can be shown to be selected by applying a class of ',
						_get__('React').createElement(
							'code',
							null,
							'.table--tr-selected'
						),
						' on the desired row.'
					),
					_get__('React').createElement(
						'div',
						{ className: 'scroll-container-x' },
						_get__('React').createElement(
							'table',
							{ className: 'table table--blue table--comfy table--striped table--rows table--hover' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Product'
									),
									_get__('React').createElement(
										'th',
										null,
										'Code'
									),
									_get__('React').createElement(
										'th',
										null,
										'Last'
									),
									_get__('React').createElement(
										'th',
										null,
										'Change'
									),
									_get__('React').createElement(
										'th',
										null,
										'Chart'
									),
									_get__('React').createElement(
										'th',
										null,
										'Open'
									),
									_get__('React').createElement(
										'th',
										null,
										'High'
									),
									_get__('React').createElement(
										'th',
										null,
										'Low'
									),
									_get__('React').createElement(
										'th',
										null,
										'Globex Vol'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'table-category' },
								_get__('React').createElement(
									'tr',
									{ className: 'table-category__head' },
									_get__('React').createElement(
										'td',
										{ colSpan: '9' },
										_get__('React').createElement(
											'div',
											{ className: 'display--flex' },
											_get__('React').createElement(
												'div',
												{ className: 'table-category__title' },
												'Category heading'
											)
										)
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Corn Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'369\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'68,284'
									)
								),
								_get__('React').createElement(
									'tr',
									{ className: 'table--tr-selected' },
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1036\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'48,346'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								{ className: 'table-category' },
								_get__('React').createElement(
									'tr',
									{ className: 'table-category__head' },
									_get__('React').createElement(
										'td',
										{ colSpan: '9' },
										_get__('React').createElement(
											'div',
											{ className: 'display--flex' },
											_get__('React').createElement(
												'div',
												{ className: 'table-category__title' },
												'Category heading'
											)
										)
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Oil Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.29'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+0.02'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'23,054'
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<div class="scroll-container-x"><table class="table table--blue table--comfy table--striped table--rows table--hover">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>Product</th>\n\t\t\t<th>Code</th>\n\t\t\t<th>Last</th>\n\t\t\t<th>Change</th>\n\t\t\t<th>Chart</th>\n\t\t\t<th>Open</th>\n\t\t\t<th>High</th>\n\t\t\t<th>Low</th>\n\t\t\t<th>Globex Vol</th>\n\t\t</tr>\n\t</thead>\n\t<tbody class="table-category">\n\t\t<tr class="table-category__head">\n\t\t\t<td colspan="9">\n\t\t\t\t<div class="display--flex">\n\t\t\t\t\t<div class="table-category__title">\n\t\t\t\t\t\tCategory heading\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td><a class="weight--bold" href="#">Corn Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">369\'0</td>\n\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">68,284</td>\n\t\t</tr>\n\t\t<tr class="table--tr-selected">\n\t\t\t<td><a class="weight--bold" href="#">Soybean Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">1036\'4</td>\n\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">48,346</td>\n\t\t</tr>\n\t</tbody>\n\t<tbody class="table-category">\n\t\t<tr class="table-category__head">\n\t\t\t<td colspan="9">\n\t\t\t\t<div class="display--flex">\n\t\t\t\t\t<div class="table-category__title">\n\t\t\t\t\t\tCategory heading\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">34.29</td>\n\t\t\t<td class="text--right">+0.02</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">23,054</td>\n\t\t</tr>\n\t</tbody>\n</table></div>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Responsive'
					),
					_get__('React').createElement(
						'div',
						{ className: 'callout' },
						_get__('React').createElement(
							'b',
							null,
							'Note'
						),
						': For full table scrolling, you need to wrap the table in a div which has the ',
						_get__('React').createElement(
							'code',
							null,
							'scroll-container-x'
						),
						' class.'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'If you have too much data for mobile view to handle, there is a couple of options'
					),
					_get__('React').createElement(
						'p',
						null,
						'For content data that the user does not need to directly compare, the following non-javascript solution is preferred'
					),
					_get__('React').createElement(
						'p',
						null,
						'Resize your browser to see the functionality.'
					),
					_get__('React').createElement(
						'p',
						null,
						'.table--collapse - Pure css enabled responsiveness'
					),
					_get__('React').createElement(
						'table',
						{ className: 'table table--blue table--comfy table--hover table--striped table--rows table--collapse' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Movie Title'
								),
								_get__('React').createElement(
									'th',
									null,
									'Genre'
								),
								_get__('React').createElement(
									'th',
									null,
									'Year'
								),
								_get__('React').createElement(
									'th',
									null,
									'Gross'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Movie Title' },
									'Star Wars'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Genre' },
									'Adventure, Sci-fi'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Year' },
									'1977'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Gross' },
									'$460,935,665'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Movie Title' },
									'Howard The Duck'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Genre' },
									'"Comedy"'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Year' },
									'1986'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Gross' },
									'$16,295,774'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Movie Title' },
									'American Graffiti'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Genre' },
									'Comedy, Drama'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Year' },
									'1973'
								),
								_get__('React').createElement(
									'td',
									{ 'data-th': 'Gross' },
									'$115,000,000'
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--blue table--comfy table--hover table--striped table--rows table--collapse">\n<thead>\n\t<tr>\n\t\t<th>Movie Title</th>\n\t\t<th>Genre</th>\n\t\t<th>Year</th>\n\t\t<th>Gross</th>\n\t</tr>\n</thead>\n<tbody>\n\t<tr>\n\t\t<td data-th="Movie Title">Star Wars</td>\n\t\t<td data-th="Genre">Adventure, Sci-fi</td>\n\t\t<td data-th="Year">1977</td>\n\t\t<td data-th="Gross">$460,935,665</td>\n\t</tr>\n\t<tr>\n\t\t<td data-th="Movie Title">Howard The Duck</td>\n\t\t<td data-th="Genre">"Comedy"</td>\n\t\t<td data-th="Year">1986</td>\n\t\t<td data-th="Gross">$16,295,774</td>\n\t</tr>\n\t<tr>\n\t\t<td data-th="Movie Title">American Graffiti</td>\n\t\t<td data-th="Genre">Comedy, Drama</td>\n\t\t<td data-th="Year">1973</td>\n\t\t<td data-th="Gross">$115,000,000</td>\n\t</tr>\n</tbody>\n</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'For tabular data that the user needs to compare directly the following behaviour is preferred - the library will break the table to enable a fixed first column and horizontal scrolling to aid viewing context.'
					),
					_get__('React').createElement(
						'p',
						null,
						'Resize your browser to see the functionality.'
					),
					_get__('React').createElement(
						'p',
						null,
						'.table--responsive .js-table--responsive - Javascript enabled responsiveness'
					),
					_get__('React').createElement(
						'select',
						{ className: 'size-select' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Select a resolution'
						),
						_get__('React').createElement(
							'option',
							{ value: '482' },
							'480px (xs)'
						),
						_get__('React').createElement(
							'option',
							{ value: '770' },
							'768px (sm)'
						),
						_get__('React').createElement(
							'option',
							{ value: '994' },
							'992px (md)'
						),
						_get__('React').createElement(
							'option',
							{ value: '1202' },
							'1200px (lg)'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'iframe-container', style: { 'height': '280px' } },
						_get__('React').createElement('iframe', { seamless: true, srcDoc: '\n\t\t\t\t<html>\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<link rel="stylesheet" type="text/css" href="css/commonUI.css">\n\t\t\t\t\t</head>\n\t\t\t\t\t<body>\n\t\t\t\t\t\t<div class="grid">\n\t\t\t\t\t\t\t<div class="grid__col-12">\n\t\t\t\t\t\t\t\t<table class="table table--blue table--comfy table--hover table--striped table--rows table--responsive js-table--responsive">\n\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<th>Lorem</th>\n\t\t\t\t\t\t\t\t\t<th>Ipsum</th>\n\t\t\t\t\t\t\t\t\t<th>Dolor</th>\n\t\t\t\t\t\t\t\t\t<th>Sit</th>\n\t\t\t\t\t\t\t\t\t<th>Lorem</th>\n\t\t\t\t\t\t\t\t\t<th>Ipsum</th>\n\t\t\t\t\t\t\t\t\t<th>Dolor</th>\n\t\t\t\t\t\t\t\t\t<th>Sit</th>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">03.788</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">03.788</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">32.210</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">32.210</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">47.797</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">47.797</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">09.640</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">09.640</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t</tr>\n\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<script type="text/javascript" src="js/commonUI.js"></script>\n\t\t\t\t\t\t<script>\n\t\t\t\t\t\t\tfunction init() {\n\t\t\t\t\t\t\t\tcommonUI.initializeTable();\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\twindow.onload = init;\n\t\t\t\t\t\t</script>\n\t\t\t\t\t</body>\n\t\t\t\t</html>\n\t\t\t' })
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--blue table--comfy table--hover table--striped table--rows table--responsive js-table--responsive text-body-xs">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>Lorem</th>\n\t\t\t<th>Ipsum</th>\n\t\t\t<th>Dolor</th>\n\t\t\t<th>Sit</th>\n\t\t\t<th>Lorem</th>\n\t\t\t<th>Ipsum</th>\n\t\t\t<th>Dolor</th>\n\t\t\t<th>Sit</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">03.788</td>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">03.788</td>\n\t\t\t<td>Lorem</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">32.210</td>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">32.210</td>\n\t\t\t<td>Lorem</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">47.797</td>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">47.797</td>\n\t\t\t<td>Lorem</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">09.640</td>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">09.640</td>\n\t\t\t<td>Lorem</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">12.117</td>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td class="text--center">12.117</td>\n\t\t\t<td>Lorem</td>\n\t\t</tr>\n\n\t</tbody>\n</table>'
						)
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'// Using default classes shown in snippet.\n// The library looks for the class \'js-table--responsive\' by default.\ncommonUI.initializeTable();\n\n// You can have multiple tables on the page, they will all be initialised\n\n// Using custom selectors\ncommonUI.initializeTable({\n  selector: \'.special-table\'\n});'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Table Detail View'
					),
					_get__('React').createElement(
						'p',
						null,
						'The table detail view will instantiate a secondary view when entering any breakpoint below the small Common UI breakpoint. Columns assigned as priority will appear on the primary view of table. Each row will have a chevron to the right of the row. Once this icon is selected the view will change to a detailed view where all data in the row (including the priority data) will be listed.'
					),
					_get__('React').createElement(
						'p',
						null,
						'To assign what column gets shown at which particular breakpoint, you can use the following pattern: ',
						_get__('React').createElement(
							'code',
							null,
							'table--detail--show-[\'breakpoint\']'
						),
						' where \'breakpoint\' is the CommonUI breakpoint name.'
					),
					_get__('React').createElement(
						'p',
						null,
						'Find a list of available breakpoints ',
						_get__('React').createElement(
							'a',
							{ href: '#breakpoints' },
							'here'
						),
						'.'
					),
					_get__('React').createElement(
						'p',
						null,
						'Examples: ',
						_get__('React').createElement(
							'code',
							null,
							'table--detail--show-xs-and-up table--detail--show-sm-and-up'
						),
						'.'
					),
					_get__('React').createElement(
						'div',
						{ style: { 'height': '450px', 'overflowX': 'hidden' } },
						_get__('React').createElement(
							'div',
							{ className: 'table--detail--container js-table--detail' },
							_get__('React').createElement(
								'div',
								{ className: 'grid height--100' },
								_get__('React').createElement(
									'div',
									{ className: 'position--relative grid__col-12 height--100' },
									_get__('React').createElement(
										'table',
										{ className: 'table table--blue table--comfy table--hover table--striped table--rows table--detail' },
										_get__('React').createElement(
											'thead',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'Client Order ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-md-and-up' },
													'Fill ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-md-and-up' },
													'Status'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-and-up' },
													'Fill Time'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-and-up' },
													'Tag 50'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Fill Qty'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'Contract'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-sm-and-up' },
													'Session ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-sm-and-up' },
													'B/S'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Amount'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Fill Price'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Order Price'
												),
												_get__('React').createElement('th', { className: 'table--detail--disclose hide--lg-and-up' })
											)
										),
										_get__('React').createElement(
											'tbody',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'ACP1529'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-trigger hide--lg-and-up' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-right' })
												)
											)
										)
									),
									_get__('React').createElement(
										'div',
										{ className: 'table--detail__secondary--view js-table-secondary-view hide--lg-and-up' },
										_get__('React').createElement(
											'div',
											{ className: 'table--detail__secondary--view__container' },
											_get__('React').createElement(
												'header',
												{ className: 'table--detail__secondary--view__header' },
												_get__('React').createElement(
													'button',
													{ className: 'btn btn--transparent table--detail__secondary--view__header__action js-table-secondary-view--dismiss soft-half' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-left' })
												),
												_get__('React').createElement(
													'h3',
													{ className: 'table--detail__secondary--view__header__title flush' },
													'Detail View'
												)
											),
											_get__('React').createElement(
												'section',
												{ className: 'table--detail__secondary--view__container__content' },
												_get__('React').createElement(
													'table',
													{ className: 'table table--detail__secondary--view-table push-half--top' },
													_get__('React').createElement(
														'tbody',
														null,
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Client Order ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'ACP1529'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'88123:M:49753'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Status'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Filled'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Time'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'2018-06-22 07:53:47'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Tag 50'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'4027'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Qty'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'9'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Contract'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'CAUM9 C0775'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Session ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'AZT'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'B/S'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'BUY'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Amount'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Order Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Client Order ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'ACP1529'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'88123:M:49753'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Status'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Filled'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Time'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'2018-06-22 07:53:47'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Tag 50'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'4027'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Qty'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'9'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Contract'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'CAUM9 C0775'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Session ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'AZT'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'B/S'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'BUY'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Amount'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Order Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Client Order ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'ACP1529'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'88123:M:49753'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Status'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Filled'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Time'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'2018-06-22 07:53:47'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Tag 50'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'4027'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Qty'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'9'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Contract'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'CAUM9 C0775'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Session ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'AZT'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'B/S'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'BUY'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Amount'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Order Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Client Order ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'ACP1529'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'88123:M:49753'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Status'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Filled'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Time'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'2018-06-22 07:53:47'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Tag 50'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'4027'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Qty'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'9'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Contract'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'CAUM9 C0775'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Session ID'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'AZT'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'B/S'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'BUY'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Amount'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'Lorum ipsum dolor sit amet, consectetur adipipscing elit'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Fill Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														),
														_get__('React').createElement(
															'tr',
															null,
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-key text--right' },
																'Order Price'
															),
															_get__('React').createElement(
																'td',
																{ className: 'table--detail__secondary--view__table-value text--left' },
																'10028.0'
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'In the provided example, you can see certain columns dropping in and out, some remain throughout the breakpoints and some only appear at the upper breakpoints. These are all configurable using the aforementioned classes. When the disclosure chevron is viewable is also configurable.'
					),
					_get__('React').createElement(
						'select',
						{ className: 'size-select' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Select a resolution'
						),
						_get__('React').createElement(
							'option',
							{ value: '482' },
							'480px (xs)'
						),
						_get__('React').createElement(
							'option',
							{ value: '770' },
							'768px (sm)'
						),
						_get__('React').createElement(
							'option',
							{ value: '994' },
							'992px (md)'
						),
						_get__('React').createElement(
							'option',
							{ value: '1202' },
							'1200px (lg)'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'iframe-container', style: { 'height': '685px' } },
						_get__('React').createElement('iframe', { seamless: true, srcDoc: '\n\t\t\t\t<html class="height--100">\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n\t\t\t\t\t\t<link rel="stylesheet" type="text/css" href="css/commonUI.css">\n\t\t\t\t\t</head>\n\t\t\t\t\t<body class="height--100">\n\t\t\t\t\t\t<div class="table--detail--container js-table--detail">\n\t\t\t\t\t\t\t<div class="grid height--100">\n\t\t\t\t\t\t\t\t<div class="position--relative grid__col-12 height--100">\n\t\t\t\t\t\t\t\t\t<table class="table table--blue table--comfy table--hover table--striped table--rows table--detail">\n\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Fill ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Status</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Fill Time</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Tag 50</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Fill Qty</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">Session ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">B/S</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Amount</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Fill Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Order Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--disclose hide--lg-and-up"></th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t<div class="table--detail__secondary--view js-table-secondary-view hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t<div class="table--detail__secondary--view__container">\n\t\t\t\t\t\t\t\t\t\t\t<header class="table--detail__secondary--view__header">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--transparent table--detail__secondary--view__header__action js-table-secondary-view--dismiss soft-half"><i class="fa fa-angle-double-left"></i></button>\n\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="table--detail__secondary--view__header__title flush">Detail View</h3>\n\t\t\t\t\t\t\t\t\t\t\t</header>\n\t\t\t\t\t\t\t\t\t\t\t<section class="table--detail__secondary--view__container__content">\n\t\t\t\t\t\t\t\t\t\t\t\t<table class="table table--detail__secondary--view-table push-half--top">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\t\t</section>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<script type="text/javascript" src="js/commonUI.js"></script>\n\t\t\t\t\t\t<script>\n\t\t\t\t\t\t\tfunction init() {\n\t\t\t\t\t\t\t\tcommonUI.initializeTable({\n\t\t\t\t\t\t\t\t\tselector: \'.js-table--detail\',\n\t\t\t\t\t\t\t\t\tdetailViewType: \'detailedView\',\n\t\t\t\t\t\t\t\t\tdetailViewSelector: \'.js-table-secondary-view\',\n\t\t\t\t\t\t\t\t\tdetailViewDismissSelector: \'.js-table-secondary-view--dismiss\'\n\t\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\twindow.onload = init;\n\t\t\t\t\t\t</script>\n\t\t\t\t\t</body>\n\t\t\t\t</html>\n\t\t\t' })
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'To enable this functionality, you can instantiate the table like this:'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'commonUI.initializeTable({\n\tselector: \'.js-table--detail\',\n\tdetailViewType: \'detailedView\',\n\tdetailViewSelector: \'.js-table-secondary-view\',\n\tdetailViewDismissSelector: \'.js-table-secondary-view--dismiss\'\n});'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<div class="table--detail--container js-table--detail">\n\t<div class="grid height--100">\n\t\t<div class="position--relative grid__col-12 height--100">\n\t\t\t<table class="table table--blue table--comfy table--hover table--striped table--rows table--detail">\n\t\t\t\t<thead>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>\n\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Fill ID</th>\n\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Status</th>\n\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Fill Time</th>\n\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Tag 50</th>\n\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Fill Qty</th>\n\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>\n\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Session ID</th>\n\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">B/S</th>\n\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">Amount</th>\n\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Fill Price</th>\n\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Order Price</th>\n\t\t\t\t\t\t<th class="table--detail--disclose hide--lg-and-up"></th>\n\t\t\t\t\t</tr>\n\t\t\t\t</thead>\n\t\t\t\t<tbody>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">ACP1529</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">AZT</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-trigger hide--lg-and-up"><i class="fa fa-angle-double-right"></i></td>\n\t\t\t\t\t</tr>\n\t\t\t\t</tbody>\n\t\t\t</table>\n\t\t\t<div class="table--detail__secondary--view js-table-secondary-view hide--lg-and-up">\n\t\t\t\t<div class="table--detail__secondary--view__container">\n\t\t\t\t\t<header class="table--detail__secondary--view__header">\n\t\t\t\t\t\t<button class="btn btn--transparent table--detail__secondary--view__header__action js-table-secondary-view--dismiss soft-half"><i class="fa fa-angle-double-left"></i></button>\n\t\t\t\t\t\t<h3 class="table--detail__secondary--view__header__title flush">Detail View</h3>\n\t\t\t\t\t</header>\n\t\t\t\t\t<section class="table--detail__secondary--view__container__content">\n\t\t\t\t\t\t<table class="table table--detail__secondary--view-table push-half--top">\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Client Order ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">ACP1529</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">88123:M:49753</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Status</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Filled</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Time</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Tag 50</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">4027</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Qty</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">9</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Contract</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Session ID</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">AZT</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">B/S</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">BUY</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Amount</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">Lorum ipsum dolor sit amet, consectetur adipipscing elit</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Fill Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-key text--right">Order Price</td>\n\t\t\t\t\t\t\t\t\t<td class="table--detail__secondary--view__table-value text--left">10028.0</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</section>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Table Expanded Row'
					),
					_get__('React').createElement(
						'p',
						null,
						'For data sets with large amounts of columns you can set priority and secondary columns. To avoid scrolling horizontally, the Common UI Expanded Row table allows you to view all information. The intention is that any data that will not fit in the defaulted view will be shown in an Expanded Row.'
					),
					_get__('React').createElement(
						'div',
						{ style: { 'height': '400px', 'overflowX': 'hidden' } },
						_get__('React').createElement(
							'div',
							{ className: 'table--detail--container' },
							_get__('React').createElement(
								'div',
								{ className: 'grid height--100' },
								_get__('React').createElement(
									'div',
									{ className: 'position--relative grid__col-12 height--100' },
									_get__('React').createElement(
										'table',
										{ className: 'table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded js-table-detail-expanded' },
										_get__('React').createElement(
											'thead',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'Client Order ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-md-and-up' },
													'Fill ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-md-and-up' },
													'Status'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-and-up' },
													'Fill Time'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-and-up' },
													'Tag 50'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Fill Qty'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'Contract'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-sm-and-up' },
													'Session ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-sm-and-up' },
													'B/S'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Fill Price'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Order Price'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Stop Price'
												),
												_get__('React').createElement('th', { className: 'table--detail--disclose' }),
												_get__('React').createElement('th', { className: 'table--detail--disclose' })
											)
										),
										_get__('React').createElement(
											'tbody',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'88123:M:49753'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Filled'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'2018-06-22 07:53:47'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'10028.0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose js-table-detail-expand-trigger' },
													_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-trash delete-row' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--expanded js-table-detail-expanded-row' },
												_get__('React').createElement(
													'td',
													{ colSpan: '14' },
													_get__('React').createElement(
														'div',
														null,
														_get__('React').createElement(
															'ul',
															{ className: 'table--detail__row--expanded--list' },
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'88123:M:49753'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Status'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Filled'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Time'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'2018-06-22 07:53:47'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Tag 50'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'4027'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Qty'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'9'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Session ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'AZT'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'B/S'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'BUY'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Fill Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Order Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Stop Price'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'10028.0'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Exchange'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'NYMEX'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Time In Force (TIF)'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Day'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Firm ID'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'100'
																)
															),
															_get__('React').createElement(
																'li',
																{ className: 'table--detail__row--expanded--list-item' },
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-title' },
																	'Comments'
																),
																_get__('React').createElement(
																	'p',
																	{ className: 'table--detail__row--expanded--list-item-value' },
																	'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																)
															)
														)
													)
												)
											)
										)
									)
								)
							)
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'As seen in the source, for each main row there should be another row immediately following with a ',
						_get__('React').createElement(
							'code',
							null,
							'table--detail__row--expanded'
						),
						' class. This means two ',
						_get__('React').createElement(
							'code',
							null,
							'tr'
						),
						' tags in succession in the DOM. The first one being the main table row that follows the usual format and the second being a row that has free-form flex elements within. The Common UI JS library expects the detailed row to immediately follow its \'parent\' row.'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<!-- Start of \'full\' row couplet -->\n<tr ...>\n\t<td>ACP1529</td>\n\t<td>88123:M:49753</td>\n\t...\n</tr>\n<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t<td colspan=""><ul>...</ul></td>\n</tr>\n<!-- End of \'full\' row couplet -->'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						{ className: 'callout' },
						_get__('React').createElement(
							'strong',
							null,
							'Note:'
						),
						' In order for the detail row to appear correctly and span the full width of the table, the td tag within the expanded row must have a \'colspan\' attribute, with a value that matches the amount of table headings.'
					),
					_get__('React').createElement(
						'p',
						null,
						'The responsive implementation is similiar to the detail table view above, using CSS classes we can show and hide certain content at certain breakpoints.'
					),
					_get__('React').createElement(
						'select',
						{ className: 'size-select' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Select a resolution'
						),
						_get__('React').createElement(
							'option',
							{ value: '482' },
							'480px (xs)'
						),
						_get__('React').createElement(
							'option',
							{ value: '770' },
							'768px (sm)'
						),
						_get__('React').createElement(
							'option',
							{ value: '994' },
							'992px (md)'
						),
						_get__('React').createElement(
							'option',
							{ value: '1202' },
							'1200px (lg)'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'iframe-container', style: { 'height': '500px' } },
						_get__('React').createElement('iframe', { seamless: true, srcDoc: '\n\t\t\t\t<html class="height--100">\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n\t\t\t\t\t\t<link rel="stylesheet" type="text/css" href="css/commonUI.css">\n\t\t\t\t\t</head>\n\t\t\t\t\t<body class="height--100">\n\t\t\t\t\t\t<div class="table--detail--container">\n\t\t\t\t\t\t\t<div class="grid height--100">\n\t\t\t\t\t\t\t\t<div class="position--relative grid__col-12 height--100">\n\t\t\t\t\t\t\t\t\t<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded js-table-detail-expanded">\n\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Fill ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Status</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-and-up">Fill Time</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-and-up">Tag 50</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Fill Qty</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">Session ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">B/S</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Fill Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Order Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Stop Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--disclose"></th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colspan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<script type="text/javascript" src="js/commonUI.js"></script>\n\t\t\t\t\t\t<script>\n\t\t\t\t\t\t\tfunction init() {\n\t\t\t\t\t\t\t\tcommonUI.initializeTable({\n\t\t\t\t\t\t\t\t\tselector: \'.js-table-detail-expanded\',\n\t\t\t\t\t\t\t\t\tdetailViewType: \'expandedRow\',\n\t\t\t\t\t\t\t\t\tdetailViewSelector: \'.js-table-detail-expand-trigger\'\n\t\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\twindow.onload = init;\n\t\t\t\t\t\t</script>\n\t\t\t\t\t</body>\n\t\t\t\t</html>\n\t\t\t' })
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'To enable this functionality, you can instantiate the table like this:'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'commonUI.initializeTable({\n\tselector: \'.js-table-detail-expanded\',\n\tdetailViewType: \'expandedRow\',\n\tdetailViewSelector: \'.js-table-detail-expand-trigger\'\n});'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded js-table-detail-expanded">\n\t<thead>\n\t\t<tr>\n\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>\n\t\t\t<th class="table--detail--show-md-and-up">Fill ID</th>\n\t\t\t<th class="table--detail--show-md-and-up">Status</th>\n\t\t\t<th class="table--detail--show-xs-and-up">Fill Time</th>\n\t\t\t<th class="table--detail--show-xs-and-up">Tag 50</th>\n\t\t\t<th class="table--detail--show-lg-and-up">Fill Qty</th>\n\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>\n\t\t\t<th class="table--detail--show-sm-and-up">Session ID</th>\n\t\t\t<th class="table--detail--show-sm-and-up">B/S</th>\n\t\t\t<th class="table--detail--show-lg-and-up">Fill Price</th>\n\t\t\t<th class="table--detail--show-lg-and-up">Order Price</th>\n\t\t\t<th class="table--detail--show-lg-and-up">Stop Price</th>\n\t\t\t<th class="table--detail--disclose"></th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr>\n\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t<td class="table--detail--show-md-and-up">88123:M:49753</td>\n\t\t\t<td class="table--detail--show-md-and-up">Filled</td>\n\t\t\t<td class="table--detail--show-xs-and-up">2018-06-22 07:53:47</td>\n\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t<td class="table--detail--show-lg-and-up">10028.0</td>\n\t\t\t<td class="table--detail--disclose js-table-detail-expand-trigger"><i class="fa fa-angle-double-down"></i></td>\n\t\t</tr>\n\t\t<tr class="table--detail__row--expanded js-table-detail-expanded-row">\n\t\t\t<td colspan="13">\n\t\t\t\t<div>\n\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill ID</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">88123:M:49753</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Filled</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Time</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-06-22 07:53:47</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Qty</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fill Price</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order Price</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">10028.0</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">NYMEX</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Time In Force (TIF)</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">100</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t</tbody>\n</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Table Stacked Row'
					),
					_get__('React').createElement(
						'p',
						null,
						'In addition to the detailed view and expanded row there is also a stacked row. The use case for the stacked row is large sets of table data per row.'
					),
					_get__('React').createElement(
						'p',
						null,
						'These can be split into 3 sections; Primary Information, Secondary Information & All other supporting information. The padding of the secondary and supporting information row is relative to the ',
						_get__('React').createElement(
							'a',
							{ href: '#tables' },
							'table class'
						),
						' applied. For example, a secondary view with a table class of ',
						_get__('React').createElement(
							'code',
							null,
							'.table--cosy'
						),
						', will inherit the styling of the next size up, in this example ',
						_get__('React').createElement(
							'code',
							null,
							'.table--comfy'
						),
						'.'
					),
					_get__('React').createElement(
						'div',
						{ style: { 'height': '550px', 'overflowX': 'hidden' } },
						_get__('React').createElement(
							'div',
							{ className: 'table--detail--container' },
							_get__('React').createElement(
								'div',
								{ className: 'grid height--100' },
								_get__('React').createElement(
									'div',
									{ className: 'position--relative grid__col-12 hard height--100' },
									_get__('React').createElement(
										'table',
										{ className: 'table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded--stacked js-table-detail-stacked' },
										_get__('React').createElement(
											'thead',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'Client Order ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-md-and-up' },
													'Status'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-md-and-up' },
													'Transaction Time'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-and-up' },
													'Tag 50'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-and-up' },
													'Qty'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Open Qty'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'Contract'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-sm-and-up' },
													'Session ID'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-sm-and-up' },
													'B/S'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Account'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'TIF'
												),
												_get__('React').createElement(
													'th',
													{ className: 'table--detail--show-lg-and-up' },
													'Decimal Price'
												),
												_get__('React').createElement('th', { className: 'table--detail--disclose' })
											)
										),
										_get__('React').createElement(
											'tbody',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Working'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'08:09:38.890'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'45'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'BRIO'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Day'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'5330.123456'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-ellipsis-v' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--stacked' },
												_get__('React').createElement(
													'td',
													{ colSpan: '13' },
													_get__('React').createElement(
														'div',
														{ className: 'table--detail__row--stacked--container' },
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--content js-stacked-content' },
															_get__('React').createElement(
																'ul',
																{ className: 'table--detail__row--expanded--list' },
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Status'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Working'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Transaction Time'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'08:09:38.890'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Tag 50'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'45'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'4027'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Open Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'9'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Contract'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CAUM9 C0775'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Session ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'AZT'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'B/S'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BUY'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Account'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'TIF'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Day'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Decimal Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'5330.123456'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Fractional Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Stop Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exchange'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CME'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Sender'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Cancel Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Expired'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Segment ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'56'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Firm ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'004'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Expiry Date'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'2018-10-11'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Reject Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'None'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Data Source'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Globex'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Order key'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'561945654'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exec Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Code'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'1'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Origin'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Comments'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																	)
																)
															)
														),
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--actions' },
															_get__('React').createElement(
																'button',
																{ className: 'btn btn--transparent  js-table-detail-stacked-trigger' },
																_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Working'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'08:09:38.890'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'45'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'BRIO'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Day'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'5330.123456'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-ellipsis-v' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--stacked' },
												_get__('React').createElement(
													'td',
													{ colSpan: '13' },
													_get__('React').createElement(
														'div',
														{ className: 'table--detail__row--stacked--container' },
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--content js-stacked-content' },
															_get__('React').createElement(
																'ul',
																{ className: 'table--detail__row--expanded--list' },
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Status'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Working'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Transaction Time'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'08:09:38.890'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Tag 50'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'45'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'4027'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Open Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'9'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Contract'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CAUM9 C0775'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Session ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'AZT'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'B/S'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BUY'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Account'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'TIF'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Day'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Decimal Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'5330.123456'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Fractional Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Stop Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exchange'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CME'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Sender'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Cancel Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Expired'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Segment ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'56'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Firm ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'004'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Expiry Date'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'2018-10-11'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Reject Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'None'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Data Source'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Globex'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Order key'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'561945654'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exec Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Code'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'1'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Origin'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Comments'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																	)
																)
															)
														),
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--actions' },
															_get__('React').createElement(
																'button',
																{ className: 'btn btn--transparent  js-table-detail-stacked-trigger' },
																_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Working'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'08:09:38.890'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'45'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'BRIO'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Day'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'5330.123456'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-ellipsis-v' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--stacked' },
												_get__('React').createElement(
													'td',
													{ colSpan: '13' },
													_get__('React').createElement(
														'div',
														{ className: 'table--detail__row--stacked--container' },
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--content js-stacked-content' },
															_get__('React').createElement(
																'ul',
																{ className: 'table--detail__row--expanded--list' },
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Status'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Working'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Transaction Time'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'08:09:38.890'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Tag 50'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'45'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'4027'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Open Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'9'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Contract'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CAUM9 C0775'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Session ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'AZT'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'B/S'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BUY'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Account'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'TIF'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Day'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Decimal Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'5330.123456'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Fractional Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Stop Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exchange'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CME'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Sender'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Cancel Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Expired'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Segment ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'56'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Firm ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'004'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Expiry Date'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'2018-10-11'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Reject Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'None'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Data Source'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Globex'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Order key'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'561945654'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exec Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Code'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'1'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Origin'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Comments'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																	)
																)
															)
														),
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--actions' },
															_get__('React').createElement(
																'button',
																{ className: 'btn btn--transparent  js-table-detail-stacked-trigger' },
																_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Working'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'08:09:38.890'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'45'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'BRIO'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Day'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'5330.123456'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--disclose' },
													_get__('React').createElement('i', { className: 'fa fa-ellipsis-v' })
												)
											),
											_get__('React').createElement(
												'tr',
												{ className: 'table--detail__row--stacked' },
												_get__('React').createElement(
													'td',
													{ colSpan: '13' },
													_get__('React').createElement(
														'div',
														{ className: 'table--detail__row--stacked--container' },
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--content js-stacked-content' },
															_get__('React').createElement(
																'ul',
																{ className: 'table--detail__row--expanded--list' },
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Status'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Working'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--md-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Transaction Time'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'08:09:38.890'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Tag 50'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'45'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--xs-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'4027'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Open Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'9'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Contract'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CAUM9 C0775'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--sm-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Session ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'AZT'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'B/S'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BUY'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Account'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'TIF'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Day'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item hide--lg-and-up' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Decimal Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'5330.123456'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Fractional Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Stop Price'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'12345'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exchange'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'CME'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Sender'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'BRIO'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Cancel Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Expired'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Segment ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'56'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Firm ID'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'004'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Expiry Date'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'2018-10-11'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Reject Reason'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'None'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Data Source'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Globex'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Order key'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'561945654'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Exec Qty'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Code'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'1'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'CTI Origin'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'3'
																	)
																),
																_get__('React').createElement(
																	'li',
																	{ className: 'table--detail__row--expanded--list-item' },
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-title' },
																		'Comments'
																	),
																	_get__('React').createElement(
																		'p',
																		{ className: 'table--detail__row--expanded--list-item-value' },
																		'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. '
																	)
																)
															)
														),
														_get__('React').createElement(
															'div',
															{ className: 'table--detail__row--stacked--actions' },
															_get__('React').createElement(
																'button',
																{ className: 'btn btn--transparent  js-table-detail-stacked-trigger' },
																_get__('React').createElement('i', { className: 'fa fa-angle-double-down' })
															)
														)
													)
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														'ACP1529'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'Normal Row'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-md-and-up' },
													'08:09:38.890'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'45'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-and-up' },
													'4027'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'9'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-xs-only table--detail--show-xs-and-up' },
													'CAUM9 C0775'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'AZT'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-sm-and-up' },
													'BUY'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'BRIO'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'Day'
												),
												_get__('React').createElement(
													'td',
													{ className: 'table--detail--show-lg-and-up' },
													'5330.123456'
												),
												_get__('React').createElement('td', { className: 'table--detail--disclose' })
											)
										)
									)
								)
							)
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'In the demo shown here, you can see primary and secondary information is always visible but in a similiar fashion to the other types of detail view, you can specify what columns are visible at certain ',
						_get__('React').createElement(
							'a',
							{ href: '#breakpoints' },
							'breakpoints'
						),
						' using the ',
						_get__('React').createElement(
							'code',
							null,
							'table--detail--show-[\'breakpoint\']'
						),
						' CSS class.'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'select',
						{ className: 'size-select' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Select a resolution'
						),
						_get__('React').createElement(
							'option',
							{ value: '482' },
							'480px (xs)'
						),
						_get__('React').createElement(
							'option',
							{ value: '770' },
							'768px (sm)'
						),
						_get__('React').createElement(
							'option',
							{ value: '994' },
							'992px (md)'
						),
						_get__('React').createElement(
							'option',
							{ value: '1202' },
							'1200px (lg)'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'iframe-container', style: { 'height': '500px' } },
						_get__('React').createElement('iframe', { seamless: true, srcDoc: '\n\t\t\t\t<html class="height--100">\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n\t\t\t\t\t\t<link rel="stylesheet" type="text/css" href="css/commonUI.css">\n\t\t\t\t\t</head>\n\t\t\t\t\t<body class="height--100">\n\t\t\t\t\t\t<div class="table--detail--container">\n\t\t\t\t\t\t\t<div class="grid height--100">\n\t\t\t\t\t\t\t\t<div class="position--relative grid__col-12 height--100">\n\t\t\t\t\t\t\t\t\t<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded--stacked js-table-detail-stacked">\n\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Status</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-md-and-up">Transaction Time</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-and-up">Tag 50</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-and-up">Qty</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Open Qty</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">Session ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-sm-and-up">B/S</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Account</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">TIF</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--show-lg-and-up">Decimal Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--detail--disclose"></th>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Working</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">08:09:38.890</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">45</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">BRIO</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">5330.123456</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose"><i class="fa fa-ellipsis-v"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--container">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--content js-stacked-content">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Working</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">45</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Open Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Contract</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Account</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">TIF</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">5330.123456</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CME</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Sender</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Expired</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Segment ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">56</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">004</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">None</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Data Source</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Globex</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order key</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">561945654</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Code</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">1</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--actions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--transparent  js-table-detail-stacked-trigger">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-angle-double-down"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Working</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">08:09:38.890</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">45</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">BRIO</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">5330.123456</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose"><i class="fa fa-trash-o"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--container">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--content js-stacked-content">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Working</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">45</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Open Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Contract</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Account</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">TIF</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">5330.123456</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CME</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Sender</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Expired</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Segment ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">56</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">004</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">None</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Data Source</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Globex</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order key</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">561945654</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Code</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">1</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--actions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--transparent  js-table-detail-stacked-trigger">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-angle-double-down"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Working</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">08:09:38.890</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">45</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">BRIO</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">5330.123456</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose"><i class="fa fa-ellipsis-v"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--container">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--content js-stacked-content">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Working</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">45</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Open Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Contract</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Account</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">TIF</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">5330.123456</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CME</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Sender</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Expired</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Segment ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">56</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">004</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">None</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Data Source</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Globex</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order key</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">561945654</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Code</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">1</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--actions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--transparent  js-table-detail-stacked-trigger">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-angle-double-down"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Working</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">08:09:38.890</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">45</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">BRIO</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">5330.123456</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose"><i class="fa fa-trash-o"></i></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr class="table--detail__row--stacked">\n\t\t\t\t\t\t\t\t\t\t\t\t<td colSpan="13">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--container">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--content js-stacked-content">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Working</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">45</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Open Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Contract</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Account</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">TIF</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">5330.123456</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CME</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Sender</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Expired</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Segment ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">56</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">004</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">None</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Data Source</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Globex</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order key</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">561945654</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Code</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">1</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table--detail__row--stacked--actions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--transparent  js-table-detail-stacked-trigger">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-angle-double-down"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">Normal Row</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-md-and-up">08:09:38.890</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">45</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">BRIO</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--show-lg-and-up">5330.123456</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td class="table--detail--disclose"></td>\n\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<script type="text/javascript" src="js/commonUI.js"></script>\n\t\t\t\t\t\t<script>\n\t\t\t\t\t\t\tfunction init() {\n\t\t\t\t\t\t\t\tcommonUI.initializeTable({\n\t\t\t\t\t\t\t\t\tselector: \'.js-table-detail-stacked\',\n\t\t\t\t\t\t\t\t\tdetailViewType: \'stackedRow\',\n\t\t\t\t\t\t\t\t\tdetailViewSelector: \'.js-table-detail-stacked-trigger\'\n\t\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\twindow.onload = init;\n\t\t\t\t\t\t</script>\n\t\t\t\t\t</body>\n\t\t\t\t</html>\n\t\t\t' })
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'To enable this functionality, you can instantiate the table like this:'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'commonUI.initializeTable({\n\tselector: \'.js-table-detail-stacked\',\n\tdetailViewType: \'stackedRow\',\n\tdetailViewSelector: \'.js-table-detail-stacked-trigger\'\n});'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--blue table--comfy table--hover table--expanded--striped table--rows table--detail table--detail__expanded--stacked js-table-detail-stacked">\n<thead>\n\t<tr>\n\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Client Order ID</th>\n\t\t<th class="table--detail--show-md-and-up">Status</th>\n\t\t<th class="table--detail--show-md-and-up">Transaction Time</th>\n\t\t<th class="table--detail--show-xs-and-up">Tag 50</th>\n\t\t<th class="table--detail--show-xs-and-up">Qty</th>\n\t\t<th class="table--detail--show-lg-and-up">Open Qty</th>\n\t\t<th class="table--detail--show-xs-only table--detail--show-xs-and-up">Contract</th>\n\t\t<th class="table--detail--show-sm-and-up">Session ID</th>\n\t\t<th class="table--detail--show-sm-and-up">B/S</th>\n\t\t<th class="table--detail--show-lg-and-up">Account</th>\n\t\t<th class="table--detail--show-lg-and-up">TIF</th>\n\t\t<th class="table--detail--show-lg-and-up">Decimal Price</th>\n\t\t<th class="table--detail--disclose"></th>\n\t</tr>\n</thead>\n<tbody>\n\t<tr>\n\t\t<td class="table--detail--inset table--detail--show-xs-only table--detail--show-xs-and-up"><a href="#">ACP1529</a></td>\n\t\t<td class="table--detail--show-md-and-up">Working</td>\n\t\t<td class="table--detail--show-md-and-up">08:09:38.890</td>\n\t\t<td class="table--detail--show-xs-and-up">45</td>\n\t\t<td class="table--detail--show-xs-and-up">4027</td>\n\t\t<td class="table--detail--show-lg-and-up">9</td>\n\t\t<td class="table--detail--show-xs-only table--detail--show-xs-and-up">CAUM9 C0775</td>\n\t\t<td class="table--detail--show-sm-and-up">AZT</td>\n\t\t<td class="table--detail--show-sm-and-up">BUY</td>\n\t\t<td class="table--detail--show-lg-and-up">BRIO</td>\n\t\t<td class="table--detail--show-lg-and-up">Day</td>\n\t\t<td class="table--detail--show-lg-and-up">5330.123456</td>\n\t\t<td class="table--detail--disclose"><i class="fa fa-ellipsis-v"></i></td>\n\t</tr>\n\t<tr class="table--detail__row--stacked">\n\t\t<td colSpan="13">\n\t\t\t<div class="table--detail__row--stacked--container">\n\t\t\t\t<div class="table--detail__row--stacked--content js-stacked-content">\n\t\t\t\t\t<ul class="table--detail__row--expanded--list">\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Status</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Working</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--md-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Transaction Time</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">08:09:38.890</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Tag 50</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">45</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--xs-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Qty</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">4027</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Open Qty</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">9</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Contract</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CAUM9 C0775</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--sm-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Session ID</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">AZT</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">B/S</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BUY</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Account</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">TIF</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Day</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item hide--lg-and-up">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Decimal Price</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">5330.123456</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Fractional Price</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Stop Price</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">12345</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exchange</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">CME</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Sender</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">BRIO</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Cancel Reason</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Expired</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Segment ID</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">56</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Firm ID</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">004</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Expiry Date</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">2018-10-11</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Reject Reason</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">None</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Data Source</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Globex</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Order key</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">561945654</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Exec Qty</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Code</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">1</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">CTI Origin</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">3</p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="table--detail__row--expanded--list-item">\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-title">Comments</p>\n\t\t\t\t\t\t\t<p class="table--detail__row--expanded--list-item-value">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu dui quis ante pulvinar consequat. </p>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<div class="table--detail__row--stacked--actions">\n\t\t\t\t\t<button class="btn btn--transparent  js-table-detail-stacked-trigger">\n\t\t\t\t\t\t<i class="fa fa-angle-double-down"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</td>\n\t</tr>\n\t</tbody>\n</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h4',
						null,
						'Table with Reorder Functionality'
					),
					_get__('React').createElement(
						'p',
						null,
						'To enable the table reorder functionality, add a unique class to the table such as ',
						_get__('React').createElement(
							'code',
							null,
							'js-table-reorder'
						),
						' in addition to a unique overlay class such as ',
						_get__('React').createElement(
							'code',
							null,
							'example-overlay'
						),
						' and a trigger class such as ',
						_get__('React').createElement(
							'code',
							null,
							'trigger-one'
						),
						'. To Disable a row from being reordered, use the helper ',
						_get__('React').createElement(
							'code',
							null,
							'table__heading--disable'
						),
						'. We recommend that you only apply this to the first few columns in the table. This will Automatically disable the button within the reorder overlay. ',
						_get__('React').createElement(
							'code',
							null,
							'table--reorder--show-row'
						),
						' will ensure the button is selected in the overlay when it is opened.'
					),
					_get__('React').createElement(
						'p',
						null,
						'The default columns for the overlay will be set to 2. It is possible to change this to 1 column by adding ',
						_get__('React').createElement(
							'code',
							null,
							'reorder__table--single-col'
						),
						' to the main parent class along side the ',
						_get__('React').createElement(
							'code',
							null,
							'reorder__table'
						),
						' class.'
					),
					_get__('React').createElement(
						'div',
						{ className: 'reorder__table' },
						_get__('React').createElement(
							'button',
							{ className: 'btn btn--link js-table-overlay-trigger' },
							_get__('React').createElement('i', { className: 'fa fa-table' }),
							' Edit Table Order'
						),
						_get__('React').createElement(
							'div',
							{ className: 'reorder__table--container' },
							_get__('React').createElement(
								'table',
								{ className: 'table table--blue table--comfy table--hover table--striped table--responsive js-table-reorder' },
								_get__('React').createElement(
									'thead',
									null,
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ className: 'table__heading--disable table--reorder--show-row' },
											'Client Order ID'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table__heading--disable table--reorder--show-row' },
											'Fill ID'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Status'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row ' },
											'Fill Time'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Tag 50'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Fill Qty'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Contract'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Session ID'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'B/S'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Order Price'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Stop Price'
										),
										_get__('React').createElement(
											'th',
											{ className: 'table--reorder--show-row' },
											'Time In Force'
										)
									)
								),
								_get__('React').createElement(
									'tbody',
									null,
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15299318869'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'8446:M:126561'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Partial Fill'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:04:46.900'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORID123'
										),
										_get__('React').createElement(
											'td',
											null,
											'100'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0775'
										),
										_get__('React').createElement(
											'td',
											null,
											'AZT'
										),
										_get__('React').createElement(
											'td',
											null,
											'BUY'
										),
										_get__('React').createElement(
											'td',
											null,
											'00331'
										),
										_get__('React').createElement(
											'td',
											null,
											'6116'
										),
										_get__('React').createElement(
											'td',
											null,
											'Day'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15524945547'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'80517:M:301326'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Filled'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:05:12.010'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORIDCME2'
										),
										_get__('React').createElement(
											'td',
											null,
											'50'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0860'
										),
										_get__('React').createElement(
											'td',
											null,
											'R89'
										),
										_get__('React').createElement(
											'td',
											null,
											'SELL'
										),
										_get__('React').createElement(
											'td',
											null,
											'00147'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15299318869'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'8446:M:126561'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Partial Fill'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:04:46.900'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORID123'
										),
										_get__('React').createElement(
											'td',
											null,
											'100'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0775'
										),
										_get__('React').createElement(
											'td',
											null,
											'AZT'
										),
										_get__('React').createElement(
											'td',
											null,
											'BUY'
										),
										_get__('React').createElement(
											'td',
											null,
											'00331'
										),
										_get__('React').createElement(
											'td',
											null,
											'6116'
										),
										_get__('React').createElement(
											'td',
											null,
											'Day'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15524945547'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'80517:M:301326'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Filled'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:05:12.010'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORIDCME2'
										),
										_get__('React').createElement(
											'td',
											null,
											'50'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0860'
										),
										_get__('React').createElement(
											'td',
											null,
											'R89'
										),
										_get__('React').createElement(
											'td',
											null,
											'SELL'
										),
										_get__('React').createElement(
											'td',
											null,
											'00147'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15299318869'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'8446:M:126561'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Partial Fill'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:04:46.900'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORID123'
										),
										_get__('React').createElement(
											'td',
											null,
											'100'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0775'
										),
										_get__('React').createElement(
											'td',
											null,
											'AZT'
										),
										_get__('React').createElement(
											'td',
											null,
											'BUY'
										),
										_get__('React').createElement(
											'td',
											null,
											'00331'
										),
										_get__('React').createElement(
											'td',
											null,
											'6116'
										),
										_get__('React').createElement(
											'td',
											null,
											'Day'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15524945547'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'80517:M:301326'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Filled'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:05:12.010'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORIDCME2'
										),
										_get__('React').createElement(
											'td',
											null,
											'50'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0860'
										),
										_get__('React').createElement(
											'td',
											null,
											'R89'
										),
										_get__('React').createElement(
											'td',
											null,
											'SELL'
										),
										_get__('React').createElement(
											'td',
											null,
											'00147'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15299318869'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'8446:M:126561'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Partial Fill'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:04:46.900'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORID123'
										),
										_get__('React').createElement(
											'td',
											null,
											'100'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0775'
										),
										_get__('React').createElement(
											'td',
											null,
											'AZT'
										),
										_get__('React').createElement(
											'td',
											null,
											'BUY'
										),
										_get__('React').createElement(
											'td',
											null,
											'00331'
										),
										_get__('React').createElement(
											'td',
											null,
											'6116'
										),
										_get__('React').createElement(
											'td',
											null,
											'Day'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15524945547'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'80517:M:301326'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Filled'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:05:12.010'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORIDCME2'
										),
										_get__('React').createElement(
											'td',
											null,
											'50'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0860'
										),
										_get__('React').createElement(
											'td',
											null,
											'R89'
										),
										_get__('React').createElement(
											'td',
											null,
											'SELL'
										),
										_get__('React').createElement(
											'td',
											null,
											'00147'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15299318869'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'8446:M:126561'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Partial Fill'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:04:46.900'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORID123'
										),
										_get__('React').createElement(
											'td',
											null,
											'100'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0775'
										),
										_get__('React').createElement(
											'td',
											null,
											'AZT'
										),
										_get__('React').createElement(
											'td',
											null,
											'BUY'
										),
										_get__('React').createElement(
											'td',
											null,
											'00331'
										),
										_get__('React').createElement(
											'td',
											null,
											'6116'
										),
										_get__('React').createElement(
											'td',
											null,
											'Day'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15524945547'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'80517:M:301326'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Filled'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:05:12.010'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORIDCME2'
										),
										_get__('React').createElement(
											'td',
											null,
											'50'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0860'
										),
										_get__('React').createElement(
											'td',
											null,
											'R89'
										),
										_get__('React').createElement(
											'td',
											null,
											'SELL'
										),
										_get__('React').createElement(
											'td',
											null,
											'00147'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15299318869'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'8446:M:126561'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Partial Fill'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:04:46.900'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORID123'
										),
										_get__('React').createElement(
											'td',
											null,
											'100'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0775'
										),
										_get__('React').createElement(
											'td',
											null,
											'AZT'
										),
										_get__('React').createElement(
											'td',
											null,
											'BUY'
										),
										_get__('React').createElement(
											'td',
											null,
											'00331'
										),
										_get__('React').createElement(
											'td',
											null,
											'6116'
										),
										_get__('React').createElement(
											'td',
											null,
											'Day'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15524945547'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'80517:M:301326'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Filled'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:05:12.010'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORIDCME2'
										),
										_get__('React').createElement(
											'td',
											null,
											'50'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0860'
										),
										_get__('React').createElement(
											'td',
											null,
											'R89'
										),
										_get__('React').createElement(
											'td',
											null,
											'SELL'
										),
										_get__('React').createElement(
											'td',
											null,
											'00147'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15299318869'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'8446:M:126561'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Partial Fill'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:04:46.900'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORID123'
										),
										_get__('React').createElement(
											'td',
											null,
											'100'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0775'
										),
										_get__('React').createElement(
											'td',
											null,
											'AZT'
										),
										_get__('React').createElement(
											'td',
											null,
											'BUY'
										),
										_get__('React').createElement(
											'td',
											null,
											'00331'
										),
										_get__('React').createElement(
											'td',
											null,
											'6116'
										),
										_get__('React').createElement(
											'td',
											null,
											'Day'
										)
									),
									_get__('React').createElement(
										'tr',
										null,
										_get__('React').createElement(
											'th',
											{ scope: 'row' },
											_get__('React').createElement(
												'a',
												{ href: '' },
												'ACP15524945547'
											)
										),
										_get__('React').createElement(
											'td',
											null,
											'80517:M:301326'
										),
										_get__('React').createElement(
											'td',
											{ className: 'text--center' },
											'Filled'
										),
										_get__('React').createElement(
											'td',
											null,
											'08:05:12.010'
										),
										_get__('React').createElement(
											'td',
											null,
											'OPERATORIDCME2'
										),
										_get__('React').createElement(
											'td',
											null,
											'50'
										),
										_get__('React').createElement(
											'td',
											null,
											'CAUM9 C0860'
										),
										_get__('React').createElement(
											'td',
											null,
											'R89'
										),
										_get__('React').createElement(
											'td',
											null,
											'SELL'
										),
										_get__('React').createElement(
											'td',
											null,
											'00147'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										),
										_get__('React').createElement(
											'td',
											null,
											'1332'
										)
									)
								)
							),
							_get__('React').createElement(
								'div',
								{ className: 'overlay__table example-overlay' },
								_get__('React').createElement('div', { className: 'overlay__table--left' }),
								_get__('React').createElement(
									'div',
									{ className: 'overlay__table--right table--comfy' },
									_get__('React').createElement(
										'div',
										{ className: 'overlay__table--title' },
										_get__('React').createElement('i', { className: 'fa fa-table', 'aria-hidden': 'true' }),
										'Edit Table Order',
										_get__('React').createElement('i', { className: 'icon-cme-close-circle-o overlay__table--close' })
									),
									_get__('React').createElement(
										'div',
										{ className: 'overlay__table--main' },
										'Customise this table by choosing which columns to display, and in which order',
										_get__('React').createElement(
											'ul',
											{ className: 'overlay__table--options' },
											_get__('React').createElement(
												'li',
												{ className: 'options-group-item' },
												_get__('React').createElement('i', { className: 'fa fa-square-o select-all', 'aria-hidden': 'true' }),
												_get__('React').createElement(
													'label',
													{ className: 'overlay__table--select-all select-all' },
													'Select All'
												)
											),
											_get__('React').createElement(
												'li',
												{ className: 'options-group-item' },
												_get__('React').createElement(
													'button',
													{ className: 'btn btn--link reset-to-default' },
													_get__('React').createElement('i', { className: 'fa fa-repeat' }),
													' Reset to Default'
												)
											)
										)
									),
									_get__('React').createElement(
										'div',
										{ className: 'overlay__table--actions' },
										_get__('React').createElement(
											'button',
											{ className: 'btn btn--secondary overlay__table--cancel' },
											'Cancel'
										),
										_get__('React').createElement(
											'button',
											{ className: 'btn btn--positive apply--reorder trigger-one' },
											_get__('React').createElement('i', { className: 'fa fa-check' }),
											' Apply Changes'
										)
									)
								)
							)
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'In the demo shown here, you can see the ability to still reorder columns at certain ',
						_get__('React').createElement(
							'a',
							{ href: '#breakpoints' },
							'breakpoints'
						),
						'.'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'select',
						{ className: 'size-select' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Select a resolution'
						),
						_get__('React').createElement(
							'option',
							{ value: '482' },
							'480px (xs)'
						),
						_get__('React').createElement(
							'option',
							{ value: '770' },
							'768px (sm)'
						),
						_get__('React').createElement(
							'option',
							{ value: '994' },
							'992px (md)'
						),
						_get__('React').createElement(
							'option',
							{ value: '1202' },
							'1200px (lg)'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'iframe-container', style: { 'height': '500px' } },
						_get__('React').createElement('iframe', { seamless: true, srcDoc: '\n\t\t\t<html class="height--100">\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n\t\t\t\t\t\t<link rel="stylesheet" type="text/css" href="css/commonUI.css">\n\t\t\t\t\t</head>\n\t\t\t\t\t<body class="height--100">\n\t\t\t\t\t\t<div class="table--detail--container">\n\t\t\t\t\t\t\t<div class="grid height--100">\n\t\t\t\t\t\t\t\t<div class="position--relative grid__col-12 height--100">\n\t\t\t\t\t\t\t\t<div class="reorder__table">\n\t\t\t\t\t\t\t\t\t<button class="btn btn--link js-table-overlay-trigger"><i class="fa fa-table"></i> Edit Table Order</button>\n\t\t\t\t\t\t\t\t\t<div class="reorder__table--container">\n\t\t\t\t\t\t\t\t\t\t<table class="table table--blue table--comfy table--hover table--striped table--responsive js-table--responsive js-table-reorder-two table--reorder">\n\t\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table__heading--disable table--reorder--show-row">Client Order ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table__heading--disable table--reorder--show-row">Fill ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Status</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row ">Fill Time</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Tag 50</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Fill Qty</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Contract</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Session ID</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">B/S</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Order Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Stop Price</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th class="table--reorder--show-row">Time In Force</th>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15299318869</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>8446:M:126561</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Partial Fill</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:04:46.900</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORID123</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>100</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00331</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>6116</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15524945547</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>80517:M:301326</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:05:12.010</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORIDCME2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0860</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>R89</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>SELL</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00147</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15299318869</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>8446:M:126561</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Partial Fill</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:04:46.900</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORID123</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>100</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00331</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>6116</td>\n\t\t\t\t\t\t\t\t\t\t\t\t<td>Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15524945547</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>80517:M:301326</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:05:12.010</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORIDCME2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0860</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>R89</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>SELL</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00147</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15299318869</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>8446:M:126561</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Partial Fill</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:04:46.900</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORID123</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>100</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00331</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>6116</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15524945547</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>80517:M:301326</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:05:12.010</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORIDCME2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0860</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>R89</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>SELL</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00147</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15299318869</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>8446:M:126561</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Partial Fill</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:04:46.900</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORID123</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>100</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00331</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>6116</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15524945547</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>80517:M:301326</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:05:12.010</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORIDCME2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0860</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>R89</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>SELL</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00147</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15299318869</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>8446:M:126561</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Partial Fill</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:04:46.900</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORID123</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>100</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00331</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>6116</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15524945547</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>80517:M:301326</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:05:12.010</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORIDCME2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0860</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>R89</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>SELL</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00147</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15299318869</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>8446:M:126561</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Partial Fill</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:04:46.900</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORID123</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>100</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00331</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>6116</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15524945547</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>80517:M:301326</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:05:12.010</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORIDCME2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0860</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>R89</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>SELL</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00147</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15299318869</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>8446:M:126561</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Partial Fill</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:04:46.900</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORID123</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>100</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0775</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>AZT</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>BUY</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00331</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>6116</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>Day</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">ACP15524945547</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>80517:M:301326</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td className="text--center">Filled</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>08:05:12.010</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>OPERATORIDCME2</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>50</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>CAUM9 C0860</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>R89</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>SELL</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>00147</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<td>1332</td>\n\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\t<div class="overlay__table example-overlay-two">\n\t\t\t\t\t\t\t\t\t\t\t<div class="overlay__table--left"></div>\n\t\t\t\t\t\t\t\t\t\t\t<div class="overlay__table--right table--comfy">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="overlay__table--title"><i class="fa fa-table" aria-hidden="true"></i>Edit Table Order<i class="icon-cme-close-circle-o overlay__table--close"></i></div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="overlay__table--main">\n\t\t\t\t\t\t\t\t\t\t\t\t\tCustomise this table by choosing which columns to display, and in which order\n\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="overlay__table--options">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="options-group-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="fa fa-square-o select-all" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="overlay__table--select-all select-all">Select All</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="options-group-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--link reset-to-default"><i class="fa fa-repeat"></i> Reset to Default</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="overlay__table--actions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--secondary overlay__table--cancel">Cancel</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="btn btn--positive apply--reorder trigger-two"><i class="fa fa-check"></i> Apply Changes</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<script type="text/javascript" src="js/commonUI.js"></script>\n\t\t\t\t\t<script>\n\t\t\t\t\t\tfunction init() {\n\t\t\t\t\t\t\tcommonUI.initializeTable({\n\t\t\t\t\t\t\t\tselector: \'.js-table-reorder-two\',\n\t\t\t\t\t\t\t\ttableReorder: \'js-table-reorder-two\',\n\t\t\t\t\t\t\t\toverlayElement: \'.example-overlay-two\',\n\t\t\t\t\t\t\t\ttrigger: \'trigger-two\',\n\t\t\t\t\t\t\t});\n\t\t\t\t\t\t\tcommonUI.initializeButtonGroup();\n\t\t\t\t\t\t\tvar tableReorderExample = document.getElementsByClassName(\'js-table-reorder-two\')[0];\n\t\t\t\t\t\t\ttableReorderExample.addEventListener(\'apply.commonui.reorderTable\', function(event) {\n\t\t\t\t\t\t\t\tconsole.log(\'Saved Table: \', event.detail);\n\t\t\t\t\t\t\t});\n\t\t\t\t\t\t}\n\t\t\t\t\t\twindow.onload = init;\n\t\t\t\t\t</script>\n\t\t\t\t</body>\n\t\t\t</html>' })
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'\n<div class="reorder__table">\n\t<button class="btn btn--link js-table-overlay-trigger"><i class="fa fa-table"></i> Edit Table Order</button>\n\t<div class="reorder__table--container">\n\t\t<table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive js-table-reorder table--reorder">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th class="table__heading--disable table--reorder--show-row">Lorem</th>\n\t\t\t\t\t<th class="table__heading--disable table--reorder--show-row">Ipsum</th>\n\t\t\t\t\t<th class="table--reorder--show-row">Dolor</th>\n\t\t\t\t\t<th class="table--reorder--show-row ">Sit</th>\n\t\t\t\t\t<th class="table--reorder--show-row">Amet</th>\n\t\t\t\t\t<th class="table--reorder--show-row">Consectetur</th>\n\t\t\t\t\t<th class="table--reorder--show-row">Afdipisicing</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">03.788</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">32.210</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">47.797</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">09.640</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t<th scope="row">\n\t\t\t\t\t\t<a href="">Sit</a>\n\t\t\t\t\t</th>\n\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t<td class="text--center">12.117</td>\n\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t<td>Amet</td>\n\t\t\t\t\t<td>Consectetur</td>\n\t\t\t\t\t<td>Afdipisicing</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t\t<div class="overlay__table example-overlay">\n\t\t\t<div class="overlay__table--left"></div>\n\t\t\t<div class="overlay__table--right table--comfy">\n\t\t\t\t<div class="overlay__table--title"><i class="fa fa-table" aria-hidden="true"></i>Edit Table Order<i class="icon-cme-close-circle-o overlay__table--close"></i></div>\n\t\t\t\t<div class="overlay__table--main">\n\t\t\t\t\tCustomise this table by choosing which columns to display, and in which order\n\t\t\t\t\t<ul class="overlay__table--options">\n\t\t\t\t\t\t<li class="options-group-item">\n\t\t\t\t\t\t\t<i class="fa fa-square-o select-all" aria-hidden="true"></i>\n\t\t\t\t\t\t\t<label class="overlay__table--select-all select-all">Select All</label>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="options-group-item">\n\t\t\t\t\t\t\t<button class="btn btn--link reset-to-default"><i class="fa fa-repeat"></i>Reset to Default</button>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t\t<div class="overlay__table--actions">\n\t\t\t\t\t<button class="btn btn--secondary overlay__table--cancel">Cancel</button>\n\t\t\t\t\t<button class="btn btn--positive apply--reorder trigger-one"><i class="fa fa-check"></i> Apply Changes</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>'
						)
					),
					_get__('React').createElement(
						'p',
						null,
						'To enable this functionality, you can instantiate the table like this:'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'commonUI.initializeTable({\n\tselector: \'.js-table-reorder\',\n\ttableReorder: \'js-table-reorder\',\n\toverlayElement: \'.example-overlay\',\n\ttrigger: \'trigger-one\',\n});'
						)
					),
					_get__('React').createElement(
						'p',
						null,
						'Subscribe to the apply event where you can get the saved table as below:'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'let tableReorderExample = document.getElementsByClassName(\'js-table-reorder\')[0];\ntableReorderExample.addEventListener(\'apply.commonui.reorderTable\', function(event) {\n\tconsole.log(\'Saved Table: \', event.detail);\n});'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Hit/Lift indicators'
					),
					_get__('React').createElement(
						'p',
						{ className: 'callout' },
						_get__('React').createElement(
							'strong',
							null,
							'Note:'
						),
						' Hit/Lift indicators are a new component. If you are going to use these styles in an app please notify the CommonUI team. This will aid us in monitoring usage, getting feedback, and notifying the correct teams of any changes.'
					),
					_get__('React').createElement(
						'p',
						null,
						'Used to indicate the ability to rapidly respond to a price displayed on our trading interfaces. A buy or a sell will be triggered by clicking on one of these table cells.'
					),
					_get__('React').createElement(
						'select',
						{ className: 'size-select' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Select a resolution'
						),
						_get__('React').createElement(
							'option',
							{ value: '482' },
							'480px (xs)'
						),
						_get__('React').createElement(
							'option',
							{ value: '770' },
							'768px (sm)'
						),
						_get__('React').createElement(
							'option',
							{ value: '994' },
							'992px (md)'
						),
						_get__('React').createElement(
							'option',
							{ value: '1202' },
							'1200px (lg)'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'iframe-container', style: { 'height': '100px' } },
						_get__('React').createElement('iframe', { seamless: true, srcDoc: '\n\t\t\t\t<html>\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<link rel="stylesheet" type="text/css" href="css/commonUI.css">\n\t\t\t\t\t</head>\n\t\t\t\t\t<body class="soft">\n\t\t\t\t\t\t<table style="width: auto;" class="table table--cells table--comfy">\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td tabindex="0" aria-label="Hit" class="hit-lift hit-lift--hit">0.0281923</td>\n\t\t\t\t\t\t\t    <td tabindex="0" aria-label="Lift" class="hit-lift hit-lift--lift">0.0281923</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</body>\n\t\t\t\t</html>\n\t\t\t' })
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'\n<table class="table table--cells table--comfy">\n\t<tbody>\n\t\t<tr>\n\t\t\t<td tabindex="0" aria-label="Hit" class="hit-lift hit-lift--hit">0.0281923</td>\n\t\t\t<td tabindex="0" aria-label="Lift" class="hit-lift hit-lift--lift">0.0281923</td>\n\t\t</tr>\n\t</tbody>\n</table>\n\t\t'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h3',
						null,
						'Inline Alerts'
					),
					_get__('React').createElement(
						'p',
						null,
						'The inline alert can be used to overlay a table row to feedback to user any information related to the row. For long running pending transactions, you can allow the user to close out the alert and reduce the overlay to a single cell. This cell will be the index of the cell on the row you wish to target, you can pass this in as a ',
						_get__('React').createElement(
							'code',
							null,
							'minimisedCellIndex'
						),
						' property.'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'commonUI.initializeAlert({\n\tselector: \'.js-inline-alert\',\n\tcloseSelector: \'.js-inline-alert__close\',\n\tautoCloseTime: null,\n\tinline: true,\n\tminimisedCellIndex: 2\n});\n'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'Use the following to initialise the pending inline alert: '
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'commonUI.initializeAlert({\n\tselector: \'.js-inline-alert-pending\',\n\tcloseSelector: \'.js-inline-alert__close\',\n\tautoCloseTime: null,\n\tinline: true,\n\tminimisedCellIndex: 2\n});\n'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'table',
						{ className: 'table table--blue table--comfy table--cells table--hover table--striped table--alert' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'th',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'th',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'th',
									null,
									'Sit'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									{ className: 'table--alert__overlay alert' },
									'EOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									{ className: 'table--alert__overlay table--alert__overlay--warning alert alert--warning' },
									_get__('React').createElement(
										'div',
										{ className: 'alert__icon alert__icon--block' },
										_get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--medium', 'aria-hidden': 'true' })
									),
									_get__('React').createElement(
										'div',
										{ className: 'alert__heading' },
										'EOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.'
									)
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									{ className: 'table--alert__overlay table--alert__overlay--success alert alert--success alert--minimal alert--outline hard' },
									_get__('React').createElement(
										'div',
										{ className: 'alert__icon' },
										_get__('React').createElement('i', { className: 'fa fa-check icon--medium', 'aria-hidden': 'true' })
									),
									_get__('React').createElement(
										'div',
										{ className: 'alert__message' },
										'PCS Entry successfully submitted'
									)
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									{ className: 'table--alert__overlay table--alert__overlay--error alert alert--error alert--minimal alert--outline hard' },
									_get__('React').createElement(
										'div',
										{ className: 'alert__icon' },
										_get__('React').createElement('i', { className: 'fa fa-ban icon--medium', 'aria-hidden': 'true' })
									),
									_get__('React').createElement(
										'div',
										{ className: 'alert__message' },
										'PCS Entry failed'
									)
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								)
							),
							_get__('React').createElement(
								'tr',
								{ className: 'js-inline-alert' },
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									{ className: 'table--alert__overlay table--alert__overlay--warning table--alert__overlay alert alert--warning js-alert-overlay' },
									_get__('React').createElement(
										'div',
										{ className: 'alert__icon alert__icon--block' },
										_get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--medium', 'aria-hidden': 'true' })
									),
									_get__('React').createElement(
										'div',
										{ className: 'alert__heading' },
										'Dismissable Info inline alert'
									),
									_get__('React').createElement(
										'button',
										{ className: 'alert__close btn btn--transparent js-inline-alert__close hard push-half', 'aria-label': 'close' },
										_get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
									)
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								)
							),
							_get__('React').createElement(
								'tr',
								{ className: 'js-inline-alert-pending' },
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								),
								_get__('React').createElement(
									'td',
									{ className: 'table--alert__overlay table--alert__overlay--pending table--alert__overlay alert alert--pending js-alert-overlay js-pending-alert' },
									_get__('React').createElement(
										'div',
										{ className: 'alert__icon alert__icon--block' },
										_get__('React').createElement(
											'div',
											{ className: 'loader-overlay' },
											_get__('React').createElement(
												'div',
												{ className: 'loader-wrapper' },
												_get__('React').createElement('div', { className: 'loader' })
											)
										)
									),
									_get__('React').createElement(
										'div',
										{ className: 'alert__heading' },
										'Your PCS entry has been submitted. Pending confirmation.'
									),
									_get__('React').createElement(
										'button',
										{ className: 'alert__close btn btn--transparent js-inline-alert__close hard push-half', 'aria-label': 'close' },
										_get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
									)
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									null,
									'Lorem'
								),
								_get__('React').createElement(
									'td',
									null,
									'Ipsum'
								),
								_get__('React').createElement(
									'td',
									null,
									'Dolor'
								),
								_get__('React').createElement(
									'td',
									null,
									'Sit'
								)
							)
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'The responsive treatment for this will take the form of the split table, and the alert(s) will scroll with the right table. '
					),
					_get__('React').createElement(
						'select',
						{ className: 'size-select' },
						_get__('React').createElement(
							'option',
							{ value: '' },
							'Select a resolution'
						),
						_get__('React').createElement(
							'option',
							{ value: '482' },
							'480px (xs)'
						),
						_get__('React').createElement(
							'option',
							{ value: '770' },
							'768px (sm)'
						),
						_get__('React').createElement(
							'option',
							{ value: '994' },
							'992px (md)'
						),
						_get__('React').createElement(
							'option',
							{ value: '1202' },
							'1200px (lg)'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'iframe-container', style: { 'height': '400px' } },
						_get__('React').createElement('iframe', { seamless: true, srcDoc: '\n\t\t\t\t<html>\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n\t\t\t\t\t\t<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n\t\t\t\t\t\t<link rel="stylesheet" type="text/css" href="css/commonUI.css">\n\t\t\t\t\t</head>\n\t\t\t\t\t<body>\n\t\t\t\t\t<table class="table table--blue table--comfy table--cells table--hover table--striped table--alert table--responsive js-table--responsive">\n\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<th>Lorem</th>\n\t\t\t\t\t\t\t\t<th>Ipsum</th>\n\t\t\t\t\t\t\t\t<th>Dolor</th>\n\t\t\t\t\t\t\t\t<th>Sit</th>\n\t\t\t\t\t\t\t\t<th>Lorem</th>\n\t\t\t\t\t\t\t\t<th>Ipsum</th>\n\t\t\t\t\t\t\t\t<th>Dolor</th>\n\t\t\t\t\t\t\t\t<th>Sit</th>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr class="js-inline-alert">\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td class="table--alert__overlay table--alert__overlay--pending table--alert__overlay alert alert--pending js-alert-overlay js-pending-alert">\n\t\t\t\t\t\t\t\t\t<div class="alert__icon alert__icon--block">\n\t\t\t\t\t\t\t\t\t\t<div class="loader-overlay">\n\t\t\t\t\t\t\t\t\t\t\t<div class="loader-wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="loader"></div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class="alert__heading">\n\t\t\t\t\t\t\t\t\t\tYour PCS entry has been submitted. Pending confirmation.\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<button class="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">\n\t\t\t\t\t\t\t\t\t\t<i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t\t<td>Lorem</td>\n\t\t\t\t\t\t\t\t<td>Ipsum</td>\n\t\t\t\t\t\t\t\t<td>Dolor</td>\n\t\t\t\t\t\t\t\t<td>Sit</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t\t</body>\n\t\t\t\t\t<script type="text/javascript" src="js/commonUI.js"></script>\n\t\t\t\t\t<script>\n\t\t\t\t\t\tfunction init() {\n\t\t\t\t\t\t\tcommonUI.initializeTable();\n\t\t\t\t\t\t\tcommonUI.initializeAlert({\n\t\t\t\t\t\t\t\tselector: \'.js-inline-alert\',\n\t\t\t\t\t\t\t\tcloseSelector: \'.js-inline-alert__close\',\n\t\t\t\t\t\t\t\tautoCloseTime: null,\n\t\t\t\t\t\t\t\tinline: true,\n\t\t\t\t\t\t\t\tminimisedCellIndex: 4\n\t\t\t\t\t\t\t});\n\t\t\t\t\t\t}\n\t\t\t\t\t\twindow.onload = init;\n\t\t\t\t\t</script>\n\t\t\t\t</html>\n\t\t\t' })
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'The inline alerts also inherit events or classes from normal alerts - you can refer to the documentation for those, ',
						_get__('React').createElement(
							'a',
							{ href: '#alerts' },
							'here'
						),
						'. You can also use the Common UI ',
						_get__('React').createElement(
							'a',
							{ href: '#helpers' },
							'helpers'
						),
						' to show and hide the inline alert.'
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--blue table--comfy table--cells table--hover table--striped table--alert">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>Lorem</th>\n\t\t\t<th>Ipsum</th>\n\t\t\t<th>Dolor</th>\n\t\t\t<th>Sit</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td class="table--alert__overlay alert">EOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td class="table--alert__overlay table--alert__overlay--warning alert alert--warning">\n\t\t\t\t<div class="alert__icon alert__icon--block">\n\t\t\t\t\t<i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="alert__heading">\n\t\t\t\t\tEOD cycle is currently running. Your value was not entered. You can submit PCS when the cycle has run.\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td class="table--alert__overlay table--alert__overlay--success alert alert--success alert--minimal alert--outline hard">\n\t\t\t\t<div class="alert__icon">\n\t\t\t\t\t<i class="fa fa-check icon--medium" aria-hidden="true"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="alert__message">\n\t\t\t\t\tPCS Entry successfully submitted\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td class="table--alert__overlay table--alert__overlay--error alert alert--error alert--minimal alert--outline hard">\n\t\t\t\t<div class="alert__icon">\n\t\t\t\t\t<i class="fa fa-ban icon--medium" aria-hidden="true"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="alert__message">\n\t\t\t\t\tPCS Entry failed\n\t\t\t\t</div>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t</tr>\n\t\t<tr class="js-inline-alert is-closeable">\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td class="table--alert__overlay table--alert__overlay--warning table--alert__overlay alert alert--warning js-alert-overlay">\n\t\t\t\t<div class="alert__icon alert__icon--block">\n\t\t\t\t\t<i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="alert__heading">\n\t\t\t\t\tDismissable Info inline alert\n\t\t\t\t</div>\n\t\t\t\t<button class="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">\n\t\t\t\t\t<i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n\t\t\t\t</button>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t</tr>\n\t\t<tr class="js-inline-alert-pending is-closeable">\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t\t<td class="table--alert__overlay table--alert__overlay--pending table--alert__overlay alert alert--pending js-alert-overlay js-pending-alert">\n\t\t\t\t<div class="alert__icon alert__icon--block">\n\t\t\t\t\t<div class="loader-overlay">\n\t\t\t\t\t\t<div class="loader-wrapper">\n\t\t\t\t\t\t\t<div class="loader"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="alert__heading">\n\t\t\t\t\tYour PCS entry has been submitted. Pending confirmation.\n\t\t\t\t</div>\n\t\t\t\t<button class="alert__close btn btn--transparent js-inline-alert__close hard push-half" aria-label="close">\n\t\t\t\t\t<i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n\t\t\t\t</button>\n\t\t\t</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td>Lorem</td>\n\t\t\t<td>Ipsum</td>\n\t\t\t<td>Dolor</td>\n\t\t\t<td>Sit</td>\n\t\t</tr>\n\t</tbody>\n</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'h4',
						null,
						'Inline Editing'
					),
					_get__('React').createElement(
						'p',
						null,
						'The inline editing can be used within a table cell to edit the data that currently resides withing that row.'
					),
					_get__('React').createElement(
						'p',
						null,
						'To enable the Inline Editing functionality add the ',
						_get__('React').createElement(
							'code',
							null,
							'inline--edit'
						),
						' class to the cells or link that require the edit.'
					),
					_get__('React').createElement(
						'p',
						null,
						'To enable the required field validation, add the ',
						_get__('React').createElement(
							'code',
							null,
							'required'
						),
						' class to the cells or link that are required.'
					),
					_get__('React').createElement(
						'p',
						null,
						'If the table has not already been initialised, initialise it with a special class:'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-javascript' },
							'commonUI.initializeTable({\n  selector: \'.edit-table\'\n});'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'div',
						{ className: 'scroll-container-x' },
						_get__('React').createElement(
							'table',
							{ className: 'table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit' },
							_get__('React').createElement(
								'thead',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'th',
										null,
										'Product'
									),
									_get__('React').createElement(
										'th',
										null,
										'Code'
									),
									_get__('React').createElement(
										'th',
										null,
										'Last'
									),
									_get__('React').createElement(
										'th',
										null,
										'Change'
									),
									_get__('React').createElement(
										'th',
										null,
										'Chart'
									),
									_get__('React').createElement(
										'th',
										null,
										'Open'
									),
									_get__('React').createElement(
										'th',
										null,
										'High'
									),
									_get__('React').createElement(
										'th',
										null,
										'Low'
									),
									_get__('React').createElement(
										'th',
										null,
										'Globex Vol'
									)
								)
							),
							_get__('React').createElement(
								'tbody',
								null,
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										{ className: 'inline--edit-border' },
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Corn Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center inline--edit required' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'369\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'367\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'68,284'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center inline--edit required' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'1036\'4'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'+1\'0'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'1037\'2'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right inline--edit' },
										'48,346'
									)
								),
								_get__('React').createElement(
									'tr',
									null,
									_get__('React').createElement(
										'td',
										null,
										_get__('React').createElement(
											'a',
											{ className: 'weight--bold', href: '#' },
											'Soybean Oil Futures'
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										'ZCH7'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.29'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'+0.02'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--center' },
										_get__('React').createElement(
											'a',
											{ href: '#' },
											_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
										)
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'34.31'
									),
									_get__('React').createElement(
										'td',
										{ className: 'text--right' },
										'23,054'
									)
								)
							)
						)
					),
					_get__('React').createElement('hr', null),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit">\n\t<thead>\n\t\t<tr>\n\t\t\t<th>Product</th>\n\t\t\t<th>Code</th>\n\t\t\t<th>Last</th>\n\t\t\t<th>Change</th>\n\t\t\t<th>Chart</th>\n\t\t\t<th>Open</th>\n\t\t\t<th>High</th>\n\t\t\t<th>Low</th>\n\t\t\t<th>Globex Vol</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr>\n\t\t\t<td class="inline--edit-border"><a class="weight--bold" href="#">Corn Futures</a></td>\n\t\t\t<td class="text--center inline--edit required">ZCH7</td>\n\t\t\t<td class="text--right inline--edit">369\'0</td>\n\t\t\t<td class="text--right inline--edit">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right inline--edit">367\'4</td>\n\t\t\t<td class="text--right inline--edit">367\'4</td>\n\t\t\t<td class="text--right inline--edit">367\'4</td>\n\t\t\t<td class="text--right inline--edit">68,284</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td><a class="weight--bold" href="#">Soybean Futures</a></td>\n\t\t\t<td class="text--center inline--edit required">ZCH7</td>\n\t\t\t<td class="text--right inline--edit">1036\'4</td>\n\t\t\t<td class="text--right inline--edit">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right inline--edit">1037\'2</td>\n\t\t\t<td class="text--right inline--edit">1037\'2</td>\n\t\t\t<td class="text--right inline--edit">1037\'2</td>\n\t\t\t<td class="text--right inline--edit">48,346</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td><a class="weight--bold" href="#">Soybean Oil Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">34.29</td>\n\t\t\t<td class="text--right">+0.02</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">23,054</td>\n\t\t</tr>\n\t</tbody>\n</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'To enable the a border on the link inline edit, add the ',
						_get__('React').createElement(
							'code',
							null,
							'inline--edit-border'
						),
						' class to the cells that require the border.'
					),
					_get__('React').createElement(
						'p',
						null,
						'To set the width of the inline edit cell apply ',
						_get__('React').createElement(
							'code',
							null,
							'inline--edit-width'
						),
						'. Add the following CSS using your own set width.'
					),
					_get__('React').createElement(
						'pre',
						null,
						_get__('React').createElement(
							'code',
							{ className: 'language-css' },
							'.inline--edit-width {\n  width: INSERT-WIDTH-HERE;\n}'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'table',
						{ className: 'table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit' },
						_get__('React').createElement(
							'thead',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'th',
									{ className: 'inline--edit-width' },
									'Product'
								),
								_get__('React').createElement(
									'th',
									null,
									'Code'
								),
								_get__('React').createElement(
									'th',
									null,
									'Last'
								),
								_get__('React').createElement(
									'th',
									null,
									'Change'
								),
								_get__('React').createElement(
									'th',
									null,
									'Chart'
								),
								_get__('React').createElement(
									'th',
									null,
									'Open'
								),
								_get__('React').createElement(
									'th',
									null,
									'High'
								),
								_get__('React').createElement(
									'th',
									null,
									'Low'
								),
								_get__('React').createElement(
									'th',
									null,
									'Globex Vol'
								)
							)
						),
						_get__('React').createElement(
							'tbody',
							null,
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									{ className: 'inline--edit-border inline--edit-width' },
									_get__('React').createElement(
										'a',
										{ className: 'weight--bold inline--edit required', href: '#' },
										'Corn Futures'
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'ZCH7'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'369\'0'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'+1\'0'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									_get__('React').createElement(
										'a',
										{ href: '#' },
										_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'367\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'367\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'367\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'68,284'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									{ className: 'inline--edit-width' },
									_get__('React').createElement(
										'a',
										{ className: 'weight--bold inline--edit', href: '#' },
										'Soybean Futures'
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'ZCH7'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1036\'4'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'+1\'0'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									_get__('React').createElement(
										'a',
										{ href: '#' },
										_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1037\'2'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1037\'2'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'1037\'2'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'48,346'
								)
							),
							_get__('React').createElement(
								'tr',
								null,
								_get__('React').createElement(
									'td',
									{ className: 'inline--edit-width' },
									_get__('React').createElement(
										'a',
										{ className: 'weight--bold', href: '#' },
										'Soybean Oil Futures'
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									'ZCH7'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.29'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'+0.02'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--center' },
									_get__('React').createElement(
										'a',
										{ href: '#' },
										_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
									)
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.31'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.31'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'34.31'
								),
								_get__('React').createElement(
									'td',
									{ className: 'text--right' },
									'23,054'
								)
							)
						)
					),
					_get__('React').createElement('hr', null),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<table class="table table--blue table--comfy table--rows table--hover table--striped text-scale-xs flush--bottom table--responsive js-table--responsive table--inline-edit">\n\t<thead>\n\t\t<tr>\n\t\t\t<th class="inline--edit-width">Product</th>\n\t\t\t<th>Code</th>\n\t\t\t<th>Last</th>\n\t\t\t<th>Change</th>\n\t\t\t<th>Chart</th>\n\t\t\t<th>Open</th>\n\t\t\t<th>High</th>\n\t\t\t<th>Low</th>\n\t\t\t<th>Globex Vol</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t<tr>\n\t\t\t<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required" href="#">Corn Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">369\'0</td>\n\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">367\'4</td>\n\t\t\t<td class="text--right">68,284</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">1036\'4</td>\n\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t<td class="text--right">48,346</td>\n\t\t</tr>\n\t\t<tr>\n\t\t\t<td class="inline--edit-width"><a class="weight--bold" href="#">Soybean Oil Futures</a></td>\n\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t<td class="text--right">34.29</td>\n\t\t\t<td class="text--right">+0.02</td>\n\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">34.31</td>\n\t\t\t<td class="text--right">23,054</td>\n\t\t</tr>\n\t</tbody>\n</table>'
						)
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'p',
						null,
						'Below is an example of inline edit working in Cards: '
					),
					_get__('React').createElement(
						'div',
						{ className: 'grid' },
						_get__('React').createElement(
							'div',
							{ className: 'grid__col-xlg-4 grid__col-lg-4 grid__col-md-6 grid__col-sm-12' },
							_get__('React').createElement(
								'div',
								{ className: 'card' },
								_get__('React').createElement(
									'div',
									{ className: 'scroll-container-x' },
									_get__('React').createElement(
										'table',
										{ className: 'table table--comfy table--hover table--striped table--blue table--inline-edit sample-edit' },
										_get__('React').createElement(
											'thead',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort' },
														'Product'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort' },
														'Code'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Last'
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort table-sort--asc' },
														'Change'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Chart'
												),
												_get__('React').createElement(
													'th',
													null,
													'Open'
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort table-sort--desc' },
														'High'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Low'
												),
												_get__('React').createElement(
													'th',
													null,
													'Globex Vol'
												)
											)
										),
										_get__('React').createElement(
											'tbody',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'inline--edit-border inline--edit-width' },
													_get__('React').createElement(
														'a',
														{ className: 'weight--bold inline--edit',
															href: '#' },
														'Corn Futures'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center inline--edit' },
													'ZCH7'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'369\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'+1\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'68,284'
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'inline--edit-width' },
													_get__('React').createElement(
														'a',
														{ className: 'weight--bold inline--edit', href: '#' },
														'Soybean Futures'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center inline--edit' },
													'ZCH7'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1036\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'+1\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'48,346'
												)
											)
										)
									)
								)
							)
						),
						_get__('React').createElement(
							'div',
							{ className: 'grid__col-xlg-4 grid__col-lg-4 grid__col-md-6 grid__col-sm-12' },
							_get__('React').createElement(
								'div',
								{ className: 'card' },
								_get__('React').createElement(
									'div',
									{ className: 'scroll-container-x' },
									_get__('React').createElement(
										'table',
										{ className: 'table table--comfy table--hover table--striped table--blue table--inline-edit sample-edit' },
										_get__('React').createElement(
											'thead',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort' },
														'Product'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort' },
														'Code'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Last'
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort table-sort--asc' },
														'Change'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Chart'
												),
												_get__('React').createElement(
													'th',
													null,
													'Open'
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort table-sort--desc' },
														'High'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Low'
												),
												_get__('React').createElement(
													'th',
													null,
													'Globex Vol'
												)
											)
										),
										_get__('React').createElement(
											'tbody',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'inline--edit-border inline--edit-width' },
													_get__('React').createElement(
														'a',
														{ className: 'weight--bold inline--edit',
															href: '#' },
														'Corn Futures'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center inline--edit' },
													'ZCH7'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'369\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'+1\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'68,284'
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'inline--edit-width' },
													_get__('React').createElement(
														'a',
														{ className: 'weight--bold inline--edit', href: '#' },
														'Soybean Futures'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center inline--edit' },
													'ZCH7'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1036\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'+1\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'48,346'
												)
											)
										)
									)
								)
							)
						),
						_get__('React').createElement(
							'div',
							{ className: 'grid__col-xlg-4 grid__col-lg-4 grid__col-md-6 grid__col-sm-12' },
							_get__('React').createElement(
								'div',
								{ className: 'card' },
								_get__('React').createElement(
									'div',
									{ className: 'scroll-container-x' },
									_get__('React').createElement(
										'table',
										{ className: 'table table--comfy table--hover table--striped table--blue table--inline-edit sample-edit' },
										_get__('React').createElement(
											'thead',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort' },
														'Product'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort' },
														'Code'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Last'
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort table-sort--asc' },
														'Change'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Chart'
												),
												_get__('React').createElement(
													'th',
													null,
													'Open'
												),
												_get__('React').createElement(
													'th',
													null,
													_get__('React').createElement(
														'button',
														{ type: 'button', className: 'table-sort table-sort--desc' },
														'High'
													)
												),
												_get__('React').createElement(
													'th',
													null,
													'Low'
												),
												_get__('React').createElement(
													'th',
													null,
													'Globex Vol'
												)
											)
										),
										_get__('React').createElement(
											'tbody',
											null,
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'inline--edit-border inline--edit-width' },
													_get__('React').createElement(
														'a',
														{ className: 'weight--bold inline--edit',
															href: '#' },
														'Corn Futures'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center inline--edit' },
													'ZCH7'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'369\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'+1\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'367\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'68,284'
												)
											),
											_get__('React').createElement(
												'tr',
												null,
												_get__('React').createElement(
													'td',
													{ className: 'inline--edit-width' },
													_get__('React').createElement(
														'a',
														{ className: 'weight--bold inline--edit', href: '#' },
														'Soybean Futures'
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center inline--edit' },
													'ZCH7'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1036\'4'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'+1\'0'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--center' },
													_get__('React').createElement(
														'a',
														{ href: '#' },
														_get__('React').createElement('i', { className: 'fa fa-bar-chart' })
													)
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'1037\'2'
												),
												_get__('React').createElement(
													'td',
													{ className: 'text--right inline--edit' },
													'48,346'
												)
											)
										)
									)
								)
							)
						)
					),
					_get__('React').createElement(
						'button',
						{ type: 'button', className: 'btn btn--secondary show-code' },
						_get__('React').createElement('i', { className: 'fa fa-plus' }),
						'View source'
					),
					_get__('React').createElement('br', null),
					_get__('React').createElement('br', null),
					_get__('React').createElement(
						'pre',
						{ className: 'hide-code' },
						_get__('React').createElement(
							'code',
							{ className: 'language-html' },
							'<div class="grid">\n\t<div class="grid__col-xlg-3 grid__col-lg-3 grid__col-md-3 grid__col-sm-12">\n\t\t<div class="card">\n\t\t\t<div class="scroll-container-x">\n\t\t\t\t<table class="table table--comfy table--hover table--striped table--blue table--inline-edit">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort">Product</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort">Code</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Last</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort table-sort--asc">Change</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Chart</th>\n\t\t\t\t\t\t\t<th>Open</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort table-sort--desc">High</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Low</th>\n\t\t\t\t\t\t\t<th>Globex Vol</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required"\n\t\t\t\t\t\t\t\t\thref="#">Corn Futures</a></td>\n\t\t\t\t\t\t\t<td class="text--center inline--edit">ZCH7</td>\n\t\t\t\t\t\t\t<td class="text--right inline--edit">369\'0</td>\n\t\t\t\t\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t\t\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">68,284</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean\n\t\t\t\t\t\t\t\t\tFutures</a></td>\n\t\t\t\t\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t\t\t\t\t<td class="text--right">1036\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t\t\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">48,346</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="grid__col-xlg-3 grid__col-lg-3 grid__col-md-3 grid__col-sm-12">\n\t\t<div class="card">\n\t\t\t<div class="scroll-container-x">\n\t\t\t\t<table class="table table--comfy table--hover table--striped table--blue table--inline-edit">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort">Product</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort">Code</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Last</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort table-sort--asc">Change</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Chart</th>\n\t\t\t\t\t\t\t<th>Open</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort table-sort--desc">High</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Low</th>\n\t\t\t\t\t\t\t<th>Globex Vol</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required"\n\t\t\t\t\t\t\t\t\thref="#">Corn Futures</a></td>\n\t\t\t\t\t\t\t<td class="text--center inline--edit">ZCH7</td>\n\t\t\t\t\t\t\t<td class="text--right inline--edit">369\'0</td>\n\t\t\t\t\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t\t\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">68,284</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean\n\t\t\t\t\t\t\t\t\tFutures</a></td>\n\t\t\t\t\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t\t\t\t\t<td class="text--right">1036\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t\t\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">48,346</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class="grid__col-xlg-3 grid__col-lg-3 grid__col-md-3 grid__col-sm-12">\n\t\t<div class="card">\n\t\t\t<div class="scroll-container-x">\n\t\t\t\t<table class="table table--comfy table--hover table--striped table--blue table--inline-edit">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort">Product</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort">Code</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Last</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort table-sort--asc">Change</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Chart</th>\n\t\t\t\t\t\t\t<th>Open</th>\n\t\t\t\t\t\t\t<th>\n\t\t\t\t\t\t\t\t<button type="button" class="table-sort table-sort--desc">High</button>\n\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t<th>Low</th>\n\t\t\t\t\t\t\t<th>Globex Vol</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td class="inline--edit-border inline--edit-width"><a class="weight--bold inline--edit required"\n\t\t\t\t\t\t\t\t\thref="#">Corn Futures</a></td>\n\t\t\t\t\t\t\t<td class="text--center inline--edit">ZCH7</td>\n\t\t\t\t\t\t\t<td class="text--right inline--edit">369\'0</td>\n\t\t\t\t\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t\t\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">367\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">68,284</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td class="inline--edit-width"><a class="weight--bold inline--edit" href="#">Soybean\n\t\t\t\t\t\t\t\t\tFutures</a></td>\n\t\t\t\t\t\t\t<td class="text--center">ZCH7</td>\n\t\t\t\t\t\t\t<td class="text--right">1036\'4</td>\n\t\t\t\t\t\t\t<td class="text--right">+1\'0</td>\n\t\t\t\t\t\t\t<td class="text--center"><a href="#"><i class="fa fa-bar-chart"></i></a></td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">1037\'2</td>\n\t\t\t\t\t\t\t<td class="text--right">48,346</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>'
						)
					),
					_get__('React').createElement('br', null)
				);
			}
		}]);
	
		return Tables;
	}(_get__('Component'));
	
	exports.default = _get__('Tables');
	
	function _getGlobalObject() {
		try {
			if (!!global) {
				return global;
			}
		} catch (e) {
			try {
				if (!!window) {
					return window;
				}
			} catch (e) {
				return this;
			}
		}
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
		if (_RewireModuleId__ === null) {
			var globalVariable = _getGlobalObject();
	
			if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
				globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
			}
	
			_RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
		}
	
		return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
			theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
		}
	
		return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
		var moduleId = _getRewireModuleId__();
	
		var registry = _getRewireRegistry__();
	
		var rewireData = registry[moduleId];
	
		if (!rewireData) {
			registry[moduleId] = Object.create(null);
			rewireData = registry[moduleId];
		}
	
		return rewireData;
	}
	
	(function registerResetAll() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable['__rewire_reset_all__']) {
			theGlobalVariable['__rewire_reset_all__'] = function () {
				theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
			};
		}
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
		function addPropertyToAPIObject(name, value) {
			Object.defineProperty(_RewireAPI__, name, {
				value: value,
				enumerable: false,
				configurable: true
			});
		}
	
		addPropertyToAPIObject('__get__', _get__);
		addPropertyToAPIObject('__GetDependency__', _get__);
		addPropertyToAPIObject('__Rewire__', _set__);
		addPropertyToAPIObject('__set__', _set__);
		addPropertyToAPIObject('__reset__', _reset__);
		addPropertyToAPIObject('__ResetDependency__', _reset__);
		addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _get_original__(variableName);
		} else {
			var value = rewireData[variableName];
	
			if (value === INTENTIONAL_UNDEFINED) {
				return undefined;
			} else {
				return value;
			}
		}
	}
	
	function _get_original__(variableName) {
		switch (variableName) {
			case 'Component':
				return _react.Component;
	
			case 'Tables':
				return Tables;
	
			case 'React':
				return _react2.default;
	
			case 'DarkThemeNav':
				return _darkThemeNav2.default;
	
			case 'AgGridThemeNav':
				return _agGridThemeNav2.default;
		}
	
		return undefined;
	}
	
	function _assign__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _set_original__(variableName, value);
		} else {
			return rewireData[variableName] = value;
		}
	}
	
	function _set_original__(variableName, _value) {
		switch (variableName) {}
	
		return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
		var oldValue = _get__(variableName);
	
		var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
		_assign__(variableName, newValue);
	
		return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
			Object.keys(variableName).forEach(function (name) {
				rewireData[name] = variableName[name];
			});
			return function () {
				Object.keys(variableName).forEach(function (name) {
					_reset__(variableName);
				});
			};
		} else {
			if (value === undefined) {
				rewireData[variableName] = INTENTIONAL_UNDEFINED;
			} else {
				rewireData[variableName] = value;
			}
	
			return function () {
				_reset__(variableName);
			};
		}
	}
	
	function _reset__(variableName) {
		var rewireData = _getRewiredData__();
	
		delete rewireData[variableName];
	
		if (Object.keys(rewireData).length == 0) {
			delete _getRewireRegistry__()[_getRewireModuleId__];
		}
	
		;
	}
	
	function _with__(object) {
		var rewireData = _getRewiredData__();
	
		var rewiredVariableNames = Object.keys(object);
		var previousValues = {};
	
		function reset() {
			rewiredVariableNames.forEach(function (variableName) {
				rewireData[variableName] = previousValues[variableName];
			});
		}
	
		return function (callback) {
			rewiredVariableNames.forEach(function (variableName) {
				previousValues[variableName] = rewireData[variableName];
				rewireData[variableName] = object[variableName];
			});
			var result = callback();
	
			if (!!result && typeof result.then == 'function') {
				result.then(reset).catch(reset);
			} else {
				reset();
			}
	
			return result;
		};
	}
	
	var _typeOfOriginalExport = typeof Tables === 'undefined' ? 'undefined' : _typeof(Tables);
	
	function addNonEnumerableProperty(name, value) {
		Object.defineProperty(Tables, name, {
			value: value,
			enumerable: false,
			configurable: true
		});
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Tables)) {
		addNonEnumerableProperty('__get__', _get__);
		addNonEnumerableProperty('__GetDependency__', _get__);
		addNonEnumerableProperty('__Rewire__', _set__);
		addNonEnumerableProperty('__set__', _set__);
		addNonEnumerableProperty('__reset__', _reset__);
		addNonEnumerableProperty('__ResetDependency__', _reset__);
		addNonEnumerableProperty('__with__', _with__);
		addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = AgGridThemeNav;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AgGridThemeNav(_ref) {
	  var anchor = _ref.anchor;
	
	  var download = '/getting-started';
	  var view = '/themes';
	  return _get__('React').createElement(
	    'div',
	    null,
	    _get__('React').createElement(
	      'div',
	      { className: 'grid dark-theme-nav' },
	      _get__('React').createElement(
	        'div',
	        { className: 'grid__col-4' },
	        _get__('React').createElement(
	          'a',
	          { className: 'btn', href: '' + download },
	          'Download Theme'
	        )
	      ),
	      _get__('React').createElement(
	        'div',
	        { className: 'grid__col-4' },
	        _get__('React').createElement(
	          'a',
	          { className: 'btn', href: view + '#' + anchor },
	          'View Theme'
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof AgGridThemeNav === 'undefined' ? 'undefined' : _typeof(AgGridThemeNav);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(AgGridThemeNav, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(AgGridThemeNav)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataTables = function (_get__2) {
	  _inherits(DataTables, _get__2);
	
	  function DataTables(props) {
	    _classCallCheck(this, DataTables);
	
	    return _possibleConstructorReturn(this, (DataTables.__proto__ || Object.getPrototypeOf(DataTables)).call(this, props));
	  }
	
	  _createClass(DataTables, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'datatables' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'DataTables'
	        ),
	        this.props.staticVersion === false ? _get__('React').createElement(_get__('Included'), { onClick: function onClick() {
	            return _this2.props.onIncludeClick();
	          }, included: this.props.included }) : '',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'a',
	            { href: 'http://datatables.net/' },
	            'DataTables'
	          ),
	          ' is a table plugin for jquery. It is a highly flexible tool, based upon the foundations of progressive enhancement, and will add advanced interaction controls to any HTML table.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout callout--secondary' },
	          _get__('React').createElement(
	            'span',
	            null,
	            _get__('React').createElement('i', { className: 'fa fa-question' }),
	            ' Common UI provides styling for datatables that overrides the provided basic theme.'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'CSS - '
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<head>\n  <link rel="stylesheet" type="text/css" href="//cdn.datatables.net/1.10.11/css/jquery.dataTables.min.css"/>\n</head>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'JS - '
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '\n<script type="text/javascript" src="//cdn.datatables.net/1.10.11/js/jquery.dataTables.min.js"></script>\n\n$(\'.js-data-table\').DataTable( {\n  pagingType: \'full_numbers\',\n\u2002\u2002classes: {\n\u2002   sSortable: \'table-sort\',\n\u2002\u2002\u2002\u2002sSortAsc: \'table-sort table-sort--asc\',\n\u2002\u2002\u2002\u2002sSortDesc: \'table-sort table-sort--desc\',\n\u2002\u2002},\n});\n        '
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'table',
	          { className: 'js-data-table table table--comfy table--hover table--striped table--dark' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                null,
	                'Name'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Position'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Office'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Age'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Start date'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Salary'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Tiger Nixon'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'System Architect'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '61'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/04/25'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$320,800'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Garrett Winters'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Accountant'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Tokyo'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '63'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/07/25'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$170,750'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Ashton Cox'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Junior Technical Author'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '66'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/01/12'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$86,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Cedric Kelly'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Senior Javascript Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '22'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/03/29'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$433,060'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Airi Satou'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Accountant'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Tokyo'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '33'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/11/28'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$162,700'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Brielle Williamson'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Integration Specialist'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '61'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/12/02'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$372,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Herrod Chandler'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Sales Assistant'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '59'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/08/06'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$137,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Rhona Davidson'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Integration Specialist'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Tokyo'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '55'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/10/14'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$327,900'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Colleen Hurst'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Javascript Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '39'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/09/15'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$205,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Sonya Frost'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Software Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '23'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/12/13'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$103,600'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Jena Gaines'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Office Manager'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '30'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/12/19'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$90,560'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Quinn Flynn'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Support Lead'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '22'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2013/03/03'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$342,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Charde Marshall'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Regional Director'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '36'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/10/16'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$470,600'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Haley Kennedy'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Senior Marketing Designer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '43'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/12/18'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$313,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Tatyana Fitzpatrick'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Regional Director'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '19'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/03/17'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$385,750'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Michael Silva'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Marketing Designer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '66'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/11/27'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$198,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Paul Byrd'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Chief Financial Officer (CFO)'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '64'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/06/09'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$725,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Gloria Little'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Systems Administrator'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '59'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/04/10'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$237,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Bradley Greer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Software Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '41'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/10/13'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$132,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Dai Rios'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Personnel Lead'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '35'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/09/26'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$217,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Jenette Caldwell'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Development Lead'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '30'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/09/03'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$345,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Yuri Berry'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Chief Marketing Officer (CMO)'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '40'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/06/25'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$675,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Caesar Vance'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Pre-Sales Support'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '21'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/12/12'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$106,450'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Doris Wilder'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Sales Assistant'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Sidney'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '23'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/09/20'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$85,600'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Angelica Ramos'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Chief Executive Officer (CEO)'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '47'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/10/09'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$1,200,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Gavin Joyce'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '42'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/12/22'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$92,575'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Jennifer Chang'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Regional Director'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Singapore'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '28'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/11/14'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$357,650'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Brenden Wagner'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Software Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '28'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/06/07'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$206,850'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Fiona Green'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Chief Operating Officer (COO)'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '48'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/03/11'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$850,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Shou Itou'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Regional Marketing'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Tokyo'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '20'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/08/14'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$163,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Michelle House'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Integration Specialist'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Sidney'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '37'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/06/02'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$95,400'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Suki Burks'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '53'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/10/22'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$114,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Prescott Bartlett'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Technical Author'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '27'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/05/07'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$145,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Gavin Cortez'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Team Leader'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '22'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/10/26'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$235,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Martena Mccray'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Post-Sales support'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '46'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/03/09'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$324,050'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Unity Butler'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Marketing Designer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '47'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/12/09'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$85,675'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Howard Hatfield'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Office Manager'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '51'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/12/16'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$164,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Hope Fuentes'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Secretary'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '41'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/02/12'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$109,850'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Vivian Harrell'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Financial Controller'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '62'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/02/14'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$452,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Timothy Mooney'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Office Manager'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '37'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/12/11'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$136,200'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Jackson Bradshaw'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Director'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '65'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/09/26'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$645,750'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Olivia Liang'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Support Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Singapore'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '64'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/02/03'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$234,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Bruno Nash'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Software Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '38'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/05/03'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$163,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Sakura Yamamoto'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Support Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Tokyo'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '37'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/08/19'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$139,575'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Thor Wgrey-5n'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '61'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2013/08/11'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$98,540'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Finn Camacho'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Support Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '47'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/07/07'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$87,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Serge Baldwin'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Data Coordinator'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Singapore'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '64'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/04/09'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$138,575'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Zenaida Frank'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Software Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '63'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/01/04'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$125,250'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Zorita Serrano'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Software Engineer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '56'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2012/06/01'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$115,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Jennifer Acosta'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Junior Javascript Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '43'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2013/02/01'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$75,650'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Cara Stevens'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Sales Assistant'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '46'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/12/06'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$145,600'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Hermione Butler'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Regional Director'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '47'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/03/21'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$356,250'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Lael Greer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Systems Administrator'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'London'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '21'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2009/02/27'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$103,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Jonas Alexander'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'San Francisco'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '30'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2010/07/14'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$86,500'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Shad Decker'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Regional Director'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Edinburgh'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '51'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2008/11/13'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$183,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Michael Bruce'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Javascript Developer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Singapore'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '29'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/06/27'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$183,000'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Donna Snider'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Customer Support'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'New York'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '27'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '2011/01/25'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                '$112,000'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DataTables;
	}(_get__('Component'));
	
	exports.default = _get__('DataTables');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'DataTables':
	      return DataTables;
	
	    case 'React':
	      return _react2.default;
	
	    case 'Included':
	      return _Included2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof DataTables === 'undefined' ? 'undefined' : _typeof(DataTables);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(DataTables, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(DataTables)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	var _html = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alertIcons = {
	  'default': 'fa-exclamation-circle',
	  'info': 'fa-info',
	  'success': 'fa-check',
	  'warning': 'fa-warning',
	  'error': 'fa-ban'
	};
	
	var alertMessages = {
	  'default': 'This is an alert',
	  'info': 'This is an info alert',
	  'success': 'This is a success alert',
	  'warning': 'This is a warning alert',
	  'error': 'This is an error alert'
	};
	
	var Alerts = function (_get__2) {
	  _inherits(Alerts, _get__2);
	
	  function Alerts() {
	    _classCallCheck(this, Alerts);
	
	    return _possibleConstructorReturn(this, (Alerts.__proto__ || Object.getPrototypeOf(Alerts)).apply(this, arguments));
	  }
	
	  _createClass(Alerts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.initializeAlerts();
	      }, 0);
	    }
	  }, {
	    key: 'initializeAlerts',
	    value: function initializeAlerts() {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = document.querySelectorAll('.alert-type-selector')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var alertTypeSelector = _step.value;
	
	          alertTypeSelector.addEventListener('change', this.changeAlerts.bind(this), false);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'changeAlerts',
	    value: function changeAlerts(event) {
	      var target = event.currentTarget;
	      var type = target.value;
	      var selector = target.dataset.selector;
	      var alertEls = document.querySelectorAll(selector);
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = alertEls[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var alertEl = _step2.value;
	
	          var alertIconEl = alertEl.querySelector('.alert__icon > i');
	          var alertHeadingEl = alertEl.querySelector('.alert__heading');
	          var alertMessageEl = alertEl.querySelector('.alert__message');
	          _get__('removeClasses')(alertEl, ['alert--info', 'alert--success', 'alert--warning', 'alert--error']);
	          _get__('addClasses')(alertEl, ['alert--' + type]);
	
	          // Update the icon, if there is one
	          if (alertIconEl) {
	            _get__('removeClasses')(alertIconEl, Object.values(_get__('alertIcons')));
	            _get__('addClasses')(alertIconEl, [_get__('alertIcons')[type]]);
	          }
	
	          // Update the heading, if there is one
	          if (alertHeadingEl) {
	            alertHeadingEl.innerHTML = _get__('alertMessages')[type];
	          }
	
	          // Update the message, if there is one
	          if (alertMessageEl) {
	            alertMessageEl.innerHTML = _get__('alertMessages')[type];
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'alerts' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Alerts'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Messages are a way to provide feedback to users:'
	        ),
	        _get__('React').createElement(
	          'ul',
	          null,
	          _get__('React').createElement(
	            'li',
	            null,
	            'Information messages can be used to inform the user about something relevant or to share tips or suggestions.'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Warnings should be displayed for example when there is something wrong with the system or the user\u2019s task can\u2019t be fully completed.'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Success messages tell people they have successfully completed a task, for example submitted a form. '
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Error messages let people know that something has gone wrong and it needs to be resolved to complete the task. Errors and success messages are the most important message types, but sometimes you might need also other types of messages.'
	          )
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'alerts' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Default Alert'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'push-half--bottom' },
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'alert-type-default', className: 'display--inline-block push-half--right' },
	            'Change Type:'
	          ),
	          _get__('React').createElement(
	            'select',
	            { id: 'alert-type-default', className: 'alert-type-selector', 'data-selector': '.js-alert--default' },
	            _get__('React').createElement(
	              'option',
	              { value: 'default' },
	              'Default'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'info' },
	              'Info'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'success' },
	              'Success'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'warning' },
	              'Warning'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'error' },
	              'Error'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert js-alert--default', role: 'alert' },
	          'This is an alert'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="alert" role="alert">This is an alert</div>\n<div class="alert alert--info" role="alert">This is an info alert</div>\n<div class="alert alert--warning" role="alert">This is a warning alert</div>\n<div class="alert alert--success" role="alert">This is a success alert</div>\n<div class="alert alert--error" role="alert">This is an error alert</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Light Alert'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'An alternative alert can be used in the same manner as the default alert, but is particularly useful when we need to include either links and/or buttons.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'push-half--bottom' },
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'alert-type-light', className: 'display--inline-block push-half--right' },
	            'Change Type:'
	          ),
	          _get__('React').createElement(
	            'select',
	            { id: 'alert-type-light', className: 'alert-type-selector', 'data-selector': '.js-alert--light' },
	            _get__('React').createElement(
	              'option',
	              { value: 'default' },
	              'Default'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'info' },
	              'Info'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'success' },
	              'Success'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'warning' },
	              'Warning'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'error' },
	              'Error'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--light js-alert--light', role: 'alert' },
	          'This is an alert',
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent js-alert__close', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Default Light Alert -->\n<div class="alert alert--light js-alert" role="alert">\n  This is a light alert, with a <a href="#">link</a>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Info Light Alert -->\n<div class="alert alert--light alert--info js-alert" role="alert">\n  This is a light info alert, with a <button class="btn btn--small push-quarter--left">button</button>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Success Light Alert -->\n<div class="alert alert--light alert--success js-alert" role="alert">\n  This is a light success alert, with a <a href="#">link</a>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Warning Light Alert -->\n<div class="alert alert--light alert--warning js-alert" role="alert">\n  This is a light warning alert, with a <a href="#">link</a> and a <button class="btn btn--small push-quarter--left">button</button>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Error Light Alert -->\n<div class="alert alert--light alert--error js-alert" role="alert">\n  This is a light error alert, with a <button class="btn btn--small push-quarter--left">button</button>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Attention Alert'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'push-half--bottom' },
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'alert-type-attention', className: 'display--inline-block push-half--right' },
	            'Change Type:'
	          ),
	          _get__('React').createElement(
	            'select',
	            { id: 'alert-type-attention', className: 'alert-type-selector', 'data-selector': '.js-alert--attention' },
	            _get__('React').createElement(
	              'option',
	              { value: 'default' },
	              'Default'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'info' },
	              'Info'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'success' },
	              'Success'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'warning' },
	              'Warning'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'error' },
	              'Error'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert js-alert--attention', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--medium', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__heading' },
	            'This is an alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent js-alert__close', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Default Attention Alert -->\n<div class="alert js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is an alert\n  </div>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Info Attention Alert -->\n<div class="alert alert--info js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-info-circle icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is an info alert\n  </div>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Success Attention Alert -->\n<div class="alert alert--success js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-check icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is a success alert\n  </div>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Success Attention Alert -->\n<div class="alert alert--success js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-check icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is a success alert\n  </div>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Warning Attention Alert -->\n<div class="alert alert--warning js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-triangle icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is a warning alert\n  </div>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Error Attention Alert -->\n<div class="alert alert--error js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-ban icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is an error alert\n  </div>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Minimal Alert'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'push-half-bottom' },
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'alert-type-minimal', className: 'display--inline-block push-half--right' },
	            'Change Type:'
	          ),
	          _get__('React').createElement(
	            'select',
	            { id: 'alert-type-minimal', className: 'alert-type-selector', 'data-selector': '.js-alert--minimal' },
	            _get__('React').createElement(
	              'option',
	              { value: 'default' },
	              'Default'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'info' },
	              'Info'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'success' },
	              'Success'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'warning' },
	              'Warning'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'error' },
	              'Error'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-half--bottom' },
	          'Minimal Alert with Block Icon and Colored Outline'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--minimal alert--outline js-alert--minimal', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon alert__icon--block' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--medium', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__message' },
	            'This is an alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-half--bottom' },
	          'Minimal Alert with Icon and Colored Outline'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--minimal alert--outline js-alert--minimal', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--medium', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__message' },
	            'This is an alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-half--bottom' },
	          'Minimal Alert with Icon and Gray Outline'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--minimal js-alert--minimal', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--medium', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__message' },
	            'This is an alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Minimal Alert with Block Icon and Colored Outline -->\n<div class="alert alert--minimal alert--outline" role="alert">\n  <div class="alert__icon alert__icon--block">\n    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__message">\n    This is an alert\n  </div>\n  <button class="alert__close btn btn--transparent" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Minimal Alert with Icon and Colored Outline -->\n<div class="alert alert--minimal alert--outline" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__message">\n    This is an alert\n  </div>\n  <button class="alert__close btn btn--transparent" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Minimal Alert with Icon and Gray Outline -->\n<div class="alert alert--minimal" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__message">\n    This is an alert\n  </div>\n  <button class="alert__close btn btn--transparent" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Alert Box'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert hard js-alert', role: 'alert' },
	          _get__('React').createElement(
	            'header',
	            { className: 'alert__header' },
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__icon' },
	              _get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--medium', 'aria-hidden': 'true' })
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__heading' },
	              'This is an alert box'
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'alert__close btn btn--transparent js-alert__close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__body' },
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__body__inner' },
	              _get__('React').createElement(
	                'p',
	                null,
	                'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.'
	              )
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'alert__body__footer text--right' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="alert hard js-alert" role="alert">\n  <header class="alert__header">\n    <div class="alert__icon">\n      <i class="fa fa-exclamation-circle icon--medium" aria-hidden="true"></i>\n    </div>\n    <div class="alert__heading">\n      This is an alert box\n    </div>\n    <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n      <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n    </button>\n  </header>\n  <div class="alert__body">\n    <div class="alert__body__inner">\n      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.</p>\n    </div>\n    <footer class="alert__body__footer text--right">\n      <button type="button" class="btn">OK</button>\n    </footer>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Dismissable Alerts'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This functionality requires javascript. You need to use the classes shown above, or pass specific paramaters when initializing'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--success js-alert', role: 'alert' },
	          _get__('React').createElement(
	            'h4',
	            null,
	            'Success'
	          ),
	          'User was created.',
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent js-alert__close', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--error js-alert', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon' },
	            _get__('React').createElement('i', { className: 'fa fa-ban icon--medium', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__heading' },
	            'This is an error alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent js-alert__close', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="alert alert--success js-alert" role="alert">\n  <button class="alert__close js-alert__close" aria-label="close"><i class="fa fa-close"></i></button>\n  <h4>Success</h4>User was created.\n</div>\n<div class="alert alert--error js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-ban icon--medium" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is a error alert\n  </div>\n  <button class="alert__close btn btn--transparent js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Using default classes shown in snippet.\n// The library looks for the class \'js-alert\' and \'js-alert__close\' by default.\ncommonUI.initializeAlert();\n\n// You can have multiple alerts on the page, they will all be initialised\n\n// Using custom selectors\ncommonUI.initializeAlert(\n  {\n    selector: \'.special-alert\',\n    closeSelector\': .special-alert-close-button\'\n  }\n);\n\n// Automatically closing after time period (in milliseconds)\ncommonUI.initializeAlert(\n  {\n    autoCloseTime: 5000\n  }\n);'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Small Alerts'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Each alert can also make use of the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'alert--small'
	          ),
	          ' class to reduce the height and padding on the alert.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'push-half-bottom' },
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'alert-type-small', className: 'display--inline-block push-half--right' },
	            'Change Type:'
	          ),
	          _get__('React').createElement(
	            'select',
	            { id: 'alert-type-small', className: 'alert-type-selector', 'data-selector': '.js-alert--small' },
	            _get__('React').createElement(
	              'option',
	              { value: 'default' },
	              'Default'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'info' },
	              'Info'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'success' },
	              'Success'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'warning' },
	              'Warning'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'error' },
	              'Error'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Default'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--small js-alert--small', role: 'alert' },
	          'This is a small alert'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Default Small Alert -->\n<div class="alert alert--small" role="alert">\n  This is a small alert\n</div>\n\n<!-- Small Info Alert -->\n<div class="alert alert--small alert--info" role="alert">\n  This is a small info alert\n</div>\n\n<!-- Small Success Alert -->\n<div class="alert alert--small alert--success" role="alert">\n  This is a small success alert\n</div>\n\n<!-- Small Warning Alert -->\n<div class="alert alert--small alert--warning" role="alert">\n  This is a small warning alert\n</div>\n\n<!-- Small Error Alert -->\n<div class="alert alert--small alert--error" role="alert">\n  This is a small error alert\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Attention'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--small js-alert--small', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--small', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__heading' },
	            'This is an alert'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Default Small Attention Alert -->\n<div class="alert alert--small js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-circle icon--small" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is an alert\n  </div>\n</div>\n\n<!-- Small Info Attention Alert -->\n<div class="alert alert--small alert--info js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-info-circle icon--small" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is an info alert\n  </div>\n</div>\n\n<!-- Small Success Attention Alert -->\n<div class="alert alert--small alert--success js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-check icon--small" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is a success alert\n  </div>\n</div>\n\n<!-- Small Warning Attention Alert -->\n<div class="alert alert--small alert--warning js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-triangle icon--small" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is a warning alert\n  </div>\n</div>\n\n<!-- Small Error Attention Alert -->\n<div class="alert alert--small alert--error js-alert" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-ban icon--small" aria-hidden="true"></i>\n  </div>\n  <div class="alert__heading">\n    This is an error alert\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Light Alert'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'It is the design suggestion that you do not use full buttons in small, light alerts - only button links are permissible. If a button is supplied then the alert will grow in height to accomodate.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--small alert--light js-alert--small', role: 'alert' },
	          'This is a small light alert, with a ',
	          _get__('React').createElement(
	            'a',
	            { href: '#' },
	            'link'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent hard js-alert__close', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Default Small & Light Alert -->\n<div class="alert alert--small alert--light js-alert" role="alert">\n  This is a small light alert, with a <a href="#">link</a>\n  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Small & Light Info Alert -->\n<div class="alert alert--small alert--light alert--info js-alert" role="alert">\n  This is a small light info alert, with a <a href="#">link</a>\n  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Small & Light Success Alert -->\n<div class="alert alert--small alert--light alert--success js-alert" role="alert">\n  This is a small light success alert, with a <a href="#">link</a>\n  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Small & Light Warning Alert -->\n<div class="alert alert--small alert--light alert--warning js-alert" role="alert">\n  This is a small light warning alert, with a <a href="#">link</a>\n  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Small & Light Error Alert -->\n<div class="alert alert--small alert--light alert--error js-alert" role="alert">\n  This is a small light error alert, with a <a href="#">link</a>\n  <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Small Minimal Alerts'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'push-half-bottom' },
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'alert-type-small', className: 'display--inline-block push-half--right' },
	            'Change Type:'
	          ),
	          _get__('React').createElement(
	            'select',
	            { id: 'alert-type-small', className: 'alert-type-selector', 'data-selector': '.js-alert--small-minimal' },
	            _get__('React').createElement(
	              'option',
	              { value: 'default' },
	              'Default'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'info' },
	              'Info'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'success' },
	              'Success'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'warning' },
	              'Warning'
	            ),
	            _get__('React').createElement(
	              'option',
	              { value: 'error' },
	              'Error'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-half--bottom' },
	          'Small Minimal Alert with Block Icon and Colored Outline'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--minimal alert--small alert--outline js-alert--small-minimal', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon alert__icon--block' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__message' },
	            'This is an alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-half--bottom' },
	          'Small Minimal Alert with Icon and Colored Outline'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--minimal alert--small alert--outline js-alert--small-minimal', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__message' },
	            'This is an alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-half--bottom' },
	          'Small Minimal Alert with Icon and Gray Outline'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--minimal alert--small js-alert--small-minimal', role: 'alert' },
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__icon' },
	            _get__('React').createElement('i', { className: 'fa fa-exclamation-circle', 'aria-hidden': 'true' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__message' },
	            'This is an alert'
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'alert__close btn btn--transparent', 'aria-label': 'close' },
	            _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Small Minimal Alert with Block Icon and Colored Outline -->\n<div class="alert alert--minimal alert--small alert--outline" role="alert">\n  <div class="alert__icon alert__icon--block">\n    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>\n  </div>\n  <div class="alert__message">\n    This is an alert\n  </div>\n  <button class="alert__close btn btn--transparent" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Small Minimal Alert with Icon and Colored Outline -->\n<div class="alert alert--minimal alert--small alert--outline" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>\n  </div>\n  <div class="alert__message">\n    This is an alert\n  </div>\n  <button class="alert__close btn btn--transparent" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>\n\n<!-- Small Minimal Alert with Icon and Gray Outline -->\n<div class="alert alert--minimal alert--small" role="alert">\n  <div class="alert__icon">\n    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>\n  </div>\n  <div class="alert__message">\n    This is an alert\n  </div>\n  <button class="alert__close btn btn--transparent" aria-label="close">\n    <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n  </button>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Alert Box'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert hard js-alert', role: 'alert' },
	          _get__('React').createElement(
	            'header',
	            { className: 'alert--small alert__header' },
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__icon' },
	              _get__('React').createElement('i', { className: 'fa fa-exclamation-circle icon--small', 'aria-hidden': 'true' })
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__heading' },
	              'This is an alert box'
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'alert__close btn btn--transparent hard js-alert__close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__body' },
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__body__inner' },
	              _get__('React').createElement(
	                'p',
	                null,
	                'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.'
	              )
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'alert__body__footer text--right' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="alert hard js-alert" role="alert">\n  <header class="alert--small alert__header">\n    <div class="alert__icon">\n      <i class="fa fa-exclamation-circle icon--small" aria-hidden="true"></i>\n    </div>\n    <div class="alert__heading">\n      This is an alert box\n    </div>\n    <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">\n      <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n    </button>\n  </header>\n  <div class="alert__body">\n    <div class="alert__body__inner">\n      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Maxime mollitia laborum at doloribus? Voluptate perferendis expedita, veniam suscipit nisi. Nam, distinctio. Nobis temporibus cumque adipisci iste laudantium quae molestiae necessitatibus.</p>\n    </div>\n    <footer class="alert__body__footer text--right">\n      <button type="button" class="btn">OK</button>\n    </footer>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Upgrading Your Browser Alert Box'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Up to date browser versions will be the current version - 1. So if it is 11.0.0 any browsers lower than 10.0.0 will be considered out of date. However you can overwrite this by passing in a config object with custom version numbers. Any browser versions lower than this will be considered out of date.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Initialise the update browser functionality as below: '
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// This will initialise with the default settings. Current Browser Version - 1\ncommonUI.initializeAlert({\n  selector: \'.alert--update-browser\',\n  updatedBrowser: true,\n});\n\n// Initializes with custom browser numbers. Any versions lower than this will be considered out of date.\ncommonUI.initializeAlert({\n  selector: \'.alert--update-browser\',\n  updatedBrowser: {\n    chrome: \'73.0.0\',\n    safari: \'13.0.0\',\n    firefox: \'66.0.0\',\n    ie: \'12.0.0\',\n  }\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--warning hard js-alert alert--update-browser', role: 'alert' },
	          _get__('React').createElement(
	            'header',
	            { className: 'alert__header' },
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__icon' },
	              _get__('React').createElement('i', { className: 'fa fa-exclamation-triangle icon--medium', 'aria-hidden': 'true' })
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__heading' },
	              'Update Browser!'
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'alert__close btn btn--transparent hard js-alert__close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'alert__close__icon fa fa-remove', 'aria-hidden': 'true' })
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'alert__body' },
	            _get__('React').createElement(
	              'div',
	              { className: 'alert__body__inner' },
	              _get__('React').createElement(
	                'p',
	                null,
	                'Your browser is not up-to-date. We recommend using the latest version for a better experience.'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="alert alert--warning hard js-alert alert--update-browser" role="alert">\n  <header class="alert__header">\n    <div class="alert__icon">\n      <i class="fa fa-exclamation-triangle icon--medium" aria-hidden="true"></i>\n    </div>\n    <div class="alert__heading">\n      Update Browser!\n    </div>\n    <button class="alert__close btn btn--transparent hard js-alert__close" aria-label="close">\n      <i class="alert__close__icon fa fa-remove" aria-hidden="true"></i>\n    </button>\n  </header>\n  <div class="alert__body">\n    <div class="alert__body__inner">\n      <p>Your browser is not up-to-date. We recommend using the latest version for a better experience.</p>\n    </div>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Alerts;
	}(_get__('Component'));
	
	exports.default = _get__('Alerts');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'alertIcons':
	      return alertIcons;
	
	    case 'alertMessages':
	      return alertMessages;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'Alerts':
	      return Alerts;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Alerts === 'undefined' ? 'undefined' : _typeof(Alerts);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Alerts, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Alerts)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _html = __webpack_require__(10);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
	
	
	var Toasts = function (_get__2) {
	  _inherits(Toasts, _get__2);
	
	  function Toasts() {
	    _classCallCheck(this, Toasts);
	
	    return _possibleConstructorReturn(this, (Toasts.__proto__ || Object.getPrototypeOf(Toasts)).apply(this, arguments));
	  }
	
	  _createClass(Toasts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.initializeToasts();
	      }, 0);
	    }
	  }, {
	    key: 'initializeToasts',
	    value: function initializeToasts() {
	      this.toasts = _get__('commonUI').initializeToasts({
	        top: 48,
	        cssClass: 'js-toasts--example'
	      });
	      var btnShowToast = document.getElementById('btnShowToast');
	      var toastPosition = document.getElementById('toast-position');
	      btnShowToast.addEventListener('click', this.showToast.bind(this), false);
	      toastPosition.addEventListener('change', this.changeToastPosition.bind(this), false);
	    }
	  }, {
	    key: 'changeToastPosition',
	    value: function changeToastPosition(event) {
	      var position = event.currentTarget.value;
	      var toastsEl = document.querySelector('.js-toasts--example');
	      _get__('removeClasses')(toastsEl, ['toasts--position-top', 'toasts--position-right', 'toasts--position-bottom', 'toasts--position-left']);
	      var positions = position.split('|');
	      var toastClasses = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = positions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var pos = _step.value;
	
	          toastClasses.push('toasts--position-' + pos);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (positions.includes('top')) {
	        _get__('setStyles')(toastsEl, { top: '48px', bottom: 'auto' });
	      } else {
	        _get__('setStyles')(toastsEl, { top: 'auto', bottom: '0px' });
	      }
	      _get__('addClasses')(toastsEl, toastClasses);
	    }
	  }, {
	    key: 'showToast',
	    value: function showToast() {
	      var toastType = document.getElementById('toast-type').value;
	      var toastOutlined = document.getElementById('toast-outlined').checked;
	      this.toasts.add({
	        type: toastType,
	        outline: toastOutlined,
	        message: 'This is an example <strong>' + toastType + '</strong> message.'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'toasts' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Toasts'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Toasts are required to allow applications to notifiy users of events which are being carried out in the background via an application or website.'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'toasts' }),
	        _get__('React').createElement(
	          'ul',
	          { className: 'toasts toasts--position-left hard position--relative' },
	          _get__('React').createElement(
	            'li',
	            { className: 'toast toast--error toast--outline' },
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__icon' },
	              _get__('React').createElement('i', { className: 'fa fa-remove' })
	            ),
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__message' },
	              'This is an error toast with a ',
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'link'
	              )
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'toast__action' },
	              _get__('React').createElement('i', { className: 'fa fa-remove' })
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'toast toast--warning toast--outline' },
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__icon' },
	              _get__('React').createElement('i', { className: 'fa fa-exclamation' })
	            ),
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__message' },
	              'This is an exclamation toast with a ',
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'link'
	              )
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'toast__action' },
	              _get__('React').createElement('i', { className: 'fa fa-remove' })
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'toast toast--success toast--outline' },
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__icon' },
	              _get__('React').createElement('i', { className: 'fa fa-check' })
	            ),
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__message' },
	              'This is a success toast with a ',
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'link'
	              )
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'toast__action' },
	              _get__('React').createElement('i', { className: 'fa fa-remove' })
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'toast toast--info toast--outline' },
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__icon' },
	              _get__('React').createElement('i', { className: 'fa fa-info' })
	            ),
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__message' },
	              'This is an info toast with a ',
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'link'
	              )
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'toast__action' },
	              _get__('React').createElement('i', { className: 'fa fa-remove' })
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Usage'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'let toasts = commonUI.initializeToasts();'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Toasts Options'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'commonUI.initializeToasts()'
	          ),
	          ' shown above will imply the default options as shown below:'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--striped table--cosy' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Property'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Type'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Default'
	              ),
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'position'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'string'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'top|right\''
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This is a string representing the position of the toasts container.',
	                _get__('React').createElement('br', null),
	                'Options are ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'top|right\''
	                ),
	                ', ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'bottom|right\''
	                ),
	                ', ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'bottom|left\''
	                ),
	                ' or ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'top|left\''
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'cssClass'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'string'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'js-toasts\''
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'You can specify an optional CSS class, which you can then use as a selector in your application code.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'maxToasts'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'integer'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '3'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'The maximum number of toasts that can be displayed at one time.'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'These options can be overridden by passing an object to the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'commonUI.initializeToasts()'
	          ),
	          ' function, for example:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Initialize the toasts component\nlet toasts = commonUI.initializeToasts({\n  cssClass: \'js-my-toasts\',\n  position: \'bottom|left\',\n  maxToasts: 5\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Additional Options'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Optionally, you can also position the toasts container relative to the top, right, bottom or left edge of the viewport, for example:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Position the toasts component 100px down from the top and 50px in from the right\nlet toasts = commonUI.initializeToasts({\n  top: 100,\n  right: 50\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' When specifying an offset for ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'top'
	          ),
	          ', ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'right'
	          ),
	          ', ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'bottom'
	          ),
	          ' or ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'left'
	          ),
	          ', you must ',
	          _get__('React').createElement(
	            'strong',
	            null,
	            'only'
	          ),
	          ' apply either ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'left'
	          ),
	          ' OR ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'right'
	          ),
	          ' (not both), and either ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'top'
	          ),
	          ' OR ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'bottom'
	          ),
	          ' (not both).'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Adding a Toast Message'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To add a new toast message simply call the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'add()'
	          ),
	          ' method on the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'toasts'
	          ),
	          ' object created above, as shown below:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'toasts.add({ message = \'This is an example toast using the default options\' });'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This will imply the default toast options as shown below:'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--striped table--cosy' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Property'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Type'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Default'
	              ),
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'message'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'string'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'\''
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This is a string representing the message to displayed in the body of the toast.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'type'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'string'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'info\''
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'The type of the toast message. Can be one of ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'info\''
	                ),
	                ', ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'success\''
	                ),
	                ', ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'warning\''
	                ),
	                ' or ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'error\''
	                ),
	                '.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'minDuration'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'integer'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '2000'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'The minimum duration (in milliseconds) that the toast message will be displayed for.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'maxDuration'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'integer'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '7000'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'The maximum duration (in milliseconds) that the toast message will be displayed for.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'outline'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                'boolean'
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'false'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Whether the toast message should be outlined or not.'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'These options can be overridden by passing an object when adding a new toast via the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'toasts.add()'
	          ),
	          ' function, for example:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Add a new toast\ntoasts.add({\n  type: \'success\',\n  message: \'This is an example of an outlined success toast message\',\n  outline: true,\n  minDuration: 3000,\n  maxDuration: 8000,\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' The toast message will be displayed for a duration of 50ms per character. If this duration is outside the min/max duration specified (or defaults if not specified), then the min/max duration will take precedence.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Icon'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'By default, the icon will be determined based on the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'type'
	          ),
	          ' of the toast message, as follows:'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--striped table--cosy', style: { width: '150px' } },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Type'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Icon'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'info'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement('i', { className: 'fa fa-info' })
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'success'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement('i', { className: 'fa fa-check' })
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'warning'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement('i', { className: 'fa fa-exclamation' })
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'error'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                { className: 'text--center' },
	                _get__('React').createElement('i', { className: 'fa fa-remove' })
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'However, you can override the default icon if necessary by specifying a different icon from the ',
	          _get__('React').createElement(
	            'a',
	            { href: '#icons' },
	            'icons'
	          ),
	          ' set, as follows:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Override the toast icon with a CME branded icon\ntoasts.add({\n  type: \'info\',\n  message: \'<strong>Joe Bloggs</strong> has sent you a message.<br/><a href="#">Click here</a> to view.\',\n  outline: true,\n  icon: \'icon-cme-chat\'\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'ul',
	          { className: 'toasts toasts--position-left hard position--relative' },
	          _get__('React').createElement(
	            'li',
	            { className: 'toast toast--info toast--outline' },
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__icon' },
	              _get__('React').createElement('i', { className: 'icon-cme-chat' })
	            ),
	            _get__('React').createElement(
	              'span',
	              { className: 'toast__message' },
	              _get__('React').createElement(
	                'strong',
	                null,
	                'Joe Bloggs'
	              ),
	              ' has sent you a message.',
	              _get__('React').createElement('br', null),
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'Click here'
	              ),
	              ' to view.'
	            ),
	            _get__('React').createElement(
	              'button',
	              { className: 'toast__action' },
	              _get__('React').createElement('i', { className: 'fa fa-remove' })
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Demo'
	        ),
	        _get__('React').createElement(
	          'p',
	          { className: 'hard--bottom' },
	          'Select a type, position and whether to outline the toast message and click the "Show Toast" button.'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields list-inline' },
	          _get__('React').createElement(
	            'li',
	            { className: 'soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'toast-type' },
	              'Type'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'toast-type' },
	              _get__('React').createElement(
	                'option',
	                { value: 'info' },
	                'Info'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'success' },
	                'Success'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'warning' },
	                'Warning'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'error' },
	                'Error'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'soft-half' },
	            _get__('React').createElement(
	              'label',
	              { htmlFor: 'toast-position' },
	              'Position'
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'toast-position' },
	              _get__('React').createElement(
	                'option',
	                { value: 'top|right' },
	                'Top Right'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'bottom|right' },
	                'Bottom Right'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'bottom|left' },
	                'Bottom Left'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'top|left' },
	                'Top Left'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'soft-half' },
	            _get__('React').createElement(
	              'label',
	              null,
	              '\xA0'
	            ),
	            _get__('React').createElement(
	              'ul',
	              { className: 'check-list' },
	              _get__('React').createElement(
	                'li',
	                null,
	                _get__('React').createElement('input', { type: 'checkbox', id: 'toast-outlined' }),
	                ' ',
	                _get__('React').createElement(
	                  'label',
	                  { htmlFor: 'toast-outlined' },
	                  'Outlined'
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'soft' },
	            _get__('React').createElement(
	              'button',
	              { type: 'button', className: 'btn', id: 'btnShowToast' },
	              'Show Toast'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Examples'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The following is a demonstration of a series of random toast messages being added one every three seconds:'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { height: '410px', border: '1px solid #ccc' } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n          <head>\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n            <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n            <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n          </head>\n          <body>\n          </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n\n    const randomToasts = [\n      {\n        type: \'success\',\n        message: \'This is an outlined success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n        outline: true,\n      }, {\n        type: \'info\',\n        message: \'This is an outlined info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n        outline: true,\n      }, {\n        type: \'error\',\n        message: \'This is an outlined error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n        outline: true,\n      }, {\n        type: \'warning\',\n        message: \'This is an outlined warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n        outline: true,\n      }, {\n        type: \'success\',\n        message: \'This is a success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n      }, {\n        type: \'info\',\n        message: \'This is an info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n      }, {\n        type: \'error\',\n        message: \'This is an error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n      }, {\n        type: \'warning\',\n        message: \'This is a warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a>\',\n      }, {\n        type: \'success\',\n        message: \'This is a really long outlined success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n        outline: true,\n      }, {\n        type: \'info\',\n        message: \'This is a really long outlined info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n        outline: true,\n      }, {\n        type: \'error\',\n        message: \'This is a really long outlined error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n        outline: true,\n      }, {\n        type: \'warning\',\n        message: \'This is a really long outlined warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n        outline: true,\n      }, {\n        type: \'success\',\n        message: \'This is a really long success toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n      }, {\n        type: \'info\',\n        message: \'This is a really long info toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n      }, {\n        type: \'error\',\n        message: \'This is a really long error toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n      }, {\n        type: \'warning\',\n        message: \'This is a really long warning toast with a <a href="https://www.cmegroup.com/" target="_blank">link</a> and using a very long description text that illustrates the position of the icon and the dismissable close icon\',\n      },  {\n        type: \'info\',\n        message: \'<strong>Joe Bloggs</strong> has sent you a message.<br/><a href="#">Click here</a> to view.\',\n        icon: \'fa fa-user\',\n      },\n    ];\n\n    const getRandomToast = () => {\n      const randomIndex = Math.floor(Math.random() * Math.floor(randomToasts.length));\n      return randomToasts[randomIndex];\n    }\n\n    // const toasts = new Toasts({\n    const toasts = commonUI.initializeToasts({\n      position: \'top|right\',\n      outline: true,\n      top: 0,\n      right: 0\n    });\n\n    setInterval(() => {\n      toasts.add(getRandomToast());\n    }, 3000);\n\n  </script>\n</html>' })
	        )
	      );
	    }
	  }]);
	
	  return Toasts;
	}(_get__('Component'));
	
	exports.default = _get__('Toasts');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;
	
	    case 'removeClasses':
	      return _html.removeClasses;
	
	    case 'setStyles':
	      return _html.setStyles;
	
	    case 'addClasses':
	      return _html.addClasses;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'Toasts':
	      return Toasts;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Toasts === 'undefined' ? 'undefined' : _typeof(Toasts);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Toasts, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Toasts)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tabs = function (_get__2) {
	  _inherits(Tabs, _get__2);
	
	  function Tabs(props) {
	    _classCallCheck(this, Tabs);
	
	    return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	  }
	
	  _createClass(Tabs, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'tabs' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Tabs'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Tabbed components are useful when grouping like data or content into groups. Tabbed components take their lead from content containers but have a set of tabs that run the full width of the container.'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'tabs' }),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Default styling'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'tabs js-tabs' },
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__toggle-group' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle tabs__toggle--active' },
	              'Jules Verne'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Around the World'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              '80 Days'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__tabs-group' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'It was now the 30th of October, and on the following day the Rangoon was due at Singapore.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="tabs js-tabs">\n    <div class="tabs__toggle-group">\n      <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>\n      <div class="tabs__toggle">Around the World</div>\n      <div class="tabs__toggle">80 Days</div>\n    </div>\n    <div class="tabs__tabs-group">\n      <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n      <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n      <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n    </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Lite styling'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'tabs tabs--lite js-tabs-lite' },
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__toggle-group' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle tabs__toggle--active' },
	              'Jules Verne'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Around the World'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              '80 Days'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__tabs-group' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'It was now the 30th of October, and on the following day the Rangoon was due at Singapore.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="tabs tabs--lite js-tabs">\n    <div class="tabs__toggle-group">\n      <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>\n      <div class="tabs__toggle">Around the World</div>\n      <div class="tabs__toggle">80 Days</div>\n    </div>\n    <div class="tabs__tabs-group">\n      <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n      <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n      <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n    </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Full Width Styling'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'By default, each tab will only consume as much space as it needs. It is possible to specify that the tabs consume the full width of the containing element. To set the container to full width, just add the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'tabs__toggle-group--full-width'
	          ),
	          ' modifier class to the containing element.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'tabs js-tabs' },
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__toggle-group tabs__toggle-group--full-width' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle tabs__toggle--active' },
	              'Jules Verne'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Around the World'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              '80 Days'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__tabs-group' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'It was now the 30th of October, and on the following day the Rangoon was due at Singapore.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="tabs js-tabs">\n    <div class="tabs__toggle-group tabs__toggle-group--full-width">\n      <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>\n      <div class="tabs__toggle">Around the World</div>\n      <div class="tabs__toggle">80 Days</div>\n    </div>\n    <div class="tabs__tabs-group">\n      <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n      <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n      <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n    </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This is a javascript enabled component. You need to use the classes shown above, or pass in the variation to the library.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Using default classes shown in snippet.\n// The library looks for the class \'js-tabs\' by default.\ncommonUI.initializeTabs();\n\n// You can have multiple tab group on the page, they will all be initialised\n\n// Using a custom selector\ncommonUI.initializeTabs({selector:\'.special-tabs\'});\n\n// Access to the tabs can be achieved programatically.\nvar tabs = commonUI.initializeTabs();\ntabs.open({index: 0}); // Opens the first tab\ntabs.open({index: 1}); // Opens the second tab\ntabs.close({index: 0}); // Closes the first tab\ntabs.close({index: 1}); // Closes the second tab\n\n// Tabs can also be open and closed by a selector.\n// <div class="tabs__tab" id="livestock-tab">Content</div>\ntabs.open({selector: \'#livestock-tab\'}); // Opens the tab with the corresponding id '
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Scrollable'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Pass in the "scrollable" flag and the tabs will become horizontally scrollable'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'tabs js-scrollable-tabs' },
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__toggle-group' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle tabs__toggle--active' },
	              'Tab Option 1'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 2'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle is-closeable' },
	              'Tab Option 3 with really long text'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 4'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 5'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 6'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 7'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 8'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 9'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__toggle' },
	              'Tab Option 10'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'tabs__tabs-group' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 1 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 2 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 3 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 4 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 5 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 6 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 7 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 8 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 9 Content'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'tabs__tab' },
	              'Tab 10 Content'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeTabs({scrollable: true});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Programatically Add/Remove Tabs'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Tabs expose methods which can be used to programatically add or remove tabs.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'let tabs = commonUI.initializeTabs({scrollable: true});\n\n// Add a new tab\nvar newTab = tabs.add({\n  title: \'A New Tab\',\n  closeable: true\n});\n\n// To set the content of the tab\nnewTab.tab.innerHTML = \'This tab will self destruct in 5 seconds &hellip;\';\n\n// Remove the tab created above\nnewTab.remove();\n\n// or you can remove a tab by its index\ntabs.remove({\n  index: 1\n});'
	          )
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "175px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n          <head>\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n            <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n            <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n          </head>\n          <body>\n            <div class="tabs js-scrollable-tabs" id="scrollableTabsExample">\n              <div class="tabs__toggle-group">\n                <div class="tabs__toggle tabs__toggle--active">Tab Option 1</div>\n                <div class="tabs__toggle">Tab Option 2</div>\n                <div class="tabs__toggle is-closeable">Tab Option 3 with really long text</div>\n              </div>\n              <div class="tabs__tabs-group">\n                <div class="tabs__tab">Tab 1 Content</div>\n                <div class="tabs__tab">Tab 2 Content</div>\n                <div class="tabs__tab">Tab 3 Content</div>\n              </div>\n            </div>\n            <div class="soft-half">\n              <button class="btn btn--small js-action--add-tab">Add Tab</button><button class="btn btn--small push-half--left js-action--remove-tab">Remove Tab</button>\n            </div>\n          </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    let tabs;\n    function init() {\n      tabs = commonUI.initializeTabs({selector: \'#scrollableTabsExample\', scrollable: true, responsive: true});\n    }\n    window.onload = init;\n    var btnAddTab = document.querySelector(\'.js-action--add-tab\');\n    var btnRemoveTab = document.querySelector(\'.js-action--remove-tab\');\n    btnAddTab.addEventListener(\'click\', function() {\n      var tabTitle = prompt("Please specify the title of the new tab?");\n      if (tabTitle) {\n        var newTab = tabs.add({title: tabTitle, closeable: true});\n        newTab.tab.innerHTML = \'Tab Content\';\n      }\n    });\n    btnRemoveTab.addEventListener(\'click\', function() {\n      var tabNumber = prompt("Please specify which tab number to remove?");\n      if (tabNumber && !isNaN(tabNumber)) {\n        tabs.remove({index: tabNumber - 1});\n      }\n    });\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Responsive'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Pass in the responsive flag and the tabs will collapse to a dropdown on small screens.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "300px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n  <head>\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n  </head>\n  <body>\n    <div class="tabs js-responsive-tabs" id="responsiveTabsExample">\n      <div class="tabs__toggle-group">\n        <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>\n        <div class="tabs__toggle">Around the World</div>\n        <div class="tabs__toggle">80 Days</div>\n      </div>\n      <div class="tabs__tabs-group">\n        <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n        <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n        <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n      </div>\n    </div>\n  </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    function init() {\n      commonUI.initializeTabs({selector: \'#responsiveTabsExample\', responsive: true});\n    }\n    window.onload = init;\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeTabs({responsive: true});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Vertical'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Tabs will default to a horizontal layout. To change the orientation pass the vertical flag in the initialisation options. Vertical tabs also work responsively, just pass the responsive flag in the initialisation options.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "300px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n        <head>\n          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n          <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n          <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n          <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n        </head>\n        <body>\n          <div class="tabs tabs--vertical" id="verticalTabsExample">\n            <div class="tabs__toggle-group">\n              <div class="tabs__toggle tabs__toggle--active">Jules Verne</div>\n              <div class="tabs__toggle">Around the World</div>\n              <div class="tabs__toggle">80 Days</div>\n            </div>\n            <div class="tabs__tabs-group">\n              <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n              <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n              <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n            </div>\n          </div>\n        </body>\n        <script type="text/javascript" src="js/commonUI.js"></script>\n        <script>\n          function init() {\n            commonUI.initializeTabs({selector: \'#verticalTabsExample\', vertical: true, responsive: true});\n          }\n          window.onload = init;\n        </script>\n        </html>' })
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeTabs({vertical: true, responsive: true});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Light Vertical'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'With light styling. Tabs will default to a horizontal layout. To change the orientation pass the vertical flag in the initialisation options. Vertical tabs also work responsively, just pass the responsive flag in the initialisation options.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '478' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "500px", "border": "0" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n        <head>\n          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n          <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n          <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n          <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n          <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n        </head>\n        <body>\n          <div class="tabs tabs--lite tabs--vertical" id="liteVerticalTabsExample">\n            <div class="tabs__toggle-group visuallyhidden--xs-only soft-half--top soft-half--bottom">\n              <h5 class="tabs__toggle--title push-half">Category Title</h5>\n              <div class="tabs__toggle tabs__toggle--active">Level 2</div>\n              <div class="tabs__toggle">Level 2</div>\n              <div class="tabs__toggle">Level 2</div>\n              <h5 class="tabs__toggle--title push-half--sides push--top push-half--bottom">Category Title</h5>\n              <div class="tabs__toggle">Level 2</div>\n              <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>\n              <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>\n              <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>\n              <div class="tabs__toggle">Level 2</div>\n              <div class="tabs__toggle">Level 2</div>\n            </div>\n            <div class="tabs__tabs-group">\n              <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n              <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n              <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n              <div class="tabs__tab"><h2>Level 2</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n              <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n              <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n              <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n              <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n              <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n            </div>\n          </div>\n        </body>\n        <script type="text/javascript" src="js/commonUI.js"></script>\n        <script>\n          function init() {\n            commonUI.initializeTabs({selector: \'#liteVerticalTabsExample\', vertical: true, responsive: true});\n          }\n          window.onload = init;\n        </script>\n        </html>' })
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeTabs({vertical: true, responsive: true});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="tabs tabs--lite tabs--vertical" id="liteVerticalTabsExample">\n  <div class="tabs__toggle-group visuallyhidden--xs-only soft-half--top soft-half--bottom">\n    <h5 class="tabs__toggle--title push-half">Category Title</h5>\n    <div class="tabs__toggle tabs__toggle--active">Level 2</div>\n    <div class="tabs__toggle">Level 2</div>\n    <div class="tabs__toggle">Level 2</div>\n    <h5 class="tabs__toggle--title push-half--sides push--top push-half--bottom">Category Title</h5>\n    <div class="tabs__toggle">Level 2</div>\n    <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>\n    <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>\n    <div class="tabs__toggle"><span class="tabs__toggle--indent">- Level 3</span></div>\n    <div class="tabs__toggle">Level 2</div>\n    <div class="tabs__toggle">Level 2</div>\n  </div>\n  <div class="tabs__tabs-group">\n    <div class="tabs__tab">But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n    <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n    <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n    <div class="tabs__tab"><h2>Level 2</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n    <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n    <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n    <div class="tabs__tab"><h2>Level 3</h2> But could he even wait till they reached Hong Kong? Fogg had an abominable way of jumping from one boat to another, and, before anything could be effected, might get full under way again for Yokohama.</div>\n    <div class="tabs__tab">Fix decided that he must warn the English authorities, and signal the Rangoon before her arrival. This was easy to do, since the steamer stopped at Singapore, whence there is a telegraphic wire to Hong Kong. He finally resolved, moreover, before acting more positively, to question Passepartout. It would not be difficult to make him talk; and, as there was no time to lose, Fix prepared to make himself known.</div>\n    <div class="tabs__tab">It was now the 30th of October, and on the following day the Rangoon was due at Singapore.</div>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Tabs;
	}(_get__('Component'));
	
	exports.default = _get__('Tabs');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Tabs':
	      return Tabs;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Tabs === 'undefined' ? 'undefined' : _typeof(Tabs);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Tabs, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Tabs)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Progress = function (_get__2) {
	  _inherits(Progress, _get__2);
	
	  function Progress(props) {
	    _classCallCheck(this, Progress);
	
	    return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).call(this, props));
	  }
	
	  _createClass(Progress, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'progress' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Progress Indicators'
	        ),
	        this.props.staticVersion === false ? _get__('React').createElement(Included, {
	          onClick: function onClick() {
	            return _this2.props.onIncludeClick();
	          },
	          included: this.props.included }) : '',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Defaults to 0% progress. Add a inline style to control the progress meter'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'progress' },
	          _get__('React').createElement('span', { className: 'progress--meter', role: 'progressbar', 'aria-valuenow': '0',
	            'aria-valuemin': '0', 'aria-valuemax': '100' })
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'progress' },
	          _get__('React').createElement(
	            'span',
	            { className: 'progress--meter', role: 'progressbar', 'aria-valuenow': '60',
	              'aria-valuemin': '0', 'aria-valuemax': '100', style: { "width": "60%" } },
	            '60%'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'progress' },
	          _get__('React').createElement(
	            'span',
	            { className: 'progress--meter', role: 'progressbar', 'aria-valuenow': '80',
	              'aria-valuemin': '0', 'aria-valuemax': '100', style: { "width": "80%" } },
	            '80%'
	          )
	        ),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Progress Indicators'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Defaults to 0% progress. Add a inline style to control the progress meter.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'For the various sizes, add progress--small, progress--medium, or progress--large.'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'progress' }),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'div',
	            { className: 'progress progress--small' },
	            _get__('React').createElement(
	              'span',
	              { className: 'progress--meter', role: 'progressbar', 'aria-valuenow': '0',
	                'aria-valuemin': '0', 'aria-valuemax': '100', style: { "width": "45%" } },
	              '45%'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'progress progress--medium' },
	            _get__('React').createElement(
	              'span',
	              { className: 'progress--meter', role: 'progressbar', 'aria-valuenow': '60',
	                'aria-valuemin': '0', 'aria-valuemax': '100', style: { "width": "60%" } },
	              '60%'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'progress progress--large' },
	            _get__('React').createElement(
	              'span',
	              { className: 'progress--meter', role: 'progressbar', 'aria-valuenow': '80',
	                'aria-valuemin': '0', 'aria-valuemax': '100', style: { "width": "80%" } },
	              '80%'
	            )
	          ),
	          _get__('React').createElement('br', null)
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="progress">\n  <span class="progress--meter" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></span>\n</div>\n<div class="progress">\n  <span class="progress--meter" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width:60%">60%</span>\n</div>\n<div class="progress">\n  <span class="progress--meter" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width:80%">80%</span>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Progress;
	}(_get__('Component'));
	
	exports.default = _get__('Progress');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Progress':
	      return Progress;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Progress === 'undefined' ? 'undefined' : _typeof(Progress);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Progress, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Progress)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Datepicker = function (_get__2) {
	  _inherits(Datepicker, _get__2);
	
	  function Datepicker(props) {
	    _classCallCheck(this, Datepicker);
	
	    var _this = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, props));
	
	    _this.state = {
	      theme: 'default'
	    };
	    _this.initializeDatepickers = _this.initializeDarkDatepickers.bind(_this);
	    _this.datePickerIdMap = {
	      timepicker: {
	        'default': 'timepicker',
	        'is-dark': 'timepickerDark',
	        'is-dark dark-blue': 'timepickerDarkBlue'
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Datepicker, [{
	    key: 'initializeDarkDatepickers',
	    value: function initializeDarkDatepickers() {
	      _get__('commonUI').initializeDatepicker('#timepicker', {
	        enableTime: true,
	        dateFormat: 'Y-m-d H:i'
	      });
	      _get__('commonUI').initializeDatepicker('#timepickerDark', {
	        enableTime: true,
	        dateFormat: 'Y-m-d H:i',
	        onReady: function onReady(index, info, element) {
	          element.calendarContainer.classList.add('is-dark');
	        }
	      });
	      _get__('commonUI').initializeDatepicker('#timepickerDarkBlue', {
	        enableTime: true,
	        dateFormat: 'Y-m-d H:i',
	        onReady: function onReady(index, info, element) {
	          element.calendarContainer.classList.add('is-dark');
	          element.calendarContainer.classList.add('dark-blue');
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.initializeDatepickers();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.state.theme;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'datepicker' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Date Picker'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The date picker comes in 3 different formats. Default, Time Picker and Range Selection.'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'datepicker' }),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'h4',
	            null,
	            'Default Date Picker'
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'The default date picker with no config will only allow you to select a date.'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'form-fields' },
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'default' },
	                'Default Date Picker'
	              ),
	              _get__('React').createElement('input', { type: 'text', className: 'text-input', id: 'default', placeholder: 'Please select date' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'icon__wrapper icon__wrapper--datepicker' },
	                _get__('React').createElement('i', { className: 'fa fa-calendar' })
	              )
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'p',
	            null,
	            'This is a javascript enabled component. You must initialize it using the following snippet:'
	          ),
	          _get__('React').createElement(
	            'pre',
	            null,
	            _get__('React').createElement(
	              'code',
	              { className: 'language-javascript' },
	              '\n            commonUI.initializeDatepicker(\'#default\', {});\n          '
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'button',
	            { type: 'button', className: 'btn btn--secondary show-code' },
	            _get__('React').createElement('i', { className: 'fa fa-plus' }),
	            'View source'
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'pre',
	            { className: 'hide-code' },
	            _get__('React').createElement(
	              'code',
	              { className: 'language-html' },
	              '<ul class="form-fields">\n            <li>\n              <label for="default">Default Date Picker</label>\n              <input type="text" class="text-input" id="default" placeholder="Please select date" />\n              <div class="icon__wrapper icon__wrapper--datepicker">\n                  <i class="fa fa-calendar"></i>\n              </div>\n            </li>\n          </ul>'
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'h4',
	            null,
	            'Date Picker with Time Picker'
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'The date picker with a time picker will only allow you to select a date followed by the time.'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'form-fields' },
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'timepicker' },
	                'Date Picker with Time Picker'
	              ),
	              _get__('React').createElement('input', { type: 'text', className: 'text-input', id: 'timepicker', placeholder: 'Please select date & time' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'icon__wrapper icon__wrapper--datepicker' },
	                _get__('React').createElement('i', { className: 'fa fa-calendar' })
	              )
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'p',
	            null,
	            'This is a javascript enabled component. You must initialize it using the following snippet:'
	          ),
	          _get__('React').createElement(
	            'pre',
	            null,
	            _get__('React').createElement(
	              'code',
	              { className: 'language-javascript' },
	              '\n            commonUI.initializeDatepicker(\'#timepicker\', {\n              enableTime: true,\n              dateFormat: \'Y-m-d H:i\',\n            });\n          '
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'button',
	            { type: 'button', className: 'btn btn--secondary show-code' },
	            _get__('React').createElement('i', { className: 'fa fa-plus' }),
	            'View source'
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'pre',
	            { className: 'hide-code' },
	            _get__('React').createElement(
	              'code',
	              { className: 'language-html' },
	              '<ul class="form-fields">\n            <li>\n              <label for="timepicker">Date Picker with Time Picker</label>\n              <input type="text" class="text-input" id="timepicker" placeholder="Please select date & time" />\n              <div class="icon__wrapper icon__wrapper--datepicker">\n                  <i class="fa fa-calendar"></i>\n              </div>\n            </li>\n          </ul>'
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'h4',
	            null,
	            'Date Picker with Range'
	          ),
	          _get__('React').createElement(
	            'p',
	            null,
	            'The date picker with range will only allow you to select a range of dates.'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'form-fields' },
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'range' },
	                'Date Picker with Range'
	              ),
	              _get__('React').createElement('input', { type: 'text', className: 'text-input', id: 'range', placeholder: 'Please select date range' }),
	              _get__('React').createElement(
	                'div',
	                { className: 'icon__wrapper icon__wrapper--datepicker' },
	                _get__('React').createElement('i', { className: 'fa fa-calendar' })
	              )
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'p',
	            null,
	            'This is a javascript enabled component. You must initialize it using the following snippet:'
	          ),
	          _get__('React').createElement(
	            'pre',
	            null,
	            _get__('React').createElement(
	              'code',
	              { className: 'language-javascript' },
	              '\n              commonUI.initializeDatepicker(\'#range\', {\n                mode: "range",\n              });\n            '
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'button',
	            { type: 'button', className: 'btn btn--secondary show-code' },
	            _get__('React').createElement('i', { className: 'fa fa-plus' }),
	            'View source'
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'pre',
	            { className: 'hide-code' },
	            _get__('React').createElement(
	              'code',
	              { className: 'language-html' },
	              '<ul class="form-fields">\n            <li>\n              <label for="range">Date Picker with Range</label>\n              <input type="text" class="text-input" id="range" placeholder="Please select date range" />\n              <div class="icon__wrapper icon__wrapper--datepicker">\n                <i class="fa fa-calendar"></i>\n              </div>\n            </li>\n          </ul>'
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('hr', null)
	        ),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Datepicker;
	}(_get__('Component'));
	
	exports.default = _get__('Datepicker');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'Datepicker':
	      return Datepicker;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Datepicker === 'undefined' ? 'undefined' : _typeof(Datepicker);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Datepicker, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Datepicker)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Callouts = function Callouts() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "callouts" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Callouts"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "As of v1.15 callouts have been incorporated into panels."
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Please refer to the ",
	      _get__("React").createElement(
	        "a",
	        { href: "core#panels" },
	        "Panels"
	      ),
	      " section of the library."
	    ),
	    _get__("React").createElement("hr", null)
	  );
	};
	
	exports.default = _get__("Callouts");
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "Callouts":
	      return Callouts;
	
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Callouts === "undefined" ? "undefined" : _typeof(Callouts);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Callouts, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Callouts)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cards = function (_get__2) {
	  _inherits(Cards, _get__2);
	
	  function Cards(props) {
	    _classCallCheck(this, Cards);
	
	    return _possibleConstructorReturn(this, (Cards.__proto__ || Object.getPrototypeOf(Cards)).call(this, props));
	  }
	
	  _createClass(Cards, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'cards' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Cards'
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Basic Card'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To create a basic card, add a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'card'
	          ),
	          ' to any block-level element. Each card can contain an optional ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'card__header'
	          ),
	          ' and an optional ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'card__body'
	          ),
	          '. By default, each card will consume 100% of the width of its container, therefore a single card implemented within a full width container will render as follows:'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'card' },
	          _get__('React').createElement(
	            'div',
	            { className: 'card__header' },
	            _get__('React').createElement(
	              'span',
	              { className: 'card__header-title' },
	              'Card Header Title'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'card__body' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'The default card implementation has no pre-defined styles for the body of the card (with the exception of padding), to allow the user to define their own content styles.'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="card">\n  <div class="card__header">\n    <span class="card__header-title">Card Header Title</span>\n  </div>\n  <div class="card__body">\n    <p>The default card implementation has no pre-defined styles for the body of the card (with the exception of padding), to allow the user to define their own content styles.</p>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Optionally, the card header can also contain a "pre-title" element immediately before the title in the header by creating an element with a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'card__header-pre-title'
	          ),
	          '. This could be used, for example, to denote status and/or context via an icon and/or background color.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'card' },
	          _get__('React').createElement(
	            'div',
	            { className: 'card__header' },
	            _get__('React').createElement(
	              'span',
	              { className: 'card__header-pre-title' },
	              _get__('React').createElement('i', { className: 'fa fa-bar-chart' })
	            ),
	            _get__('React').createElement(
	              'span',
	              { className: 'card__header-title' },
	              'Card Header Title'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'card__body' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="card">\n  <div class="card__header">\n    <span class="card__header-pre-title"><i class="fa fa-bar-chart"></i></span>\n    <span class="card__header-title">Card Header Title</span>\n  </div>\n  <div class="card__body">\n    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Grid Layout'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To render multiple cards in a responsive grid, use the ',
	          _get__('React').createElement(
	            'a',
	            { href: '#grid' },
	            'grid'
	          ),
	          ' layout to wrap each card. ',
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' Some of the styling implemented in the example below is purely for demonstration purposes only and therefore is not included in the main Common UI library.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1602' },
	            '1600px (xlg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "716px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n          <html>\n            <head>\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n              <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n            </head>\n            <body>\n\n              <div class="grid">\n\n                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n\n                  <div class="card">\n                    <div class="card__header">\n                      <span class="card__header-pre-title card__header-pre-title--positive card__header-pre-title--new"></span>\n                      <span class="card__header-title">Active</span>\n                      <span class="card__header-meta">01/11/16 \u2013 12/31/16</span>\n                    </div>\n                    <div class="card__body">\n                      <div class="card__content">\n                        <a class="card__body-title">Ultra 10-Year Futures Market Maker Program</a>\n                        <ul class="push--ends">\n                          <li>Type: <strong>Futures</strong></li>\n                          <li>Asset Class: <strong>Interest Rates</strong></li>\n                          <li>Exchange: <strong>CBOT</strong></li>\n                        </ul>\n                      </div>\n                      <div class="card__actions">\n                        <div class="push--bottom">\n                          <a>View Program Accounts</a>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n\n                  <div class="card">\n                    <div class="card__header">\n                      <span class="card__header-pre-title card__header-pre-title--warning"></span>\n                      <span class="card__header-title">Upcoming</span>\n                      <span class="card__header-meta">01/01/16 \u2013 12/31/16</span>\n                    </div>\n                    <div class="card__body">\n                      <div class="card__content">\n                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>\n                        <p class="card__body-subtitle">Program Details Not Available</p>\n                        <ul class="meta-list push--ends">\n                          <li>Type: <strong>Futures</strong></li>\n                          <li>Asset Class: <strong>Agricultural</strong></li>\n                          <li>Exchange: <strong>CBOT</strong></li>\n                        </ul>\n                      </div>\n                      <div class="card__actions">\n                        <div class="push--bottom">\n                          <a>View Program Accounts</a>\n                        </div>\n                        <button class="btn card__action">Renew Program</button>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n\n                  <div class="card">\n                    <div class="card__header">\n                      <span class="card__header-pre-title card__header-pre-title--default"></span>\n                      <span class="card__header-title">Expired</span>\n                      <span class="card__header-meta">01/01/16 \u2013 12/31/16</span>\n                    </div>\n                    <div class="card__body">\n                      <div class="card__content">\n                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>\n                        <p class="card__body-subtitle">Program Details Not Available</p>\n                        <ul class="meta-list push--ends">\n                          <li>Type: <strong>Futures</strong></li>\n                          <li>Asset Class: <strong>Agricultural</strong></li>\n                          <li>Exchange: <strong>CBOT</strong></li>\n                        </ul>\n                      </div>\n                      <div class="card__actions">\n                        <div class="push--bottom">\n                          <a>View Program Accounts</a>\n                        </div>\n                        <button class="btn card__action">Renew Program</button>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n\n                  <div class="card">\n                    <div class="card__header">\n                      <span class="card__header-pre-title card__header-pre-title--warning"></span>\n                      <span class="card__header-title">Upcoming</span>\n                      <span class="card__header-meta">01/01/16 \u2013 12/31/16</span>\n                    </div>\n                    <div class="card__body">\n                      <div class="card__content">\n                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>\n                        <p class="card__body-subtitle">Program Details Not Available</p>\n                        <ul class="meta-list push--ends">\n                          <li>Type: <strong>Futures</strong></li>\n                          <li>Asset Class: <strong>Agricultural</strong></li>\n                          <li>Exchange: <strong>CBOT</strong></li>\n                        </ul>\n                      </div>\n                      <div class="card__actions">\n                        <div class="push--bottom">\n                          <a>View Program Accounts</a>\n                        </div>\n                        <button class="btn card__action">Renew Program</button>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n\n                  <div class="card">\n                    <div class="card__header">\n                      <span class="card__header-pre-title card__header-pre-title--default"></span>\n                      <span class="card__header-title">Expired</span>\n                      <span class="card__header-meta">01/01/16 \u2013 12/31/16</span>\n                    </div>\n                    <div class="card__body">\n                      <div class="card__content">\n                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>\n                        <p class="card__body-subtitle">Program Details Not Available</p>\n                        <ul class="meta-list push--ends">\n                          <li>Type: <strong>Futures</strong></li>\n                          <li>Asset Class: <strong>Agricultural</strong></li>\n                          <li>Exchange: <strong>CBOT</strong></li>\n                        </ul>\n                      </div>\n                      <div class="card__actions">\n                        <div class="push--bottom">\n                          <a>View Program Accounts</a>\n                        </div>\n                        <button class="btn card__action">Renew Program</button>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n                <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n\n                  <div class="card">\n                    <div class="card__header">\n                      <span class="card__header-pre-title card__header-pre-title--warning"></span>\n                      <span class="card__header-title">Upcoming</span>\n                      <span class="card__header-meta">01/01/16 \u2013 12/31/16</span>\n                    </div>\n                    <div class="card__body">\n                      <div class="card__content">\n                        <p class="card__body-title">Grain and Oilseed Futures Volume Incentive Program</p>\n                        <p class="card__body-subtitle">Program Details Not Available</p>\n                        <ul class="meta-list push--ends">\n                          <li>Type: <strong>Futures</strong></li>\n                          <li>Asset Class: <strong>Agricultural</strong></li>\n                          <li>Exchange: <strong>CBOT</strong></li>\n                        </ul>\n                      </div>\n                      <div class="card__actions">\n                        <div class="push--bottom">\n                          <a>View Program Accounts</a>\n                        </div>\n                        <button class="btn card__action">Renew Program</button>\n                      </div>\n                    </div>\n                  </div>\n\n                </div>\n\n              </div>\n\n            </body>\n          </html>\n        ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n\n  <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n    <div class="card">\n      <!-- card content -->\n    </div>\n  </div>\n\n  <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n    <div class="card">\n      <!-- card content -->\n    </div>\n  </div>\n\n  ...\n\n  <div class="grid__col-xlg-3 grid__col-lg-4 grid__col-md-6 grid__col-sm-12">\n    <div class="card">\n      <!-- card content -->\n    </div>\n  </div>\n\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Cards;
	}(_get__('Component'));
	
	exports.default = _get__('Cards');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Cards':
	      return Cards;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Cards === 'undefined' ? 'undefined' : _typeof(Cards);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Cards, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Cards)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Media = function (_get__2) {
	  _inherits(Media, _get__2);
	
	  function Media(props) {
	    _classCallCheck(this, Media);
	
	    return _possibleConstructorReturn(this, (Media.__proto__ || Object.getPrototypeOf(Media)).call(this, props));
	  }
	
	  _createClass(Media, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'mediaobjects' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Media Objects'
	        ),
	        this.props.staticVersion === false ? _get__('React').createElement(_get__('Included'), {
	          onClick: function onClick() {
	            return _this2.props.onIncludeClick();
	          },
	          included: this.props.included }) : '',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Media objects are useful components for displaying an item, usually an image, alongside some content, usually text. You could put lists, grids, or even other media objects inside. Ensure your images follow the 16:9 aspect ratios'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Helper classes exist to aid how the images and text display. These limit the images to a certain percentage.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            '.max-width-10\n.max-width-20\n.max-width-30\n.max-width-40\n.max-width-50\n.max-width-60\n.max-width-70\n.max-width-80\n.max-width-90\n.max-width-100'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "500px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n<html>\n  <head>\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n  </head>\n  <body>\n    <div class="media push--bottom">\n        <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>\n        <div class="media__body"><h3 class="flush"><a href="javascript:;">CME Group to Host Grain Expert Panel Following USDA\'s March 9 Crop Production and WASDE reports</a></h3>Live expert webcast to discuss the USDA reports and their impact on grain futures markets.</div>\n    </div>\n    <div class="media media--rev push--bottom">\n        <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>\n        <div class="media__body"><h3 class="flush"><a href="javascript:;">\'Brexit\' Can Cause Event Risk for Euro, Pound</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how the \'Brexit\' vote could cause event risk for the British pound, euro.</div>\n    </div>\n    <div class="media push--bottom">\n        <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>\n        <div class="media__body"><h3 class="flush"><a href="javascript:;">Will Weakening El Nino Morph Into La Nina?</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how agriculture markets will see greater volatility if El Nino turns into La Nina.</div>\n    </div>\n  </body>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="media push--bottom">\n    <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>\n    <div class="media__body"><h3 class="flush"><a href="#">CME Group to Host Grain Expert Panel Following USDA\'s March 9 Crop Production and WASDE reports</a></h3>Live expert webcast to discuss the USDA reports and their impact on grain futures markets.</div>\n</div>\n<div class="media media--rev push--bottom">\n    <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>\n    <div class="media__body"><h3 class="flush"><a href="#">\'Brexit\' Can Cause Event Risk for Euro, Pound</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how the \'Brexit\' vote could cause event risk for the British pound, euro.</div>\n</div>\n<div class="media push--bottom">\n    <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--20"/>\n    <div class="media__body"><h3 class="flush"><a href="#">Will Weakening El Nino Morph Into La Nina?</a></h3>Watch CME Group Chief Economist Blu Putnam on Futures Institute discuss how agriculture markets will see greater volatility if El Nino turns into La Nina.</div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "500px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n<html>\n  <head>\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n  </head>\n  <body>\n    <div class="grid">\n      <div class="grid__col-xs-12 grid__col-md-6">\n        <div class="media">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n            <div class="media__body"><h3 class="flush"><a href="javascript:;">Indicative Opening Price Overview</a></h3>Watch an overview of Indicative Opening Price, including a definition of IOP and a demonstration of IOP scenarios.</div>\n        </div>\n      </div>\n      <div class="grid__col-xs-12 grid__col-md-6">\n        <div class="media">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n            <div class="media__body"><h3 class="flush"><a href="javascript:;">OTC Credit Default Swaps Overview</a></h3>Get an overview of OTC Credit Default Swaps at CME Group, including our credit offering of CDX and iTraxx index.</div>\n        </div>\n      </div>\n      <div class="grid__col-xs-12 grid__col-md-6">\n        <div class="media">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n            <div class="media__body"><h3 class="flush"><a href="javascript:;">NYMEX Energy Options Update</a></h3>Watch Jeff White, Senior Director of Energy Products at CME Group, present a brief update on NYMEX Energy Options trading.</div>\n        </div>\n      </div>\n      <div class="grid__col-xs-12 grid__col-md-6">\n        <div class="media">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n            <div class="media__body"><h3 class="flush"><a href="javascript:;">Corn, Soy and Wheat Volatility Set to Spike?</a></h3>Five factors, including the course of the U.S. dollar, that could change the low-volatility environment in grain markets lulled by ample supplies.</div>\n        </div>\n      </div>\n    </div>\n  </body>\n</html>' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n<div class="grid__col-xs-12 grid__col-md-6">\n  <div class="media">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n      <div class="media__body"><h3 class="flush"><a href="#">Indicative Opening Price Overview</a></h3>Watch an overview of Indicative Opening Price, including a definition of IOP and a demonstration of IOP scenarios.</div>\n  </div>\n</div>\n<div class="grid__col-xs-12 grid__col-md-6">\n  <div class="media">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n      <div class="media__body"><h3 class="flush"><a href="#">OTC Credit Default Swaps Overview</a></h3>Get an overview of OTC Credit Default Swaps at CME Group, including our credit offering of CDX and iTraxx index.</div>\n  </div>\n</div>\n<div class="grid__col-xs-12 grid__col-md-6">\n  <div class="media">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n      <div class="media__body"><h3 class="flush"><a href="#">NYMEX Energy Options Update</a></h3>Watch Jeff White, Senior Director of Energy Products at CME Group, present a brief update on NYMEX Energy Options trading.</div>\n  </div>\n</div>\n<div class="grid__col-xs-12 grid__col-md-6">\n  <div class="media">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img max-width--50"/>\n      <div class="media__body"><h3 class="flush"><a href="#">Corn, Soy and Wheat Volatility Set to Spike?</a></h3>Five factors, including the course of the U.S. dollar, that could change the low-volatility environment in grain markets lulled by ample supplies.</div>\n  </div>\n</div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "500px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n  <html>\n  <head>\n  <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n  </head>\n  <body>\n    <div class="grid">\n      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n        <div class="media media--stacked">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n            <div class="media__body">\n              <h3 class="push-half--top"><a href="javascript:;">Market Regulation Home</a></h3>\n              Read an overview of the Market Regulation department.\n            </div>\n        </div>\n      </div>\n      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n        <div class="media media--stacked">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n            <div class="media__body">\n              <h3 class="push-half--top"><a href="javascript:;">Regulatory Outreach</a></h3>\n              Learn about our Regulatory Outreach program for information and resources to meet your compliance needs.\n            </div>\n        </div>\n      </div>\n      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n        <div class="media media--stacked">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n            <div class="media__body">\n              <h3 class="push-half--top"><a href="javascript:;">Disciplinary Actions</a></h3>\n              View a full listing of the latest Disciplinary Actions.\n            </div>\n        </div>\n      </div>\n      <div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n        <div class="media media--stacked">\n            <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n            <div class="media__body">\n              <h3 class="push-half--top"><a href="javascript:;">Rule Filings</a></h3>\n              View the latest rule amendments, as well as an archive of amendments.\n            </div>\n        </div>\n      </div>\n    </div>\n  </body>\n</html>' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n  <div class="media media--stacked">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n      <div class="media__body">\n        <h3 class="push-half--top"><a href="#">Market Regulation Home</a></h3>\n        Read an overview of the Market Regulation department.\n      </div>\n  </div>\n</div>\n<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n  <div class="media media--stacked">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n      <div class="media__body">\n        <h3 class="push-half--top"><a href="#">Regulatory Outreach</a></h3>\n        Learn about our Regulatory Outreach program for information and resources to meet your compliance needs.\n      </div>\n  </div>\n</div>\n<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n  <div class="media media--stacked">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n      <div class="media__body">\n        <h3 class="push-half--top"><a href="#">Disciplinary Actions</a></h3>\n        View a full listing of the latest Disciplinary Actions.\n      </div>\n  </div>\n</div>\n<div class="grid__col-xs-12 grid__col-sm-6 grid__col-md-3">\n  <div class="media media--stacked">\n      <img src="https://dummyimage.com/459x293" alt="" class="media__img"/>\n      <div class="media__body">\n        <h3 class="push-half--top"><a href="#">Rule Filings</a></h3>\n        View the latest rule amendments, as well as an archive of amendments.\n      </div>\n  </div>\n</div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Media;
	}(_get__('Component'));
	
	exports.default = _get__('Media');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Media':
	      return Media;
	
	    case 'React':
	      return _react2.default;
	
	    case 'Included':
	      return _Included2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Media === 'undefined' ? 'undefined' : _typeof(Media);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Media, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Media)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Wells = function Wells() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "wells" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Wells"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "As of v1.15 wells have been incorporated into panels."
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Please refer to the ",
	      _get__("React").createElement(
	        "a",
	        { href: "#panels" },
	        "Panels"
	      ),
	      " section of the library."
	    ),
	    _get__("React").createElement("hr", null)
	  );
	};
	
	exports.default = _get__("Wells");
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "Wells":
	      return Wells;
	
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Wells === "undefined" ? "undefined" : _typeof(Wells);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Wells, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Wells)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Grid = function (_get__2) {
	  _inherits(Grid, _get__2);
	
	  function Grid(props) {
	    _classCallCheck(this, Grid);
	
	    return _possibleConstructorReturn(this, (Grid.__proto__ || Object.getPrototypeOf(Grid)).call(this, props));
	  }
	
	  _createClass(Grid, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'grid' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Grid'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'We are using a ',
	          _get__('React').createElement(
	            'a',
	            { href: 'http://leejordan.github.io/reflex/docs/' },
	            'flexbox 12 column based grid system'
	          ),
	          ' that should be relatively familiar if you have used another grid system.',
	          _get__('React').createElement('br', null),
	          ' Though flexbox has ',
	          _get__('React').createElement(
	            'a',
	            { href: 'http://caniuse.com/#search=flexbox' },
	            'good support'
	          ),
	          ', the grid will fallback to using inline-block to support older browsers.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '483' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '771' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '995' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1203' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "347px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n              <html>\n                <head>\n                  <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n                  <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n                </head>\n                <body>\n                  <div class="grid sample-grid"">\n            <div class="grid__col-4">\n              grid__col-4\n            </div>\n            <div class="grid__col-4">\n              grid__col-4\n            </div>\n            <div class="grid__col-4">\n              grid__col-4\n            </div>\n            <div class="grid__col-xs-4">\n              grid__col-xs-4\n            </div>\n            <div class="grid__col-xs-8">\n              grid__col-xs-8\n            </div>\n            <div class="grid__col-sm-6">\n              grid__col-sm-6\n            </div>\n            <div class="grid__col-sm-6">\n              grid__col-sm-6\n            </div>\n            <div class="grid__col-md-8">\n              grid__col-md-8\n            </div>\n            <div class="grid__col-md-4">\n              grid__col-md-4\n            </div>\n            <div class="grid__col-lg-4">\n              grid__col-lg-4\n            </div>\n            <div class="grid__col-lg-8">\n              grid__col-lg-8\n            </div>\n            </div>\n                </body>\n              </html>\n            ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n  <div class="grid__col-4">\n    grid__col-4\n  </div>\n  <div class="grid__col-4">\n    grid__col-4\n  </div>\n  <div class="grid__col-4">\n    grid__col-5\n  </div>\n  <div class="grid__col-xs-4">\n    grid__col-xs-4\n  </div>\n  <div class="grid__col-xs-8">\n    grid__col-xs-8\n  </div>\n  <div class="grid__col-sm-6">\n    grid__col-sm-6\n  </div>\n  <div class="grid__col-sm-6">\n    grid__col-sm-6\n  </div>\n  <div class="grid__col-md-8">\n    grid__col-md-8\n  </div>\n  <div class="grid__col-md-4">\n    grid__col-md-4\n  </div>\n  <div class="grid__col-lg-4">\n    grid__col-lg-4\n  </div>\n  <div class="grid__col-lg-8">\n    grid__col-lg-8\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'These modifier classes determine grid columns at various viewport sizes. A grid built using numbered columns in this way will remain fully intact in the inline-block fallback.'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--cells table--light table--comfy table--striped table--responsive js-table--responsive' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                null,
	                'Class prefix'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'grid__col-'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'grid__col-xs-'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'grid__col-sm-'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'grid__col-md-'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'grid__col-lg-'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'grid__col-xlg-'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'grid__col-auto-'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Collapses at'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'does not collapse'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'around 480px',
	                _get__('React').createElement('br', null),
	                'think palm device'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'around 768px',
	                _get__('React').createElement('br', null),
	                'think portrait tablet'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'around 992px',
	                _get__('React').createElement('br', null),
	                'think tablet'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'around 1200px',
	                _get__('React').createElement('br', null),
	                'think laptop '
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'around 1600px',
	                _get__('React').createElement('br', null),
	                'think desktop'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Dynamic sizing'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Media Queries'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Media queries are built using ems to be compatible with users that alter their font size and use the zoom feature.',
	          _get__('React').createElement('br', null),
	          'Use breakpoints to suit the content and not specific device sizes.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            '@media screen and (max-width: 29.938em) { /* Insert styles */ } /* XS only */\n@media screen and (min-width: 30em) and (max-width: 47.938em) { /* Insert styles */ } /* SM only */\n@media screen and (min-width: 48em) { /* Insert styles */ } /* SM and up */\n@media screen and (min-width: 48em) and (max-width: 61.938em) { /* Insert styles */ } /* MD only */\n@media screen and (min-width: 62em) { /* Insert styles */ } /* MD and up */\n@media screen and (min-width: 62em) and (max-width: 74.938em) { /* Insert styles */ } /* LG only */\n@media screen and (min-width: 75em) { /* Insert styles */ } /* LG and up */\n@media screen and (min-width: 100em) { /* Insert styles */ } /* XLG and up */\n\n@media screen and (max-width: 47.938em) { /* Insert styles */ } /* \'Palm\' devices */\n@media screen and (max-width: 74.938em) { /* Insert styles */ } /* \'Portable\' devices */\n@media screen and (min-width: 75em) { /* Insert styles */ } /* \'Desktop\' devices */\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx) { /* Insert styles */ } /* Retina */'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'These helper classes work in conjunction with the grid breakpoints to allow finer control over elements.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            '.visuallyhidden--xs-only\n.visuallyhidden--sm-only\n.visuallyhidden--sm-and-up\n.visuallyhidden--md-only\n.visuallyhidden--md-and-up\n.visuallyhidden--lg-only\n.visuallyhidden--lg-and-up\n.visuallyhidden--xlg-and-up\n\n.visuallyhidden--palm\n.visuallyhidden--lap\n.visuallyhidden--lap-and-up\n.visuallyhidden--portable\n.visuallyhidden--desk\n\n.visuallyhidden--retina'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Grid modifiers'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'By default, the grid will wrap. You can prevent this behaviour with ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--no-wrap'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid grid--no-wrap sample-grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'these'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'columns'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-10' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'do not collapse'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The direction of the children can be reversed with ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--wrap-reverse'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid grid--wrap-reverse sample-grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am first in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am second in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-10' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am third in the markup'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Cross axis modifiers'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Equal height columns by default'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Over after behold was living together tree is very sixth let bring fish. Forth behold they\'re fly deep.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          '\'Start\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-start'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid grid--align-start' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Over after behold was living together tree is very sixth let bring fish. Forth behold they\'re fly deep.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          '\'End\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-end'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid grid--align-end' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Over after behold was living together tree is very sixth let bring fish. Forth behold they\'re fly deep.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          '\'Center\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-center'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid grid--align-center' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Over after behold was living together tree is very sixth let bring fish. Forth behold they\'re fly deep.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          '\'Baseline\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-baseline'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid grid--align-baseline' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              { style: { "fontSize": "30px", "margin": "0" } },
	              'It makes the'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              { style: { "fontSize": "10px", "margin": "0" } },
	              'text all line up'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              { style: { "fontSize": "20px", "margin": "0" } },
	              'despite size'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Cross axis positioning'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Stretch by default'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Great blessed'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Years night'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Firmament you'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'To lights'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Place good '
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Content \'start\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-content-start'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--align-content-start' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Great blessed'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Years night'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Firmament you'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'To lights'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Place good '
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Content \'end\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-content-end'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--align-content-end' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Great blessed'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Years night'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Firmament you'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'To lights'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Place good '
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Content \'center\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-content-center'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--align-content-center' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Great blessed'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Years night'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Firmament you'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'To lights'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Place good '
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Content \'space-between\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-content-space-between'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--align-content-space-between' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Great blessed'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Years night'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Firmament you'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'To lights'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Place good '
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Content \'space-around\' aligned',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--align-content-space-around'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--align-content-space-around' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Great blessed'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Years night'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Firmament you'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'To lights'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Place good '
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Main axis alignment'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          '\'Start\' aligned by default'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first. Shall, fourth Greater cattle.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          '\'End\' aligned ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--justify-end'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--justify-end' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first. Shall, fourth Greater cattle.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Center aligned ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--justify-center'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--justify-center' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first. Shall, fourth Greater cattle.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Space between aligned ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--justify-space-between'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--justify-space-between' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first. Shall, fourth Greater cattle.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Space around aligned ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--justify-space-around'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--justify-space-around' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'First appear years night there the in them rule.'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Be can\'t winged good for also saying first. Shall, fourth Greater cattle.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Direction'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          '\'Rows\' by default'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'first'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'second'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'third'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fourth'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fifth'
	              ),
	              ' in the markup'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Row Reverse ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--direction-row-reverse'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--direction-row-reverse' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'first'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'second'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'third'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fourth'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fifth'
	              ),
	              ' in the markup'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Column ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--direction-column'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--direction-column' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'first'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'second'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'third'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fourth'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fifth'
	              ),
	              ' in the markup'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Column Reverse',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--direction-column-reverse'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big grid--direction-column-reverse' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'first'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'second'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'third'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fourth'
	              ),
	              ' in the markup'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'fifth'
	              ),
	              ' in the markup'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Ordering grid elements'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--order-<n>'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4 grid--order-2' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'first'
	              ),
	              ' in the markup but ordered second'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4 grid--order-3' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'second'
	              ),
	              ' in the markup but ordered third'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4 grid--order-1' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am ',
	              _get__('React').createElement(
	                'strong',
	                null,
	                'third'
	              ),
	              ' in the markup but ordered first'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n  <div class="grid__col-4 grid--order-2">\n      <p>I am <strong>first</strong> in the markup but ordered second</p>\n  </div>\n  <div class="grid__col-4 grid--order-3">\n      <p>I am <strong>second</strong> in the markup but ordered third</p>\n  </div>\n  <div class="grid__col-4 grid--order-1">\n      <p>I am <strong>third</strong> in the markup but ordered first</p>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Advanced grid layout'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid__cell-footer'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid sample-grid--big' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-12' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I am a cell'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'grid__cell-footer' },
	              _get__('React').createElement(
	                'p',
	                null,
	                'I am a ',
	                _get__('React').createElement(
	                  'strong',
	                  null,
	                  '.grid__cell-footer'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n    <div class="grid__col-12">\n        <p>I am a cell</p>\n        <div class="grid__cell-footer">\n            <p>I am a <strong>.grid__cell-footer</strong></p>\n        </div>\n    </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid--bleed'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid grid--bleed sample-grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I have no padding'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I have no padding'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I have no padding'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid grid--bleed">\n    <div class="grid__col-4">\n        <p>I have no padding</p>\n    </div>\n    <div class="grid__col-4">\n        <p>I have no padding</p>\n    </div>\n    <div class="grid__col-4">\n        <p>I have no padding</p>\n    </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid__col--bleed'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Normal'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4 grid__col--bleed' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'I have no padding'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'Normal'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n    <div class="grid__col-4">\n        <p>Normal</p>\n    </div>\n    <div class="grid__col-4 grid__col--bleed">\n        <p>I have no padding</p>\n    </div>\n    <div class="grid__col-4">\n        <p>Normal</p>\n    </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.grid__cell--padding-x'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid sample-grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4 grid__cell--padding-sm' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'padding-sm'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4 grid__cell--padding-md' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'padding-md'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-4 grid__cell--padding-lg' },
	            _get__('React').createElement(
	              'p',
	              null,
	              'padding-lg'
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n    <div class="grid__col-4 grid__cell--padding-sm">\n        <p>padding-sm</p>\n    </div>\n    <div class="grid__col-4 grid__cell--padding-md">\n        <p>padding-md</p>\n    </div>\n    <div class="grid__col-4 grid__cell--padding-lg">\n        <p>padding-lg</p>\n    </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Grid;
	}(_get__('Component'));
	
	exports.default = _get__('Grid');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Grid':
	      return Grid;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Grid === 'undefined' ? 'undefined' : _typeof(Grid);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Grid, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Grid)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tooltips = function (_get__2) {
	  _inherits(Tooltips, _get__2);
	
	  function Tooltips(props) {
	    _classCallCheck(this, Tooltips);
	
	    return _possibleConstructorReturn(this, (Tooltips.__proto__ || Object.getPrototypeOf(Tooltips)).call(this, props));
	  }
	
	  _createClass(Tooltips, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'tooltips' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Tooltips'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Hover over this ',
	          _get__('React').createElement(
	            'abbr',
	            { 'data-toggle': 'tooltip', rel: 'tooltip', title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
	            'text'
	          ),
	          ' to view a tooltip'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<p>Hover over this <abbr rel="tooltip" title="I am a tooltip">text</abbr> to view a tooltip</p>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Tooltips Styles'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Hover on this text styles\xA0\xA0',
	          _get__('React').createElement(
	            'abbr',
	            { rel: 'tooltip', className: 'tooltip-selector--light', title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
	            'light'
	          ),
	          ',\xA0\xA0\xA0',
	          _get__('React').createElement(
	            'abbr',
	            { rel: 'tooltip', className: 'tooltip-selector--alternative', title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
	            'alternative'
	          ),
	          '\xA0\xA0and\xA0\xA0',
	          _get__('React').createElement(
	            'abbr',
	            { rel: 'tooltip', className: 'tooltip-selector--white', title: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.' },
	            'white'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<p>Hover over this text styles\n        <abbr rel="tooltip" className="tooltip-selector--light" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">light</abbr>,\n        <abbr rel="tooltip" className="tooltip-selector--alternative" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">alternative</abbr> and\n        <abbr rel="tooltip" className="tooltip-selector--white" title="Lorem ipsum dolor sit amet, consectetur adipiscing elit."> white</abbr></p>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '\n// Using default attributes shown in snippet.\n// The library looks for the an abbr with the attribute rel=\'tooltip\' by default.\ncommonUI.initializeTooltip();\n\n// You can have multiple tooltips on the page, they will all be initialised.\n\n// The element must have a \'title\' attribute with the text to be used in the tooltip.\n\n// Using a custom selector\n//commonUI.initializeTooltip({selector:\'a[rel="custom-property"]\'});\ncommonUI.initializeTooltip({selector:\'.tooltip-selector--light\'});\n\n// Applying the light theme\ncommonUI.initializeTooltip({\n  selector:\'.tooltip-selector--light\',\n  theme: \'light\'\n});\n      '
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Tooltips;
	}(_get__('Component'));
	
	exports.default = _get__('Tooltips');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Tooltips':
	      return Tooltips;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Tooltips === 'undefined' ? 'undefined' : _typeof(Tooltips);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Tooltips, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Tooltips)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable no-magic-numbers, id-length, max-len, padded-blocks, newline-after-var */
	
	var S = 1000;
	var M = _get__('S') * 60;
	var H = _get__('M') * 60;
	var D = _get__('H') * 24;
	
	var CountdownTimer = function (_get__2) {
	  _inherits(CountdownTimer, _get__2);
	
	  function CountdownTimer() {
	    _classCallCheck(this, CountdownTimer);
	
	    return _possibleConstructorReturn(this, (CountdownTimer.__proto__ || Object.getPrototypeOf(CountdownTimer)).apply(this, arguments));
	  }
	
	  _createClass(CountdownTimer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        _this2.initializeCountdownTimers();
	      }, 0);
	    }
	  }, {
	    key: 'initializeCountdownTimers',
	    value: function initializeCountdownTimers() {
	
	      var sd = Date.now();
	      var ed = sd + 10 * _get__('M');
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-default',
	        startDate: sd,
	        endDate: ed
	      });
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-default-dark',
	        startDate: sd,
	        endDate: ed,
	        dark: true
	      });
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-extended',
	        startDate: sd,
	        endDate: ed,
	        extended: true
	      });
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-extended-dark',
	        startDate: sd,
	        endDate: ed,
	        extended: true,
	        dark: true
	      });
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-compact',
	        startDate: sd,
	        endDate: ed,
	        compact: true
	      });
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-compact-dark',
	        startDate: sd,
	        endDate: ed,
	        compact: true,
	        dark: true
	      });
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-compact-extended',
	        startDate: sd,
	        endDate: ed,
	        compact: true,
	        extended: true
	      });
	
	      _get__('commonUI').initializeCountdownTimer({
	        selector: '#timer-compact-extended-dark',
	        startDate: sd,
	        endDate: ed,
	        compact: true,
	        extended: true,
	        dark: true
	      });
	    }
	  }, {
	    key: 'getContainerStyle',
	    value: function getContainerStyle() {
	      return {
	        width: '250px'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'countdown-timer' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Countdown Timer'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The countdown timer component can be used when trying to create urgency of time remaining to an event or status change.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The countdown timer has 2 variations of style; default and extended.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'There is also a reverse color style for all timer styles. This will allow the timer to render clearly on full color backgrounds without any major accessibility issues. '
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout push--bottom' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Please Note:'
	          ),
	          ' The examples shown below are for demonstration purposes only to demonstrate how to render a countdown timer using the provided sample markup. A fully functional version of the countdown timer component will be available soon.'
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Default Version'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The default version is more stripped back in terms of visual information and presents only labelling for time remaining. This would be used ideally for situations that don\u2019t have a long period of time when initiated.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-6 grid--align-center grid__cell--padding-lg' },
	            _get__('React').createElement('div', { id: 'timer-default', style: this.getContainerStyle() })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-6 grid--align-center grid__cell--padding-lg background--black' },
	            _get__('React').createElement('div', { id: 'timer-default-dark', style: this.getContainerStyle() })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Default version -->\n<div class="timer">\n  <div class="timer__parts">\n    <span class="timer__part">\n      <span class="timer__part-value">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>\n\n<!-- Default versino with reversed background -->\n<div class="timer timer--dark">\n  <div class="timer__parts">\n    <span class="timer__part">\n      <span class="timer__part-value">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Extended Version'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The extended version is designed and recommended to be used for more of the marketing/promotional page type scenario where all labelling of numbers etc is visible but suppressed in background as it counts down.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To use the extended version, apply a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer--extended'
	          ),
	          ' to the main ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-6 grid--align-center grid__cell--padding-lg' },
	            _get__('React').createElement('div', { id: 'timer-extended', style: this.getContainerStyle() })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-6 grid--align-center grid__cell--padding-lg background--black' },
	            _get__('React').createElement('div', { id: 'timer-extended-dark', style: this.getContainerStyle() })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Extended version -->\n<div class="timer timer--extended">\n  <div class="timer__parts">\n    <span class="timer__part text--disabled">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">days</span>\n    </span>\n    <span class="timer__part text--disabled">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">hours</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>\n\n<!-- Extended version with reversed background -->\n<div class="timer timer--extended timer--dark">\n  <div class="timer__parts">\n    <span class="timer__part display--none">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">days</span>\n    </span>\n    <span class="timer__part display--none">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">hours</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value ">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Compact Version'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'In each style version we have 2 sizes; default and compact. The compact version will allow the use of the timers to be able to adjust to smaller screens responsively.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To use the compact version, apply a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer--compact'
	          ),
	          ' to the main ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6 grid--align-center grid__cell--padding-lg hard--bottom' },
	            _get__('React').createElement('div', { id: 'timer-compact' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6 grid--align-center grid__cell--padding-lg hard--bottom background--black' },
	            _get__('React').createElement('div', { id: 'timer-compact-dark' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6 grid--align-center grid__cell--padding-lg' },
	            _get__('React').createElement('div', { id: 'timer-compact-extended' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-6 grid--align-center grid__cell--padding-lg background--black' },
	            _get__('React').createElement('div', { id: 'timer-compact-extended-dark' })
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Compact version -->\n<div class="timer timer--compact">\n  <div class="timer__parts">\n    <span class="timer__part">\n      <span class="timer__part-value">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>\n\n<!-- Compact version with reversed background -->\n<div class="timer timer--compact timer--dark">\n  <div class="timer__parts">\n    <span class="timer__part">\n      <span class="timer__part-value ">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>\n\n<!-- Compact Extended version -->\n<div class="timer timer--compact timer--extended">\n  <div class="timer__parts">\n    <span class="timer__part text--disabled">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">days</span>\n    </span>\n    <span class="timer__part text--disabled">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">hours</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>\n\n<!-- Compact Extended version with reversed background -->\n<div class="timer timer--compact timer--extended timer--dark">\n  <div class="timer__parts">\n    <span class="timer__part display--none">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">days</span>\n    </span>\n    <span class="timer__part display--none">\n      <span class="timer__part-value">00</span>\n      <span class="timer__part-unit">hours</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value ">09</span>\n      <span class="timer__part-unit">mins</span>\n    </span>\n    <span class="timer__part">\n      <span class="timer__part-value">31</span>\n      <span class="timer__part-unit">secs</span>\n    </span>\n  </div>\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%;"></div>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Dark Version'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The dark version does not specify a dark background color, it only inverts the color of the text whilst inheriting the background color from its parent. If you wish to use the dark version, you will need to set the background color of a parent element containing the countdown timer element, then apply a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer--dark'
	          ),
	          ' to the main ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Progress Bar'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To change the color of the progress bar, add one of the following classes to the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer__duration-remaining'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout push-half--bottom' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' You still need the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer__duration-remaining'
	          ),
	          ' class in addition to the color listed below \u2014 do not ',
	          _get__('React').createElement(
	            'em',
	            null,
	            'replace'
	          ),
	          ' the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'timer__duration-remaining'
	          ),
	          ' class, as it will not work without this class.'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--comfy table--striped' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Stage'
	              ),
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Class'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Stage 1'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  { className: 'inline' },
	                  '.timer__duration-remaining--green'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Stage 2'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  { className: 'inline' },
	                  '.timer__duration-remaining--lime'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Stage 3'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  { className: 'inline' },
	                  '.timer__duration-remaining--orange'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'Stage 4'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  { className: 'inline' },
	                  '.timer__duration-remaining--red'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-3 grid__col-xs-6' },
	            _get__('React').createElement(
	              'div',
	              { className: 'timer' },
	              _get__('React').createElement(
	                'div',
	                { className: 'timer__duration' },
	                _get__('React').createElement('div', { className: 'timer__duration-remaining timer__duration-remaining--green', style: { width: '95%' } })
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-3 grid__col-xs-6' },
	            _get__('React').createElement(
	              'div',
	              { className: 'timer' },
	              _get__('React').createElement(
	                'div',
	                { className: 'timer__duration' },
	                _get__('React').createElement('div', { className: 'timer__duration-remaining timer__duration-remaining--lime', style: { width: '45%' } })
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-3 grid__col-xs-6' },
	            _get__('React').createElement(
	              'div',
	              { className: 'timer' },
	              _get__('React').createElement(
	                'div',
	                { className: 'timer__duration' },
	                _get__('React').createElement('div', { className: 'timer__duration-remaining timer__duration-remaining--orange', style: { width: '15%' } })
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-md-3 grid__col-xs-6' },
	            _get__('React').createElement(
	              'div',
	              { className: 'timer' },
	              _get__('React').createElement(
	                'div',
	                { className: 'timer__duration' },
	                _get__('React').createElement('div', { className: 'timer__duration-remaining timer__duration-remaining--red', style: { width: '5%' } })
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Green -->\n<div class="timer">\n  ...\n  <div class="timer__duration">\n    <div class="timer__duration-remaining timer__duration-remaining--green" style="width: 95%"></div>\n  </div>\n</div>\n\n<!-- Lime -->\n<div class="timer">\n  ...\n  <div class="timer__duration">\n    <div class="timer__duration-remaining timer__duration-remaining--lime" style="width: 45%"></div>\n  </div>\n</div>\n\n<!-- Orange -->\n<div class="timer">\n  ...\n  <div class="timer__duration">\n    <div class="timer__duration-remaining timer__duration-remaining--orange" style="width: 15%"></div>\n  </div>\n</div>\n\n<!-- Red -->\n<div class="timer">\n  ...\n  <div class="timer__duration">\n    <div class="timer__duration-remaining timer__duration-remaining--red" style="width: 5%"></div>\n  </div>\n</div>\n\n'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To set the width of the progress bar, apply an inline style setting the width to the appropriate percentage, as demonstrated in the examples above. Similarly, you can also set the background color of the progress bar by applying an inline style, e.g.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="timer">\n  ...\n  <div class="timer__duration">\n    <div class="timer__duration-remaining" style="background-color: #8ebe3f; width: 95%"></div>\n  </div>\n</div>'
	          )
	        )
	      );
	    }
	  }]);
	
	  return CountdownTimer;
	}(_get__('Component'));
	
	exports.default = _get__('CountdownTimer');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'S':
	      return S;
	
	    case 'M':
	      return M;
	
	    case 'H':
	      return H;
	
	    case 'commonUI':
	      return _commonUI2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'CountdownTimer':
	      return CountdownTimer;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof CountdownTimer === 'undefined' ? 'undefined' : _typeof(CountdownTimer);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(CountdownTimer, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(CountdownTimer)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modals = function (_get__2) {
	  _inherits(Modals, _get__2);
	
	  function Modals(props) {
	    _classCallCheck(this, Modals);
	
	    var _this = _possibleConstructorReturn(this, (Modals.__proto__ || Object.getPrototypeOf(Modals)).call(this, props));
	
	    _this.state = {
	      selectedModalStyle: '',
	      selectedModalSize: '',
	      modalSizeTitle: ''
	    };
	
	    _this.toggleModalStyle = _this.toggleModalStyle.bind(_this);
	    _this.toggleModalSize = _this.toggleModalSize.bind(_this);
	    _this.registerModalListeners = _this.registerModalListeners.bind(_this);
	    return _this;
	  }
	
	  _createClass(Modals, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _get__('commonUI').initializeModal({
	        selector: '.complex-example-modal',
	        clickElementSelector: '.complex-example-button'
	      });
	      _get__('commonUI').initializeModal({
	        selector: '.events-example-modal',
	        clickElementSelector: '.events-example-button'
	      });
	      _get__('commonUI').initializeModal({
	        selector: '.size-example-modal',
	        clickElementSelector: '.toggle-modal-size'
	      });
	      _get__('commonUI').initializeModal({
	        selector: '.style-example-modal',
	        clickElementSelector: '.toggle-modal-style'
	      });
	
	      this.registerModalListeners();
	    }
	  }, {
	    key: 'registerModalListeners',
	    value: function registerModalListeners() {
	      var _this2 = this;
	
	      var modalStyleBtns = document.querySelectorAll('.toggle-modal-style');
	      var modalSizeBtns = document.querySelectorAll('.toggle-modal-size');
	      modalStyleBtns.forEach(function (btn) {
	        return btn.addEventListener('click', function () {
	          return _this2.toggleModalStyle(btn.value);
	        });
	      });
	      modalSizeBtns.forEach(function (btn) {
	        return btn.addEventListener('click', function () {
	          return _this2.toggleModalSize(btn.value);
	        });
	      });
	    }
	  }, {
	    key: 'toggleModalStyle',
	    value: function toggleModalStyle(style) {
	      this.setState({
	        selectedModalStyle: style + ' modal--is-open'
	      });
	    }
	  }, {
	    key: 'toggleModalSize',
	    value: function toggleModalSize(size) {
	      this.setState({
	        selectedModalSize: 'modal--is-' + size + ' modal--is-open',
	        modalSizeTitle: size.slice(0, 1).toUpperCase() + size.slice(1)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'modals' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Modals'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Overlays are typically intended to get users to view content, complete a form, or make a decision.',
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          'Other good reasons to use modals:',
	          _get__('React').createElement('br', null),
	          'The user is about to take an action that has serious consequences and is difficult to reverse.',
	          _get__('React').createElement('br', null),
	          'It\u2019s essential to collect a small amount of information before letting users proceed to the next step in a process.',
	          _get__('React').createElement('br', null),
	          'The content in the overlay is urgent, and users are more likely to notice it in an overlay.'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'modal' }),
	        _get__('React').createElement(
	          'div',
	          { className: 'modal js-modal' },
	          _get__('React').createElement(
	            'div',
	            { className: 'modal__inner' },
	            _get__('React').createElement(
	              'header',
	              { className: 'modal__header', 'aria-labelledby': 'modal__title' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'modal__title' },
	                'Modal Heading'
	              ),
	              _get__('React').createElement(
	                'button',
	                { className: 'modal__close btn btn--transparent js-modal-close', 'aria-label': 'close' },
	                _get__('React').createElement('i', { className: 'fas fa-times icon--medium' })
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'modal__contents', role: 'dialog', 'aria-hidden': 'false', 'aria-describedby': 'modal__description' },
	              _get__('React').createElement(
	                'p',
	                { className: 'modal__description' },
	                'This is a description of what this modal is for'
	              )
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'modal__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__cancel btn btn--secondary btn--outline js-modal-close' },
	                'Cancel'
	              ),
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__confirm btn js-modal-positive' },
	                'Confirm'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'By default, the library will look for the class ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.js-modal'
	          ),
	          ' for the content and ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.js-modal__button'
	          ),
	          ' to attach the open modal event to.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display-inline-block' },
	          _get__('React').createElement(
	            'button',
	            { className: 'btn js-modal__button' },
	            'Simplest Example'
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="modal js-modal">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Modal heading</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n      <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<button class="btn js-modal__button">Simplest Example</button>'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          { className: 'language-javascript' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Using default classes shown in snippet.\ncommonUI.initializeModal();'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'There are five options for sizing at non-mobile sizes, these are applied by the classes:',
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'modal--is-fullscreen | modal--is-large | modal--is-medium | modal--is-small | modal--is-xsmall '
	          ),
	          _get__('React').createElement('br', null),
	          'If none of the above classes are applied, the default modal size is Medium'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display-inline-block' },
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-size push-quarter--ends', value: 'fullscreen' },
	            'Fullscreen Example'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-size push-quarter--ends', value: 'large' },
	            'Large Example'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-size push-quarter--ends', value: 'medium' },
	            'Medium Example'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-size push-quarter--ends', value: 'small' },
	            'Small Example'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-size push-quarter--ends', value: 'xsmall' },
	            'XSmall Example'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'modal ' + this.state.selectedModalSize + ' size-example-modal' },
	          _get__('React').createElement(
	            'div',
	            { className: 'modal__inner' },
	            _get__('React').createElement(
	              'header',
	              { className: 'modal__header', 'aria-labelledby': 'modal__title' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'modal__title' },
	                this.state.modalSizeTitle,
	                ' Modal Example'
	              ),
	              _get__('React').createElement(
	                'button',
	                { className: 'modal__close btn btn--transparent js-modal-close', 'aria-label': 'close' },
	                _get__('React').createElement('i', { className: 'fas fa-times icon--medium' })
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'modal__contents', role: 'dialog', 'aria-hidden': 'false', 'aria-describedby': 'modal__description' },
	              _get__('React').createElement(
	                'p',
	                { className: 'modal__description' },
	                'This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for.'
	              )
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'modal__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__cancel btn btn--secondary btn--outline js-modal-close' },
	                'Cancel'
	              ),
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__confirm btn js-modal-positive' },
	                'Confirm'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="modal fullscreen-example-modal modal--is-fullscreen">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Fullscreen</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<div class="modal large-example-modal modal--is-large">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Large</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<div class="modal medium-example-modal modal--is-medium">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Medium</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<div class="modal small-example-modal modal--is-small">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Small</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<div class="modal xsmall-example-modal modal--is-xsmall">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Xsmall</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<button class="btn fullscreen-example-button">Fullscreen Example</button>\n<button class="btn large-example-button">Large Example</button>\n<button class="btn medium-example-button">Medium Example</button>\n<button class="btn small-example-button">Small Example</button>\n<button class="btn xsmall-example-button">Xsmall Example</button>'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          { className: 'language-javascript' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// With multiple modals on the page,\n// each needs unique content and areas for the click handlers.\ncommonUI.initializeModal(\n  {\n    selector: \'.fullscreen-example-modal\',\n    clickElementSelector: \'.fullscreen-example-button\'\n  }\n);\ncommonUI.initializeModal(\n  {\n    selector: \'.large-example-modal\',\n    clickElementSelector: \'.large-example-button\'\n  }\n);\ncommonUI.initializeModal(\n  {\n    selector: \'.medium-example-modal\',\n    clickElementSelector: \'.medium-example-button\'\n  }\n);\ncommonUI.initializeModal(\n  {\n    selector: \'.small-example-modal\',\n    clickElementSelector: \'.small-example-button\'\n  }\n);\ncommonUI.initializeModal(\n  {\n    selector: \'.xsmall-example-modal\',\n    clickElementSelector: \'.xsmall-example-button\'\n  }\n);'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'modal complex-example-modal modal--is-large' },
	          _get__('React').createElement(
	            'div',
	            { className: 'modal__inner' },
	            _get__('React').createElement(
	              'header',
	              { className: 'modal__header', 'aria-labelledby': 'modal__title' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'modal__title' },
	                'Example Search'
	              ),
	              _get__('React').createElement(
	                'button',
	                { className: 'modal__close btn btn--transparent js-modal-close', 'aria-label': 'close' },
	                _get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'modal__contents', role: 'dialog', 'aria-hidden': 'false', 'aria-describedby': 'modal__description' },
	              _get__('React').createElement(
	                'p',
	                { className: 'modal__description' },
	                'Enter your search term in the field to fetch results'
	              ),
	              _get__('React').createElement(
	                'ul',
	                { className: 'form-fields grid' },
	                _get__('React').createElement(
	                  'li',
	                  { className: 'grid__col-12 hard' },
	                  _get__('React').createElement(
	                    'div',
	                    { className: 'icon__wrapper icon__wrapper--left' },
	                    _get__('React').createElement('i', { className: 'fa fa-search' })
	                  ),
	                  _get__('React').createElement(
	                    'label',
	                    null,
	                    'Search'
	                  ),
	                  _get__('React').createElement('input', { type: 'text', className: 'text-input' })
	                )
	              ),
	              _get__('React').createElement('br', null),
	              _get__('React').createElement(
	                'table',
	                { className: 'table table--cells table--comfy table--hover table--striped table--dark' },
	                _get__('React').createElement(
	                  'thead',
	                  null,
	                  _get__('React').createElement(
	                    'tr',
	                    null,
	                    _get__('React').createElement(
	                      'th',
	                      null,
	                      'Lorem'
	                    ),
	                    _get__('React').createElement(
	                      'th',
	                      null,
	                      'Ipsum'
	                    ),
	                    _get__('React').createElement(
	                      'th',
	                      null,
	                      'Dolor'
	                    ),
	                    _get__('React').createElement(
	                      'th',
	                      null,
	                      'Sit'
	                    )
	                  )
	                ),
	                _get__('React').createElement(
	                  'tbody',
	                  null,
	                  _get__('React').createElement(
	                    'tr',
	                    null,
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Sit'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Dolor'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      { className: 'text--center' },
	                      '03.788'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Lorem'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'tr',
	                    null,
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Sit'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Dolor'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      { className: 'text--center' },
	                      '32.210'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Lorem'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'tr',
	                    null,
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Sit'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Dolor'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      { className: 'text--center' },
	                      '47.797'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Lorem'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'tr',
	                    null,
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Sit'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Dolor'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      { className: 'text--center' },
	                      '09.640'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Lorem'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'tr',
	                    null,
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Sit'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Dolor'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      { className: 'text--center' },
	                      '12.117'
	                    ),
	                    _get__('React').createElement(
	                      'td',
	                      null,
	                      'Lorem'
	                    )
	                  )
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'modal__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__cancel btn btn--secondary js-modal-close' },
	                'Cancel'
	              ),
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__confirm btn js-modal-positive' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'A more realistic example with content'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn complex-example-button' },
	          'Content example'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Modal Header Color Styles'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'There are three color options for modal headers, these are applied by the classes:',
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'modal | modal modal--navy-header | modal modal--grey-header '
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display-inline-block' },
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-style push-quarter--ends', value: '' },
	            'Default Header'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-style push-quarter--ends', value: 'modal--navy-header' },
	            'Navy Header'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-style push-quarter--ends', value: 'modal--grey-header' },
	            'Grey Header'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="modal modal--navy-header">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Fullscreen</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<div class="modal modal--grey-header">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Large</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Modal Full Color Styles'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'There are three color options for modal full colour styles, these are applied by the classes:',
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'modal | modal modal--navy | modal modal--navy-dark | modal modal--grey '
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'display-inline-block' },
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-style push-quarter--ends', value: '' },
	            'Default Style'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-style push-quarter--ends', value: 'modal--navy' },
	            'Navy Style'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-style push-quarter--ends', value: 'modal--navy-dark' },
	            'Dark Navy Style'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn toggle-modal-style push-quarter--ends', value: 'modal--grey' },
	            'Grey Style'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'modal ' + this.state.selectedModalStyle + ' style-example-modal' },
	          _get__('React').createElement(
	            'div',
	            { className: 'modal__inner' },
	            _get__('React').createElement(
	              'header',
	              { className: 'modal__header', 'aria-labelledby': 'modal__title' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'modal__title' },
	                'Modal Header Style'
	              ),
	              _get__('React').createElement(
	                'button',
	                { className: 'modal__close btn btn--transparent js-modal-close', 'aria-label': 'close' },
	                _get__('React').createElement('i', { className: 'fas fa-times icon--medium' })
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'modal__contents', role: 'dialog', 'aria-hidden': 'false', 'aria-describedby': 'modal__description' },
	              _get__('React').createElement(
	                'p',
	                { className: 'modal__description' },
	                'This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for. This is a description of what this modal is for.'
	              )
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'modal__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__cancel btn btn--secondary btn--outline js-modal-close' },
	                'Cancel'
	              ),
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__confirm btn js-modal-positive' },
	                'Confirm'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="modal modal--navy">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Fullscreen</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<div class="modal modal--navy-dark">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Large</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>\n\n<div class="modal modal--grey">\n  <div class="modal__inner">\n    <header class="modal__header" aria-labelledby="modal__title">\n      <h1 class="modal__title">Large</h1>\n      <button class="modal__close btn btn--transparent js-modal-close" aria-label="close">\n        <i class="icon-cme-card-close icon--medium"></i>\n      </button>\n    </header>\n    <div class="modal__contents" role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description">\n      <p class="modal__description">This is a description of what this modal is for</p>\n    </div>\n    <footer class="modal__footer">\n        <button type="button" class="modal__cancel btn btn--secondary js-modal-close">Cancel</button>\n        <button type="button" class="modal__confirm btn js-modal-positive">OK</button>\n    </footer>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Caution!'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'On mobile: a new page should be displayed instead of using an overlay for mobile. Refer to ',
	          _get__('React').createElement(
	            'a',
	            { href: 'http://bradfrost.com/blog/post/conditional-lightbox/' },
	            'Brad Frosts Conditional Lightbox'
	          ),
	          ' for additional info.',
	          _get__('React').createElement('br', null),
	          'Scrolling and anchor links make sense on very long web pages. But if you find yourself adding multiple navigation mechanisms within an overlay, it\u2019s time to stop and reevaluate your approach.',
	          _get__('React').createElement('br', null),
	          'If someone might need to share the content, an overlay is not a good option - a new page should be used instead. '
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Best Practices'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Provide a visible \u2018close\u2019 command to allow users to return to the underlying page.',
	          _get__('React').createElement('br', null),
	          'Overlays that ask users to provide input, even if it is just a single field, need an explicit \u2018Cancel\u2019 option.',
	          _get__('React').createElement('br', null),
	          'To help users recover from accidentally closing the overlay, any field inputs should be saved and the overlay should be easy to reactivate.',
	          _get__('React').createElement('br', null),
	          'To help users avoid dismissing a lightbox without understanding the consequences of their actions, use an explicit  button label that states exactly what will happen when the user clicks it, as LinkedIn does with their \u2018Yes, Remove them\u2019 confirmation button on the lightbox to confirm deleting a contact.'
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Accessibility Tips'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The aria and other associated attributes help screenreader users to navigate the modal'
	        ),
	        _get__('React').createElement(
	          'code',
	          { className: 'inline' },
	          'role="dialog" aria-hidden="false" aria-labelledby="modal__title" aria-describedby="modal__description"'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The escape key is bound to close the modal and the tab order is automatically set inside the modal when opened.',
	          _get__('React').createElement('br', null),
	          'The first element of the modal should be a ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '<h1>'
	          ),
	          ' to allow the screenreaders to construct the document correctly.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Programatic control'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The modal exposes open and close methods.'
	        ),
	        _get__('React').createElement(
	          'code',
	          { className: 'inline' },
	          'var modal = commonUI.initializeModal({selector:\'.example-modal\'});'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--fixed table--cells table--comfy' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                null,
	                'Method'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'modal.open()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Opens the modal'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'modal.close()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Closes the modal, does not fire positive/negative events'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'modal.positive()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Closes the modal, fires positive event'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'modal.negative()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Closes the modal, fires negative event'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Events'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The modal exposes a few events for hooking into modal functionality.'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--fixed table--cells table--comfy' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                null,
	                'Event Type'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'show.commonui.modal'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event fires immediately when the open instance method is called.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'hide.commonui.modal'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event is fired immediately when the close instance method has been called.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'negative.commonui.modal'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event is fired when the user clicks a .js-modal-close element'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'positive.commonui.modal'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event is fired when the user clicks a .js-modal-positive element'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Open the browser console to see the events firing with the below example'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'All modal events are fired at the modal instance itself (i.e. at the <div class="events-example-modal">).'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'modal events-example-modal modal--is-large' },
	          _get__('React').createElement(
	            'div',
	            { className: 'modal__inner' },
	            _get__('React').createElement(
	              'header',
	              { className: 'modal__header', 'aria-labelledby': 'modal__title' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'modal__title' },
	                'Hello'
	              ),
	              _get__('React').createElement(
	                'button',
	                { className: 'modal__close btn btn--transparent js-modal-close', 'aria-label': 'close' },
	                _get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'modal__contents', role: 'dialog', 'aria-hidden': 'false', 'aria-labelledby': 'modal__title', 'aria-describedby': 'modal__description' },
	              _get__('React').createElement(
	                'p',
	                { className: 'modal__description' },
	                'This is a description of what this modal is for'
	              )
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'modal__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__cancel btn btn--secondary js-modal-close' },
	                'Cancel'
	              ),
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'modal__confirm btn js-modal-positive' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn events-example-button' },
	          'Events example'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeModal(\n  {\n    selector: \'.events-example-modal\',\n    clickElementSelector: \'.events-example-button\'\n  }\n);\n\nvar eventsExampleModal = document.getElementsByClassName(\'events-example-modal\')[0];\n\neventsExampleModal.addEventListener(\'show.commonui.modal\', function(){\n    console.log(\'modal show\')\n});\neventsExampleModal.addEventListener(\'hide.commonui.modal\', function(){\n    console.log(\'modal hide\')\n});\neventsExampleModal.addEventListener(\'positive.commonui.modal\', function(){\n    console.log(\'modal positive\')\n});\neventsExampleModal.addEventListener(\'negative.commonui.modal\', function(){\n    console.log(\'modal negative\')\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Modals;
	}(_get__('Component'));
	
	exports.default = _get__('Modals');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'Modals':
	      return Modals;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Modals === 'undefined' ? 'undefined' : _typeof(Modals);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Modals, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Modals)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Carousel = function (_get__2) {
	  _inherits(Carousel, _get__2);
	
	  function Carousel(props) {
	    _classCallCheck(this, Carousel);
	
	    return _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));
	  }
	
	  _createClass(Carousel, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'carousel' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Carousel'
	        ),
	        this.props.staticVersion === false ? _get__('React').createElement(_get__('Included'), {
	          onClick: function onClick() {
	            return _this2.props.onIncludeClick();
	          },
	          included: this.props.included }) : '',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Using the slick carousel ',
	          _get__('React').createElement(
	            'a',
	            { href: 'http://kenwheeler.github.io/slick/' },
	            'http://kenwheeler.github.io/slick/'
	          )
	        ),
	        _get__('React').createElement(
	          'ul',
	          null,
	          _get__('React').createElement(
	            'li',
	            null,
	            'Fully responsive. Scales with its container.'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Separate settings per breakpoint'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Uses CSS3 when available. Fully functional when not.'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Swipe enabled. Or disabled, if you prefer.'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Desktop mouse dragging'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Infinite looping.'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Fully accessible with arrow key navigation'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Add, remove, filter & unfilter slides'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'Autoplay, dots, arrows, callbacks, etc...'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'carousel js-carousel' },
	          _get__('React').createElement(
	            'div',
	            { className: 'carousel--panel' },
	            _get__('React').createElement('img', { src: 'https://dummyimage.com/950x430/666666/ffffff&text=Slide+1' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'carousel--panel' },
	            _get__('React').createElement('img', { src: 'https://dummyimage.com/950x430/666666/ffffff&text=Slide+2' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'carousel--panel' },
	            _get__('React').createElement('img', { src: 'https://dummyimage.com/950x430/666666/ffffff&text=Slide+3' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'carousel--panel' },
	            _get__('React').createElement('img', { src: 'https://dummyimage.com/950x430/666666/ffffff&text=Slide+4' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'carousel--panel' },
	            _get__('React').createElement('img', { src: 'https://dummyimage.com/950x430/666666/ffffff&text=Slide+5' })
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'carousel--panel' },
	            _get__('React').createElement('img', { src: 'https://dummyimage.com/950x430/666666/ffffff&text=Slide+6' })
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div className="carousel js-carousel">\n  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+1"/></div>\n  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+2"/></div>\n  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+3"/></div>\n  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+4"/></div>\n  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+5"/></div>\n  <div className="carousel--panel"><img src="https://dummyimage.com/950x430/666666/ffffff&text=Slide+6"/></div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Initialise the carousel'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement('code', { className: 'language-js', dangerouslySetInnerHTML: { __html: "$('.js-carousel').slick({dots: true, fade: true, cssEase: 'linear'});" } })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'CSS Dependencies'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick.min.css"/>\n<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick-theme.min.css"/>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'JS Dependencies'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.5.9/slick.min.js"></script>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Carousel;
	}(_get__('Component'));
	
	exports.default = _get__('Carousel');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Carousel':
	      return Carousel;
	
	    case 'React':
	      return _react2.default;
	
	    case 'Included':
	      return _Included2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Carousel === 'undefined' ? 'undefined' : _typeof(Carousel);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Carousel, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Carousel)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pagination = function (_get__2) {
	  _inherits(Pagination, _get__2);
	
	  function Pagination(props) {
	    _classCallCheck(this, Pagination);
	
	    return _possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
	  }
	
	  _createClass(Pagination, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'pagination' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Pagination'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'pagination' }),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Include the comment blocks to strip whitespace around the text and keep the styling consistent'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "100px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n        <html data-theme="default">\n          <head>\n            <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n          </head>\n          <body>\n          <div class="grid">\n            <div class="grid__col-12 grid--direction-row grid--justify-center display--block">\n            <ol class="pagination js-pagination"><!--\n        --><li class="pagination__first"><i class="fa fa-angle-double-left"></i></li><!--\n        --><li class="pagination__prev"><i class="fa fa-angle-left"></i>Prev</li><!--\n        --><li class="pagination__current">1 of 10</li><!--\n        --><li><a href="javascript:;">2</a></li><!--\n        --><li><a href="javascript:;">3</a></li><!--\n        --><li><a href="javascript:;">4</a></li><!--\n        --><li><a href="javascript:;">5</a></li><!--\n        --><li><a href="javascript:;">6</a></li><!--\n        --><li><a href="javascript:;">7</a></li><!--\n        --><li><a href="javascript:;">8</a></li><!--\n        --><li><a href="javascript:;">9</a></li><!--\n        --><li><a href="javascript:;">10</a></li><!--\n        --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--\n        --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--\n        --></ol>\n          </div>\n          </div>\n          </body>\n          <script type="text/javascript" src="js/commonUI.js"></script>\n          <script>\n            function init() {\n              commonUI.initializePagination();\n            }\n            window.onload = init;\n          </script>\n        </html>\n      ' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ol class="pagination js-pagination"><!--\n--><li class="pagination__first"><i class="fa fa-angle-double-left"></i></li><!--\n--><li class="pagination__prev"><i class="fa fa-angle-left"></i>Prev</li><!--\n--><li class="pagination__current">1 of 10</li><!--\n--><li><a href="#">2</a></li><!--\n--><li><a href="#">3</a></li><!--\n--><li><a href="#">4</a></li><!--\n--><li><a href="#">5</a></li><!--\n--><li><a href="#">6</a></li><!--\n--><li><a href="#">7</a></li><!--\n--><li><a href="#">8</a></li><!--\n--><li><a href="#">9</a></li><!--\n--><li><a href="#">10</a></li><!--\n--><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--\n--><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--\n--></ol>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "100px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n         <html data-theme="default">\n           <head>\n             <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n           </head>\n           <body>\n           <div class="grid">\n             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">\n               <ol class="pagination js-pagination"><!--\n             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--\n             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n             --><li><a href="javascript:;">1</a></li><!--\n             --><li><a href="javascript:;">2</a></li><!--\n             --><li class="pagination__current">3 of 10</li><!--\n             --><li><a href="javascript:;">4</a></li><!--\n             --><li><a href="javascript:;">5</a></li><!--\n             --><li><a href="javascript:;">6</a></li><!--\n             --><li><a href="javascript:;">7</a></li><!--\n             --><li><a href="javascript:;">8</a></li><!--\n             --><li><a href="javascript:;">9</a></li><!--\n             --><li><a href="javascript:;">10</a></li><!--\n             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--\n             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--\n           --></ol>\n             </div>\n           </div>\n           </body>\n           <script type="text/javascript" src="js/commonUI.js"></script>\n           <script>\n             function init() {\n               commonUI.initializePagination();\n             }\n             window.onload = init;\n           </script>\n         </html>\n       ' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ol class="pagination js-pagination"><!--\n  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--\n  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n  --><li><a href="#">1</a></li><!--\n  --><li><a href="#">2</a></li><!--\n  --><li class="pagination__current">3 of 10</li><!--\n  --><li><a href="#">4</a></li><!--\n  --><li><a href="#">5</a></li><!--\n  --><li><a href="#">6</a></li><!--\n  --><li><a href="#">7</a></li><!--\n  --><li><a href="#">8</a></li><!--\n  --><li><a href="#">9</a></li><!--\n  --><li><a href="#">10</a></li><!--\n  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--\n  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--\n--></ol>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Applying classes of ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'pagination--lite'
	          ),
	          ' or ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'pagination--small'
	          ),
	          ' will affect the look and feel of pagination in the following ways'
	        ),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Pagination Lite'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            null,
	            'pagination--lite'
	          ),
	          ' class applied'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "100px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n         <html data-theme="default">\n           <head>\n             <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n           </head>\n           <body>\n           <div class="grid">\n             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">\n               <ol class="pagination pagination--lite js-pagination"><!--\n             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--\n             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n             --><li><a href="javascript:;">1</a></li><!--\n             --><li><a href="javascript:;">2</a></li><!--\n             --><li class="pagination__current">3 of 10</li><!--\n             --><li><a href="javascript:;">4</a></li><!--\n             --><li><a href="javascript:;">5</a></li><!--\n             --><li><a href="javascript:;">6</a></li><!--\n             --><li><a href="javascript:;">7</a></li><!--\n             --><li><a href="javascript:;">8</a></li><!--\n             --><li><a href="javascript:;">9</a></li><!--\n             --><li><a href="javascript:;">10</a></li><!--\n             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--\n             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--\n           --></ol>\n             </div>\n           </div>\n           </body>\n           <script type="text/javascript" src="js/commonUI.js"></script>\n           <script>\n             function init() {\n               commonUI.initializePagination();\n             }\n             window.onload = init;\n           </script>\n         </html>\n       ' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ol class="pagination pagination--lite js-pagination"><!--\n  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--\n  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n  --><li><a href="#">1</a></li><!--\n  --><li><a href="#">2</a></li><!--\n  --><li class="pagination__current">3 of 10</li><!--\n  --><li><a href="#">4</a></li><!--\n  --><li><a href="#">5</a></li><!--\n  --><li><a href="#">6</a></li><!--\n  --><li><a href="#">7</a></li><!--\n  --><li><a href="#">8</a></li><!--\n  --><li><a href="#">9</a></li><!--\n  --><li><a href="#">10</a></li><!--\n  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--\n  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--\n--></ol>'
	          )
	        ),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Pagination Small'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            null,
	            'pagination--small'
	          ),
	          ' class applied'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "100px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n         <html data-theme="default">\n           <head>\n             <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n           </head>\n           <body>\n           <div class="grid">\n             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">\n               <ol class="pagination pagination--small js-pagination"><!--\n             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--\n             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n             --><li><a href="javascript:;">1</a></li><!--\n             --><li><a href="javascript:;">2</a></li><!--\n             --><li class="pagination__current">3 of 10</li><!--\n             --><li><a href="javascript:;">4</a></li><!--\n             --><li><a href="javascript:;">5</a></li><!--\n             --><li><a href="javascript:;">6</a></li><!--\n             --><li><a href="javascript:;">7</a></li><!--\n             --><li><a href="javascript:;">8</a></li><!--\n             --><li><a href="javascript:;">9</a></li><!--\n             --><li><a href="javascript:;">10</a></li><!--\n             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--\n             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--\n           --></ol>\n             </div>\n           </div>\n           </body>\n           <script type="text/javascript" src="js/commonUI.js"></script>\n           <script>\n             function init() {\n               commonUI.initializePagination();\n             }\n             window.onload = init;\n           </script>\n         </html>\n       ' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ol class="pagination pagination--small js-pagination"><!--\n  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--\n  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n  --><li><a href="#">1</a></li><!--\n  --><li><a href="#">2</a></li><!--\n  --><li class="pagination__current">3 of 10</li><!--\n  --><li><a href="#">4</a></li><!--\n  --><li><a href="#">5</a></li><!--\n  --><li><a href="#">6</a></li><!--\n  --><li><a href="#">7</a></li><!--\n  --><li><a href="#">8</a></li><!--\n  --><li><a href="#">9</a></li><!--\n  --><li><a href="#">10</a></li><!--\n  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--\n  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--\n--></ol>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Pagination Small and Pagination Lite'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'code',
	            null,
	            'pagination--small pagination-lite'
	          ),
	          ' classes applied'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "100px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n         <html data-theme="default">\n           <head>\n             <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n             <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n           </head>\n           <body>\n           <div class="grid">\n             <div class="grid__col-12 grid--direction-row grid--justify-center display--block">\n               <ol class="pagination pagination--small pagination--lite js-pagination"><!--\n             --><li class="pagination__first"><a href="javascript:;"><i class="fa fa-angle-double-left"></i></a></li><!--\n             --><li class="pagination__prev"><a href="javascript:;"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n             --><li><a href="javascript:;">1</a></li><!--\n             --><li><a href="javascript:;">2</a></li><!--\n             --><li class="pagination__current">3 of 10</li><!--\n             --><li><a href="javascript:;">4</a></li><!--\n             --><li><a href="javascript:;">5</a></li><!--\n             --><li><a href="javascript:;">6</a></li><!--\n             --><li><a href="javascript:;">7</a></li><!--\n             --><li><a href="javascript:;">8</a></li><!--\n             --><li><a href="javascript:;">9</a></li><!--\n             --><li><a href="javascript:;">10</a></li><!--\n             --><li class="pagination__next"><a href="javascript:;">Next<i class="fa fa-angle-right"></i></a></li><!--\n             --><li class="pagination__last"><a href="javascript:;"><i class="fa fa-angle-double-right"></i></a></li><!--\n           --></ol>\n             </div>\n           </div>\n           </body>\n           <script type="text/javascript" src="js/commonUI.js"></script>\n           <script>\n             function init() {\n               commonUI.initializePagination();\n             }\n             window.onload = init;\n           </script>\n         </html>\n       ' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ol class="pagination pagination--small pagination--lite js-pagination"><!--\n  --><li class="pagination__first"><a href="#"><i class="fa fa-angle-double-left"></i></a></li><!--\n  --><li class="pagination__prev"><a href="#"><i class="fa fa-angle-left"></i>Prev</a></li><!--\n  --><li><a href="#">1</a></li><!--\n  --><li><a href="#">2</a></li><!--\n  --><li class="pagination__current">3 of 10</li><!--\n  --><li><a href="#">4</a></li><!--\n  --><li><a href="#">5</a></li><!--\n  --><li><a href="#">6</a></li><!--\n  --><li><a href="#">7</a></li><!--\n  --><li><a href="#">8</a></li><!--\n  --><li><a href="#">9</a></li><!--\n  --><li><a href="#">10</a></li><!--\n  --><li class="pagination__next"><a href="#">Next<i class="fa fa-angle-right"></i></a></li><!--\n  --><li class="pagination__last"><a href="#"><i class="fa fa-angle-double-right"></i></a></li><!--\n--></ol>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This is a partly javascript enabled component. You need to use the classes shown above to enable the responsive pagination'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          _get__('React').createElement(
	            'b',
	            null,
	            'Responsive functionality is only available with javascript'
	          )
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// Using default classes shown in snippet.\n// The library looks for the class \'js-pagination\' by default.\ncommonUI.initializePagination();\n\n// You can have multiple paginations on the page, they will all be initialised\n\n// Using custom selectors\ncommonUI.initializePagination({selector:\'.special-pagination\'});'
	          )
	        ),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Pagination;
	}(_get__('Component'));
	
	exports.default = _get__('Pagination');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Pagination':
	      return Pagination;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Pagination === 'undefined' ? 'undefined' : _typeof(Pagination);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Pagination, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Pagination)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Breadcrumb = function (_get__2) {
	  _inherits(Breadcrumb, _get__2);
	
	  function Breadcrumb(props) {
	    _classCallCheck(this, Breadcrumb);
	
	    return _possibleConstructorReturn(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).call(this, props));
	  }
	
	  _createClass(Breadcrumb, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'breadcrumb' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Breadcrumb'
	        ),
	        this.props.staticVersion === false ? _get__('React').createElement(Included, {
	          onClick: function onClick() {
	            return _this2.props.onIncludeClick();
	          },
	          included: this.props.included }) : '',
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'breadcrumbs' }),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'ol',
	            { className: 'breadcrumb' },
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'Top level'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { 'data-breadcrumb': '/' },
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'Level 1'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { 'data-breadcrumb': '/' },
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'Level 2'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { 'data-breadcrumb': '/', className: 'breadcrumb__current' },
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'Level 3'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ol class="breadcrumb"><\n      <li ><a href="#">Top level</a></li>\n      <li data-breadcrumb="/"><a href="#">Level 1</a></li>\n      <li data-breadcrumb="/"><a href="#">Level 2</a></li>\n      <li data-breadcrumb="/" class="breadcrumb__current"><a href="#">Level 3</a></li>\n    </ol>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'ol',
	            { className: 'breadcrumb' },
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'Home'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { 'data-breadcrumb': '|', className: 'breadcrumb__current' },
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'About'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { 'data-breadcrumb': '|' },
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'The Board'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              { 'data-breadcrumb': '|' },
	              _get__('React').createElement(
	                'a',
	                { href: '#' },
	                'Directors'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ol class="breadcrumb">\n\t<li><a href="#">Home</a></li>\n\t<li data-breadcrumb="|" class="breadcrumb__current"><a href="#">About</a></li>\n\t<li data-breadcrumb="|"><a href="#">The Board</a></li>\n\t<li data-breadcrumb="|"><a href="#">Directors</a></li>\n</ol>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Breadcrumb;
	}(_get__('Component'));
	
	exports.default = _get__('Breadcrumb');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Breadcrumb':
	      return Breadcrumb;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Breadcrumb === 'undefined' ? 'undefined' : _typeof(Breadcrumb);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Breadcrumb, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Breadcrumb)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toggles = function (_get__2) {
	  _inherits(Toggles, _get__2);
	
	  function Toggles(props) {
	    _classCallCheck(this, Toggles);
	
	    return _possibleConstructorReturn(this, (Toggles.__proto__ || Object.getPrototypeOf(Toggles)).call(this, props));
	  }
	
	  _createClass(Toggles, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'toggles' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Toggles'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The toggle switch represents a physical switch and is used for actions to allow users to turn things on or off. The toggle component can be used in place of a checkbox control to denote the on or off state.'
	        ),
	        _get__('React').createElement(
	          'p',
	          { className: 'push-half--top' },
	          'To add a toggle component to your page, just wrap a standard HTML checkbox input element as outlined below.'
	        ),
	        _get__('React').createElement(
	          'p',
	          { className: 'push-half--top' },
	          'To use various sizes, add ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.toggle__label-large, .toggle__label-medium, .toggle__label-small, .toggle__label-xsmall'
	          ),
	          ' to the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '<label>'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' The label element can be placed before or after the toggle, but it should be noted that, regardless of whether you would like the label to appear before or after the toggle, in the HTML the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '<label>'
	          ),
	          ' element must be placed physically after the checkbox input element in the markup. This is due to a limitation in the current CSS specification.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'toggles' }),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Label Before'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To place the label before the toggle apply the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.toggle__label-before'
	          ),
	          ' class to the label element.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'toggle' },
	          _get__('React').createElement('input', { id: 'switch1', type: 'checkbox' }),
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'switch1', className: 'toggle__label toggle__label-before' },
	            'Default'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- HTML -->\n<div class="toggle">\n  <input id="switch1" type="checkbox">\n  <label for="switch1" class="toggle__label toggle__label-before">Default</label>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-quarter--bottom' },
	          'Disabled State'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'toggle push--right' },
	          _get__('React').createElement('input', { id: 'switch2', type: 'checkbox', disabled: true }),
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'switch2', className: 'toggle__label toggle__label-before' },
	            'Disabled / Unchecked'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'toggle' },
	          _get__('React').createElement('input', { id: 'switch3', type: 'checkbox', disabled: true, checked: true }),
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'switch3', className: 'toggle__label toggle__label-before' },
	            'Disabled / Checked'
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Disabled / Unchecked -->\n<div class="toggle">\n  <input id="switch2" type="checkbox" disabled>\n  <label for="switch2" class="toggle__label toggle__label-before">Disabled / Unchecked</label>\n</div>\n\n<!-- Disabled / Checked -->\n<div class="toggle">\n  <input id="switch3" type="checkbox" disabled checked>\n  <label for="switch3" class="toggle__label toggle__label-before">Disabled / Checked</label>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Label After'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To place the label after the toggle apply the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '.toggle__label-after'
	          ),
	          ' class to the label element.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'toggle' },
	          _get__('React').createElement('input', { id: 'switch4', type: 'checkbox' }),
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'switch4', className: 'toggle__label toggle__label-after' },
	            'Default'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- HTML -->\n<div class="toggle">\n  <input id="switch4" type="checkbox">\n  <label for="switch4" class="toggle__label toggle__label-after">Auto Refresh</label>\n</div>'
	          )
	        ),
	        _get__('React').createElement(
	          'h5',
	          { className: 'push--top push-quarter--bottom' },
	          'Disabled State'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'toggle push--right' },
	          _get__('React').createElement('input', { id: 'switch5', type: 'checkbox', disabled: true }),
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'switch5', className: 'toggle__label toggle__label-after' },
	            'Disabled / Unchecked'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'toggle' },
	          _get__('React').createElement('input', { id: 'switch6', type: 'checkbox', disabled: true, checked: true }),
	          _get__('React').createElement(
	            'label',
	            { htmlFor: 'switch6', className: 'toggle__label toggle__label-after' },
	            'Disabled / Checked'
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- Disabled / Unchecked -->\n<div class="toggle">\n  <input id="switch5" type="checkbox" disabled>\n  <label for="switch5" class="toggle__label toggle__label-after">Disabled / Unchecked</label>\n</div>\n\n<!-- Disabled / Checked -->\n<div class="toggle">\n  <input id="switch6" type="checkbox" disabled checked>\n  <label for="switch6" class="toggle__label toggle__label-after">Disabled / Checked</label>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Toggles;
	}(_get__('Component'));
	
	exports.default = _get__('Toggles');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Toggles':
	      return Toggles;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Toggles === 'undefined' ? 'undefined' : _typeof(Toggles);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Toggles, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Toggles)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Wizard = function (_get__2) {
	  _inherits(Wizard, _get__2);
	
	  function Wizard(props) {
	    _classCallCheck(this, Wizard);
	
	    return _possibleConstructorReturn(this, (Wizard.__proto__ || Object.getPrototypeOf(Wizard)).call(this, props));
	  }
	
	  _createClass(Wizard, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'wizard' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Wizard'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The wizard component can be used when you need to implement a multi-step process. By default, the wizard can contain details of each step in the process, for example "Step 1: Participant Info". The wizard will respond as the browser window is resized to automatically show/hide the step details as necessary.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1602' },
	            '1600px (xlg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "50px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n        <html>\n          <head>\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n            <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n            <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n          </head>\n          <body>\n            <ul class="wizard flush">\n              <li class="wizard__item is-active is-complete">\n                <span class="wizard__item-step">Step</span><span class="wizard__item-position">1</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Participant Info</span>\n              </li>\n              <li class="wizard__item">\n                <span class="wizard__item-step">Step</span><span class="wizard__item-position">2</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Background Info</span>\n              </li>\n              <li class="wizard__item">\n                <span class="wizard__item-step">Step</span><span class="wizard__item-position">3</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Program Variations</span>\n              </li>\n              <li class="wizard__item">\n                <span class="wizard__item-step">Step</span><span class="wizard__item-position">4</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Accounts</span>\n              </li>\n              <li class="wizard__item">\n                <span class="wizard__item-step">Step</span><span class="wizard__item-position">5</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Terms of Participation</span>\n              </li>\n            </ul>\n          </body>\n          <script src="//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>\n          <script>\n          $(document).ready(function() {\n            $items = $(\'.wizard__item\');\n            $items.on(\'click\', function() {\n              $item = $(this);\n              if ($item.is(\':first-child\') || $item.prev().hasClass(\'is-complete\')) {\n                $items.removeClass(\'is-active\');\n                $item.addClass(\'is-active is-complete\');\n              }\n            });\n          });\n          </script>\n        </html>\n      ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="wizard">\n  <li class="wizard__item is-active is-complete">\n    <span class="wizard__item-step">Step</span><span class="wizard__item-position">1</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Participant Info</span>\n  </li>\n  <li class="wizard__item">\n    <span class="wizard__item-step">Step</span><span class="wizard__item-position">2</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Background Info</span>\n  </li>\n  <li class="wizard__item">\n    <span class="wizard__item-step">Step</span><span class="wizard__item-position">3</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Program Variations</span>\n  </li>\n  <li class="wizard__item">\n    <span class="wizard__item-step">Step</span><span class="wizard__item-position">4</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Accounts</span>\n  </li>\n  <li class="wizard__item">\n    <span class="wizard__item-step">Step</span><span class="wizard__item-position">5</span><span class="wizard__item-separator"></span><span class="wizard__item-title">Terms of Participation</span>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' The following elements are required for the wizard to behave correctly in responsive mode:',
	          _get__('React').createElement(
	            'ul',
	            { className: 'list-dots flush' },
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'pre',
	                { className: 'flush--bottom' },
	                '<span class="wizard__item-position">step number</span>'
	              )
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              _get__('React').createElement(
	                'pre',
	                { className: 'flush--bottom' },
	                '<span class="wizard__item-title">step title</span>'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Simplified Wizard'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'A simplified wizard can be created without including the additional details for each step, i.e. by including ',
	          _get__('React').createElement(
	            'em',
	            null,
	            'only'
	          ),
	          ' the title of the step.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'alert alert--warning' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' The simplified wizard should only be used for a desktop-only layout, or where there are a limited number of steps in the process, as the simple layout is not fully mobile-optimized.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'A basic wizard can be created by applying the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'wizard'
	          ),
	          ' class to an unordered list element, together with the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'wizard__item'
	          ),
	          ' class each list item within the unordered list, as follows:'
	        ),
	        _get__('React').createElement('iframe', { seamless: true, className: 'flush', style: { height: 50 + 'px' }, srcDoc: '\n        <html>\n          <head>\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n            <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n            <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n            <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n          </head>\n          <body>\n            <ul class="wizard">\n              <li class="wizard__item is-active is-complete">Participant Info</li>\n              <li class="wizard__item">Background Info</li>\n              <li class="wizard__item">Program Variations</li>\n              <li class="wizard__item">Accounts</li>\n              <li class="wizard__item">Terms of Participation</li>\n            </ul>\n          </body>\n          <script src="//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>\n          <script>\n          $(document).ready(function() {\n            $items = $(\'.wizard__item\');\n            $items.on(\'click\', function() {\n              $item = $(this);\n              if ($item.is(\':first-child\') || $item.prev().hasClass(\'is-complete\')) {\n                $items.removeClass(\'is-active\');\n                $item.addClass(\'is-active is-complete\');\n              }\n            });\n          });\n          </script>\n        </html>\n      ' }),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<!-- HTML -->\n<ul class="wizard">\n  <li class="wizard__item is-active is-complete">Participant Info</li>\n  <li class="wizard__item">Background Info</li>\n  ...\n  <li class="wizard__item">Terms of Participation</li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            { style: { position: 'relative', left: -5 + 'px' } },
	            _get__('React').createElement('i', { className: 'fa fa-lightbulb-o fa-lg' }),
	            ' Tips'
	          ),
	          _get__('React').createElement(
	            'ul',
	            { className: 'list-dots flush' },
	            _get__('React').createElement(
	              'li',
	              null,
	              'The sample code provided does not include the functionality for setting the state of each step in the wizard process \u2013 the functionality for setting the state of each step is therefore down to implementation.'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'To set the "active" step in the process, apply the ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'is-active'
	              ),
	              ' class.'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'To mark a step as "complete", apply the ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'is-complete'
	              ),
	              ' class.'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'Applying the ',
	              _get__('React').createElement(
	                'code',
	                null,
	                'is-complete'
	              ),
	              ' class to a step will automatically "enable" the next step visually \u2013 the actual functionality to enable the step is down to implementation.'
	            ),
	            _get__('React').createElement(
	              'li',
	              null,
	              'It is recommended that a ',
	              _get__('React').createElement(
	                'em',
	                null,
	                'maximum'
	              ),
	              ' of five steps be included in the wizard.'
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Wizard;
	}(_get__('Component'));
	
	exports.default = _get__('Wizard');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Wizard':
	      return Wizard;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Wizard === 'undefined' ? 'undefined' : _typeof(Wizard);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Wizard, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Wizard)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_get__2) {
	  _inherits(Nav, _get__2);
	
	  function Nav(props) {
	    _classCallCheck(this, Nav);
	
	    return _possibleConstructorReturn(this, (Nav.__proto__ || Object.getPrototypeOf(Nav)).call(this, props));
	  }
	
	  _createClass(Nav, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'navigation' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Navigation'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The top-level navigation is available in several variations. The default navigation bar should be used within your application for app-level navigation by applying a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'nav'
	          ),
	          ' to any block-level container, e.g. ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            '<div>'
	          ),
	          '. The suggested container for your navigation, however, would be the HTML5 ',
	          _get__('React').createElement(
	            'a',
	            { href: 'https://developer.mozilla.org/en/docs/Web/HTML/Element/nav', target: '_blank' },
	            'nav'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The top-level navigation bar consists of 3 (optional) sections:'
	        ),
	        _get__('React').createElement(
	          'ol',
	          { className: 'push--left' },
	          _get__('React').createElement(
	            'li',
	            null,
	            'A "header" section, containing the CME Group logo. The header section can also contain an optional application/site name immediately adjacent to the logo.'
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'An "items" section, containing one or more navigation items. Each item can be either a string representing the top-level title of a block of secondary navigation items, or a link. Note that, at present, if secondary level items exist then the primary item must not be a link, as this will interfere with the mobile/responsive behavior. In this case the primary item should still be an anchor tag, but without an href attribute, e.g. ',
	            _get__('React').createElement(
	              'code',
	              { className: 'inline' },
	              '<a>Title</a>'
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            null,
	            'An "actions" section, containing one or more action items. Each action item should ideally be represented by a ',
	            _get__('React').createElement(
	              'code',
	              { className: 'inline' },
	              '<button>'
	            ),
	            ' element with a class of ',
	            _get__('React').createElement(
	              'code',
	              { className: 'inline' },
	              'nav__action-btn'
	            ),
	            ', and containing an ',
	            _get__('React').createElement(
	              'a',
	              { href: '#icons' },
	              'icon'
	            ),
	            '.'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' To display the logo as the CME Group globe only, add a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'nav__logo--globe-only'
	          ),
	          ' to the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'nav__logo'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Top-level Navigation'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Top-level navigation styles are reserved for sites/applications that exist outside of Customer Center (a.k.a Uno or Common Nav). For example, cmegroup.com, CME Institute, CME One etc. Top-level navigation is denoted by the presence of the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'nav--global'
	          ),
	          ' class. To change the theme to use the dark theme the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'nav--dark'
	          ),
	          ' class should also be applied.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1602' },
	            '1600px (xlg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "275px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n          <html>\n            <head>\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n              <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n            </head>\n            <body>\n\n              <nav class="nav nav--global nav--dark drop-shadow js-nav">\n                <div class="nav__inner">\n                  <div class="nav__header nav__header--logo-only">\n                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary">\n                      <a>Trading</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Agricultural</a></li>\n                        <li class="nav__item--secondary"><a>Energy</a></li>\n                        <li class="nav__item--secondary"><a>Equity Index</a></li>\n                        <li class="nav__item--secondary"><a>FX</a></li>\n                        <li class="nav__item--secondary"><a>Interest Rates</a></li>\n                        <li class="nav__item--secondary"><a>Metals</a></li>\n                        <li class="nav__item--secondary"><a>Options</a></li>\n                        <li class="nav__item--secondary"><a>OTC</a></li>\n                        <li class="nav__item--secondary"><a>Weather</a></li>\n                        <li class="nav__item--secondary"><a>Real Estate</a></li>\n                        <li class="nav__item--secondary"><a>Technology</a></li>\n                        <li class="nav__item--secondary"><a>CME Globex</a></li>\n                        <li class="nav__item--secondary"><a>CME Direct</a></li>\n                        <li class="nav__item--secondary"><a>CME ClearPort</a></li>\n                        <li class="nav__item--secondary"><a>Straight Through Processing (STP)</a></li>\n                        <li class="nav__item--secondary"><a>Global Repository Services</a></li>\n                        <li class="nav__item--secondary"><a>Co-Location Services</a></li>\n                        <li class="nav__item--secondary"><a>CME Pivot</a></li>\n                        <li class="nav__item--secondary"><a>Membership</a></li>\n                        <li class="nav__item--secondary"><a>Fees</a></li>\n                        <li class="nav__item--secondary"><a>Incentive Programs</a></li>\n                        <li class="nav__item--secondary"><a>Tools &amp; Resources</a></li>\n                        <li class="nav__item--secondary"><a>Swap Execution Facility (SEF)</a></li>\n                        <li class="nav__item--secondary"><a>CME Europe</a></li>\n                        <li class="nav__item--secondary"><a>Economic Research</a></li>\n                        <li class="nav__item--secondary"><a>Holiday Calendar</a></li>\n                        <li class="nav__item--secondary"><a>Find a Broker</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary is-active">\n                      <a>Clearing</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Clearing Home</a></li>\n                        <li class="nav__item--secondary is-active"><a>Risk Management</a></li>\n                        <li class="nav__item--secondary"><a>Financial &amp; Collateral Management</a></li>\n                        <li class="nav__item--secondary"><a>Financial and Regulatory Surveillance</a></li>\n                        <li class="nav__item--secondary"><a>Clearing Operations and Deliveries</a></li>\n                        <li class="nav__item--secondary"><a>Performance Bonds / Margins</a></li>\n                        <li class="nav__item--secondary"><a>Clearing Advisories</a></li>\n                        <li class="nav__item--secondary is-active"><a>CME Clearing Europe</a></li>\n                        <li class="nav__item--secondary"><a>Margin Services</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>Regulation</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Market Regulation Home</a></li>\n                        <li class="nav__item--secondary"><a>Investigations</a></li>\n                        <li class="nav__item--secondary"><a>Data Investigations</a></li>\n                        <li class="nav__item--secondary"><a>Market Surveillance</a></li>\n                        <li class="nav__item--secondary"><a>Enforcement</a></li>\n                        <li class="nav__item--secondary"><a>Regulatory Outreach</a></li>\n                        <li class="nav__item--secondary"><a>Advisory Notices</a></li>\n                        <li class="nav__item--secondary"><a>Subscription Center</a></li>\n                        <li class="nav__item--secondary"><a>Rulebooks</a></li>\n                        <li class="nav__item--secondary"><a>Rule Filings</a></li>\n                        <li class="nav__item--secondary"><a>Disciplinary Notices</a></li>\n                        <li class="nav__item--secondary"><a>Arbitration</a></li>\n                        <li class="nav__item--secondary"><a>Position Links</a></li>\n                        <li class="nav__item--secondary"><a>Registrar\'s Advisories</a></li>\n                        <li class="nav__item--secondary"><a>Market Regulation Advisory Notices</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>Data</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Market Data Home</a></li>\n                        <li class="nav__item--secondary"><a>Settlements</a></li>\n                        <li class="nav__item--secondary"><a>Volume &amp; Open Interest</a></li>\n                        <li class="nav__item--secondary"><a>Daily Bulletin</a></li>\n                        <li class="nav__item--secondary"><a>Registrar Reports</a></li>\n                        <li class="nav__item--secondary"><a>New &amp; Existing Distributors</a></li>\n                        <li class="nav__item--secondary"><a>Licensed Distributor List</a></li>\n                        <li class="nav__item--secondary"><a>Delayed Quotes</a></li>\n                        <li class="nav__item--secondary"><a>Block Trades</a></li>\n                        <li class="nav__item--secondary"><a>MDP (Streaming)</a></li>\n                        <li class="nav__item--secondary"><a>E-Quotes</a></li>\n                        <li class="nav__item--secondary"><a>Datamine (Historical)</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>Education</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Education Home</a></li>\n                        <li class="nav__item--secondary"><a>Learn About Trading</a></li>\n                        <li class="nav__item--secondary"><a>Practice Trading</a></li>\n                        <li class="nav__item--secondary"><a>Risk Management/Hedging</a></li>\n                        <li class="nav__item--secondary"><a>Event Calendar</a></li>\n                        <li class="nav__item--secondary"><a>Podcasts</a></li>\n                        <li class="nav__item--secondary"><a>All Education Materials</a></li>\n                        <li class="nav__item--secondary"><a>Alternative Investment Resources</a></li>\n                        <li class="nav__item--secondary"><a>Latest Market Reports</a></li>\n                        <li class="nav__item--secondary"><a>Futures Institute</a></li>\n                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>About</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>About Us Home</a></li>\n                        <li class="nav__item--secondary"><a>Corporate Overview</a></li>\n                        <li class="nav__item--secondary"><a>Global Offices</a></li>\n                        <li class="nav__item--secondary"><a>Center for Innovation</a></li>\n                        <li class="nav__item--secondary"><a>Corporate Citizenship</a></li>\n                        <li class="nav__item--secondary"><a>Careers</a></li>\n                        <li class="nav__item--secondary"><a>Investor Relations</a></li>\n                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>\n                        <li class="nav__item--secondary"><a>Futures Institute</a></li>\n                        <li class="nav__item--secondary"><a>Media Room</a></li>\n                        <li class="nav__item--secondary"><a>News</a></li>\n                        <li class="nav__item--secondary"><a>Jobs</a></li>\n                        <li class="nav__item--secondary"><a>Open Markets</a></li>\n                      </ul>\n                    </li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n\n              <br/>\n\n              <nav class="nav nav--global nav--dark drop-shadow js-nav">\n                <div class="nav__inner">\n                  <div class="nav__header nav__header--alternate">\n                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                    <h1 class="nav__app-name">CME Institute</h1>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary"><a>Learn</a></li>\n                    <li class="nav__item--primary"><a>Practice</a></li>\n                    <li class="nav__item--primary"><a>Challenge</a></li>\n                    <li class="nav__item--primary"><a>Markets</a></li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n\n              <br/>\n\n              <nav class="nav nav--global nav--dark drop-shadow js-nav">\n                <div class="nav__inner">\n                  <div class="nav__header">\n                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                    <h1 class="nav__app-name">Customer Center</h1>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary"><a>Portfolio &amp; Risk</a></li>\n                    <li class="nav__item--primary"><a>Regulatory</a></li>\n                    <li class="nav__item--primary"><a>Apps &amp; Analytics</a></li>\n                    <li class="nav__item--primary"><a>Administration</a></li>\n                    <li class="nav__item--primary"><a>Default</a></li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="21"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n\n              <br/>\n\n              <nav class="nav nav--global nav--blue drop-shadow js-nav">\n                <div class="nav__inner">\n                  <div class="nav__header nav__header--logo-only">\n                    <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                  </div>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n\n            </body>\n            <script type="text/javascript" src="js/commonUI.js"></script>\n            <script>\n              function init() {\n                commonUI.initializeNavigation();\n              }\n              window.onload = init;\n            </script>\n          </html>\n        ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<nav class="nav nav--global nav--dark drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header nav__header--logo-only">\n      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>Trading</a></li>\n      <li class="nav__item--primary"><a>Clearing</a></li>\n      <li class="nav__item--primary"><a>Regulation</a></li>\n      <li class="nav__item--primary"><a>Data</a></li>\n      <li class="nav__item--primary"><a>Education</a></li>\n      <li class="nav__item--primary"><a>About</a></li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>\n    </ul>\n  </div>\n</nav>\n\n<nav class="nav nav--global nav--dark drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header nav__header--alternate">\n      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n      <h1 class="nav__app-name">CME Institute</h1>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>Learn</a></li>\n      <li class="nav__item--primary"><a>Practice</a></li>\n      <li class="nav__item--primary"><a>Challenge</a></li>\n      <li class="nav__item--primary"><a>Markets</a></li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>\n    </ul>\n  </div>\n</nav>\n\n<nav class="nav nav--global nav--dark drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header">\n      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n      <h1 class="nav__app-name">Customer Center</h1>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>Portfolio &amp; Risk</a></li>\n      <li class="nav__item--primary"><a>Regulatory</a></li>\n      <li class="nav__item--primary"><a>Apps &amp; Analytics</a></li>\n      <li class="nav__item--primary"><a>Administration</a></li>\n      <li class="nav__item--primary"><a>Default</a></li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="21"></i></button></li>\n    </ul>\n  </div>\n</nav>\n\n<nav class="nav nav--global nav--blue drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header nav__header--logo-only">\n      <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n    </div>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon"></i></button></li>\n    </ul>\n  </div>\n</nav>'
	          )
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            _get__('React').createElement('i', { className: 'fa fa-lightbulb-o fa-lg' }),
	            ' Tip:'
	          ),
	          ' To add a badge count to one of the action items add a custom data attribute called ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'data-badge-count'
	          ),
	          ' to the associated ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'nav__action-icon'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Light theme'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'In some scenarios, a lighter version of the navigation will be most appropriate. This version can be used for both internal and external apps, or as a basis for whitelabelling our nav component. It encompasses the same behaviour and interactions as the other versions, and has the option to add the logo and/or the stripes.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The light theme can be implemented by adding the modifier class ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.nav--light'
	          ),
	          ' to the navigation as shown in the example below. We have also added a modifier for the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.nav__header'
	          ),
	          ' to remove the strips either side of the logo, simply add the class ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.nav__header--no-strips'
	          )
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1602' },
	            '1600px (xlg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "275px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n          <html>\n            <head>\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n              <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n            </head>\n            <body>\n\n              <nav class="nav nav--global nav--light drop-shadow js-nav">\n                <div class="nav__inner">\n                  <div class="nav__header nav__header--logo-only">\n                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary">\n                      <a>Trading</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Agricultural</a></li>\n                        <li class="nav__item--secondary"><a>Energy</a></li>\n                        <li class="nav__item--secondary"><a>Equity Index</a></li>\n                        <li class="nav__item--secondary"><a>FX</a></li>\n                        <li class="nav__item--secondary"><a>Interest Rates</a></li>\n                        <li class="nav__item--secondary"><a>Metals</a></li>\n                        <li class="nav__item--secondary"><a>Options</a></li>\n                        <li class="nav__item--secondary"><a>OTC</a></li>\n                        <li class="nav__item--secondary"><a>Weather</a></li>\n                        <li class="nav__item--secondary"><a>Real Estate</a></li>\n                        <li class="nav__item--secondary"><a>Technology</a></li>\n                        <li class="nav__item--secondary"><a>CME Globex</a></li>\n                        <li class="nav__item--secondary"><a>CME Direct</a></li>\n                        <li class="nav__item--secondary"><a>CME ClearPort</a></li>\n                        <li class="nav__item--secondary"><a>Straight Through Processing (STP)</a></li>\n                        <li class="nav__item--secondary"><a>Global Repository Services</a></li>\n                        <li class="nav__item--secondary"><a>Co-Location Services</a></li>\n                        <li class="nav__item--secondary"><a>CME Pivot</a></li>\n                        <li class="nav__item--secondary"><a>Membership</a></li>\n                        <li class="nav__item--secondary"><a>Fees</a></li>\n                        <li class="nav__item--secondary"><a>Incentive Programs</a></li>\n                        <li class="nav__item--secondary"><a>Tools &amp; Resources</a></li>\n                        <li class="nav__item--secondary"><a>Swap Execution Facility (SEF)</a></li>\n                        <li class="nav__item--secondary"><a>CME Europe</a></li>\n                        <li class="nav__item--secondary"><a>Economic Research</a></li>\n                        <li class="nav__item--secondary"><a>Holiday Calendar</a></li>\n                        <li class="nav__item--secondary"><a>Find a Broker</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary is-active">\n                      <a>Clearing</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Clearing Home</a></li>\n                        <li class="nav__item--secondary is-active"><a>Risk Management</a></li>\n                        <li class="nav__item--secondary"><a>Financial &amp; Collateral Management</a></li>\n                        <li class="nav__item--secondary"><a>Financial and Regulatory Surveillance</a></li>\n                        <li class="nav__item--secondary"><a>Clearing Operations and Deliveries</a></li>\n                        <li class="nav__item--secondary"><a>Performance Bonds / Margins</a></li>\n                        <li class="nav__item--secondary"><a>Clearing Advisories</a></li>\n                        <li class="nav__item--secondary"><a>CME Clearing Europe</a></li>\n                        <li class="nav__item--secondary"><a>Margin Services</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>Regulation</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Market Regulation Home</a></li>\n                        <li class="nav__item--secondary"><a>Investigations</a></li>\n                        <li class="nav__item--secondary"><a>Data Investigations</a></li>\n                        <li class="nav__item--secondary"><a>Market Surveillance</a></li>\n                        <li class="nav__item--secondary"><a>Enforcement</a></li>\n                        <li class="nav__item--secondary"><a>Regulatory Outreach</a></li>\n                        <li class="nav__item--secondary"><a>Advisory Notices</a></li>\n                        <li class="nav__item--secondary"><a>Subscription Center</a></li>\n                        <li class="nav__item--secondary"><a>Rulebooks</a></li>\n                        <li class="nav__item--secondary"><a>Rule Filings</a></li>\n                        <li class="nav__item--secondary"><a>Disciplinary Notices</a></li>\n                        <li class="nav__item--secondary"><a>Arbitration</a></li>\n                        <li class="nav__item--secondary"><a>Position Links</a></li>\n                        <li class="nav__item--secondary"><a>Registrar\'s Advisories</a></li>\n                        <li class="nav__item--secondary"><a>Market Regulation Advisory Notices</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>Data</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Market Data Home</a></li>\n                        <li class="nav__item--secondary"><a>Settlements</a></li>\n                        <li class="nav__item--secondary"><a>Volume &amp; Open Interest</a></li>\n                        <li class="nav__item--secondary"><a>Daily Bulletin</a></li>\n                        <li class="nav__item--secondary"><a>Registrar Reports</a></li>\n                        <li class="nav__item--secondary"><a>New &amp; Existing Distributors</a></li>\n                        <li class="nav__item--secondary"><a>Licensed Distributor List</a></li>\n                        <li class="nav__item--secondary"><a>Delayed Quotes</a></li>\n                        <li class="nav__item--secondary"><a>Block Trades</a></li>\n                        <li class="nav__item--secondary"><a>MDP (Streaming)</a></li>\n                        <li class="nav__item--secondary"><a>E-Quotes</a></li>\n                        <li class="nav__item--secondary"><a>Datamine (Historical)</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>Education</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>Education Home</a></li>\n                        <li class="nav__item--secondary"><a>Learn About Trading</a></li>\n                        <li class="nav__item--secondary"><a>Practice Trading</a></li>\n                        <li class="nav__item--secondary"><a>Risk Management/Hedging</a></li>\n                        <li class="nav__item--secondary"><a>Event Calendar</a></li>\n                        <li class="nav__item--secondary"><a>Podcasts</a></li>\n                        <li class="nav__item--secondary"><a>All Education Materials</a></li>\n                        <li class="nav__item--secondary"><a>Alternative Investment Resources</a></li>\n                        <li class="nav__item--secondary"><a>Latest Market Reports</a></li>\n                        <li class="nav__item--secondary"><a>Futures Institute</a></li>\n                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>\n                      </ul>\n                    </li>\n                    <li class="nav__item--primary">\n                      <a>About</a>\n                      <ul class="nav__items--secondary">\n                        <li class="nav__item--secondary"><a>About Us Home</a></li>\n                        <li class="nav__item--secondary"><a>Corporate Overview</a></li>\n                        <li class="nav__item--secondary"><a>Global Offices</a></li>\n                        <li class="nav__item--secondary"><a>Center for Innovation</a></li>\n                        <li class="nav__item--secondary"><a>Corporate Citizenship</a></li>\n                        <li class="nav__item--secondary"><a>Careers</a></li>\n                        <li class="nav__item--secondary"><a>Investor Relations</a></li>\n                        <li class="nav__item--secondary"><a>Futures Fundamentals</a></li>\n                        <li class="nav__item--secondary"><a>Futures Institute</a></li>\n                        <li class="nav__item--secondary"><a>Media Room</a></li>\n                        <li class="nav__item--secondary"><a>News</a></li>\n                        <li class="nav__item--secondary"><a>Jobs</a></li>\n                        <li class="nav__item--secondary"><a>Open Markets</a></li>\n                      </ul>\n                    </li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n\n              <br/>\n\n              <nav class="nav nav--light nav--global drop-shadow js-nav">\n                <div class="nav__inner">\n                  <div class="nav__header nav__header--no-strips">\n                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                    <h1 class="nav__app-name">CME Institute</h1>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary"><a>Learn</a></li>\n                    <li class="nav__item--primary"><a>Practice</a></li>\n                    <li class="nav__item--primary"><a>Challenge</a></li>\n                    <li class="nav__item--primary"><a>Markets</a></li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n\n\n\n            </body>\n            <script type="text/javascript" src="js/commonUI.js"></script>\n            <script>\n              function init() {\n                commonUI.initializeNavigation();\n              }\n              window.onload = init;\n            </script>\n          </html>\n        ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<nav class="nav nav--global nav--light drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header nav__header--logo-only">\n      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>Trading</a></li>\n      <li class="nav__item--primary"><a>Clearing</a></li>\n      <li class="nav__item--primary"><a>Regulation</a></li>\n      <li class="nav__item--primary"><a>Data</a></li>\n      <li class="nav__item--primary"><a>Education</a></li>\n      <li class="nav__item--primary"><a>About</a></li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>\n    </ul>\n  </div>\n</nav>\n\n<nav class="nav nav--light nav--global drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header nav__header--no-strips">\n      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n      <h1 class="nav__app-name">CME Institute</h1>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>Learn</a></li>\n      <li class="nav__item--primary"><a>Practice</a></li>\n      <li class="nav__item--primary"><a>Challenge</a></li>\n      <li class="nav__item--primary"><a>Markets</a></li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>\n    </ul>\n  </div>\n</nav>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          '"Active" State'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To denote the "active" navigation item at either the primary or secondary level, apply a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'is-active'
	          ),
	          ' to the appropriate navigation item. Note that if a secondary level item is currently active, then the ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'is-active'
	          ),
	          ' class should be applied to both the secondary level item ',
	          _get__('React').createElement(
	            'em',
	            null,
	            'and'
	          ),
	          ' its corresponding primary level item, as demonstrated in the examples both above and below.'
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Default/App-level Navigation'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The default app-level navigation should be used for apps that reside within Uno/Common Nav.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1602' },
	            '1600px (xlg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "250px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n          <html>\n            <head>\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n              <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n            </head>\n            <body>\n              <nav class="nav drop-shadow js-nav responsive-nav-example">\n                <div class="nav__inner">\n                  <div class="nav__header">\n                    <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                    <h1 class="nav__app-name">Request Center</h1>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary"><a onclick="handleClick(this)">My Requests</a></li>\n                    <li class="nav__item--primary is-active"><a onclick="handleClick(this)">Globex Requests</a><ul class="nav__items--secondary"><li class="nav__item--secondary"><a onclick="handleClick(this)">Globex Firms</a></li><li class="nav__item--secondary is-active"><a onclick="handleClick(this)">Drop Copy Groups</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">iLink Sessions</a></li></ul></li>\n                    <li class="nav__item--primary"><a onclick="handleClick(this)">OTC</a><ul class="nav__items--secondary"><li class="nav__item--secondary"><a onclick="handleClick(this)">Exchange Registration</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Funds</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Platform</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Counterparty</a></li></ul></li>\n                    <li class="nav__item--primary"><a onclick="handleClick(this)">Incentive Programs</a></li>\n                    <li class="nav__item--primary"><a onclick="handleClick(this)">Preferences</a><ul class="nav__items--secondary"><li class="nav__item--secondary"><a onclick="handleClick(this)">Clearing Firms</a></li><li class="nav__item--secondary"><a onclick="handleClick(this)">Front End Systems</a></li></ul></li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn" id="contact-us-tool-tip"><i class="fa fa-phone"></i></button></li>\n                    <li class="nav__action"><a class="nav__action-link" href="http://www.cmegroup.com/tools-information/webhelp/cme-customer-center/Default.html" target="_blank" title="Help"><i class="fa fa-question-circle"></i></a></li>\n                </div>\n              </nav>\n            </body>\n            <script type="text/javascript" src="js/commonUI.js"></script>\n            <script>\n              function init() {\n                responsiveNav = commonUI.initializeNavigation({\n                  selector: \'.responsive-nav-example\',\n                });\n              }\n              const handleClick = (e) => {\n                const selectedNavItem = e.closest(\'li\');\n                const activeNavItems = responsiveNav.nav.querySelectorAll(\'.is-active\');\n\n                activeNavItems.forEach((elem) => elem.classList.remove(\'is-active\'));\n                selectedNavItem.classList.add(\'is-active\');\n\n                if (selectedNavItem.classList.contains(\'nav__item--secondary\')) {\n                  selectedNavItem.closest(\'.nav__item--primary.has-children\').classList.add(\'is-active\');\n                }\n              }\n              window.onload = init;\n            </script>\n          </html>\n        ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<nav class="nav drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header">\n      <a class="nav__logo nav__logo--globe-only" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n      <h1 class="nav__app-name">Request Center</h1>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>My Requests</a></li>\n      <li class="nav__item--primary is-active">\n        <a>Globex Requests</a>\n        <ul class="nav__items--secondary">\n          <li class="nav__item--secondary"><a>Globex Firms</a></li>\n          <li class="nav__item--secondary is-active"><a>Drop Copy Groups</a></li>\n          <li class="nav__item--secondary"><a>iLink Sessions</a></li>\n        </ul>\n      </li>\n      <li class="nav__item--primary">\n        <a>OTC</a>\n        <ul class="nav__items--secondary">\n          <li class="nav__item--secondary"><a>Exchange Registration</a></li>\n          <li class="nav__item--secondary"><a>Funds</a></li>\n          <li class="nav__item--secondary"><a>Platform</a></li>\n          <li class="nav__item--secondary"><a>Counterparty</a></li>\n        </ul>\n      </li>\n      <li class="nav__item--primary">\n        <a>Incentive Programs</a>\n      </li>\n      <li class="nav__item--primary">\n        <a>Preferences</a>\n        <ul class="nav__items--secondary">\n          <li class="nav__item--secondary"><a>Clearing Firms</a></li>\n          <li class="nav__item--secondary"><a>Front End Systems</a></li>\n        </ul>\n      </li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn" id="contact-us-tool-tip"><i class="fa fa-phone"></i></button></li>\n      <li class="nav__action"><a class="nav__action-link" href="http://www.cmegroup.com/tools-information/webhelp/cme-customer-center/Default.html" target="_blank" title="Help"><i class="fa fa-question-circle"></i></a></li>\n    </ul>\n  </div>\n</nav>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Responsive Navigation'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This is a partly JavaScript enabled component \u2014 by default, the navigation will work without JavaScript. However, should you need to implement mobile/responsive navigation functionality within your site or application, then you must include the commonUI JavaScript library on the page and apply a class of ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'js-nav'
	          ),
	          ' to act as a JavaScript hook on the top-level navigation element.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To initialize the navigation using the default selector ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'js-nav'
	          ),
	          ', call the following once the page has fully rendered:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeNavigation();'
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'If you wish to use a JS hook other than ',
	          _get__('React').createElement(
	            'code',
	            { className: 'inline' },
	            'js-nav'
	          ),
	          ' you can also initialize the navigation in the following manner:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeNavigation({selector: ".js-main-nav"});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	
	    //  render (){
	    //    return(
	    //    <section>
	    //      <a className="anchor" id="nav"></a>
	    //      <h2>Navigation</h2>
	    //      <br/>
	    //      <p>Classic theme</p>
	    //      <ul className="nav nav--branded-classic">
	    //        <li><a href="#">Trading</a></li>
	    //        <li><a href="#">Clearing</a></li>
	    //        <li><a href="#" className="nav--selected">Regulation</a></li>
	    //        <li><a href="#">Data</a></li>
	    //      </ul>
	    //
	    //      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
	    //      <pre className="hide-code"><code className="language-html">{`<ul class="nav nav--branded-classic">
	    //  <li><a href="#">Trading</a></li>
	    //  <li><a href="#">Clearing</a></li>
	    //  <li><a href="#" class="nav--selected">Regulation</a></li>
	    //  <li><a href="#">Data</a></li>
	    //</ul>`}</code></pre>
	    //
	    //      <br/>
	    //      <p>Main navigation theme</p>
	    //      <ul className="nav nav--branded-main">
	    //        <li><a href="#">Trading</a></li>
	    //        <li><a href="#">Clearing</a></li>
	    //        <li><a href="#" className="nav--selected">Regulation</a></li>
	    //        <li><a href="#">Data</a></li>
	    //      </ul>
	    //
	    //      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
	    //      <pre className="hide-code"><code className="language-html">{`<ul class="nav nav--branded-main">
	    //  <li><a href="#">Trading</a></li>
	    //  <li><a href="#">Clearing</a></li>
	    //  <li><a href="#" class="nav--selected">Regulation</a></li>
	    //  <li><a href="#">Data</a></li>
	    //</ul>`}</code></pre>
	    //
	    //      <br/>
	    //      <p>Multi level</p>
	    //      <div className="js-nav">
	    //        <ul className="nav nav--branded-main">
	    //          <li><a href="#">About</a></li>
	    //          <li><a href="#">Services</a></li>
	    //          <li>
	    //            <a className="nav__submenu" href="#">Offices &#9660;</a>
	    //            <ul className="nav nav--branded-main">
	    //              <li><a href="#">Chicago</a></li>
	    //              <li><a href="#">London</a></li>
	    //              <li><a href="#">Belfast</a></li>
	    //              <li><a href="#">Singapore</a></li>
	    //            </ul>
	    //          </li>
	    //        </ul>
	    //      </div>
	    //
	    //      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
	    //      <pre className="hide-code"><code className="language-html">{`<div class="js-nav">
	    //  <ul class="nav nav--branded-main js-nav">
	    //    <li><a href="#">About</a></li>
	    //    <li><a href="#">Services</a></li>
	    //    <li>
	    //        <a class="nav__submenu" href="#">Offices &#9660;</a>
	    //        <ul class="nav nav--branded-main">
	    //            <li><a href="#">Chicago</a></li>
	    //            <li><a href="#">London</a></li>
	    //            <li><a href="#">Belfast</a></li>
	    //            <li><a href="#">Singapore</a></li>
	    //        </ul>
	    //    </li>
	    //    <li><a href="#">Contact</a></li>
	    //  </ul>
	    //</div>`}</code></pre>
	    //
	    //      <br/>
	    //      <p>Responsive multi level</p>
	    //        <select className="size-select">
	    //          <option value="">Select a resolution</option>
	    //          <option value="482">480px (xs)</option>
	    //          <option value="770">768px (sm)</option>
	    //          <option value="994">992px (md)</option>
	    //          <option value="1202">1200px (lg)</option>
	    //        </select>
	    //        <br/><br/>
	    //        <div className="iframe-container" style={{"height":"400px"}}>
	    //          <iframe seamless srcDoc={`
	    //          <html>
	    //            <head>
	    //              <link rel="stylesheet" type="text/css" href="css/commonUI.css">
	    //              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
	    //              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
	    //            </head>
	    //            <body>
	    //            <div class="js-nav">
	    //              <ul class="nav nav--branded-main">
	    //                <li class="js-nav-toggle visuallyhidden--lap-and-up"><a><span><i class="fa fa-bars"></i>Menu</span></a></li>
	    //              </ul>
	    //              <ul class="nav nav--branded-main nav--collapse">
	    //                <li><a href="#">About</a></li>
	    //                <li><a href="#">Services</a></li>
	    //                <li>
	    //                  <a class="nav__submenu" href="#">Offices &#9660;</a>
	    //                  <ul class="nav nav--branded-main">
	    //                    <li><a href="#">Chicago</a></li>
	    //                    <li><a href="#">London</a></li>
	    //                    <li><a href="#">Belfast</a></li>
	    //                    <li><a href="#">Singapore</a></li>
	    //                  </ul>
	    //                </li>
	    //                <li><a href="#">Contact</a></li>
	    //              </ul>
	    //            </div>
	    //          </body>
	    //          <script type="text/javascript" src="js/commonUI.js"></script>
	    //          <script>
	    //            function init() {
	    //              commonUI.initializeNavigation();
	    //            }
	    //            window.onload = init;
	    //          </script>
	    //        </html>`}>
	    //          </iframe>
	    //        </div>
	    //
	    //      <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button><br/><br/>
	    //      <pre className="hide-code"><code className="language-html">{`<div class="js-nav">
	    //	<ul class="nav nav--branded-main">
	    //		<li class="js-nav-toggle visuallyhidden--lap-and-up"><a><span><i class="fa fa-bars"></i>Menu</span></a></li>
	    //	</ul>
	    //  <ul class="nav nav--branded-main nav--collapse">
	    //    <li><a href="#">About</a></li>
	    //    <li><a href="#">Services</a></li>
	    //    <li>
	    //        <a class="nav__submenu" href="#">Offices &#9660;</a>
	    //        <ul class="nav nav--branded-main">
	    //            <li><a href="#">Chicago</a></li>
	    //            <li><a href="#">London</a></li>
	    //            <li><a href="#">Belfast</a></li>
	    //            <li><a href="#">Singapore</a></li>
	    //        </ul>
	    //    </li>
	    //    <li><a href="#">Contact</a></li>
	    //  </ul>
	    //</div>`}</code></pre>
	    //
	    //      <br/>
	    //      <p>An example of this in use can be found in this <a href="samples/tables.html">sample layout.</a></p>
	    //        <br/>
	    //
	    //        <p>This is a partly javascript enabled component. You need to use the classes shown above to enable the responsive menu</p>
	    //        <p><b>Responsive functionality is only available with javascript</b></p>
	    //
	    //        <pre><code className="language-javascript">{`// Using default classes shown in snippet.
	    //// The library looks for the class 'js-nav' and 'js-nav-toggle' by default.
	    //commonUI.initializeNavigation();
	    //
	    //// You can have multiple navs on the page, they will all be initialised
	    //
	    //// Using custom selectors
	    //commonUI.initializeNavigation(
	    //  {
	    //    selector: '.special-nav',
	    //    clickElementSelector: '.special-nav-toggle-button'
	    //  }
	    //);`}</code></pre>
	    //
	    //    <br/>
	    //    <hr />
	    //    </section>
	    //  )
	    //}
	
	  }]);
	
	  return Nav;
	}(_get__('Component'));
	
	exports.default = _get__('Nav');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Nav':
	      return Nav;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Nav === 'undefined' ? 'undefined' : _typeof(Nav);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Nav, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Nav)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = function (_get__2) {
	  _inherits(Search, _get__2);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	  }
	
	  _createClass(Search, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'search' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Search'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The search component should be used to present a consistent search experience utilising a free text box and search button.'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'search' }),
	        _get__('React').createElement(
	          'div',
	          { className: 'search js-search', role: 'search' },
	          _get__('React').createElement(
	            'div',
	            { className: 'search-input' },
	            _get__('React').createElement('input', { type: 'text', placeholder: 'Search' }),
	            _get__('React').createElement('i', { className: 'fa fa-search' })
	          ),
	          _get__('React').createElement(
	            'button',
	            { className: 'nav__action-btn search-toggle' },
	            _get__('React').createElement('i', { className: 'fa fa-search' })
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="search js-search" role="search">\n  <div class="search-input">\n    <input type="text" placeholder="Search" />\n    <i class="fa fa-search"></i>\n  </div>\n  <button class="nav__action-btn search-toggle"><i class="fa fa-search"></i></button>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The search component text box will be hidden on load by default. You can force it open on load by passing the following variable when initializing the component:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeSearch({openOnLoad: true})'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The search component text box visibility will be toggled when the search icon is clicked. To force it to always stay open you can pass the following variable when initializing the component:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeSearch({allowClose: false })'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The search components fires some events which you can hook into to execute your search within your application.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeSearch({selector: "#mySearch"});\n\nvar mySearch = document.getElementById("mySearch");\n\nmySearch.addEventListener(\'open.commonui.search\', function(){\n  console.log(\'open search\')\n});\n\nmySearch.addEventListener(\'close.commonui.search\', function(){\n  console.log(\'close search\')\n});\n\nmySearch.addEventListener(\'do.commonui.search\', function(){\n  console.log(\'do search\');\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Search within Navigation Component'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The search component has some unique behaviours when placed inside a navigation component. When clicking the search action icon in responsive mode (sm an md) the search box will be fixed under the nav component.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '482' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '770' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '994' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1202' },
	            '1200px (lg)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1602' },
	            '1600px (xlg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "110px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n          <html>\n            <head>\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n              <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Roboto">\n              <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n              <script language="javascript" src="js/commonUI.js"></script>\n            </head>\n            <body>\n\n              <nav class="nav">\n                <div class="nav__inner">\n                  <div class="nav__header">\n                    <a class="nav__logo nav__logo--small" href="/" title="CME Group"></a>\n                    <h1 class="nav__app-name">CORE</h1>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary"><a>Home</a></li>\n                    <li class="nav__item--primary"><a>Margin Calculator</a></li>\n                    <li class="nav__item--primary"><a>Reports</a></li>\n                    <li class="nav__item--primary"><a>Download Center</a></li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action">\n                      <div class="search js-search" role="search" id="mySearch">\n                        <div class="search-input">\n                          <input type="text" placeholder="Search" class="text-input" />\n                          <i class="fa fa-search"></i>\n                        </div>\n                        <button class="nav__action-btn search-toggle"><i class="fa fa-search"></i></button>\n                      </div>\n                    </li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n              <script language="javascript">\n                commonUI.initializeSearch({ selector: "#mySearch", openOnLoad: false, allowClose: true, alwaysOpenDownInNav: false  });\n\n                var mySearch = document.getElementById("mySearch");\n\n                mySearch.addEventListener(\'open.commonui.search\', function(){\n                    console.log(\'open search\')\n                });\n\n                mySearch.addEventListener(\'close.commonui.search\', function(){\n                    console.log(\'close search\')\n                });\n\n                mySearch.addEventListener(\'do.commonui.search\', function(){\n                  console.log(\'do search\');\n                });\n\n               </script>\n            </body>\n          </html>\n        ' })
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<nav class="nav">\n  <div class="nav__inner">\n    <div class="nav__header">\n      <a class="nav__logo nav__logo--small" href="/" title="CME Group"></a>\n      <h1 class="nav__app-name">CORE</h1>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>Home</a></li>\n      <li class="nav__item--primary"><a>Margin Calculator</a></li>\n      <li class="nav__item--primary"><a>Reports</a></li>\n      <li class="nav__item--primary"><a>Download Center</a></li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action">\n        <div class="search js-search" role="search" id="mySearch">\n          <div class="search-input">\n            <input type="text" placeholder="Search" class="text-input" />\n            <i class="fa fa-search"></i>\n          </div>\n          <button class="nav__action-btn search-toggle"><i class="fa fa-search"></i></button>\n        </div>\n      </li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-bell"></i></button></li>\n    </ul>\n  </div>\n</nav>\n<script language="javascript">\n  commonUI.initializeSearch({ selector: "#mySearch", openOnLoad: false, allowClose: true, alwaysOpenDownInNav: false  });\n\n  var mySearch = document.getElementById("mySearch");\n\n  mySearch.addEventListener(\'open.commonui.search\', function(){\n      console.log(\'open search\')\n  });\n\n  mySearch.addEventListener(\'close.commonui.search\', function(){\n      console.log(\'close search\')\n  });\n\n  mySearch.addEventListener(\'do.commonui.search\', function(){\n    console.log(\'do search\');\n  });\n\n </script>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The search component can be forced for all responsive variants to always open underneath the navigation component by passing the following variable when initializing the component:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeSearch({alwaysOpenDownInNav: true})'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Search;
	}(_get__('Component'));
	
	exports.default = _get__('Search');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Search':
	      return Search;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Search === 'undefined' ? 'undefined' : _typeof(Search);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Search, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Search)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sizeSelector = __webpack_require__(845);
	
	var _sizeSelector2 = _interopRequireDefault(_sizeSelector);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Accordion = function (_get__2) {
	  _inherits(Accordion, _get__2);
	
	  function Accordion(props) {
	    _classCallCheck(this, Accordion);
	
	    var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));
	
	    _this.state = {
	      theme: 'default',
	      size: 'medium'
	    };
	    return _this;
	  }
	
	  _createClass(Accordion, [{
	    key: 'render',
	    value: function render() {
	      var size = this.state.size;
	
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'accordion' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Accordion'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'accordion' }),
	        _get__('React').createElement(_get__('SizeSelector'), {
	          componentToSize: this
	        }),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Default style'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'div',
	            { className: 'accordion js-accordion accordion--' + size },
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 1'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 2'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 3'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '\n            <div class="soft">\n              <div class="accordion js-accordion accordion--' + size + '">\n                <div class="accordion__item">\n                  <div class="accordion__title">\n                    <h2 class="flush">Accordion title 1</h2>\n                  </div>\n                  <div class="accordion__content">\n                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>\n                  </div>\n                </div>\n                <div class="accordion__item">\n                  <div class="accordion__title">\n                    <h2 class="flush">Accordion title 2</h2>\n                  </div>\n                  <div class="accordion__content">\n                    <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>\n                  </div>\n                </div>\n                <div class="accordion__item">\n                  <div class="accordion__title">\n                    <h2 class="flush">Accordion title 3</h2>\n                  </div>\n                  <div class="accordion__content">\n                    <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>\n                  </div>\n                </div>\n              </div>\n            </div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Light style'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'div',
	            { className: 'accordion accordion--light js-accordion accordion--' + size },
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 1'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 2'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 3'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '\n          <div class="soft">\n            <div class="accordion accordion--light js-accordion accordion--' + size + '">\n              <div class="accordion__item">\n                <div class="accordion__title">\n                  <h2 class="flush">Accordion title 1</h2>\n                </div>\n                <div class="accordion__content">\n                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>\n                </div>\n              </div>\n              <div class="accordion__item">\n                <div class="accordion__title">\n                  <h2 class="flush">Accordion title 2</h2>\n                </div>\n                <div class="accordion__content">\n                  <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>\n                </div>\n              </div>\n              <div class="accordion__item">\n                <div class="accordion__title">\n                  <h2 class="flush">Accordion title 3</h2>\n                </div>\n                <div class="accordion__content">\n                  <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>\n                </div>\n              </div>\n            </div>\n          </div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Highlight active style'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft' },
	          _get__('React').createElement(
	            'div',
	            { className: 'accordion accordion--highlight-active js-accordion accordion--' + size },
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 1'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 2'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'accordion__item' },
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__title' },
	                _get__('React').createElement(
	                  'h2',
	                  { className: 'flush' },
	                  'Accordion title 3'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'accordion__content' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '\n          <div class="soft">\n            <div class="accordion accordion--highlight-active js-accordion accordion--' + size + '">\n                <div class="accordion__item accordion--open">\n                    <div class="accordion__title">\n                        <h2 class="flush">Accordion title 1</h2>\n                    </div>\n                    <div class="accordion__content hard">\n                        <div class="accordion accordion--light js-accordion">\n                            <div class="accordion__item accordion--open">\n                                <div class="accordion__title">\n                                    <h2 class="flush">Accordion title 1</h2>\n                                </div>\n                                <div class="accordion__content">\n                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et dui sit amet massa vehicula semper id eu neque. Nulla venenatis consectetur mauris. Integer eu ornare eros. In malesuada viverra urna sed vehicula.</p>\n                                </div>\n                            </div>\n                            <div class="accordion__item">\n                                <div class="accordion__title">\n                                    <h2 class="flush">Accordion title 2</h2>\n                                </div>\n                                <div class="accordion__content">\n                                    <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>\n                                </div>\n                            </div>\n                            <div class="accordion__item">\n                                <div class="accordion__title">\n                                    <h2 class="flush">Accordion title 3</h2>\n                                </div>\n                                <div class="accordion__content">\n                                    <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="accordion__item">\n                    <div class="accordion__title">\n                        <h2 class="flush">Accordion title 2</h2>\n                    </div>\n                    <div class="accordion__content">\n                        <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Etiam id lorem vestibulum, ornare ipsum vel, varius magna. Integer venenatis nibh urna, et hendrerit felis venenatis in.</p>\n                    </div>\n                </div>\n                <div class="accordion__item">\n                    <div class="accordion__title">\n                        <h2 class="flush">Accordion title 3</h2>\n                    </div>\n                    <div class="accordion__content">\n                        <p>Curabitur accumsan augue eget purus lacinia, at fringilla velit vestibulum. Aenean iaculis enim elit. Vestibulum convallis, massa et vestibulum feugiat, leo ipsum commodo libero, vel lacinia diam libero vel purus.</p>\n                    </div>\n                </div>\n              </div>\n            </div>\n      '
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Usage'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeAccordion();'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Options'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'commonUI.initializeAccordion()'
	          ),
	          ' shown above will imply the default options as shown below.'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--striped table--cosy' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                null,
	                'Name'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Type'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Default'
	              ),
	              _get__('React').createElement(
	                'th',
	                null,
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'selector'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'string'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '\'.js-accordion\''
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This is the selector that will be used to hook into the DOM and Initialize the accordion.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'openByDefault'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'boolean'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'true'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Open the first item of the accordion on initialization.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'singleOpen'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'boolean'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'true'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Allow only one accordion item to be open at a time.'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'These options can be overridden by passing an object to the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'commonUI.initializeAccordion()'
	          ),
	          ' function, for example:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '\n      commonUI.initializeAccordion({\n        selector: \'.js-customHookClass\',\n        openByDefault: false,\n        singleOpen: false\n      });\n    '
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Accordion;
	}(_get__('Component'));
	
	exports.default = _get__('Accordion');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Accordion':
	      return Accordion;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	
	    case 'SizeSelector':
	      return _sizeSelector2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Accordion === 'undefined' ? 'undefined' : _typeof(Accordion);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Accordion, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Accordion)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _uuid = __webpack_require__(846);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SizeSelector = function (_get__2) {
	  _inherits(SizeSelector, _get__2);
	
	  function SizeSelector(props) {
	    _classCallCheck(this, SizeSelector);
	
	    var _this = _possibleConstructorReturn(this, (SizeSelector.__proto__ || Object.getPrototypeOf(SizeSelector)).call(this, props));
	
	    _this.props = props;
	    _this.handleSizeChange = _this.handleSizeChange.bind(_this);
	    return _this;
	  }
	
	  _createClass(SizeSelector, [{
	    key: 'handleSizeChange',
	    value: function handleSizeChange(event) {
	      var componentToSize = this.props.componentToSize;
	
	      componentToSize.setState({ size: event.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'div',
	        null,
	        _get__('React').createElement(
	          'p',
	          null,
	          'Change Size:'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'push-half--bottom', id: _get__('uuid')(), onChange: this.handleSizeChange, style: { 'maxWidth': '160px', 'display': 'inline' } },
	          _get__('React').createElement(
	            'option',
	            { value: 'medium', selected: true },
	            'Default(Medium)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: 'x-small' },
	            'x-small'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: 'small' },
	            'small'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: 'large' },
	            'large'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SizeSelector;
	}(_get__('Component'));
	
	exports.default = _get__('SizeSelector');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'uuid':
	      return _uuid2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'SizeSelector':
	      return SizeSelector;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof SizeSelector === 'undefined' ? 'undefined' : _typeof(SizeSelector);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(SizeSelector, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(SizeSelector)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(847);
	var v4 = __webpack_require__(850);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(848);
	var bytesToUuid = __webpack_require__(849);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/broofa/node-uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ }),
/* 849 */
/***/ (function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  return bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] + '-' +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]] +
	          bth[buf[i++]] + bth[buf[i++]];
	}
	
	module.exports = bytesToUuid;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(848);
	var bytesToUuid = __webpack_require__(849);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SplitPanel = function (_get__2) {
	  _inherits(SplitPanel, _get__2);
	
	  function SplitPanel(props) {
	    _classCallCheck(this, SplitPanel);
	
	    var _this = _possibleConstructorReturn(this, (SplitPanel.__proto__ || Object.getPrototypeOf(SplitPanel)).call(this, props));
	
	    _this.state = {
	      'smallSplitterVertical': false,
	      'smallSplitterHorizontal': false,
	      'lightColourVertical': false,
	      'lightColourHorizontal': false
	    };
	    return _this;
	  }
	
	  _createClass(SplitPanel, [{
	    key: 'toggleVerticalSplitterWidth',
	    value: function toggleVerticalSplitterWidth() {
	      this.setState({ smallSplitterVertical: !this.state.smallSplitterVertical });
	    }
	  }, {
	    key: 'toggleHorizontalSplitterWidth',
	    value: function toggleHorizontalSplitterWidth() {
	      this.setState({ smallSplitterHorizontal: !this.state.smallSplitterHorizontal });
	    }
	  }, {
	    key: 'toggleVerticalColour',
	    value: function toggleVerticalColour() {
	      this.setState({ lightColourVertical: !this.state.lightColourVertical });
	    }
	  }, {
	    key: 'toggleHorizontalColour',
	    value: function toggleHorizontalColour() {
	      this.setState({ lightColourHorizontal: !this.state.lightColourHorizontal });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        { className: 'is-styleguide' },
	        _get__('React').createElement('a', { className: 'anchor', id: 'splitpanel' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Resizeable Split Layout'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'splitPanels' }),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The Split Layout component is intended to be used as a wrapper for scenarios where you wish to resize various components in the UI. There are two modes, vertical and horizontal, and support 2 panels.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'By Default the Split Layout component will work as 2 seperate panels where the main panel will launch the secondary panel when triggered to do so. If you want to avoid this functionality add the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'split-panel--stacked'
	          ),
	          ' helper class to the Split Layout parent element and remove the buttons from each panel. You have to set the height of the spllit panels as follows:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            '.split-panel {\n  height: 600px;\n}\n'
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'By default, there will be no gutter on the divider. To enable this, apply ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'split-panel--gutter'
	          ),
	          '.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To enable a colour version apply ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'split-panel--light'
	          ),
	          '. Add the following CSS using your own colour for background and box shadow. This can be seen in action by toggling the colour version.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            '.split-panel--light {\n  background-color: INSERT-COLOUR-HERE;\n}\n.split-panel--light.split-panel--gutter .split-panel--vertical--divider,\n.split-panel--light.split-panel--gutter .split-panel--horizontal--divider {\n  box-shadow: 0 0 0 12px INSERT-COLOUR-HERE;\n}'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Vertical Layout'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'You can use a vertical splitter - this can be achieved by adding the',
	          _get__('React').createElement(
	            'code',
	            null,
	            ' js-vertically-divided'
	          ),
	          ' JavaScript hook to the container.'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push--right push--bottom', onClick: this.toggleVerticalColour.bind(this) },
	          'Toggle Colour Version'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push--right push--bottom', onClick: this.toggleVerticalSplitterWidth.bind(this) },
	          'Toggle Splitter Width'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'split-panel split-panel--vertical split-panel--gutter js-split-panel js-vertically-divided ' + (this.state.smallSplitterVertical && 'split-panel--vertical-small') + ' ' + (this.state.lightColourVertical && 'split-panel--light') },
	          _get__('React').createElement(
	            'div',
	            { className: 'soft-half split-panel--main' },
	            _get__('React').createElement(
	              'div',
	              null,
	              _get__('React').createElement(
	                'h1',
	                null,
	                'Content Main'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.'
	              ),
	              _get__('React').createElement(
	                'button',
	                { className: 'btn split-panel--btn split-panel__launch' },
	                'Launch Content'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'soft-half split-panel--secondary' },
	            _get__('React').createElement(
	              'div',
	              { className: 'soft-half split-panel--title' },
	              _get__('React').createElement('i', { className: 'fa fa-angle-left split-panel__back' }),
	              _get__('React').createElement(
	                'h1',
	                null,
	                'Content Two'
	              )
	            ),
	            _get__('React').createElement(
	              'table',
	              { className: 'table table--light table--comfy table--hover table--striped table--responsive js-table--responsive' },
	              _get__('React').createElement(
	                'thead',
	                null,
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Ipsum'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Sit'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Afdipisicing'
	                  )
	                )
	              ),
	              _get__('React').createElement(
	                'tbody',
	                null,
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '03.788'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '32.210'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '47.797'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '09.640'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '12.117'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Horizontal Layout'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'You can also use a horizontal splitter - this can be achieved by adding the',
	          _get__('React').createElement(
	            'code',
	            null,
	            ' js-horizontally-divided'
	          ),
	          ' JavaScript hook to the container.'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push--right push--bottom', onClick: this.toggleHorizontalColour.bind(this) },
	          'Toggle Colour Version'
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push--right push--bottom', onClick: this.toggleHorizontalSplitterWidth.bind(this) },
	          'Toggle Splitter Width'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'split-panel split-panel--horizontal js-split-panel js-horizontally-divided ' + (this.state.smallSplitterHorizontal && 'split-panel--horizontal-small') + ' ' + (this.state.lightColourHorizontal && 'split-panel--light') },
	          _get__('React').createElement(
	            'div',
	            { className: 'soft-half split-panel--main' },
	            _get__('React').createElement(
	              'div',
	              null,
	              _get__('React').createElement(
	                'h1',
	                null,
	                'Content Main'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.'
	              ),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.'
	              ),
	              _get__('React').createElement(
	                'button',
	                { className: 'btn split-panel--btn split-panel__launch' },
	                'Launch Content'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'soft-half split-panel--secondary' },
	            _get__('React').createElement(
	              'div',
	              { className: 'soft-half split-panel--title' },
	              _get__('React').createElement('i', { className: 'fa fa-angle-left split-panel__back' }),
	              _get__('React').createElement(
	                'h1',
	                null,
	                'Content Two'
	              )
	            ),
	            _get__('React').createElement(
	              'table',
	              { className: 'table table--light table--comfy table--hover table--striped table--responsive js-table--responsive' },
	              _get__('React').createElement(
	                'thead',
	                null,
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Ipsum'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Sit'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'th',
	                    null,
	                    'Afdipisicing'
	                  )
	                )
	              ),
	              _get__('React').createElement(
	                'tbody',
	                null,
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '03.788'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '32.210'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '47.797'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '09.640'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                ),
	                _get__('React').createElement(
	                  'tr',
	                  null,
	                  _get__('React').createElement(
	                    'th',
	                    { scope: 'row' },
	                    _get__('React').createElement(
	                      'a',
	                      { href: '' },
	                      'Sit'
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Dolor'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    '12.117'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Lorem'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Amet'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Consectetur'
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    'Afdipisicing'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout' },
	          _get__('React').createElement(
	            'strong',
	            null,
	            'Note:'
	          ),
	          ' The height of the Split Layout wrapper, ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.split-panel'
	          ),
	          ', must be determined by the developer due to the panels being absolutely positioned and not inheriting height.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The JavaScript event ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '\'resized.commonui.splitpanel\''
	          ),
	          ' will get triggered on the element once the user has finished dragging the splitter. You can listen to this event like so:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'for (const splitPanel of document.getElementsByClassName(\'js-split-panel\')) {\n  splitPanel.addEventListener(\'resized.commonui.splitpanel\', () => {}, false);\n}'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Click \'View Source\' to show the code for all 4 different Split Layout Options.'
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="split-panel split-panel--vertical js-split-panel js-vertically-divided">\n  <div class="split-panel--main">\n    <div>\n      <h1>Vertical One</h1>\n      <p>This is Panel 1.</p>\n      <button class="btn split-panel--btn split-panel__launch">Launch Panel</button>\n    </div>\n  </div>\n  <div class="split-panel--secondary">\n    <div class="soft-half split-panel--title">\n      <i class="fa fa-angle-left split-panel__back"></i>\n      <h1>Vertical Two</h1>\n    </div>\n    <p>This is Panel 2.</p>\n  </div>\n</div>\n\n<div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided">\n  <div class="split-panel--main">\n    <div>\n      <h1>Horizontal One</h1>\n      <p>This is Panel 1.</p>\n      <button class="btn split-panel--btn split-panel__launch">Launch Panel</button>\n    </div>\n  </div>\n  <div class="split-panel--secondary">\n    <div class="soft-half split-panel--title">\n      <i class="fa fa-angle-left split-panel__back"></i>\n      <h1>Horizontal Two</h1>\n    </div>\n    <p>This is Panel 2.</p>\n  </div>\n</div>\n\n<div class="split-panel split-panel--stacked split-panel--vertical js-split-panel js-vertically-divided">\n  <div class="split-panel--main">\n    <div>\n      <h1>Vertical One Stacked</h1>\n      <p>This is Panel 1.</p>\n    </div>\n  </div>\n  <div class="split-panel--secondary">\n    <h1>Vertical Two Stacked</h2>\n    <p>This is Panel 2.</p>\n  </div>\n</div>\n\n<div class="split-panel split-panel--stacked split-panel--horizontal js-split-panel js-horizontally-divided">\n  <div class="split-panel--main">\n    <div>\n      <h1>Horizontal One Stacked</h1>\n      <p>This is Panel 1.</p>\n    </div>\n  </div>\n  <div class="split-panel--secondary">\n    <h1>Horizontal Two Stacked</h1>\n    <p>This is Panel 2.</p>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Responsive Default Vertical'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "600px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n  <head>\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n  </head>\n  <body class="is-styleguide">\n    <div class="split-panel split-panel--vertical js-split-panel js-vertically-divided">\n        <div class="soft-half split-panel--main">\n          <div>\n            <h1>Content Main</h1>\n            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>\n            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>\n            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>\n            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>\n            <button class="btn split-panel--btn split-panel__launch">Launch Content</button>\n          </div>\n        </div>\n        <div class="split-panel--secondary">\n            <div class="soft-half split-panel--title">\n              <i class="fa fa-angle-left split-panel__back"></i>\n              <h1>Content Secondary</h1>\n            </div>\n            <div class="soft-half">\n            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">\n            <thead>\n              <tr>\n                <th>Lorem</th>\n                <th>Ipsum</th>\n                <th>Dolor</th>\n                <th>Sit</th>\n                <th>Amet</th>\n                <th>Consectetur</th>\n                <th>Afdipisicing</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">03.788</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">32.210</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">47.797</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">09.640</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">12.117</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n            </tbody>\n            </table>\n            </div>\n        </div>\n    </div>\n  </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    function init() {\n      commonUI.initializeTable();\n      commonUI.initializeSplitPanel();\n    }\n    window.onload = init;\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Responsive Default Horizontal'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "600px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n  <head>\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n  </head>\n  <body class="is-styleguide">\n    <div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided">\n        <div class="soft-half split-panel--main">\n          <div>\n            <h1>Content Main</h1>\n            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>\n            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>\n            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>\n            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>\n            <button class="btn split-panel--btn split-panel__launch">Launch Content</button>\n          </div>\n        </div>\n        <div class="split-panel--secondary">\n            <div class="soft-half split-panel--title">\n              <i class="fa fa-angle-left split-panel__back"></i>\n              <h1>Content Secondary</h1>\n            </div>\n            <div class="soft-half">\n            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">\n            <thead>\n              <tr>\n                <th>Lorem</th>\n                <th>Ipsum</th>\n                <th>Dolor</th>\n                <th>Sit</th>\n                <th>Amet</th>\n                <th>Consectetur</th>\n                <th>Afdipisicing</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">03.788</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">32.210</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">47.797</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">09.640</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">12.117</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n            </tbody>\n            </table>\n            </div>\n        </div>\n    </div>\n  </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    function init() {\n        commonUI.initializeTable();\n        commonUI.initializeSplitPanel();\n    }\n    window.onload = init;\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Responsive Stacked Vertical'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "600px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n  <head>\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n  </head>\n  <body class="is-styleguide">\n    <div class="split-panel split-panel--vertical split-panel--stacked js-split-panel js-vertically-divided">\n        <div class="soft-half split-panel--main">\n          <div>\n            <h1>Content Main</h1>\n            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>\n            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>\n            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>\n            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>\n          </div>\n        </div>\n        <div class="soft-half split-panel--secondary">\n        <h1>Content Secondary</h1>\n        <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">\n        <thead>\n          <tr>\n            <th>Lorem</th>\n            <th>Ipsum</th>\n            <th>Dolor</th>\n            <th>Sit</th>\n            <th>Amet</th>\n            <th>Consectetur</th>\n            <th>Afdipisicing</th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr>\n            <th scope="row">\n              <a href="">Sit</a>\n            </th>\n            <td>Dolor</td>\n            <td class="text--center">03.788</td>\n            <td>Lorem</td>\n            <td>Amet</td>\n            <td>Consectetur</td>\n            <td>Afdipisicing</td>\n          </tr>\n          <tr>\n            <th scope="row">\n              <a href="">Sit</a>\n            </th>\n            <td>Dolor</td>\n            <td class="text--center">32.210</td>\n            <td>Lorem</td>\n            <td>Amet</td>\n            <td>Consectetur</td>\n            <td>Afdipisicing</td>\n          </tr>\n          <tr>\n            <th scope="row">\n              <a href="">Sit</a>\n            </th>\n            <td>Dolor</td>\n            <td class="text--center">47.797</td>\n            <td>Lorem</td>\n            <td>Amet</td>\n            <td>Consectetur</td>\n            <td>Afdipisicing</td>\n          </tr>\n          <tr>\n            <th scope="row">\n              <a href="">Sit</a>\n            </th>\n            <td>Dolor</td>\n            <td class="text--center">09.640</td>\n            <td>Lorem</td>\n            <td>Amet</td>\n            <td>Consectetur</td>\n            <td>Afdipisicing</td>\n          </tr>\n          <tr>\n            <th scope="row">\n              <a href="">Sit</a>\n            </th>\n            <td>Dolor</td>\n            <td class="text--center">12.117</td>\n            <td>Lorem</td>\n            <td>Amet</td>\n            <td>Consectetur</td>\n            <td>Afdipisicing</td>\n          </tr>\n        </tbody>\n        </table>\n        </div>\n    </div>\n  </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    function init() {\n        commonUI.initializeTable();\n        commonUI.initializeSplitPanel();\n    }\n    window.onload = init;\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Responsive Stacked Horizontal'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'At the smallest breakpoint, the panels will stack and the splitter will be removed. This is reset when back at the larger breakpoints.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "600px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n  <head>\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n  </head>\n  <body class="is-styleguide">\n    <div class="split-panel split-panel--horizontal split-panel--stacked js-split-panel js-horizontally-divided">\n        <div class="soft-half split-panel--main">\n          <div>\n            <h1>Content Main</h1>\n            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam dapibus scelerisque mi, at ultrices lacus. Praesent eget dolor sit amet lorem porta tempor. Vestibulum ut nisl euismod, viverra ante posuere, lobortis sem. Morbi aliquet libero vel accumsan vulputate. Nullam tincidunt tellus et dui tempus dapibus congue sit amet tellus. Vestibulum diam massa, fermentum eget lobortis ac, venenatis ut orci. Donec in feugiat lacus. Pellentesque lobortis arcu vehicula, mattis dui id, pharetra enim. Fusce consectetur ac erat et convallis. Cras lorem massa, egestas quis pretium in, pellentesque sed ipsum. Sed rhoncus erat dignissim nulla placerat sodales. Duis vel blandit turpis. Sed semper tellus velit, iaculis aliquet velit porta vitae.</p>\n            <p>Integer ac commodo neque. Vestibulum a elit id ligula eleifend gravida commodo ac ligula. Nam congue eget urna elementum consequat. Pellentesque faucibus sagittis lacinia. Sed rhoncus tincidunt felis sagittis feugiat. Quisque ullamcorper ipsum vitae molestie pulvinar. Sed eget consectetur nisl. Etiam rhoncus, purus vel lacinia commodo, orci velit posuere nisi, eget venenatis metus est sit amet turpis.</p>\n            <p>Duis porta ultricies mi, eu malesuada eros ullamcorper nec. Etiam a justo scelerisque, posuere est nec, facilisis lorem. Nam non felis et nulla suscipit sodales sed finibus lacus. In auctor non magna ut dignissim. Praesent nec sodales velit, eget condimentum tellus. In hac habitasse platea dictumst. Aenean nec est accumsan ipsum venenatis vehicula. Nulla nec risus non turpis placerat accumsan. Quisque id enim interdum eros egestas accumsan. Pellentesque quis diam porttitor, dignissim leo eget, pretium velit.</p>\n            <p>Nulla facilisi. Proin accumsan maximus lectus, sed aliquet justo iaculis lobortis. Praesent tincidunt bibendum neque, nec laoreet enim accumsan sit amet. Morbi efficitur nec turpis id feugiat. Vivamus condimentum bibendum venenatis. Suspendisse nulla mi, sollicitudin ut vehicula nec, lacinia quis ante. Nunc vel consectetur nisi. In placerat lacinia auctor. Morbi ultricies bibendum massa, id aliquam magna commodo non. Nulla iaculis sem sed erat congue, vel cursus ipsum cursus. Maecenas congue hendrerit vulputate. Duis dapibus velit at dictum dictum.</p>\n          </div>\n        </div>\n        <div class="soft-half split-panel--secondary">\n            <h1>Content Secondary</h1>\n            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">\n              <thead>\n                <tr>\n                  <th>Lorem</th>\n                  <th>Ipsum</th>\n                  <th>Dolor</th>\n                  <th>Sit</th>\n                  <th>Amet</th>\n                  <th>Consectetur</th>\n                  <th>Afdipisicing</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <th scope="row">\n                    <a href="">Sit</a>\n                  </th>\n                  <td>Dolor</td>\n                  <td class="text--center">03.788</td>\n                  <td>Lorem</td>\n                  <td>Amet</td>\n                  <td>Consectetur</td>\n                  <td>Afdipisicing</td>\n                </tr>\n                <tr>\n                  <th scope="row">\n                    <a href="">Sit</a>\n                  </th>\n                  <td>Dolor</td>\n                  <td class="text--center">32.210</td>\n                  <td>Lorem</td>\n                  <td>Amet</td>\n                  <td>Consectetur</td>\n                  <td>Afdipisicing</td>\n                </tr>\n                <tr>\n                  <th scope="row">\n                    <a href="">Sit</a>\n                  </th>\n                  <td>Dolor</td>\n                  <td class="text--center">47.797</td>\n                  <td>Lorem</td>\n                  <td>Amet</td>\n                  <td>Consectetur</td>\n                  <td>Afdipisicing</td>\n                </tr>\n                <tr>\n                  <th scope="row">\n                    <a href="">Sit</a>\n                  </th>\n                  <td>Dolor</td>\n                  <td class="text--center">09.640</td>\n                  <td>Lorem</td>\n                  <td>Amet</td>\n                  <td>Consectetur</td>\n                  <td>Afdipisicing</td>\n                </tr>\n                <tr>\n                  <th scope="row">\n                    <a href="">Sit</a>\n                  </th>\n                  <td>Dolor</td>\n                  <td class="text--center">12.117</td>\n                  <td>Lorem</td>\n                  <td>Amet</td>\n                  <td>Consectetur</td>\n                  <td>Afdipisicing</td>\n                </tr>\n              </tbody>\n            </table>\n        </div>\n    </div>\n  </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    function init() {\n        commonUI.initializeTable();\n        commonUI.initializeSplitPanel();\n    }\n    window.onload = init;\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This is a javascript enabled component. You must initialize it using the following snippet:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeSplitPanel();'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Interactive Split Layout'
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Interactive Vertical Split Layout'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The split panel can be activated by clicking on the link with the open panel class. Normal split layout functionality will resume when open. You can then close the split layout if desired by clicking link with closse class.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "600px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n  <head>\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n  </head>\n  <body class="is-styleguide">\n    <div class="split-panel split-panel--vertical js-split-panel js-vertically-divided is-vertical is-closable">\n        <div class="soft-half split-panel--main">\n          <div>\n            <h1>Content Main</h1>\n            <div class="scroll-container-x">\n              <table class="table table--comfy table--hover table--striped table--light">\n                <thead>\n                  <tr>\n                    <th>Lorem</th>\n                    <th>Ipsum</th>\n                    <th>Dolor</th>\n                    <th>Sit</th>\n                    <th>Amet</th>\n                    <th>Consectetur</th>\n                    <th>Afdipisicing</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr>\n                    <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n                    <td>Dolor</td>\n                    <td class="text--center">03.788</td>\n                    <td>Lorem</td>\n                    <td>Amet</td>\n                    <td>Consectetur</td>\n                    <td>Afdipisicing</td>\n                  </tr>\n                  <tr>\n                    <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n                    <td>Dolor</td>\n                    <td class="text--center">32.210</td>\n                    <td>Lorem</td>\n                    <td>Amet</td>\n                    <td>Consectetur</td>\n                    <td>Afdipisicing</td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </div>\n        <div class="split-panel--secondary">\n            <div class="soft-half split-panel--title space-between">\n              <h1>Content Secondary</h1>\n              <button class="btn btn--link close-panel">\n                <i class="fas fa-times"></i> Close\n              </button>\n            </div>\n            <div class="soft-half">\n            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">\n            <thead>\n              <tr>\n                <th>Lorem</th>\n                <th>Ipsum</th>\n                <th>Dolor</th>\n                <th>Sit</th>\n                <th>Amet</th>\n                <th>Consectetur</th>\n                <th>Afdipisicing</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">03.788</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">32.210</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">47.797</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">09.640</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">12.117</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n            </tbody>\n            </table>\n            </div>\n        </div>\n    </div>\n  </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    function init() {\n      commonUI.initializeTable();\n      commonUI.initializeSplitPanel({\n        closePanel: \'.close-panel\',\n        openPanel: \'.open-panel\',\n        vertical: true,\n      });\n    }\n    window.onload = init;\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Click \'View Source\' to show the code for Vertical Interactive Split Layout.'
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="split-panel split-panel--vertical js-split-panel js-vertically-divided is-vertical is-closable">\n  <div class="soft-half split-panel--main">\n    <div>\n      <h1>Content Main</h1>\n      <div class="scroll-container-x">\n        <table class="table table--comfy table--hover table--striped table--light">\n          <thead>\n            <tr>\n              <th>Lorem</th>\n              <th>Ipsum</th>\n              <th>Dolor</th>\n              <th>Sit</th>\n              <th>Amet</th>\n              <th>Consectetur</th>\n              <th>Afdipisicing</th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr>\n              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n              <td>Dolor</td>\n              <td class="text--center">03.788</td>\n              <td>Lorem</td>\n              <td>Amet</td>\n              <td>Consectetur</td>\n              <td>Afdipisicing</td>\n            </tr>\n            <tr>\n              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n              <td>Dolor</td>\n              <td class="text--center">32.210</td>\n              <td>Lorem</td>\n              <td>Amet</td>\n              <td>Consectetur</td>\n              <td>Afdipisicing</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class="split-panel--secondary">\n    <div class="soft-half split-panel--title space-between">\n      <h1>Content Secondary</h1>\n      <button class="btn btn--link close-panel">\n        <i class="fas fa-times"></i> Close\n      </button>\n    </div>\n    <div class="soft-half">\n\n    </div>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This is a javascript enabled component. You must initialize it using the following snippet:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeSplitPanel({\n  closePanel: \'.close-panel\',\n  openPanel: \'.open-panel\',\n  vertical: true,\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Interactive Horizontal Split Layout'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The split panel can be activated by clicking on the link with the open panel class. Normal split layout functionality will resume when open. You can then close the split layout if desired by clicking link with closse class.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: 'auto' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '480' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '768' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '992' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1200' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: { "height": "600px" } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '<html>\n  <head>\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n    <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n    <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n    <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n  </head>\n  <body class="is-styleguide">\n    <div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided is-closable">\n      <div class="soft-half split-panel--main">\n        <div>\n          <h1>Content Main</h1>\n          <div class="scroll-container-x">\n            <table class="table table--comfy table--hover table--striped table--light">\n              <thead>\n                <tr>\n                  <th>Lorem</th>\n                  <th>Ipsum</th>\n                  <th>Dolor</th>\n                  <th>Sit</th>\n                  <th>Amet</th>\n                  <th>Consectetur</th>\n                  <th>Afdipisicing</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n                  <td>Dolor</td>\n                  <td class="text--center">03.788</td>\n                  <td>Lorem</td>\n                  <td>Amet</td>\n                  <td>Consectetur</td>\n                  <td>Afdipisicing</td>\n                </tr>\n                <tr>\n                  <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n                  <td>Dolor</td>\n                  <td class="text--center">32.210</td>\n                  <td>Lorem</td>\n                  <td>Amet</td>\n                  <td>Consectetur</td>\n                  <td>Afdipisicing</td>\n                </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n        <div class="split-panel--secondary">\n          <div class="soft-half split-panel--title space-between">\n            <h1>Content Secondary</h1>\n            <button class="btn btn--link close-panel">\n              <i class="fas fa-times"></i> Close\n            </button>\n          </div>\n            <div class="soft-half">\n            <table class="table table--light table--comfy table--hover table--striped table--responsive js-table--responsive">\n            <thead>\n              <tr>\n                <th>Lorem</th>\n                <th>Ipsum</th>\n                <th>Dolor</th>\n                <th>Sit</th>\n                <th>Amet</th>\n                <th>Consectetur</th>\n                <th>Afdipisicing</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">03.788</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">32.210</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">47.797</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">09.640</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n              <tr>\n                <th scope="row">\n                  <a href="">Sit</a>\n                </th>\n                <td>Dolor</td>\n                <td class="text--center">12.117</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n              </tr>\n            </tbody>\n            </table>\n            </div>\n        </div>\n    </div>\n  </body>\n  <script type="text/javascript" src="js/commonUI.js"></script>\n  <script>\n    function init() {\n        commonUI.initializeTable();\n        commonUI.initializeSplitPanel({\n          closePanel: \'.close-panel\',\n          openPanel: \'.open-panel\',\n          horizontal: true,\n        });\n    }\n    window.onload = init;\n  </script>\n</html>' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Click \'View Source\' to show the code for Interactive Horizontal Split Layout.'
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="split-panel split-panel--horizontal js-split-panel js-horizontally-divided is-closable">\n    <div class="soft-half split-panel--main">\n      <div>\n        <h1>Content Main</h1>\n        <div class="scroll-container-x">\n          <table class="table table--comfy table--hover table--striped table--light">\n            <thead>\n              <tr>\n                <th>Lorem</th>\n                <th>Ipsum</th>\n                <th>Dolor</th>\n                <th>Sit</th>\n                <th>Amet</th>\n                <th>Consectetur</th>\n                <th>Afdipisicing</th>\n              </tr>\n            </thead>\n          <tbody>\n            <tr>\n              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n                <td>Dolor</td>\n                <td class="text--center">03.788</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n            </tr>\n            <tr>\n              <th scope="row" class="table__cell--highlight"><a class="open-panel" href="javascript:void(0)">Sit</a></th>\n                <td>Dolor</td>\n                <td class="text--center">32.210</td>\n                <td>Lorem</td>\n                <td>Amet</td>\n                <td>Consectetur</td>\n                <td>Afdipisicing</td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n    </div>\n  </div>\n  <div class="split-panel--secondary">\n    <div class="soft-half split-panel--title space-between">\n      <h1>Content Secondary</h1>\n      <button class="btn btn--link close-panel">\n        <i class="fas fa-times"></i> Close\n      </button>\n    </div>\n    <div class="soft-half">\n      <p>Secondary Panel Content</p>\n    </div>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This is a javascript enabled component. You must initialize it using the following snippet:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            'commonUI.initializeSplitPanel({\n  closePanel: \'.close-panel\',\n  openPanel: \'.open-panel\',\n  horizontal: true,\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return SplitPanel;
	}(_get__('Component'));
	
	exports.default = _get__('SplitPanel');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'SplitPanel':
	      return SplitPanel;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof SplitPanel === 'undefined' ? 'undefined' : _typeof(SplitPanel);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(SplitPanel, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(SplitPanel)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Panels = function (_get__2) {
	  _inherits(Panels, _get__2);
	
	  function Panels() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Panels);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Panels.__proto__ || Object.getPrototypeOf(Panels)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      animatedPanelClass: 'panel--raised'
	    }, _this.handleChangePanelType = function (e) {
	      var selectedOption = e.target.value;
	      var animatedPanelClass = '';
	
	      switch (selectedOption) {
	        case 'raised':
	          animatedPanelClass = 'panel--raised';
	          break;
	        case 'block':
	          animatedPanelClass = 'panel--block';
	          break;
	        case 'colored':
	          animatedPanelClass = 'panel--blue-3';
	          break;
	        case 'outlined':
	          animatedPanelClass = 'panel--outline panel--outline--grey-4';
	          break;
	        case 'callout':
	          animatedPanelClass = 'panel--callout panel--callout--blue-2';
	          break;
	        default:
	          animatedPanelClass = 'panel--raised';
	          break;
	      }
	
	      _this.setState({
	        animatedPanelClass: animatedPanelClass
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Panels, [{
	    key: 'render',
	    value: function render() {
	      var animatedPanelClass = this.state.animatedPanelClass;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'panels' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Panels'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Wells, Callouts & Panels have now all been combined into a single component, called Panels. ',
	          _get__('React').createElement('br', null),
	          'Panels can be used to callout or highlight sections or content, and can be used to apply structure and layout to a page.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'panels' }),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Block Panel'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--block' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Title'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Panel content'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--block panel--block--border' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Block panel w/ border'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="panel--block">\n      <div class="panel__heading">\n        <h3 class="flush">Title</h3>\n      </div>\n      <div class="panel__body">\n        Panel content\n      </div>\n    </div>\n\n    <div class="panel--block panel--block--border">\n      <div class="panel__heading">\n        <h3 class="flush">Block panel w/ border</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Raised Panel'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--raised' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Block raised'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--raised panel--raised--border' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Block raised w/ border'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="panel--raised">\n      <div class="panel__heading">\n        <h3 class="flush">Block raised</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--raised panel--raised--border">\n      <div class="panel__heading">\n        <h3 class="flush">Block raised w/ border</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Colored Panel'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--blue-2 ' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Regal Blue'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--blue-3' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'blue-3'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--grey-3' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'grey-3'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--grey-4' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Oslo Gray'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="panel--blue-2 ">\n      <div class="panel__heading">\n        <h3 class="flush">Regal Blue</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--blue-3">\n      <div class="panel__heading">\n        <h3 class="flush">blue-3</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--grey-3">\n      <div class="panel__heading">\n        <h3 class="flush">grey-3</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--grey-4">\n      <div class="panel__heading">\n        <h3 class="flush">Oslo Gray</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Outlined Panel'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--outline panel--outline--blue-2' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Regal Blue - Outline Heavy'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--outline panel--outline--blue-3' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'blue-3 - Outline Heavy'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--outline panel--outline--grey-3' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'grey-3 - Outline Heavy'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--outline panel--outline--grey-4' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Oslo gray - Outline Heavy'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="panel--outline panel--outline--blue-2">\n      <div class="panel__heading">\n        <h3 class="flush">Regal Blue - Outline Heavy</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--outline panel--outline--blue-3">\n      <div class="panel__heading">\n        <h3 class="flush">blue-3 - Outline Heavy</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--outline panel--outline--grey-3">\n      <div class="panel__heading">\n        <h3 class="flush">grey-3 - Outline Heavy</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--outline panel--outline--grey-4">\n      <div class="panel__heading">\n        <h3 class="flush">Oslo gray - Outline Heavy</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h4',
	          null,
	          'Callout Panel'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--callout panel--callout--blue-2' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Regal Blue - Callout'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--callout panel--callout--blue-3' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'blue-3 - Callout'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--callout panel--callout--grey-3' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'grey-3 - Callout'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'panel--callout panel--callout--grey-4' },
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__heading' },
	            _get__('React').createElement(
	              'h3',
	              { className: 'flush' },
	              'Oslo Gray - Callout'
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'panel__body' },
	            'Lorem ipsum dolor sit amet'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="panel--callout panel--callout--blue-2">\n      <div class="panel__heading">\n        <h3 class="flush">Regal Blue - Callout</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--callout panel--callout--blue-3">\n      <div class="panel__heading">\n        <h3 class="flush">blue-3 - Callout</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--callout panel--callout--grey-3">\n      <div class="panel__heading">\n        <h3 class="flush">grey-3 - Callout</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>\n\n    <div class="panel--callout panel--callout--grey-4">\n      <div class="panel__heading">\n        <h3 class="flush">Oslo Gray - Callout</h3>\n      </div>\n      <div class="panel__body">\n        Lorem ipsum dolor sit amet\n      </div>\n    </div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Panel Animations'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'soft-half' },
	          _get__('React').createElement(
	            'p',
	            null,
	            _get__('React').createElement(
	              'label',
	              { className: 'display--inline-block push-half--right' },
	              'Select Panel style: '
	            ),
	            _get__('React').createElement(
	              'select',
	              { id: 'panel-animation-select', style: { width: 100 + 'px' }, className: 'display--inline-block', onChange: this.handleChangePanelType },
	              _get__('React').createElement(
	                'option',
	                { value: 'raised', selected: true },
	                'Raised'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'block' },
	                'Block'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'colored' },
	                'Colored'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'outlined' },
	                'Outlined'
	              ),
	              _get__('React').createElement(
	                'option',
	                { value: 'callout' },
	                'Callout'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'grid' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4' },
	            _get__('React').createElement(
	              'div',
	              { className: animatedPanelClass + ' panel--move-up' },
	              _get__('React').createElement(
	                'div',
	                { className: 'panel__heading' },
	                _get__('React').createElement(
	                  'h3',
	                  { className: 'flush' },
	                  'Move Up Animation'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'panel__body' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.'
	                ),
	                _get__('React').createElement('i', { className: 'fas fa-arrow-right fa-2x', style: { color: '#006eb6' } })
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4' },
	            _get__('React').createElement(
	              'div',
	              { className: animatedPanelClass + ' panel--sheen' },
	              _get__('React').createElement(
	                'div',
	                { className: 'panel__heading' },
	                _get__('React').createElement(
	                  'h3',
	                  { className: 'flush' },
	                  'Sheen Animation'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'panel__body' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.'
	                ),
	                _get__('React').createElement('i', { className: 'fas fa-arrow-right fa-2x', style: { color: '#006eb6' } })
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4' },
	            _get__('React').createElement(
	              'div',
	              { className: animatedPanelClass + ' panel--scale' },
	              _get__('React').createElement(
	                'div',
	                { className: 'panel__heading' },
	                _get__('React').createElement(
	                  'h3',
	                  { className: 'flush' },
	                  'Scale Animation'
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'panel__body' },
	                _get__('React').createElement(
	                  'p',
	                  null,
	                  'Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.'
	                ),
	                _get__('React').createElement('i', { className: 'fas fa-arrow-right fa-2x', style: { color: '#006eb6' } })
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="grid">\n\n  <div class="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">\n    <div class="' + animatedPanelClass + ' panel--move-up">\n      <div class="panel__heading">\n        <h3 class="flush">Move Up Animation</h3>\n      </div>\n      <div class="panel__body">\n        <p>\n          Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.\n        </p>\n        <i class="fas fa-arrow-right fa-2x" style={{ color: \'#006eb6\' }}></i>\n      </div>\n    </div>\n  </div>\n\n  <div class="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">\n    <div class="' + animatedPanelClass + ' panel--sheen">\n      <div class="panel__heading">\n        <h3 class="flush">Sheen Animation</h3>\n      </div>\n      <div class="panel__body">\n        <p>\n        Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.\n        </p>\n        <i class="fas fa-arrow-right fa-2x" style={{ color: \'#006eb6\' }}></i>\n      </div>\n    </div>\n  </div>\n\n  <div class="grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-4">\n    <div class="' + animatedPanelClass + ' panel--scale">\n      <div class="panel__heading">\n        <h3 class="flush">Scale Animation</h3>\n      </div>\n      <div class="panel__body">\n        <p>\n        Establish and/or maintain Drop Copy Groups used to send carbon copies of iLink execution reports, heartbeats and acknowledgement, and trade bust messages for one or many source sessions.\n        </p>\n        <i class="fas fa-arrow-right fa-2x" style={{ color: \'#006eb6\' }}></i>\n      </div>\n    </div>\n  </div>\n\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Panels;
	}(_get__('Component'));
	
	exports.default = _get__('Panels');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Panels':
	      return Panels;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Panels === 'undefined' ? 'undefined' : _typeof(Panels);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Panels, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Panels)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loaders = function (_get__2) {
	  _inherits(Loaders, _get__2);
	
	  function Loaders(props) {
	    _classCallCheck(this, Loaders);
	
	    var _this = _possibleConstructorReturn(this, (Loaders.__proto__ || Object.getPrototypeOf(Loaders)).call(this, props));
	
	    _this.state = {
	      theme: 'default'
	    };
	    return _this;
	  }
	
	  _createClass(Loaders, [{
	    key: 'handleClick',
	    value: function handleClick() {
	      var loader = _get__('commonUI').initializeLoader();
	      setTimeout(function () {
	        return loader.destroy();
	      }, 3000);
	    }
	  }, {
	    key: 'handleClickTargeted',
	    value: function handleClickTargeted() {
	      var loader = _get__('commonUI').initializeLoader({ selector: '.js-custom-loader', fullscreen: false });
	      setTimeout(function () {
	        return loader.destroy();
	      }, 3000);
	    }
	  }, {
	    key: 'handleClickTargetedMessage',
	    value: function handleClickTargetedMessage() {
	      var loader = _get__('commonUI').initializeLoader({ selector: '.js-custom-loader', fullscreen: false, message: 'Custom messaging...' });
	      setTimeout(function () {
	        return loader.destroy();
	      }, 3000);
	    }
	  }, {
	    key: 'handleClickTheme',
	    value: function handleClickTheme() {
	      var loader = _get__('commonUI').initializeLoader({ selector: '.js-custom-loader', fullscreen: false, theme: 'light', message: 'Light themed...' });
	      setTimeout(function () {
	        return loader.destroy();
	      }, 3000);
	    }
	  }, {
	    key: 'handleClickProgressWording',
	    value: function handleClickProgressWording() {
	      var loader = _get__('commonUI').initializeLoader({ message: [{ changeAt: 0, text: 'Loading...' }, { changeAt: 2, text: 'Still loading...' }, { changeAt: 4, text: 'Still working on your request...' }] });
	      setTimeout(function () {
	        return loader.destroy();
	      }, 6000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'loaders' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Loaders'
	        ),
	        _get__('React').createElement(
	          'div',
	          { style: { "position": "relative", "minHeight": "6.5em", "zIndex": "1" } },
	          _get__('React').createElement(
	            'div',
	            { className: 'loader-overlay soft', style: { "height": "0%", "position": "relative" } },
	            _get__('React').createElement(
	              'div',
	              { className: 'loader-wrapper', style: { "position": "relative", "width": "5em" } },
	              _get__('React').createElement('div', { className: 'loader', style: { "marginTop": "0" } }),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Loading...'
	              )
	            )
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'div',
	            { className: 'loader-overlay soft', style: { "height": "0%", "position": "relative" } },
	            _get__('React').createElement(
	              'div',
	              { className: 'loader-wrapper', style: { "position": "relative", "width": "5em" } },
	              _get__('React').createElement('div', { className: 'loader loader--small', style: { "marginTop": "0" } }),
	              _get__('React').createElement(
	                'p',
	                null,
	                'Loading...'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Adding ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.loader--small'
	          ),
	          ' to the \'loader\' div will use the smaller size.'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'loaders' }),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Full page loaders can be achieved by adding the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.js-loader'
	          ),
	          ' class to the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'body'
	          ),
	          ' tag.',
	          _get__('React').createElement('br', null),
	          'This loader is fixed to the center of the screen - even if the content is scrollable, the loader will always be in view.'
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'btn', className: 'btn', onClick: this.handleClick },
	          'Click for full screen demo'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<html>\n  <body class="js-loader">\n  </body>\n</html>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeLoader()'
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To cover a specific area, you can pass a selector to define the area.'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'callout callout--secondary' },
	          _get__('React').createElement(
	            'span',
	            null,
	            _get__('React').createElement(
	              'i',
	              { className: 'fa fa-exclamation' },
	              '  '
	            ),
	            ' Make sure the element you are trying to cover is set to ',
	            _get__('React').createElement(
	              'b',
	              null,
	              'position: relative'
	            ),
	            ' to allow the loader to overlay it.',
	            _get__('React').createElement('br', null),
	            'This can be achieved by adding the helper ',
	            _get__('React').createElement(
	              'b',
	              null,
	              '.position--relative'
	            ),
	            ' to the element.'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { style: { "position": "relative" }, className: 'well js-custom-loader' },
	          'Custom area to cover with a loader. ',
	          _get__('React').createElement('br', null),
	          ' This div has the class - js-custom-loader ',
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null)
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'btn', className: 'btn', onClick: this.handleClickTargeted },
	          'Click for targetted demo'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeLoader({selector: \'.js-custom-loader\', fullscreen: false})'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'btn', className: 'btn', onClick: this.handleClickTargetedMessage },
	          'Click for demo with customized message'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeLoader({selector: \'.js-custom-loader\', fullscreen: false, message: \'Custom messaging...\'})'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'btn', className: 'btn', onClick: this.handleClickTheme },
	          'Click for demo with light theme'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeLoader({selector: \'.js-custom-loader\', fullscreen: false, theme: \'light\', message: \'Light themed...\'}'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To close the loader, you must call the destroy method when you have finished loading. The following is a jquery example.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'var loader = commonUI.initializeLoader();\n$.post( "test.php", { name: "John", time: "2pm" })\n.done(function( data ) {\n  loader.destroy();\n  // Do stuff\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'You can defer the loader until required.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'var loader = commonUI.initializeLoader({deferred: true});\n// Loader not shown.\n// Start will show loader\nloader.start();\n// Do stuff\n// Stop will destroy loader\nloader.stop();\n// Could show loader again\n// loader.start();'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'When you know a process is going to take longer than a few seconds, you can add progression wording so that user knows it is still in progress.',
	          _get__('React').createElement('br', null),
	          'You can specify after how many seconds the wording should change and what it should change to using the code below:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'var loader = commonUI.initializeLoader({\n message: [\n   {\n      changeAt: 0,  // Number of seconds to change wording at\n      text: "Loading..." // Initial wording\n   },\n   {\n      changeAt: 5,  // Number of seconds to change wording at\n      text: "Still loading..." // New wording\n   },\n   {\n      changeAt: 10,\n      text: "Still working on your request..."\n    }\n  ]\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'btn', className: 'btn', onClick: this.handleClickProgressWording },
	          'Click for demo of progressive wording'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Loaders;
	}(_get__('Component'));
	
	exports.default = _get__('Loaders');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'Loaders':
	      return Loaders;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Loaders === 'undefined' ? 'undefined' : _typeof(Loaders);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Loaders, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Loaders)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Helpers;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Helpers() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "helpers" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Helpers"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "A series of helper classes to use arbitrarily. A lot of these classes carry '!important' to win out over other selectors. While adding lots of helpers can lead to 'ugly' html where the elements become overloaded with many classes, this is one of the most maintainable and traceable pattern for scalable CSS"
	    ),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Add/remove Floats"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "callout callout--secondary" },
	      _get__("React").createElement(
	        "span",
	        null,
	        _get__("React").createElement("i", { className: "fa fa-exclamation" }),
	        "Floats do",
	        _get__("React").createElement(
	          "b",
	          null,
	          "\xA0not\xA0"
	        ),
	        "work when the flex grid is involved - use the flex classes to achieve the same result."
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "p",
	          { className: "float--none push-half--bottom" },
	          "Float none"
	        ),
	        _get__("React").createElement(
	          "p",
	          { className: "float--right push-half--bottom" },
	          "Float right"
	        ),
	        _get__("React").createElement(
	          "p",
	          { className: "float--left push-half--bottom" },
	          "Float left"
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".float--none\n.float--right\n.float--left"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Text aligment"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "p",
	          { className: "text--left push-half--bottom" },
	          "Text left"
	        ),
	        _get__("React").createElement(
	          "p",
	          { className: "text--center push-half--bottom" },
	          "Text center"
	        ),
	        _get__("React").createElement(
	          "p",
	          { className: "text--right push-half--bottom" },
	          "Text right"
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".text--left\n.text--center\n.text--right"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Font weights"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "p",
	          { className: "weight--light push-half--bottom" },
	          "Weight light"
	        ),
	        _get__("React").createElement(
	          "p",
	          { className: "weight--normal push-half--bottom" },
	          "Weight normal"
	        ),
	        _get__("React").createElement(
	          "p",
	          { className: "weight--semibold push-half--bottom" },
	          "Weight semibold"
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            ".weight--light\n.weight--normal\n.weight--semibold"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Lists"
	    ),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Dotted list"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dotted" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "List item 1"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "List item 2"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "List item 3"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<ul class=\"list-dotted\">\n  <li>List item 1</li>\n  <li>List item 2</li>\n  <li>List item 3</li>\n</ul>"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Decimal list"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "ol",
	          { className: "list-decimal" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "List item 1"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "List item 2"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "List item 3"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-html" },
	            "<ol class=\"list-decimal\">\n  <li>List item 1</li>\n  <li>List item 2</li>\n  <li>List item 3</li>\n</ol>"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Add/Remove margins"
	    ),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Add Full Margins"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "div",
	          { className: "margins-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "margins-demo__item push--left" },
	            "Push Left"
	          )
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "margins-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "margins-demo__item push--sides" },
	            "Push Sides"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".push\n.push--top\n.push--right\n.push--bottom\n.push--left\n.push--ends\n.push--sides\n\nResponsive variants:\n--xs-only, --sm-only, --sm-and-up, --md-only,\n--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,\n--palm, --lap, --lap-and-up,\n--portable, --desk"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Add Half Margins"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "div",
	          { className: "margins-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "margins-demo__item push-half--left" },
	            "Push Half Left"
	          )
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "margins-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "margins-demo__item push-half--sides" },
	            "Push Half Sides"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".push-half\n.push-half--top\n.push-half--right\n.push-half--bottom\n.push-half--left\n.push-half--ends\n.push-half--sides\n\nResponsive variants:\n--xs-only, --sm-only, --sm-and-up, --md-only,\n--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,\n--palm, --lap, --lap-and-up,\n--portable, --desk"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Remove Margins"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "div",
	          { className: "margins-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "margins-demo__item  margins-demo--full-margin flush--left" },
	            "Flush Left"
	          )
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "margins-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "margins-demo__item margins-demo--full-margin flush--sides" },
	            "Flush Sides"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".flush\n.flush--top\n.flush--right\n.flush--bottom\n.flush--left\n.flush--ends\n.flush--sides\n\nResponsive variants:\n--xs-only, --sm-only, --sm-and-up, --md-only,\n--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,\n--palm, --lap, --lap-and-up,\n--portable, --desk"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Add/Remove paddings"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item soft--left" },
	            "Soft Left"
	          )
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item soft--sides" },
	            "Soft Sides"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".soft\n.soft--top\n.soft--right\n.soft--bottom\n.soft--left\n.soft--ends\n.soft--sides\n\nResponsive variants:\n--xs-only, --sm-only, --sm-and-up, --md-only,\n--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,\n--palm, --lap, --lap-and-up,\n--portable, --desk"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item soft-half--left" },
	            "Soft Half Left"
	          )
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item soft-half--sides" },
	            "Soft Half Sides"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".soft-half\n.soft-half--top\n.soft-half--right\n.soft-half--bottom\n.soft-half--left\n.soft-half--ends\n.soft-half--sides\n\nResponsive variants:\n--xs-only, --sm-only, --sm-and-up, --md-only,\n--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,\n--palm, --lap, --lap-and-up,\n--portable, --desk"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item soft-quarter--left" },
	            "Soft Quarter Left"
	          )
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item soft-quarter--sides" },
	            "Soft Quarter Sides"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".soft-quarter\n.soft-quarter--top\n.soft-quarter--right\n.soft-quarter--bottom\n.soft-quarter--left\n.soft-quarter--ends\n.soft-quarter--sides\n\nResponsive variants:\n--xs-only, --sm-only, --sm-and-up, --md-only,\n--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,\n--palm, --lap, --lap-and-up,\n--portable, --desk"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Remove Padding"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--align-center" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item  paddings-demo--full-padding hard--left" },
	            "Hard Left"
	          )
	        ),
	        _get__("React").createElement(
	          "div",
	          { className: "paddings-demo" },
	          _get__("React").createElement(
	            "div",
	            { className: "paddings-demo__item paddings-demo--full-padding hard--sides" },
	            "Hard Sides"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-xs-12 grid__col-sm-6" },
	        _get__("React").createElement(
	          "pre",
	          null,
	          _get__("React").createElement(
	            "code",
	            { className: "language-css" },
	            ".hard\n.hard--top\n.hard--right\n.hard--bottom\n.hard--left\n.hard--ends\n.hard--sides\n\nResponsive variants:\n--xs-only, --sm-only, --sm-and-up, --md-only,\n--md-and-up, --lg-only, --lg-and-up, --xlg-and-up,\n--palm, --lap, --lap-and-up,\n--portable, --desk"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Display Helpers"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        ".display--block\n.display--inline-block\n.display--flex\n.display--table\n.display--table-cell"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Position Helpers"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        ".position--static\n.position--relative\n.position--fixed\n.position--absolute"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Clearfix"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        ".clearfix\n.clear--left\n.clear--right\n.clear--both"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Center"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "IE behaves differently when centering content displayed with inline-block. This helper normalises the differences."
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        ".center"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Show / Hide"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      ".hide will make content 'inaccessible' to screenreaders, .visuallyhidden will allow the element to be hidden but accessible."
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        ".hide\n.visuallyhidden"
	      )
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        "// Visually hidden variants\n\n.visuallyhidden--xs-only\n.visuallyhidden--sm-only\n.visuallyhidden--sm-and-up\n.visuallyhidden--md-only\n.visuallyhidden--md-and-up\n.visuallyhidden--lg-only\n.visuallyhidden--lg-and-up\n.visuallyhidden--xlg-and-up\n\n.visuallyhidden--palm\n.visuallyhidden--lap\n.visuallyhidden--lap-and-up\n.visuallyhidden--portable\n.visuallyhidden--desk\n\n.visuallyhidden--retina"
	      )
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        "// hide variants\n\n.hide--xs-only\n.hide--sm-only\n.hide--sm-and-up\n.hide--md-only\n.hide--md-and-up\n.hide--lg-only\n.hide--lg-and-up\n.hide--xlg-and-up\n\n.hide--palm\n.hide--lap\n.hide--lap-and-up\n.hide--portable\n.hide--desk\n\n.hide--retina"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Max width"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        ".max-width--10 // percent\n.max-width--20\n.max-width--30\n.max-width--40\n.max-width--50\n.max-width--60\n.max-width--70\n.max-width--80\n.max-width--90\n.max-width--100\n\n.max-width-xs // matches grid breakpoints\n.max-width-sm\n.max-width-md\n.max-width-lg\n.max-width-xl"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Text fix"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "If you find your text is jumbled and too close together, it is a side effect of the grid system. ",
	      _get__("React").createElement(
	        "b",
	        null,
	        "It is likely you have content inside a grid, but not inside a column."
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "callout callout--secondary" },
	      _get__("React").createElement(
	        "span",
	        null,
	        _get__("React").createElement("i", { className: "fa fa-exclamation" }),
	        "There is limited use cases for this class, its almost certainly an indicator you should check you have a valid grid layout."
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-css" },
	        ".fix-text"
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Helpers === "undefined" ? "undefined" : _typeof(Helpers);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Helpers, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Helpers)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataTables = function (_get__2) {
	  _inherits(DataTables, _get__2);
	
	  function DataTables(props) {
	    _classCallCheck(this, DataTables);
	
	    return _possibleConstructorReturn(this, (DataTables.__proto__ || Object.getPrototypeOf(DataTables)).call(this, props));
	  }
	
	  _createClass(DataTables, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'environmentbanners' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Environment Banners'
	        ),
	        this.props.staticVersion === false ? _get__('React').createElement(_get__('Included'), { onClick: function onClick() {
	            return _this2.props.onIncludeClick();
	          }, included: this.props.included }) : '',
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Include beneath your navigation for high visibility of current environment'
	        ),
	        _get__('React').createElement('div', { className: 'env-banner env-banner--dev' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('div', { className: 'env-banner env-banner--qa' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('div', { className: 'env-banner env-banner--nr' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('div', { className: 'env-banner env-banner--nr-test' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('div', { className: 'env-banner env-banner--pp' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('div', { className: 'env-banner env-banner--cert' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="env-banner env-banner--dev"></div>\n<div class="env-banner env-banner--qa"></div>\n<div class="env-banner env-banner--nr"></div>\n<div class="env-banner env-banner--nr-test"></div>\n<div class="env-banner env-banner--pp"></div>\n<div class="env-banner env-banner--cert"></div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return DataTables;
	}(_get__('Component'));
	
	exports.default = _get__('DataTables');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'DataTables':
	      return DataTables;
	
	    case 'React':
	      return _react2.default;
	
	    case 'Included':
	      return _Included2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof DataTables === 'undefined' ? 'undefined' : _typeof(DataTables);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(DataTables, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(DataTables)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BackToTop = function (_get__2) {
	  _inherits(BackToTop, _get__2);
	
	  function BackToTop(props) {
	    _classCallCheck(this, BackToTop);
	
	    return _possibleConstructorReturn(this, (BackToTop.__proto__ || Object.getPrototypeOf(BackToTop)).call(this, props));
	  }
	
	  _createClass(BackToTop, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'backToTop' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Back To Top'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'An example of the "Back to Top" control can be seen in the bottom right-hand corner of this screen.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Adding a "Back to Top" control can be achieved by adding the following JavaScript to your page:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// JavaScript\ncommonUI.initializeBackToTop();'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Custom Margins'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'By default, the back to top control is placed 12 pixels from the bottom right-hand corner of the page, and will remain in this fixed position. In some circumstances, for example to allow for a bottom navigation bar, you can override the bottom and right offsets at initialization.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '// This will set the bottom margin to 50 pixels\ncommonUI.initializeBackToTop({ marginBottom: 50 });\n\n// This will set the right margin to 30 pixels\ncommonUI.initializeBackToTop({ marginRight: 30 });\n\n// This will set the bottom margin to 50 pixels and the right margin to 30 pixels\ncommonUI.initializeBackToTop({\n  marginBottom: 50,\n  marginRight: 30\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null),
	        _get__('React').createElement('br', null)
	      );
	    }
	  }]);
	
	  return BackToTop;
	}(_get__('Component'));
	
	exports.default = _get__('BackToTop');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'BackToTop':
	      return BackToTop;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof BackToTop === 'undefined' ? 'undefined' : _typeof(BackToTop);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(BackToTop, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(BackToTop)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Drawers = function (_get__2) {
	  _inherits(Drawers, _get__2);
	
	  function Drawers(props) {
	    _classCallCheck(this, Drawers);
	
	    return _possibleConstructorReturn(this, (Drawers.__proto__ || Object.getPrototypeOf(Drawers)).call(this, props));
	  }
	
	  _createClass(Drawers, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'drawers' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Drawers'
	        ),
	        _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'drawers' }),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The drawer is similar to the modal component but it slides in from the left or right of the screen.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The drawer spans the height of the screen. The width can be configured for non-mobile devices and will fill 100% width of mobile devices.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'A drawer by default will open and close from the ',
	          _get__('React').createElement(
	            'strong',
	            null,
	            'right'
	          ),
	          ' of the screen, this can be changed to the ',
	          _get__('React').createElement(
	            'strong',
	            null,
	            'left'
	          ),
	          ' of the screen by adding the class',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.drawer__panel--left'
	          ),
	          ' to the panel element as documented below and shown in the examples code.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'There are two built in size variations applied through classes (documented below).'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--comfy table--striped' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Class'
	              ),
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '.drawer__panel--sm'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Applies a width of 25% of the screen width to the drawer when open'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '.drawer__panel--lg'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Applies a width of 50% of the screen width to the drawer when open'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '.drawer__panel--xl'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Applies a width of 70% of the screen width to the drawer when open'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '.drawer__panel--left'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Causes the drawer to open from the left of the screen'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'aside',
	          { className: 'example-drawer drawer', 'aria-hidden': 'true' },
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__panel' },
	            _get__('React').createElement(
	              'button',
	              { className: 'drawer__close btn btn--transparent js-drawer-close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
	            ),
	            _get__('React').createElement(
	              'header',
	              { className: 'drawer__header ' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'flush' },
	                'Default drawer'
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'drawer__body' },
	              'Drawer contents here'
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'drawer__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn btn--secondary js-drawer-close' },
	                'Cancel'
	              ),
	              '\xA0',
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn js-drawer-positive' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'aside',
	          { className: 'example-drawer-left-small drawer' },
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__panel drawer__panel--left drawer__panel--sm' },
	            _get__('React').createElement(
	              'button',
	              { className: 'drawer__close btn btn--transparent js-drawer-close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
	            ),
	            _get__('React').createElement(
	              'header',
	              { className: 'drawer__header' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'flush' },
	                'Left drawer, small'
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'drawer__body', role: 'dialog' },
	              'Drawer contents here'
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'drawer__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn btn--secondary js-drawer-close' },
	                'Cancel'
	              ),
	              '\xA0',
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn js-drawer-positive' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'aside',
	          { className: 'example-drawer-large drawer' },
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__panel drawer__panel--lg' },
	            _get__('React').createElement(
	              'button',
	              { className: 'drawer__close btn btn--transparent js-drawer-close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
	            ),
	            _get__('React').createElement(
	              'header',
	              { className: 'drawer__header' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'flush' },
	                'Large drawer'
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'drawer__body', role: 'dialog' },
	              'Drawer contents here'
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'drawer__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn btn--secondary js-drawer-close' },
	                'Cancel'
	              ),
	              '\xA0',
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn js-drawer-positive' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'aside',
	          { className: 'example-drawer-xlarge drawer' },
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__panel drawer__panel--xl' },
	            _get__('React').createElement(
	              'button',
	              { className: 'drawer__close btn btn--transparent js-drawer-close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
	            ),
	            _get__('React').createElement(
	              'header',
	              { className: 'drawer__header' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'flush' },
	                'Extra Large drawer'
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'drawer__body', role: 'dialog' },
	              'Drawer contents here'
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'drawer__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn btn--secondary js-drawer-close' },
	                'Cancel'
	              ),
	              '\xA0',
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn js-drawer-positive' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'display-inline-block' },
	          _get__('React').createElement(
	            'button',
	            { className: 'btn drawer-example-button push-quarter--ends' },
	            'Drawer default example'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn drawer-left-small-example-button push-quarter--ends' },
	            'Drawer left small example'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn drawer-large-example-button push-quarter--ends' },
	            'Drawer large example'
	          ),
	          '\xA0',
	          _get__('React').createElement(
	            'button',
	            { className: 'btn drawer-xlarge-example-button push-quarter--ends' },
	            'Drawer extra large example'
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '\n<aside class="example-drawer drawer">\n  <div class="drawer__panel">\n    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">\n      <i class="icon-cme-card-close icon--medium"></i>\n    </button>\n    <header class="drawer__header">\n      <h1 class="flush">Default drawer</h1>\n    </header>\n    <div class="drawer__body" role="dialog">\n      Drawer contents here\n    </div>\n    <footer class="drawer__footer">\n      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;\n      <button type="button" class="btn js-drawer-positive">OK</button>\n    </footer>\n  </div>\n</aside>\n\n<aside class="example-drawer-left-small drawer">\n  <div class="drawer__panel drawer__panel--left drawer__panel--sm">\n    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">\n      <i class="icon-cme-card-close icon--medium"></i>\n    </button>\n    <header class="drawer__header">\n      <h1 class="flush">Left drawer, small</h1>\n    </header>\n    <div class="drawer__body">\n      Drawer contents here\n    </div>\n    <footer class="drawer__footer">\n      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;\n      <button type="button" class="btn js-drawer-positive">OK</button>\n    </footer>\n  </div>\n</aside>\n\n<aside class="example-drawer-large drawer">\n  <div class="drawer__panel drawer__panel--lg">\n    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">\n      <i class="icon-cme-card-close icon--medium"></i>\n    </button>\n    <header class="drawer__header">\n      <h1 class="flush">Large drawer</h1>\n    </header>\n    <div class="drawer__body" role="dialog">\n      Drawer contents here\n    </div>\n    <footer class="drawer__footer">\n      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;\n      <button type="button" class="btn js-drawer-positive">OK</button>\n    </footer>\n  </div>\n</aside>\n\n<aside class="example-drawer-xlarge drawer">\n  <div class="drawer__panel drawer__panel--xl">\n    <button class="drawer__close btn btn--transparent js-drawer-close" aria-label="close">\n      <i class="icon-cme-card-close icon--medium"></i>\n    </button>\n    <header class="drawer__header">\n      <h1 class="flush">Extra Large drawer</h1>\n    </header>\n    <div class="drawer__body">\n      Drawer contents here\n    </div>\n    <footer class="drawer__footer">\n      <button type="button" class="btn btn--secondary js-drawer-close">Cancel</button>&nbsp;\n      <button type="button" class="btn js-drawer-positive">OK</button>\n    </footer>\n  </div>\n</aside>\n\n<button class="btn drawer-example-button">Drawer example</button>\n<button class="btn drawer-left-small-example-button">Drawer left small example</button>\n<button class="btn drawer-large-example-button">Drawer large example</button>\n<button class="btn drawer-xlarge-example-button">Drawer extra large example</button>\n'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'language-javascript' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '\ncommonUI.initializeDrawer(\n  \'.example-drawer\',\n  {\n    trigger: \'.drawer-example-button\'\n  }\n);\n\ncommonUI.initializeDrawer(\n  \'.example-drawer-left-small\',\n  {\n    trigger: \'.drawer-left-small-example-button\'\n  }\n);\n\ncommonUI.initializeDrawer(\n  \'.example-drawer-large\',\n  {\n    trigger: \'.drawer-large-example-button\'\n  }\n);\n\ncommonUI.initializeDrawer(\n  \'.example-drawer-xlarge\',\n  {\n    trigger: \'.drawer-xlarge-example-button\'\n  }\n);\n'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Programatic control'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The drawer exposes open and close methods.'
	        ),
	        _get__('React').createElement(
	          'code',
	          { className: 'inline' },
	          'var drawer = commonUI.initializeDrawer(\'.example-drawer\');'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--striped table--comfy' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Method'
	              ),
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'drawer.open()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Opens the drawer'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'drawer.close()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Closes the drawer, does not fire positive/negative events'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'drawer.positive()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Closes the drawer, fires positive event'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'drawer.negative()'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Closes the drawer, fires negative event'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Events'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The drawer exposes a few events for hooking into drawer functionality.'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--striped table--comfy' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Event'
	              ),
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'show.commonui.drawer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event fires immediately when the open instance method is called.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'hide.commonui.drawer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event is fired immediately when the close instance method has been called.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'negative.commonui.drawer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event is fired when the user clicks a .js-drawer-close element'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                'positive.commonui.drawer'
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'This event is fired when the user clicks a .js-drawer-positive element'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'aside',
	          { className: 'example-drawer-events drawer' },
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__panel drawer__panel--small' },
	            _get__('React').createElement(
	              'button',
	              { className: 'drawer__close btn btn--transparent js-drawer-close', 'aria-label': 'close' },
	              _get__('React').createElement('i', { className: 'icon-cme-card-close icon--medium' })
	            ),
	            _get__('React').createElement(
	              'header',
	              { className: 'drawer__header' },
	              _get__('React').createElement(
	                'h1',
	                { className: 'flush' },
	                'Events Drawer'
	              )
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'drawer__body', role: 'dialog' },
	              'Drawer contents here'
	            ),
	            _get__('React').createElement(
	              'footer',
	              { className: 'drawer__footer' },
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn btn--secondary js-drawer-close' },
	                'Cancel'
	              ),
	              '\xA0',
	              _get__('React').createElement(
	                'button',
	                { type: 'button', className: 'btn js-drawer-positive' },
	                'OK'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn drawer-events-example-button' },
	          'Events example'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            '\ncommonUI.initializeDrawer(\n  \'.example-drawer-events\',\n  {\n    trigger: \'.drawer-events-example-button\'\n  }\n);\n\nvar eventsDrawerExample = document.getElementsByClassName(\'example-drawer-events\')[0];\n\neventsDrawerExample.addEventListener(\'show.commonui.drawer\', function(){\n    console.log(\'drawer show\')\n});\neventsDrawerExample.addEventListener(\'hide.commonui.drawer\', function(){\n    console.log(\'drawer hide\')\n});\neventsDrawerExample.addEventListener(\'positive.commonui.drawer\', function(){\n    console.log(\'drawer positive\')\n});\neventsDrawerExample.addEventListener(\'negative.commonui.drawer\', function(){\n    console.log(\'drawer negative\')\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Tabbed Drawer'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Tabbed drawers behave similiarly to the standard drawer component except they show a tab with an action attached to trigger the content reveal.'
	        ),
	        _get__('React').createElement(
	          'table',
	          { className: 'table table--comfy table--striped' },
	          _get__('React').createElement(
	            'thead',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Class'
	              ),
	              _get__('React').createElement(
	                'th',
	                { className: 'text--left' },
	                'Description'
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'tbody',
	            null,
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '.drawer__tabbed'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Applies tabbed styles and functionality to drawer component. This should be applied to the ',
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  'aside'
	                ),
	                ' tag.'
	              )
	            ),
	            _get__('React').createElement(
	              'tr',
	              null,
	              _get__('React').createElement(
	                'td',
	                null,
	                _get__('React').createElement(
	                  'code',
	                  null,
	                  '.drawer__tabbed--bottom'
	                )
	              ),
	              _get__('React').createElement(
	                'td',
	                null,
	                'Aligns the tab to the bottom of the screen/container.'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Creating a tabbed drawer is similiar to the initiaisation of the default drawer component except you pass an attribute of ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'tabbed: true'
	          ),
	          '. The trigger in this case is the revealed part of the drawer; the blue chevron button.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            'commonUI.initializeDrawer(\'.example-drawer-tabbed\', {\n    tabbed: true,\n    trigger: \'.js-drawer-bottom-toggle\'\n});'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'aside',
	          { id: 'tabbedDrawer', className: 'example-drawer-tabbed drawer drawer__tabbed drawer__tabbed--bottom hide', 'aria-hidden': 'true' },
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__toggle js-drawer-bottom-toggle', 'aria-label': 'toggle' },
	            _get__('React').createElement(
	              'button',
	              { className: 'btn btn--primary drawer__toggle__action' },
	              _get__('React').createElement('i', { className: 'fa fa-chevron-up' })
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__panel' },
	            _get__('React').createElement(
	              'p',
	              { className: 'drawer__panel--heading' },
	              'Activity Log'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'drawer__body' },
	              _get__('React').createElement(
	                'ul',
	                { className: 'drawer__body__list' },
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 1'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 2'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 3'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 4'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 5'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 6'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 7'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 8'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 9'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 10'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'aside',
	          { id: 'tabbedDrawerAlt', className: 'example-drawer-tabbed-alt drawer drawer__tabbed drawer__tabbed--bottom hide', 'aria-hidden': 'true' },
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__toggle js-alt-drawer-bottom-toggle', 'aria-label': 'toggle' },
	            _get__('React').createElement(
	              'button',
	              { className: 'btn btn--primary drawer__toggle__action drawer__toggle__action--alt' },
	              _get__('React').createElement('i', { className: 'fa fa-chevron-up' })
	            )
	          ),
	          _get__('React').createElement(
	            'div',
	            { className: 'drawer__panel' },
	            _get__('React').createElement(
	              'p',
	              { className: 'drawer__panel--heading' },
	              'Activity Log'
	            ),
	            _get__('React').createElement(
	              'div',
	              { className: 'drawer__body' },
	              _get__('React').createElement(
	                'ul',
	                { className: 'drawer__body__list' },
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 1'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 2'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 3'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 4'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 5'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 6'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 7'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 8'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 9'
	                ),
	                _get__('React').createElement(
	                  'li',
	                  { className: 'soft-quarter' },
	                  'Item 10'
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'h3',
	          null,
	          'Bottom Drawer Container Example'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'When open, the bottom drawer will fill 30% of its containing element.'
	        ),
	        _get__('React').createElement(
	          'select',
	          { className: 'size-select' },
	          _get__('React').createElement(
	            'option',
	            { value: '1199' },
	            'Select a resolution'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '479' },
	            '480px (xs)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '767' },
	            '768px (sm)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '991' },
	            '992px (md)'
	          ),
	          _get__('React').createElement(
	            'option',
	            { value: '1199' },
	            '1200px (lg)'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container', style: {
	              "height": "600px"
	            } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n            <html class="height--100" style="background-color: #dedfe0">\n              <head>\n                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n                <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              </head>\n                <body class="height--100">\n                  <aside id="tabbedDrawer" class="example-drawer-tabbed drawer drawer__tabbed drawer__tabbed--bottom" aria-hidden="true">\n                    <div class="drawer__toggle js-drawer-bottom-toggle" aria-label="toggle">\n                      <button class="btn btn--primary drawer__toggle__action">\n                        <i class="fa fa-chevron-up"></i>\n                      </button>\n                    </div>\n                    <div class="drawer__panel">\n                      <p class="drawer__panel--heading">Activity Log</p>\n                      <div class="drawer__body">\n                        <ul class="drawer__body__list">\n                          <li class="soft-quarter">Item 1</li>\n                          <li class="soft-quarter">Item 2</li>\n                          <li class="soft-quarter">Item 3</li>\n                          <li class="soft-quarter">Item 4</li>\n                          <li class="soft-quarter">Item 5</li>\n                          <li class="soft-quarter">Item 6</li>\n                          <li class="soft-quarter">Item 7</li>\n                          <li class="soft-quarter">Item 8</li>\n                          <li class="soft-quarter">Item 9</li>\n                          <li class="soft-quarter">Item 10</li>\n                        </ul>\n                      </div>\n                    </div>\n                  </aside>\n                  <script type="text/javascript" src="js/commonUI.js"></script>\n                  <script>\n                    function init() {\n                      commonUI.initializeDrawer(\'.example-drawer-tabbed\', {\n                        tabbed: true,\n                        trigger: \'.js-drawer-bottom-toggle\'\n                      });\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push-quarter--ends', onClick: function onClick() {
	              var tabbedDrawer = document.getElementById('tabbedDrawer'),
	                  tabbedDrawerAlt = document.getElementById('tabbedDrawerAlt');
	              tabbedDrawerAlt.classList.add('hide');
	              tabbedDrawer.classList.toggle('hide');
	            } },
	          'Toggle Tabbed Drawer'
	        ),
	        '\xA0',
	        _get__('React').createElement(
	          'button',
	          { className: 'btn push-quarter--ends', onClick: function onClick() {
	              var tabbedDrawer = document.getElementById('tabbedDrawer'),
	                  tabbedDrawerAlt = document.getElementById('tabbedDrawerAlt');
	              tabbedDrawer.classList.add('hide');
	              tabbedDrawerAlt.classList.toggle('hide');
	            } },
	          'Toggle Tabbed Drawer Alternative Button'
	        ),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<aside id="tabbedDrawer" class="example-drawer-tabbed drawer drawer__tabbed drawer__tabbed--bottom" aria-hidden="true">\n  <div class="drawer__toggle js-drawer-bottom-toggle" aria-label="toggle">\n    <button class="btn btn--primary drawer__toggle__action">\n      <i class="fa fa-chevron-up"></i>\n    </button>\n  </div>\n  <div class="drawer__panel">\n    <p class="drawer__panel--heading">Activity Log</p>\n    <div class="drawer__body">\n      <ul class="drawer__body__list">\n        <li class="soft-quarter">Item 1</li>\n        <li class="soft-quarter">Item 2</li>\n        <li class="soft-quarter">Item 3</li>\n        <li class="soft-quarter">Item 4</li>\n        <li class="soft-quarter">Item 5</li>\n        <li class="soft-quarter">Item 6</li>\n        <li class="soft-quarter">Item 7</li>\n        <li class="soft-quarter">Item 8</li>\n        <li class="soft-quarter">Item 9</li>\n        <li class="soft-quarter">Item 10</li>\n      </ul>\n    </div>\n  </div>\n</aside>\n\n<aside id="tabbedDrawerAlt" class="example-drawer-tabbed-alt drawer drawer__tabbed drawer__tabbed--bottom" aria-hidden="true">\n  <div class="drawer__toggle js-alt-drawer-bottom-toggle" aria-label="toggle">\n    <button class="btn btn--primary drawer__toggle__action drawer__toggle__action--alt">\n      <i class="fa fa-chevron-up"></i>\n    </button>\n  </div>\n  <div class="drawer__panel">\n    <p class="drawer__panel--heading">Activity Log</p>\n    <div class="drawer__body">\n      <ul class="drawer__body__list">\n        <li class="soft-quarter">Item 1</li>\n        <li class="soft-quarter">Item 2</li>\n        <li class="soft-quarter">Item 3</li>\n        <li class="soft-quarter">Item 4</li>\n        <li class="soft-quarter">Item 5</li>\n        <li class="soft-quarter">Item 6</li>\n        <li class="soft-quarter">Item 7</li>\n        <li class="soft-quarter">Item 8</li>\n        <li class="soft-quarter">Item 9</li>\n        <li class="soft-quarter">Item 10</li>\n      </ul>\n    </div>\n  </div>\n</aside>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Drawers;
	}(_get__('Component'));
	
	exports.default = _get__('Drawers');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Drawers':
	      return Drawers;
	
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Drawers === 'undefined' ? 'undefined' : _typeof(Drawers);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Drawers, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Drawers)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Tick = function (_get__2) {
	  _inherits(Tick, _get__2);
	
	  function Tick(props) {
	    _classCallCheck(this, Tick);
	
	    return _possibleConstructorReturn(this, (Tick.__proto__ || Object.getPrototypeOf(Tick)).call(this, props));
	  }
	
	  _createClass(Tick, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'pricetick' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Price Tick'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The price and quantity elements each will span the full width of whatever wrapper they are placed in. In these examples, they are placed within a grid of 2 columns but fill width from mobile - this is using grid classes from Common UI. The up/down buttons will not grow in width but the currency and input value will.'
	        ),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Active State'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  '$'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34' }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-quantity' },
	                'Quantity'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement('input', { id: 'tick-quantity', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '6' }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  'USD'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34' }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  '$/lb'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34' }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34' }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Dynamic Currency Width'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'There may be occasions where the currency section of the component needs to increase in width, again the input field will reduce in size to accomodate.'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  '$/Barrel'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34', readOnly: true }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Compact Width'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Here we have a more compact wrapper width and you can see the input field reducing in width to accomodate.'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-9 grid__col-sm-2 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  '$'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34', readOnly: true }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="form-fields grid">\n  <li class="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">\n    <div class="tick js-price-tick">\n      <label for="tick-price">Price</label>\n      <div class="tick__group">\n        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>\n        <span class="tick__group--currency soft-quarter--sides">$</span>\n        <input id="tick-price" type="text" class="text-input text-input--large tick__group--value" value="95.34"/>\n        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>\n      </div>\n    </div>\n  </li>\n  <li class="grid__col-12 grid__col-sm-2 hard--right--sm-and-up">\n    <div class="tick js-price-tick">\n      <label for="tick-quantity">Quantity</label>\n      <div class="tick__group">\n        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>\n        <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6"/>\n        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>\n      </div>\n    </div>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Read Only State'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To enable the read only state on the main field simply add the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'readonly'
	          ),
	          ' attribute to you input element. The will prevent the user from manually entering values into the fields.'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  '$'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34', readOnly: true }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-quantity' },
	                'Quantity'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement('input', { id: 'tick-quantity', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '6', readOnly: true }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="form-fields grid">\n  <li class="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">\n    <div class="tick js-price-tick">\n      <label for="tick-price">Price</label>\n      <div class="tick__group">\n        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>\n        <span class="tick__group--currency soft-quarter--sides">$</span>\n        <input id="tick-price" type="text" class="text-input text-input--large tick__group--value" value="95.34" readonly/>\n        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>\n      </div>\n    </div>\n  </li>\n  <li class="grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up">\n    <div class="tick js-price-tick">\n      <label for="tick-quantity">Quantity</label>\n      <div class="tick__group">\n        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>\n        <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6" readonly/>\n        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>\n      </div>\n    </div>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Disabled State'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To disable the component add the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'is-disabled'
	          ),
	          ' class to your ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'tick__group'
	          ),
	          ' element. This will visually change the component to a greyed-out appearance and prevent user interaction with the buttons and field.'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group is-disabled' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down', disabled: true },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  '$'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '95.34', disabled: true }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up', disabled: true },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          ),
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-quantity' },
	                'Quantity'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group is-disabled' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down', disabled: true },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement('input', { id: 'tick-quantity', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '6', disabled: true }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up', disabled: true },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<ul class="form-fields grid">\n  <li class="grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up">\n    <div class="tick js-price-tick">\n      <label for="tick-price">Price</label>\n      <div class="tick__group is-disabled">\n        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i class="fa fa-minus"></i></button>\n        <span class="tick__group--currency soft-quarter--sides">$</span>\n        <input id="tick-price" type="text" class="text-input text-input--large tick__group--value" value="95.34" disabled/>\n        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i class="fa fa-plus"></i></button>\n      </div>\n    </div>\n  </li>\n  <li class="grid__col-12 grid__col-sm-2 grid__col-md-3 grid__col-lg-2 hard--right--sm-and-up">\n    <div class="tick js-price-tick">\n      <label for="tick-quantity">Quantity</label>\n      <div class="tick__group is-disabled">\n        <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i class="fa fa-minus"></i></button>\n        <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6" disabled/>\n        <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i class="fa fa-plus"></i></button>\n      </div>\n    </div>\n  </li>\n</ul>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Disabled Quantity Standalone State'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To further remove the up/down buttons from the component you can add the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'is-standalone'
	          ),
	          ' class to the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'tick__group'
	          ),
	          ' element.'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-6 grid__col-sm-1 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-quantity' },
	                'Quantity'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group is-disabled is-standalone' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down', disabled: true },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement('input', { id: 'tick-quantity', type: 'text', className: 'text-input text-input--large tick__group--value', defaultValue: '6', disabled: true }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up', disabled: true },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="tick js-price-tick">\n  <label for="tick-quantity">Quantity</label>\n  <div class="tick__group is-disabled is-standalone">\n    <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down" disabled><i class="fa fa-minus"></i></button>\n    <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value" value="6" disabled/>\n    <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up" disabled><i class="fa fa-plus"></i></button>\n  </div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Error State'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Like forms, the error state for the Price Tick component can be invoked by adding an ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'has-error'
	          ),
	          ' class to the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'tick__group'
	          ),
	          '.'
	        ),
	        _get__('React').createElement(
	          'ul',
	          { className: 'form-fields grid' },
	          _get__('React').createElement(
	            'li',
	            { className: 'grid__col-12 grid__col-sm-5 grid__col-md-4 grid__col-lg-3 hard--left--sm-and-up' },
	            _get__('React').createElement(
	              'div',
	              { className: 'tick js-price-tick' },
	              _get__('React').createElement(
	                'label',
	                { htmlFor: 'tick-price' },
	                'Price'
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'tick__group has-error' },
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down' },
	                  _get__('React').createElement('i', { className: 'fa fa-minus' })
	                ),
	                _get__('React').createElement(
	                  'span',
	                  { className: 'tick__group--currency soft-quarter--sides' },
	                  '$'
	                ),
	                _get__('React').createElement('input', { id: 'tick-price', type: 'text', className: 'text-input text-input--large tick__group--value has-error', defaultValue: '95.34' }),
	                _get__('React').createElement(
	                  'button',
	                  { className: 'btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up' },
	                  _get__('React').createElement('i', { className: 'fa fa-plus' })
	                )
	              ),
	              _get__('React').createElement(
	                'div',
	                { className: 'error error--small' },
	                'This is an example of an error message'
	              )
	            )
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'button',
	          { type: 'button', className: 'btn btn--secondary show-code' },
	          _get__('React').createElement('i', { className: 'fa fa-plus' }),
	          'View source'
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'pre',
	          { className: 'hide-code' },
	          _get__('React').createElement(
	            'code',
	            { className: 'language-html' },
	            '<div class="tick js-price-tick">\n  <label for="tick-price">Price</label>\n  <div class="tick__group has-error">\n    <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>\n    <span class="tick__group--currency soft-quarter--sides">$</span>\n    <input id="tick-price" type="text" class="text-input text-input--large tick__group--value has-error" value="95.34"/>\n    <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>\n  </div>\n  <div className="error error-small">This is an example of an error message</div>\n</div>'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Events'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'To initiate an instance of the PriceTick component, use the following snippet:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '\nvar priceTickComponent = commonUI.initializePriceTick();\n        '
	          )
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The up/down buttons have the ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '\'up.commonui.pricetick\''
	          ),
	          ' & ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '\'down.commonui.pricetick\''
	          ),
	          ' events attached to them so you can invoke a function when they are called like so:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-javascript' },
	            '\n// PRICE\n\nvar priceTickComponent = commonUI.initializePriceTick({\n  selector: \'.js-price-tick\'\n});\n\nvar priceTickElement = document.querySelector(\'.js-price-tick\');\n\npriceTickElement.addEventListener(\'up.commonui.pricetick\', function () {\n  var currentValue = parseFloat(priceTickComponent.componentInputElement.value)\n  priceTickComponent.componentInputElement.value = (currentValue + 1)\n}, false);\n\npriceTickElement.addEventListener(\'down.commonui.pricetick\', function () {\n  var currentValue = parseFloat(priceTickComponent.componentInputElement.value)\n  priceTickComponent.componentInputElement.value = (currentValue - 1)\n}, false);\n\n// QTY\n\nvar quantityTickComponent = commonUI.initializePriceTick({\n  selector: \'.js-price-tick-quantity\'\n});\n\nvar quantityTickElement = document.querySelector(\'.js-price-tick-quantity\');\n\nquantityTickElement.addEventListener(\'up.commonui.pricetick\', function () {\n  var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)\n  quantityTickComponent.componentInputElement.value = (currentValue + 1)\n}, false);\n\nquantityTickElement.addEventListener(\'down.commonui.pricetick\', function () {\n  var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)\n  quantityTickComponent.componentInputElement.value = (currentValue - 1)\n}, false);\n        '
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'The below example simply increments/decrements the current value of the inputs. The property of ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'componentInputElement'
	          ),
	          ' will be the input element supplied, this class defaults to ',
	          _get__('React').createElement(
	            'code',
	            null,
	            '.js-price-tick__value'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h5',
	          null,
	          'Example'
	        ),
	        _get__('React').createElement(
	          'div',
	          { className: 'iframe-container display--flex', style: {
	              "height": "200px",
	              "width": "100%",
	              "margin": "0"
	            } },
	          _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n            <html style="background-color: #efefef">\n              <head>\n                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> \n                <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              </head>\n                <body>\n                  <div class="grid">\n                    <div class="grid__col-sm-12 main">\n                      <section style="max-width: 400px; margin: 0 auto; width: 100%;">\n                        <ul class="form-fields">\n                          <li class="push--bottom">\n                            <div class="tick js-price-tick">\n                              <label for="tick-price">Price</label>\n                              <div class="tick__group">\n                                <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>\n                                <span class="tick__group--currency soft-quarter--sides">$</span>\n                                <input id="tick-price" type="text" class="text-input text-input--large tick__group--value js-price-tick__value" value="95.34"/>\n                                <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>\n                              </div>\n                            </div>\n                          </li>\n                          <li>\n                            <div class="tick js-price-tick-quantity">\n                              <label for="tick-quantity">Quantity</label>\n                              <div class="tick__group">\n                                <button class="btn btn--secondary tick__group__button tick__group__button--down js-price-tick__down"><i class="fa fa-minus"></i></button>\n                                <input id="tick-quantity" type="text" class="text-input text-input--large tick__group--value js-price-tick__value" value="6"/>\n                                <button class="btn btn--secondary tick__group__button tick__group__button--up js-price-tick__up"><i class="fa fa-plus"></i></button>\n                              </div>\n                            </div>\n                          </li>\n                        </ul>\n                      </section>\n                    </div>\n                  </div>\n\n                  <script type="text/javascript" src="js/commonUI.js"></script>\n                  <script>\n                    function init() {\n\n                      // PRICE\n\n                      var priceTickComponent = commonUI.initializePriceTick({\n                        selector: \'.js-price-tick\'\n                      });\n\n                      var priceTickElement = document.querySelector(\'.js-price-tick\');\n\n                      priceTickElement.addEventListener(\'up.commonui.pricetick\', function () {\n                        var currentValue = parseFloat(priceTickComponent.componentInputElement.value)\n                        priceTickComponent.componentInputElement.value = (currentValue + 1)\n                      }, false);\n\n                      priceTickElement.addEventListener(\'down.commonui.pricetick\', function () {\n                        var currentValue = parseFloat(priceTickComponent.componentInputElement.value)\n                        priceTickComponent.componentInputElement.value = (currentValue - 1)\n                      }, false);\n\n                      // QTY\n\n                      var quantityTickComponent = commonUI.initializePriceTick({\n                        selector: \'.js-price-tick-quantity\'\n                      });\n\n                      var quantityTickElement = document.querySelector(\'.js-price-tick-quantity\');\n\n                      quantityTickElement.addEventListener(\'up.commonui.pricetick\', function () {\n                        var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)\n                        quantityTickComponent.componentInputElement.value = (currentValue + 1)\n                      }, false);\n\n                      quantityTickElement.addEventListener(\'down.commonui.pricetick\', function () {\n                        var currentValue = parseFloat(quantityTickComponent.componentInputElement.value)\n                        quantityTickComponent.componentInputElement.value = (currentValue - 1)\n                      }, false);\n                    }\n                    window.onload = init;\n                  </script>\n                </body>\n              </html>\n            ' })
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Tick;
	}(_get__('Component'));
	
	exports.default = _get__('Tick');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Tick':
	      return Tick;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Tick === 'undefined' ? 'undefined' : _typeof(Tick);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Tick, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Tick)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Breakpoints = function (_get__2) {
	  _inherits(Breakpoints, _get__2);
	
	  function Breakpoints(props) {
	    _classCallCheck(this, Breakpoints);
	
	    return _possibleConstructorReturn(this, (Breakpoints.__proto__ || Object.getPrototypeOf(Breakpoints)).call(this, props));
	  }
	
	  _createClass(Breakpoints, [{
	    key: 'render',
	    value: function render() {
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'breakpoints' }),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Breakpoints'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Common UI styling is developed mobile first by design. Breakpoints are based on minimum viewport widths and allow us to change styling, scaling or layout as the viewport changes.'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Common UI uses the following media query ranges in our source files. Some target a specific range and some target from the specified width up. In the source, these are defined in em units, here they are shown in pixels. The most commonly used breakpoints throughout Common UI are ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'xs-and-up'
	          ),
	          ', ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'sm-and-up'
	          ),
	          ', ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'md-and-up'
	          ),
	          ' and ',
	          _get__('React').createElement(
	            'code',
	            null,
	            'lg-and-up'
	          ),
	          '. These can be seen in the examples after each component.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            '\'xs-only\'     \'screen and (max-width: 479.04px)\'\n\'xs-and-up\'   \'screen and (min-width: 480px)\'\n\'sm-only\'     \'screen and (min-width: 480px) and (max-width: 767.04px)\'\n\'sm-and-up\'   \'screen and (min-width: 768px)\'\n\'md-only\'     \'screen and (min-width: 768px) and (max-width: 991.04px)\'\n\'md-and-up\'   \'screen and (min-width: 992px)\'\n\'lg-only\'     \'screen and (min-width: 992px) and (max-width: 1199.04px)\'\n\'lg-and-up\'   \'screen and (min-width: 1200px)\'\n\'xlg-only\'    \'screen and (min-width: 1200px) and (max-width: 1599.04px)\'\n\'xlg-and-up\'  \'screen and (min-width: 1600px)\'\n\n\'retina\'      \'(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx)\'\n\'ie\'          \'screen and (-ms-high-contrast: active), (-ms-high-contrast: none)\''
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'This compiles to:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-css' },
	            '@media screen and (max-width: 479.04px) { /* Insert styles */ } /* XS only */\n@media screen and (min-width: 480px) { /* Insert styles */ } /* XS and up */\n@media screen and (min-width: 480px) and (max-width: 767.04px) { /* Insert styles */ } /* SM only */\n@media screen and (min-width: 768px) { /* Insert styles */ } /* SM and up */\n@media screen and (min-width: 768px) and (max-width: 991.04px) { /* Insert styles */ } /* MD only */\n@media screen and (min-width: 992px) { /* Insert styles */ } /* MD and up */\n@media screen and (min-width: 992px) and (max-width: 1199.04px) { /* Insert styles */ } /* LG only */\n@media screen and (min-width: 1200px) { /* Insert styles */ } /* LG and up */\n@media screen and (min-width: 1200px) and (max-width: 1599.04px) { /* Insert styles */ } /* XLG only */\n@media screen and (min-width: 1600px) { /* Insert styles */ } /* XL and up */\n\n@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx) { /* Insert styles */ } /* Retina */\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { /* Insert styles */ } /* IE */\n'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'There are additional values for targeting retina screens and IE. Common UI provides these as SASS functions so these are intended to be use as such in application source:'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            '@include media-query(lap-and-up) { .. }'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'p',
	          null,
	          'It is intended that your application\'s styles adhere to the same breakpoints as outlined here. Failure to do this will result in an unscalable, inconsistent UI.'
	        ),
	        _get__('React').createElement(
	          'pre',
	          null,
	          _get__('React').createElement(
	            'code',
	            { className: 'language-js' },
	            '// Example: Hide starting at \'min-width: 0\', and then show at the \'sm-and-up\' breakpoint\n.custom-class {\n  display: none;\n}\n\n@include media-query(sm-and-up) {\n  .custom-class {\n    display: block;\n  }\n}'
	          )
	        ),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return Breakpoints;
	}(_get__('Component'));
	
	exports.default = _get__('Breakpoints');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'Component':
	      return _react.Component;
	
	    case 'Breakpoints':
	      return Breakpoints;
	
	    case 'React':
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Breakpoints === 'undefined' ? 'undefined' : _typeof(Breakpoints);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Breakpoints, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Breakpoints)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = DismissableSidebarPanel;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _darkThemeNav = __webpack_require__(806);
	
	var _darkThemeNav2 = _interopRequireDefault(_darkThemeNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DismissableSidebarPanel() {
	  return _get__('React').createElement(
	    'section',
	    null,
	    _get__('React').createElement('a', { className: 'anchor', id: 'dismissablesidebarpanel' }),
	    _get__('React').createElement(
	      'h2',
	      null,
	      'Dismissable Sidebar Panel'
	    ),
	    _get__('React').createElement(_get__('DarkThemeNav'), { anchor: 'dismissableSidePanel' }),
	    _get__('React').createElement(
	      'p',
	      null,
	      'Dismissable Sidebar Panels are required for interfaces that do not overlay the content like drawers but rather take up a percentage of the UI and can be dismissed and launched from a click action'
	    ),
	    _get__('React').createElement(
	      'p',
	      null,
	      'The dismissable sidebar panel will default to the left hand side of the screen. To have is appear on the right add the helper ',
	      _get__('React').createElement(
	        'code',
	        null,
	        '.is-right'
	      )
	    ),
	    _get__('React').createElement(
	      'p',
	      null,
	      'The example can be launched by clicking the notification bell in the header.'
	    ),
	    _get__('React').createElement(
	      'select',
	      { className: 'size-select' },
	      _get__('React').createElement(
	        'option',
	        { value: 'auto' },
	        'Select a resolution'
	      ),
	      _get__('React').createElement(
	        'option',
	        { value: '482' },
	        '480px (xs)'
	      ),
	      _get__('React').createElement(
	        'option',
	        { value: '770' },
	        '768px (sm)'
	      ),
	      _get__('React').createElement(
	        'option',
	        { value: '994' },
	        '992px (md)'
	      ),
	      _get__('React').createElement(
	        'option',
	        { value: '1202' },
	        '1200px (lg)'
	      )
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'div',
	      { className: 'iframe-container', style: { "height": "700px" } },
	      _get__('React').createElement('iframe', { seamless: true, srcDoc: '\n          <html>\n            <head>\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">\n              <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">\n              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Roboto">\n              <link rel="stylesheet" type="text/css" href="css/commonUI.css">\n              <link rel="stylesheet" type="text/css" href="css/styleguide.css">\n            </head>\n            <body>\n              <nav class="nav nav--global nav--dark drop-shadow js-nav">\n                <div class="nav__inner">\n                  <div class="nav__header nav__header--alternate">\n                    <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n                    <h1 class="nav__app-name">CME Institute</h1>\n                  </div>\n                  <ul class="nav__items--primary">\n                    <li class="nav__item--primary"><a>Learn</a></li>\n                    <li class="nav__item--primary"><a>Practice</a></li>\n                    <li class="nav__item--primary"><a>Challenge</a></li>\n                    <li class="nav__item--primary"><a>Markets</a></li>\n                  </ul>\n                  <ul class="nav__actions">\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n                    <li class="nav__action"><button class="nav__action-btn js-dismissable-sidebar-panel__open js-dismissable-sidebar-panel__remote-open"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>\n                  </ul>\n                </div>\n              </nav>\n              <div class="dismissable-sidebar-panels js-dismissable-sidebar-panel is-title is-compact is-right">\n                <div class="dismissable-sidebar-panels__wrapper">\n                  <div class="dismissable-sidebar-panels__sidebar">\n                    <div class="dismissable-sidebar-panels__sidebar--heading">\n                      <h1 class="flush--bottom dismissable-sidebar-panels__sidebar--heading--title push-quarter--left">Events</h3>\n                      <button class="btn btn--transparent dismissable-sidebar-panels__sidebar--heading--hide js-dismissable-sidebar-panel__close text--right hard">\n                        <span class="dismissable-sidebar-panels__sidebar--heading--hide--icon">\n                          <i class="icon-cme-card-close icon--medium"></i>\n                        </span>\n                        <span class="dismissable-sidebar-panels__sidebar--heading--hide--close">\n                          <i class="icon-cme-close-circle-o"></i>\n                        </span>\n                      </button>\n                    </div>\n\n                    <div class="dismissable-sidebar-panels__sidebar--content"></div>\n                  </div>\n                  <div class="dismissable-sidebar-panels__content">\n                    <div class="well well--border-color push">\n                      <h3 class="flush">Results Content</h3>\n                      <button class="btn dismissable-sidebar-panels__content--action js-dismissable-sidebar-panel__remote-open push--top">\n                          <i class="dismissable-sidebar-panels__content--state js-dismissable-sidebar-panel__state fa icon-cme-filter"></i>\n                          <span class="push-quarter--left">Events</span>\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </body>\n            <script type="text/javascript" src="js/commonUI.js"></script>\n            <script>\n              function init() {\n                  commonUI.initializeDismissableSidebarPanel({\n                    width: \'50%\',\n                  });\n              }\n              window.onload = init;\n            </script>\n          </html>\n        ' })
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'p',
	      null,
	      'Click \'View Source\' to show the code for Dismissable Sidebar Panel.'
	    ),
	    _get__('React').createElement(
	      'button',
	      { type: 'button', className: 'btn btn--secondary show-code' },
	      _get__('React').createElement('i', { className: 'fa fa-plus' }),
	      'View source'
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'pre',
	      { className: 'hide-code' },
	      _get__('React').createElement(
	        'code',
	        { className: 'language-html' },
	        '<nav class="nav nav--global nav--dark drop-shadow js-nav">\n  <div class="nav__inner">\n    <div class="nav__header nav__header--alternate">\n      <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>\n      <h1 class="nav__app-name">CME Institute</h1>\n    </div>\n    <ul class="nav__items--primary">\n      <li class="nav__item--primary"><a>Learn</a></li>\n      <li class="nav__item--primary"><a>Practice</a></li>\n      <li class="nav__item--primary"><a>Challenge</a></li>\n      <li class="nav__item--primary"><a>Markets</a></li>\n    </ul>\n    <ul class="nav__actions">\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-search nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-user nav__action-icon"></i></button></li>\n      <li class="nav__action"><button class="nav__action-btn js-dismissable-sidebar-panel__open js-dismissable-sidebar-panel__remote-open"><i class="fa fa-bell nav__action-icon" data-badge-count="3"></i></button></li>\n    </ul>\n  </div>\n</nav>\n<div class="dismissable-sidebar-panels js-dismissable-sidebar-panel is-title is-compact is-right">\n  <div class="dismissable-sidebar-panels__wrapper">\n    <div class="dismissable-sidebar-panels__sidebar">\n      <div class="dismissable-sidebar-panels__sidebar--heading">\n        <h1 class="flush--bottom dismissable-sidebar-panels__sidebar--heading--title push-quarter--left">Events</h3>\n        <button class="btn btn--transparent dismissable-sidebar-panels__sidebar--heading--hide js-dismissable-sidebar-panel__close text--right hard">\n          <span class="dismissable-sidebar-panels__sidebar--heading--hide--icon">\n            <i class="icon-cme-card-close icon--medium"></i>\n          </span>\n          <span class="dismissable-sidebar-panels__sidebar--heading--hide--close">\n            <i class="icon-cme-close-circle-o"></i>\n          </span>\n        </button>\n      </div>\n      <div class="dismissable-sidebar-panels__sidebar--content"></div>\n    </div>\n    <div class="dismissable-sidebar-panels__content">\n      <div class="well well--border-color push">\n        <h3 class="flush">Results Content</h3>\n        <button class="btn dismissable-sidebar-panels__content--action js-dismissable-sidebar-panel__remote-open push--top">\n          <i class="dismissable-sidebar-panels__content--state js-dismissable-sidebar-panel__state fa icon-cme-filter"></i>\n          <span class="push-quarter--left">Events</span>\n        </button>\n      </div>\n    </div>\n  </div>\n</div>'
	      )
	    ),
	    _get__('React').createElement('br', null),
	    _get__('React').createElement(
	      'p',
	      null,
	      'This is a javascript enabled component. You must initialize it using the following snippet:'
	    ),
	    _get__('React').createElement(
	      'pre',
	      null,
	      _get__('React').createElement(
	        'code',
	        { className: 'language-javascript' },
	        'commonUI.initializeDismissableSidebarPanel({\n  width: \'50%\',\n});'
	      )
	    ),
	    _get__('React').createElement('hr', null)
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'React':
	      return _react2.default;
	
	    case 'DarkThemeNav':
	      return _darkThemeNav2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof DismissableSidebarPanel === 'undefined' ? 'undefined' : _typeof(DismissableSidebarPanel);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(DismissableSidebarPanel, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(DismissableSidebarPanel)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = LayoutsDataEntry;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayoutsDataEntry(props) {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "grid" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/grid.html" },
	          _get__("React").createElement("img", { src: "images/grid.png", alt: "Screenshot of the grid samples", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "h1",
	          null,
	          "Grid Showcase"
	        ),
	        "Example of using -",
	        _get__("React").createElement(
	          "ul",
	          null,
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/forms' : 'Core#forms' },
	              "Forms"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/grid' : 'Core#grid' },
	              "Grid"
	            )
	          )
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/grid.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/grid.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof LayoutsDataEntry === "undefined" ? "undefined" : _typeof(LayoutsDataEntry);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(LayoutsDataEntry, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LayoutsDataEntry)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = LayoutsMarketing;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayoutsMarketing(props) {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "marketing" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/marketing.html" },
	          _get__("React").createElement("img", { src: "images/marketing.png", alt: "Screenshot of the marketing snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "Marketing layout"
	        ),
	        "Example of using -",
	        _get__("React").createElement(
	          "ul",
	          null,
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/navigation' : 'Core#navigation' },
	              "Navigation"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/alerts' : 'Core#alerts' },
	              "Alerts"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/wells' : 'Core#wells' },
	              "Wells"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/buttons' : 'Core#buttons' },
	              "Buttons"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#components/mediaObjects' : 'Components#mediaObjects' },
	              "Media Objects"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/grid' : 'Core#grid' },
	              "Grid"
	            )
	          )
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/marketing.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/marketing.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof LayoutsMarketing === "undefined" ? "undefined" : _typeof(LayoutsMarketing);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(LayoutsMarketing, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LayoutsMarketing)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = LayoutsSignIn;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayoutsSignIn(props) {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "signin" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/signin.html" },
	          _get__("React").createElement("img", { src: "images/signin.png", alt: "Screenshot of the sign in snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "Sign in snippet"
	        ),
	        "Example of using -",
	        _get__("React").createElement(
	          "ul",
	          null,
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/forms' : 'Core#forms' },
	              "Forms"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/buttons' : 'Core#buttons' },
	              "Buttons"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/panels' : 'Core#panels' },
	              "Panels"
	            )
	          )
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/signin.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/signin.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof LayoutsSignIn === "undefined" ? "undefined" : _typeof(LayoutsSignIn);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(LayoutsSignIn, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LayoutsSignIn)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = LayoutsEREP;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayoutsEREP(props) {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "erep" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/erep.html" },
	          _get__("React").createElement("img", { src: "images/erep.png", alt: "Screenshot of the extract-text-webpack-plugin snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "EREP"
	        ),
	        "Example of using -",
	        _get__("React").createElement(
	          "ul",
	          null,
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/navigation' : 'Core#navigation' },
	              "Navigation"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/tables' : 'Core#tables' },
	              "Tables"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/grid' : 'Core#grid' },
	              "Grid"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/buttons' : 'Core#buttons' },
	              "Buttons"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/forms' : 'Core#forms' },
	              "Forms"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/pagination' : 'Core#pagination' },
	              "Pagination"
	            )
	          )
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/erep.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/erep.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof LayoutsEREP === "undefined" ? "undefined" : _typeof(LayoutsEREP);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(LayoutsEREP, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LayoutsEREP)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = LayoutsCoreUI;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayoutsCoreUI(props) {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "core-ui" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/coreui.html" },
	          _get__("React").createElement("img", { src: "images/coreui.png", alt: "Screenshot of the CORE UI snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-xs-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "Core UI"
	        ),
	        "Example of using -",
	        _get__("React").createElement(
	          "ul",
	          null,
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/navigation' : 'Core#navigation' },
	              "Navigation"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/forms' : 'Core#forms' },
	              "Forms"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/buttons' : 'Core#buttons' },
	              "Buttons"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/grid' : 'Core#grid' },
	              "Grid"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#core/tables' : 'Core#tables' },
	              "Tables"
	            )
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            _get__("React").createElement(
	              "a",
	              { href: props.staticVersion === true ? '#components/environmentbanners' : 'Components#environmentbanners' },
	              "Environment Banner"
	            )
	          )
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/coreui.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "samples/coreui.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof LayoutsCoreUI === "undefined" ? "undefined" : _typeof(LayoutsCoreUI);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(LayoutsCoreUI, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LayoutsCoreUI)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = LayoutsUpdateBrowser;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayoutsUpdateBrowser() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "updatebrowser" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/updatebrowser.html" },
	          _get__("React").createElement("img", { src: "images/updatebrowser.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h1",
	          null,
	          "Update Browser"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live examples of the update browser alert."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/updatebrowser.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/updatebrowser.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof LayoutsUpdateBrowser === "undefined" ? "undefined" : _typeof(LayoutsUpdateBrowser);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(LayoutsUpdateBrowser, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LayoutsUpdateBrowser)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = LayoutsErrors;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layouts = __webpack_require__(868);
	
	var _Layouts2 = _interopRequireDefault(_Layouts);
	
	var _Layouts3 = __webpack_require__(869);
	
	var _Layouts4 = _interopRequireDefault(_Layouts3);
	
	var _Layouts5 = __webpack_require__(870);
	
	var _Layouts6 = _interopRequireDefault(_Layouts5);
	
	var _Layouts7 = __webpack_require__(871);
	
	var _Layouts8 = _interopRequireDefault(_Layouts7);
	
	var _Layouts9 = __webpack_require__(872);
	
	var _Layouts10 = _interopRequireDefault(_Layouts9);
	
	var _Layouts11 = __webpack_require__(873);
	
	var _Layouts12 = _interopRequireDefault(_Layouts11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LayoutsErrors() {
	  return _get__('React').createElement(
	    'section',
	    null,
	    _get__('React').createElement('a', { className: 'anchor', id: 'errors' }),
	    _get__('React').createElement(
	      'div',
	      { className: 'push--bottom grid' },
	      _get__('React').createElement(
	        'div',
	        { className: 'media__body soft--top grid__col-sm-12 grid__col-lg-12' },
	        _get__('React').createElement(
	          'h1',
	          null,
	          'Error Pages'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Live examples of the error pages can be seen below:'
	        ),
	        _get__('React').createElement(_get__('Layouts301'), null),
	        _get__('React').createElement(_get__('Layouts400'), null),
	        _get__('React').createElement(_get__('Layouts401'), null),
	        _get__('React').createElement(_get__('Layouts403'), null),
	        _get__('React').createElement(_get__('Layouts404'), null),
	        _get__('React').createElement(_get__('Layouts500'), null)
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'React':
	      return _react2.default;
	
	    case 'Layouts301':
	      return _Layouts2.default;
	
	    case 'Layouts400':
	      return _Layouts4.default;
	
	    case 'Layouts401':
	      return _Layouts6.default;
	
	    case 'Layouts403':
	      return _Layouts8.default;
	
	    case 'Layouts404':
	      return _Layouts10.default;
	
	    case 'Layouts500':
	      return _Layouts12.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof LayoutsErrors === 'undefined' ? 'undefined' : _typeof(LayoutsErrors);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(LayoutsErrors, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(LayoutsErrors)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Layouts301;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Layouts301() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "redirect" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/redirect.html" },
	          _get__("React").createElement("img", { src: "images/redirect.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "301 Error"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of the 301 error page."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/redirect.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/redirect.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Layouts301 === "undefined" ? "undefined" : _typeof(Layouts301);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Layouts301, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Layouts301)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Layouts400;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Layouts400() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "badrequest" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/badrequest.html" },
	          _get__("React").createElement("img", { src: "images/badrequest.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "400 Error"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of all the 400 error page."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/badrequest.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/badrequest.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Layouts400 === "undefined" ? "undefined" : _typeof(Layouts400);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Layouts400, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Layouts400)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Layouts401;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Layouts401() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "unauthorized" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/unauthorized.html" },
	          _get__("React").createElement("img", { src: "images/unauthorized.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "401 Error"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of all the 401 error page."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/unauthorized.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/unauthorized.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Layouts401 === "undefined" ? "undefined" : _typeof(Layouts401);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Layouts401, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Layouts401)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Layouts403;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Layouts403() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "forbidden" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/forbidden.html" },
	          _get__("React").createElement("img", { src: "images/forbidden.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "403 Error"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of all the 403 error page."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/forbidden.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/forbidden.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Layouts403 === "undefined" ? "undefined" : _typeof(Layouts403);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Layouts403, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Layouts403)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Layouts404;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Layouts404() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "notfound" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/notfound.html" },
	          _get__("React").createElement("img", { src: "images/notfound.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "404 Error"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of all the 404 error page."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/notfound.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/notfound.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Layouts404 === "undefined" ? "undefined" : _typeof(Layouts404);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Layouts404, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Layouts404)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Layouts500;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Layouts500() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "internalserver" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/internalserver.html" },
	          _get__("React").createElement("img", { src: "images/internalserver.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h2",
	          null,
	          "500 Error"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of all the 500 error page."
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/internalserver.html" },
	            "View live preview"
	          ),
	          "\xA0",
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/internalserver.html", download: true },
	            "Download"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Layouts500 === "undefined" ? "undefined" : _typeof(Layouts500);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Layouts500, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Layouts500)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = AgGrid;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AgGrid() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "agGrid" }),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/ag-grid.html" },
	          _get__("React").createElement("img", { src: "images/ag-theme.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h1",
	          null,
	          "AG Grid - Default"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of an AG Grid implementation with AG Grid Theme"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/ag-grid.html" },
	            "View live preview"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/ag-grid-dark.html" },
	          _get__("React").createElement("img", { src: "images/ag-theme-dark.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h1",
	          null,
	          "AG Grid - Dark"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of an AG Grid implementation with AG Grid Dark Theme"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/ag-grid-dark.html" },
	            "View live preview"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "push--bottom grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12  grid__col-lg-6" },
	        _get__("React").createElement(
	          "a",
	          { href: "samples/ag-grid-dark-blue.html" },
	          _get__("React").createElement("img", { src: "images/ag-theme-dark-blue.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	        _get__("React").createElement(
	          "h1",
	          null,
	          "AG Grid - Dark Blue"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          "Live example of an AG Grid implementation with AG Grid Dark Blue Theme"
	        ),
	        _get__("React").createElement(
	          "p",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn btn--large", href: "samples/ag-grid-dark-blue.html" },
	            "View live preview"
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof AgGrid === "undefined" ? "undefined" : _typeof(AgGrid);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(AgGrid, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(AgGrid)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = ComponentsShowcase;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ComponentsShowcase() {
	    return _get__("React").createElement(
	        "section",
	        null,
	        _get__("React").createElement("a", { className: "anchor", id: "theme" }),
	        _get__("React").createElement(
	            "div",
	            { className: "push--bottom grid" },
	            _get__("React").createElement(
	                "div",
	                { className: "grid__col-sm-12  grid__col-lg-6" },
	                _get__("React").createElement(
	                    "a",
	                    { href: "samples/theme-default.html" },
	                    _get__("React").createElement("img", { src: "images/theme.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	                )
	            ),
	            _get__("React").createElement(
	                "div",
	                { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	                _get__("React").createElement(
	                    "h1",
	                    null,
	                    "Theme Showcase - Default"
	                ),
	                _get__("React").createElement(
	                    "p",
	                    null,
	                    "Live examples of all the components in the framework as would be shown with the default theme."
	                ),
	                _get__("React").createElement(
	                    "p",
	                    null,
	                    _get__("React").createElement(
	                        "a",
	                        { className: "btn btn--large", href: "samples/theme.html" },
	                        "View live preview"
	                    ),
	                    "\xA0",
	                    _get__("React").createElement(
	                        "a",
	                        { className: "btn btn--large", href: "samples/theme.html", download: true },
	                        "Download"
	                    )
	                )
	            )
	        ),
	        _get__("React").createElement(
	            "div",
	            { className: "push--bottom grid" },
	            _get__("React").createElement(
	                "div",
	                { className: "grid__col-sm-12  grid__col-lg-6" },
	                _get__("React").createElement(
	                    "a",
	                    { href: "samples/theme-dark-grey.html" },
	                    _get__("React").createElement("img", { src: "images/theme-dark.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	                )
	            ),
	            _get__("React").createElement(
	                "div",
	                { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	                _get__("React").createElement(
	                    "h1",
	                    null,
	                    "Theme Showcase - Dark"
	                ),
	                _get__("React").createElement(
	                    "p",
	                    null,
	                    "Live examples of all the components in the framework as would be shown with Dark theme selected"
	                ),
	                _get__("React").createElement(
	                    "p",
	                    null,
	                    _get__("React").createElement(
	                        "a",
	                        { className: "btn btn--large", href: "samples/theme-dark-grey.html" },
	                        "View live preview"
	                    ),
	                    "\xA0",
	                    _get__("React").createElement(
	                        "a",
	                        { className: "btn btn--large", href: "samples/theme-dark-grey.html", download: true },
	                        "Download"
	                    )
	                )
	            )
	        ),
	        _get__("React").createElement(
	            "div",
	            { className: "push--bottom grid" },
	            _get__("React").createElement(
	                "div",
	                { className: "grid__col-sm-12  grid__col-lg-6" },
	                _get__("React").createElement(
	                    "a",
	                    { href: "samples/theme-dark-blue.html" },
	                    _get__("React").createElement("img", { src: "images/theme-dark-blue.png", alt: "Screenshot of the theme snippet", className: "media__img" })
	                )
	            ),
	            _get__("React").createElement(
	                "div",
	                { className: "media__body soft--top grid__col-sm-12 grid__col-lg-6" },
	                _get__("React").createElement(
	                    "h1",
	                    null,
	                    "Theme Showcase - Dark Blue"
	                ),
	                _get__("React").createElement(
	                    "p",
	                    null,
	                    "Live examples of all the components in the framework as would be shown with Dark Blue theme selected"
	                ),
	                _get__("React").createElement(
	                    "p",
	                    null,
	                    _get__("React").createElement(
	                        "a",
	                        { className: "btn btn--large", href: "samples/theme-dark-blue.html" },
	                        "View live preview"
	                    ),
	                    "\xA0",
	                    _get__("React").createElement(
	                        "a",
	                        { className: "btn btn--large", href: "samples/theme-dark-blue.html", download: true },
	                        "Download"
	                    )
	                )
	            )
	        )
	    );
	}
	
	function _getGlobalObject() {
	    try {
	        if (!!global) {
	            return global;
	        }
	    } catch (e) {
	        try {
	            if (!!window) {
	                return window;
	            }
	        } catch (e) {
	            return this;
	        }
	    }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	    if (_RewireModuleId__ === null) {
	        var globalVariable = _getGlobalObject();
	
	        if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	            globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	        }
	
	        _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	    }
	
	    return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	    var theGlobalVariable = _getGlobalObject();
	
	    if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	        theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    }
	
	    return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	    var moduleId = _getRewireModuleId__();
	
	    var registry = _getRewireRegistry__();
	
	    var rewireData = registry[moduleId];
	
	    if (!rewireData) {
	        registry[moduleId] = Object.create(null);
	        rewireData = registry[moduleId];
	    }
	
	    return rewireData;
	}
	
	(function registerResetAll() {
	    var theGlobalVariable = _getGlobalObject();
	
	    if (!theGlobalVariable['__rewire_reset_all__']) {
	        theGlobalVariable['__rewire_reset_all__'] = function () {
	            theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	        };
	    }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	    function addPropertyToAPIObject(name, value) {
	        Object.defineProperty(_RewireAPI__, name, {
	            value: value,
	            enumerable: false,
	            configurable: true
	        });
	    }
	
	    addPropertyToAPIObject('__get__', _get__);
	    addPropertyToAPIObject('__GetDependency__', _get__);
	    addPropertyToAPIObject('__Rewire__', _set__);
	    addPropertyToAPIObject('__set__', _set__);
	    addPropertyToAPIObject('__reset__', _reset__);
	    addPropertyToAPIObject('__ResetDependency__', _reset__);
	    addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	    var rewireData = _getRewiredData__();
	
	    if (rewireData[variableName] === undefined) {
	        return _get_original__(variableName);
	    } else {
	        var value = rewireData[variableName];
	
	        if (value === INTENTIONAL_UNDEFINED) {
	            return undefined;
	        } else {
	            return value;
	        }
	    }
	}
	
	function _get_original__(variableName) {
	    switch (variableName) {
	        case "React":
	            return _react2.default;
	    }
	
	    return undefined;
	}
	
	function _assign__(variableName, value) {
	    var rewireData = _getRewiredData__();
	
	    if (rewireData[variableName] === undefined) {
	        return _set_original__(variableName, value);
	    } else {
	        return rewireData[variableName] = value;
	    }
	}
	
	function _set_original__(variableName, _value) {
	    switch (variableName) {}
	
	    return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	    var oldValue = _get__(variableName);
	
	    var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	    _assign__(variableName, newValue);
	
	    return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	    var rewireData = _getRewiredData__();
	
	    if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	        Object.keys(variableName).forEach(function (name) {
	            rewireData[name] = variableName[name];
	        });
	        return function () {
	            Object.keys(variableName).forEach(function (name) {
	                _reset__(variableName);
	            });
	        };
	    } else {
	        if (value === undefined) {
	            rewireData[variableName] = INTENTIONAL_UNDEFINED;
	        } else {
	            rewireData[variableName] = value;
	        }
	
	        return function () {
	            _reset__(variableName);
	        };
	    }
	}
	
	function _reset__(variableName) {
	    var rewireData = _getRewiredData__();
	
	    delete rewireData[variableName];
	
	    if (Object.keys(rewireData).length == 0) {
	        delete _getRewireRegistry__()[_getRewireModuleId__];
	    }
	
	    ;
	}
	
	function _with__(object) {
	    var rewireData = _getRewiredData__();
	
	    var rewiredVariableNames = Object.keys(object);
	    var previousValues = {};
	
	    function reset() {
	        rewiredVariableNames.forEach(function (variableName) {
	            rewireData[variableName] = previousValues[variableName];
	        });
	    }
	
	    return function (callback) {
	        rewiredVariableNames.forEach(function (variableName) {
	            previousValues[variableName] = rewireData[variableName];
	            rewireData[variableName] = object[variableName];
	        });
	        var result = callback();
	
	        if (!!result && typeof result.then == 'function') {
	            result.then(reset).catch(reset);
	        } else {
	            reset();
	        }
	
	        return result;
	    };
	}
	
	var _typeOfOriginalExport = typeof ComponentsShowcase === "undefined" ? "undefined" : _typeof(ComponentsShowcase);
	
	function addNonEnumerableProperty(name, value) {
	    Object.defineProperty(ComponentsShowcase, name, {
	        value: value,
	        enumerable: false,
	        configurable: true
	    });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ComponentsShowcase)) {
	    addNonEnumerableProperty('__get__', _get__);
	    addNonEnumerableProperty('__GetDependency__', _get__);
	    addNonEnumerableProperty('__Rewire__', _set__);
	    addNonEnumerableProperty('__set__', _set__);
	    addNonEnumerableProperty('__reset__', _reset__);
	    addNonEnumerableProperty('__ResetDependency__', _reset__);
	    addNonEnumerableProperty('__with__', _with__);
	    addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Included = __webpack_require__(820);
	
	var _Included2 = _interopRequireDefault(_Included);
	
	var _reactRouter = __webpack_require__(605);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BuildDetail = function (_get__2) {
	  _inherits(BuildDetail, _get__2);
	
	  function BuildDetail(props) {
	    _classCallCheck(this, BuildDetail);
	
	    var _this = _possibleConstructorReturn(this, (BuildDetail.__proto__ || Object.getPrototypeOf(BuildDetail)).call(this, props));
	
	    _this.state = {
	      error: null
	    };
	    return _this;
	  }
	
	  _createClass(BuildDetail, [{
	    key: 'handleBuildError',
	    value: function handleBuildError(e) {
	      this.setState({ error: e });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var self = this;
	      e.preventDefault();
	
	      var data = {};
	      var loader = _get__('commonUI').initializeLoader({ message: 'Building Resources...' });
	
	      for (var i = 0; i < e.target.length; i++) {
	        if (e.target[i].type === 'checkbox') {
	          data[e.target[i].name.toLowerCase()] = e.target[i].checked;
	        }
	      }
	
	      $.ajax({
	        type: 'POST',
	        url: 'custom-build',
	        data: JSON.stringify(data),
	        contentType: "application/json; charset=utf-8",
	        success: function success(e) {
	          loader.destroy();
	          self.handleBuildError(null);
	          $.fileDownload(e);
	        },
	        error: function error(e) {
	          loader.destroy();
	          self.handleBuildError(e.responseText);
	        }
	      });
	    }
	  }, {
	    key: 'renderErrorMessage',
	    value: function renderErrorMessage() {
	      if (this.state.error) {
	        return _get__('React').createElement(
	          'div',
	          { className: 'alert alert--error', role: 'alert' },
	          _get__('React').createElement(
	            'code',
	            null,
	            this.state.error
	          )
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          components = _props.components,
	          onIncludeClick = _props.onIncludeClick;
	
	      return _get__('React').createElement(
	        'section',
	        null,
	        _get__('React').createElement('a', { className: 'anchor', id: 'build' }),
	        _get__('React').createElement('br', null),
	        _get__('React').createElement(
	          'h2',
	          null,
	          'Create a custom package'
	        ),
	        _get__('React').createElement(
	          'p',
	          null,
	          'Core components are always included. Optional components consist of more specific use cases that your project may not require out of the box.',
	          _get__('React').createElement('br', null),
	          'Select your components and click the \'Package\' button to generate and download a customised set of assets.'
	        ),
	        _get__('React').createElement(
	          'form',
	          { onSubmit: this.handleSubmit.bind(this) },
	          _get__('React').createElement(
	            'table',
	            { className: 'table table--fixed table--cells table--comfy' },
	            _get__('React').createElement(
	              'thead',
	              null,
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Feature'
	                ),
	                _get__('React').createElement(
	                  'th',
	                  null,
	                  'Included'
	                )
	              )
	            ),
	            _get__('React').createElement(
	              'tbody',
	              null,
	              _get__('React').createElement(
	                'tr',
	                null,
	                _get__('React').createElement(
	                  'td',
	                  null,
	                  'Core Components'
	                ),
	                _get__('React').createElement(
	                  'td',
	                  { className: 'text--center' },
	                  'Included'
	                )
	              ),
	              components.Components.map(function (object, index) {
	                return _get__('React').createElement(
	                  'tr',
	                  { key: object.template },
	                  _get__('React').createElement(
	                    'td',
	                    null,
	                    _get__('React').createElement(
	                      _get__('Link'),
	                      { to: 'components' + object.anchor },
	                      object.name
	                    )
	                  ),
	                  _get__('React').createElement(
	                    'td',
	                    { className: 'text--center' },
	                    _get__('React').createElement('input', { type: 'checkbox', name: object.template, checked: object.include, onChange: function onChange() {
	                        return onIncludeClick('Components', index);
	                      } }),
	                    _get__('React').createElement(
	                      'label',
	                      { className: 'hide' },
	                      object.name
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          _get__('React').createElement('br', null),
	          this.renderErrorMessage(),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement(
	            'button',
	            { type: 'submit', className: 'btn btn--positive' },
	            'Package',
	            _get__('React').createElement('i', { className: 'fa fa-magic' })
	          ),
	          _get__('React').createElement('br', null),
	          _get__('React').createElement('br', null)
	        ),
	        _get__('React').createElement('hr', null)
	      );
	    }
	  }]);
	
	  return BuildDetail;
	}(_get__('Component'));
	
	exports.default = _get__('BuildDetail');
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;
	
	    case 'Component':
	      return _react.Component;
	
	    case 'BuildDetail':
	      return BuildDetail;
	
	    case 'React':
	      return _react2.default;
	
	    case 'Link':
	      return _reactRouter.Link;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof BuildDetail === 'undefined' ? 'undefined' : _typeof(BuildDetail);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(BuildDetail, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(BuildDetail)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Installation;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Installation(props) {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "installation" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Getting Started"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      _get__("React").createElement(
	        "b",
	        null,
	        "Version: 1.28.0.6 Built: 2021-01-12 14:46:58"
	      )
	    ),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Installation"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Download the latest files available and include them in your build"
	    ),
	    _get__("React").createElement(
	      "ul",
	      { className: "list-inline" },
	      _get__("React").createElement(
	        "li",
	        null,
	        _get__("React").createElement(
	          "a",
	          { className: "btn btn--positive", href: "css/commonUI.css", download: true },
	          "commonUI.css"
	        ),
	        "\xA0"
	      ),
	      _get__("React").createElement(
	        "li",
	        null,
	        _get__("React").createElement(
	          "a",
	          { className: "btn btn--positive", href: "css/AG-Grid_theming.css", download: true },
	          "AG-Grid_theming.css"
	        ),
	        "\xA0"
	      ),
	      _get__("React").createElement(
	        "li",
	        null,
	        _get__("React").createElement(
	          "a",
	          { className: "btn btn--positive", href: "js/commonUI.js", download: true },
	          "commonUI.js"
	        ),
	        "\xA0"
	      ),
	      _get__("React").createElement(
	        "li",
	        null,
	        _get__("React").createElement(
	          "a",
	          { className: "btn btn--positive", href: "js/ie11CustomProperties.js", download: true },
	          "ie11CustomProperties.js"
	        ),
	        "\xA0"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "div",
	      { className: "callout" },
	      "Optional! Download and include these map files in the same directory as their minified counterparts for better debugging",
	      _get__("React").createElement("br", null),
	      _get__("React").createElement("br", null),
	      _get__("React").createElement(
	        "ul",
	        { className: "list-inline" },
	        _get__("React").createElement(
	          "li",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "css/commonUI.css.map", download: true },
	            "commonUI.css.map"
	          ),
	          "\xA0"
	        ),
	        _get__("React").createElement(
	          "li",
	          null,
	          _get__("React").createElement(
	            "a",
	            { className: "btn", href: "js/commonUI.js.map", download: true },
	            "commonUI.js.map"
	          )
	        )
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Adding to your project"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Include the files along with the Roboto font and FontAwesome in your build like below. "
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "CSS - "
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<head>\n  <meta charset=\"utf-8\">\n  <meta http-equiv=\"x-ua-compatible\" content=\"ie=edge\">\n  <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n  <link rel=\"stylesheet\" type=\"text/css\" href=\"https://fonts.googleapis.com/css?family=Roboto:400,500,700\">\n  <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/all.css\">\n  <link rel=\"stylesheet\" href=\"https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css\">\n  <link rel=\"stylesheet\" type=\"text/css\" href=\"path/to/commonUI.css\"/>\n</head>"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "JavaScript - "
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<script type=\"text/javascript\" src=\"path/to/commonUI.js\"></script>"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "The following polyfill must be used to allow IE11 to use custom properties."
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<head>\n  <script>window.MSInputMethodContext && document.documentMode && document.write('<script type=\"text/javascript\" src=\"../js/ie11CustomProperties.js\"></script>');</script>\n</head>"
	      )
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Using a sample ",
	      _get__("React").createElement(
	        "a",
	        { href: props.staticVersion === true ? '#layouts' : 'layouts' },
	        "layout"
	      ),
	      " is the recommended starting point."
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null)
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Installation === "undefined" ? "undefined" : _typeof(Installation);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Installation, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Installation)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = Support;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Support() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "support" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Support"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "h3",
	      null,
	      "Need help?"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Join the ",
	      _get__("React").createElement(
	        "a",
	        { className: "btn", href: "https://hipchat.chicago.cme.com/chat/room/414", target: "_blank" },
	        "Hipchat"
	      ),
	      " room."
	    ),
	    _get__("React").createElement(
	      "h4",
	      null,
	      "Issue / Feature request"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Raise a ",
	      _get__("React").createElement(
	        "button",
	        { className: "btn jira-button" },
	        "Jira"
	      ),
	      " ticket. These will be reviewed and prioritised"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null)
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof Support === "undefined" ? "undefined" : _typeof(Support);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(Support, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(Support)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = ChangeLog;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ChangeLog() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "changelog" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Change Log"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "Current version - ",
	      _get__("React").createElement(
	        "strong",
	        null,
	        "v1.28.0.6"
	      )
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "What has changed recently?"
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--bleed" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-2" },
	        _get__("React").createElement(
	          "h3",
	          null,
	          "Version History"
	        )
	      )
	    ),
	    _get__("React").createElement(
	      "div",
	      { className: "grid" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.28", target: "_blank" },
	            "1.28"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1086", target: "_blank" },
	              "CMEUI-1086"
	            ),
	            " Dark Theme - Search"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1133", target: "_blank" },
	              "CMEUI-1133"
	            ),
	            " Dark Theme - Outline Buttons"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1215", target: "_blank" },
	              "CMEUI-1215"
	            ),
	            " Dark Theme - Dropdown"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.27", target: "_blank" },
	            "1.27"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1024", target: "_blank" },
	              "CMEUI-1024"
	            ),
	            " AG Grid - Default Theme"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1025", target: "_blank" },
	              "CMEUI-1025"
	            ),
	            " AG Grid - Dark Blue Theme"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1026", target: "_blank" },
	              "CMEUI-1026"
	            ),
	            " AG Grid - Dark Grey Theme"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.26", target: "_blank" },
	            "1.26"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-976", target: "_blank" },
	              "CMEUI-976"
	            ),
	            " Font - Add Poppins as Default Font"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1075", target: "_blank" },
	              "CMEUI-1075"
	            ),
	            " Dark Theme - Alerts"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1084", target: "_blank" },
	              "CMEUI-1084"
	            ),
	            " Dark Theme - Pagination"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1082", target: "_blank" },
	              "CMEUI-1082"
	            ),
	            " Dark Theme - Toasts"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-995", target: "_blank" },
	              "CMEUI-995"
	            ),
	            " Dark Theme - Forms"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1093", target: "_blank" },
	              "CMEUI-1093"
	            ),
	            " Dark Theme - Typography"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1091", target: "_blank" },
	              "CMEUI-1091"
	            ),
	            " Dark Theme - Breadcrumbs"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1088", target: "_blank" },
	              "CMEUI-1088"
	            ),
	            " Dark Theme - Toggles"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1081", target: "_blank" },
	              "CMEUI-1081"
	            ),
	            " Dark Theme - Datepicker"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1078", target: "_blank" },
	              "CMEUI-1078"
	            ),
	            " Dark Theme - Split Layout"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1069", target: "_blank" },
	              "CMEUI-1069"
	            ),
	            " Dark Theme - Panels"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1092", target: "_blank" },
	              "CMEUI-1092"
	            ),
	            " Dark Theme - Progress Indicators"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1076", target: "_blank" },
	              "CMEUI-1076"
	            ),
	            " Dark Theme - Accordions"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1073", target: "_blank" },
	              "CMEUI-1073"
	            ),
	            " Dark Theme - Drawers"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1105", target: "_blank" },
	              "CMEUI-1105"
	            ),
	            " Dark Theme - Filters"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1071", target: "_blank" },
	              "CMEUI-1071"
	            ),
	            " Dark Theme - Tabs"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1201", target: "_blank" },
	              "CMEUI-1201"
	            ),
	            " Dark Theme - Dismissable Sidebar Panels"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1124", target: "_blank" },
	              "CMEUI-1124"
	            ),
	            " Dark Theme - Tables"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1084", target: "_blank" },
	              "CMEUI-1084"
	            ),
	            " Dark Theme - Pagination"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1092", target: "_blank" },
	              "CMEUI-1092"
	            ),
	            " Dark Theme - Loaders"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1135", target: "_blank" },
	              "CMEUI-1135"
	            ),
	            " Buttons - Fix Outline Button BG"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.25", target: "_blank" },
	            "1.25"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-976", target: "_blank" },
	              "CMEUI-976"
	            ),
	            " Font - Add Poppins as Default Font"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-982", target: "_blank" },
	              "CMEUI-982"
	            ),
	            " Dismissable Sidebar Panels"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1000", target: "_blank" },
	              "CMEUI-1000"
	            ),
	            " Split Layout - Dismissible Event"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-981", target: "_blank" },
	              "CMEUI-981"
	            ),
	            " Modals - Variations and New Sizes"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-928", target: "_blank" },
	              "CMEUI-928"
	            ),
	            " Forms - Light Theme"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-929", target: "_blank" },
	              "CMEUI-929"
	            ),
	            " Forms - Dark Theme"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-931", target: "_blank" },
	              "CMEUI-931"
	            ),
	            " Input States - Light Theme"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-930", target: "_blank" },
	              "CMEUI-930"
	            ),
	            " Input States - Dark Theme"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-1001", target: "_blank" },
	              "CMEUI-1001"
	            ),
	            " Update to NR Environment Banner"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.24", target: "_blank" },
	            "1.24"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-571", target: "_blank" },
	              "CMEUI-571"
	            ),
	            " Forms - Client Side Validation"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-573", target: "_blank" },
	              "CMEUI-573"
	            ),
	            " Forms - Default Theme"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-940", target: "_blank" },
	              "CMEUI-940"
	            ),
	            " Button - Update styles for full colour buttons"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-804", target: "_blank" },
	              "CMEUI-804"
	            ),
	            " Button Dropdown - Nested Content"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-878", target: "_blank" },
	              "CMEUI-878"
	            ),
	            " Icons - Fix outstanding matches to mismatch set"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.23", target: "_blank" },
	            "1.23"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-507", target: "_blank" },
	              "CMEUI-507"
	            ),
	            " Upgrade to Font Awesome 5"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-856", target: "_blank" },
	              "CMEUI-856"
	            ),
	            " Add Admin User Settings Icon to CME Font"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.22", target: "_blank" },
	            "1.22"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-915", target: "_blank" },
	              "CMEUI-915"
	            ),
	            " Tables - Single Row - Delete Action"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-906", target: "_blank" },
	              "CMEUI-906"
	            ),
	            " Update Typography - Introduce Averta Font"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-883", target: "_blank" },
	              "CMEUI-883"
	            ),
	            " Colour Mapping - Map Existing Colous to New Pallette for New Theme"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.21", target: "_blank" },
	            "1.21"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-785", target: "_blank" },
	              "CMEUI-785"
	            ),
	            " Pre-Canned Error Pages 301 / 400 / 401 / 403 / 404 / 500"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-802", target: "_blank" },
	              "CMEUI-802"
	            ),
	            " Pre-Canned Error Pages Responsive 301 / 400 / 401 / 403 / 404 / 500"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-786", target: "_blank" },
	              "CMEUI-786"
	            ),
	            " Automated Upgrade your browser alert"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-884", target: "_blank" },
	              "CMEUI-884"
	            ),
	            " Add new logo to CUI"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-889", target: "_blank" },
	              "CMEUI-889"
	            ),
	            "  Enhancement to Reorder Columns in Tables"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.20", target: "_blank" },
	            "1.20"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-440", target: "_blank" },
	              "CMEUI-440"
	            ),
	            " Tables - Inline Edit text"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-830", target: "_blank" },
	              "CMEUI-830"
	            ),
	            " Table - Inline Edit Link"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.19", target: "_blank" },
	            "1.19"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-442", target: "_blank" },
	              "CMEUI-442"
	            ),
	            " Tables - Reorder Columns"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-556", target: "_blank" },
	              "CMEUI-556"
	            ),
	            " Table - Inline Alerts"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-811", target: "_blank" },
	              "CMEUI-811"
	            ),
	            " Icons - file-alt icon added"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-791", target: "_blank" },
	              "CMEUI-791"
	            ),
	            " Buttons Groups - Multi-Select Draggable & Reorder"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-532", target: "_blank" },
	              "CMEUI-532"
	            ),
	            " Forms - Datepicker style & range and time enhancments"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-810", target: "_blank" },
	              "CMEUI-810"
	            ),
	            " Resizable Split Layout - Mobile Behaviour"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-808", target: "_blank" },
	              "CMEUI-808"
	            ),
	            " Resizable Split Layout - Hover State & Configure Gutter"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.18", target: "_blank" },
	            "1.18"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-566", target: "_blank" },
	              "CMEUI-566"
	            ),
	            " Tables - Stacked Row"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-747", target: "_blank" },
	              "CMEUI-747"
	            ),
	            " Icons - Whiteboard icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-748", target: "_blank" },
	              "CMEUI-748"
	            ),
	            " Icons - Close icon light"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-784", target: "_blank" },
	              "CMEUI-784"
	            ),
	            " Icons - Price history & Activity Log"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-761", target: "_blank" },
	              "CMEUI-761"
	            ),
	            " Button Groups (toggle) - Single Select Responsive"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-378", target: "_blank" },
	              "CMEUI-378"
	            ),
	            " Toggle Switch - Disabled/Locked State"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-637", target: "_blank" },
	              "CMEUI-637"
	            ),
	            " Adjustable/Resizable UI Elements"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-671", target: "_blank" },
	              "CMEUI-671"
	            ),
	            " Badges - enhancements to style and documentation"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-751", target: "_blank" },
	              "CMEUI-751"
	            ),
	            " Icons - Centre the user outline and trophy"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-685", target: "_blank" },
	              "CMEUI-685"
	            ),
	            " New color - light grey"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.17", target: "_blank" },
	            "1.17"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-710", target: "_blank" },
	              "CMEUI-710"
	            ),
	            " Toasts"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-595", target: "_blank" },
	              "CMEUI-595"
	            ),
	            " Tables - Responsive Detail View"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-435", target: "_blank" },
	              "CMEUI-435"
	            ),
	            " Tables - Expanded Row for Desktop"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-728", target: "_blank" },
	              "CMEUI-728"
	            ),
	            " Alerts - Minimal"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-99", target: "_blank" },
	              "CMEUI-99"
	            ),
	            " Button Groups (toggle) - Single Select"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.16", target: "_blank" },
	            "1.16"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-656", target: "_blank" },
	              "CMEUI-656"
	            ),
	            " Icons - Trade book icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-657", target: "_blank" },
	              "CMEUI-657"
	            ),
	            " Icons - Price to beat icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-658", target: "_blank" },
	              "CMEUI-658"
	            ),
	            " Icons - User bid icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-659", target: "_blank" },
	              "CMEUI-659"
	            ),
	            " Icons - Associate bid icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-660", target: "_blank" },
	              "CMEUI-660"
	            ),
	            " Icons - Auctions icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-664", target: "_blank" },
	              "CMEUI-664"
	            ),
	            " Icons - Persistent chat icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-494", target: "_blank" },
	              "CMEUI-494"
	            ),
	            " Icons - Options grid icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-526", target: "_blank" },
	              "CMEUI-526"
	            ),
	            " Icons - Login icon"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-448", target: "_blank" },
	              "CMEUI-448"
	            ),
	            " Filters - Categories"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-479", target: "_blank" },
	              "CMEUI-479"
	            ),
	            " Tabs - Vertical lite styling"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-612", target: "_blank" },
	              "CMEUI-612"
	            ),
	            " Buttons - Multi-select groups"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-670", target: "_blank" },
	              "CMEUI-670"
	            ),
	            " Alert Boxes - IE fix"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.15", target: "_blank" },
	            "1.15"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-642", target: "_blank" },
	              "CMEUI-642"
	            ),
	            " Buttons - New default secondary styling"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-642", target: "_blank" },
	              "CMEUI-634"
	            ),
	            " Buttons - Border weight restyle"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-636", target: "_blank" },
	              "CMEUI-636"
	            ),
	            " Buttons - Button state colour updates"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-636", target: "_blank" },
	              "CMEUI-636"
	            ),
	            " Buttons - Button state colour updates"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-627", target: "_blank" },
	              "CMEUI-627"
	            ),
	            " Buttons - fix for layout in responsive view"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-641", target: "_blank" },
	              "CMEUI-641"
	            ),
	            " Dropdown - Restyle"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-632", target: "_blank" },
	              "CMEUI-632"
	            ),
	            " Breakpoints - documentation on supported breakpoints"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-626", target: "_blank" },
	              "CMEUI-626"
	            ),
	            " Tables - improved documentation on responsive implementation"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-598", target: "_blank" },
	              "CMEUI-598"
	            ),
	            " Drawers - tabbed bottom drawer component"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-591", target: "_blank" },
	              "CMEUI-591"
	            ),
	            " Alerts - compact alert styling"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-646", target: "_blank" },
	              "CMEUI-646"
	            ),
	            " Alerts - treatment for \"upgrading your browser\" to a supported version"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-478", target: "_blank" },
	              "CMEUI-478"
	            ),
	            " Wells/Panels - Wells & callouts, now known as Panels"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-550", target: "_blank" },
	              "CMEUI-550"
	            ),
	            " Home - fix for incorrect Hipchat room link"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.14", target: "_blank" },
	            "1.14"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-492", target: "_blank" },
	              "CMEUI-492"
	            ),
	            " Filters - Core layout"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-498", target: "_blank" },
	              "CMEUI-498"
	            ),
	            " Filters - Responsive layout"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-447", target: "_blank" },
	              "CMEUI-447"
	            ),
	            " Filters - Hide/Show Sidebar"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-359", target: "_blank" },
	              "CMEUI-359"
	            ),
	            " Countdown Timer with Progress Bar"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-450", target: "_blank" },
	              "CMEUI-450"
	            ),
	            " Filters - Fixed Footer Action"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-578", target: "_blank" },
	              "CMEUI-578"
	            ),
	            " Badges - Status Badges"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-594", target: "_blank" },
	              "CMEUI-594"
	            ),
	            " Price Tick Component - Tick up/down for price and quantity"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.13", target: "_blank" },
	            "1.13"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-561", target: "_blank" },
	              "CMEUI-561"
	            ),
	            " Accordion enhancements - Active state"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-368", target: "_blank" },
	              "CMEUI-368"
	            ),
	            " Tabs - 'Tabs Lite' style"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-373", target: "_blank" },
	              "CMEUI-373"
	            ),
	            " Colours - adding additional colours"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-553", target: "_blank" },
	              "CMEUI-553"
	            ),
	            " Tooltips - update position in scrollable containers"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-555", target: "_blank" },
	              "CMEUI-555"
	            ),
	            " Navigation - 'Navigation Lite' style"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.12", target: "_blank" },
	            "1.12"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-432", target: "_blank" },
	              "CMEUI-432"
	            ),
	            " Table - Categories"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-436", target: "_blank" },
	              "CMEUI-436"
	            ),
	            " Table - Grouped columns"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-437", target: "_blank" },
	              "CMEUI-437"
	            ),
	            " Table - Grouped rows"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-518", target: "_blank" },
	              "CMEUI-518"
	            ),
	            " XL class for the drawer component"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.11", target: "_blank" },
	            "1.11"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[IMPROVEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-177", target: "_blank" },
	              "CMEUI-177"
	            ),
	            " Add remain open option to accordions"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-363", target: "_blank" },
	              "CMEUI-363"
	            ),
	            " Drawer component"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-409", target: "_blank" },
	              "CMEUI-409"
	            ),
	            " Modal buttons default position"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[IMPROVEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-438", target: "_blank" },
	              "CMEUI-438"
	            ),
	            " Table - Sortable Columns"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-454", target: "_blank" },
	              "CMEUI-454"
	            ),
	            " Blue table theme update - ",
	            _get__("React").createElement(
	              "strong",
	              null,
	              "Note:"
	            ),
	            " This update effects the default styling for the blue theme, see ",
	            _get__("React").createElement(
	              "a",
	              { href: "/core#tables" },
	              "tables docs"
	            ),
	            " for more info"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-461", target: "_blank" },
	              "CMEUI-461"
	            ),
	            " Hit/Lift indicators"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.10", target: "_blank" },
	            "1.10"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-110", target: "_blank" },
	              "CMEUI-110"
	            ),
	            " Vertical tabs"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-339", target: "_blank" },
	              "CMEUI-339"
	            ),
	            " Tooltip - additional style"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-366", target: "_blank" },
	              "CMEUI-366"
	            ),
	            " Add \"white\" table style"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[IMPROVEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-428", target: "_blank" },
	              "CMEUI-428"
	            ),
	            " Layout fix for dissmissable alerts"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-429", target: "_blank" },
	              "CMEUI-429"
	            ),
	            " Scrolling issue on Windows Google Chrome"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-434", target: "_blank" },
	              "CMEUI-434"
	            ),
	            " Table Density"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-456", target: "_blank" },
	              "CMEUI-456"
	            ),
	            " Dotted / Decimal Lists"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-441", target: "_blank" },
	              "CMEUI-441"
	            ),
	            " Table - Row Hover"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.9", target: "_blank" },
	            "1.9.1"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-308", target: "_blank" },
	              "CMEUI-308"
	            ),
	            " Multi step process component"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-351", target: "_blank" },
	              "CMEUI-351"
	            ),
	            " Pinegreen-3 alerts with links"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-380", target: "_blank" },
	              "CMEUI-380"
	            ),
	            " New CME icons for RFQ and Blocks"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.7", target: "_blank" },
	            "1.7.1"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-315", target: "_blank" },
	              "CMEUI-315"
	            ),
	            " Tabs enhancements: provide a property to enable auto-scroll to newest tab"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-324", target: "_blank" },
	              "CMEUI-324"
	            ),
	            " Issues when cancelling Add/Remove tabs"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-325", target: "_blank" },
	              "CMEUI-325"
	            ),
	            " Adding tabs doesn't add content"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-326", target: "_blank" },
	              "CMEUI-326"
	            ),
	            " Tabs require close button"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-333", target: "_blank" },
	              "CMEUI-333"
	            ),
	            " Reduce width of tabs in tab menu"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.6", target: "_blank" },
	            "1.6.1"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-137", target: "_blank" },
	              "CMEUI-137"
	            ),
	            " Toggle (on/off switch)"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-320", target: "_blank" },
	              "CMEUI-320"
	            ),
	            " \"Back to Top\" button"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-332", target: "_blank" },
	              "CMEUI-332"
	            ),
	            " Scrollable tab menu - arrow buttons"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[ENHANCEMENT] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-337", target: "_blank" },
	              "CMEUI-337"
	            ),
	            " Navigation: scrollbar is showing in IE"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-338", target: "_blank" },
	              "CMEUI-338"
	            ),
	            " Dropdowns have list style by default"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-346", target: "_blank" },
	              "CMEUI-346"
	            ),
	            " Nav menu - add/remove child menu items not updating mobile menu"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-350", target: "_blank" },
	              "CMEUI-350"
	            ),
	            " Z-index issue with modals and dropdowns"
	          )
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-12 hard push--bottom" },
	        _get__("React").createElement(
	          "h4",
	          { className: "push-half--bottom" },
	          _get__("React").createElement(
	            "a",
	            { href: "https://wiki.chicago.cme.com/confluence/display/FEDEVCOE/CMEUI+1.5", target: "_blank" },
	            "1.5.3"
	          )
	        ),
	        _get__("React").createElement(
	          "ul",
	          { className: "list-dots" },
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-330", target: "_blank" },
	              "CMEUI-330"
	            ),
	            " Loaders: add additional explanatory text when a process is still working"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[FEATURE] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-310", target: "_blank" },
	              "CMEUI-310"
	            ),
	            " Dropdown button"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-323", target: "_blank" },
	              "CMEUI-323"
	            ),
	            " Modal display issue on IE"
	          ),
	          _get__("React").createElement(
	            "li",
	            null,
	            "[BUG] ",
	            _get__("React").createElement(
	              "a",
	              { href: "https://cmejira.chicago.cme.com/login/browse/CMEUI-328", target: "_blank" },
	              "CMEUI-328"
	            ),
	            " Required field marker misplaced when modal is scrolled"
	          )
	        )
	      )
	    ),
	    " */}",
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--bleed" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-2" },
	        _get__("React").createElement(
	          "h4",
	          null,
	          "Features"
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-11" },
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.6.1"
	          ),
	          " - Toggle (on/off switch)."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.6.1"
	          ),
	          " - \"Back to Top\" button."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.6.1"
	          ),
	          " - Scrollable tab menu - arrow buttons."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.6.1"
	          ),
	          " - Navigation: scrollbar is showing in IE."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.5.1"
	          ),
	          " - Loader progressive wording."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.5.1"
	          ),
	          " - Dropdown menu buttons."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.4.1"
	          ),
	          " - Scrollable tabs."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.4.1"
	          ),
	          " - Tab events for adding/removing tabs dynamically."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.4.1"
	          ),
	          " - Blue table theme."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.3.1"
	          ),
	          " - New attention and box alerts."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.3.0"
	          ),
	          " - New modal layout and style updates"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.2.4"
	          ),
	          " - Added new form, button and tab styles."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.2.2"
	          ),
	          " - Added in new theme colours."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.2.1"
	          ),
	          " - Added branded icon fonts."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.2.0"
	          ),
	          " - Added new top-level navigation and cards."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.1.5"
	          ),
	          " - Added new hide classes, application icons, transparent button styles."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.1.1"
	          ),
	          " - Added calendars and environment banners."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.14"
	          ),
	          " - Adding deferred option to loaders."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.13"
	          ),
	          " - Tab open/close extended to allow selectors."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.11"
	          ),
	          " - Adding auto close timeout for alerts."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.7"
	          ),
	          " \xA0 - NPM module preparation complete."
	        )
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null),
	    _get__("React").createElement(
	      "div",
	      { className: "grid grid--bleed" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-2" },
	        _get__("React").createElement(
	          "h4",
	          null,
	          "Bug Fixes"
	        )
	      ),
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-sm-11" },
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.6.1"
	          ),
	          " - Z-index issue with modals and dropdowns"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.6.1"
	          ),
	          " - Nav menu - add/remove child menu items not updating mobile menu"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.6.1"
	          ),
	          " - Dropdowns have list style by default"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.5.1"
	          ),
	          " - Modal display issue on IE"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.5.1"
	          ),
	          " - Required field marker misplaced when modal is scrolled"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.4.1"
	          ),
	          " - Navigation secondary items no longer cut off on small view port"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.1.2"
	          ),
	          " - Switched callouts from using outline to inset border to better align content"
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.13"
	          ),
	          " - Loaders will no longer stack if called multiple times."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.10"
	          ),
	          " - Improved error handling in JS modules."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.10"
	          ),
	          " - Documentation demo links no longer link anywhere."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.9"
	          ),
	          " \xA0 - Updates to inputs with icons and validation to bring inline with others."
	        ),
	        _get__("React").createElement(
	          "span",
	          null,
	          _get__("React").createElement(
	            "b",
	            null,
	            "1.0.7"
	          ),
	          " \xA0 - .table--rows and --columns not applying correctly fixed."
	        ),
	        _get__("React").createElement("br", null)
	      )
	    ),
	    _get__("React").createElement("hr", null)
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof ChangeLog === "undefined" ? "undefined" : _typeof(ChangeLog);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(ChangeLog, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(ChangeLog)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = BrowserCompatibility;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function BrowserCompatibility() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "anchor", id: "browserCompatibility" }),
	    _get__("React").createElement(
	      "div",
	      { className: "grid content--middle" },
	      _get__("React").createElement(
	        "div",
	        { className: "grid__col-md-12 grid__col--bleed" },
	        _get__("React").createElement(
	          "div",
	          { className: "grid" },
	          _get__("React").createElement(
	            "div",
	            { className: "swatch-card grid__col-sm-3 text--center grid--justify-center", style: { "backgroundColor": "#5CA446" } },
	            _get__("React").createElement(
	              "h1",
	              { className: "flush" },
	              "IE 10 +"
	            )
	          ),
	          _get__("React").createElement(
	            "div",
	            { className: "swatch-card grid__col-sm-3 text--center grid--justify-center", style: { "backgroundColor": "#52933f" } },
	            _get__("React").createElement(
	              "h1",
	              { className: "flush" },
	              "Chrome 50 +"
	            )
	          ),
	          _get__("React").createElement(
	            "div",
	            { className: "swatch-card grid__col-sm-3 text--center grid--justify-center", style: { "backgroundColor": "#498338" } },
	            _get__("React").createElement(
	              "h1",
	              { className: "flush" },
	              "Firefox 46 +"
	            )
	          ),
	          _get__("React").createElement(
	            "div",
	            { className: "swatch-card grid__col-sm-3 text--center grid--justify-center", style: { "backgroundColor": "#407231" } },
	            _get__("React").createElement(
	              "h1",
	              { className: "flush" },
	              "Safari 9.3 +"
	            )
	          )
	        )
	      )
	    )
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof BrowserCompatibility === "undefined" ? "undefined" : _typeof(BrowserCompatibility);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(BrowserCompatibility, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(BrowserCompatibility)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.toggleComponent = toggleComponent;
	exports.toggleStaticVersion = toggleStaticVersion;
	
	var _ActionTypes = __webpack_require__(882);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function toggleComponent(component, index) {
	  return {
	    type: _get__('types').TOGGLE_COMPONENT,
	    component: component,
	    index: index
	  };
	}
	
	function toggleStaticVersion(override) {
	  override = override ? override : null;
	  return {
	    type: _get__('types').TOGGLE_STATIC,
	    override: override
	  };
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'types':
	      return _filterWildcardImport__(types);
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	exports.default = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 882 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TOGGLE_COMPONENT = exports.TOGGLE_COMPONENT = 'TOGGLE_COMPONENT';
	var TOGGLE_STATIC = exports.TOGGLE_STATIC = 'TOGGLE_STATIC';

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(561);
	
	var _redux = __webpack_require__(571);
	
	var _Sidebar = __webpack_require__(675);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainMenu = __webpack_require__(677);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _DynamicSection = __webpack_require__(678);
	
	var _DynamicSection2 = _interopRequireDefault(_DynamicSection);
	
	var _actions = __webpack_require__(881);
	
	var ComponentActions = _interopRequireWildcard(_actions);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brand = function (_get__2) {
	  _inherits(Brand, _get__2);
	
	  function Brand(_ref) {
	    var components = _ref.components;
	
	    _classCallCheck(this, Brand);
	
	    return _possibleConstructorReturn(this, (Brand.__proto__ || Object.getPrototypeOf(Brand)).call(this));
	  }
	
	  _createClass(Brand, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(function () {
	        _get__('commonUI').initializeNavigation();
	        _get__('initPlugins')();
	      }, 0);
	    }
	  }, {
	    key: 'getFilteredContent',
	    value: function getFilteredContent(components) {
	      return components.Brand;
	    }
	  }, {
	    key: 'renderMainMenu',
	    value: function renderMainMenu(components, staticVersion) {
	      return _get__('React').createElement(_get__('MainMenu'), { components: components, selected: 'Brand', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(filteredContent, staticVersion) {
	      return _get__('React').createElement(_get__('Sidebar'), { sections: filteredContent, selected: 'Brand', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var components = this.props.components;
	
	      var staticVersion = this.props.config.staticVersion;
	      var filteredContent = this.getFilteredContent(components);
	
	      return _get__('React').createElement(
	        'div',
	        null,
	        this.renderMainMenu(components, staticVersion),
	        this.renderSidebar(filteredContent, staticVersion),
	        _get__('React').createElement(
	          'div',
	          { id: 'main', className: 'content' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid' },
	            _get__('React').createElement(
	              'div',
	              { className: 'grid__col-sm-12 main' },
	              filteredContent.map(function (object, index) {
	                return _get__('React').createElement(_get__('DynamicSection'), {
	                  key: object.template,
	                  sectionName: object.template,
	                  onIncludeClick: function onIncludeClick() {
	                    return _this2.handleIncludeClick('Brand', index, object.include);
	                  },
	                  included: object.include,
	                  staticVersion: staticVersion });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Brand;
	}(_get__('Component'));
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: _get__('bindActionCreators')(_get__('ComponentActions'), dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return { components: state.components, config: state.config };
	}
	
	var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Brand'));
	
	exports.default = _DefaultExportValue;

	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;

	    case 'initPlugins':
	      return _utils.initPlugins;

	    case 'Component':
	      return _react.Component;

	    case 'bindActionCreators':
	      return _redux.bindActionCreators;

	    case 'ComponentActions':
	      return _filterWildcardImport__(ComponentActions);

	    case 'connect':
	      return _reactRedux.connect;

	    case 'mapStateToProps':
	      return mapStateToProps;

	    case 'mapDispatchToProps':
	      return mapDispatchToProps;

	    case 'Brand':
	      return Brand;

	    case 'React':
	      return _react2.default;

	    case 'MainMenu':
	      return _MainMenu2.default;

	    case 'Sidebar':
	      return _Sidebar2.default;

	    case 'DynamicSection':
	      return _DynamicSection2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(_DefaultExportValue, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(561);
	
	var _redux = __webpack_require__(571);
	
	var _Sidebar = __webpack_require__(675);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainMenu = __webpack_require__(677);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _DynamicSection = __webpack_require__(678);
	
	var _DynamicSection2 = _interopRequireDefault(_DynamicSection);
	
	var _actions = __webpack_require__(881);
	
	var ComponentActions = _interopRequireWildcard(_actions);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Core = function (_get__2) {
	  _inherits(Core, _get__2);
	
	  function Core(_ref) {
	    var components = _ref.components;
	
	    _classCallCheck(this, Core);
	
	    return _possibleConstructorReturn(this, (Core.__proto__ || Object.getPrototypeOf(Core)).call(this));
	  }
	
	  _createClass(Core, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(function () {
	        _get__('commonUI').initializeSplitPanel();
	        _get__('commonUI').initializeTabs();
	        _get__('commonUI').initializeTabs({ selector: '.js-tabs-lite', responsive: true });
	        _get__('commonUI').initializeTabs({ selector: '.js-scrollable-tabs', scrollable: true });
	        _get__('commonUI').initializeDropdown();
	        _get__('commonUI').initializeAlert();
	        _get__('commonUI').initializeAlert({ selector: '.js-inline-alert-pending', closeSelector: '.js-inline-alert__close', autoCloseTime: null, inline: true, minimisedCellIndex: 2 });
	        _get__('commonUI').initializeAlert({ selector: '.js-inline-alert', closeSelector: '.js-inline-alert__close', autoCloseTime: null, inline: true });
	        _get__('commonUI').initializeTable();
	        _get__('commonUI').initializeNavigation();
	        _get__('commonUI').initializeSearch();
	        _get__('commonUI').initializeAccordion();
	        _get__('commonUI').initializeTooltip();
	        _get__('commonUI').initializeTooltip({
	          selector: '.tooltip-selector--light',
	          theme: 'light'
	        });
	        _get__('commonUI').initializeTooltip({
	          selector: '.tooltip-selector--alternative',
	          theme: 'alternative'
	        });
	        _get__('commonUI').initializeTooltip({
	          selector: '.tooltip-selector--white',
	          theme: 'white'
	        });
	        _get__('commonUI').initializePagination();
	        _get__('commonUI').initializeModal();
	        _get__('commonUI').initializeTable({
	          selector: '.js-table-reorder',
	          tableReorder: 'js-table-reorder',
	          overlayElement: '.example-overlay',
	          trigger: 'trigger-one'
	        });
	        _get__('commonUI').initializeTable({
	          selector: '.js-table--detail',
	          detailViewType: 'detailedView',
	          detailViewSelector: '.js-table-secondary-view',
	          detailViewDismissSelector: '.js-table-secondary-view--dismiss'
	        });
	        _get__('commonUI').initializeTable({
	          selector: '.js-table-detail-expanded',
	          detailViewType: 'expandedRow',
	          detailViewSelector: '.js-table-detail-expand-trigger'
	        });
	        _get__('commonUI').initializeTable({
	          selector: '.js-table-detail-stacked',
	          detailViewType: 'stackedRow',
	          detailViewSelector: '.js-table-detail-stacked-trigger'
	        });
	        _get__('commonUI').initializeTable({
	          selector: '.sample-edit'
	        });
	        _get__('commonUI').initializeDrawer('.example-drawer', {
	          trigger: '.drawer-example-button'
	        });
	        _get__('commonUI').initializeDrawer('.example-drawer-left-small', {
	          trigger: '.drawer-left-small-example-button'
	        });
	        _get__('commonUI').initializeDrawer('.example-drawer-large', {
	          trigger: '.drawer-large-example-button'
	        });
	        _get__('commonUI').initializeDrawer('.example-drawer-xlarge', {
	          trigger: '.drawer-xlarge-example-button'
	        });
	        _get__('commonUI').initializeDrawer('.example-drawer-events', { trigger: '.drawer-events-example-button' });
	
	        _get__('commonUI').initializeDrawer('.example-drawer-tabbed', {
	          tabbed: true,
	          trigger: '.js-drawer-bottom-toggle'
	        });
	        _get__('commonUI').initializeDrawer('.example-drawer-tabbed-alt', {
	          tabbed: true,
	          trigger: '.js-alt-drawer-bottom-toggle'
	        });
	        _get__('commonUI').initializeButtonGroup();
	        _get__('commonUI').initializeAlert({
	          selector: '.alert--update-browser',
	          updatedBrowser: {
	            chrome: '73.0.0',
	            safari: '13.0.0',
	            firefox: '66.0.0',
	            ie: '12.0.0'
	          }
	        });
	        _get__('commonUI').initializeModal({
	          selector: '.delete-row-modal',
	          clickElementSelector: '.delete-row'
	        });
	
	        var eventsExampleModal = document.getElementsByClassName('events-example-modal')[0];
	        eventsExampleModal.addEventListener('show.commonui.modal', function () {
	          console.log('modal show');
	        });
	        eventsExampleModal.addEventListener('hide.commonui.modal', function () {
	          console.log('modal hide');
	        });
	        eventsExampleModal.addEventListener('positive.commonui.modal', function () {
	          console.log('modal positive');
	        });
	        eventsExampleModal.addEventListener('negative.commonui.modal', function () {
	          console.log('modal negative');
	        });
	
	        var eventsDrawerExample = document.getElementsByClassName('example-drawer-events')[0];
	        eventsDrawerExample.addEventListener('show.commonui.drawer', function () {
	          console.log('drawer show');
	        });
	        eventsDrawerExample.addEventListener('hide.commonui.drawer', function () {
	          console.log('drawer hide');
	        });
	        eventsDrawerExample.addEventListener('positive.commonui.drawer', function () {
	          console.log('drawer positive');
	        });
	        eventsDrawerExample.addEventListener('negative.commonui.drawer', function () {
	          console.log('drawer negative');
	        });
	        var tableReorderExample = document.getElementsByClassName('js-table-reorder')[0];
	        tableReorderExample.addEventListener('apply.commonui.reorderTable', function (event) {
	          console.log('Saved Table: ', event.detail);
	        });
	        _get__('initPlugins')();
	      }, 0);
	    }
	  }, {
	    key: 'getFilteredContent',
	    value: function getFilteredContent(components) {
	      return components.Core;
	    }
	  }, {
	    key: 'renderMainMenu',
	    value: function renderMainMenu(components, staticVersion) {
	      return _get__('React').createElement(_get__('MainMenu'), { components: components, staticVersion: staticVersion, selected: 'Core' });
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(filteredContent) {
	      return _get__('React').createElement(_get__('Sidebar'), { sections: filteredContent, selected: 'Core' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var components = this.props.components;
	
	      var staticVersion = this.props.config.staticVersion;
	      var filteredContent = this.getFilteredContent(components);
	      return _get__('React').createElement(
	        'div',
	        null,
	        this.renderMainMenu(components, staticVersion),
	        this.renderSidebar(filteredContent),
	        _get__('React').createElement(
	          'div',
	          { id: 'main', className: 'content' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid' },
	            _get__('React').createElement(
	              'div',
	              { className: 'grid__col-sm-12 main' },
	              filteredContent.map(function (object, index) {
	                return _get__('React').createElement(_get__('DynamicSection'), {
	                  key: object.template,
	                  sectionName: object.template,
	                  staticVersion: staticVersion });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Core;
	}(_get__('Component'));
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: _get__('bindActionCreators')(_get__('ComponentActions'), dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return { components: state.components, config: state.config };
	}
	
	var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Core'));
	
	exports.default = _DefaultExportValue;

	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;

	    case 'initPlugins':
	      return _utils.initPlugins;

	    case 'Component':
	      return _react.Component;

	    case 'bindActionCreators':
	      return _redux.bindActionCreators;

	    case 'ComponentActions':
	      return _filterWildcardImport__(ComponentActions);

	    case 'connect':
	      return _reactRedux.connect;

	    case 'mapStateToProps':
	      return mapStateToProps;

	    case 'mapDispatchToProps':
	      return mapDispatchToProps;

	    case 'Core':
	      return Core;

	    case 'React':
	      return _react2.default;

	    case 'MainMenu':
	      return _MainMenu2.default;

	    case 'Sidebar':
	      return _Sidebar2.default;

	    case 'DynamicSection':
	      return _DynamicSection2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(_DefaultExportValue, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(561);
	
	var _redux = __webpack_require__(571);
	
	var _Sidebar = __webpack_require__(675);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainMenu = __webpack_require__(677);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _DynamicSection = __webpack_require__(678);
	
	var _DynamicSection2 = _interopRequireDefault(_DynamicSection);
	
	var _actions = __webpack_require__(881);
	
	var ComponentActions = _interopRequireWildcard(_actions);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Components = function (_get__2) {
	  _inherits(Components, _get__2);
	
	  function Components(_ref) {
	    var components = _ref.components;
	
	    _classCallCheck(this, Components);
	
	    return _possibleConstructorReturn(this, (Components.__proto__ || Object.getPrototypeOf(Components)).call(this));
	  }
	
	  _createClass(Components, [{
	    key: 'handleIncludeClick',
	    value: function handleIncludeClick(component, index) {
	      this.props.actions.toggleComponent(component, index);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(function () {
	
	        _get__('commonUI').initializeNavigation();
	        _get__('commonUI').initializeDatepicker('#default', {});
	        _get__('commonUI').initializeDatepicker('#timepicker', {
	          enableTime: true,
	          dateFormat: 'Y-m-d H:i'
	        });
	        _get__('commonUI').initializeDatepicker('#range', {
	          mode: 'range'
	        });
	
	        $('.js-data-table').DataTable({
	          pagingType: 'full_numbers',
	          classes: {
	            sSortable: 'table-sort',
	            sSortAsc: 'table-sort table-sort--asc',
	            sSortDesc: 'table-sort table-sort--desc'
	          }
	        });
	
	        $('.js-carousel').slick({
	          dots: true,
	          fade: true,
	          cssEase: 'linear'
	        });
	        $('.datepicker').datepicker();
	
	        _get__('initPlugins')();
	      }, 0);
	    }
	  }, {
	    key: 'getFilteredContent',
	    value: function getFilteredContent(components) {
	      return components.Components;
	    }
	  }, {
	    key: 'renderMainMenu',
	    value: function renderMainMenu(components, staticVersion) {
	      return _get__('React').createElement(_get__('MainMenu'), { components: components, selected: 'Components', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(filteredContent, staticVersion) {
	      return _get__('React').createElement(_get__('Sidebar'), { sections: filteredContent, selected: 'Components', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var components = this.props.components;
	
	      var staticVersion = this.props.config.staticVersion;
	      var filteredContent = this.getFilteredContent(components);
	      return _get__('React').createElement(
	        'div',
	        null,
	        this.renderMainMenu(components, staticVersion),
	        this.renderSidebar(filteredContent, staticVersion),
	        _get__('React').createElement(
	          'div',
	          { id: 'main', className: 'content' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid' },
	            _get__('React').createElement(
	              'div',
	              { className: 'grid__col-sm-12 main' },
	              filteredContent.map(function (object, index) {
	                return _get__('React').createElement(_get__('DynamicSection'), {
	                  key: object.template,
	                  sectionName: object.template,
	                  onIncludeClick: function onIncludeClick() {
	                    return _this2.handleIncludeClick('Components', index, object.include);
	                  },
	                  included: object.include,
	                  staticVersion: staticVersion });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Components;
	}(_get__('Component'));
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: _get__('bindActionCreators')(_get__('ComponentActions'), dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return { components: state.components, config: state.config };
	}
	
	var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Components'));
	
	exports.default = _DefaultExportValue;

	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;

	    case 'initPlugins':
	      return _utils.initPlugins;

	    case 'Component':
	      return _react.Component;

	    case 'bindActionCreators':
	      return _redux.bindActionCreators;

	    case 'ComponentActions':
	      return _filterWildcardImport__(ComponentActions);

	    case 'connect':
	      return _reactRedux.connect;

	    case 'mapStateToProps':
	      return mapStateToProps;

	    case 'mapDispatchToProps':
	      return mapDispatchToProps;

	    case 'Components':
	      return Components;

	    case 'React':
	      return _react2.default;

	    case 'MainMenu':
	      return _MainMenu2.default;

	    case 'Sidebar':
	      return _Sidebar2.default;

	    case 'DynamicSection':
	      return _DynamicSection2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(_DefaultExportValue, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(561);
	
	var _redux = __webpack_require__(571);
	
	var _Sidebar = __webpack_require__(675);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainMenu = __webpack_require__(677);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _DynamicSection = __webpack_require__(678);
	
	var _DynamicSection2 = _interopRequireDefault(_DynamicSection);
	
	var _actions = __webpack_require__(881);
	
	var ComponentActions = _interopRequireWildcard(_actions);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Layouts = function (_get__2) {
	  _inherits(Layouts, _get__2);
	
	  function Layouts(_ref) {
	    var components = _ref.components;
	
	    _classCallCheck(this, Layouts);
	
	    return _possibleConstructorReturn(this, (Layouts.__proto__ || Object.getPrototypeOf(Layouts)).call(this));
	  }
	
	  _createClass(Layouts, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(function () {
	        _get__('commonUI').initializeNavigation();
	        _get__('initPlugins')();
	      }, 0);
	    }
	  }, {
	    key: 'getFilteredContent',
	    value: function getFilteredContent(components) {
	      return components.Layouts;
	    }
	  }, {
	    key: 'renderMainMenu',
	    value: function renderMainMenu(components, staticVersion) {
	      return _get__('React').createElement(_get__('MainMenu'), { components: components, selected: 'Layouts', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(filteredContent, staticVersion) {
	      return _get__('React').createElement(_get__('Sidebar'), { sections: filteredContent, selected: 'Layouts', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var components = this.props.components;
	
	      var staticVersion = this.props.config.staticVersion;
	      var filteredContent = this.getFilteredContent(components);
	      return _get__('React').createElement(
	        'div',
	        null,
	        this.renderMainMenu(components, staticVersion),
	        this.renderSidebar(filteredContent, staticVersion),
	        _get__('React').createElement(
	          'div',
	          { id: 'main', className: 'content' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid' },
	            _get__('React').createElement(
	              'div',
	              { className: 'grid__col-sm-12 main layouts' },
	              filteredContent.map(function (object, index) {
	                return _get__('React').createElement(_get__('DynamicSection'), {
	                  key: object.template,
	                  sectionName: object.template,
	                  onIncludeClick: function onIncludeClick() {
	                    return _this2.handleIncludeClick('Layouts', index, object.include);
	                  },
	                  included: object.include,
	                  staticVersion: staticVersion });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Layouts;
	}(_get__('Component'));
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: _get__('bindActionCreators')(_get__('ComponentActions'), dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return { components: state.components, config: state.config };
	}
	
	var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Layouts'));
	
	exports.default = _DefaultExportValue;

	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;

	    case 'initPlugins':
	      return _utils.initPlugins;

	    case 'Component':
	      return _react.Component;

	    case 'bindActionCreators':
	      return _redux.bindActionCreators;

	    case 'ComponentActions':
	      return _filterWildcardImport__(ComponentActions);

	    case 'connect':
	      return _reactRedux.connect;

	    case 'mapStateToProps':
	      return mapStateToProps;

	    case 'mapDispatchToProps':
	      return mapDispatchToProps;

	    case 'Layouts':
	      return Layouts;

	    case 'React':
	      return _react2.default;

	    case 'MainMenu':
	      return _MainMenu2.default;

	    case 'Sidebar':
	      return _Sidebar2.default;

	    case 'DynamicSection':
	      return _DynamicSection2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(_DefaultExportValue, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(561);
	
	var _redux = __webpack_require__(571);
	
	var _Sidebar = __webpack_require__(675);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainMenu = __webpack_require__(677);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _DynamicSection = __webpack_require__(678);
	
	var _DynamicSection2 = _interopRequireDefault(_DynamicSection);
	
	var _actions = __webpack_require__(881);
	
	var ComponentActions = _interopRequireWildcard(_actions);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Themes = function (_get__2) {
	  _inherits(Themes, _get__2);
	
	  function Themes(_ref) {
	    var components = _ref.components;
	
	    _classCallCheck(this, Themes);
	
	    return _possibleConstructorReturn(this, (Themes.__proto__ || Object.getPrototypeOf(Themes)).call(this));
	  }
	
	  _createClass(Themes, [{
	    key: 'handleIncludeClick',
	    value: function handleIncludeClick(component, index) {
	      this.props.actions.toggleComponent(component, index);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(function () {
	        _get__('commonUI').initializeNavigation();
	        _get__('initPlugins')();
	      }, 0);
	    }
	  }, {
	    key: 'getFilteredContent',
	    value: function getFilteredContent(components) {
	      //    return components.GettingStarted
	      return components.Themes;
	    }
	  }, {
	    key: 'renderMainMenu',
	    value: function renderMainMenu(components, staticVersion) {
	      return _get__('React').createElement(_get__('MainMenu'), { components: components, selected: 'Themes', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(filteredContent, staticVersion) {
	      return _get__('React').createElement(_get__('Sidebar'), { sections: filteredContent, selected: 'Themes', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var components = this.props.components;
	
	      var staticVersion = this.props.config.staticVersion;
	      var filteredContent = this.getFilteredContent(components);
	      return _get__('React').createElement(
	        'div',
	        null,
	        this.renderMainMenu(components, staticVersion),
	        this.renderSidebar(filteredContent, staticVersion),
	        _get__('React').createElement(
	          'div',
	          { id: 'main', className: 'content' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid' },
	            _get__('React').createElement(
	              'div',
	              { className: 'grid__col-sm-12 main' },
	              filteredContent.map(function (object, index) {
	                return _get__('React').createElement(_get__('DynamicSection'), {
	                  key: object.template,
	                  sectionName: object.template,
	                  onIncludeClick: function onIncludeClick() {
	                    return _this2.handleIncludeClick('Themes', index, object.include);
	                  },
	                  included: object.include,
	                  staticVersion: staticVersion });
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Themes;
	}(_get__('Component'));
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: _get__('bindActionCreators')(_get__('ComponentActions'), dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return { components: state.components, config: state.config };
	}
	
	var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('Themes'));
	
	exports.default = _DefaultExportValue;

	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;

	    case 'initPlugins':
	      return _utils.initPlugins;

	    case 'Component':
	      return _react.Component;

	    case 'bindActionCreators':
	      return _redux.bindActionCreators;

	    case 'ComponentActions':
	      return _filterWildcardImport__(ComponentActions);

	    case 'connect':
	      return _reactRedux.connect;

	    case 'mapStateToProps':
	      return mapStateToProps;

	    case 'mapDispatchToProps':
	      return mapDispatchToProps;

	    case 'Themes':
	      return Themes;

	    case 'React':
	      return _react2.default;

	    case 'MainMenu':
	      return _MainMenu2.default;

	    case 'Sidebar':
	      return _Sidebar2.default;

	    case 'DynamicSection':
	      return _DynamicSection2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(_DefaultExportValue, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(561);
	
	var _redux = __webpack_require__(571);
	
	var _Sidebar = __webpack_require__(675);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _MainMenu = __webpack_require__(677);
	
	var _MainMenu2 = _interopRequireDefault(_MainMenu);
	
	var _BuildDetail = __webpack_require__(876);
	
	var _BuildDetail2 = _interopRequireDefault(_BuildDetail);
	
	var _Installation = __webpack_require__(877);
	
	var _Installation2 = _interopRequireDefault(_Installation);
	
	var _Support = __webpack_require__(878);
	
	var _Support2 = _interopRequireDefault(_Support);
	
	var _DarkTheme = __webpack_require__(889);
	
	var _DarkTheme2 = _interopRequireDefault(_DarkTheme);
	
	var _ChangeLog = __webpack_require__(879);
	
	var _ChangeLog2 = _interopRequireDefault(_ChangeLog);
	
	var _BrowserCompatibility = __webpack_require__(880);
	
	var _BrowserCompatibility2 = _interopRequireDefault(_BrowserCompatibility);
	
	var _actions = __webpack_require__(881);
	
	var ComponentActions = _interopRequireWildcard(_actions);
	
	var _commonUI = __webpack_require__(6);
	
	var _commonUI2 = _interopRequireDefault(_commonUI);
	
	var _utils = __webpack_require__(808);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GettingStarted = function (_get__2) {
	  _inherits(GettingStarted, _get__2);
	
	  function GettingStarted(_ref) {
	    var components = _ref.components;
	
	    _classCallCheck(this, GettingStarted);
	
	    return _possibleConstructorReturn(this, (GettingStarted.__proto__ || Object.getPrototypeOf(GettingStarted)).call(this));
	  }
	
	  _createClass(GettingStarted, [{
	    key: 'handleIncludeClick',
	    value: function handleIncludeClick(component, index) {
	      this.props.actions.toggleComponent(component, index);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      setTimeout(function () {
	        _get__('commonUI').initializeNavigation();
	        _get__('initPlugins')();
	      }, 0);
	    }
	  }, {
	    key: 'getFilteredContent',
	    value: function getFilteredContent(components) {
	      //    return components.GettingStarted
	      return components["Getting Started"];
	    }
	  }, {
	    key: 'renderMainMenu',
	    value: function renderMainMenu(components, staticVersion) {
	      return _get__('React').createElement(_get__('MainMenu'), { components: components, selected: 'GettingStarted', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'renderSidebar',
	    value: function renderSidebar(filteredContent, staticVersion) {
	      return _get__('React').createElement(_get__('Sidebar'), { sections: filteredContent, selected: 'GettingStarted', staticVersion: staticVersion });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var components = this.props.components;
	
	      var staticVersion = this.props.config.staticVersion;
	      var filteredContent = this.getFilteredContent(components);
	
	      return _get__('React').createElement(
	        'div',
	        null,
	        this.renderMainMenu(components, staticVersion),
	        this.renderSidebar(filteredContent, staticVersion),
	        _get__('React').createElement(
	          'div',
	          { id: 'main', className: 'content' },
	          _get__('React').createElement(
	            'div',
	            { className: 'grid' },
	            _get__('React').createElement(
	              'div',
	              { className: 'grid__col-sm-12 main' },
	              _get__('React').createElement(_get__('Installation'), {
	                staticVersion: staticVersion }),
	              _get__('React').createElement(_get__('DarkTheme'), null),
	              staticVersion === false ? _get__('React').createElement(_get__('Support'), null) : '',
	              _get__('React').createElement(_get__('ChangeLog'), {
	                staticVersion: staticVersion }),
	              staticVersion === false ? _get__('React').createElement(_get__('BuildDetail'), {
	                components: components,
	                onIncludeClick: function onIncludeClick(component, index) {
	                  return _this2.handleIncludeClick(component, index);
	                } }) : ''
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return GettingStarted;
	}(_get__('Component'));
	
	function mapDispatchToProps(dispatch) {
	  return {
	    actions: _get__('bindActionCreators')(_get__('ComponentActions'), dispatch)
	  };
	}
	
	function mapStateToProps(state) {
	  return { components: state.components, config: state.config };
	}
	
	var _DefaultExportValue = _get__('connect')(_get__('mapStateToProps'), _get__('mapDispatchToProps'))(_get__('GettingStarted'));
	
	exports.default = _DefaultExportValue;

	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}

	;
	var _RewireModuleId__ = null;

	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();

	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }

	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }

	  return _RewireModuleId__;
	}

	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }

	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}

	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();

	  var registry = _getRewireRegistry__();

	  var rewireData = registry[moduleId];

	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }

	  return rewireData;
	}

	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();

	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();

	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};

	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }

	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();

	function _get__(variableName) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];

	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}

	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'commonUI':
	      return _commonUI2.default;

	    case 'initPlugins':
	      return _utils.initPlugins;

	    case 'Component':
	      return _react.Component;

	    case 'bindActionCreators':
	      return _redux.bindActionCreators;

	    case 'ComponentActions':
	      return _filterWildcardImport__(ComponentActions);

	    case 'connect':
	      return _reactRedux.connect;

	    case 'mapStateToProps':
	      return mapStateToProps;

	    case 'mapDispatchToProps':
	      return mapDispatchToProps;

	    case 'GettingStarted':
	      return GettingStarted;

	    case 'React':
	      return _react2.default;

	    case 'MainMenu':
	      return _MainMenu2.default;

	    case 'Sidebar':
	      return _Sidebar2.default;

	    case 'Installation':
	      return _Installation2.default;

	    case 'DarkTheme':
	      return _DarkTheme2.default;

	    case 'Support':
	      return _Support2.default;

	    case 'ChangeLog':
	      return _ChangeLog2.default;

	    case 'BuildDetail':
	      return _BuildDetail2.default;
	  }

	  return undefined;
	}

	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}

	function _set_original__(variableName, _value) {
	  switch (variableName) {}

	  return undefined;
	}

	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);

	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

	  _assign__(variableName, newValue);

	  return prefix ? newValue : oldValue;
	}

	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();

	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }

	    return function () {
	      _reset__(variableName);
	    };
	  }
	}

	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();

	  delete rewireData[variableName];

	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }

	  ;
	}

	function _with__(object) {
	  var rewireData = _getRewiredData__();

	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};

	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }

	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();

	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }

	    return result;
	  };
	}

	var _typeOfOriginalExport = typeof _DefaultExportValue === 'undefined' ? 'undefined' : _typeof(_DefaultExportValue);

	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(_DefaultExportValue, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}

	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(_DefaultExportValue)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	function _filterWildcardImport__() {
	  var wildcardImport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var validPropertyNames = Object.keys(wildcardImport).filter(function (propertyName) {
	    return propertyName !== '__get__' && propertyName !== '__set__' && propertyName !== '__reset__' && propertyName !== '__with__' && propertyName !== '__GetDependency__' && propertyName !== '__Rewire__' && propertyName !== '__ResetDependency__' && propertyName !== '__RewireAPI__';
	  });
	  return validPropertyNames.reduce(function (filteredWildcardImport, propertyName) {
	    filteredWildcardImport[propertyName] = wildcardImport[propertyName];
	    return filteredWildcardImport;
	  }, {});
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = DarkTheme;
	
	var _react = __webpack_require__(393);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DarkTheme() {
	  return _get__("React").createElement(
	    "section",
	    null,
	    _get__("React").createElement("a", { className: "darkTheme", id: "darkTheme" }),
	    _get__("React").createElement(
	      "h2",
	      null,
	      "Dark Theme"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "To utilise the Dark Theme varaints of dark grey and dark blue the HTML tag needs a ",
	      _get__("React").createElement(
	        "code",
	        null,
	        "data-theme"
	      ),
	      " data attribute added to it as follows"
	    ),
	    _get__("React").createElement(
	      "p",
	      null,
	      "HTML - Dark Grey"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<html lang=\"en\" data-theme=\"dark\">"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "HTML - Dark Blue"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<html lang=\"en\" data-theme=\"dark-blue\">"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "HTML - Default"
	    ),
	    _get__("React").createElement(
	      "pre",
	      null,
	      _get__("React").createElement(
	        "code",
	        { className: "language-html" },
	        "<html lang=\"en\" data-theme=\"default\">"
	      )
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement(
	      "p",
	      null,
	      "This data-theme can be manipulated via JS"
	    ),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("br", null),
	    _get__("React").createElement("hr", null)
	  );
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case "React":
	      return _react2.default;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === "undefined" ? "undefined" : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof DarkTheme === "undefined" ? "undefined" : _typeof(DarkTheme);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(DarkTheme, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(DarkTheme)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.config = exports.components = undefined;
	
	var _components2 = __webpack_require__(891);
	
	var _components3 = _interopRequireDefault(_components2);
	
	var _config2 = __webpack_require__(893);
	
	var _config3 = _interopRequireDefault(_config2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.components = _components3.default;
	exports.config = _config3.default;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	exports.default = components;
	
	var _ActionTypes = __webpack_require__(882);
	
	var _update = __webpack_require__(892);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
		'Home': [{
			'name': 'Intro',
			'anchor': '#intro',
			'template': 'Intro'
		}, {
			'name': 'Browser Compatibility',
			'anchor': '#browserCompatibility',
			'template': 'BrowserCompatibility'
		}],
		'Brand': [{
			'name': 'Typography',
			'anchor': '#typography',
			'template': 'Typography',
			'include': true
		}, {
			'name': 'Colors',
			'anchor': '#colors',
			'template': 'Colors',
			'include': true
		}, {
			'name': 'Logo',
			'anchor': '#logo',
			'template': 'Logo',
			'include': true
		}, {
			'name': 'App Icons',
			'anchor': '#appify',
			'template': 'Appify',
			'include': true
		}],
		'Core': [{
			'name': 'Grid',
			'anchor': '#grid',
			'template': 'Grid',
			'include': true
		}, {
			'name': 'Forms',
			'anchor': '#forms',
			'template': 'Forms',
			'include': true
		}, {
			'name': 'Dropzone',
			'anchor': '#dropzone',
			'template': 'Dropzone',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Buttons',
			'anchor': '#buttons',
			'template': 'Buttons',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Button Dropdowns',
			'anchor': '#button-dropdowns',
			'template': 'ButtonDropdowns',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Filters',
			'anchor': '#filters',
			'template': 'Filters',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Tables',
			'anchor': '#tables',
			'template': 'Tables',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Badges',
			'anchor': '#badges',
			'template': 'Badges',
			'include': true
		}, {
			'name': 'Alerts',
			'anchor': '#alerts',
			'template': 'Alerts',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Toasts',
			'anchor': '#toasts',
			'template': 'Toasts',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Tabs',
			'anchor': '#tabs',
			'template': 'Tabs',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Accordion',
			'anchor': '#accordion',
			'template': 'Accordion',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Wells',
			'anchor': '#wells',
			'template': 'Wells',
			'include': true,
			'optional': true
		}, {
			'name': 'Tooltips',
			'anchor': '#tooltips',
			'template': 'Tooltips',
			'include': true,
			'optional': true
		}, {
			'name': 'Countdown Timer',
			'anchor': '#countdown-timer',
			'template': 'CountdownTimer',
			'include': true,
			'optional': true
		}, {
			'name': 'Modals',
			'anchor': '#modals',
			'template': 'Modals',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Drawers',
			'anchor': '#drawers',
			'template': 'Drawers',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Pagination',
			'anchor': '#pagination',
			'template': 'Pagination',
			'include': true,
			'optional': true
		}, {
			'name': 'Panels',
			'anchor': '#panels',
			'template': 'Panels',
			'include': true,
			'optional': true
		}, {
			'name': 'Split Layout',
			'anchor': '#splitpanel',
			'template': 'SplitPanel',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Dismissable Sidebar Panel',
			'anchor': '#dismissablesidebarpanel',
			'template': 'DismissableSidebarPanel',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Navigation',
			'anchor': '#navigation',
			'template': 'Nav',
			'include': true,
			'js': true
		}, {
			'name': 'Search',
			'anchor': '#search',
			'template': 'Search',
			'include': true,
			'js': true
		}, {
			'name': 'Cards',
			'anchor': '#cards',
			'template': 'Cards',
			'include': true
		}, {
			'name': 'Toggles',
			'anchor': '#toggles',
			'template': 'Toggles',
			'include': true
		}, {
			'name': 'Wizard',
			'anchor': '#wizard',
			'template': 'Wizard',
			'include': true
		}, {
			'name': 'Loaders',
			'anchor': '#loaders',
			'template': 'Loaders',
			'include': true,
			'optional': true
		}, {
			'name': 'Icons',
			'anchor': '#icons',
			'template': 'Icons',
			'include': true,
			'optional': true
		}, {
			'name': 'Helpers',
			'anchor': '#helpers',
			'template': 'Helpers',
			'include': true,
			'optional': false
		}, {
			'name': 'Breakpoints',
			'anchor': '#breakpoints',
			'template': 'Breakpoints',
			'include': true,
			'optional': false
		}],
		'Components': [{
			'name': 'Date Picker',
			'anchor': '#datepicker',
			'template': 'Datepicker',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Callouts',
			'anchor': '#callouts',
			'template': 'Callouts',
			'include': true,
			'optional': true
		}, {
			'name': 'Media Objects',
			'anchor': '#mediaobjects',
			'template': 'Media',
			'include': true,
			'optional': true
		}, {
			'name': 'Carousel',
			'anchor': '#carousel',
			'template': 'Carousel',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Price Tick',
			'anchor': '#pricetick',
			'template': 'Tick',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Back to Top',
			'anchor': '#backToTop',
			'template': 'BackToTop',
			'include': true,
			'optional': false
		}, {
			'name': 'Breadcrumb',
			'anchor': '#breadcrumb',
			'template': 'Breadcrumb',
			'include': true,
			'optional': true
		}, {
			'name': 'Progress Indicators',
			'anchor': '#progress',
			'template': 'Progress',
			'include': true,
			'optional': true
		}, {
			'name': 'DataTables',
			'anchor': '#datatables',
			'template': 'DataTables',
			'js': true,
			'include': true,
			'optional': true
		}, {
			'name': 'Environment Banners',
			'anchor': '#environmentbanners',
			'template': 'EnvironmentBanners',
			'include': true,
			'optional': true
		}],
		'Layouts': [{
			'name': 'Grid Showcase',
			'anchor': '#grid',
			'template': 'LayoutsGrid'
		}, {
			'name': 'Marketing',
			'anchor': '#marketing',
			'template': 'LayoutsMarketing'
		}, {
			'name': 'EREP',
			'anchor': '#erep',
			'template': 'LayoutsEREP'
		}, {
			'name': 'Core UI',
			'anchor': '#core-ui',
			'template': 'LayoutsCoreUI'
		}, {
			'name': 'Sign In Page',
			'anchor': '#signin',
			'template': 'LayoutsSignIn'
		}, {
			'name': 'Update Browser',
			'anchor': '#updatebrowser',
			'template': 'LayoutsUpdateBrowser'
		}, {
			'name': 'Error Pages',
			'anchor': '#errors',
			'template': 'LayoutsErrors'
		}],
		'Themes': [{
			'name': 'Components Showcase',
			'anchor': '#componentsShowcase',
			'template': 'ComponentsShowcase'
		}, {
			'name': 'AG-Grid',
			'anchor': '#agGrid',
			'template': 'AgGrid'
		}],
		'Getting Started': [{
			'name': 'Installation',
			'anchor': '#installation',
			'template': 'Installation'
		}, {
			'name': 'Dark Theme',
			'anchor': '#darkTheme',
			'template': 'DarkTheme'
		}, {
			'name': 'Support',
			'anchor': '#support',
			'template': 'Support',
			'includeStatic': false
		}, {
			'name': 'Change Log',
			'anchor': '#changelog',
			'template': 'ChangeLog'
		}, {
			'name': 'Build',
			'anchor': '#build',
			'template': 'BuildDetail',
			'includeStatic': false
		}]
	};
	
	function components() {
		var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _get__('initialState');
		var action = arguments[1];
	
	
		switch (action.type) {
			case _get__('TOGGLE_COMPONENT'):
				var newState = _get__('update')(state, _defineProperty({}, action.component, _defineProperty({}, action.index, {
					include: {
						$set: state[action.component][action.index].include ? false : true
					}
				})));
				return newState;
			default:
				return state;
		}
	}
	
	function _getGlobalObject() {
		try {
			if (!!global) {
				return global;
			}
		} catch (e) {
			try {
				if (!!window) {
					return window;
				}
			} catch (e) {
				return this;
			}
		}
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
		if (_RewireModuleId__ === null) {
			var globalVariable = _getGlobalObject();
	
			if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
				globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
			}
	
			_RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
		}
	
		return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
			theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
		}
	
		return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
		var moduleId = _getRewireModuleId__();
	
		var registry = _getRewireRegistry__();
	
		var rewireData = registry[moduleId];
	
		if (!rewireData) {
			registry[moduleId] = Object.create(null);
			rewireData = registry[moduleId];
		}
	
		return rewireData;
	}
	
	(function registerResetAll() {
		var theGlobalVariable = _getGlobalObject();
	
		if (!theGlobalVariable['__rewire_reset_all__']) {
			theGlobalVariable['__rewire_reset_all__'] = function () {
				theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
			};
		}
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
		function addPropertyToAPIObject(name, value) {
			Object.defineProperty(_RewireAPI__, name, {
				value: value,
				enumerable: false,
				configurable: true
			});
		}
	
		addPropertyToAPIObject('__get__', _get__);
		addPropertyToAPIObject('__GetDependency__', _get__);
		addPropertyToAPIObject('__Rewire__', _set__);
		addPropertyToAPIObject('__set__', _set__);
		addPropertyToAPIObject('__reset__', _reset__);
		addPropertyToAPIObject('__ResetDependency__', _reset__);
		addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _get_original__(variableName);
		} else {
			var value = rewireData[variableName];
	
			if (value === INTENTIONAL_UNDEFINED) {
				return undefined;
			} else {
				return value;
			}
		}
	}
	
	function _get_original__(variableName) {
		switch (variableName) {
			case 'initialState':
				return initialState;
	
			case 'TOGGLE_COMPONENT':
				return _ActionTypes.TOGGLE_COMPONENT;
	
			case 'update':
				return _update2.default;
		}
	
		return undefined;
	}
	
	function _assign__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if (rewireData[variableName] === undefined) {
			return _set_original__(variableName, value);
		} else {
			return rewireData[variableName] = value;
		}
	}
	
	function _set_original__(variableName, _value) {
		switch (variableName) {}
	
		return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
		var oldValue = _get__(variableName);
	
		var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
		_assign__(variableName, newValue);
	
		return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
		var rewireData = _getRewiredData__();
	
		if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
			Object.keys(variableName).forEach(function (name) {
				rewireData[name] = variableName[name];
			});
			return function () {
				Object.keys(variableName).forEach(function (name) {
					_reset__(variableName);
				});
			};
		} else {
			if (value === undefined) {
				rewireData[variableName] = INTENTIONAL_UNDEFINED;
			} else {
				rewireData[variableName] = value;
			}
	
			return function () {
				_reset__(variableName);
			};
		}
	}
	
	function _reset__(variableName) {
		var rewireData = _getRewiredData__();
	
		delete rewireData[variableName];
	
		if (Object.keys(rewireData).length == 0) {
			delete _getRewireRegistry__()[_getRewireModuleId__];
		}
	
		;
	}
	
	function _with__(object) {
		var rewireData = _getRewiredData__();
	
		var rewiredVariableNames = Object.keys(object);
		var previousValues = {};
	
		function reset() {
			rewiredVariableNames.forEach(function (variableName) {
				rewireData[variableName] = previousValues[variableName];
			});
		}
	
		return function (callback) {
			rewiredVariableNames.forEach(function (variableName) {
				previousValues[variableName] = rewireData[variableName];
				rewireData[variableName] = object[variableName];
			});
			var result = callback();
	
			if (!!result && typeof result.then == 'function') {
				result.then(reset).catch(reset);
			} else {
				reset();
			}
	
			return result;
		};
	}
	
	var _typeOfOriginalExport = typeof components === 'undefined' ? 'undefined' : _typeof(components);
	
	function addNonEnumerableProperty(name, value) {
		Object.defineProperty(components, name, {
			value: value,
			enumerable: false,
			configurable: true
		});
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(components)) {
		addNonEnumerableProperty('__get__', _get__);
		addNonEnumerableProperty('__GetDependency__', _get__);
		addNonEnumerableProperty('__Rewire__', _set__);
		addNonEnumerableProperty('__set__', _set__);
		addNonEnumerableProperty('__reset__', _reset__);
		addNonEnumerableProperty('__ResetDependency__', _reset__);
		addNonEnumerableProperty('__with__', _with__);
		addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(397),
	    _assign = __webpack_require__(395);
	
	var invariant = __webpack_require__(403);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return _assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = '$push';
	var COMMAND_UNSHIFT = '$unshift';
	var COMMAND_SPLICE = '$splice';
	var COMMAND_SET = '$set';
	var COMMAND_MERGE = '$merge';
	var COMMAND_APPLY = '$apply';
	
	var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function (command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
	  var specValue = spec[command];
	  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
	}
	
	/**
	 * Returns a updated shallow copy of an object without mutating the original.
	 * See https://facebook.github.io/react/docs/update.html for details.
	 */
	function update(value, spec) {
	  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
	    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
	    _assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function (item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function (item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
	    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	    spec[COMMAND_SPLICE].forEach(function (args) {
	      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.__RewireAPI__ = exports.__ResetDependency__ = exports.__set__ = exports.__Rewire__ = exports.__GetDependency__ = exports.__get__ = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = config;
	
	var _ActionTypes = __webpack_require__(882);
	
	var _update = __webpack_require__(892);
	
	var _update2 = _interopRequireDefault(_update);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	  staticVersion: false
	};
	
	function config() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _get__('initialState');
	  var action = arguments[1];
	
	
	  switch (action.type) {
	    case _get__('TOGGLE_STATIC'):
	      var isStatic = action.override ? action.override : !state.staticVersion;
	      var newState = _extends({}, state, { staticVersion: isStatic });
	      return newState;
	    default:
	      return state;
	  }
	}
	
	function _getGlobalObject() {
	  try {
	    if (!!global) {
	      return global;
	    }
	  } catch (e) {
	    try {
	      if (!!window) {
	        return window;
	      }
	    } catch (e) {
	      return this;
	    }
	  }
	}
	
	;
	var _RewireModuleId__ = null;
	
	function _getRewireModuleId__() {
	  if (_RewireModuleId__ === null) {
	    var globalVariable = _getGlobalObject();
	
	    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
	      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
	    }
	
	    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
	  }
	
	  return _RewireModuleId__;
	}
	
	function _getRewireRegistry__() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
	    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	  }
	
	  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
	}
	
	function _getRewiredData__() {
	  var moduleId = _getRewireModuleId__();
	
	  var registry = _getRewireRegistry__();
	
	  var rewireData = registry[moduleId];
	
	  if (!rewireData) {
	    registry[moduleId] = Object.create(null);
	    rewireData = registry[moduleId];
	  }
	
	  return rewireData;
	}
	
	(function registerResetAll() {
	  var theGlobalVariable = _getGlobalObject();
	
	  if (!theGlobalVariable['__rewire_reset_all__']) {
	    theGlobalVariable['__rewire_reset_all__'] = function () {
	      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
	    };
	  }
	})();
	
	var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
	var _RewireAPI__ = {};
	
	(function () {
	  function addPropertyToAPIObject(name, value) {
	    Object.defineProperty(_RewireAPI__, name, {
	      value: value,
	      enumerable: false,
	      configurable: true
	    });
	  }
	
	  addPropertyToAPIObject('__get__', _get__);
	  addPropertyToAPIObject('__GetDependency__', _get__);
	  addPropertyToAPIObject('__Rewire__', _set__);
	  addPropertyToAPIObject('__set__', _set__);
	  addPropertyToAPIObject('__reset__', _reset__);
	  addPropertyToAPIObject('__ResetDependency__', _reset__);
	  addPropertyToAPIObject('__with__', _with__);
	})();
	
	function _get__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _get_original__(variableName);
	  } else {
	    var value = rewireData[variableName];
	
	    if (value === INTENTIONAL_UNDEFINED) {
	      return undefined;
	    } else {
	      return value;
	    }
	  }
	}
	
	function _get_original__(variableName) {
	  switch (variableName) {
	    case 'initialState':
	      return initialState;
	
	    case 'TOGGLE_STATIC':
	      return _ActionTypes.TOGGLE_STATIC;
	  }
	
	  return undefined;
	}
	
	function _assign__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if (rewireData[variableName] === undefined) {
	    return _set_original__(variableName, value);
	  } else {
	    return rewireData[variableName] = value;
	  }
	}
	
	function _set_original__(variableName, _value) {
	  switch (variableName) {}
	
	  return undefined;
	}
	
	function _update_operation__(operation, variableName, prefix) {
	  var oldValue = _get__(variableName);
	
	  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
	
	  _assign__(variableName, newValue);
	
	  return prefix ? newValue : oldValue;
	}
	
	function _set__(variableName, value) {
	  var rewireData = _getRewiredData__();
	
	  if ((typeof variableName === 'undefined' ? 'undefined' : _typeof(variableName)) === 'object') {
	    Object.keys(variableName).forEach(function (name) {
	      rewireData[name] = variableName[name];
	    });
	    return function () {
	      Object.keys(variableName).forEach(function (name) {
	        _reset__(variableName);
	      });
	    };
	  } else {
	    if (value === undefined) {
	      rewireData[variableName] = INTENTIONAL_UNDEFINED;
	    } else {
	      rewireData[variableName] = value;
	    }
	
	    return function () {
	      _reset__(variableName);
	    };
	  }
	}
	
	function _reset__(variableName) {
	  var rewireData = _getRewiredData__();
	
	  delete rewireData[variableName];
	
	  if (Object.keys(rewireData).length == 0) {
	    delete _getRewireRegistry__()[_getRewireModuleId__];
	  }
	
	  ;
	}
	
	function _with__(object) {
	  var rewireData = _getRewiredData__();
	
	  var rewiredVariableNames = Object.keys(object);
	  var previousValues = {};
	
	  function reset() {
	    rewiredVariableNames.forEach(function (variableName) {
	      rewireData[variableName] = previousValues[variableName];
	    });
	  }
	
	  return function (callback) {
	    rewiredVariableNames.forEach(function (variableName) {
	      previousValues[variableName] = rewireData[variableName];
	      rewireData[variableName] = object[variableName];
	    });
	    var result = callback();
	
	    if (!!result && typeof result.then == 'function') {
	      result.then(reset).catch(reset);
	    } else {
	      reset();
	    }
	
	    return result;
	  };
	}
	
	var _typeOfOriginalExport = typeof config === 'undefined' ? 'undefined' : _typeof(config);
	
	function addNonEnumerableProperty(name, value) {
	  Object.defineProperty(config, name, {
	    value: value,
	    enumerable: false,
	    configurable: true
	  });
	}
	
	if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(config)) {
	  addNonEnumerableProperty('__get__', _get__);
	  addNonEnumerableProperty('__GetDependency__', _get__);
	  addNonEnumerableProperty('__Rewire__', _set__);
	  addNonEnumerableProperty('__set__', _set__);
	  addNonEnumerableProperty('__reset__', _reset__);
	  addNonEnumerableProperty('__ResetDependency__', _reset__);
	  addNonEnumerableProperty('__with__', _with__);
	  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
	}

	exports.__get__ = _get__;
	exports.__GetDependency__ = _get__;
	exports.__Rewire__ = _set__;
	exports.__set__ = _set__;
	exports.__ResetDependency__ = _reset__;
	exports.__RewireAPI__ = _RewireAPI__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(403);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ })
/******/ ])))
});
;


// WEBPACK FOOTER //
// js/styleguide.js